export const finnGenData = [
  {
    "accessionId": "DGWAS-1",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYTHY_AI_STRICT",
    "phenotype": "Hypothyroidism, strict autoimmune",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune hypothyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYTHY_AI_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-10",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CHOLELITH",
    "phenotype": "Cholelithiasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholelithiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CHOLELITH.gz"
  },
  {
    "accessionId": "DGWAS-100",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_WET_AMD",
    "phenotype": "Wet age-related macular degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Wet AMD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_WET_AMD.gz"
  },
  {
    "accessionId": "DGWAS-1000",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERGLYCER",
    "phenotype": "Pure hyperglyceridaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperglyceridemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERGLYCER.gz"
  },
  {
    "accessionId": "DGWAS-1001",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_FE_DEF",
    "phenotype": "Iron deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_FE_DEF.gz"
  },
  {
    "accessionId": "DGWAS-1002",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ENDODISNAS",
    "phenotype": "Endocrine disorders, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocrine disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ENDODISNAS.gz"
  },
  {
    "accessionId": "DGWAS-1003",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_CATAR",
    "phenotype": "Drug-induced cataract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced cataract",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_CATAR.gz"
  },
  {
    "accessionId": "DGWAS-1004",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DENTAL_TMD_FIBRO",
    "phenotype": "TMD muscular pain linked with fibromyalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TMD muscular pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DENTAL_TMD_FIBRO.gz"
  },
  {
    "accessionId": "DGWAS-1005",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SPLEENDISEASE",
    "phenotype": "Diseases of spleen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spleen disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SPLEENDISEASE.gz"
  },
  {
    "accessionId": "DGWAS-1006",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SCNDPOLYCYTHAEMIA",
    "phenotype": "Secondary polycythaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary polycythemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SCNDPOLYCYTHAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-1007",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_OTHPRIMTHROMBOCYTOPENIA",
    "phenotype": "Other primary thrombocytopenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary thrombocytopenia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_OTHPRIMTHROMBOCYTOPENIA.gz"
  },
  {
    "accessionId": "DGWAS-1008",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ITP",
    "phenotype": "Idiopathic thrombocytopenic purpura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ITP",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ITP.gz"
  },
  {
    "accessionId": "DGWAS-1009",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_INFARCTSPLEEN",
    "phenotype": "Infarction of spleen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spleen infarction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_INFARCTSPLEEN.gz"
  },
  {
    "accessionId": "DGWAS-101",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_T1D",
    "phenotype": "Type1 diabetes, definitions combined",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_T1D.gz"
  },
  {
    "accessionId": "DGWAS-1010",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_IMMUDEFANTIBODY",
    "phenotype": "Immunodeficiency with predominantly antibody defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Antibody deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_IMMUDEFANTIBODY.gz"
  },
  {
    "accessionId": "DGWAS-1011",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HERESPHERO",
    "phenotype": "Hereditary spherocytosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary spherocytosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HERESPHERO.gz"
  },
  {
    "accessionId": "DGWAS-1012",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HEREDHYPOGAMMA",
    "phenotype": "Hereditary hypogammaglobulinemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary hypogammaglobulinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HEREDHYPOGAMMA.gz"
  },
  {
    "accessionId": "DGWAS-1013",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ALLERGPURPURA",
    "phenotype": "Allergic purpura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic purpura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ALLERGPURPURA.gz"
  },
  {
    "accessionId": "DGWAS-1014",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_AGRANULOCYTOSIS",
    "phenotype": "Agranulocytosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agranulocytosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_AGRANULOCYTOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1015",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ACQHAEMOLYTICANAEMIANAS",
    "phenotype": "Other and unspecified acquired haemolytic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired hemolytic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ACQHAEMOLYTICANAEMIANAS.gz"
  },
  {
    "accessionId": "DGWAS-1016",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CPAP",
    "phenotype": "Continuous positive airway pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "CPAP therapy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CPAP.gz"
  },
  {
    "accessionId": "DGWAS-1017",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CMV_HEPATITIS",
    "phenotype": "Cytomegaloviral hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CMV hepatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CMV_HEPATITIS.gz"
  },
  {
    "accessionId": "DGWAS-1018",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CHARCOT",
    "phenotype": "Charcot foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Charcot foot",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CHARCOT.gz"
  },
  {
    "accessionId": "DGWAS-1019",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_UVEAMELANOMA_EXALLC",
    "phenotype": "Melanoma of uvea (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uveal melanoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_UVEAMELANOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-102",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_GALLB_BILE_DUCTS_LIVER",
    "phenotype": "Congenital malformations of gallbladder, bile ducts and liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital biliary malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_GALLB_BILE_DUCTS_LIVER.gz"
  },
  {
    "accessionId": "DGWAS-1020",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_NONHODGKIN_NAS_EXALLC",
    "phenotype": "Other and unspecified types of non-Hodgkin lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-Hodgkin lymphoma NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_NONHODGKIN_NAS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1021",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_CERVIX_UTERI_EXALLC",
    "phenotype": "Carcinoma in situ of cervix uteri (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_CERVIX_UTERI_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1022",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_IMMUNOPROLIFERATIVE_EXALLC",
    "phenotype": "Malignant immunoproliferative diseases (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immunoproliferative disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_IMMUNOPROLIFERATIVE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1023",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_VAGINA",
    "phenotype": "Benign neoplasm: Vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign vulvar neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_VAGINA.gz"
  },
  {
    "accessionId": "DGWAS-1024",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_THYROID",
    "phenotype": "Benign neoplasm of thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign thyroid neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_THYROID.gz"
  },
  {
    "accessionId": "DGWAS-1025",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_SPINAL_CORD",
    "phenotype": "Benign neoplasm: Spinal cord",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign spinal cord neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_SPINAL_CORD.gz"
  },
  {
    "accessionId": "DGWAS-1026",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_SALIVARY_KNOWN",
    "phenotype": "Benign neoplasm: salivary glands, exclude unknown (D119)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign salivary gland neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_SALIVARY_KNOWN.gz"
  },
  {
    "accessionId": "DGWAS-1027",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_SALIVARY",
    "phenotype": "Benign neoplasm of major salivary glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign major salivary gland neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_SALIVARY.gz"
  },
  {
    "accessionId": "DGWAS-1028",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PHARYNX_NOS",
    "phenotype": "Benign neoplasm: Pharynx, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pharyngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PHARYNX_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1029",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PAROTID",
    "phenotype": "Benign neoplasm: Parotid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign parotid neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PAROTID.gz"
  },
  {
    "accessionId": "DGWAS-103",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMETRIOSIS_OVARY",
    "phenotype": "Endometriosis of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMETRIOSIS_OVARY.gz"
  },
  {
    "accessionId": "DGWAS-1030",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PARATHYROID",
    "phenotype": "Benign neoplasm: Parathyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign parathyroid neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PARATHYROID.gz"
  },
  {
    "accessionId": "DGWAS-1031",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_NOS",
    "phenotype": "Benign neoplasm: Other/unspecified site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1032",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_NASOPHARYNX",
    "phenotype": "Benign neoplasm: Nasopharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign nasopharyngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_NASOPHARYNX.gz"
  },
  {
    "accessionId": "DGWAS-1033",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MOUTH_NOS",
    "phenotype": "Benign neoplasm: Other and unspecified parts of mouth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oral neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MOUTH_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1034",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MENINGES_SPINAL",
    "phenotype": "Benign neoplasm: Spinal meninges",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign spinal meningeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MENINGES_SPINAL.gz"
  },
  {
    "accessionId": "DGWAS-1035",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIPO_NOS",
    "phenotype": "Benign lipomatous neoplasm of other sites/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIPO_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1036",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LARYNX",
    "phenotype": "Benign neoplasm: Larynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign laryngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LARYNX.gz"
  },
  {
    "accessionId": "DGWAS-1037",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_EYE",
    "phenotype": "Benign neoplasm of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign eye/adnexa neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_EYE.gz"
  },
  {
    "accessionId": "DGWAS-1038",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_DESCENDING_COLON",
    "phenotype": "Benign neoplasm: Descending colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign descending colon neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_DESCENDING_COLON.gz"
  },
  {
    "accessionId": "DGWAS-1039",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CRANIAL_NERVE",
    "phenotype": "Benign neoplasm: Cranial nerves",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cranial nerve neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CRANIAL_NERVE.gz"
  },
  {
    "accessionId": "DGWAS-104",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_MOOD",
    "phenotype": "Mood [affective] disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mood disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_MOOD.gz"
  },
  {
    "accessionId": "DGWAS-1040",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CORPUS_UTERI",
    "phenotype": "Other benign neoplasm of uterus: Corpus uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign uterine corpus neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CORPUS_UTERI.gz"
  },
  {
    "accessionId": "DGWAS-1041",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_TESTIS_EXALLC",
    "phenotype": "Malignant neoplasm of testis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_TESTIS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1042",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_STOMACH_NEUROENDOCRINE_EXALLC",
    "phenotype": "Neuroendocrine tumor and carcinoma of stomach (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_STOMACH_NEUROENDOCRINE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1043",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_SMALL_INTESTINE_EXALLC",
    "phenotype": "Malignant neoplasm of small intestine (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_SMALL_INTESTINE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1044",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OVARY_EXALLC",
    "phenotype": "Malignant neoplasm of ovary (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OVARY_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1045",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_NSCLC_ADENO_EXALLC",
    "phenotype": "Non-small cell lung cancer, adenocarcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NSCLC adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_NSCLC_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1046",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_MULT_MYELOMA_EXALLC",
    "phenotype": "Multiple myeloma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_MULT_MYELOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1047",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_LIP_EXALLC",
    "phenotype": "Malignant neoplasm of lip (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lip cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_LIP_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1048",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_COLORECTAL_NEUROENDO_EXALLC",
    "phenotype": "Colorectal neuroendocrine tumor and carcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colorectal NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_COLORECTAL_NEUROENDO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1049",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CERVIX_SQUAM_EXALLC",
    "phenotype": "Squamous cell neoplasms and carcinoma of cervix (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical SCC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CERVIX_SQUAM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-105",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_DEMENTIA",
    "phenotype": "Dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_DEMENTIA.gz"
  },
  {
    "accessionId": "DGWAS-1050",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ARTHRO_SPEC",
    "phenotype": "Other specific arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Specific arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ARTHRO_SPEC.gz"
  },
  {
    "accessionId": "DGWAS-1052",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ALCO_PRESCRIPTION",
    "phenotype": "Use of disulfiram, acamprosate or naltrexone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Alcohol dependence medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ALCO_PRESCRIPTION.gz"
  },
  {
    "accessionId": "DGWAS-1053",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ZOONOTIC_BACTERIAL",
    "phenotype": "Certain zoonotic bacterial diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Zoonotic bacterial disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ZOONOTIC_BACTERIAL.gz"
  },
  {
    "accessionId": "DGWAS-1054",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAN_CNS_INFECTIONS_NOS",
    "phenotype": "Viral infections of central nervous system, not elsewhere classified/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS viral infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAN_CNS_INFECTIONS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1055",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAL_CNS",
    "phenotype": "Viral infections of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS viral infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAL_CNS.gz"
  },
  {
    "accessionId": "DGWAS-1056",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAAL_CONJUNCT",
    "phenotype": "Viral conjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAAL_CONJUNCT.gz"
  },
  {
    "accessionId": "DGWAS-1057",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TUBERCU_OTH_ORG",
    "phenotype": "Tuberculosis of other organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Extrapulmonary TB",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TUBERCU_OTH_ORG.gz"
  },
  {
    "accessionId": "DGWAS-1058",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TRICHOMONIASIS",
    "phenotype": "Trichomoniasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trichomoniasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TRICHOMONIASIS.gz"
  },
  {
    "accessionId": "DGWAS-1059",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SEQULEAE_OF_INFECTIONS_AND_PARASITES",
    "phenotype": "Sequelae of infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-infectious sequelae",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SEQULEAE_OF_INFECTIONS_AND_PARASITES.gz"
  },
  {
    "accessionId": "DGWAS-106",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_FH",
    "phenotype": "Familial hypercholesterolemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial hypercholesterolemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_FH.gz"
  },
  {
    "accessionId": "DGWAS-1060",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SEQULAE_INF_NOS",
    "phenotype": "Sequelae of other and unspecified infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-infectious sequelae NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SEQULAE_INF_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1061",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_PARASITIC_NOS",
    "phenotype": "Unspecified parasitic disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parasitic disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_PARASITIC_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1062",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_MYCOBAC",
    "phenotype": "Infection due to other mycobacteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontuberculous mycobacterial infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_MYCOBAC.gz"
  },
  {
    "accessionId": "DGWAS-1063",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_BACT_INOTHER",
    "phenotype": "Other bacterial agents as the cause of diseases classified to other chapters",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other bacterial infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_BACT_INOTHER.gz"
  },
  {
    "accessionId": "DGWAS-1064",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HERPES_SIMPLEX",
    "phenotype": "Herpesviral [herpes simplex] infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Herpes simplex",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HERPES_SIMPLEX.gz"
  },
  {
    "accessionId": "DGWAS-1065",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HELMINTIASES",
    "phenotype": "Helminthiases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Helminthiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HELMINTIASES.gz"
  },
  {
    "accessionId": "DGWAS-1066",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_BACT_INTEST_OTH",
    "phenotype": "Other bacterial intestinal infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial enteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_BACT_INTEST_OTH.gz"
  },
  {
    "accessionId": "DGWAS-1067",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_AMOEBIASIS",
    "phenotype": "Amoebiasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amebiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_AMOEBIASIS.gz"
  },
  {
    "accessionId": "DGWAS-1068",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Z21_TOBAC_USE",
    "phenotype": "Tobacco use",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Tobacco use",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Z21_TOBAC_USE.gz"
  },
  {
    "accessionId": "DGWAS-1069",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Z21_PREVIOUS_SUICIDE_ATTEMPT",
    "phenotype": "Previous suicide attempt",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Past suicide attempt",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Z21_PREVIOUS_SUICIDE_ATTEMPT.gz"
  },
  {
    "accessionId": "DGWAS-107",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRY_AMD",
    "phenotype": "Dry age-related macular degeneration (includes geographic atrophy)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dry AMD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRY_AMD.gz"
  },
  {
    "accessionId": "DGWAS-1070",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_VIT_DEF",
    "phenotype": "Vitamin deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitamin deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_VIT_DEF.gz"
  },
  {
    "accessionId": "DGWAS-1071",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_VIRALPNEUMONAS",
    "phenotype": "Viral pneumonia (unknown virus, not influenza)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral pneumonia (unknown virus)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_VIRALPNEUMONAS.gz"
  },
  {
    "accessionId": "DGWAS-1072",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_VIRALPNEUMOKNOWN",
    "phenotype": "Viral pneumonia (known virus, not influenza)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral pneumonia (specified virus)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_VIRALPNEUMOKNOWN.gz"
  },
  {
    "accessionId": "DGWAS-1073",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_VD_O",
    "phenotype": "Vascular dementia (other)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_VD_O.gz"
  },
  {
    "accessionId": "DGWAS-1074",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_TRACHEOBRONCHOMAL",
    "phenotype": "Tracheo-bronchomalasia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tracheobronchomalacia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_TRACHEOBRONCHOMAL.gz"
  },
  {
    "accessionId": "DGWAS-1075",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_TEMPOROMANDIB_INCLAVO",
    "phenotype": "Temporomandibular joint disorders, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TMD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_TEMPOROMANDIB_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-1076",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SYSTINOTH_FG",
    "phenotype": "Systemic disorders of connective tissue in diseases classified elsewhere (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Connective tissue disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SYSTINOTH_FG.gz"
  },
  {
    "accessionId": "DGWAS-1077",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_STILL_ADULT",
    "phenotype": "Adult-onset Still disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adult-onset Still disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_STILL_ADULT.gz"
  },
  {
    "accessionId": "DGWAS-1078",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_SKULL_FACIAL_BONES",
    "phenotype": "Fracture of skull and facial bones",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skull/facial fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_SKULL_FACIAL_BONES.gz"
  },
  {
    "accessionId": "DGWAS-1079",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_RIBS_STERNUM_THORACIC_SPINE",
    "phenotype": "Fracture of rib(s), sternum and thoracic spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rib/sternum/thoracic spine fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_RIBS_STERNUM_THORACIC_SPINE.gz"
  },
  {
    "accessionId": "DGWAS-108",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ABDOM_HERNIA",
    "phenotype": "Hernia of abdominal wall",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal wall hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ABDOM_HERNIA.gz"
  },
  {
    "accessionId": "DGWAS-1080",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_NECK",
    "phenotype": "Fracture of neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neck fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_NECK.gz"
  },
  {
    "accessionId": "DGWAS-1081",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_INVOLVI_MULTIPLE_BODY_REGIONS",
    "phenotype": "Fractures involving multiple body regions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple fractures",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_INVOLVI_MULTIPLE_BODY_REGIONS.gz"
  },
  {
    "accessionId": "DGWAS-1082",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_FEMUR",
    "phenotype": "Fracture of femur",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femur fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_FEMUR.gz"
  },
  {
    "accessionId": "DGWAS-1083",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SFN",
    "phenotype": "Small fibre neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small fiber neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SFN.gz"
  },
  {
    "accessionId": "DGWAS-1084",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SCND_OTH_KNEEARTHROSIS",
    "phenotype": "Other secondary gonarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary knee osteoarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SCND_OTH_KNEEARTHROSIS.gz"
  },
  {
    "accessionId": "DGWAS-1085",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHINITIS_VASOMOTOR",
    "phenotype": "Vasomotor rhinitis (mode)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vasomotor rhinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHINITIS_VASOMOTOR.gz"
  },
  {
    "accessionId": "DGWAS-1086",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMAT_LUNG",
    "phenotype": "Rheumatoid lung disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatoid lung disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMAT_LUNG.gz"
  },
  {
    "accessionId": "DGWAS-1087",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_R18_RETEN_URINE",
    "phenotype": "Retention of urine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary retention",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_R18_RETEN_URINE.gz"
  },
  {
    "accessionId": "DGWAS-1088",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_R18_ANOREXIA",
    "phenotype": "Anorexia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorexia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_R18_ANOREXIA.gz"
  },
  {
    "accessionId": "DGWAS-1089",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_SYNDACTYLY",
    "phenotype": "Syndactyly",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Syndactyly",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_SYNDACTYLY.gz"
  },
  {
    "accessionId": "DGWAS-109",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMETRIOSIS_ASRM_STAGE3_4",
    "phenotype": "Endometriosis ASRM stages 3,4",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMETRIOSIS_ASRM_STAGE3_4.gz"
  },
  {
    "accessionId": "DGWAS-1090",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_SPINA_BIFIDA",
    "phenotype": "Spina bifida",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spina bifida",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_SPINA_BIFIDA.gz"
  },
  {
    "accessionId": "DGWAS-1091",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_RVOTO",
    "phenotype": "Right ventricular outflow tract obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "RVOT obstruction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_RVOTO.gz"
  },
  {
    "accessionId": "DGWAS-1092",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_RENAL_AGENE_OTHER_REDUCT_DEFECTS_KIDNEY",
    "phenotype": "Renal agenesis and other reduction defects of kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal agenesis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_RENAL_AGENE_OTHER_REDUCT_DEFECTS_KIDNEY.gz"
  },
  {
    "accessionId": "DGWAS-1093",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_REDUCT_DEFECTS_UPPER_LIMB",
    "phenotype": "Reduction defects of upper limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb reduction defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_REDUCT_DEFECTS_UPPER_LIMB.gz"
  },
  {
    "accessionId": "DGWAS-1094",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_REDUCT_DEFECTS_LOWER_LIMB",
    "phenotype": "Reduction defects of lower limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb reduction defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_REDUCT_DEFECTS_LOWER_LIMB.gz"
  },
  {
    "accessionId": "DGWAS-1095",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_PDA",
    "phenotype": "Isolated patent ductus arteriosus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Isolated PDA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_PDA.gz"
  },
  {
    "accessionId": "DGWAS-1096",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_SEX_CHROMOSOME_ABNORMALITI_MALE_PHENOT_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Other sex chromosome abnormalities, male phenotype, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sex chromosome abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_SEX_CHROMOSOME_ABNORMALITI_MALE_PHENOT_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-1097",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MUSCULOS_DEFORMITI",
    "phenotype": "Other congenital musculoskeletal deformities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital musculoskeletal deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MUSCULOS_DEFORMITI.gz"
  },
  {
    "accessionId": "DGWAS-1098",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_URINARY_SYSTEM",
    "phenotype": "Other congenital malformations of urinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital urinary malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_URINARY_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1099",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_TONGUE_MOUTH_PHARYNX",
    "phenotype": "Other congenital malformations of tongue, mouth and pharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital oral malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_TONGUE_MOUTH_PHARYNX.gz"
  },
  {
    "accessionId": "DGWAS-11",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_ASTHMACOPDKELA",
    "phenotype": "Asthma/COPD (KELA code 203)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma/COPD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_ASTHMACOPDKELA.gz"
  },
  {
    "accessionId": "DGWAS-110",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_CALCUKIDUR",
    "phenotype": "Calculus of kidney and ureter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney/ureter stone",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_CALCUKIDUR.gz"
  },
  {
    "accessionId": "DGWAS-1100",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_SKULL_FACE_BONES",
    "phenotype": "Other congenital malformations of skull and face bones",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital skull/facial malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_SKULL_FACE_BONES.gz"
  },
  {
    "accessionId": "DGWAS-1101",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_PERIP_VASCULAR_SYSTEM",
    "phenotype": "Other congenital malformations of peripheral vascular system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital peripheral vascular malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_PERIP_VASCULAR_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1102",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_MALE_GENITAL_ORGANS",
    "phenotype": "Other congenital malformations of male genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital male genital malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_MALE_GENITAL_ORGANS.gz"
  },
  {
    "accessionId": "DGWAS-1103",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_LIMBS",
    "phenotype": "Other congenital malformations of limb(s)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital limb malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_LIMBS.gz"
  },
  {
    "accessionId": "DGWAS-1104",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_KIDNEY",
    "phenotype": "Other congenital malformations of kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital kidney malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_KIDNEY.gz"
  },
  {
    "accessionId": "DGWAS-1105",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_INTESTINE",
    "phenotype": "Other congenital malformations of intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital intestinal malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_INTESTINE.gz"
  },
  {
    "accessionId": "DGWAS-1106",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_CIRCULATO_SYSTEM",
    "phenotype": "Other congenital malformations of circulatory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital circulatory malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_CIRCULATO_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1107",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_BRAIN",
    "phenotype": "Other congenital malformations of brain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital brain malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_BRAIN.gz"
  },
  {
    "accessionId": "DGWAS-1108",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_MONOSOMI_DELET_AUTOSOMES_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Monosomies and deletions from the autosomes, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autosomal monosomy/deletion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_MONOSOMI_DELET_AUTOSOMES_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-1109",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_HYPOSPADIAS",
    "phenotype": "Hypospadias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypospadias",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_HYPOSPADIAS.gz"
  },
  {
    "accessionId": "DGWAS-111",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_UAP",
    "phenotype": "Unstable angina pectoris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unstable angina",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_UAP.gz"
  },
  {
    "accessionId": "DGWAS-1110",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONOTR_DEFEC",
    "phenotype": "Conotruncal defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conotruncal defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONOTR_DEFEC.gz"
  },
  {
    "accessionId": "DGWAS-1111",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_OBSTRUCTIVE_DEFECTS_RENAL_PELVIS_CONGEN_MALFO_URETER",
    "phenotype": "Congenital obstructive defects of renal pelvis and congenital malformations of ureter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital ureteropelvic obstruction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_OBSTRUCTIVE_DEFECTS_RENAL_PELVIS_CONGEN_MALFO_URETER.gz"
  },
  {
    "accessionId": "DGWAS-1112",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_UTERUS_CERVIX",
    "phenotype": "Congenital malformations of uterus and cervix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital uterine/cervical malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_UTERUS_CERVIX.gz"
  },
  {
    "accessionId": "DGWAS-1113",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_SPINE_BONY_THORAX",
    "phenotype": "Congenital malformations of spine and bony thorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital spine/thorax malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_SPINE_BONY_THORAX.gz"
  },
  {
    "accessionId": "DGWAS-1114",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_RESPI_SYSTEM",
    "phenotype": "Congenital malformations of the respiratory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital respiratory malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_RESPI_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1115",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_OESOPHAGUS",
    "phenotype": "Congenital malformations of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital esophageal malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_OESOPHAGUS.gz"
  },
  {
    "accessionId": "DGWAS-1116",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_NERVOUS_SYSTEM",
    "phenotype": "Congenital malformations of the nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital nervous system malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_NERVOUS_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1117",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_LUNG",
    "phenotype": "Congenital malformations of lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital lung malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_LUNG.gz"
  },
  {
    "accessionId": "DGWAS-1118",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_LARYNX",
    "phenotype": "Congenital malformations of larynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital laryngeal malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_LARYNX.gz"
  },
  {
    "accessionId": "DGWAS-1119",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_GENITAL_ORGANS",
    "phenotype": "Congenital malformations of genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital genital malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_GENITAL_ORGANS.gz"
  },
  {
    "accessionId": "DGWAS-112",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_OTHARR",
    "phenotype": "Other arrhythmias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arrhythmia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_OTHARR.gz"
  },
  {
    "accessionId": "DGWAS-1120",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_EYELID_LACRIMAL_APPARA_ORBIT",
    "phenotype": "Congenital malformations of eyelid, lacrimal apparatus and orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital eyelid/lacrimal malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_EYELID_LACRIMAL_APPARA_ORBIT.gz"
  },
  {
    "accessionId": "DGWAS-1121",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_EAR_CAUSI_IMPAIRM_HEARING",
    "phenotype": "Congenital malformations of ear causing impairment of hearing",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital ear malformation with hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_EAR_CAUSI_IMPAIRM_HEARING.gz"
  },
  {
    "accessionId": "DGWAS-1122",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_DEFORMAT_MUSCULOS_SYSTEM",
    "phenotype": "Congenital malformations and deformations of the musculoskeletal system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital musculoskeletal deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_DEFORMAT_MUSCULOS_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1123",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_BREAST",
    "phenotype": "Congenital malformations of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital breast malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_BREAST.gz"
  },
  {
    "accessionId": "DGWAS-1124",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_BILI",
    "phenotype": "Congenital malformation of biliary tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital biliary malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_BILI.gz"
  },
  {
    "accessionId": "DGWAS-1125",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_ANTER_SEGMENT_EYE",
    "phenotype": "Congenital malformations of anterior segment of eye",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital anterior segment malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_ANTER_SEGMENT_EYE.gz"
  },
  {
    "accessionId": "DGWAS-1126",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_ICHTHYOSIS",
    "phenotype": "Congenital ichthyosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital ichthyosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_ICHTHYOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1127",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_DEFORMITI_HIP",
    "phenotype": "Congenital deformities of hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital hip deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_DEFORMITI_HIP.gz"
  },
  {
    "accessionId": "DGWAS-1128",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_COMPLEX_CARD_DEFEC",
    "phenotype": "Complex cardiac defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Complex cardiac defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_COMPLEX_CARD_DEFEC.gz"
  },
  {
    "accessionId": "DGWAS-1129",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CHROMOSOMAL_ABNORMALITI_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Chromosomal abnormalities, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chromosomal abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CHROMOSOMAL_ABNORMALITI_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-113",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_DEPRESSIO",
    "phenotype": "Depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_DEPRESSIO.gz"
  },
  {
    "accessionId": "DGWAS-1130",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_AVSD",
    "phenotype": "Atrioventricular septal defect",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AVSD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_AVSD.gz"
  },
  {
    "accessionId": "DGWAS-1131",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_APVR",
    "phenotype": "Abnormal pulmonary venous return",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anomalous pulmonary venous return",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_APVR.gz"
  },
  {
    "accessionId": "DGWAS-1132",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_PHLEBI_THROMBOP_OTHER_DEEP_VESSE_LOWER_EXTREMITI",
    "phenotype": "Phlebitis and thrombophlebitis of other deep vessels of lower extremities, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced lower extremity thrombophlebitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_PHLEBI_THROMBOP_OTHER_DEEP_VESSE_LOWER_EXTREMITI.gz"
  },
  {
    "accessionId": "DGWAS-1133",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_PHLEBI_THROMBOP_LOWER_EXTREMITI_UNSPE",
    "phenotype": "Phlebitis and thrombophlebitis of lower extremities, unspecified, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced lower extremity thrombophlebitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_PHLEBI_THROMBOP_LOWER_EXTREMITI_UNSPE.gz"
  },
  {
    "accessionId": "DGWAS-1134",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_SLOW_FETAL_GROWTH_FETAL_MALNUTRITION",
    "phenotype": "Slow fetal growth and fetal malnutrition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fetal growth restriction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_SLOW_FETAL_GROWTH_FETAL_MALNUTRITION.gz"
  },
  {
    "accessionId": "DGWAS-1135",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_INFECTIONS_SPECIFIC_PERINA_PERIOD",
    "phenotype": "Infections specific to the perinatal period",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perinatal infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_INFECTIONS_SPECIFIC_PERINA_PERIOD.gz"
  },
  {
    "accessionId": "DGWAS-1136",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_FET_NEWB_MATERN_COND_UNREL_PRESENT_PREGNAC",
    "phenotype": "Fetus and newborn affected by maternal conditions that may be unrelated to present pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Newborn affected by maternal condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_FET_NEWB_MATERN_COND_UNREL_PRESENT_PREGNAC.gz"
  },
  {
    "accessionId": "DGWAS-1137",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_FEEDI_PROBL_NEWBO",
    "phenotype": "Feeding problems of newborn",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Newborn feeding problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_FEEDI_PROBL_NEWBO.gz"
  },
  {
    "accessionId": "DGWAS-1138",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_DISORD_RELATED_LONG_GESTATION_HIGH_BIRTHWGHTT",
    "phenotype": "Disorders related to long gestation and high birth weight",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-term/large for gestational age",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_DISORD_RELATED_LONG_GESTATION_HIGH_BIRTHWGHTT.gz"
  },
  {
    "accessionId": "DGWAS-1139",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_DISORD_RELATED_GESTATION_LOW_BIRTHWGHTT_NECIFIED",
    "phenotype": "Disorders related to short gestation and low birth weight, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preterm/low birth weight",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_DISORD_RELATED_GESTATION_LOW_BIRTHWGHTT_NECIFIED.gz"
  },
  {
    "accessionId": "DGWAS-114",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ST19_FRACT_FOREA",
    "phenotype": "Fracture of forearm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Forearm fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ST19_FRACT_FOREA.gz"
  },
  {
    "accessionId": "DGWAS-1140",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_CARDIOV_DISORD_ORIGINA_PERINA_PERIOD",
    "phenotype": "Cardiovascular disorders originating in the perinatal period",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perinatal cardiovascular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_CARDIOV_DISORD_ORIGINA_PERINA_PERIOD.gz"
  },
  {
    "accessionId": "DGWAS-1141",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_BIRTH_TRAUMA",
    "phenotype": "Birth trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Birth trauma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_BIRTH_TRAUMA.gz"
  },
  {
    "accessionId": "DGWAS-1142",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_P16_BACTERIAL_SEPSIS_NEWBO",
    "phenotype": "Bacterial sepsis of newborn",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neonatal bacterial sepsis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_P16_BACTERIAL_SEPSIS_NEWBO.gz"
  },
  {
    "accessionId": "DGWAS-1143",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_OSTPOPATFRACTURE",
    "phenotype": "Drug-induced osteoporosis with pathological fracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced osteoporosis with fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_OSTPOPATFRACTURE.gz"
  },
  {
    "accessionId": "DGWAS-1144",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_OFFICIAL_TILASTOKESKUS_DEATH",
    "phenotype": "Alcohol related diseases, tilastokeskus definition, death only",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol-related disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_OFFICIAL_TILASTOKESKUS_DEATH.gz"
  },
  {
    "accessionId": "DGWAS-1145",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_TWIN_GEST",
    "phenotype": "Twin gestation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Twin pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_TWIN_GEST.gz"
  },
  {
    "accessionId": "DGWAS-1146",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_RETAINED_PLAC_MEMB_NO_HEAMORRH",
    "phenotype": "Retained placenta and membranes, without haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retained placenta",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_RETAINED_PLAC_MEMB_NO_HEAMORRH.gz"
  },
  {
    "accessionId": "DGWAS-1147",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PUERP_INFECT_OTHER",
    "phenotype": "Other puerperal infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PUERP_INFECT_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-1148",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PUERP_COMPL_NAS",
    "phenotype": "Complications of the puerperium, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal complication NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PUERP_COMPL_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1149",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PUERP_ANEST_COMPL",
    "phenotype": "Complications of anaesthesia during the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anesthesia complication in puerperium",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PUERP_ANEST_COMPL.gz"
  },
  {
    "accessionId": "DGWAS-115",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RX_PARACETAMOL_NSAID",
    "phenotype": "Paracetamol of NSAID medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Paracetamol or NSAID",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RX_PARACETAMOL_NSAID.gz"
  },
  {
    "accessionId": "DGWAS-1150",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PREG_HYDAT",
    "phenotype": "Hydatidiform mole",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydatidiform mole",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PREG_HYDAT.gz"
  },
  {
    "accessionId": "DGWAS-1151",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PREG_GU_INFECT",
    "phenotype": "Infections of genitourinary tract in pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy GU infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PREG_GU_INFECT.gz"
  },
  {
    "accessionId": "DGWAS-1152",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PREG_ANESTH_COMPL",
    "phenotype": "Complications of anaesthesia during pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anesthesia complication in pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PREG_ANESTH_COMPL.gz"
  },
  {
    "accessionId": "DGWAS-1153",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_POSTPART_HAEMORRH_ANATOMY",
    "phenotype": "Postpartum haemorrhage due to anatomy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anatomical PPH",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_POSTPART_HAEMORRH_ANATOMY.gz"
  },
  {
    "accessionId": "DGWAS-1154",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_MULTIP_GEST",
    "phenotype": "Multiple gestation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Multiple pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_MULTIP_GEST.gz"
  },
  {
    "accessionId": "DGWAS-1155",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_MATERN_INFECT_ELSEWHERE",
    "phenotype": "Maternal infectious and parasitic diseases classifiable elsewhere but complicating pregnancy, childbirth and  the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal infection complicating pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_MATERN_INFECT_ELSEWHERE.gz"
  },
  {
    "accessionId": "DGWAS-1156",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_MATERN_CARE_DISPROP",
    "phenotype": "Maternal care for known or suspected disproportion",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Maternal care for disproportion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_MATERN_CARE_DISPROP.gz"
  },
  {
    "accessionId": "DGWAS-1157",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_LABOUR_MALPOS",
    "phenotype": "Obstructed labour due to malposition and malpresentation of fetus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstructed labor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_LABOUR_MALPOS.gz"
  },
  {
    "accessionId": "DGWAS-1158",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_LABOUR_LONG",
    "phenotype": "Long labour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prolonged labor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_LABOUR_LONG.gz"
  },
  {
    "accessionId": "DGWAS-1159",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_LABOUR_INTRAPART_HAEMORRH",
    "phenotype": "Labour and delivery complicated by intrapartum haemorrhage, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intrapartum hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_LABOUR_INTRAPART_HAEMORRH.gz"
  },
  {
    "accessionId": "DGWAS-116",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_OTHERJOINT",
    "phenotype": "Other joint disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_OTHERJOINT.gz"
  },
  {
    "accessionId": "DGWAS-1160",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_LABOUR_ANEST_COMPLIC",
    "phenotype": "Complications of anaesthesia during labour and delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anesthesia complication in labor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_LABOUR_ANEST_COMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-1161",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_ECLAMPSIA",
    "phenotype": "Eclampsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eclampsia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_ECLAMPSIA.gz"
  },
  {
    "accessionId": "DGWAS-1163",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_COMPLIC_PUERP",
    "phenotype": "Complications predominantly related to the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_COMPLIC_PUERP.gz"
  },
  {
    "accessionId": "DGWAS-1164",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_COMPLIC_LAB_DELIV",
    "phenotype": "Complications of labour and delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labor/delivery complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_COMPLIC_LAB_DELIV.gz"
  },
  {
    "accessionId": "DGWAS-1165",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_BREAST_LACT_OTHER_DIS",
    "phenotype": "Other disorders of breast and lactation associated with childbirth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum breast disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_BREAST_LACT_OTHER_DIS.gz"
  },
  {
    "accessionId": "DGWAS-1166",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_BIRTH_BREAT_INFECT",
    "phenotype": "Infections of breast associated with childbirth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum breast infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_BIRTH_BREAT_INFECT.gz"
  },
  {
    "accessionId": "DGWAS-1167",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_ABORT_UNS",
    "phenotype": "Unspecified abortion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abortion NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_ABORT_UNS.gz"
  },
  {
    "accessionId": "DGWAS-1168",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_ABORT_SPONTAN",
    "phenotype": "Spontaneous abortion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spontaneous abortion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_ABORT_SPONTAN.gz"
  },
  {
    "accessionId": "DGWAS-1169",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_NIV",
    "phenotype": "Non-invasive ventilation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Non-invasive ventilation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_NIV.gz"
  },
  {
    "accessionId": "DGWAS-117",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_GOUT",
    "phenotype": "Gout",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_GOUT.gz"
  },
  {
    "accessionId": "DGWAS-1170",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_NEPHROP_INDUCED_OTHER_DRUGS_MEDICAM_BIOLO_SUBST",
    "phenotype": "Nephropathy induced by other drugs, medicaments and biological substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced nephropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_NEPHROP_INDUCED_OTHER_DRUGS_MEDICAM_BIOLO_SUBST.gz"
  },
  {
    "accessionId": "DGWAS-1171",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_VAGINAL_DYSPLASIA_ALL",
    "phenotype": "All dysplastic lesions of the vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_VAGINAL_DYSPLASIA_ALL.gz"
  },
  {
    "accessionId": "DGWAS-1172",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_UTER_POLYP",
    "phenotype": "Uterine polyps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine polyp",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_UTER_POLYP.gz"
  },
  {
    "accessionId": "DGWAS-1173",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_URETHRITISANDURSYNDR",
    "phenotype": "Urethritis and urethral syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urethritis/urethral syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_URETHRITISANDURSYNDR.gz"
  },
  {
    "accessionId": "DGWAS-1174",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_URETHRALSTRICT",
    "phenotype": "Urethral stricture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urethral stricture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_URETHRALSTRICT.gz"
  },
  {
    "accessionId": "DGWAS-1175",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_TORSIOTEST",
    "phenotype": "Torsion of testis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular torsion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_TORSIOTEST.gz"
  },
  {
    "accessionId": "DGWAS-1176",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_SMALLKIDNEY",
    "phenotype": "Small kidney of unknown cause",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small kidney",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_SMALLKIDNEY.gz"
  },
  {
    "accessionId": "DGWAS-1177",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_RENALTUBULOOTH",
    "phenotype": "Other renal tubulo-interstitial diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tubulointerstitial nephritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_RENALTUBULOOTH.gz"
  },
  {
    "accessionId": "DGWAS-1178",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_RENALTUBULOINOTH",
    "phenotype": "Renal tubulo-interstitial disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary tubulointerstitial disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_RENALTUBULOINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1179",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_RAPIDPROGNEPHRITIC",
    "phenotype": "Rapidly progressive nephritic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rapidly progressive GN",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_RAPIDPROGNEPHRITIC.gz"
  },
  {
    "accessionId": "DGWAS-118",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_COAGDEF",
    "phenotype": "Chronic Coagulation defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coagulation defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_COAGDEF.gz"
  },
  {
    "accessionId": "DGWAS-1180",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_PROSTATITIS",
    "phenotype": "Inflammatory diseases of prostate (prostatitis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_PROSTATITIS.gz"
  },
  {
    "accessionId": "DGWAS-1181",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OVARTORS",
    "phenotype": "Torsion of ovary, ovarian pedicle and fallopian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adnexal torsion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OVARTORS.gz"
  },
  {
    "accessionId": "DGWAS-1182",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHPENIS",
    "phenotype": "Other disorders of penis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Penile disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHPENIS.gz"
  },
  {
    "accessionId": "DGWAS-1183",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHNONINFVAG",
    "phenotype": "Other noninflammatory disorders of vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHNONINFVAG.gz"
  },
  {
    "accessionId": "DGWAS-1184",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHNONINFOVA",
    "phenotype": "Other and unspecified noninflammatory disorders of ovary, fallopian tube and broad ligament",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adnexal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHNONINFOVA.gz"
  },
  {
    "accessionId": "DGWAS-1185",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHNONINFCERVIX",
    "phenotype": "Other noninflammatory disorders of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHNONINFCERVIX.gz"
  },
  {
    "accessionId": "DGWAS-1186",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHETNASKIDUR",
    "phenotype": "Other specified disorders of kidney and ureter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney/ureter disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHETNASKIDUR.gz"
  },
  {
    "accessionId": "DGWAS-1187",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHDISMALEGEN",
    "phenotype": "Other disorders of male genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHDISMALEGEN.gz"
  },
  {
    "accessionId": "DGWAS-1188",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHBLADD",
    "phenotype": "Other disorders of  bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHBLADD.gz"
  },
  {
    "accessionId": "DGWAS-1189",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ORHCEPINDIDYMITIS",
    "phenotype": "Orchitis and epididymitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orchitis/epididymitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ORHCEPINDIDYMITIS.gz"
  },
  {
    "accessionId": "DGWAS-119",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_CHILD_EXMORE",
    "phenotype": "Childhood asthma (age<16) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_CHILD_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1190",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_NEUROMUSCDYSBLADD",
    "phenotype": "Neuromuscular dysfunction of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neurogenic bladder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_NEUROMUSCDYSBLADD.gz"
  },
  {
    "accessionId": "DGWAS-1191",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_NEPHROPATHYHER",
    "phenotype": "Hereditary nephropathy, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary nephropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_NEPHROPATHYHER.gz"
  },
  {
    "accessionId": "DGWAS-1192",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_MALEGENINOTH",
    "phenotype": "Disorders of male genital organs in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary male genital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_MALEGENINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1193",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_MAEMABROAD",
    "phenotype": "Haematosalpinx/Haematoma of broad ligament",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hematosalpinx/broad ligament hematoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_MAEMABROAD.gz"
  },
  {
    "accessionId": "DGWAS-1194",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_INFLUTH",
    "phenotype": "Inflammatory disease of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_INFLUTH.gz"
  },
  {
    "accessionId": "DGWAS-1195",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_INFCERVIX",
    "phenotype": "Inflammatory disease of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_INFCERVIX.gz"
  },
  {
    "accessionId": "DGWAS-1196",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_IMPOTENCE",
    "phenotype": "Impotence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erectile dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_IMPOTENCE.gz"
  },
  {
    "accessionId": "DGWAS-1197",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_HYDRONEPHR",
    "phenotype": "Hydronephrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydronephrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_HYDRONEPHR.gz"
  },
  {
    "accessionId": "DGWAS-1198",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_HABITABORT",
    "phenotype": "Habitual aborter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent miscarriage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_HABITABORT.gz"
  },
  {
    "accessionId": "DGWAS-1199",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FITUB",
    "phenotype": "Female infertility, tubal origin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tubal infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FITUB.gz"
  },
  {
    "accessionId": "DGWAS-12",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CORATHER",
    "phenotype": "Coronary atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coronary atherosclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CORATHER.gz"
  },
  {
    "accessionId": "DGWAS-120",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SLEEP",
    "phenotype": "Sleep disorders (combined)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SLEEP.gz"
  },
  {
    "accessionId": "DGWAS-1200",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FIANOV",
    "phenotype": "Female infertility, associated with anovulation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anovulatory infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FIANOV.gz"
  },
  {
    "accessionId": "DGWAS-1201",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMPELINFINOTH",
    "phenotype": "Female pelvic inflammatory disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary pelvic inflammatory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMPELINFINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1202",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMGENFISTUL",
    "phenotype": "Fistulae involving female genital tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital fistula",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMGENFISTUL.gz"
  },
  {
    "accessionId": "DGWAS-1203",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMALE_GENITAL_DYSPLASIA_NOS",
    "phenotype": "Dysplastic lesion of unknown severity in the cervix uteri, vagina or vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMALE_GENITAL_DYSPLASIA_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1204",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_CERVICAL_DYSPLASIA_NOS",
    "phenotype": "Dysplastic lesion of unknown severity of the cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_CERVICAL_DYSPLASIA_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1205",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_BREASTDISOTH",
    "phenotype": "Other disorders of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_BREASTDISOTH.gz"
  },
  {
    "accessionId": "DGWAS-1206",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_BARTHOABSCESS",
    "phenotype": "Abscess of Bartholin gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bartholin abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_BARTHOABSCESS.gz"
  },
  {
    "accessionId": "DGWAS-1207",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ATROPHOV",
    "phenotype": "Acquired atrophy of ovary and fallopian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired adnexal atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ATROPHOV.gz"
  },
  {
    "accessionId": "DGWAS-1208",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_MYCOBLUNGATYPICA",
    "phenotype": "Atypical mycobacterium lung infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atypical mycobacterial lung infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_MYCOBLUNGATYPICA.gz"
  },
  {
    "accessionId": "DGWAS-1209",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_MENINGITIS",
    "phenotype": "Meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_MENINGITIS.gz"
  },
  {
    "accessionId": "DGWAS-121",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SOFTTISSUE",
    "phenotype": "Soft tissue disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Soft tissue disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SOFTTISSUE.gz"
  },
  {
    "accessionId": "DGWAS-1210",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_MATERNCAREFETUSALCO",
    "phenotype": "Maternal care for (suspected) damage to fetus from alcohol",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Maternal care for fetal alcohol damage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_MATERNCAREFETUSALCO.gz"
  },
  {
    "accessionId": "DGWAS-1211",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_VILLONODULAR",
    "phenotype": "Villonodular synovitis (pigmented)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pigmented villonodular synovitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_VILLONODULAR.gz"
  },
  {
    "accessionId": "DGWAS-1212",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_VERTEBCOLLAPSE",
    "phenotype": "Collapsed vertebra, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertebral collapse",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_VERTEBCOLLAPSE.gz"
  },
  {
    "accessionId": "DGWAS-1213",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_TORTICOLLIS",
    "phenotype": "Torticollis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Torticollis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_TORTICOLLIS.gz"
  },
  {
    "accessionId": "DGWAS-1214",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_TOEDEFORMOTH",
    "phenotype": "Other deformities of toe(s)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toe deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_TOEDEFORMOTH.gz"
  },
  {
    "accessionId": "DGWAS-1215",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_TIBIALCOLLATERAL",
    "phenotype": "Tibial collateral bursitis [Pellegrini-Stieda]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tibial collateral bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_TIBIALCOLLATERAL.gz"
  },
  {
    "accessionId": "DGWAS-1216",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_THORACISPINEPAIN",
    "phenotype": "Pain in thoracic spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thoracic spine pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_THORACISPINEPAIN.gz"
  },
  {
    "accessionId": "DGWAS-1217",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_TENDONCONTRACT",
    "phenotype": "Oher contracture of tendon (sheath)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tendon contracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_TENDONCONTRACT.gz"
  },
  {
    "accessionId": "DGWAS-1218",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPONDYLOTRAUM",
    "phenotype": "Traumatic spondylopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic spondylopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPONDYLOTRAUM.gz"
  },
  {
    "accessionId": "DGWAS-1219",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPONDYLOPATHINOTH",
    "phenotype": "Spondylopathies in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary spondylopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPONDYLOPATHINOTH.gz"
  },
  {
    "accessionId": "DGWAS-122",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_COELIAC",
    "phenotype": "Coeliac disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Celiac disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_COELIAC.gz"
  },
  {
    "accessionId": "DGWAS-1220",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPONDYLOINFECTION",
    "phenotype": "Other infective spondylopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infective spondylopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPONDYLOINFECTION.gz"
  },
  {
    "accessionId": "DGWAS-1221",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPININSTAB",
    "phenotype": "Spinal instabilities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal instability",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPININSTAB.gz"
  },
  {
    "accessionId": "DGWAS-1222",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPINENTHES",
    "phenotype": "Spinal enthesopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal enthesopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPINENTHES.gz"
  },
  {
    "accessionId": "DGWAS-1223",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPINALOSTEOCHON",
    "phenotype": "Spinal osteochondrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal osteochondrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPINALOSTEOCHON.gz"
  },
  {
    "accessionId": "DGWAS-1224",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SHOULDERNAS",
    "phenotype": "Other shoulder lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SHOULDERNAS.gz"
  },
  {
    "accessionId": "DGWAS-1225",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SHOULDERBURSITIS",
    "phenotype": "Bursitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SHOULDERBURSITIS.gz"
  },
  {
    "accessionId": "DGWAS-1226",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SHORTACHILLES",
    "phenotype": "Short Achilles tendon (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired short Achilles tendon",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SHORTACHILLES.gz"
  },
  {
    "accessionId": "DGWAS-1227",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_RUPTUREMUSC",
    "phenotype": "Other rupture of muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle rupture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_RUPTUREMUSC.gz"
  },
  {
    "accessionId": "DGWAS-1228",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_RELAPSPOLYCHONDR",
    "phenotype": "Relapsing polychondritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Relapsing polychondritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_RELAPSPOLYCHONDR.gz"
  },
  {
    "accessionId": "DGWAS-1229",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_PREPATELLARBURSITIS",
    "phenotype": "Prepatellar bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prepatellar bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_PREPATELLARBURSITIS.gz"
  },
  {
    "accessionId": "DGWAS-123",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CAVS_OPERATED",
    "phenotype": "Calcific aortic valvular stenosis, operated",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Calcific aortic stenosis (operated)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CAVS_OPERATED.gz"
  },
  {
    "accessionId": "DGWAS-1230",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_POYARTOTH",
    "phenotype": "Other conditions related to polyarteritis nodosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarteritis nodosa related",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_POYARTOTH.gz"
  },
  {
    "accessionId": "DGWAS-1231",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_POSTOPMUSCULOSKE",
    "phenotype": "Postprocedural musculoskeletal disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural musculoskeletal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_POSTOPMUSCULOSKE.gz"
  },
  {
    "accessionId": "DGWAS-1232",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_POLYARTERETAL",
    "phenotype": "Polyarteritis nodosa and related conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarteritis nodosa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_POLYARTERETAL.gz"
  },
  {
    "accessionId": "DGWAS-1233",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_PATELLADISLOCATIO",
    "phenotype": "Recurrent dislocation of patella",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent patellar dislocation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_PATELLADISLOCATIO.gz"
  },
  {
    "accessionId": "DGWAS-1234",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_PANNICULITISNAS",
    "phenotype": "Panniculitis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panniculitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_PANNICULITISNAS.gz"
  },
  {
    "accessionId": "DGWAS-1235",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_PAGET",
    "phenotype": "Paget disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paget disease of bone",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_PAGET.gz"
  },
  {
    "accessionId": "DGWAS-1236",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_OVERUSENAS",
    "phenotype": "Other/unspecified soft tissue disorders related to use, overuse and pressure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overuse soft tissue disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_OVERUSENAS.gz"
  },
  {
    "accessionId": "DGWAS-1237",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_OTHERBONE",
    "phenotype": "Other disorders of bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_OTHERBONE.gz"
  },
  {
    "accessionId": "DGWAS-1239",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_OSTEOMALACIA",
    "phenotype": "Osteomalacia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteomalacia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_OSTEOMALACIA.gz"
  },
  {
    "accessionId": "DGWAS-124",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_NEUATR",
    "phenotype": "Systemic atrophies primarily affecting the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic CNS atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_NEUATR.gz"
  },
  {
    "accessionId": "DGWAS-1240",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_NEURALGIA",
    "phenotype": "Neuralgia and neuritis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neuralgia/neuritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_NEURALGIA.gz"
  },
  {
    "accessionId": "DGWAS-1241",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_NECROVASCNAS",
    "phenotype": "Other specified/unspecified necrotizing vasculopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Necrotizing vasculopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_NECROVASCNAS.gz"
  },
  {
    "accessionId": "DGWAS-1242",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_NECROFASC",
    "phenotype": "Necrotizing fasciitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Necrotizing fasciitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_NECROFASC.gz"
  },
  {
    "accessionId": "DGWAS-1243",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_MUSCLESTRAIN",
    "phenotype": "Muscle strain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle strain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_MUSCLESTRAIN.gz"
  },
  {
    "accessionId": "DGWAS-1244",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_MEDIALEPICOND",
    "phenotype": "Medial epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Medial epicondylitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_MEDIALEPICOND.gz"
  },
  {
    "accessionId": "DGWAS-1245",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LOOSEJOINT",
    "phenotype": "Loose body in joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Loose joint body",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LOOSEJOINT.gz"
  },
  {
    "accessionId": "DGWAS-1246",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LIMBLENGTH",
    "phenotype": "Unequal limb length (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired limb length discrepancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LIMBLENGTH.gz"
  },
  {
    "accessionId": "DGWAS-1247",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LIMBDEFORM",
    "phenotype": "Other specified acquired deformities of limbs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired limb deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LIMBDEFORM.gz"
  },
  {
    "accessionId": "DGWAS-1248",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_KISSING",
    "phenotype": "Kissing spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kissing spine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_KISSING.gz"
  },
  {
    "accessionId": "DGWAS-1249",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_KAWASAKI",
    "phenotype": "Mucocutaneous lymph node syndrome [Kawasaki]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kawasaki disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_KAWASAKI.gz"
  },
  {
    "accessionId": "DGWAS-125",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_OBESITYCAL",
    "phenotype": "Obesity due to excess calories",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_OBESITYCAL.gz"
  },
  {
    "accessionId": "DGWAS-1250",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_INTERHYDRARTHR",
    "phenotype": "Intermittent hydrarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intermittent hydrarthrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_INTERHYDRARTHR.gz"
  },
  {
    "accessionId": "DGWAS-1251",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_INFTENOSYNOVITIS",
    "phenotype": "Other infective (teno)synovitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infective tenosynovitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_INFTENOSYNOVITIS.gz"
  },
  {
    "accessionId": "DGWAS-1252",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_INFBURSA",
    "phenotype": "Infective bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infective bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_INFBURSA.gz"
  },
  {
    "accessionId": "DGWAS-1253",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ILIOTIBBAND",
    "phenotype": "Iliotibial band syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IT band syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ILIOTIBBAND.gz"
  },
  {
    "accessionId": "DGWAS-1254",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_HYPERMOBILITY",
    "phenotype": "Hypermobility syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint hypermobility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_HYPERMOBILITY.gz"
  },
  {
    "accessionId": "DGWAS-1255",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_HTROMBMICROANG",
    "phenotype": "Thrombotic microangiopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thrombotic microangiopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_HTROMBMICROANG.gz"
  },
  {
    "accessionId": "DGWAS-1256",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_FINGERDEFORM",
    "phenotype": "Deformity of finger(s)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Finger deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_FINGERDEFORM.gz"
  },
  {
    "accessionId": "DGWAS-1257",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_FIBROBLASTNAS",
    "phenotype": "Other fibroblastic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibroblastic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_FIBROBLASTNAS.gz"
  },
  {
    "accessionId": "DGWAS-1258",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DISSYNOTENDNAS",
    "phenotype": "Other specified/unspecified disorders of synovium and tendon +Other specified/unspecified bursopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovium/tendon/bursa disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DISSYNOTENDNAS.gz"
  },
  {
    "accessionId": "DGWAS-1259",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DIASTASIS",
    "phenotype": "Diastasis of muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle diastasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DIASTASIS.gz"
  },
  {
    "accessionId": "DGWAS-126",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_EOSINOPHIL_SUGG",
    "phenotype": "Suggestive for eosinophilic asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eosinophilic asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_EOSINOPHIL_SUGG.gz"
  },
  {
    "accessionId": "DGWAS-1260",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DERMATOPOLYNAS",
    "phenotype": "Dermatopolymyositis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatopolymyositis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DERMATOPOLYNAS.gz"
  },
  {
    "accessionId": "DGWAS-1261",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DEFORMDORSONAS",
    "phenotype": "Other specified/unspecified deforming dorsopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deforming dorsopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DEFORMDORSONAS.gz"
  },
  {
    "accessionId": "DGWAS-1262",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DEFORMACQ",
    "phenotype": "Other acquired deformities of musculoskeletal system and connective tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired musculoskeletal deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DEFORMACQ.gz"
  },
  {
    "accessionId": "DGWAS-1263",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CLAWCLUBHANDFOOT",
    "phenotype": "Acquired clawhand, clubhand, clawfoot and clubfoot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired claw/club deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CLAWCLUBHANDFOOT.gz"
  },
  {
    "accessionId": "DGWAS-1264",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CHRONSYNOVITISHANDWRIST",
    "phenotype": "Chronic crepitant synovitis/bursitis of hand and wrist/periarthritis of wrist",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic hand/wrist synovitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CHRONSYNOVITISHANDWRIST.gz"
  },
  {
    "accessionId": "DGWAS-1265",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CHRONDROPATHIES",
    "phenotype": "Chondropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CHRONDROPATHIES.gz"
  },
  {
    "accessionId": "DGWAS-1266",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CARTILAGE",
    "phenotype": "Other articular cartilage disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Articular cartilage disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CARTILAGE.gz"
  },
  {
    "accessionId": "DGWAS-1267",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CALCIOSSIMUSCLE",
    "phenotype": "Calcification and ossification of muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle calcification/ossification",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CALCIOSSIMUSCLE.gz"
  },
  {
    "accessionId": "DGWAS-1268",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CALCBURS",
    "phenotype": "Calcium deposit in bursa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bursal calcium deposit",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CALCBURS.gz"
  },
  {
    "accessionId": "DGWAS-1269",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CALCANSPUR",
    "phenotype": "Calcaneal spur",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heel spur",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CALCANSPUR.gz"
  },
  {
    "accessionId": "DGWAS-127",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Z21_PROCREATIVE_MANAG",
    "phenotype": "Procreative management",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Reproductive management",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Z21_PROCREATIVE_MANAG.gz"
  },
  {
    "accessionId": "DGWAS-1270",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BURSELBOWOTH",
    "phenotype": "Other bursitis of elbow",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Elbow bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BURSELBOWOTH.gz"
  },
  {
    "accessionId": "DGWAS-1271",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BURSCYSTOTH",
    "phenotype": "Other bursal cyst",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bursal cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BURSCYSTOTH.gz"
  },
  {
    "accessionId": "DGWAS-1272",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BONEDISNAS",
    "phenotype": "Other specified/unspecified disorders of  bone/cartilage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone/cartilage disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BONEDISNAS.gz"
  },
  {
    "accessionId": "DGWAS-1273",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BONEDENSOTH",
    "phenotype": "Other disorders of bone density and structure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone density disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BONEDENSOTH.gz"
  },
  {
    "accessionId": "DGWAS-1274",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BIOMECHLESIO",
    "phenotype": "Biomechanical lesions, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biomechanical lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BIOMECHLESIO.gz"
  },
  {
    "accessionId": "DGWAS-1275",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BICIPITALTEND",
    "phenotype": "Bicipital tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biceps tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BICIPITALTEND.gz"
  },
  {
    "accessionId": "DGWAS-1276",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_BAKERCYST",
    "phenotype": "Synovial cyst of popliteal space [Baker]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Baker cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_BAKERCYST.gz"
  },
  {
    "accessionId": "DGWAS-1277",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ANKLEFOOT",
    "phenotype": "Other acquired deformities of ankle and foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired ankle/foot deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ANKLEFOOT.gz"
  },
  {
    "accessionId": "DGWAS-1278",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_VASCULITISNAS",
    "phenotype": "Other and unspecified vasculitis limited to skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cutaneous vasculitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_VASCULITISNAS.gz"
  },
  {
    "accessionId": "DGWAS-1279",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_URTIGA_CONTACT",
    "phenotype": "Contact urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Contact urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_URTIGA_CONTACT.gz"
  },
  {
    "accessionId": "DGWAS-128",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ULCERNAS",
    "phenotype": "Ulcerative colitis, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ULCERNAS.gz"
  },
  {
    "accessionId": "DGWAS-1280",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_URTICA_COLDHEAT",
    "phenotype": "Urticaria due to cold and heat",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Physical urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_URTICA_COLDHEAT.gz"
  },
  {
    "accessionId": "DGWAS-1281",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_URTICA_CHOLINERG",
    "phenotype": "Cholinergic urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholinergic urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_URTICA_CHOLINERG.gz"
  },
  {
    "accessionId": "DGWAS-1282",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_SUNBURN",
    "phenotype": "Sunburn",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sunburn",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_SUNBURN.gz"
  },
  {
    "accessionId": "DGWAS-1283",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_STRIAEATROPHICAE",
    "phenotype": "Striae atrophicae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Striae",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_STRIAEATROPHICAE.gz"
  },
  {
    "accessionId": "DGWAS-1284",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_SCARCONDITIONS",
    "phenotype": "Scar conditions and fibrosis of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin scar/fibrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_SCARCONDITIONS.gz"
  },
  {
    "accessionId": "DGWAS-1285",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_RADIODERMATITIS",
    "phenotype": "Radiodermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Radiodermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_RADIODERMATITIS.gz"
  },
  {
    "accessionId": "DGWAS-1286",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PYODERMAGANGRENOSUM",
    "phenotype": "Pyoderma gangrenosum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyoderma gangrenosum",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PYODERMAGANGRENOSUM.gz"
  },
  {
    "accessionId": "DGWAS-1287",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PSORI_ACRODERM",
    "phenotype": "Acrodermatitis continua",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acrodermatitis continua",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PSORI_ACRODERM.gz"
  },
  {
    "accessionId": "DGWAS-1288",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PRURIGONOD",
    "phenotype": "Prurigo nodularis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prurigo nodularis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PRURIGONOD.gz"
  },
  {
    "accessionId": "DGWAS-1289",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PIGPURPDERM",
    "phenotype": "Pigmented purpuric dermatosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pigmented purpuric dermatosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PIGPURPDERM.gz"
  },
  {
    "accessionId": "DGWAS-129",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_MALEGEN",
    "phenotype": "Diseases of male genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_MALEGEN.gz"
  },
  {
    "accessionId": "DGWAS-1290",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PIGMENTNAS",
    "phenotype": "Other and unspecified disorders of pigmentation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pigmentation disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PIGMENTNAS.gz"
  },
  {
    "accessionId": "DGWAS-1291",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PERIORALDERM",
    "phenotype": "Perioral dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perioral dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PERIORALDERM.gz"
  },
  {
    "accessionId": "DGWAS-1292",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PEMPHIKELA",
    "phenotype": "Severe bullous disorders, KELA reimbursement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe bullous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PEMPHIKELA.gz"
  },
  {
    "accessionId": "DGWAS-1293",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PEMPHIGUS_VULG",
    "phenotype": "Pemphigus vulgaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pemphigus vulgaris",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PEMPHIGUS_VULG.gz"
  },
  {
    "accessionId": "DGWAS-1294",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PEMPHIGUS_NAS",
    "phenotype": "Other and unspecified pemphigus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pemphigus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PEMPHIGUS_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1295",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PARAPSO_RETIFORM",
    "phenotype": "Other and unspecified parapsoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parapsoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PARAPSO_RETIFORM.gz"
  },
  {
    "accessionId": "DGWAS-1296",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PARAPSO_PLAQUE",
    "phenotype": "Small plaque parapsoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small plaque parapsoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PARAPSO_PLAQUE.gz"
  },
  {
    "accessionId": "DGWAS-1297",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PARAPSO_PITYLICHCHRON",
    "phenotype": "Pityriasis lichenoides chronica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pityriasis lichenoides chronica",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PARAPSO_PITYLICHCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1298",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PAPULOSQUONAS",
    "phenotype": "Other and unspecified papulosquamous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Papulosquamous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PAPULOSQUONAS.gz"
  },
  {
    "accessionId": "DGWAS-1299",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PAPULOSQUAOTH",
    "phenotype": "Other papulosquamous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Papulosquamous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PAPULOSQUAOTH.gz"
  },
  {
    "accessionId": "DGWAS-13",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CHD",
    "phenotype": "Major coronary heart disease event",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major CHD event",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CHD.gz"
  },
  {
    "accessionId": "DGWAS-130",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_HYPERTROPHYBREAST_BOTH",
    "phenotype": "Hypertrophy of breast in women and men",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_HYPERTROPHYBREAST_BOTH.gz"
  },
  {
    "accessionId": "DGWAS-1300",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_OTHPIGMENTATION",
    "phenotype": "Other disorders of pigmentation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pigmentation disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_OTHPIGMENTATION.gz"
  },
  {
    "accessionId": "DGWAS-1301",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_OTHERMELANIN",
    "phenotype": "Other melanin hyperpigmentation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperpigmentation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_OTHERMELANIN.gz"
  },
  {
    "accessionId": "DGWAS-1302",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_OTHERDISSKINANDSUBCUTIS",
    "phenotype": "Other disorders of skin and subcutaneous tissue, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin/subcutaneous disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_OTHERDISSKINANDSUBCUTIS.gz"
  },
  {
    "accessionId": "DGWAS-1303",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_OTHACUSKINSUNNAS",
    "phenotype": "Other and unspecified acute skin changes due to ultraviolet radiation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute UV skin change",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_OTHACUSKINSUNNAS.gz"
  },
  {
    "accessionId": "DGWAS-1304",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_NAIL_LYSIS",
    "phenotype": "Onycholysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Onycholysis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_NAIL_LYSIS.gz"
  },
  {
    "accessionId": "DGWAS-1305",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_NAIL_GRYPHOSIS",
    "phenotype": "Onychogryphosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Onychogryphosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_NAIL_GRYPHOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1306",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_NAIL_DYSTROPHY",
    "phenotype": "Nail dystrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nail dystrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_NAIL_DYSTROPHY.gz"
  },
  {
    "accessionId": "DGWAS-1307",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_NAILNAS",
    "phenotype": "Other and unspecified nail disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nail disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_NAILNAS.gz"
  },
  {
    "accessionId": "DGWAS-1308",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_LOCALSCLERODERMA",
    "phenotype": "Localized scleroderma [morphea]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Morphea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_LOCALSCLERODERMA.gz"
  },
  {
    "accessionId": "DGWAS-1309",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_LOCALDCONNECTISSUEOTH",
    "phenotype": "Other localized connective tissue disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Localized connective tissue disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_LOCALDCONNECTISSUEOTH.gz"
  },
  {
    "accessionId": "DGWAS-131",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_HYPERTROPHYBREAST",
    "phenotype": "Hypertrophy of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_HYPERTROPHYBREAST.gz"
  },
  {
    "accessionId": "DGWAS-1310",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_LOCALCONNECTISSUENAS",
    "phenotype": "Other and unspecified localized connective tissue disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Localized CTD NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_LOCALCONNECTISSUENAS.gz"
  },
  {
    "accessionId": "DGWAS-1311",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_LIVEDOIDVASC",
    "phenotype": "Livedoid vasculitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Livedoid vasculitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_LIVEDOIDVASC.gz"
  },
  {
    "accessionId": "DGWAS-1312",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_LICHENPLANO",
    "phenotype": "Lichen planopilaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen planopilaris",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_LICHENPLANO.gz"
  },
  {
    "accessionId": "DGWAS-1313",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_INFECT_SKIN_OTHER",
    "phenotype": "Other local infections of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Local skin infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_INFECT_SKIN_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-1314",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_IMPETIGO",
    "phenotype": "Impetigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impetigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_IMPETIGO.gz"
  },
  {
    "accessionId": "DGWAS-1315",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HYPERTROPHICNAS",
    "phenotype": "Other and unspecified hypertrophic disorders of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic skin disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HYPERTROPHICNAS.gz"
  },
  {
    "accessionId": "DGWAS-1316",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HYPERTICHNAS",
    "phenotype": "Other hypertrichosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrichosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HYPERTICHNAS.gz"
  },
  {
    "accessionId": "DGWAS-1317",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HIRSUTISM_ADVERSE",
    "phenotype": "Hirsutism, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced hirsutism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HIRSUTISM_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-1318",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HAIRLOSS_NONSCARNAS",
    "phenotype": "Other and unspecified nonscarring hair loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-scarring alopecia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HAIRLOSS_NONSCARNAS.gz"
  },
  {
    "accessionId": "DGWAS-1319",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HAIRLOSSSCAR",
    "phenotype": "Cicatricial alopecia [scarring hair loss]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scarring alopecia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HAIRLOSSSCAR.gz"
  },
  {
    "accessionId": "DGWAS-132",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ALZHEIMER",
    "phenotype": "Alzheimer disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ALZHEIMER.gz"
  },
  {
    "accessionId": "DGWAS-1320",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HAIRLOSSNONSCAR",
    "phenotype": "Other nonscarring hair loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-scarring alopecia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HAIRLOSSNONSCAR.gz"
  },
  {
    "accessionId": "DGWAS-1321",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HAIRCOLOUR",
    "phenotype": "Hair colour and hair shaft abnormalities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hair shaft abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HAIRCOLOUR.gz"
  },
  {
    "accessionId": "DGWAS-1322",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_GRANULOMASKINNAS",
    "phenotype": "Other and unspecified granulomatous disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin granulomatous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_GRANULOMASKINNAS.gz"
  },
  {
    "accessionId": "DGWAS-1323",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_FOLLICULITDECALV",
    "phenotype": "Folliculitis decalvans",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Folliculitis decalvans",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_FOLLICULITDECALV.gz"
  },
  {
    "accessionId": "DGWAS-1324",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_FOLLICULARNAS",
    "phenotype": "Other and unspecified follicular disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_FOLLICULARNAS.gz"
  },
  {
    "accessionId": "DGWAS-1325",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_FOLICULAROTH",
    "phenotype": "Other follicular disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_FOLICULAROTH.gz"
  },
  {
    "accessionId": "DGWAS-1326",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_EXFOLIATIVE",
    "phenotype": "Exfoliative dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Exfoliative dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_EXFOLIATIVE.gz"
  },
  {
    "accessionId": "DGWAS-1327",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ERYTHRASMA",
    "phenotype": "Erythrasma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erythrasma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ERYTHRASMA.gz"
  },
  {
    "accessionId": "DGWAS-1328",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ERYTHINOTH",
    "phenotype": "Erythema in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary erythema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ERYTHINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1329",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ERYTHEMATOUSOTH",
    "phenotype": "Other erythematous conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erythematous condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ERYTHEMATOUSOTH.gz"
  },
  {
    "accessionId": "DGWAS-133",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_MENORRHAGIA",
    "phenotype": "Menorrhagia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menorrhagia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_MENORRHAGIA.gz"
  },
  {
    "accessionId": "DGWAS-1330",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ERTYTH_TOXIC",
    "phenotype": "Toxic erythema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic erythema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ERTYTH_TOXIC.gz"
  },
  {
    "accessionId": "DGWAS-1331",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_EPIDERMALTHICKOTH",
    "phenotype": "Other epidermal thickening",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epidermal thickening",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_EPIDERMALTHICKOTH.gz"
  },
  {
    "accessionId": "DGWAS-1332",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ECCRINESWEAT",
    "phenotype": "Eccrine sweat disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sweat gland disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ECCRINESWEAT.gz"
  },
  {
    "accessionId": "DGWAS-1333",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_DERM_NUMMULAR",
    "phenotype": "Nummular dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nummular dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_DERM_NUMMULAR.gz"
  },
  {
    "accessionId": "DGWAS-1334",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_DECUBITANSULCERANDPRESSURE",
    "phenotype": "Decubitus ulcer and pressure area",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pressure ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_DECUBITANSULCERANDPRESSURE.gz"
  },
  {
    "accessionId": "DGWAS-1335",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_CUTLAXSEN",
    "phenotype": "Cutis laxa senilis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Senile cutis laxa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_CUTLAXSEN.gz"
  },
  {
    "accessionId": "DGWAS-1336",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_CHRONICULCEROFSKIN",
    "phenotype": "Chronic ulcer of skin, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic skin ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_CHRONICULCEROFSKIN.gz"
  },
  {
    "accessionId": "DGWAS-1337",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_CHLOASMA",
    "phenotype": "Chloasma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chloasma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_CHLOASMA.gz"
  },
  {
    "accessionId": "DGWAS-1338",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_CELLULITIS",
    "phenotype": "Cellulitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cellulitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_CELLULITIS.gz"
  },
  {
    "accessionId": "DGWAS-1339",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ATROPHICSKINNAS",
    "phenotype": "Other and unspecified atrophic disorders of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrophic skin disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ATROPHICSKINNAS.gz"
  },
  {
    "accessionId": "DGWAS-134",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMGENPROL",
    "phenotype": "Female genital prolapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital prolapse",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMGENPROL.gz"
  },
  {
    "accessionId": "DGWAS-1340",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_APOCRINESWEAT",
    "phenotype": "Apocrine sweat disorders, other sweat gland disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Apocrine sweat disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_APOCRINESWEAT.gz"
  },
  {
    "accessionId": "DGWAS-1341",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ALOPECANDRO",
    "phenotype": "Androgenic alopecia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Androgenetic alopecia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ALOPECANDRO.gz"
  },
  {
    "accessionId": "DGWAS-1342",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ACQKERAT",
    "phenotype": "Acquired keratosis [keratoderma] palmaris et plantaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired palmoplantar keratoderma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ACQKERAT.gz"
  },
  {
    "accessionId": "DGWAS-1343",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ACNE_VARIOLIFORMIS",
    "phenotype": "Acne varioliformis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne varioliformis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ACNE_VARIOLIFORMIS.gz"
  },
  {
    "accessionId": "DGWAS-1344",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ACNE_NAS",
    "phenotype": "Other  and unspecified acne",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ACNE_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1345",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ACNEKELOID",
    "phenotype": "Acne keloid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne keloidalis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ACNEKELOID.gz"
  },
  {
    "accessionId": "DGWAS-1346",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_ACANTHOLYTIC",
    "phenotype": "Other acantholytic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acantholytic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_ACANTHOLYTIC.gz"
  },
  {
    "accessionId": "DGWAS-1347",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_MOTOR_EXMORE",
    "phenotype": "Motor disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Motor disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_MOTOR_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1348",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_CHILDSOC_EXMORE",
    "phenotype": "Social disorders starting during childhood or adolescence (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood/adolescent social disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_CHILDSOC_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1349",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_BEHAV_EXMORE",
    "phenotype": "Behavioural disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_BEHAV_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-135",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_AORTANEUR",
    "phenotype": "Aortic aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic aneurysm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_AORTANEUR.gz"
  },
  {
    "accessionId": "DGWAS-1350",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_AUTISM_EXMORE",
    "phenotype": "Autism spe (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autism spectrum disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_AUTISM_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1351",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_VOLVU",
    "phenotype": "Volvulus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Volvulus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_VOLVU.gz"
  },
  {
    "accessionId": "DGWAS-1352",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_VASCINT",
    "phenotype": "Vascular disorders of the intestines",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal vascular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_VASCINT.gz"
  },
  {
    "accessionId": "DGWAS-1353",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_TOXLIV",
    "phenotype": "Toxic liver disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic liver disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_TOXLIV.gz"
  },
  {
    "accessionId": "DGWAS-1354",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_SUPNUM_ONLY_INCLAVO",
    "phenotype": "Supernumerary teeth EXCLUDE clefts and syndromes , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Supernumerary teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_SUPNUM_ONLY_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-1355",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_SUPNUM_ONLY",
    "phenotype": "Supernumerary teeth EXCLUDE clefts and syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Supernumerary teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_SUPNUM_ONLY.gz"
  },
  {
    "accessionId": "DGWAS-1356",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_SCISS_BITE",
    "phenotype": "Scissor bite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scissor bite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_SCISS_BITE.gz"
  },
  {
    "accessionId": "DGWAS-1357",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_SALIVARY",
    "phenotype": "Diseases of salivary glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salivary gland disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_SALIVARY.gz"
  },
  {
    "accessionId": "DGWAS-1358",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_RETROG_MAXILLAE",
    "phenotype": "Maxillary retrognathism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maxillary retrognathism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_RETROG_MAXILLAE.gz"
  },
  {
    "accessionId": "DGWAS-1359",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_RESORPTION",
    "phenotype": "Pathological resorption of teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth resorption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_RESORPTION.gz"
  },
  {
    "accessionId": "DGWAS-136",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_OTHEREAR",
    "phenotype": "Other disorders of ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ear disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_OTHEREAR.gz"
  },
  {
    "accessionId": "DGWAS-1360",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_PULPITIS_3",
    "phenotype": "Dental pulpitis 3",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulpitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_PULPITIS_3.gz"
  },
  {
    "accessionId": "DGWAS-1361",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_PULC",
    "phenotype": "Peptic ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peptic ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_PULC.gz"
  },
  {
    "accessionId": "DGWAS-1362",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_PERITON",
    "phenotype": "Diseases of peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_PERITON.gz"
  },
  {
    "accessionId": "DGWAS-1363",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_PERFOES",
    "phenotype": "Perforation of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal perforation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_PERFOES.gz"
  },
  {
    "accessionId": "DGWAS-1364",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OTHILEUS",
    "phenotype": "Other or unspecified ileus, impaction or obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal obstruction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OTHILEUS.gz"
  },
  {
    "accessionId": "DGWAS-1365",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OTHABDHER",
    "phenotype": "Other and unspecified abdominal hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OTHABDHER.gz"
  },
  {
    "accessionId": "DGWAS-1366",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ORAL_LEUCOPLACIA",
    "phenotype": "Oral leukoplakia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral leukoplakia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ORAL_LEUCOPLACIA.gz"
  },
  {
    "accessionId": "DGWAS-1367",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ORALCYST",
    "phenotype": "Cysts of oral region, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ORALCYST.gz"
  },
  {
    "accessionId": "DGWAS-1368",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OPEN_BITE_SURGERY",
    "phenotype": "Open bite that required surgery (Lefort1 or BSSRO)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Open bite (surgical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OPEN_BITE_SURGERY.gz"
  },
  {
    "accessionId": "DGWAS-1369",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OPEN_BITE",
    "phenotype": "Open bite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Open bite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OPEN_BITE.gz"
  },
  {
    "accessionId": "DGWAS-137",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_IRIDOACUTE",
    "phenotype": "Acute and subacute iridocyclitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iridocyclitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_IRIDOACUTE.gz"
  },
  {
    "accessionId": "DGWAS-1370",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OESULC_ADVERSE",
    "phenotype": "Ulcer of oesophagus, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced esophageal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OESULC_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-1371",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OESULC",
    "phenotype": "Ulcer of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OESULC.gz"
  },
  {
    "accessionId": "DGWAS-1372",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OESITIS_ADVERSE",
    "phenotype": "Oesophagitis, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced esophagitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OESITIS_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-1373",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OESITIS",
    "phenotype": "Oesophagitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophagitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OESITIS.gz"
  },
  {
    "accessionId": "DGWAS-1374",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MN_RETRGN",
    "phenotype": "Mandibular retrognathia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular retrognathia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MN_RETRGN.gz"
  },
  {
    "accessionId": "DGWAS-1375",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MN_PROGN_AND_SURGRT_INCLAVO",
    "phenotype": "Mandibular prognathia AND surgery (LeFortI or BSSO or LeFortI AND BSSO) , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular prognathia (surgical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MN_PROGN_AND_SURGRT_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-1376",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MN_PROGN_AND_SURGRT",
    "phenotype": "Mandibular prognathia AND surgery (LeFortI or BSSRO)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular prognathia (surgical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MN_PROGN_AND_SURGRT.gz"
  },
  {
    "accessionId": "DGWAS-1377",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MAXIL_PROGN",
    "phenotype": "Maxillary prognathism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maxillary prognathism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MAXIL_PROGN.gz"
  },
  {
    "accessionId": "DGWAS-1378",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MAXIL_MOLAR_FAILED_ERUPT_OBSTRUCTION_TOOTH",
    "phenotype": "Impacted maxillary molar",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted maxillary molar",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MAXIL_MOLAR_FAILED_ERUPT_OBSTRUCTION_TOOTH.gz"
  },
  {
    "accessionId": "DGWAS-1379",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MAXIL_CANINE_PALAT",
    "phenotype": "Palatinal maxillary canine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Palatally impacted maxillary canine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MAXIL_CANINE_PALAT.gz"
  },
  {
    "accessionId": "DGWAS-138",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GEST_DIABETES",
    "phenotype": "Gestational diabetes (for exclusion)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational diabetes",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GEST_DIABETES.gz"
  },
  {
    "accessionId": "DGWAS-1380",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MAXIL_CANINE_FAILED_ERUPT_OBSTRUCTION_TOOTH",
    "phenotype": "Impacted maxillary canine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted maxillary canine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MAXIL_CANINE_FAILED_ERUPT_OBSTRUCTION_TOOTH.gz"
  },
  {
    "accessionId": "DGWAS-1381",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MANDIBULAR_HYPOPL",
    "phenotype": "Mandibular hypoplasia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular hypoplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MANDIBULAR_HYPOPL.gz"
  },
  {
    "accessionId": "DGWAS-1382",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MAJOR_ANOMALI_JAW_SIZE",
    "phenotype": "Major anomalies of jaw size",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw size anomaly",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MAJOR_ANOMALI_JAW_SIZE.gz"
  },
  {
    "accessionId": "DGWAS-1383",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_LIVDISINOTH",
    "phenotype": "Liver disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary liver disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_LIVDISINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1384",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_K03_COMBINATION",
    "phenotype": "Other diseases of hard tissues of teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental hard tissue disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_K03_COMBINATION.gz"
  },
  {
    "accessionId": "DGWAS-1385",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_INTUSS",
    "phenotype": "Intussusception",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intussusception",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_INTUSS.gz"
  },
  {
    "accessionId": "DGWAS-1386",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_IMPACTED_TEETH",
    "phenotype": "Impacted teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_IMPACTED_TEETH.gz"
  },
  {
    "accessionId": "DGWAS-1387",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_IMPACT",
    "phenotype": "Impaction of intestines",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal impaction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_IMPACT.gz"
  },
  {
    "accessionId": "DGWAS-1388",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ILEUS",
    "phenotype": "Paralytic ileus and intestinal obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic ileus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ILEUS.gz"
  },
  {
    "accessionId": "DGWAS-1389",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_IBS",
    "phenotype": "Irritable bowel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IBS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_IBS.gz"
  },
  {
    "accessionId": "DGWAS-139",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_SPINAMUSCOTH",
    "phenotype": "Other and unspecified spinal muscular atrophies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal muscular atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_SPINAMUSCOTH.gz"
  },
  {
    "accessionId": "DGWAS-1390",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HYPERTROPHY_TONGUE_PAPILLAE",
    "phenotype": "Hypertrophy of tongue papillae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tongue papillae hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HYPERTROPHY_TONGUE_PAPILLAE.gz"
  },
  {
    "accessionId": "DGWAS-1391",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HEPFAIL",
    "phenotype": "Hepatic failure, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatic failure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HEPFAIL.gz"
  },
  {
    "accessionId": "DGWAS-1392",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_GULC",
    "phenotype": "Gastric ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_GULC.gz"
  },
  {
    "accessionId": "DGWAS-1393",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_GJULC",
    "phenotype": "Gastrojejunal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastrojejunal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_GJULC.gz"
  },
  {
    "accessionId": "DGWAS-1395",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_EMBIMPACT_TEETH",
    "phenotype": "Embedded and impacted teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embedded/impacted teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_EMBIMPACT_TEETH.gz"
  },
  {
    "accessionId": "DGWAS-1396",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_DISTAL_BITE",
    "phenotype": "Distal bite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Distal occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_DISTAL_BITE.gz"
  },
  {
    "accessionId": "DGWAS-1397",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_DISORD_TEETH",
    "phenotype": "Other disorders of teeth and supporting structures",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental/supporting structure disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_DISORD_TEETH.gz"
  },
  {
    "accessionId": "DGWAS-1398",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_DEEP_BITE_SURGERY",
    "phenotype": "Deep bite that required surgery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deep bite (surgical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_DEEP_BITE_SURGERY.gz"
  },
  {
    "accessionId": "DGWAS-1399",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_DEEP_BITE",
    "phenotype": "Deep bite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deep bite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_DEEP_BITE.gz"
  },
  {
    "accessionId": "DGWAS-14",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CARDIAC_ARRHYTM",
    "phenotype": "Cardiac arrhythmias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrhythmia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CARDIAC_ARRHYTM.gz"
  },
  {
    "accessionId": "DGWAS-140",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CYSTIC_KIDNEY_DISEA",
    "phenotype": "Cystic kidney disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystic kidney disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CYSTIC_KIDNEY_DISEA.gz"
  },
  {
    "accessionId": "DGWAS-1400",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CD_STRICT_PSC",
    "phenotype": "Crohn's disease (strict) with PSC",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease with PSC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CD_STRICT_PSC.gz"
  },
  {
    "accessionId": "DGWAS-1401",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ANOMALI_DENTAL_ARCH_RELATIONS1",
    "phenotype": "Anomalies of dental arch relationship, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental arch anomaly",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ANOMALI_DENTAL_ARCH_RELATIONS1.gz"
  },
  {
    "accessionId": "DGWAS-1402",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_SIMPLBRONCH",
    "phenotype": "Simple and mucopurulent chronic bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic bronchitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_SIMPLBRONCH.gz"
  },
  {
    "accessionId": "DGWAS-1403",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_SILICAPNEUMOC",
    "phenotype": "Pneumoconiosis due to dust containing silica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Silicosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_SILICAPNEUMOC.gz"
  },
  {
    "accessionId": "DGWAS-1404",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_RESPCONDEXT",
    "phenotype": "Respiratory conditions due to other external agents",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External agent respiratory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_RESPCONDEXT.gz"
  },
  {
    "accessionId": "DGWAS-1405",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PULMOEDEMA",
    "phenotype": "Pulmonary oedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary edema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PULMOEDEMA.gz"
  },
  {
    "accessionId": "DGWAS-1406",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PULMEOS",
    "phenotype": "Pulmonary eosinophilia, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary eosinophilia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PULMEOS.gz"
  },
  {
    "accessionId": "DGWAS-1407",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PNEUMOTHORAX",
    "phenotype": "Pneumothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumothorax",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PNEUMOTHORAX.gz"
  },
  {
    "accessionId": "DGWAS-1408",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PNEUMOPNEUMO",
    "phenotype": "Pneumonia due to Streptococcus pneumoniae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumococcal pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PNEUMOPNEUMO.gz"
  },
  {
    "accessionId": "DGWAS-1409",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PNEUMONONBACT",
    "phenotype": "Pneumonia due to other infectious organisms, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious pneumonia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PNEUMONONBACT.gz"
  },
  {
    "accessionId": "DGWAS-141",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_ICP_EXMORE",
    "phenotype": "Intrahepatic Cholestasis of Pregnancy (ICP) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intrahepatic cholestasis of pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_ICP_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1410",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PNEUMOHAEM",
    "phenotype": "Pneumonia due to Haemophilus influenzae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "H. influenzae pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PNEUMOHAEM.gz"
  },
  {
    "accessionId": "DGWAS-1411",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PLEUROTH",
    "phenotype": "Other pleural conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PLEUROTH.gz"
  },
  {
    "accessionId": "DGWAS-1412",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PLEUREFFUSION",
    "phenotype": "Pleural effusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural effusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PLEUREFFUSION.gz"
  },
  {
    "accessionId": "DGWAS-1413",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PHARYNGITIS",
    "phenotype": "Acute pharyngitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pharyngitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PHARYNGITIS.gz"
  },
  {
    "accessionId": "DGWAS-1414",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_NECROTIC",
    "phenotype": "Suppurative and necrotic conditions of lower respiratory tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower respiratory suppurative/necrotic condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_NECROTIC.gz"
  },
  {
    "accessionId": "DGWAS-1415",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_INORGPNEUMOC",
    "phenotype": "Pneumoconiosis due to other inorganic dusts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other inorganic dust pneumoconiosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_INORGPNEUMOC.gz"
  },
  {
    "accessionId": "DGWAS-1416",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_COLD",
    "phenotype": "Acute nasopharyngitis(common cold)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Common cold",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_COLD.gz"
  },
  {
    "accessionId": "DGWAS-1417",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_CHRONRHINITIS",
    "phenotype": "Chronic rhinitis, nasopharyngitis and pharyngitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic rhinitis/pharyngitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_CHRONRHINITIS.gz"
  },
  {
    "accessionId": "DGWAS-1418",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_BRONCHNAS",
    "phenotype": "Unspecified chronic bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic bronchitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_BRONCHNAS.gz"
  },
  {
    "accessionId": "DGWAS-1419",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_BRONCH",
    "phenotype": "Bronchitis, not specified as acute or chronic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_BRONCH.gz"
  },
  {
    "accessionId": "DGWAS-142",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ANKYLOSPON",
    "phenotype": "Ankylosing spondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankylosing spondylitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ANKYLOSPON.gz"
  },
  {
    "accessionId": "DGWAS-1420",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_ARDS",
    "phenotype": "Adult respiratory distress syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ARDS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_ARDS.gz"
  },
  {
    "accessionId": "DGWAS-1421",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_AIRWDISDUST",
    "phenotype": "Airway disease due to specific organic dust",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Organic dust airway disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_AIRWDISDUST.gz"
  },
  {
    "accessionId": "DGWAS-1422",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_ABSCMEDIASTINUM",
    "phenotype": "Abscess of mediastinum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mediastinal abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_ABSCMEDIASTINUM.gz"
  },
  {
    "accessionId": "DGWAS-1423",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_INFLUENZA",
    "phenotype": "All influenza (not pneumonia)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Influenza",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_INFLUENZA.gz"
  },
  {
    "accessionId": "DGWAS-1424",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_INCREASEDMUSCLETONE",
    "phenotype": "Increased muscle tone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_INCREASEDMUSCLETONE.gz"
  },
  {
    "accessionId": "DGWAS-1425",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ILD_SYST_AUTO",
    "phenotype": "ILD related to systemic autoimmune disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune ILD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ILD_SYST_AUTO.gz"
  },
  {
    "accessionId": "DGWAS-1426",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ILD_ELSEWHERE",
    "phenotype": "ILD and respiratory illness in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary ILD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ILD_ELSEWHERE.gz"
  },
  {
    "accessionId": "DGWAS-1427",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_VASCINT",
    "phenotype": "Vascular diseases of the intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal vascular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_VASCINT.gz"
  },
  {
    "accessionId": "DGWAS-1428",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_VARICVESOTH",
    "phenotype": "Varicose veins of other sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varicose veins",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_VARICVESOTH.gz"
  },
  {
    "accessionId": "DGWAS-1429",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_THROMBANG",
    "phenotype": "Thromboangiitis obliterans",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Buerger disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_THROMBANG.gz"
  },
  {
    "accessionId": "DGWAS-143",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_KERATOCONUS",
    "phenotype": "Hereditary corneal dystrophies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary corneal dystrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_KERATOCONUS.gz"
  },
  {
    "accessionId": "DGWAS-1430",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_SECONDRIGHT",
    "phenotype": "Secondary right heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary right heart disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_SECONDRIGHT.gz"
  },
  {
    "accessionId": "DGWAS-1431",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_RHEUVALV",
    "phenotype": "Rheumatic valve diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic valve disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_RHEUVALV.gz"
  },
  {
    "accessionId": "DGWAS-1432",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_RHEUFEVWITHOUTHEART",
    "phenotype": "Rheumatic fever without mention of heart involvement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_RHEUFEVWITHOUTHEART.gz"
  },
  {
    "accessionId": "DGWAS-1433",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_RHEUFEV",
    "phenotype": "Rheumatic fever incl heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic heart disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_RHEUFEV.gz"
  },
  {
    "accessionId": "DGWAS-1434",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PROGVASC",
    "phenotype": "Progressive vascular leukoencephalopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Progressive vascular leukoencephalopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PROGVASC.gz"
  },
  {
    "accessionId": "DGWAS-1435",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PERICARD",
    "phenotype": "Pericarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pericarditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PERICARD.gz"
  },
  {
    "accessionId": "DGWAS-1436",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PERICAOTH",
    "phenotype": "Other diseases of pericardium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pericardial disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PERICAOTH.gz"
  },
  {
    "accessionId": "DGWAS-1437",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_OTHILLHEART",
    "phenotype": "Other or ill-defined heart diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_OTHILLHEART.gz"
  },
  {
    "accessionId": "DGWAS-1438",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_LYMPHOTH",
    "phenotype": "Other noninfective disorders of lymphatic vessels and lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfective lymphatic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_LYMPHOTH.gz"
  },
  {
    "accessionId": "DGWAS-1439",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HYPTENSPUL",
    "phenotype": "Hypertension, Pulmonary Arterial",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary arterial hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HYPTENSPUL.gz"
  },
  {
    "accessionId": "DGWAS-144",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_IRIDOCYC_ANTER",
    "phenotype": "Anterior Iridocyclitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anterior iridocyclitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_IRIDOCYC_ANTER.gz"
  },
  {
    "accessionId": "DGWAS-1440",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HYPTENSPOR",
    "phenotype": "Hypertension, portal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Portal hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HYPTENSPOR.gz"
  },
  {
    "accessionId": "DGWAS-1441",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HYPOTE",
    "phenotype": "Hypotension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypotension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HYPOTE.gz"
  },
  {
    "accessionId": "DGWAS-1442",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HYPERTENC",
    "phenotype": "Hypertensive encephalopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive encephalopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HYPERTENC.gz"
  },
  {
    "accessionId": "DGWAS-1443",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_EMBTHROAOR",
    "phenotype": "Embolism and thrombosis of abdominal aorta",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal aortic thrombosis/embolism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_EMBTHROAOR.gz"
  },
  {
    "accessionId": "DGWAS-1444",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CEREBRART",
    "phenotype": "Cerebral arteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral arteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CEREBRART.gz"
  },
  {
    "accessionId": "DGWAS-1445",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CARDMYORESTR",
    "phenotype": "Restrictive cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Restrictive cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CARDMYORESTR.gz"
  },
  {
    "accessionId": "DGWAS-1446",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CARDMYOALC",
    "phenotype": "Alcoholic cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CARDMYOALC.gz"
  },
  {
    "accessionId": "DGWAS-1447",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_HYPOTE_DRUGS",
    "phenotype": "Hypotension due to drugs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced hypotension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_HYPOTE_DRUGS.gz"
  },
  {
    "accessionId": "DGWAS-1448",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_HERING_UNILATERAL",
    "phenotype": "Inguinal hernia, unilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unilateral inguinal hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_HERING_UNILATERAL.gz"
  },
  {
    "accessionId": "DGWAS-1449",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_TYMPSCLE",
    "phenotype": "Tympanosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanosclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_TYMPSCLE.gz"
  },
  {
    "accessionId": "DGWAS-145",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ULCERRECT",
    "phenotype": "Ulcerative rectosigmoiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative rectosigmoiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ULCERRECT.gz"
  },
  {
    "accessionId": "DGWAS-1450",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_SUP_OTINAS",
    "phenotype": "Suppurative otitis media, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suppurative otitis media NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_SUP_OTINAS.gz"
  },
  {
    "accessionId": "DGWAS-1451",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_POSTOPNAS",
    "phenotype": "Other/unspecified postprocedural disorders of ear and mastoid process",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural ear/mastoid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_POSTOPNAS.gz"
  },
  {
    "accessionId": "DGWAS-1452",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_POSTOP",
    "phenotype": "Postprocedural disorders of ear and mastoid process, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural ear/mastoid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_POSTOP.gz"
  },
  {
    "accessionId": "DGWAS-1453",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_POSTMASTNAS",
    "phenotype": "Other disorders following mastoidectomy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmastoidectomy disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_POSTMASTNAS.gz"
  },
  {
    "accessionId": "DGWAS-1454",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_POSTMASTCHOLEASTOMA",
    "phenotype": "Recurrent cholesteatoma of postmastoidectomy cavity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent cholesteatoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_POSTMASTCHOLEASTOMA.gz"
  },
  {
    "accessionId": "DGWAS-1455",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_PINNADIS",
    "phenotype": "Noninfective disorders of pinna",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pinna disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_PINNADIS.gz"
  },
  {
    "accessionId": "DGWAS-1456",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_OTIMEDNAS",
    "phenotype": "Otitis media, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis media NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_OTIMEDNAS.gz"
  },
  {
    "accessionId": "DGWAS-1457",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_OTALGIA",
    "phenotype": "Otalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_OTALGIA.gz"
  },
  {
    "accessionId": "DGWAS-1458",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_NOISEINNER",
    "phenotype": "Noise effects on inner ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noise-induced hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_NOISEINNER.gz"
  },
  {
    "accessionId": "DGWAS-1459",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MYRINGNAS",
    "phenotype": "Other specified/unspecified disorders of tympanic membrane",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MYRINGNAS.gz"
  },
  {
    "accessionId": "DGWAS-146",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMA_SEROPOS_STRICT",
    "phenotype": "Seropositive rheumatoid arthritis, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seropositive RA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMA_SEROPOS_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-1460",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MYRINGCHRON",
    "phenotype": "Chronic myringitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic myringitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MYRINGCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1461",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MIDDMASTNAS",
    "phenotype": "Other specified/unspecified disorders of middle ear and mastoid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear/mastoid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MIDDMASTNAS.gz"
  },
  {
    "accessionId": "DGWAS-1462",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MIDDLEADDH",
    "phenotype": "Adhesive middle ear disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adhesive otitis media",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MIDDLEADDH.gz"
  },
  {
    "accessionId": "DGWAS-1463",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MASTNAS",
    "phenotype": "Other/unspecified mastoiditis and related conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mastoiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MASTNAS.gz"
  },
  {
    "accessionId": "DGWAS-1464",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_LABYRINTHITIS",
    "phenotype": "Labyrinthitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labyrinthitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_LABYRINTHITIS.gz"
  },
  {
    "accessionId": "DGWAS-1465",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_LABYRFISTU",
    "phenotype": "Labyrinthine fistula",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labyrinthine fistula",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_LABYRFISTU.gz"
  },
  {
    "accessionId": "DGWAS-1466",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_INNERNAS",
    "phenotype": "Other specified/unspecified diseases of inner ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inner ear disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_INNERNAS.gz"
  },
  {
    "accessionId": "DGWAS-1467",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_HL_NAS",
    "phenotype": "Other specified/unspecified hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hearing loss NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_HL_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1468",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_HL_CON_NAS",
    "phenotype": "Conductive hearing loss, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conductive hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_HL_CON_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1469",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_EXTDISNAS",
    "phenotype": "Other specified disorders of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_EXTDISNAS.gz"
  },
  {
    "accessionId": "DGWAS-147",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_HYPTENSPREG",
    "phenotype": "Pregnancy hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_HYPTENSPREG.gz"
  },
  {
    "accessionId": "DGWAS-1470",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_CERUMEN",
    "phenotype": "Impacted cerumen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted cerumen",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_CERUMEN.gz"
  },
  {
    "accessionId": "DGWAS-1471",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VITRPROLAPSE",
    "phenotype": "Vitreous prolapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous prolapse",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VITRPROLAPSE.gz"
  },
  {
    "accessionId": "DGWAS-1472",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VITROTH",
    "phenotype": "Other and unspecified disorders of vitreous body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VITROTH.gz"
  },
  {
    "accessionId": "DGWAS-1473",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VISUDISTURBSUB",
    "phenotype": "Subjective visual disturbances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual disturbance",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VISUDISTURBSUB.gz"
  },
  {
    "accessionId": "DGWAS-1474",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VISUALPATHNAS",
    "phenotype": "Disorder of visual pathways, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual pathway disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VISUALPATHNAS.gz"
  },
  {
    "accessionId": "DGWAS-1475",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VISIMPBILATERAL",
    "phenotype": "Blindness or visual impairment, binocular",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binocular blindness",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VISIMPBILATERAL.gz"
  },
  {
    "accessionId": "DGWAS-1476",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_VISFIELDDEF",
    "phenotype": "Visual field defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual field defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_VISFIELDDEF.gz"
  },
  {
    "accessionId": "DGWAS-1477",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_RETINODISINOTH",
    "phenotype": "Other retinal disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary retinal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_RETINODISINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1478",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_RETINANAS",
    "phenotype": "Other specified and unspecified retinal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_RETINANAS.gz"
  },
  {
    "accessionId": "DGWAS-1479",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_RETARTOCCTRANS",
    "phenotype": "Transient retinal artery occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transient retinal artery occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_RETARTOCCTRANS.gz"
  },
  {
    "accessionId": "DGWAS-148",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_MESNRUIRREG",
    "phenotype": "Excessive, frequent and irregular menstruation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menstrual disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_MESNRUIRREG.gz"
  },
  {
    "accessionId": "DGWAS-1480",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_PURENDOPHTHALMITIS",
    "phenotype": "Purulent endophthalmitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Purulent endophthalmitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_PURENDOPHTHALMITIS.gz"
  },
  {
    "accessionId": "DGWAS-1481",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_PARASTRAB",
    "phenotype": "Paralytic strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic strabismus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_PARASTRAB.gz"
  },
  {
    "accessionId": "DGWAS-1482",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_PARASTRA6",
    "phenotype": "Sixth [abducent] nerve palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abducens palsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_PARASTRA6.gz"
  },
  {
    "accessionId": "DGWAS-1483",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_OTHERCONJ",
    "phenotype": "Other disorders of conjunctiva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_OTHERCONJ.gz"
  },
  {
    "accessionId": "DGWAS-1484",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_OTHENDOPHTHALMITIS",
    "phenotype": "Other endophthalmitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endophthalmitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_OTHENDOPHTHALMITIS.gz"
  },
  {
    "accessionId": "DGWAS-1485",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ORBITNAS",
    "phenotype": "Other and unspecified disorders of orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orbital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ORBITNAS.gz"
  },
  {
    "accessionId": "DGWAS-1486",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ORBITINFLAMCHRON",
    "phenotype": "Chronic inflammatory disorders of orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic orbital inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ORBITINFLAMCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1487",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_OPTNEUROTH",
    "phenotype": "Other disorders of optic [2nd] nerve and visual pathways",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic nerve/visual pathway disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_OPTNEUROTH.gz"
  },
  {
    "accessionId": "DGWAS-1488",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_NYSTAGMUS",
    "phenotype": "Nystagmus and other irregular eye movements",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nystagmus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_NYSTAGMUS.gz"
  },
  {
    "accessionId": "DGWAS-1489",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_LACRINAS",
    "phenotype": "Other and unspecified disorders of lacrimal system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_LACRINAS.gz"
  },
  {
    "accessionId": "DGWAS-149",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_DEMENTIA_EXMORE",
    "phenotype": "Any dementia (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_DEMENTIA_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1490",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_LACRIMINFLAMCHRON",
    "phenotype": "Inflammation of lacrimal passages (chronic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic dacryocystitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_LACRIMINFLAMCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1491",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_IRISCILIARYNAS",
    "phenotype": "Other specified and unspecified disorders of iris and ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iris/ciliary body disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_IRISCILIARYNAS.gz"
  },
  {
    "accessionId": "DGWAS-1492",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_INTERNUCOPHTHALMOPLEGIA",
    "phenotype": "Internuclear ophthalmoplegia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Internuclear ophthalmoplegia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_INTERNUCOPHTHALMOPLEGIA.gz"
  },
  {
    "accessionId": "DGWAS-1493",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_INTERHETEROTRO",
    "phenotype": "Intermittent heterotropia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intermittent heterotropia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_INTERHETEROTRO.gz"
  },
  {
    "accessionId": "DGWAS-1494",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLOBE",
    "phenotype": "Disorders of globe",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Globe disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLOBE.gz"
  },
  {
    "accessionId": "DGWAS-1495",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCSECTRAUMA",
    "phenotype": "Glaucoma secondary to eye trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCSECTRAUMA.gz"
  },
  {
    "accessionId": "DGWAS-1496",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCSECDRUG",
    "phenotype": "Glaucoma secondary to drugs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCSECDRUG.gz"
  },
  {
    "accessionId": "DGWAS-1497",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCOMA_JOAG",
    "phenotype": "Juvenile Open Angle Glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Juvenile open-angle glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCOMA_JOAG.gz"
  },
  {
    "accessionId": "DGWAS-1498",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYEPOSTOP",
    "phenotype": "Postprocedural disorders of eye and adnexa, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural eye disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYEPOSTOP.gz"
  },
  {
    "accessionId": "DGWAS-1499",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYELIDINOTH",
    "phenotype": "Disorders of eyelid in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary eyelid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYELIDINOTH.gz"
  },
  {
    "accessionId": "DGWAS-15",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OTHER_SKIN_EXALLC",
    "phenotype": "Other malignant neoplasms of skin (=non-melanoma skin cancer) (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-melanoma skin cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OTHER_SKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-150",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_COPD",
    "phenotype": "COPD",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_COPD.gz"
  },
  {
    "accessionId": "DGWAS-1500",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYELIDFUNC",
    "phenotype": "Other disorders affecting eyelid function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid function disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYELIDFUNC.gz"
  },
  {
    "accessionId": "DGWAS-1501",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYELIDDEGEN",
    "phenotype": "Other degenerative disorders of eyelid and periocular area",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Degenerative eyelid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYELIDDEGEN.gz"
  },
  {
    "accessionId": "DGWAS-1502",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYEADNEXOTH",
    "phenotype": "Other specified and unspecified disorders of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/adnexa disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYEADNEXOTH.gz"
  },
  {
    "accessionId": "DGWAS-1503",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EXOPTHALMUS",
    "phenotype": "Exophthalmic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Exophthalmos",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EXOPTHALMUS.gz"
  },
  {
    "accessionId": "DGWAS-1504",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ECTROPION",
    "phenotype": "Ectropion of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectropion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ECTROPION.gz"
  },
  {
    "accessionId": "DGWAS-1505",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_DIPLOPIA",
    "phenotype": "Diplopia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diplopia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_DIPLOPIA.gz"
  },
  {
    "accessionId": "DGWAS-1506",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_DEGENMYOPIA",
    "phenotype": "Degenerative myopia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Degenerative myopia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_DEGENMYOPIA.gz"
  },
  {
    "accessionId": "DGWAS-1507",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_DACRYOADENITIS",
    "phenotype": "Dacryoadenitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dacryoadenitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_DACRYOADENITIS.gz"
  },
  {
    "accessionId": "DGWAS-1508",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CORNEAPIGMENT",
    "phenotype": "Corneal pigmentations and deposits",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal pigmentation/deposit",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CORNEAPIGMENT.gz"
  },
  {
    "accessionId": "DGWAS-1509",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CORNEALSCAR",
    "phenotype": "Corneal scars and opacities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal scar/opacity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CORNEALSCAR.gz"
  },
  {
    "accessionId": "DGWAS-151",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_CHRONSINUSITIS",
    "phenotype": "Chronic sinusitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic sinusitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_CHRONSINUSITIS.gz"
  },
  {
    "accessionId": "DGWAS-1510",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CORNEALMEMBRANE",
    "phenotype": "Changes in corneal membranes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal membrane change",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CORNEALMEMBRANE.gz"
  },
  {
    "accessionId": "DGWAS-1511",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONVERGINSUFF",
    "phenotype": "Convergence insufficiency and excess",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Convergence disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONVERGINSUFF.gz"
  },
  {
    "accessionId": "DGWAS-1512",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUVASC",
    "phenotype": "Other conjunctival vascular disorders and cysts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival vascular disorder/cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUVASC.gz"
  },
  {
    "accessionId": "DGWAS-1513",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUNCTIVITISCHRON",
    "phenotype": "Chronic conjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUNCTIVITISCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1514",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUNCTDEGDEPOT",
    "phenotype": "conjunctival degenerations and deposits",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival degeneration/deposit",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUNCTDEGDEPOT.gz"
  },
  {
    "accessionId": "DGWAS-1515",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUNAS",
    "phenotype": "Other specified and unspecified disorders of conjunctiva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUNAS.gz"
  },
  {
    "accessionId": "DGWAS-1516",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUHAEMOR",
    "phenotype": "conjunctival haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUHAEMOR.gz"
  },
  {
    "accessionId": "DGWAS-1517",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CHOROIDOTH",
    "phenotype": "Other disorders of choroid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Choroidal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CHOROIDOTH.gz"
  },
  {
    "accessionId": "DGWAS-1518",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CHORNAS",
    "phenotype": "Other specified and unspecified disorders of choroid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Choroidal disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CHORNAS.gz"
  },
  {
    "accessionId": "DGWAS-1519",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CHORHAEMORRHAGE",
    "phenotype": "Choroidal haemorrhage and rupture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Choroidal hemorrhage/rupture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CHORHAEMORRHAGE.gz"
  },
  {
    "accessionId": "DGWAS-152",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_MACULADEGEN",
    "phenotype": "Degeneration of macula and posterior pole",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_MACULADEGEN.gz"
  },
  {
    "accessionId": "DGWAS-1520",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CHORDETACH",
    "phenotype": "Choroidal detachment",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Choroidal detachment",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CHORDETACH.gz"
  },
  {
    "accessionId": "DGWAS-1521",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_BLINDMONOCULAR",
    "phenotype": "Blindness, monocular",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Monocular blindness",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_BLINDMONOCULAR.gz"
  },
  {
    "accessionId": "DGWAS-1522",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_BINODISTOTH",
    "phenotype": "Other disorders of binocular vision",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binocular vision disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_BINODISTOTH.gz"
  },
  {
    "accessionId": "DGWAS-1523",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_BINOCUMOVOTH",
    "phenotype": "Other disorders of binocular movement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binocular movement disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_BINOCUMOVOTH.gz"
  },
  {
    "accessionId": "DGWAS-1524",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_BINOCUMOVNAS",
    "phenotype": "Other and unspecified disorders of binocular movement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binocular movement disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_BINOCUMOVNAS.gz"
  },
  {
    "accessionId": "DGWAS-1525",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_BCKRNDRETINOPAT",
    "phenotype": "Background retinopathy and retinal vascular changes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_BCKRNDRETINOPAT.gz"
  },
  {
    "accessionId": "DGWAS-1526",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ASTIGMATISM",
    "phenotype": "Astigmatism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Astigmatism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ASTIGMATISM.gz"
  },
  {
    "accessionId": "DGWAS-1527",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ANISOMETROPIA",
    "phenotype": "Anisometropia and aniseikonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anisometropia/aniseikonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ANISOMETROPIA.gz"
  },
  {
    "accessionId": "DGWAS-1528",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ADHESIOIRIS",
    "phenotype": "Pupillary membranes and other adhesions and disruptions of iris and ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iris/ciliary adhesion/disruption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ADHESIOIRIS.gz"
  },
  {
    "accessionId": "DGWAS-1529",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GE_MODE",
    "phenotype": "Generalized epilepsy, mode (most common among epilepsy diagnosis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized epilepsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GE_MODE.gz"
  },
  {
    "accessionId": "DGWAS-153",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CORNEALOTH",
    "phenotype": "Other disorders of cornea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CORNEALOTH.gz"
  },
  {
    "accessionId": "DGWAS-1530",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GENERALI_SKIN_ERUPT_DRUGS_MEDICAM",
    "phenotype": "Generalized skin eruption due to drugs and medicaments",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced skin eruption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GENERALI_SKIN_ERUPT_DRUGS_MEDICAM.gz"
  },
  {
    "accessionId": "DGWAS-1531",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GASTRIC_ULCER_ACUTE_W_HAEMORRHAGE",
    "phenotype": "Gastric ulcer - Acute with haemorrhage, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced acute gastric ulcer with hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GASTRIC_ULCER_ACUTE_W_HAEMORRHAGE.gz"
  },
  {
    "accessionId": "DGWAS-1532",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_TETRAPLE",
    "phenotype": "Tetraplegia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tetraplegia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_TETRAPLE.gz"
  },
  {
    "accessionId": "DGWAS-1533",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_TARSTUN",
    "phenotype": "Tarsal tunnel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tarsal tunnel syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_TARSTUN.gz"
  },
  {
    "accessionId": "DGWAS-1534",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_SPINOTH",
    "phenotype": "Other diseases of spinal cord",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal cord disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_SPINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1535",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_SLEEPDISOTH",
    "phenotype": "Other sleep disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_SLEEPDISOTH.gz"
  },
  {
    "accessionId": "DGWAS-1536",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_SCIALE",
    "phenotype": "Lesion of sciatic nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sciatic nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_SCIALE.gz"
  },
  {
    "accessionId": "DGWAS-1537",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_POSTZOST",
    "phenotype": "Postzoster neuralgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postherpetic neuralgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_POSTZOST.gz"
  },
  {
    "accessionId": "DGWAS-1538",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_PHANTOM",
    "phenotype": "Phantom limb syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phantom limb syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_PHANTOM.gz"
  },
  {
    "accessionId": "DGWAS-1539",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_PERIPHOTH",
    "phenotype": "Other disorders of peripheral nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral nervous system disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_PERIPHOTH.gz"
  },
  {
    "accessionId": "DGWAS-154",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MUSCOTHUNS",
    "phenotype": "Other and unspecified primary disorders of muscles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary muscle disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MUSCOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1540",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_NEURAMYO",
    "phenotype": "Neuralgic amyotrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neuralgic amyotrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_NEURAMYO.gz"
  },
  {
    "accessionId": "DGWAS-1541",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_NEUINFL",
    "phenotype": "Inflammatory diseases of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS inflammatory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_NEUINFL.gz"
  },
  {
    "accessionId": "DGWAS-1542",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MYONEUOTHUNS",
    "phenotype": "Other and unspecified myoneural disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myoneural disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MYONEUOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1543",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MONOPLE",
    "phenotype": "Monoplegia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Monoplegia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MONOPLE.gz"
  },
  {
    "accessionId": "DGWAS-1544",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MONONPOTHUS",
    "phenotype": "Other and unspecified mononeuropathies of upper limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb mononeuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MONONPOTHUS.gz"
  },
  {
    "accessionId": "DGWAS-1545",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MONOLOWOTHUNS",
    "phenotype": "Other and unspecified mononeuropathies of lower limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb mononeuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MONOLOWOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1546",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MITOCMY",
    "phenotype": "Mitochondrial myopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mitochondrial myopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MITOCMY.gz"
  },
  {
    "accessionId": "DGWAS-1547",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MIGRAINE_WITH_AURA_TRIPTAN",
    "phenotype": "Migraine with aura and triptan purchases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine with aura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MIGRAINE_WITH_AURA_TRIPTAN.gz"
  },
  {
    "accessionId": "DGWAS-1548",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MIGRAINE_WITH_AURA_ADVERSE",
    "phenotype": "Migraine with aura, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced migraine with aura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MIGRAINE_WITH_AURA_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-1549",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MIGRAINE_NO_AURA_ADVERSE",
    "phenotype": "Migraine without aura, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced migraine without aura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MIGRAINE_NO_AURA_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-155",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_NAS",
    "phenotype": "Asthma, unspecified (mode)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1550",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MENINGOTH",
    "phenotype": "Other meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningitis (other)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MENINGOTH.gz"
  },
  {
    "accessionId": "DGWAS-1551",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MENINGBACT",
    "phenotype": "Bacterial meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial meningitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MENINGBACT.gz"
  },
  {
    "accessionId": "DGWAS-1552",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MEDLEOTH",
    "phenotype": "Other lesions of median nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Median nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MEDLEOTH.gz"
  },
  {
    "accessionId": "DGWAS-1553",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_IDIOAUT",
    "phenotype": "Idiopathic peripheral autonomic neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic autonomic neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_IDIOAUT.gz"
  },
  {
    "accessionId": "DGWAS-1554",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_HCPOSTRAU",
    "phenotype": "Post-traumatic hydrocephalus, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-traumatic hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_HCPOSTRAU.gz"
  },
  {
    "accessionId": "DGWAS-1555",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_HCOTHUNS",
    "phenotype": "Other and unspecified hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_HCOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1556",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_HCCOMM",
    "phenotype": "Communicating hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Communicating hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_HCCOMM.gz"
  },
  {
    "accessionId": "DGWAS-1557",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ENCEPHTOX",
    "phenotype": "Toxic encephalopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic encephalopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ENCEPHTOX.gz"
  },
  {
    "accessionId": "DGWAS-1558",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ENCEPHOTH",
    "phenotype": "Other encephalitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Encephalitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ENCEPHOTH.gz"
  },
  {
    "accessionId": "DGWAS-1559",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ENCEPATH",
    "phenotype": "Encephalopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Encephalopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ENCEPATH.gz"
  },
  {
    "accessionId": "DGWAS-156",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_APPENDACUT",
    "phenotype": "Acute appendicitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute appendicitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_APPENDACUT.gz"
  },
  {
    "accessionId": "DGWAS-1560",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_DRUGMYOP",
    "phenotype": "Drug-induced myopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced myopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_DRUGMYOP.gz"
  },
  {
    "accessionId": "DGWAS-1561",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_DISOTHUNS",
    "phenotype": "Disorders of other and unspecified cranial nerves",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cranial nerve disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_DISOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1562",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_DISBROTHUNS",
    "phenotype": "Disorders of brain, other and unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_DISBROTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1563",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_DEGENSEN",
    "phenotype": "Senile degeneration of the brain, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Senile brain degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_DEGENSEN.gz"
  },
  {
    "accessionId": "DGWAS-1564",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CRAINOTH",
    "phenotype": "Other cranial nerve disorders in other disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary cranial nerve disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CRAINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1565",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CPETAL",
    "phenotype": "Cerebral palsy and other paralytic syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral palsy/paralytic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CPETAL.gz"
  },
  {
    "accessionId": "DGWAS-1566",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CP",
    "phenotype": "Cerebral palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral palsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CP.gz"
  },
  {
    "accessionId": "DGWAS-1567",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CNSOTH",
    "phenotype": "Other disorders of central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CNSOTH.gz"
  },
  {
    "accessionId": "DGWAS-1568",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CLUSTHEADACHE_WIDE",
    "phenotype": "Cluster headache, wide",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cluster headache (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CLUSTHEADACHE_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-1569",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CLUSTHEADACHE_STRICT_INCLAVO",
    "phenotype": "Cluster headache, strict, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cluster headache (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CLUSTHEADACHE_STRICT_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-157",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_PERITONSABSC",
    "phenotype": "Peritonsillar abscess",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritonsillar abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_PERITONSABSC.gz"
  },
  {
    "accessionId": "DGWAS-1570",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CEROEDEMA",
    "phenotype": "Cerebral oedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral edema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CEROEDEMA.gz"
  },
  {
    "accessionId": "DGWAS-1571",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_CAUDA",
    "phenotype": "Cauda equina syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cauda equina syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_CAUDA.gz"
  },
  {
    "accessionId": "DGWAS-1572",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_BRACHPLE",
    "phenotype": "Brachial plexus disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brachial plexus disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_BRACHPLE.gz"
  },
  {
    "accessionId": "DGWAS-1573",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_BASDEGENOTH",
    "phenotype": "Other degenerative diseases of the basal ganglia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Basal ganglia degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_BASDEGENOTH.gz"
  },
  {
    "accessionId": "DGWAS-1574",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_AUTOTHUNS",
    "phenotype": "Other and unspecified disorders of autonomic nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autonomic nervous system disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_AUTOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-1575",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ATYFAC",
    "phenotype": "Atypical facial pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atypical facial pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ATYFAC.gz"
  },
  {
    "accessionId": "DGWAS-1576",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ANOXBRAINDAM",
    "phenotype": "Anoxic brain damage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anoxic brain damage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ANOXBRAINDAM.gz"
  },
  {
    "accessionId": "DGWAS-1577",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ALCOPOLY",
    "phenotype": "Alcohol induced polyneuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic polyneuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ALCOPOLY.gz"
  },
  {
    "accessionId": "DGWAS-1578",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_ADEM",
    "phenotype": "Acute disseminated encephalitis/encephalomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute disseminated encephalomyelitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_ADEM.gz"
  },
  {
    "accessionId": "DGWAS-1579",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FOOD_ALLERGY",
    "phenotype": "Food allergy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Food allergy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FOOD_ALLERGY.gz"
  },
  {
    "accessionId": "DGWAS-158",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_SCLERACORNEA",
    "phenotype": "Disorders of sclera, cornea, iris and ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anterior segment disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_SCLERACORNEA.gz"
  },
  {
    "accessionId": "DGWAS-1580",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FIBROLIV",
    "phenotype": "Fibrosis of liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver fibrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FIBROLIV.gz"
  },
  {
    "accessionId": "DGWAS-1581",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FE_STRICT",
    "phenotype": "Focal epilepsy, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Focal epilepsy (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FE_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-1582",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FE_MODE",
    "phenotype": "Focal epilepsy, mode (most common among epilepsy diagnosis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Focal epilepsy (mode)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FE_MODE.gz"
  },
  {
    "accessionId": "DGWAS-1583",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FEMHER_BILATERAL",
    "phenotype": "Femoral hernia, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral femoral hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FEMHER_BILATERAL.gz"
  },
  {
    "accessionId": "DGWAS-1584",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_FE",
    "phenotype": "Focal epilepsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Focal epilepsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_FE.gz"
  },
  {
    "accessionId": "DGWAS-1585",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_UNSORG",
    "phenotype": "Unspecified organic or symptomatic mental disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Organic mental disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_UNSORG.gz"
  },
  {
    "accessionId": "DGWAS-1586",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_STIMUL",
    "phenotype": "Mental and behavioural disorders due to use of other stimulants, including caffeine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stimulant use disorder (incl caffeine)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_STIMUL.gz"
  },
  {
    "accessionId": "DGWAS-1587",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SOMATOFORM",
    "phenotype": "Somatoform disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Somatoform disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SOMATOFORM.gz"
  },
  {
    "accessionId": "DGWAS-1588",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SLEEP_NOS",
    "phenotype": "Sleep disorders, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SLEEP_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1589",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SLEEPWAKE",
    "phenotype": "Disorder of the sleep-wake schedule",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circadian rhythm sleep disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SLEEPWAKE.gz"
  },
  {
    "accessionId": "DGWAS-159",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_IRIDOCYCLITIS",
    "phenotype": "Iridocyclitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iridocyclitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_IRIDOCYCLITIS.gz"
  },
  {
    "accessionId": "DGWAS-1590",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SLEEPTERRORS",
    "phenotype": "Sleep terrors [night terrors]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Night terrors",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SLEEPTERRORS.gz"
  },
  {
    "accessionId": "DGWAS-1591",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SEXUAL",
    "phenotype": "Physiological and behavioural disorders associated with sexual development and orientation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sexual development/orientation disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SEXUAL.gz"
  },
  {
    "accessionId": "DGWAS-1592",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SEXPREF",
    "phenotype": "Disorders of sexual preference",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paraphilia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SEXPREF.gz"
  },
  {
    "accessionId": "DGWAS-1593",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SEXDYS",
    "phenotype": "Sexual dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sexual dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SEXDYS.gz"
  },
  {
    "accessionId": "DGWAS-1594",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SEVRET",
    "phenotype": "Severe mental retardation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe intellectual disability",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SEVRET.gz"
  },
  {
    "accessionId": "DGWAS-1595",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SCHOLA",
    "phenotype": "Specific development disorders of scholastic skills",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Learning disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SCHOLA.gz"
  },
  {
    "accessionId": "DGWAS-1596",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_SCHIZOTYP",
    "phenotype": "Schizotypal disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizotypal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_SCHIZOTYP.gz"
  },
  {
    "accessionId": "DGWAS-1597",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_PSYCHOTH",
    "phenotype": "Other and unspecified nonorganic psychotic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonorganic psychosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_PSYCHOTH.gz"
  },
  {
    "accessionId": "DGWAS-1598",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_PHOBANX",
    "phenotype": "Phobic anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phobic anxiety disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_PHOBANX.gz"
  },
  {
    "accessionId": "DGWAS-1599",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_PERSOTH",
    "phenotype": "Other and unspecified disorders of adult personality and behaviour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality/behavior disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_PERSOTH.gz"
  },
  {
    "accessionId": "DGWAS-16",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_SKIN_EXALLC",
    "phenotype": "Malignant neoplasm of skin (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_SKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-160",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERLIPNAS",
    "phenotype": "Hyperlipidaemia, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperlipidemia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERLIPNAS.gz"
  },
  {
    "accessionId": "DGWAS-1600",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_PERSOCHANGE",
    "phenotype": "Enduring personality changes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enduring personality change",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_PERSOCHANGE.gz"
  },
  {
    "accessionId": "DGWAS-1601",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_PANIC",
    "phenotype": "Panic disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_PANIC.gz"
  },
  {
    "accessionId": "DGWAS-1602",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_OPIOIDS",
    "phenotype": "Mental and behavioural disorders due to opioids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Opioid use disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_OPIOIDS.gz"
  },
  {
    "accessionId": "DGWAS-1603",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_OCD",
    "phenotype": "Obsessive-compulsive disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "OCD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_OCD.gz"
  },
  {
    "accessionId": "DGWAS-1604",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_NIGHTMARES",
    "phenotype": "Nightmares",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nightmare disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_NIGHTMARES.gz"
  },
  {
    "accessionId": "DGWAS-1605",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_MOODOTH",
    "phenotype": "Other and unspecified mood [affective] disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mood disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_MOODOTH.gz"
  },
  {
    "accessionId": "DGWAS-1606",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_MIXEDDEV",
    "phenotype": "Mixed specific developmental disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed developmental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_MIXEDDEV.gz"
  },
  {
    "accessionId": "DGWAS-1607",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_MANIA",
    "phenotype": "Manic episode",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Manic episode",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_MANIA.gz"
  },
  {
    "accessionId": "DGWAS-1608",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_KELARET",
    "phenotype": "Kela-code for behavioural disturbances in mental retardation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral disturbance in ID",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_KELARET.gz"
  },
  {
    "accessionId": "DGWAS-1609",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_HYPERKIN",
    "phenotype": "Hyperkinetic disorders (excl. ADHD)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperkinetic disorder (non-ADHD)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_HYPERKIN.gz"
  },
  {
    "accessionId": "DGWAS-161",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_COLORECANI",
    "phenotype": "Benign neoplasm of colon, rectum, anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colorectal/anal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_COLORECANI.gz"
  },
  {
    "accessionId": "DGWAS-1610",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_HABIT",
    "phenotype": "Habit and impulse disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impulse control disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_HABIT.gz"
  },
  {
    "accessionId": "DGWAS-1611",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_GENDER",
    "phenotype": "Gender identity disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gender identity disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_GENDER.gz"
  },
  {
    "accessionId": "DGWAS-1612",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_EMOPER",
    "phenotype": "Emotionally unstable personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emotionally unstable personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_EMOPER.gz"
  },
  {
    "accessionId": "DGWAS-1613",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_EATOTH",
    "phenotype": "Other eating disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eating disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_EATOTH.gz"
  },
  {
    "accessionId": "DGWAS-1614",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_DEPRESSION_PSYCHOTIC",
    "phenotype": "Psychotic depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychotic depression",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_DEPRESSION_PSYCHOTIC.gz"
  },
  {
    "accessionId": "DGWAS-1615",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_DEPPER",
    "phenotype": "Dependent personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dependent personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_DEPPER.gz"
  },
  {
    "accessionId": "DGWAS-1616",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_ANAPER",
    "phenotype": "Anankastic personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anankastic personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_ANAPER.gz"
  },
  {
    "accessionId": "DGWAS-1617",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_AGORAPHOBIA",
    "phenotype": "Agoraphobia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agoraphobia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_AGORAPHOBIA.gz"
  },
  {
    "accessionId": "DGWAS-1618",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_F5_ADHD",
    "phenotype": "Disturbance of activity and attention",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Attention/activity disturbance",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_F5_ADHD.gz"
  },
  {
    "accessionId": "DGWAS-1619",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_EPISEIZALCO",
    "phenotype": "Epileptic seizures related to alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol-related seizure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_EPISEIZALCO.gz"
  },
  {
    "accessionId": "DGWAS-162",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_ACUTE_RESPIRATORY_INFECTIONS",
    "phenotype": "Asthma-related acute respiratory infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma-related acute respiratory infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_ACUTE_RESPIRATORY_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-1620",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_EPILEPTIC_SEIZU_RELATED_DRUGS",
    "phenotype": "Epileptic seizures related to drugs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-related seizure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_EPILEPTIC_SEIZU_RELATED_DRUGS.gz"
  },
  {
    "accessionId": "DGWAS-1621",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_VOLUME",
    "phenotype": "Volume depletion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Volume depletion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_VOLUME.gz"
  },
  {
    "accessionId": "DGWAS-1622",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_VIT_A_DEF",
    "phenotype": "Vitamin A deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitamin A deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_VIT_A_DEF.gz"
  },
  {
    "accessionId": "DGWAS-1623",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYTOXFAC",
    "phenotype": "Thyrotoxicosis factitia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Factitious thyrotoxicosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYTOXFAC.gz"
  },
  {
    "accessionId": "DGWAS-1624",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYROIDITDRUG",
    "phenotype": "Drug-induced thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYROIDITDRUG.gz"
  },
  {
    "accessionId": "DGWAS-1625",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYROIDITACU",
    "phenotype": "Acute thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYROIDITACU.gz"
  },
  {
    "accessionId": "DGWAS-1626",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYMUSDIS",
    "phenotype": "Diseases of thymus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thymus disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYMUSDIS.gz"
  },
  {
    "accessionId": "DGWAS-1627",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYCRISIS",
    "phenotype": "Thyroid crisis or storm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid storm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYCRISIS.gz"
  },
  {
    "accessionId": "DGWAS-1628",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THIA_DEF",
    "phenotype": "Thiamine deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thiamine deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THIA_DEF.gz"
  },
  {
    "accessionId": "DGWAS-1629",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_TESTICHYPO",
    "phenotype": "Testicular hypofunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular hypofunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_TESTICHYPO.gz"
  },
  {
    "accessionId": "DGWAS-163",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_POLYCYTVERA",
    "phenotype": "Polycythaemia vera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycythemia vera",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_POLYCYTVERA.gz"
  },
  {
    "accessionId": "DGWAS-1630",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_TESTICDYSNAS",
    "phenotype": "Testicular dysfunction, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_TESTICDYSNAS.gz"
  },
  {
    "accessionId": "DGWAS-1631",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_SEQUMAL",
    "phenotype": "Sequelae of malnutrition and other nutritional deficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sequelae of malnutrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_SEQUMAL.gz"
  },
  {
    "accessionId": "DGWAS-1632",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PUBDISNAS",
    "phenotype": "Disorders of puberty, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pubertal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PUBDISNAS.gz"
  },
  {
    "accessionId": "DGWAS-1633",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PROTMALMODMILD",
    "phenotype": "Protein-energy malnutrition of moderate and mild degree",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Protein-energy malnutrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PROTMALMODMILD.gz"
  },
  {
    "accessionId": "DGWAS-1634",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PREPUB",
    "phenotype": "Precocious puberty",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Precocious puberty",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PREPUB.gz"
  },
  {
    "accessionId": "DGWAS-1635",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PHOS_MET",
    "phenotype": "Disorders of phosphorus metabolism and phosphatases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phosphorus metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PHOS_MET.gz"
  },
  {
    "accessionId": "DGWAS-1636",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PARANAS",
    "phenotype": "Disorders of parathyroid gland, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parathyroid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PARANAS.gz"
  },
  {
    "accessionId": "DGWAS-1637",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PANCSECNAS",
    "phenotype": "Disorder of pancreatic internal secretion, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic endocrine disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PANCSECNAS.gz"
  },
  {
    "accessionId": "DGWAS-1638",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_OBESITYDRUG",
    "phenotype": "Drug-induced obesity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced obesity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_OBESITYDRUG.gz"
  },
  {
    "accessionId": "DGWAS-1639",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_NUTRI_DEF_NAS",
    "phenotype": "Other specified/unspecified nutritional deficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nutritional deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_NUTRI_DEF_NAS.gz"
  },
  {
    "accessionId": "DGWAS-164",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMETRIOSIS_PELVICPERITONEUM",
    "phenotype": "Endometriosis of pelvic peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMETRIOSIS_PELVICPERITONEUM.gz"
  },
  {
    "accessionId": "DGWAS-1640",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_MG_MET",
    "phenotype": "Disorders of magnesium metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Magnesium metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_MG_MET.gz"
  },
  {
    "accessionId": "DGWAS-1641",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_MG_DEF",
    "phenotype": "Magnesium deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Magnesium deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_MG_DEF.gz"
  },
  {
    "accessionId": "DGWAS-1642",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_MALNUTRITION",
    "phenotype": "Malnutrition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malnutrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_MALNUTRITION.gz"
  },
  {
    "accessionId": "DGWAS-1643",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_LOCALADIP",
    "phenotype": "Localized adiposity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Localized adiposity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_LOCALADIP.gz"
  },
  {
    "accessionId": "DGWAS-1644",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_LIPODEF",
    "phenotype": "Lipoprotein deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipoprotein deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_LIPODEF.gz"
  },
  {
    "accessionId": "DGWAS-1645",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYTHY_AI_DX",
    "phenotype": "Hypothyroidism, autoimmune, DX-based",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune hypothyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYTHY_AI_DX.gz"
  },
  {
    "accessionId": "DGWAS-1646",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYTHYPOSTINF",
    "phenotype": "Postinfectious hypothyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postinfectious hypothyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYTHYPOSTINF.gz"
  },
  {
    "accessionId": "DGWAS-1647",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPOKALAEMIA",
    "phenotype": "Hypokalaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypokalemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPOKALAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-1648",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERURI",
    "phenotype": "Hyperuricaemia without signs of inflammatory arthritis and tophaceous disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperuricemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERURI.gz"
  },
  {
    "accessionId": "DGWAS-1649",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERPRO_ADVERSE",
    "phenotype": "Hyperprolactinaemia, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced hyperprolactinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERPRO_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-165",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SYSTCONNECT",
    "phenotype": "Systemic connective tissue disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic connective tissue disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SYSTCONNECT.gz"
  },
  {
    "accessionId": "DGWAS-1650",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERPRO",
    "phenotype": "Hyperprolactinaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperprolactinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERPRO.gz"
  },
  {
    "accessionId": "DGWAS-1651",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERPIT",
    "phenotype": "Hyperfunction of pituitary gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperpituitarism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERPIT.gz"
  },
  {
    "accessionId": "DGWAS-1652",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERCHYLO",
    "phenotype": "Hyperchylomicronaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperchylomicronemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERCHYLO.gz"
  },
  {
    "accessionId": "DGWAS-1653",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERALISEQ",
    "phenotype": "Sequelae of hyperalimentation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sequelae of overnutrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERALISEQ.gz"
  },
  {
    "accessionId": "DGWAS-1654",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_HYPERALI",
    "phenotype": "Other hyperalimentation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overnutrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_HYPERALI.gz"
  },
  {
    "accessionId": "DGWAS-1655",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_FLUIDOVER",
    "phenotype": "Fluid overload",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fluid overload",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_FLUIDOVER.gz"
  },
  {
    "accessionId": "DGWAS-1656",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_FLUIDELECTRONAS",
    "phenotype": "Other disorders of electrolyte and fluid balance, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Electrolyte/fluid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_FLUIDELECTRONAS.gz"
  },
  {
    "accessionId": "DGWAS-1657",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ENDODIS",
    "phenotype": "Other endocrine disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocrine disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ENDODIS.gz"
  },
  {
    "accessionId": "DGWAS-1658",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ENDINOTH",
    "phenotype": "Disorders of endocrine glands in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary endocrine disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ENDINOTH.gz"
  },
  {
    "accessionId": "DGWAS-1659",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_DISPUB",
    "phenotype": "Disorders of puberty",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pubertal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_DISPUB.gz"
  },
  {
    "accessionId": "DGWAS-166",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_KRA_PSY_ANXIETY_EXMORE",
    "phenotype": "Anxiety disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_KRA_PSY_ANXIETY_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1660",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_CARBONAS",
    "phenotype": "Disorder of carbohydrate metabolism, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carbohydrate metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_CARBONAS.gz"
  },
  {
    "accessionId": "DGWAS-1661",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_AROMAMINO",
    "phenotype": "Disorders of aromatic amino-acid metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aromatic amino acid metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_AROMAMINO.gz"
  },
  {
    "accessionId": "DGWAS-1662",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_AMYL_SCNDSYST",
    "phenotype": "Secondary systemic amyloidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary systemic amyloidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_AMYL_SCNDSYST.gz"
  },
  {
    "accessionId": "DGWAS-1663",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_AMYL_ORGAN",
    "phenotype": "Organ-limited amyloidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Organ-limited amyloidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_AMYL_ORGAN.gz"
  },
  {
    "accessionId": "DGWAS-1664",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ALKALOSIS",
    "phenotype": "Alkalosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alkalosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ALKALOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1665",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ADREMEDHYPER",
    "phenotype": "Adrenomedullary hyperfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenomedullary hyperfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ADREMEDHYPER.gz"
  },
  {
    "accessionId": "DGWAS-1666",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ADREACT",
    "phenotype": "Other adrenocortical overactivity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenocortical overactivity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ADREACT.gz"
  },
  {
    "accessionId": "DGWAS-1667",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ACROMEG",
    "phenotype": "Acromegaly and pituitary gigantism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acromegaly/gigantism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ACROMEG.gz"
  },
  {
    "accessionId": "DGWAS-1668",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_ACIDOSIS",
    "phenotype": "Acidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_ACIDOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1669",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DUODENAL_ULCER_UNSPE_ACUTE_CHRONIC_WO_HAEMORRHAGE_PERFORATION",
    "phenotype": "Duodenal ulcer - Unspecified as acute or chronic, without haemorrhage or perforation, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced duodenal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DUODENAL_ULCER_UNSPE_ACUTE_CHRONIC_WO_HAEMORRHAGE_PERFORATION.gz"
  },
  {
    "accessionId": "DGWAS-167",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PULMEMB",
    "phenotype": "Pulmonary embolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary embolism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PULMEMB.gz"
  },
  {
    "accessionId": "DGWAS-1670",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_TREMOR",
    "phenotype": "Drug-induced tremor",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced tremor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_TREMOR.gz"
  },
  {
    "accessionId": "DGWAS-1671",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_OSTEOPO",
    "phenotype": "Drug-induced osteoporosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced osteoporosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_OSTEOPO.gz"
  },
  {
    "accessionId": "DGWAS-1672",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_GOUT",
    "phenotype": "Drug-induced gout",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced gout",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_GOUT.gz"
  },
  {
    "accessionId": "DGWAS-1673",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_DYSTON",
    "phenotype": "Drug-induced dystonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced dystonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_DYSTON.gz"
  },
  {
    "accessionId": "DGWAS-1674",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DRUGADVERS_ADRENOCORTICAL_INSUFFICIENCY",
    "phenotype": "Drug-induced adrenocortical insufficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced adrenal insufficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DRUGADVERS_ADRENOCORTICAL_INSUFFICIENCY.gz"
  },
  {
    "accessionId": "DGWAS-1675",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_DENTAL_TMD",
    "phenotype": "TMD related pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TMD pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_DENTAL_TMD.gz"
  },
  {
    "accessionId": "DGWAS-1676",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_WHITEBLOODCELLNAS",
    "phenotype": "Other and unspecified disorders of white blood cells",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "White blood cell disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_WHITEBLOODCELLNAS.gz"
  },
  {
    "accessionId": "DGWAS-1677",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_THROMBOCYTOPENIANAS",
    "phenotype": "Thrombocytopenia, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thrombocytopenia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_THROMBOCYTOPENIANAS.gz"
  },
  {
    "accessionId": "DGWAS-1678",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SPLEENNAS",
    "phenotype": "Other and unspecified diseases of spleen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spleen disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SPLEENNAS.gz"
  },
  {
    "accessionId": "DGWAS-1679",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SIDEROANASCND",
    "phenotype": "Secondary sideroblastic anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary sideroblastic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SIDEROANASCND.gz"
  },
  {
    "accessionId": "DGWAS-168",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PHLETHROM",
    "phenotype": "Phlebitis and thrombophlebitis (not including DVT)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phlebitis/thrombophlebitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PHLETHROM.gz"
  },
  {
    "accessionId": "DGWAS-1680",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SIDEROANAMIEAOTHER",
    "phenotype": "Other sideroblastic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sideroblastic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SIDEROANAMIEAOTHER.gz"
  },
  {
    "accessionId": "DGWAS-1681",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SICKLECELLDIS",
    "phenotype": "Sickle-cell disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sickle cell disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SICKLECELLDIS.gz"
  },
  {
    "accessionId": "DGWAS-1682",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SCIDA",
    "phenotype": "Severe combined immunodeficiency [SCID] with reticular dysgenesis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SCID with reticular dysgenesis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SCIDA.gz"
  },
  {
    "accessionId": "DGWAS-1683",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_QUALIPATELETDEF",
    "phenotype": "Qualitative platelet defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Platelet function defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_QUALIPATELETDEF.gz"
  },
  {
    "accessionId": "DGWAS-1684",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_PURPURA_AND3_OTHER_HAEMORRHAGIC",
    "phenotype": "Purpura and other haemorrhagic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Purpura/hemorrhagic condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_PURPURA_AND3_OTHER_HAEMORRHAGIC.gz"
  },
  {
    "accessionId": "DGWAS-1685",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_OTHNONTHROMBOCYTOPENPURPURA",
    "phenotype": "Other nonthrombocytopenic purpura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonthrombocytopenic purpura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_OTHNONTHROMBOCYTOPENPURPURA.gz"
  },
  {
    "accessionId": "DGWAS-1686",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_OTHERWHITECELL",
    "phenotype": "Other disorders of white blood cells",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "White blood cell disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_OTHERWHITECELL.gz"
  },
  {
    "accessionId": "DGWAS-1687",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_OTHERAPLASTICANAEMIA",
    "phenotype": "Other and unspecified aplastic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aplastic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_OTHERAPLASTICANAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-1688",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_OTHDISLYMPHORETANDRETICULOHIST",
    "phenotype": "Other specified diseases with participation of lymphoreticular and reticulohistiocytic tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoreticular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_OTHDISLYMPHORETANDRETICULOHIST.gz"
  },
  {
    "accessionId": "DGWAS-1689",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_NUTRIANAEMIAOTHER",
    "phenotype": "Other nutritional anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nutritional anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_NUTRIANAEMIAOTHER.gz"
  },
  {
    "accessionId": "DGWAS-169",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HEARTFAIL_AND_CHD",
    "phenotype": "Heart failure and coronary heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure/CHD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HEARTFAIL_AND_CHD.gz"
  },
  {
    "accessionId": "DGWAS-1690",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_NONAIHA_OTHER",
    "phenotype": "Haemolytic-uraemic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemolytic uremic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_NONAIHA_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-1691",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_NEFELOF",
    "phenotype": "Nezelof syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nezelof syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_NEFELOF.gz"
  },
  {
    "accessionId": "DGWAS-1692",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_KELA_IMMUDEF",
    "phenotype": "Kela reimbursement Agammaglobulinemia (D80-84)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agammaglobulinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_KELA_IMMUDEF.gz"
  },
  {
    "accessionId": "DGWAS-1693",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_IMMUDEFWITHMAJORDEF",
    "phenotype": "Immunodeficiency associated with other major defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immunodeficiency with major defects",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_IMMUDEFWITHMAJORDEF.gz"
  },
  {
    "accessionId": "DGWAS-1694",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_IMMUDEFNAS",
    "phenotype": "Other or unspecified immunodeficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immunodeficiency NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_IMMUDEFNAS.gz"
  },
  {
    "accessionId": "DGWAS-1695",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_IMMUDEFANTIBODYNAS",
    "phenotype": "Other and unspecified immunodeficiencies with predominantly antibody defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Antibody deficiency NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_IMMUDEFANTIBODYNAS.gz"
  },
  {
    "accessionId": "DGWAS-1696",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_IMMUDEF",
    "phenotype": "Immunodeficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immunodeficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_IMMUDEF.gz"
  },
  {
    "accessionId": "DGWAS-1697",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HYPERSPLENISM",
    "phenotype": "Hypersplenism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypersplenism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HYPERSPLENISM.gz"
  },
  {
    "accessionId": "DGWAS-1698",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HEREDFVIIIDEF",
    "phenotype": "Hereditary factor VIII deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemophilia A",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HEREDFVIIIDEF.gz"
  },
  {
    "accessionId": "DGWAS-1699",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HAEMORRHAGICNAS",
    "phenotype": "Other and unspecified haemorrhagic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemorrhagic condition NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HAEMORRHAGICNAS.gz"
  },
  {
    "accessionId": "DGWAS-17",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ARTHROSIS_KNEE",
    "phenotype": "Gonarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee osteoarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ARTHROSIS_KNEE.gz"
  },
  {
    "accessionId": "DGWAS-170",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_RETINALDISOTH",
    "phenotype": "Other retinal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_RETINALDISOTH.gz"
  },
  {
    "accessionId": "DGWAS-1700",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_HAEMORRHAGCIRGUANTICO",
    "phenotype": "Haemorrhagic disorder due to circulating anticoagulants",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemorrhagic disorder due to anticoagulants",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_HAEMORRHAGCIRGUANTICO.gz"
  },
  {
    "accessionId": "DGWAS-1701",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_DISSEINTRAVASCCOAG",
    "phenotype": "Disseminated intravascular coagulation [defibrination syndrome]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DIC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_DISSEINTRAVASCCOAG.gz"
  },
  {
    "accessionId": "DGWAS-1702",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_CYSTSPLEEN",
    "phenotype": "Cyst of spleen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Splenic cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_CYSTSPLEEN.gz"
  },
  {
    "accessionId": "DGWAS-1703",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_CVID_BCELL",
    "phenotype": "Common variable immunodeficiency with predominant abnormalities of B-cell numbers and function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CVID with B-cell defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_CVID_BCELL.gz"
  },
  {
    "accessionId": "DGWAS-1704",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_CVIDNAS",
    "phenotype": "Other or unspecified common variable immunodeficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CVID NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_CVIDNAS.gz"
  },
  {
    "accessionId": "DGWAS-1705",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_CVID",
    "phenotype": "Common variable immunodeficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CVID",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_CVID.gz"
  },
  {
    "accessionId": "DGWAS-1706",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_COMPLEMENTDEF",
    "phenotype": "Defects in the complement system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Complement deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_COMPLEMENTDEF.gz"
  },
  {
    "accessionId": "DGWAS-1707",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_BLOODNAS",
    "phenotype": "Other and unspecified diseases of blood and blood-forming organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_BLOODNAS.gz"
  },
  {
    "accessionId": "DGWAS-1708",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ANAEMIA_FOLATEDEF",
    "phenotype": "Folate deficiency anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Folate deficiency anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ANAEMIA_FOLATEDEF.gz"
  },
  {
    "accessionId": "DGWAS-1709",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ANAEMIAINCHRONICDISEASE",
    "phenotype": "Anaemia in chronic diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia of chronic disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ANAEMIAINCHRONICDISEASE.gz"
  },
  {
    "accessionId": "DGWAS-171",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_KERATITIS",
    "phenotype": "Keratitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Keratitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_KERATITIS.gz"
  },
  {
    "accessionId": "DGWAS-1710",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ACUTEPOSTBLEEDANAEMIA",
    "phenotype": "Acute posthaemorrhagic anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute posthemorrhagic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ACUTEPOSTBLEEDANAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-1711",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_COLONPSEUDOP",
    "phenotype": "Pseudopolyposis of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colonic pseudopolyposis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_COLONPSEUDOP.gz"
  },
  {
    "accessionId": "DGWAS-1712",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CMV_NOS",
    "phenotype": "Other/unspecified cytomegaloviral diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CMV disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CMV_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1713",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CML",
    "phenotype": "Chronic myeloid leukaemia [CML], BCR/ABL-positive",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CML",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CML.gz"
  },
  {
    "accessionId": "DGWAS-1714",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CHIRBIL_NAS",
    "phenotype": "Biliary cirrhosis, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biliary cirrhosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CHIRBIL_NAS.gz"
  },
  {
    "accessionId": "DGWAS-1715",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_TNK_LYMPHOMA_EXALLC",
    "phenotype": "Mature T/NK-cell lymphomas (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mature T/NK-cell lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_TNK_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1716",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_PRIMARY_LYMPHOID_HEMATOPOIETIC_NAS_EXALLC",
    "phenotype": "Other and unspecified malignant neoplasms of lymphoid, haematopoietic and related tissue (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid/hematopoietic malignancy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_PRIMARY_LYMPHOID_HEMATOPOIETIC_NAS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1717",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_OTHER_LEUKAEMIA_SPECIFIED_EXALLC",
    "phenotype": "Other leukaemias of specified cell type (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Specified leukemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_OTHER_LEUKAEMIA_SPECIFIED_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1718",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_MYELOID_LEUKAEMIA_EXALLC",
    "phenotype": "Myeloid leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloid leukemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_MYELOID_LEUKAEMIA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1719",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_MULTIPLE_MYELOMA_PLASMA_CELL_EXALLC",
    "phenotype": "Multiple myeloma and malignant plasma cell neoplasms (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_MULTIPLE_MYELOMA_PLASMA_CELL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-172",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CATARACTOTHER",
    "phenotype": "Other cataract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cataract NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CATARACTOTHER.gz"
  },
  {
    "accessionId": "DGWAS-1720",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_MONOCYTIC_LEUKAEMIA_EXALLC",
    "phenotype": "Monocytic leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Monocytic leukemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_MONOCYTIC_LEUKAEMIA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1721",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_LEUKAEMIA_NAS_EXALLC",
    "phenotype": "Leukaemia of unspecified cell type (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leukemia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_LEUKAEMIA_NAS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1722",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_VULVA_EXALLC",
    "phenotype": "Carcinoma in situ of vulva (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_VULVA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1723",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_VAGINA_EXALLC",
    "phenotype": "Carcinoma in situ of vagina (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_VAGINA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1724",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_RECTUM_EXALLC",
    "phenotype": "Carcinoma in situ of rectum (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_RECTUM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1725",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_ORALCAVITY_EXALLC",
    "phenotype": "Carcinoma in situ of lip, oral cavity and pharynx (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral/pharyngeal CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_ORALCAVITY_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1726",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_ENDOMETRIUM_EXALLC",
    "phenotype": "Carcinoma in situ of endometrium (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometrial CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_ENDOMETRIUM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1727",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_COLON_EXALLC",
    "phenotype": "Carcinoma in situ of colon (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_COLON_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1728",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_INSITU_BREAST_EXALLC",
    "phenotype": "Carcinoma in situ of breast (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_INSITU_BREAST_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1729",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_EYE_NOS_EXALLC",
    "phenotype": "Benign neoplasm: Eye, unspecified (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign eye neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_EYE_NOS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-173",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_ALLERGICCONJUNCTIVITIS",
    "phenotype": "Allergic conjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_ALLERGICCONJUNCTIVITIS.gz"
  },
  {
    "accessionId": "DGWAS-1730",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_VULVA",
    "phenotype": "Benign neoplasm: Vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign vaginal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_VULVA.gz"
  },
  {
    "accessionId": "DGWAS-1731",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_UTERUS_OTH",
    "phenotype": "Other benign neoplasms of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign uterine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_UTERUS_OTH.gz"
  },
  {
    "accessionId": "DGWAS-1732",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_UTERUS_NOS",
    "phenotype": "Other benign neoplasm of uterus: Other parts/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign uterine neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_UTERUS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1733",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_UTERINE_TUBES_LIGAMENTS",
    "phenotype": "Benign neoplasm: Uterine tubes and ligaments",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign adnexal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_UTERINE_TUBES_LIGAMENTS.gz"
  },
  {
    "accessionId": "DGWAS-1734",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_URINARY_NOS",
    "phenotype": "Benign neoplasm: Urinary organ, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign urinary neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_URINARY_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1735",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_URINARY",
    "phenotype": "Benign neoplasm of urinary organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign urinary neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_URINARY.gz"
  },
  {
    "accessionId": "DGWAS-1736",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_TRANSVERSE_COLON",
    "phenotype": "Benign neoplasm: Transverse colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign transverse colon neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_TRANSVERSE_COLON.gz"
  },
  {
    "accessionId": "DGWAS-1737",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_THYMUS",
    "phenotype": "Benign neoplasm: Thymus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign thymic neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_THYMUS.gz"
  },
  {
    "accessionId": "DGWAS-1738",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_SMALL_INTESTINE_OTH",
    "phenotype": "Benign neoplasm: Other and unspecified parts of small intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign small intestine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_SMALL_INTESTINE_OTH.gz"
  },
  {
    "accessionId": "DGWAS-1739",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_SALIVARY_NOS",
    "phenotype": "Benign neoplasm: other/unspecified salivary gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign salivary neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_SALIVARY_NOS.gz"
  },
  {
    "accessionId": "DGWAS-174",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_OBESITYNAS",
    "phenotype": "Obesity, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_OBESITYNAS.gz"
  },
  {
    "accessionId": "DGWAS-1740",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_RIBS_STERNUM_CLAVICLE",
    "phenotype": "Benign neoplasm: Ribs, sternum and clavicle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign rib/sternum/clavicle neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_RIBS_STERNUM_CLAVICLE.gz"
  },
  {
    "accessionId": "DGWAS-1741",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_RETINA",
    "phenotype": "Benign neoplasm: Retina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign retinal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_RETINA.gz"
  },
  {
    "accessionId": "DGWAS-1742",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_RESPIRATORY_NOS",
    "phenotype": "Benign neoplasm: Respiratory system, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign respiratory neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_RESPIRATORY_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1743",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PROSTATE",
    "phenotype": "Benign neoplasm: Prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign prostatic neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PROSTATE.gz"
  },
  {
    "accessionId": "DGWAS-1744",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PINEAL",
    "phenotype": "Benign neoplasm: Pineal gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pineal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PINEAL.gz"
  },
  {
    "accessionId": "DGWAS-1745",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PENIS",
    "phenotype": "Benign neoplasm: Penis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign penile neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PENIS.gz"
  },
  {
    "accessionId": "DGWAS-1746",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PELVIC_BONES_SACRUM_COCCYX",
    "phenotype": "Benign neoplasm: Pelvic bones, sacrum and coccyx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pelvic bone neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PELVIC_BONES_SACRUM_COCCYX.gz"
  },
  {
    "accessionId": "DGWAS-1747",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_PANCREAS",
    "phenotype": "Benign neoplasm: Pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pancreatic neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_PANCREAS.gz"
  },
  {
    "accessionId": "DGWAS-1748",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_OTHERDIGESTIVE",
    "phenotype": "Benign neoplasm of other and ill-defined parts of digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign digestive neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_OTHERDIGESTIVE.gz"
  },
  {
    "accessionId": "DGWAS-1749",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_OROPHA_OTHER",
    "phenotype": "Benign neoplasm: Other parts of oropharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oropharyngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_OROPHA_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-175",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_SARCOIDOSIS",
    "phenotype": "Sarcoidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_SARCOIDOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1750",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_ORBIT_NOS",
    "phenotype": "Benign neoplasm: Orbit, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign orbital neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_ORBIT_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1751",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_OESOPHAGUS",
    "phenotype": "Benign neoplasm: Oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign esophageal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_OESOPHAGUS.gz"
  },
  {
    "accessionId": "DGWAS-1752",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MOUTH_PHARYNX",
    "phenotype": "Benign neoplasm of mouth and pharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oral/pharyngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MOUTH_PHARYNX.gz"
  },
  {
    "accessionId": "DGWAS-1753",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MENINGES_NOS",
    "phenotype": "Beningn neoplasm: Meninges, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign meningeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MENINGES_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1754",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MELANOCYTIC_UPPERLIMB",
    "phenotype": "Melanocytic naevi of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (upper limb)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MELANOCYTIC_UPPERLIMB.gz"
  },
  {
    "accessionId": "DGWAS-1755",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MELANOCYTIC_SCALPNECK",
    "phenotype": "Melanocytic naevi of scalp and neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (scalp/neck)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MELANOCYTIC_SCALPNECK.gz"
  },
  {
    "accessionId": "DGWAS-1756",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MELANOCYTIC_LIP",
    "phenotype": "Melanocytic naevi of lip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (lip)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MELANOCYTIC_LIP.gz"
  },
  {
    "accessionId": "DGWAS-1757",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MELANOCYTIC_FACE",
    "phenotype": "Melanocytic naevi of other and unspecified parts of face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (face)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MELANOCYTIC_FACE.gz"
  },
  {
    "accessionId": "DGWAS-1758",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MELANOCYTIC_EYELID",
    "phenotype": "Melanocytic naevi of eyelid, including canthus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (eyelid)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MELANOCYTIC_EYELID.gz"
  },
  {
    "accessionId": "DGWAS-1759",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MEDIASTINUM",
    "phenotype": "Benign neoplasm: Mediastinum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign mediastinal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MEDIASTINUM.gz"
  },
  {
    "accessionId": "DGWAS-176",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_DIGES_SYSTEM1",
    "phenotype": "Other congenital malformations of the digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital digestive malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_DIGES_SYSTEM1.gz"
  },
  {
    "accessionId": "DGWAS-1760",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_MALE_GEN",
    "phenotype": "Benign neoplasm of male genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign male genital neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_MALE_GEN.gz"
  },
  {
    "accessionId": "DGWAS-1761",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LYMPHNODES",
    "phenotype": "Benign neoplasm: Lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lymph node neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LYMPHNODES.gz"
  },
  {
    "accessionId": "DGWAS-1762",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LYMPHANGIOMA",
    "phenotype": "Lymphangioma, anys site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphangioma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LYMPHANGIOMA.gz"
  },
  {
    "accessionId": "DGWAS-1763",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIVER",
    "phenotype": "Benign neoplasm: Liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign liver neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIVER.gz"
  },
  {
    "accessionId": "DGWAS-1764",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIPO_SKIN_NOS",
    "phenotype": "Benign lipomatous neoplasm of skin and subcutaneous tissue of other and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma (skin, NOS)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIPO_SKIN_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1765",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIPO_SKIN_HEADFACENECK",
    "phenotype": "Benign lipomatous neoplasm of skin and subcutaneous tissue of head, face and neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma (head/face/neck)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIPO_SKIN_HEADFACENECK.gz"
  },
  {
    "accessionId": "DGWAS-1766",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIPO_INTRATHO",
    "phenotype": "Benign lipomatous neoplasm of  of intra-abdominal organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign intra-abdominal lipoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIPO_INTRATHO.gz"
  },
  {
    "accessionId": "DGWAS-1767",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_LIP",
    "phenotype": "Benign neoplasm: Lip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lip neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_LIP.gz"
  },
  {
    "accessionId": "DGWAS-1768",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_INTRATHORACIC_NOS",
    "phenotype": "Benign neoplasm: Other specified/unspecified intrathoracic organs (+ respiratory system NOS of Icd-9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign intrathoracic neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_INTRATHORACIC_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1769",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_INTRATHORACIC",
    "phenotype": "Benign neoplasm of other and unspecified intrathoracic organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign intrathoracic neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_INTRATHORACIC.gz"
  },
  {
    "accessionId": "DGWAS-177",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_ATHSCLE",
    "phenotype": "Atherosclerosis, excluding cerebral, coronary and PAD",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atherosclerosis (other)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_ATHSCLE.gz"
  },
  {
    "accessionId": "DGWAS-1770",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_HYPOPHARYNX",
    "phenotype": "Benign neoplasm: Hypopharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign hypopharyngeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_HYPOPHARYNX.gz"
  },
  {
    "accessionId": "DGWAS-1771",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_HEMANGIOMA",
    "phenotype": "Haemangioma, any site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemangioma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_HEMANGIOMA.gz"
  },
  {
    "accessionId": "DGWAS-1772",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_HEAMANGIOMA_LYMPHANGIOMA",
    "phenotype": "Haemangioma and lymphangioma, any site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemangioma/lymphangioma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_HEAMANGIOMA_LYMPHANGIOMA.gz"
  },
  {
    "accessionId": "DGWAS-1773",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_FLOOROFMOUTH",
    "phenotype": "Benign neoplasm: Floor of mouth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oral floor neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_FLOOROFMOUTH.gz"
  },
  {
    "accessionId": "DGWAS-1774",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_FEMALE_GEN_NOS",
    "phenotype": "Benign neoplasm: Female genital organ, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign female genital neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_FEMALE_GEN_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1775",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_EPIDIDYMIS",
    "phenotype": "Benign neoplasm: Epididymis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign epididymal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_EPIDIDYMIS.gz"
  },
  {
    "accessionId": "DGWAS-1776",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_ENDOCRINE_PANCREAS",
    "phenotype": "Benign neoplasm: Endocrine pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pancreatic endocrine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_ENDOCRINE_PANCREAS.gz"
  },
  {
    "accessionId": "DGWAS-1777",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_ENDOCRINE_NOS",
    "phenotype": "Benign neoplasm: Endocrine gland, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign endocrine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_ENDOCRINE_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1778",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_EAR_RESP",
    "phenotype": "Benign neoplasm of middle ear and respiratory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign middle ear/respiratory neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_EAR_RESP.gz"
  },
  {
    "accessionId": "DGWAS-1779",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_EAR_NASAL_SINUS",
    "phenotype": "Benign neoplasm: Middle ear, nasal cavity and accessory sinuses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign middle ear/nasal/sinus neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_EAR_NASAL_SINUS.gz"
  },
  {
    "accessionId": "DGWAS-178",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCOMA_XFG",
    "phenotype": "Glaucoma, exfoliation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Exfoliation glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCOMA_XFG.gz"
  },
  {
    "accessionId": "DGWAS-1780",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_DUODENUM",
    "phenotype": "Benign neoplasm: Duodenum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign duodenal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_DUODENUM.gz"
  },
  {
    "accessionId": "DGWAS-1781",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CONNSOFT_UPPERLIMB",
    "phenotype": "Benign neoplasm: Connective and other soft tissue of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm (upper limb)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CONNSOFT_UPPERLIMB.gz"
  },
  {
    "accessionId": "DGWAS-1782",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CONNSOFT_TRUNK",
    "phenotype": "Benign neoplasm: Connective and other soft tissue of trunk, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm (trunk)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CONNSOFT_TRUNK.gz"
  },
  {
    "accessionId": "DGWAS-1783",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CONNSOFT_THX",
    "phenotype": "Benign neoplasm: Connective and other soft tissue of thorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm (thorax)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CONNSOFT_THX.gz"
  },
  {
    "accessionId": "DGWAS-1784",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CONNSOFT_ABD",
    "phenotype": "Benign neoplasm: Connective and other soft tissue of abdomen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm (abdomen)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CONNSOFT_ABD.gz"
  },
  {
    "accessionId": "DGWAS-1785",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CONJUNCTIVA",
    "phenotype": "Benign neoplasm: Conjunctiva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign conjunctival neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CONJUNCTIVA.gz"
  },
  {
    "accessionId": "DGWAS-1786",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CNS_NOS",
    "phenotype": "Benign neoplasm: Central nervous system, other parts/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign CNS neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CNS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1787",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CILIARY",
    "phenotype": "Benign neoplasm: Ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign ciliary body neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CILIARY.gz"
  },
  {
    "accessionId": "DGWAS-1788",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CERVIX_UTERI",
    "phenotype": "Other benign neoplasm of uterus: Cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cervical neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CERVIX_UTERI.gz"
  },
  {
    "accessionId": "DGWAS-1789",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_CAROTIDBODY",
    "phenotype": "Benign neoplasm: Carotid body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign carotid body neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_CAROTIDBODY.gz"
  },
  {
    "accessionId": "DGWAS-179",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_ALLERG",
    "phenotype": "Asthma and allergy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma/allergy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_ALLERG.gz"
  },
  {
    "accessionId": "DGWAS-1790",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BRONCHUS_LUNG",
    "phenotype": "Benign neoplasm: Bronchus and lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bronchial/lung neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BRONCHUS_LUNG.gz"
  },
  {
    "accessionId": "DGWAS-1791",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BRAIN_SUPRATENT",
    "phenotype": "Benign neoplasm: Brain, supratentorial",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign supratentorial brain neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BRAIN_SUPRATENT.gz"
  },
  {
    "accessionId": "DGWAS-1792",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BRAIN_NOS",
    "phenotype": "Benign neoplasm: Brain, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign brain neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BRAIN_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1793",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BRAIN_INFRATENT",
    "phenotype": "Benign neoplasm: Brain, infratentorial",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign infratentorial brain neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BRAIN_INFRATENT.gz"
  },
  {
    "accessionId": "DGWAS-1794",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_SKULL_FACE",
    "phenotype": "Benign neoplasm: Bones of skull and face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign skull/facial bone neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_SKULL_FACE.gz"
  },
  {
    "accessionId": "DGWAS-1795",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_SHORT_UPPER",
    "phenotype": "Benign neoplasm: Short bones of upper limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign short bone neoplasm (upper)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_SHORT_UPPER.gz"
  },
  {
    "accessionId": "DGWAS-1796",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_SHORT_LOWER",
    "phenotype": "Benign neoplasm: Short bones of lower limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign short bone neoplasm (lower)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_SHORT_LOWER.gz"
  },
  {
    "accessionId": "DGWAS-1797",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_SCAPULA_LONG_UPPER",
    "phenotype": "Benign neoplasm: Scapula and long bones of upper limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign scapula/long bone neoplasm (upper)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_SCAPULA_LONG_UPPER.gz"
  },
  {
    "accessionId": "DGWAS-1798",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_LOWER_JAW",
    "phenotype": "Benign neoplasm: Lower jaw bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign mandibular neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_LOWER_JAW.gz"
  },
  {
    "accessionId": "DGWAS-1799",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_BONE_LONG_LOWER",
    "phenotype": "Benign neoplasm: Long bones of lower limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign long bone neoplasm (lower)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_BONE_LONG_LOWER.gz"
  },
  {
    "accessionId": "DGWAS-18",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCOMA",
    "phenotype": "Glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCOMA.gz"
  },
  {
    "accessionId": "DGWAS-180",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SPONDYLOARTHRITIS",
    "phenotype": "Spondyloarthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondyloarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SPONDYLOARTHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-1800",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_BENIGN_ANUS_ANAL_CANAL",
    "phenotype": "Benign neoplasm: Anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign anal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_BENIGN_ANUS_ANAL_CANAL.gz"
  },
  {
    "accessionId": "DGWAS-1801",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CARDIOMYOPATHY_DRUGS_OTHER_EXTER_AGENTS",
    "phenotype": "Cardiomyopathy due to drugs and other external agents",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CARDIOMYOPATHY_DRUGS_OTHER_EXTER_AGENTS.gz"
  },
  {
    "accessionId": "DGWAS-1802",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_TONSIL_BASETONGUE",
    "phenotype": "Malignant cancer of tonsil and base of tongue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsil/base of tongue cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_TONSIL_BASETONGUE.gz"
  },
  {
    "accessionId": "DGWAS-1803",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_THYROID_FOLLICULAR_EXALLC",
    "phenotype": "Follicular adenocarcinoma of thyroid gland (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular thyroid cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_THYROID_FOLLICULAR_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1804",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_TESTIS_NONSEMINOMA_EXALLC",
    "phenotype": "Non-seminoma of testis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular non-seminoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_TESTIS_NONSEMINOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1805",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_SCLC_EXALLC",
    "phenotype": "Small cell lung cancer (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small cell lung cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_SCLC_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1806",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_RENAL_PELVIS_EXALLC",
    "phenotype": "Malignant neoplasm of renal pelvis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal pelvis cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_RENAL_PELVIS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1807",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_RECTUM_NEUROENDOCRINE_EXALLC",
    "phenotype": "Neuroendocrine tumor and carcinoma of rectum (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_RECTUM_NEUROENDOCRINE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1808",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_PENIS_EXALLC",
    "phenotype": "Malignant neoplasm of penis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Penile cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_PENIS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1809",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_PAROTIDGLAND_EXALLC",
    "phenotype": "Malignant neoplasm of parotid gland (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parotid cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_PAROTIDGLAND_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-181",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_BREAST",
    "phenotype": "Disorders of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_BREAST.gz"
  },
  {
    "accessionId": "DGWAS-1810",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_PANCREAS_NEUROENDOCRINE_EXALLC",
    "phenotype": "Neuroendocrine tumor and carcinoma of pancreas (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_PANCREAS_NEUROENDOCRINE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1811",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_PANCREAS_ADENO_DUCTAL_EXALLC",
    "phenotype": "Adenocarcinoma and ductal carcinoma of pancreas (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic adenocarcinoma/ductal carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_PANCREAS_ADENO_DUCTAL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1812",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OVARY_SEROUS_EXALLC",
    "phenotype": "Serous carcinoma of ovary (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian serous carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OVARY_SEROUS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1813",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OVARY_MUCINO_EXALLC",
    "phenotype": "Mucinous and mucinous cystic tumor (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mucinous/mucinous cystic tumor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OVARY_MUCINO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1814",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OVARY_GRANULOSA_EXALLC",
    "phenotype": "Granulosa cell carcinoma of ovary (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian granulosa cell carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OVARY_GRANULOSA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1815",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OVARY_ENDOMETROID_EXALLC",
    "phenotype": "Endometroid carcinoma of ovary (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian endometrioid carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OVARY_ENDOMETROID_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1816",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_OSTEOSARCOMA_EXALLC",
    "phenotype": "Osteosarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteosarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_OSTEOSARCOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1817",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_NONHODGKIN_EXALLC",
    "phenotype": "Non-Hodgkin lymphoma, all (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-Hodgkin lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_NONHODGKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1818",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_NASOPHARYNX_EXALLC",
    "phenotype": "Malignant neoplasm of nasopharynx (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasopharyngeal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_NASOPHARYNX_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1819",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_NASAL_CAVITY_SINUSES_EXALLC",
    "phenotype": "Malignant neoplasm of nasal cavity and sinuses (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal/sinus cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_NASAL_CAVITY_SINUSES_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-182",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ANKYLOSPON_STRICT",
    "phenotype": "Ankylosing spondylitis, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankylosing spondylitis (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ANKYLOSPON_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-1820",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_MYELODYSP_SYNDR_EXALLC",
    "phenotype": "Myelodysplastic syndrome (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myelodysplastic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_MYELODYSP_SYNDR_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1821",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_MESOTHELIOMA_EXALLC",
    "phenotype": "Mesothelioma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesothelioma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_MESOTHELIOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1822",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_MARGINAL_ZONE_LYMPHOMA_EXALLC",
    "phenotype": "Marginal zone B-cell lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Marginal zone B-cell lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_MARGINAL_ZONE_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1823",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_MANTLE_CELL_LYMPHOMA_EXALLC",
    "phenotype": "Mantle cell lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mantle cell lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_MANTLE_CELL_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1824",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_LUNG_NEUROENDO_EXALLC",
    "phenotype": "Neuroendocrine tumor and carcinoma of lung (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_LUNG_NEUROENDO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1825",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_LEIOMYOSARCOMA_EXALLC",
    "phenotype": "Leiomyosarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leiomyosarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_LEIOMYOSARCOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1826",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_KIDNEY_PAPILLARYADENO_EXALLC",
    "phenotype": "Adenocarcinoma and Papillary adenocarcinoma of kidney (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney adenocarcinoma/papillary adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_KIDNEY_PAPILLARYADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1827",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_KIDNEY_CHROMOPHOBE_EXALLC",
    "phenotype": "Chromophobe cell carcinoma of kidney (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney chromophobe carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_KIDNEY_CHROMOPHOBE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1828",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_HYPOPHARYNX_EXALLC",
    "phenotype": "Malignant neoplasm of hypopharynx (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypopharyngeal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_HYPOPHARYNX_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1829",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_GBM_EXALLC",
    "phenotype": "Brain glioblastoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glioblastoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_GBM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-183",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_MIDDLEMASTOID",
    "phenotype": "Diseases of middle ear and mastoid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear/mastoid disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_MIDDLEMASTOID.gz"
  },
  {
    "accessionId": "DGWAS-1830",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_GBM_ASTROCYTOMA_EXALLC",
    "phenotype": "Brain glioblastoma and astrocytoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glioblastoma/astrocytoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_GBM_ASTROCYTOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1831",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_GASTRINT_STROM_EXALLC",
    "phenotype": "Gastrointestinal stromal tumor and sarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GIST/sarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_GASTRINT_STROM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1832",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CORPUS_UTERI_EXALLC",
    "phenotype": "Malignant neoplasm of corpus uteri (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine corpus cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CORPUS_UTERI_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1833",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CML_EXALLC",
    "phenotype": "Chronic myeloid leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CML",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CML_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1834",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CHONDROSARCOMA_EXALLC",
    "phenotype": "Chondrosarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondrosarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CHONDROSARCOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1835",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CERVIX_UTERI_EXALLC",
    "phenotype": "Malignant neoplasm of cervix uteri (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CERVIX_UTERI_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1836",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_CERVIX_ADENO_EXALLC",
    "phenotype": "Adenocarcinomas of cervix (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_CERVIX_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1837",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_BONE_CARTILAGE_EXALLC",
    "phenotype": "Malignant neoplasm of bone and articular cartilage (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone/articular cartilage cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_BONE_CARTILAGE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1838",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_ANUS_ANALCANAL_EXALLC",
    "phenotype": "Malignant neoplasm of anus and anal canal (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_ANUS_ANALCANAL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1839",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_AML_EXALLC",
    "phenotype": "Acute myeloid leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AML",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_AML_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-184",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_AMYLNAS",
    "phenotype": "Amyloidosis, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amyloidosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_AMYLNAS.gz"
  },
  {
    "accessionId": "DGWAS-1840",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_ALL_EXALLC",
    "phenotype": "Acute lymphocytic leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ALL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_ALL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1841",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_ADRENAL_GLAND_EXALLC",
    "phenotype": "Malignant neoplasm of adrenal gland (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenal gland cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_ADRENAL_GLAND_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-1842",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_BACT_INTEST_INFECTION_NOS",
    "phenotype": "Other specified/unspecified bacterial intestinal infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial intestinal infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_BACT_INTEST_INFECTION_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1843",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ASTHMA_MIXED_EXMORE",
    "phenotype": "Asthma mixed form (mode) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma mixed form",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ASTHMA_MIXED_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1844",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ANAPH_SHOCK_ADVER_EFFECT_CORRE_DRUG_MEDICAM_PROPE_ADMINISTE",
    "phenotype": "Anaphylactic shock due to adverse effect of correct drug or medication properly administered",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anaphylactic shock (drug-induced)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ANAPH_SHOCK_ADVER_EFFECT_CORRE_DRUG_MEDICAM_PROPE_ADMINISTE.gz"
  },
  {
    "accessionId": "DGWAS-1845",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ALLERGIC_CONTACT_DERMA_DRUGS_CONTACT_W_SKIN",
    "phenotype": "Allergic contact dermatitis due to drugs in contact with skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic contact dermatitis (drug)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ALLERGIC_CONTACT_DERMA_DRUGS_CONTACT_W_SKIN.gz"
  },
  {
    "accessionId": "DGWAS-1846",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ACUTE_DRUGADVERS_INTERSTITIAL_LUNG_DISORD",
    "phenotype": "Acute drug-induced interstitial lung disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced ILD (acute)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ACUTE_DRUGADVERS_INTERSTITIAL_LUNG_DISORD.gz"
  },
  {
    "accessionId": "DGWAS-1847",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ABPA",
    "phenotype": "Allergic bronchopulmonary aspergillosis (ABPA)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ABPA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ABPA.gz"
  },
  {
    "accessionId": "DGWAS-1848",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAL_SKIN_NOS",
    "phenotype": "Other viral infections characterized by skin and mucous membrane lesions, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral skin/mucous infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAL_SKIN_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1849",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAL_NOS",
    "phenotype": "Other viral diseases, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAL_NOS.gz"
  },
  {
    "accessionId": "DGWAS-185",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_URINARY_SYSTEM",
    "phenotype": "Congenital malformations of the urinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital urinary malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_URINARY_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-1850",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAL_MENINGITIS",
    "phenotype": "Viral meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral meningitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAL_MENINGITIS.gz"
  },
  {
    "accessionId": "DGWAS-1851",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VIRAL_ENCEPHALITIS_NOS",
    "phenotype": "Viral encephalitis, not elsewhere classified/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral encephalitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VIRAL_ENCEPHALITIS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1852",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_VARICELLA",
    "phenotype": "Varicella [chickenpox]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chickenpox",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_VARICELLA.gz"
  },
  {
    "accessionId": "DGWAS-1853",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TYPHOIDPARATHYPHOID",
    "phenotype": "Typhoid and paratyphoid fevers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Typhoid/paratyphoid",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TYPHOIDPARATHYPHOID.gz"
  },
  {
    "accessionId": "DGWAS-1854",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TULARAEMIA",
    "phenotype": "Tularaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tularemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TULARAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-1855",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TOXOPLASMOSIS",
    "phenotype": "Toxoplasmosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxoplasmosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TOXOPLASMOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1856",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_TICK_BORNE_ENCEPHALITIS",
    "phenotype": "Tick-borne viral encephalitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tick-borne encephalitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_TICK_BORNE_ENCEPHALITIS.gz"
  },
  {
    "accessionId": "DGWAS-1857",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SYPHILIS_NOS",
    "phenotype": "Other and unspecified syphilis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Syphilis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SYPHILIS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1858",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SYPHILIS",
    "phenotype": "Syphilis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Syphilis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SYPHILIS.gz"
  },
  {
    "accessionId": "DGWAS-1859",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_STREPTSTAPHYCOCC_INOTHER",
    "phenotype": "Streptococcus and staphylococcus as the cause of diseases classified to other chapters",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Strep/staph infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_STREPTSTAPHYCOCC_INOTHER.gz"
  },
  {
    "accessionId": "DGWAS-186",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CLEFT_PALATE",
    "phenotype": "Cleft palate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cleft palate",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CLEFT_PALATE.gz"
  },
  {
    "accessionId": "DGWAS-1860",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SHIGELLOSIS",
    "phenotype": "Shigellosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shigellosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SHIGELLOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1861",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SEQULAE_TUBERCU",
    "phenotype": "Sequelae of tuberculosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sequelae of TB",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SEQULAE_TUBERCU.gz"
  },
  {
    "accessionId": "DGWAS-1862",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_SEQULAE_POLIO",
    "phenotype": "Sequelae of poliomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sequelae of polio",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_SEQULAE_POLIO.gz"
  },
  {
    "accessionId": "DGWAS-1863",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_RESP_TUBERCU_NONCONF",
    "phenotype": "Respiratory tuberculosis, not confirmed bacteriologically or histologically",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory TB (unconfirmed)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_RESP_TUBERCU_NONCONF.gz"
  },
  {
    "accessionId": "DGWAS-1864",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_RESP_TUBERCU_CONF",
    "phenotype": "Respiratory tuberculosis, bacteriologically and histologically confirmed",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory TB (confirmed)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_RESP_TUBERCU_CONF.gz"
  },
  {
    "accessionId": "DGWAS-1865",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_RELAP_FEVER",
    "phenotype": "Relapsing fevers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Relapsing fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_RELAP_FEVER.gz"
  },
  {
    "accessionId": "DGWAS-1866",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_PROTOZOAL",
    "phenotype": "Protozoal diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Protozoal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_PROTOZOAL.gz"
  },
  {
    "accessionId": "DGWAS-1867",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_POLIOMYELITIS",
    "phenotype": "Acute poliomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute polio",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_POLIOMYELITIS.gz"
  },
  {
    "accessionId": "DGWAS-1868",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_PNEUMOCYSTOSIS",
    "phenotype": "Pneumocystosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumocystosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_PNEUMOCYSTOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1869",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_PEDICULOSIS_AND_PHTHIRIAASIS",
    "phenotype": "Pediculosis and phthiriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pediculosis/phthiriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_PEDICULOSIS_AND_PHTHIRIAASIS.gz"
  },
  {
    "accessionId": "DGWAS-187",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_PRIM_COXARTHROSIS",
    "phenotype": "Primary coxarthrosis, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral hip osteoarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_PRIM_COXARTHROSIS.gz"
  },
  {
    "accessionId": "DGWAS-1870",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_PROTOZOAL",
    "phenotype": "Other protozoal intestinal diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other protozoal intestinal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_PROTOZOAL.gz"
  },
  {
    "accessionId": "DGWAS-1871",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_MOSQUITO_FEVER",
    "phenotype": "Other mosquito-borne viral fevers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mosquito-borne viral fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_MOSQUITO_FEVER.gz"
  },
  {
    "accessionId": "DGWAS-1872",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_INFESTATIONS",
    "phenotype": "Other infestations",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other infestation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_INFESTATIONS.gz"
  },
  {
    "accessionId": "DGWAS-1873",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_CONDITIONS",
    "phenotype": "Human immunodeficiency virus [HIV] disease resulting in other conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "HIV with other conditions",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_CONDITIONS.gz"
  },
  {
    "accessionId": "DGWAS-1874",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_CHLAMYDIAE",
    "phenotype": "Other diseases caused by chlamydiae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chlamydial disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_CHLAMYDIAE.gz"
  },
  {
    "accessionId": "DGWAS-1875",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_OTHER_CESTODE",
    "phenotype": "Other cestode infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cestode infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_OTHER_CESTODE.gz"
  },
  {
    "accessionId": "DGWAS-1876",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_MYSOSIS_NOS",
    "phenotype": "Other mycoses, not elsewhere classified/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mycosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_MYSOSIS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1877",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_MUMPS",
    "phenotype": "Mumps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mumps",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_MUMPS.gz"
  },
  {
    "accessionId": "DGWAS-1878",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_MENINGOCOCCAL",
    "phenotype": "Meningococcal infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningococcal infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_MENINGOCOCCAL.gz"
  },
  {
    "accessionId": "DGWAS-1879",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_MEASLES",
    "phenotype": "Measles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Measles",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_MEASLES.gz"
  },
  {
    "accessionId": "DGWAS-188",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_PSORIARTH",
    "phenotype": "Psoriatic arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriatic arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_PSORIARTH.gz"
  },
  {
    "accessionId": "DGWAS-1880",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_MALARIA_NOS",
    "phenotype": "Other parasitologically confirmed or unspecified malaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_MALARIA_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1881",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_LISTERIOSIS",
    "phenotype": "Listeriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Listeriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_LISTERIOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1882",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_LATE_SYPHILIS",
    "phenotype": "Late syphilis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Late syphilis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_LATE_SYPHILIS.gz"
  },
  {
    "accessionId": "DGWAS-1883",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HIV_NOS",
    "phenotype": "Unspecified human immunodeficiency virus [HIV] disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "HIV disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HIV_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1884",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HIV_INFECT_PARASITES",
    "phenotype": "Human immunodeficiency virus [HIV] disease resulting in infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "HIV with infections",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HIV_INFECT_PARASITES.gz"
  },
  {
    "accessionId": "DGWAS-1885",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HEPATITIS_B",
    "phenotype": "Acute hepatitis B",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute hepatitis B",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HEPATITIS_B.gz"
  },
  {
    "accessionId": "DGWAS-1886",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_HEPATITIS_A",
    "phenotype": "Acute hepatitis A",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute hepatitis A",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_HEPATITIS_A.gz"
  },
  {
    "accessionId": "DGWAS-1887",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_GONOCOCCAL",
    "phenotype": "Gonococcal infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gonorrhea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_GONOCOCCAL.gz"
  },
  {
    "accessionId": "DGWAS-1888",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ENTEROBIASIS",
    "phenotype": "Enterobiasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enterobiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ENTEROBIASIS.gz"
  },
  {
    "accessionId": "DGWAS-1889",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_EARLY_SYPHILIS",
    "phenotype": "Early syphilis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early syphilis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_EARLY_SYPHILIS.gz"
  },
  {
    "accessionId": "DGWAS-189",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_DORSALGIA",
    "phenotype": "Dorsalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_DORSALGIA.gz"
  },
  {
    "accessionId": "DGWAS-1890",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_DENGUE_FEVER",
    "phenotype": "Dengue fever [classical dengue]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dengue fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_DENGUE_FEVER.gz"
  },
  {
    "accessionId": "DGWAS-1891",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_CHOLERA",
    "phenotype": "Cholera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholera",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_CHOLERA.gz"
  },
  {
    "accessionId": "DGWAS-1892",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ATYPICAL_CNS_VIRUS",
    "phenotype": "Atypical virus infections of central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atypical CNS virus infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ATYPICAL_CNS_VIRUS.gz"
  },
  {
    "accessionId": "DGWAS-1893",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ASPERGILLOSIS",
    "phenotype": "Aspergillosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aspergillosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ASPERGILLOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1894",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ANOGENITAL_HERPES_SIMPLEX",
    "phenotype": "Anogenital herpesviral [herpes simplex] infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anogenital herpes",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ANOGENITAL_HERPES_SIMPLEX.gz"
  },
  {
    "accessionId": "DGWAS-1895",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_AB1_ACTINOMYCOSIS",
    "phenotype": "Actinomycosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Actinomycosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_AB1_ACTINOMYCOSIS.gz"
  },
  {
    "accessionId": "DGWAS-19",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_LOWCHRON",
    "phenotype": "Chronic lower respiratory diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic lower respiratory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_LOWCHRON.gz"
  },
  {
    "accessionId": "DGWAS-190",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_THROMBOTH",
    "phenotype": "Other embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embolism/thrombosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_THROMBOTH.gz"
  },
  {
    "accessionId": "DGWAS-1901",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_BACTINF_NOS",
    "phenotype": "Bacterial infection, other or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_BACTINF_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1902",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_BACT_BIR_OTHER_INF_AGENTS",
    "phenotype": "Bacterial, viral and other infectious agents",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious agent",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_BACT_BIR_OTHER_INF_AGENTS.gz"
  },
  {
    "accessionId": "DGWAS-1904",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_CANDIDIASIS",
    "phenotype": "Candidiasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Candidiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_CANDIDIASIS.gz"
  },
  {
    "accessionId": "DGWAS-1905",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_CHLAMYDIA_OTHER",
    "phenotype": "Other sexually transmitted chlamydial diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chlamydial STI",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_CHLAMYDIA_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-1907",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_DERMATOPHYTOSIS",
    "phenotype": "Dermatophytosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatophytosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_DERMATOPHYTOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1909",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_EBV",
    "phenotype": "Infectious mononucleosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious mononucleosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_EBV.gz"
  },
  {
    "accessionId": "DGWAS-191",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_PAROXTAC",
    "phenotype": "Paroxysmal tachycardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paroxysmal tachycardia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_PAROXTAC.gz"
  },
  {
    "accessionId": "DGWAS-1911",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_ERYSIPELAS",
    "phenotype": "Erysipelas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erysipelas",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_ERYSIPELAS.gz"
  },
  {
    "accessionId": "DGWAS-1912",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_GASTROENTERITIS_NOS",
    "phenotype": "Diarrhoea and gastroenteritis of presumed infectious origin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious diarrhea/gastroenteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_GASTROENTERITIS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1919",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_INTESTINAL_INFECTIONS",
    "phenotype": "Intestinal infectious diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_INTESTINAL_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-192",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HYPTENSHD",
    "phenotype": "Hypertensive Heart Disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive heart disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HYPTENSHD.gz"
  },
  {
    "accessionId": "DGWAS-1922",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_MALARIA",
    "phenotype": "Malaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_MALARIA.gz"
  },
  {
    "accessionId": "DGWAS-1926",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_MYCOSES",
    "phenotype": "Mycoses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mycosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_MYCOSES.gz"
  },
  {
    "accessionId": "DGWAS-1927",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_BACTERIAL",
    "phenotype": "Other bacterial diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other bacterial disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_BACTERIAL.gz"
  },
  {
    "accessionId": "DGWAS-193",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CHOROIDRETINA",
    "phenotype": "Disorders of choroid and retina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Choroid/retina disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CHOROIDRETINA.gz"
  },
  {
    "accessionId": "DGWAS-1932",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_INFECTIONS",
    "phenotype": "Other infectious diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other infectious disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-1935",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_SEPSIS",
    "phenotype": "Other septicaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Septicemia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_SEPSIS.gz"
  },
  {
    "accessionId": "DGWAS-1936",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_SPIROCHAETAL",
    "phenotype": "Other spirochaetal diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spirochetal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_SPIROCHAETAL.gz"
  },
  {
    "accessionId": "DGWAS-1937",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_SUPERF_MYCOSIS",
    "phenotype": "Other superficial mycoses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Superficial mycosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_SUPERF_MYCOSIS.gz"
  },
  {
    "accessionId": "DGWAS-1938",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_OTHER_VIRAL",
    "phenotype": "Other viral diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other viral disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_OTHER_VIRAL.gz"
  },
  {
    "accessionId": "DGWAS-194",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GOUT_STRICT",
    "phenotype": "Gout, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GOUT_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-1940",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_PEDICULOSIS_ACARIASIS_OTHERINFEST",
    "phenotype": "Pediculosis, acariasis and other infestations",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pediculosis/acariasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_PEDICULOSIS_ACARIASIS_OTHERINFEST.gz"
  },
  {
    "accessionId": "DGWAS-1947",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_RUBELLA",
    "phenotype": "Rubella [German measles]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rubella",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_RUBELLA.gz"
  },
  {
    "accessionId": "DGWAS-1948",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_SALMONELLA_OTH",
    "phenotype": "Other salmonella infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salmonella infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_SALMONELLA_OTH.gz"
  },
  {
    "accessionId": "DGWAS-1949",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_SCABIES",
    "phenotype": "Scabies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scabies",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_SCABIES.gz"
  },
  {
    "accessionId": "DGWAS-195",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_GOUT_NOS",
    "phenotype": "Gout, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_GOUT_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1950",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_SCARLET_FEVER",
    "phenotype": "Scarlet fever",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scarlet fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_SCARLET_FEVER.gz"
  },
  {
    "accessionId": "DGWAS-1955",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_SEXUAL_TRANSMISSION",
    "phenotype": "Infections with a predominantly sexual mode of transmission",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "STI",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_SEXUAL_TRANSMISSION.gz"
  },
  {
    "accessionId": "DGWAS-1956",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_SEXUAL_TRANSMISSION_NOS",
    "phenotype": "Other predominantly sexually transmitted diseases, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other STI",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_SEXUAL_TRANSMISSION_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1958",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_STREPTO_SEPSIS",
    "phenotype": "Streptococcal septicaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Streptococcal septicemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_STREPTO_SEPSIS.gz"
  },
  {
    "accessionId": "DGWAS-196",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_EPIPAROX",
    "phenotype": "Episodal and paroxysmal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Episodic/paroxysmal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_EPIPAROX.gz"
  },
  {
    "accessionId": "DGWAS-1964",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_TUBERCULOSIS",
    "phenotype": "Tuberculosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tuberculosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_TUBERCULOSIS.gz"
  },
  {
    "accessionId": "DGWAS-197",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_GRAVES_STRICT",
    "phenotype": "Graves disease, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Graves disease (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_GRAVES_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-1972",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_HEMOR_FEVER_NOS",
    "phenotype": "Viral haemorrhagic fevers, not elsewhere classified/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral hemorrhagic fever",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_HEMOR_FEVER_NOS.gz"
  },
  {
    "accessionId": "DGWAS-1973",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_HEPATITIS",
    "phenotype": "Viral hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral hepatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_HEPATITIS.gz"
  },
  {
    "accessionId": "DGWAS-1974",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_INOTHER",
    "phenotype": "Viral agents as the cause of diseases classified to other chapters",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral agent",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_INOTHER.gz"
  },
  {
    "accessionId": "DGWAS-1977",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_OTHER_INTEST_INFECTIONS",
    "phenotype": "Viral and other specified intestinal infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral intestinal infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_OTHER_INTEST_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-1978",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_SKIN_MUCOUS_MEMBRANE",
    "phenotype": "Viral infections characterized by skin and mucous membrane lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral skin/mucous infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_SKIN_MUCOUS_MEMBRANE.gz"
  },
  {
    "accessionId": "DGWAS-198",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_CYSTFIBRO",
    "phenotype": "Cystic fibrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystic fibrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_CYSTFIBRO.gz"
  },
  {
    "accessionId": "DGWAS-1980",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_VIRAL_WARTS",
    "phenotype": "Viral warts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral warts",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_VIRAL_WARTS.gz"
  },
  {
    "accessionId": "DGWAS-1982",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_WHOOPCOUGH",
    "phenotype": "Whooping cough",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pertussis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_WHOOPCOUGH.gz"
  },
  {
    "accessionId": "DGWAS-1984",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AB1_ZOSTER",
    "phenotype": "Zoster [herpes zoster]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Herpes zoster",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AB1_ZOSTER.gz"
  },
  {
    "accessionId": "DGWAS-1986",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ABDOM_HERNIA_POSTOP",
    "phenotype": "Hernia of abdominal wall, postoperative",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postop abdominal wall hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ABDOM_HERNIA_POSTOP.gz"
  },
  {
    "accessionId": "DGWAS-1989",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AD_AM_EXMORE",
    "phenotype": "Alzheimer's disease (Atypical or mixed) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease (atypical/mixed)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AD_AM_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-199",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CHRONNAS",
    "phenotype": "Crohn's disease NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CHRONNAS.gz"
  },
  {
    "accessionId": "DGWAS-1990",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AD_EO_EXMORE",
    "phenotype": "Alzheimer's disease (Early onset) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease (early onset)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AD_EO_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1991",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AD_LO_EXMORE",
    "phenotype": "Alzheimer's disease (Late onset) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease (late onset)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AD_LO_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1992",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AD_U_EXMORE",
    "phenotype": "Alzheimer's disease (undefined) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease (undefined)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AD_U_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-1993",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALCODELIRIUM",
    "phenotype": "Alcohol withdrawal state with delirium?",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol withdrawal with delirium",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALCODELIRIUM.gz"
  },
  {
    "accessionId": "DGWAS-1994",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALCOHOLACUTE10",
    "phenotype": "Acute alcohol intoxication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute alcohol intoxication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALCOHOLACUTE10.gz"
  },
  {
    "accessionId": "DGWAS-1995",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALCOPANCACU",
    "phenotype": "Alcohol-induced acute pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic acute pancreatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALCOPANCACU.gz"
  },
  {
    "accessionId": "DGWAS-1996",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALCOPANCCHRON",
    "phenotype": "Alcohol-induced chronic pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic chronic pancreatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALCOPANCCHRON.gz"
  },
  {
    "accessionId": "DGWAS-1999",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALLERG_ASTHMA",
    "phenotype": "Allergic asthma (mode)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALLERG_ASTHMA.gz"
  },
  {
    "accessionId": "DGWAS-2",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_T2D_WIDE",
    "phenotype": "Type 2 diabetes, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_T2D_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-20",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HERING",
    "phenotype": "Inguinal hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inguinal hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HERING.gz"
  },
  {
    "accessionId": "DGWAS-200",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_PRIMARY_LYMPHOID_HEMATOPOIETIC_EXALLC",
    "phenotype": "Primary_lymphoid and hematopoietic malignant neoplasms (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid/hematopoietic malignancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_PRIMARY_LYMPHOID_HEMATOPOIETIC_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2000",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ALLERG_RHINITIS",
    "phenotype": "Allergic rhinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic rhinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ALLERG_RHINITIS.gz"
  },
  {
    "accessionId": "DGWAS-2001",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AMN2",
    "phenotype": "Transient global amnesia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transient global amnesia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AMN2.gz"
  },
  {
    "accessionId": "DGWAS-2004",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ANTIDEPRESSANTS",
    "phenotype": "Depression medications",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Antidepressant medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ANTIDEPRESSANTS.gz"
  },
  {
    "accessionId": "DGWAS-2005",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_APPENDACUT_COMPLIC",
    "phenotype": "Acute appendicitis, with complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute appendicitis with complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_APPENDACUT_COMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-2006",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_APPENDACUT_NOCOMPLIC",
    "phenotype": "Acute appendicitis, no complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute appendicitis without complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_APPENDACUT_NOCOMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-2008",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ARTRHO_POSTDYSENTERIC",
    "phenotype": "Postdysenteric arthropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postdysenteric arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ARTRHO_POSTDYSENTERIC.gz"
  },
  {
    "accessionId": "DGWAS-201",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_GESTAT_HYPERT",
    "phenotype": "Gestational [pregnancy-induced] hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_GESTAT_HYPERT.gz"
  },
  {
    "accessionId": "DGWAS-2013",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ASTHMA_INFECTIONS",
    "phenotype": "Asthma-related infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma-related infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ASTHMA_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-2016",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ASTHMA_OBESITY",
    "phenotype": "Obesity related asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity-related asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ASTHMA_OBESITY.gz"
  },
  {
    "accessionId": "DGWAS-2017",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ASTHMA_OPPORTUNIST_INFECTIONS",
    "phenotype": "Asthma and opportunity respiratory infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma with opportunistic respiratory infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ASTHMA_OPPORTUNIST_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-2018",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ASTHMA_PNEUMONIA",
    "phenotype": "Asthma-related pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma-related pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ASTHMA_PNEUMONIA.gz"
  },
  {
    "accessionId": "DGWAS-2019",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUD",
    "phenotype": "Alcohol use disorder, ICD-based",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol use disorder (ICD-based)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUD.gz"
  },
  {
    "accessionId": "DGWAS-202",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ADHCAPSULITIS",
    "phenotype": "Adhesive capsulitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adhesive capsulitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ADHCAPSULITIS.gz"
  },
  {
    "accessionId": "DGWAS-2020",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUD_SWEDISH",
    "phenotype": "Alcohol use disorder, Swedish definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol use disorder (Swedish)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUD_SWEDISH.gz"
  },
  {
    "accessionId": "DGWAS-2021",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUTOIMMUNE",
    "phenotype": "Autoimmune diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUTOIMMUNE.gz"
  },
  {
    "accessionId": "DGWAS-2022",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUTOIMMUNE_HYPERTHYROIDISM",
    "phenotype": "Autoimmune hyperthyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune hyperthyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUTOIMMUNE_HYPERTHYROIDISM.gz"
  },
  {
    "accessionId": "DGWAS-2023",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUTOIMMUNE_NONTHYROID",
    "phenotype": "Autoimmune diseases excluding thyroid diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune disease (non-thyroid)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUTOIMMUNE_NONTHYROID.gz"
  },
  {
    "accessionId": "DGWAS-2024",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_AUTOIMMUNE_NONTHYROID_STRICT",
    "phenotype": "Autoimmune diseases excluding thyroid diseases, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune disease (non-thyroid, strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_AUTOIMMUNE_NONTHYROID_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-2026",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_BLEEDING",
    "phenotype": "Bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bleeding",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_BLEEDING.gz"
  },
  {
    "accessionId": "DGWAS-2027",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_BRONCHITIS",
    "phenotype": "Bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_BRONCHITIS.gz"
  },
  {
    "accessionId": "DGWAS-2028",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_BRUXISM",
    "phenotype": "Bruxism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bruxism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_BRUXISM.gz"
  },
  {
    "accessionId": "DGWAS-203",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CARDMYOOTH",
    "phenotype": "Cardiomyopathy, other and unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CARDMYOOTH.gz"
  },
  {
    "accessionId": "DGWAS-2033",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_ASTROCYTOMA_EXALLC",
    "phenotype": "Brain astrocytoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Astrocytoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_ASTROCYTOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2034",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BASAL_CELL_CARCINOMA_EXALLC",
    "phenotype": "Basal cell carcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "BCC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BASAL_CELL_CARCINOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2035",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BASAL_CELL_CARCINOMA_INCLAVO_EXALLC",
    "phenotype": "Basal cell carcinoma, including avohilmo (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "BCC (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BASAL_CELL_CARCINOMA_INCLAVO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2036",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BILIARY_GALLBLADDER_EXALLC",
    "phenotype": "Malignant neoplasm of intrahepatic ducts, biliary tract and gallbladder (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biliary tract/gallbladder cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BILIARY_GALLBLADDER_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2037",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BLADDER_EXALLC",
    "phenotype": "Malignant neoplasm of bladder (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BLADDER_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2039",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BRAIN_EXALLC",
    "phenotype": "Malignant neoplasm of brain (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BRAIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-204",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_CONJUNCTIVITIS",
    "phenotype": "Conjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_CONJUNCTIVITIS.gz"
  },
  {
    "accessionId": "DGWAS-2040",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BREAST_ERNEG_EXALLC",
    "phenotype": "Malignant neoplasm of breast, HER-negative (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (HER2-)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BREAST_ERNEG_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2041",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BREAST_ERPLUS_EXALLC",
    "phenotype": "Malignant neoplasm of breast, HER-positive (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (HER2+)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BREAST_ERPLUS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2042",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BREAST_EXALLC",
    "phenotype": "Malignant neoplasm of breast (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BREAST_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2043",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_BRONCHUS_LUNG_EXALLC",
    "phenotype": "Malignant neoplasm of bronchus and lung (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_BRONCHUS_LUNG_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2044",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_CANCER_EXALLC",
    "phenotype": "Malignant neoplasm (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malignant neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_CANCER_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2048",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_CLL_EXALLC",
    "phenotype": "Chronic lymphocytic leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CLL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_CLL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-205",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_D3_ANAEMIA_IRONDEF",
    "phenotype": "Iron deficiency anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_D3_ANAEMIA_IRONDEF.gz"
  },
  {
    "accessionId": "DGWAS-2050",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_COLON_ADENO_EXALLC",
    "phenotype": "Colon adenocarcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_COLON_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2051",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_COLON_EXALLC",
    "phenotype": "Malignant neoplasm of colon (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_COLON_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2052",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_COLORECTAL_ADENO_EXALLC",
    "phenotype": "Colorectal adenocarcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colorectal adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_COLORECTAL_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2053",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_COLORECTAL_EXALLC",
    "phenotype": "Colorectal cancer (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colorectal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_COLORECTAL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2056",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_DLBCL_EXALLC",
    "phenotype": "Diffuse large B-cell lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DLBCL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_DLBCL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2057",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_EYE_ADNEXA_EXALLC",
    "phenotype": "Malignant neoplasm of eye and adnexa (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/adnexal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_EYE_ADNEXA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2058",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_FIBROSARCOMA_EXALLC",
    "phenotype": "Fibrosarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibrosarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_FIBROSARCOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-206",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C3_THYROID_PAPILLARY_ADENO_EXALLC",
    "phenotype": "Papillary adenocarcinoma of thyroid gland (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid papillary adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C3_THYROID_PAPILLARY_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2062",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_HEAD_AND_NECK_EXALLC",
    "phenotype": "Malignant neoplasm of head and neck (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Head/neck cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_HEAD_AND_NECK_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2063",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_HEPATOCELLU_CARC_EXALLC",
    "phenotype": "Hepatocellular carcinoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "HCC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_HEPATOCELLU_CARC_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2066",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_KIDNEY_CLEAR_CELL_CARCINOMA_EXALLC",
    "phenotype": "Clear cell adenocarcinoma of kidney (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney clear cell adenocarcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_KIDNEY_CLEAR_CELL_CARCINOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2067",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_KIDNEY_NOTRENALPELVIS_EXALLC",
    "phenotype": "Malignant neoplasm of kidney, except renal pelvis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (non-pelvis)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_KIDNEY_NOTRENALPELVIS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2070",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_LIPOSARCOMA_EXALLC",
    "phenotype": "Liposarcoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liposarcoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_LIPOSARCOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2073",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_LUNG_NONSMALL_EXALLC",
    "phenotype": "Non-small cell lung cancer (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NSCLC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_LUNG_NONSMALL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2074",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_MACROGLOBULINEMIA_EXALLC",
    "phenotype": "Waldenstrom macroglobulinemia, lymphoplasmacytic lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Waldenstrom macroglobulinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_MACROGLOBULINEMIA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2077",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_MELANOMA_EXALLC",
    "phenotype": "Malignant melanoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_MELANOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2078",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_MELANOMA_SKIN_EXALLC",
    "phenotype": "Malignant melanoma of skin (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma of skin",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_MELANOMA_SKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2079",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_MENINGIOMA_EXALLC",
    "phenotype": "Brain meningioma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningioma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_MENINGIOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-208",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OVARYCYST",
    "phenotype": "Ovarian cyst",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OVARYCYST.gz"
  },
  {
    "accessionId": "DGWAS-2086",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_NSCLC_SQUAM_EXALLC",
    "phenotype": "Non-small cell lung cancer, squamous (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NSCLC squamous",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_NSCLC_SQUAM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2087",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_OESOPHAGUS_EXALLC",
    "phenotype": "Malignant neoplasm of oesophagus (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_OESOPHAGUS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2088",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_ORALCAVITY_EXALLC",
    "phenotype": "Malignant neoplasm of oral cavity (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral cavity cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_ORALCAVITY_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-209",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMETRIOSIS_ASRM_STAGE1_2",
    "phenotype": "Endometriosis ASRM stages 1,2",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis (stages 1-2)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMETRIOSIS_ASRM_STAGE1_2.gz"
  },
  {
    "accessionId": "DGWAS-2095",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_PANCREAS_EXALLC",
    "phenotype": "Malignant neoplasm of pancreas (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_PANCREAS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2098",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_PROSTATE_EXALLC",
    "phenotype": "Malignant neoplasm of prostate (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_PROSTATE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2099",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_RECTUM_ADENO",
    "phenotype": "Adenocarcinoma and papilloma adenocarcinoma of rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal adenocarcinoma/papilloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_RECTUM_ADENO.gz"
  },
  {
    "accessionId": "DGWAS-21",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_CABG",
    "phenotype": "Coronary artery bypass grafting",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "CABG procedure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_CABG.gz"
  },
  {
    "accessionId": "DGWAS-210",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_KNEEDERANGEMENTS",
    "phenotype": "Internal derangement of knee",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Internal knee derangement",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_KNEEDERANGEMENTS.gz"
  },
  {
    "accessionId": "DGWAS-2100",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_RECTUM_ADENO_MUCINO_EXALLC",
    "phenotype": "Adenocarcinoma, papilloma adenocarcinoma and mucinous carcinomas of rectum (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal adenocarcinoma/papillary/mucinous",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_RECTUM_ADENO_MUCINO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2101",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_RECTUM_EXALLC",
    "phenotype": "Malignant neoplasm of rectum (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_RECTUM_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2106",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_SMALL_INTESTINE_NEUROENDOCRINE_EXALLC",
    "phenotype": "Neuroendocrine tumor and carcinoma of small intestine (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine NET/carcinoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_SMALL_INTESTINE_NEUROENDOCRINE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2107",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_SQUOMOUS_CELL_CARCINOMA_SKIN_EXALLC",
    "phenotype": "Squamous cell neoplasms and carcinomas of the skin (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cutaneous SCC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_SQUOMOUS_CELL_CARCINOMA_SKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2108",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_STOMACH_ADENO_EXALLC",
    "phenotype": "Adenocarcinoma and papillary adenocarcinoma of stomach (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric adenocarcinoma/papillary",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_STOMACH_ADENO_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2109",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_STOMACH_EXALLC",
    "phenotype": "Malignant neoplasm of stomach (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_STOMACH_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-211",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_FOLLICULARCYST",
    "phenotype": "Follicular cysts of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_FOLLICULARCYST.gz"
  },
  {
    "accessionId": "DGWAS-2113",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_TESTIS_SEMINOMA_EXALLC",
    "phenotype": "Seminoma of testis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular seminoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_TESTIS_SEMINOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2115",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_THYROID_GLAND_EXALLC",
    "phenotype": "Malignant neoplasm of thyroid gland (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_THYROID_GLAND_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2118",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_URINARY_TRACT_EXALLC",
    "phenotype": "Malignant neoplasm of urinary organs (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary organ cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_URINARY_TRACT_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2119",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C3_VULVA_EXALLC",
    "phenotype": "Malignant neoplasm of vulva (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar cancer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C3_VULVA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-212",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_LIVER",
    "phenotype": "Diseases of liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_LIVER.gz"
  },
  {
    "accessionId": "DGWAS-2120",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CAMPYLOENTERITIS",
    "phenotype": "Campylobacter enteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Campylobacter enteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CAMPYLOENTERITIS.gz"
  },
  {
    "accessionId": "DGWAS-2122",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_ADRENAL",
    "phenotype": "Benign neoplasm: Adrenal gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign adrenal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_ADRENAL.gz"
  },
  {
    "accessionId": "DGWAS-2124",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_APPENDIX",
    "phenotype": "Benign neoplasm: Appendix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign appendiceal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_APPENDIX.gz"
  },
  {
    "accessionId": "DGWAS-2125",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_ASCENDING_COLON",
    "phenotype": "Benign neoplasm: Ascending colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign ascending colon neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_ASCENDING_COLON.gz"
  },
  {
    "accessionId": "DGWAS-2126",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_BLADDER",
    "phenotype": "Benign neoplasm: Bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bladder neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_BLADDER.gz"
  },
  {
    "accessionId": "DGWAS-2127",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_BONE_CARTILAGE",
    "phenotype": "Benign neoplasm of bone and articular cartilage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bone/cartilage neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_BONE_CARTILAGE.gz"
  },
  {
    "accessionId": "DGWAS-2128",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_BONE_CARTILAGE_NOS",
    "phenotype": "Benign neoplasm: Bone and articular cartilage, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bone/cartilage neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_BONE_CARTILAGE_NOS.gz"
  },
  {
    "accessionId": "DGWAS-213",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_LICHEN_PLANUS_WIDE",
    "phenotype": "Lichen ruber planus, wide definition including periferal and oral lichen planus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen planus (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_LICHEN_PLANUS_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-2135",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_BRAIN_CNS",
    "phenotype": "Benign neoplasm of brain and other parts of central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign CNS neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_BRAIN_CNS.gz"
  },
  {
    "accessionId": "DGWAS-2139",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_BREAST",
    "phenotype": "Benign neoplasm of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign breast neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_BREAST.gz"
  },
  {
    "accessionId": "DGWAS-214",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_DISLIVOTH",
    "phenotype": "Other diseases of liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_DISLIVOTH.gz"
  },
  {
    "accessionId": "DGWAS-2141",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_CAECUM",
    "phenotype": "Benign neoplasm: Caecum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cecal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_CAECUM.gz"
  },
  {
    "accessionId": "DGWAS-2143",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_CHOROID",
    "phenotype": "Benign neoplasm: Choroid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign choroid neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_CHOROID.gz"
  },
  {
    "accessionId": "DGWAS-2145",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_COLON",
    "phenotype": "Benign neoplasm: Colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colon neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_COLON.gz"
  },
  {
    "accessionId": "DGWAS-2146",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_COLON_NOS",
    "phenotype": "Benign neoplasm: Colon, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colon neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_COLON_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2149",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_CONNECTIVE_SOFT",
    "phenotype": "Other benign neoplasms of connective and other soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_CONNECTIVE_SOFT.gz"
  },
  {
    "accessionId": "DGWAS-215",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_THYTOXGOITMULT",
    "phenotype": "Thyrotoxicosis with toxic multinodular goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic multinodular goiter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_THYTOXGOITMULT.gz"
  },
  {
    "accessionId": "DGWAS-2156",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_DIGESTIVE_NOS",
    "phenotype": "Benign neoplasm: Ill-defined sites within the digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign digestive neoplasm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_DIGESTIVE_NOS.gz"
  },
  {
    "accessionId": "DGWAS-216",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_PARATHYRO",
    "phenotype": "Disorders of parathyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parathyroid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_PARATHYRO.gz"
  },
  {
    "accessionId": "DGWAS-2161",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_ENDOCRINE_OTH",
    "phenotype": "Benign neoplasm of other and unspecified endocrine glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign endocrine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_ENDOCRINE_OTH.gz"
  },
  {
    "accessionId": "DGWAS-2165",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_FEMALE_GEN_OTH",
    "phenotype": "Benign neoplasm of other and unspecified female genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign female genital neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_FEMALE_GEN_OTH.gz"
  },
  {
    "accessionId": "DGWAS-2168",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_HEART",
    "phenotype": "Benign neoplasm: Heart",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign heart neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_HEART.gz"
  },
  {
    "accessionId": "DGWAS-217",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_IRON_MET",
    "phenotype": "Disorders of iron metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_IRON_MET.gz"
  },
  {
    "accessionId": "DGWAS-2172",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_KIDNEY",
    "phenotype": "Benign neoplasm: Kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign kidney neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_KIDNEY.gz"
  },
  {
    "accessionId": "DGWAS-2174",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_LEIOMYOMA_UTERI",
    "phenotype": "Leiomyoma of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine leiomyoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_LEIOMYOMA_UTERI.gz"
  },
  {
    "accessionId": "DGWAS-2176",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_LIPOMATOUS",
    "phenotype": "Benign lipomatous neoplasm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_LIPOMATOUS.gz"
  },
  {
    "accessionId": "DGWAS-2179",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_LIPO_SKIN_LIMBS",
    "phenotype": "Benign lipomatous neoplasm of skin and subcutaneous tissue of limbs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma (limbs)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_LIPO_SKIN_LIMBS.gz"
  },
  {
    "accessionId": "DGWAS-218",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CHRONOTH",
    "phenotype": "Other Crohn's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CHRONOTH.gz"
  },
  {
    "accessionId": "DGWAS-2181",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_LIPO_SKIN_TRUNK",
    "phenotype": "Benign lipomatous neoplasm of skin and subcutaneous tissue of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign lipoma (trunk)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_LIPO_SKIN_TRUNK.gz"
  },
  {
    "accessionId": "DGWAS-2183",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_LIVE_BILE",
    "phenotype": "Benign neoplasm: Liver/bile ducts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign liver/bile duct neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_LIVE_BILE.gz"
  },
  {
    "accessionId": "DGWAS-2187",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MELANOCYTIC",
    "phenotype": "Melanocytic naevi",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MELANOCYTIC.gz"
  },
  {
    "accessionId": "DGWAS-2188",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MELANOCYTIC_EAR",
    "phenotype": "Melanocytic naevi of ear and external auricular canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (ear)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MELANOCYTIC_EAR.gz"
  },
  {
    "accessionId": "DGWAS-2192",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MELANOCYTIC_LOWERLIMB",
    "phenotype": "Melanocytic naevi of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (lower limb)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MELANOCYTIC_LOWERLIMB.gz"
  },
  {
    "accessionId": "DGWAS-2193",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MELANOCYTIC_NOS",
    "phenotype": "Melanocytic naevi, other sites/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MELANOCYTIC_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2195",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MELANOCYTIC_TRUNK",
    "phenotype": "Melanocytic naevi of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus (trunk)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MELANOCYTIC_TRUNK.gz"
  },
  {
    "accessionId": "DGWAS-2197",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MENINGES",
    "phenotype": "Benign neoplasm of meninges",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign meningeal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MENINGES.gz"
  },
  {
    "accessionId": "DGWAS-2198",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_MENINGES_CEREBRAL",
    "phenotype": "Benign neoplasm: Cerebral meninges",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cerebral meninges neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_MENINGES_CEREBRAL.gz"
  },
  {
    "accessionId": "DGWAS-22",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_ANGINA",
    "phenotype": "Angina pectoris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angina pectoris",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_ANGINA.gz"
  },
  {
    "accessionId": "DGWAS-2209",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_OTHER_NOS",
    "phenotype": "Benign neoplasm of other and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign neoplasm (other)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_OTHER_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2210",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_OVARY",
    "phenotype": "Benign neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign ovarian neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_OVARY.gz"
  },
  {
    "accessionId": "DGWAS-2215",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_PERIPH_AUTO_NEURO",
    "phenotype": "Benign neoplasm: Peripheral nerves and autonomic nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign peripheral nerve neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_PERIPH_AUTO_NEURO.gz"
  },
  {
    "accessionId": "DGWAS-2217",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_PITUITARY_CRANIPHAR",
    "phenotype": "Benign neoplasm: Pituitary gland, craniopharyngeal duct",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pituitary neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_PITUITARY_CRANIPHAR.gz"
  },
  {
    "accessionId": "DGWAS-2219",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_RECTOSIGMOID_JUNC",
    "phenotype": "Benign neoplasm: Rectosigmoid junction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign rectosigmoid neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_RECTOSIGMOID_JUNC.gz"
  },
  {
    "accessionId": "DGWAS-222",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_DERMATITISNAS",
    "phenotype": "Other and unspecified dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_DERMATITISNAS.gz"
  },
  {
    "accessionId": "DGWAS-2220",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_RECTUM",
    "phenotype": "Benign neoplasm: Rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign rectal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_RECTUM.gz"
  },
  {
    "accessionId": "DGWAS-2221",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_RECTUM_ANAL",
    "phenotype": "Benign neoplasm: Rectum, anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign rectal/anal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_RECTUM_ANAL.gz"
  },
  {
    "accessionId": "DGWAS-2222",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_RECTUM_ANAL_CANAL_ICD9",
    "phenotype": "Benign neoplasm: Rectum/anal canal icd-9",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign rectal/anal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_RECTUM_ANAL_CANAL_ICD9.gz"
  },
  {
    "accessionId": "DGWAS-2224",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_RETROPERITONEUM_PERITONEUM",
    "phenotype": "Benign neoplasm of soft tissue of retroperitoneum and peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign retroperitoneal/peritoneal soft tissue neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_RETROPERITONEUM_PERITONEUM.gz"
  },
  {
    "accessionId": "DGWAS-2228",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_SCROTUM",
    "phenotype": "Benign neoplasm: Scrotum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign scrotal neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_SCROTUM.gz"
  },
  {
    "accessionId": "DGWAS-2229",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_SIGMOID_COLON",
    "phenotype": "Benign neoplasm: Sigmoid colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign sigmoid colon neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_SIGMOID_COLON.gz"
  },
  {
    "accessionId": "DGWAS-223",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_THAORTANEUR",
    "phenotype": "Thoracic aortic aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thoracic aortic aneurysm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_THAORTANEUR.gz"
  },
  {
    "accessionId": "DGWAS-2230",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_SKIN",
    "phenotype": "Other benign neoplasms of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign skin neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_SKIN.gz"
  },
  {
    "accessionId": "DGWAS-2231",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_SMALL_INTESTINE",
    "phenotype": "Benign neoplasm: Small intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign small intestine neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_SMALL_INTESTINE.gz"
  },
  {
    "accessionId": "DGWAS-2234",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_STOMACH",
    "phenotype": "Benign neoplasm: Stomach",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign gastric neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_STOMACH.gz"
  },
  {
    "accessionId": "DGWAS-2235",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_TESTIS",
    "phenotype": "Benign neoplasm: Testis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign testicular neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_TESTIS.gz"
  },
  {
    "accessionId": "DGWAS-2237",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_TONGUE",
    "phenotype": "Benign neoplasm: Tongue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign tongue neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_TONGUE.gz"
  },
  {
    "accessionId": "DGWAS-2238",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_BENIGN_TONSIL",
    "phenotype": "Benign neoplasm: Tonsil",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign tonsil neoplasm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_BENIGN_TONSIL.gz"
  },
  {
    "accessionId": "DGWAS-224",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HEARTFAIL_EXMORE",
    "phenotype": "Heart failure,strict (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HEARTFAIL_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-2247",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_FOLLICULAR_LYMPHOMA",
    "phenotype": "Follicular lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_FOLLICULAR_LYMPHOMA.gz"
  },
  {
    "accessionId": "DGWAS-2248",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_FOLLICULAR_LYMPHOMA_EXALLC",
    "phenotype": "Follicular lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_FOLLICULAR_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2249",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_HODGKIN_LYMPHOMA",
    "phenotype": "Hodgkin lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hodgkin lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_HODGKIN_LYMPHOMA.gz"
  },
  {
    "accessionId": "DGWAS-225",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_GLAUCOMAMEDICATION",
    "phenotype": "Use of antiglaucoma preparations and miotics",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Antiglaucoma medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_GLAUCOMAMEDICATION.gz"
  },
  {
    "accessionId": "DGWAS-2250",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_HODGKIN_LYMPHOMA_EXALLC",
    "phenotype": "Hodgkin lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hodgkin lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_HODGKIN_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2252",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_BLADDER_EXALLC",
    "phenotype": "Carcinoma in situ, bladder (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_BLADDER_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2254",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_BREAST_INTRADUCTAL_EXALLC",
    "phenotype": "Carcinoma in situ of breast, intraductal (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast intraductal CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_BREAST_INTRADUCTAL_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2255",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_BREAST_LOBULAR_EXALLC",
    "phenotype": "Carcinoma in situ of breast, lobular (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast lobular CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_BREAST_LOBULAR_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2259",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_MELANOMA_EXALLC",
    "phenotype": "Melanoma in situ (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma in situ",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_MELANOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-226",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MS",
    "phenotype": "MS-disease / Multiple Sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple sclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MS.gz"
  },
  {
    "accessionId": "DGWAS-2260",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_PROSTATE_EXALLC",
    "phenotype": "Carcinoma in situ of prostate (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_PROSTATE_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2262",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_INSITU_SKIN_EXALLC",
    "phenotype": "Carcinoma in situ of skin (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin CIS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_INSITU_SKIN_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2264",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_LEUKAEMIA_NAS",
    "phenotype": "Leukaemia of unspecified cell type",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leukemia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_LEUKAEMIA_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2266",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_LYMPHOID_LEUKAEMIA_EXALLC",
    "phenotype": "Lymphoid leukaemia (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid leukemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_LYMPHOID_LEUKAEMIA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2268",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_MYELOID_LEUKAEMIA",
    "phenotype": "Myeloid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloid leukemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_MYELOID_LEUKAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-227",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_C_STROKE",
    "phenotype": "STROKE",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_C_STROKE.gz"
  },
  {
    "accessionId": "DGWAS-2270",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_NONFOLLICULAR_LYMPHOMA",
    "phenotype": "Non-follicular lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-follicular lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_NONFOLLICULAR_LYMPHOMA.gz"
  },
  {
    "accessionId": "DGWAS-2271",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_NONFOLLICULAR_LYMPHOMA_EXALLC",
    "phenotype": "Non-follicular lymphoma (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-follicular lymphoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_NONFOLLICULAR_LYMPHOMA_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2272",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CD2_NONHODGKIN_NAS",
    "phenotype": "Other and unspecified types of non-Hodgkin lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-Hodgkin lymphoma NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CD2_NONHODGKIN_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2279",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHILDHOOD_ALLERGY",
    "phenotype": "Childhood allergy (age < 16)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood allergy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHILDHOOD_ALLERGY.gz"
  },
  {
    "accessionId": "DGWAS-228",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CD2_LEIOMYOMA_ENDOMETRIOSIS_EXALLC",
    "phenotype": "Benign leiomyoma with endometriosis (controls excluding all cancers)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign leiomyoma with endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CD2_LEIOMYOMA_ENDOMETRIOSIS_EXALLC.gz"
  },
  {
    "accessionId": "DGWAS-2280",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHIRBIL_PRIM",
    "phenotype": "Primary biliary cholangitis (PBC)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary biliary cholangitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHIRBIL_PRIM.gz"
  },
  {
    "accessionId": "DGWAS-2281",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHIRHEP_NAS",
    "phenotype": "Cirrhosis of liver, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cirrhosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHIRHEP_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2282",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHONDRO_OTH",
    "phenotype": "Other chondrocalcinosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondrocalcinosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHONDRO_OTH.gz"
  },
  {
    "accessionId": "DGWAS-2283",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHRONHEP_NAS",
    "phenotype": "Chronic hepatitis NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic hepatitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHRONHEP_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2284",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHRONLARGE",
    "phenotype": "Crohn's disease of large intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (large intestine)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHRONLARGE.gz"
  },
  {
    "accessionId": "DGWAS-2285",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHRONMYELOPRO",
    "phenotype": "Chronic myeloproliferative disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic myeloproliferative disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHRONMYELOPRO.gz"
  },
  {
    "accessionId": "DGWAS-2288",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHRONSMALL",
    "phenotype": "Crohn's disease of small intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (small intestine)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHRONSMALL.gz"
  },
  {
    "accessionId": "DGWAS-2289",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CHRYSTAL_NOS",
    "phenotype": "Other/unspecified crystal arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crystal arthropathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CHRYSTAL_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2290",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CIRRHOSIS_BROAD",
    "phenotype": "Cirrhosis, broad definition used in the article https://doi.org/10.1101/594523",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cirrhosis (broad)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CIRRHOSIS_BROAD.gz"
  },
  {
    "accessionId": "DGWAS-2293",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CONGEN_HEART_ARTER",
    "phenotype": "Congenital malformations of heart and great arteries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital heart malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CONGEN_HEART_ARTER.gz"
  },
  {
    "accessionId": "DGWAS-2294",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_COPD_EARLY",
    "phenotype": "Early onset COPD",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early onset COPD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_COPD_EARLY.gz"
  },
  {
    "accessionId": "DGWAS-2295",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_COPD_INSUFFICIENCY",
    "phenotype": "COPD-related respiratory insufficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD-related respiratory insufficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_COPD_INSUFFICIENCY.gz"
  },
  {
    "accessionId": "DGWAS-2296",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_COPD_LATER",
    "phenotype": "Later onset COPD",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Late onset COPD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_COPD_LATER.gz"
  },
  {
    "accessionId": "DGWAS-2297",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_COPD_OPPORTUNIST_INFECTIONS",
    "phenotype": "COPD related to chronic (opportunist) infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD with chronic infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_COPD_OPPORTUNIST_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-2299",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CREST",
    "phenotype": "CR(E)ST syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CREST syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CREST.gz"
  },
  {
    "accessionId": "DGWAS-23",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HERNIA",
    "phenotype": "Hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HERNIA.gz"
  },
  {
    "accessionId": "DGWAS-2300",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_CROHN_ARTHR",
    "phenotype": "Arthropathy in Crohn disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_CROHN_ARTHR.gz"
  },
  {
    "accessionId": "DGWAS-2301",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_C_DIFFICILE_ENTEROCOLITIS",
    "phenotype": "Enterocolitis due to Clostridium difficile",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "C. diff colitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_C_DIFFICILE_ENTEROCOLITIS.gz"
  },
  {
    "accessionId": "DGWAS-2303",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ACQHAEMOLYTICANAEMIA",
    "phenotype": "Acquired haemolytic anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired hemolytic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ACQHAEMOLYTICANAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-2305",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ACQPUREREDCLLAPLASIA",
    "phenotype": "Acquired pure red cell aplasia [erythroblastopenia]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pure red cell aplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ACQPUREREDCLLAPLASIA.gz"
  },
  {
    "accessionId": "DGWAS-2308",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_AIHA_OTHER",
    "phenotype": "Other autoimmune haemolytic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune hemolytic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_AIHA_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-231",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMA_OTHER_WIDE",
    "phenotype": "Other (seronegative) rheumatoid arthritis, wide",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seronegative rheumatoid arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMA_OTHER_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-2310",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ANAEMIA",
    "phenotype": "Anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ANAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-2312",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ANAEMIANAS",
    "phenotype": "Other and unspecified anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ANAEMIANAS.gz"
  },
  {
    "accessionId": "DGWAS-2313",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ANAEMIA_B12_DEF",
    "phenotype": "Vitamin B12 deficiency anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitamin B12 deficiency anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ANAEMIA_B12_DEF.gz"
  },
  {
    "accessionId": "DGWAS-2316",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ANAEMIA_IRONDEF_BLOODLOSS",
    "phenotype": "Iron deficiency anaemia secondary to blood loss (chronic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency anemia (chronic blood loss)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ANAEMIA_IRONDEF_BLOODLOSS.gz"
  },
  {
    "accessionId": "DGWAS-2317",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_ANAEMIA_IRONDEF_NAS",
    "phenotype": "Other and unspecified iron deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_ANAEMIA_IRONDEF_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2319",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_BLOODOTHER",
    "phenotype": "Other diseases of blood and blood-forming organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_BLOODOTHER.gz"
  },
  {
    "accessionId": "DGWAS-232",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO",
    "phenotype": "Other congenital malformations",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital malformation NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO.gz"
  },
  {
    "accessionId": "DGWAS-2321",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_COAGDEFNAS",
    "phenotype": "Other and unspecified coagulation defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coagulation defect NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_COAGDEFNAS.gz"
  },
  {
    "accessionId": "DGWAS-2322",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_COAGDEF_PURPUR_HAEMORRHAGIC",
    "phenotype": "Coagulation defects, purpura and other haemorrhagic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coagulation/hemorrhagic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_COAGDEF_PURPUR_HAEMORRHAGIC.gz"
  },
  {
    "accessionId": "DGWAS-2323",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_COAGOTHER",
    "phenotype": "Other coagulation defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coagulation defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_COAGOTHER.gz"
  },
  {
    "accessionId": "DGWAS-2324",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_COMBIMMUDEF",
    "phenotype": "Combined immunodeficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Combined immunodeficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_COMBIMMUDEF.gz"
  },
  {
    "accessionId": "DGWAS-2328",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_DEF_IGG",
    "phenotype": "Selective deficiency of immunoglobulin G [IgG] subclasses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IgG subclass deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_DEF_IGG.gz"
  },
  {
    "accessionId": "DGWAS-2329",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_DEF_IIGA",
    "phenotype": "Selective deficiency of immunoglobulin A [IgA]y",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IgA deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_DEF_IIGA.gz"
  },
  {
    "accessionId": "DGWAS-233",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_NEPHROTICSYND",
    "phenotype": "Nephrotic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nephrotic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_NEPHROTICSYND.gz"
  },
  {
    "accessionId": "DGWAS-2331",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_FAMIERYTHROCYTOCIS",
    "phenotype": "Familial erythrocytosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial erythrocytosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_FAMIERYTHROCYTOCIS.gz"
  },
  {
    "accessionId": "DGWAS-2332",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_HAEMOLYTICANAEMIA",
    "phenotype": "Haemolytic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemolytic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_HAEMOLYTICANAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-2335",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_HEREDHAEMOLYTICANAEMIAOTHER",
    "phenotype": "Other hereditary haemolytic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary hemolytic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_HEREDHAEMOLYTICANAEMIAOTHER.gz"
  },
  {
    "accessionId": "DGWAS-2337",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_HEREDOTHCLOFACTORS",
    "phenotype": "Hereditary deficiency of other clotting factors",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary clotting factor deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_HEREDOTHCLOFACTORS.gz"
  },
  {
    "accessionId": "DGWAS-234",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMALEGENNONINF",
    "phenotype": "Noninflammatory disorders of female genital tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninflammatory female genital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMALEGENNONINF.gz"
  },
  {
    "accessionId": "DGWAS-2343",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_IMMUDEFOTHER",
    "phenotype": "Other immunodeficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other immunodeficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_IMMUDEFOTHER.gz"
  },
  {
    "accessionId": "DGWAS-2344",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_IMMUNEMECHANISM",
    "phenotype": "Certain disorders involving the immune mechanism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immune disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_IMMUNEMECHANISM.gz"
  },
  {
    "accessionId": "DGWAS-2349",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_NONHEREDHYPOGAMMA",
    "phenotype": "Nonhereditary hypogammaglobulinemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonhereditary hypogammaglobulinemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_NONHEREDHYPOGAMMA.gz"
  },
  {
    "accessionId": "DGWAS-235",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_OTHDIG",
    "phenotype": "Other diseases of the digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Digestive system disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_OTHDIG.gz"
  },
  {
    "accessionId": "DGWAS-236",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_IPF",
    "phenotype": "Idiopathic pulmonary fibrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic pulmonary fibrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_IPF.gz"
  },
  {
    "accessionId": "DGWAS-2362",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_SCNDTHROMBOCYTOPENIA",
    "phenotype": "Secondary thrombocytopenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary thrombocytopenia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_SCNDTHROMBOCYTOPENIA.gz"
  },
  {
    "accessionId": "DGWAS-2363",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_SIDEROANAEMIAHERED",
    "phenotype": "Hereditary sideroblastic anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary sideroblastic anemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_SIDEROANAEMIAHERED.gz"
  },
  {
    "accessionId": "DGWAS-2368",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_D3_VONVILLEBRAND",
    "phenotype": "Von Willebrand disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Von Willebrand disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_D3_VONVILLEBRAND.gz"
  },
  {
    "accessionId": "DGWAS-237",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_NERPLEX",
    "phenotype": "Nerve, nerve root and plexus disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nerve root/plexus disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_NERPLEX.gz"
  },
  {
    "accessionId": "DGWAS-2370",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DEATH",
    "phenotype": "Any death",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Death (any cause)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DEATH.gz"
  },
  {
    "accessionId": "DGWAS-2373",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DERMATOPOLY_FG",
    "phenotype": "Dermatopolymyositis (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatopolymyositis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DERMATOPOLY_FG.gz"
  },
  {
    "accessionId": "DGWAS-2374",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_AUTONOMIC",
    "phenotype": "Diabetic autonomic neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic autonomic neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_AUTONOMIC.gz"
  },
  {
    "accessionId": "DGWAS-2375",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_HYPOGLYC",
    "phenotype": "Diabetic hypoglycemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic hypoglycemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_HYPOGLYC.gz"
  },
  {
    "accessionId": "DGWAS-2376",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_KETOACIDOSIS",
    "phenotype": "Diabetic ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DKA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_KETOACIDOSIS.gz"
  },
  {
    "accessionId": "DGWAS-2377",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_MACULOPATHY_EXMORE",
    "phenotype": "Diabetic maculopathy (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic maculopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_MACULOPATHY_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-2378",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_MONONEURO",
    "phenotype": "Diabetic mononeuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic mononeuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_MONONEURO.gz"
  },
  {
    "accessionId": "DGWAS-2379",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_NEOVASCULAR_GLAUCOMA",
    "phenotype": "Neovascular glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neovascular glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_NEOVASCULAR_GLAUCOMA.gz"
  },
  {
    "accessionId": "DGWAS-238",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_GOITRENAS",
    "phenotype": "Other and/or unspecified nontoxic goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic goiter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_GOITRENAS.gz"
  },
  {
    "accessionId": "DGWAS-2380",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_NEPHROPATHY_EXMORE",
    "phenotype": "Diabetic nephropathy (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic nephropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_NEPHROPATHY_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-2381",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_NEUROPATHY",
    "phenotype": "Diabetic neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_NEUROPATHY.gz"
  },
  {
    "accessionId": "DGWAS-2382",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_PERIPH_ANGIOPATHY",
    "phenotype": "Peripheral angiopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral angiopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_PERIPH_ANGIOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-2383",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_POLYNEURO",
    "phenotype": "Diabetic polyneuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic polyneuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_POLYNEURO.gz"
  },
  {
    "accessionId": "DGWAS-2384",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RETINA_NOS",
    "phenotype": "Unspecified diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RETINA_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2385",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RETINA_PROLIF",
    "phenotype": "Proliferative diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Proliferative diabetic retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RETINA_PROLIF.gz"
  },
  {
    "accessionId": "DGWAS-2386",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RETINOPATHY_EXMORE",
    "phenotype": "Diabetic retinopathy (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RETINOPATHY_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-2387",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RET_ART_OCCLU_BRANCH",
    "phenotype": "Retinal artery occlusion (branch)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Branch retinal artery occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RET_ART_OCCLU_BRANCH.gz"
  },
  {
    "accessionId": "DGWAS-2388",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RET_ART_OCCLU_MAIN",
    "phenotype": "Retinal artery occlusion (main artery)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central retinal artery occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RET_ART_OCCLU_MAIN.gz"
  },
  {
    "accessionId": "DGWAS-2389",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_RET_VEIN_OCCLU",
    "phenotype": "Retinal vein occlusion (central or branch)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal vein occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_RET_VEIN_OCCLU.gz"
  },
  {
    "accessionId": "DGWAS-2390",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_SEVERAL_COMPLICATIONS",
    "phenotype": "Diabetes, several complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes with multiple complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_SEVERAL_COMPLICATIONS.gz"
  },
  {
    "accessionId": "DGWAS-2391",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DM_VITREOUS_BLEEDING",
    "phenotype": "Vitreous bleeding (caused by prolif. dmrp when together with H36.03*)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous hemorrhage (diabetic)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DM_VITREOUS_BLEEDING.gz"
  },
  {
    "accessionId": "DGWAS-2396",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DRUGADVERS_HEADA_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Drug-induced headache, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced headache",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DRUGADVERS_HEADA_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-2397",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DRUGADVERS_NEUTROPENIA",
    "phenotype": "Drug-induced neutropenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced neutropenia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DRUGADVERS_NEUTROPENIA.gz"
  },
  {
    "accessionId": "DGWAS-2399",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_DRUGADVERS_SYSTEMIC_LUPUS_ERYTHEMAT",
    "phenotype": "Drug-induced systemic lupus erythematosus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced SLE",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_DRUGADVERS_SYSTEMIC_LUPUS_ERYTHEMAT.gz"
  },
  {
    "accessionId": "DGWAS-24",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ARTHROSIS_INCLAVO",
    "phenotype": "Artrosis, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ARTHROSIS_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-2405",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ADDISON",
    "phenotype": "Adrenocortical insufficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenal insufficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ADDISON.gz"
  },
  {
    "accessionId": "DGWAS-2408",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ADRENAS",
    "phenotype": "Disorders of adrenal gland, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ADRENAS.gz"
  },
  {
    "accessionId": "DGWAS-2409",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ADRENOGEN",
    "phenotype": "Adrenogenital disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenogenital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ADRENOGEN.gz"
  },
  {
    "accessionId": "DGWAS-2410",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_AMINO",
    "phenotype": "Other disorders of amino-acid metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amino acid metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_AMINO.gz"
  },
  {
    "accessionId": "DGWAS-2413",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ANTIDIU",
    "phenotype": "Syndrome of inappropriate secretion of antidiuretic hormone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SIADH",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ANTIDIU.gz"
  },
  {
    "accessionId": "DGWAS-2415",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_CARBO",
    "phenotype": "Other disorders of carbohydrate metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carbohydrate metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_CARBO.gz"
  },
  {
    "accessionId": "DGWAS-2417",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_CARCISDR",
    "phenotype": "Carcinoid syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carcinoid syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_CARCISDR.gz"
  },
  {
    "accessionId": "DGWAS-2418",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_CONGEIOD",
    "phenotype": "Congenital iodine-deficiency syndrome/hypothyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital hypothyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_CONGEIOD.gz"
  },
  {
    "accessionId": "DGWAS-2419",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_CUSHING",
    "phenotype": "Cushing syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cushing syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_CUSHING.gz"
  },
  {
    "accessionId": "DGWAS-2420",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DELPUB",
    "phenotype": "Delayed puberty",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Delayed puberty",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DELPUB.gz"
  },
  {
    "accessionId": "DGWAS-2421",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DIABINSIPIDUS",
    "phenotype": "Diabetes insipidus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes insipidus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DIABINSIPIDUS.gz"
  },
  {
    "accessionId": "DGWAS-2423",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1COMA",
    "phenotype": "Type 1 diabetes with coma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with coma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1COMA.gz"
  },
  {
    "accessionId": "DGWAS-2424",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1KETO",
    "phenotype": "Type 1 diabetes with ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with DKA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1KETO.gz"
  },
  {
    "accessionId": "DGWAS-2425",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1NASCOMP",
    "phenotype": "Type 1 diabetes with other specified/multiple/unspecified complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1NASCOMP.gz"
  },
  {
    "accessionId": "DGWAS-2426",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1NEU",
    "phenotype": "Type 1 diabetes with neurological complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with neurological complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1NEU.gz"
  },
  {
    "accessionId": "DGWAS-2427",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1OPTH",
    "phenotype": "Type 1 diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with ophthalmic complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1OPTH.gz"
  },
  {
    "accessionId": "DGWAS-2428",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1PERIPH",
    "phenotype": "Type 1 diabetes with peripheral circulatory complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with peripheral circulatory complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1PERIPH.gz"
  },
  {
    "accessionId": "DGWAS-2429",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM1REN",
    "phenotype": "Type 1 diabetes with renal complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with renal complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM1REN.gz"
  },
  {
    "accessionId": "DGWAS-2430",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2COMA",
    "phenotype": "Type 2 diabetes with coma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with coma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2COMA.gz"
  },
  {
    "accessionId": "DGWAS-2431",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2KETO",
    "phenotype": "Type 2 diabetes with ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with ketoacidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2KETO.gz"
  },
  {
    "accessionId": "DGWAS-2432",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2NASCOMP",
    "phenotype": "Type 2 diabetes with other specified/multiple/unspecified complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2NASCOMP.gz"
  },
  {
    "accessionId": "DGWAS-2433",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2NEU",
    "phenotype": "Type 2 diabetes with neurological complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with neurological complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2NEU.gz"
  },
  {
    "accessionId": "DGWAS-2434",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2OPTH",
    "phenotype": "Type 2 diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with ophthalmic complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2OPTH.gz"
  },
  {
    "accessionId": "DGWAS-2435",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2PERIPH",
    "phenotype": "Type 2 diabetes with peripheral circulatory complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with peripheral circulatory complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2PERIPH.gz"
  },
  {
    "accessionId": "DGWAS-2436",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DM2REN",
    "phenotype": "Type 2 diabetes with renal complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with renal complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DM2REN.gz"
  },
  {
    "accessionId": "DGWAS-2437",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNAS",
    "phenotype": "Unspecified diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes mellitus NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNAS.gz"
  },
  {
    "accessionId": "DGWAS-2438",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASCOMA",
    "phenotype": "Unspecified diabetes with coma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with coma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASCOMA.gz"
  },
  {
    "accessionId": "DGWAS-2439",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASKETO",
    "phenotype": "Unspecified diabetes with ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with ketoacidosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASKETO.gz"
  },
  {
    "accessionId": "DGWAS-244",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMA_NOS",
    "phenotype": "Other/unspecified rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatoid arthritis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMA_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2440",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASNASCOMP",
    "phenotype": "Unspecified diabetes with multiple/unspecified complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASNASCOMP.gz"
  },
  {
    "accessionId": "DGWAS-2441",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASNEU",
    "phenotype": "Unspecified diabetes with neurological complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with neurological complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASNEU.gz"
  },
  {
    "accessionId": "DGWAS-2442",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASNOCOMP",
    "phenotype": "Unspecified diabetes without complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS without complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASNOCOMP.gz"
  },
  {
    "accessionId": "DGWAS-2443",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASOPTH",
    "phenotype": "Unspecified diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with ophthalmic complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASOPTH.gz"
  },
  {
    "accessionId": "DGWAS-2444",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_DMNASOTHCOMP",
    "phenotype": "Unspecified diabetes with other specified complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with other complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_DMNASOTHCOMP.gz"
  },
  {
    "accessionId": "DGWAS-2447",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ENDOGLAND",
    "phenotype": "Disorders of other endocrine glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other endocrine gland disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ENDOGLAND.gz"
  },
  {
    "accessionId": "DGWAS-2448",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_ENDOMETPOSTOP",
    "phenotype": "Postprocedural endocrine and metabolic disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural endocrine/metabolic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_ENDOMETPOSTOP.gz"
  },
  {
    "accessionId": "DGWAS-245",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_SKIN",
    "phenotype": "Other congenital malformations of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital skin malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_SKIN.gz"
  },
  {
    "accessionId": "DGWAS-2451",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_FH_IHD",
    "phenotype": "Familial hypercholesterolemia, with ischemic heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial hypercholesterolemia with IHD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_FH_IHD.gz"
  },
  {
    "accessionId": "DGWAS-2452",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_FLUIDELECTRO",
    "phenotype": "Other disorders of fluid, electrolyte and acid-base balance",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fluid/electrolyte/acid-base disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_FLUIDELECTRO.gz"
  },
  {
    "accessionId": "DGWAS-2454",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GILBERT",
    "phenotype": "Gilbert syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gilbert syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GILBERT.gz"
  },
  {
    "accessionId": "DGWAS-2455",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GLUCOPANCREAS",
    "phenotype": "Other disorders of glucose regulation and pancreatic internal secretion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glucose regulation disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GLUCOPANCREAS.gz"
  },
  {
    "accessionId": "DGWAS-2456",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GOITREDIFF",
    "phenotype": "Nontoxic diffuse goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic diffuse goiter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GOITREDIFF.gz"
  },
  {
    "accessionId": "DGWAS-2457",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GOITREMULTINOD",
    "phenotype": "Nontoxic multinodular goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic multinodular goiter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GOITREMULTINOD.gz"
  },
  {
    "accessionId": "DGWAS-2459",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GOITRENOD",
    "phenotype": "Nontoxic single thyroid nodule",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic single thyroid nodule",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GOITRENOD.gz"
  },
  {
    "accessionId": "DGWAS-246",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OSTEOCHONDROD_W_DEFECTS_GROWTH_TUBULAR_BONES_SPINE",
    "phenotype": "Osteochondrodysplasia with defects of growth of tubular bones and spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteochondrodysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OSTEOCHONDROD_W_DEFECTS_GROWTH_TUBULAR_BONES_SPINE.gz"
  },
  {
    "accessionId": "DGWAS-2460",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_GRAVES_OPHT_STRICT",
    "phenotype": "Graves ophthalmopathy, strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Graves ophthalmopathy (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_GRAVES_OPHT_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-2462",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPERALDO",
    "phenotype": "Hyperaldosteronism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperaldosteronism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPERALDO.gz"
  },
  {
    "accessionId": "DGWAS-2463",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPERCHOL",
    "phenotype": "Pure hypercholesterolaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pure hypercholesterolemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPERCHOL.gz"
  },
  {
    "accessionId": "DGWAS-2465",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPERKALAEMIA",
    "phenotype": "Hyperkalaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperkalemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPERKALAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-2466",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPERLIPMIX",
    "phenotype": "Mixed hyperlipidaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed hyperlipidemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPERLIPMIX.gz"
  },
  {
    "accessionId": "DGWAS-2468",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPEROSMHNAT",
    "phenotype": "Hyperosmolality and hypernatraemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperosmolality/hypernatremia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPEROSMHNAT.gz"
  },
  {
    "accessionId": "DGWAS-2469",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPERPARA",
    "phenotype": "Hyperparathyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperparathyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPERPARA.gz"
  },
  {
    "accessionId": "DGWAS-247",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SCIATICA",
    "phenotype": "Sciatica+with lumbago",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sciatica with lumbago",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SCIATICA.gz"
  },
  {
    "accessionId": "DGWAS-2474",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPOCOMA",
    "phenotype": "Nondiabetic hypoglycaemic coma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nondiabetic hypoglycemic coma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPOCOMA.gz"
  },
  {
    "accessionId": "DGWAS-2475",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPODRUG",
    "phenotype": "Drug-induced hypoglycaemia without coma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced hypoglycemia without coma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPODRUG.gz"
  },
  {
    "accessionId": "DGWAS-2477",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPOOSMNAT",
    "phenotype": "Hypo-osmolality and hyponatraemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypo-osmolality/hyponatremia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPOOSMNAT.gz"
  },
  {
    "accessionId": "DGWAS-2478",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPOPARA",
    "phenotype": "Hypoparathyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypoparathyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPOPARA.gz"
  },
  {
    "accessionId": "DGWAS-2479",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYPOPIT",
    "phenotype": "Hypopituitarism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypopituitarism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYPOPIT.gz"
  },
  {
    "accessionId": "DGWAS-248",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_VENTHER",
    "phenotype": "Ventral hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ventral hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_VENTHER.gz"
  },
  {
    "accessionId": "DGWAS-2481",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_HYTHYSUBS",
    "phenotype": "Hypothyroidism due to medicaments and other exogenous substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced hypothyroidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_HYTHYSUBS.gz"
  },
  {
    "accessionId": "DGWAS-2485",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_LACTONAS",
    "phenotype": "Lactose intolerance, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lactose intolerance NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_LACTONAS.gz"
  },
  {
    "accessionId": "DGWAS-2486",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_LIPOPROT",
    "phenotype": "Disorders of lipoprotein metabolism and other lipidaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipoprotein metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_LIPOPROT.gz"
  },
  {
    "accessionId": "DGWAS-2487",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_LIPOPROTNAS",
    "phenotype": "Disorder of lipoprotein metabolism, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipoprotein disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_LIPOPROTNAS.gz"
  },
  {
    "accessionId": "DGWAS-249",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HYPO_ONLY",
    "phenotype": "Tooth agenesis EXCLUDE clefts and syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth agenesis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HYPO_ONLY.gz"
  },
  {
    "accessionId": "DGWAS-2490",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_METABOLIA",
    "phenotype": "Metabolic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metabolic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_METABOLIA.gz"
  },
  {
    "accessionId": "DGWAS-2492",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_MINERAL_MET",
    "phenotype": "Disorders of mineral metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mineral metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_MINERAL_MET.gz"
  },
  {
    "accessionId": "DGWAS-2493",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_NONTOXIC_THYROID",
    "phenotype": "Nontoxic goitre/thyroid nodule",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic goiter/thyroid nodule",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_NONTOXIC_THYROID.gz"
  },
  {
    "accessionId": "DGWAS-2495",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_OBESITY",
    "phenotype": "Obesity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_OBESITY.gz"
  },
  {
    "accessionId": "DGWAS-2499",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_OBESITYXTRMALV",
    "phenotype": "Extreme obesity with alveolar hypoventilation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity hypoventilation syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_OBESITYXTRMALV.gz"
  },
  {
    "accessionId": "DGWAS-25",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_KELAIBD",
    "phenotype": "IBD patients in KELA-register",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IBD (KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_KELAIBD.gz"
  },
  {
    "accessionId": "DGWAS-250",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CD_STRICT2",
    "phenotype": "Crohn disease (strict definition, require KELA, min 2 HDR)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CD_STRICT2.gz"
  },
  {
    "accessionId": "DGWAS-2500",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_OVARDYS",
    "phenotype": "Ovarian dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_OVARDYS.gz"
  },
  {
    "accessionId": "DGWAS-2501",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_OVARDYSNAS",
    "phenotype": "Ovarian dysfunction, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian dysfunction NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_OVARDYSNAS.gz"
  },
  {
    "accessionId": "DGWAS-2502",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_OVARFAIL",
    "phenotype": "Primary ovarian failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary ovarian insufficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_OVARFAIL.gz"
  },
  {
    "accessionId": "DGWAS-2506",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PCOS",
    "phenotype": "Polycystic ovarian syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PCOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PCOS.gz"
  },
  {
    "accessionId": "DGWAS-2507",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PCOS_BROAD",
    "phenotype": "Polycystic ovarian syndrome, broad definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PCOS (broad)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PCOS_BROAD.gz"
  },
  {
    "accessionId": "DGWAS-2508",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PCOS_CONCORTIUM",
    "phenotype": "Polycystic ovarian syndrome, consortium definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PCOS (consortium)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PCOS_CONCORTIUM.gz"
  },
  {
    "accessionId": "DGWAS-251",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ACUTPANC",
    "phenotype": "Acute pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pancreatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ACUTPANC.gz"
  },
  {
    "accessionId": "DGWAS-2510",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PITUDISNAS",
    "phenotype": "Disorders of pituitary gland, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pituitary disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PITUDISNAS.gz"
  },
  {
    "accessionId": "DGWAS-2511",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PLASMAPROT",
    "phenotype": "Disorders of plasma-protein metabolism, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Plasma protein metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PLASMAPROT.gz"
  },
  {
    "accessionId": "DGWAS-2512",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PORBILIR",
    "phenotype": "Disorders of porphyrin and bilirubin metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Porphyrin/bilirubin metabolism disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PORBILIR.gz"
  },
  {
    "accessionId": "DGWAS-2513",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PRECOXCENTPUB",
    "phenotype": "Precocious central puberty",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central precocious puberty",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PRECOXCENTPUB.gz"
  },
  {
    "accessionId": "DGWAS-2516",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_PROTMALNAS",
    "phenotype": "Unspecified protein-energy malnutrition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Protein-energy malnutrition NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_PROTMALNAS.gz"
  },
  {
    "accessionId": "DGWAS-2518",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_SHORT",
    "phenotype": "Short stature, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Short stature",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_SHORT.gz"
  },
  {
    "accessionId": "DGWAS-2519",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_SPHINGOLIP",
    "phenotype": "Disorders of sphingolipid metabolism and other lipid storage disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sphingolipidosis/lipid storage disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_SPHINGOLIP.gz"
  },
  {
    "accessionId": "DGWAS-252",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_VHD",
    "phenotype": "Valvular heart disease excluding rheumatic fever",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Valvular heart disease (non-rheumatic)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_VHD.gz"
  },
  {
    "accessionId": "DGWAS-2520",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_TALL",
    "phenotype": "Constitutional tall stature",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Constitutional tall stature",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_TALL.gz"
  },
  {
    "accessionId": "DGWAS-2524",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROID",
    "phenotype": "Disorders of the thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROID.gz"
  },
  {
    "accessionId": "DGWAS-2526",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROIDITAUTOIM",
    "phenotype": "Autoimmune thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROIDITAUTOIM.gz"
  },
  {
    "accessionId": "DGWAS-2527",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROIDITCHRON",
    "phenotype": "Chronic thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROIDITCHRON.gz"
  },
  {
    "accessionId": "DGWAS-2528",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROIDITNAS",
    "phenotype": "Thyroiditis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroiditis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROIDITNAS.gz"
  },
  {
    "accessionId": "DGWAS-2529",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROIDITSUBAC",
    "phenotype": "Subacute thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subacute thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROIDITSUBAC.gz"
  },
  {
    "accessionId": "DGWAS-253",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_HEARTFAIL_ALLCAUSE",
    "phenotype": "All-cause Heart Failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (all-cause)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_HEARTFAIL_ALLCAUSE.gz"
  },
  {
    "accessionId": "DGWAS-2530",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYROIDNASOTH",
    "phenotype": "Disorder of thyroid, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYROIDNASOTH.gz"
  },
  {
    "accessionId": "DGWAS-2532",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYTOXGOITDIF",
    "phenotype": "Thyrotoxicosis with diffuse goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis with diffuse goiter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYTOXGOITDIF.gz"
  },
  {
    "accessionId": "DGWAS-2534",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_THYTOXNOD",
    "phenotype": "Thyrotoxicosis with toxic single thyroid nodule",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic single thyroid nodule",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_THYTOXNOD.gz"
  },
  {
    "accessionId": "DGWAS-2536",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_VIT_B_DEF",
    "phenotype": "Deficiency of other B group vitamins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "B vitamin deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_VIT_B_DEF.gz"
  },
  {
    "accessionId": "DGWAS-2537",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_E4_VIT_D_DEF",
    "phenotype": "Vitamin D deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitamin D deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_E4_VIT_D_DEF.gz"
  },
  {
    "accessionId": "DGWAS-254",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_MYOPOTHUNS",
    "phenotype": "Other and unspecified myopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_MYOPOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2541",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ERECTILE_DYSFUNCTION",
    "phenotype": "Erectile dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erectile dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ERECTILE_DYSFUNCTION.gz"
  },
  {
    "accessionId": "DGWAS-2542",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ESOSINOPHIL_DISEASE",
    "phenotype": "Eosinophilic disease (BM)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eosinophilic disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ESOSINOPHIL_DISEASE.gz"
  },
  {
    "accessionId": "DGWAS-2546",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ALCOHOL_DEPENDENCE",
    "phenotype": "Alcohol dependence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol dependence",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ALCOHOL_DEPENDENCE.gz"
  },
  {
    "accessionId": "DGWAS-2547",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ALLANXIOUS",
    "phenotype": "All anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ALLANXIOUS.gz"
  },
  {
    "accessionId": "DGWAS-2548",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ALZHDEMENT",
    "phenotype": "Dementia in Alzheimer disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ALZHDEMENT.gz"
  },
  {
    "accessionId": "DGWAS-2550",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ANOREX",
    "phenotype": "Anorexia (incl.atypical)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorexia nervosa (incl atypical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ANOREX.gz"
  },
  {
    "accessionId": "DGWAS-2551",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ANXIETY",
    "phenotype": "Other anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ANXIETY.gz"
  },
  {
    "accessionId": "DGWAS-2552",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_ANXPER",
    "phenotype": "Anxious personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxious personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_ANXPER.gz"
  },
  {
    "accessionId": "DGWAS-2553",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_BEHAVE",
    "phenotype": "Behavioural syndromes associated with physiological disturbances and physical factors",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_BEHAVE.gz"
  },
  {
    "accessionId": "DGWAS-2554",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_BEHEMOCHILD",
    "phenotype": "Behavioural and emotional disorders with onset usually occurring in childhood and adolescence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood emotional/behavioral disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_BEHEMOCHILD.gz"
  },
  {
    "accessionId": "DGWAS-2555",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_BIPO",
    "phenotype": "Bipolar affective disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_BIPO.gz"
  },
  {
    "accessionId": "DGWAS-2556",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_BULIMIA",
    "phenotype": "Bulimia nervosa (incl. atypical)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bulimia nervosa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_BULIMIA.gz"
  },
  {
    "accessionId": "DGWAS-2557",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_CANNABIS",
    "phenotype": "Mental and behavioural disorders due to cannabinoids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cannabinoid use disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_CANNABIS.gz"
  },
  {
    "accessionId": "DGWAS-2558",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DELIRIUM",
    "phenotype": "Delirium, not induced by alcohol and other psychoactive substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Delirium (non-substance)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DELIRIUM.gz"
  },
  {
    "accessionId": "DGWAS-2559",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DELUSIO",
    "phenotype": "Persistent delusional disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Delusional disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DELUSIO.gz"
  },
  {
    "accessionId": "DGWAS-2561",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DEMENTIA_INCLAVO",
    "phenotype": "Dementia, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DEMENTIA_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-2562",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DEMINOTH",
    "phenotype": "Dementia in other diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia in other diseases",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DEMINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2563",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DEMNAS",
    "phenotype": "Unspecified dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DEMNAS.gz"
  },
  {
    "accessionId": "DGWAS-2566",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DEPRESSION_DYSTHYMIA",
    "phenotype": "Depression or dysthymia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression/dysthymia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DEPRESSION_DYSTHYMIA.gz"
  },
  {
    "accessionId": "DGWAS-2568",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DEPRESSION_RECURRENT",
    "phenotype": "Recurrent or chronic depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent/chronic depression",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DEPRESSION_RECURRENT.gz"
  },
  {
    "accessionId": "DGWAS-2569",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DISPER",
    "phenotype": "Dissocial personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dissocial personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DISPER.gz"
  },
  {
    "accessionId": "DGWAS-2570",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_DISSOCIATIVE",
    "phenotype": "Dissociative [conversion] disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conversion disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_DISSOCIATIVE.gz"
  },
  {
    "accessionId": "DGWAS-2572",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_EMOCHILD",
    "phenotype": "Emotional disorders and disorders of social functioning with onset specific to childhood",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood emotional/social disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_EMOCHILD.gz"
  },
  {
    "accessionId": "DGWAS-2574",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_GAD",
    "phenotype": "Generalized anxiety disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GAD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_GAD.gz"
  },
  {
    "accessionId": "DGWAS-2577",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_HALLUCIN",
    "phenotype": "Mental and behavioural disorders due to hallucinogens",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallucinogen use disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_HALLUCIN.gz"
  },
  {
    "accessionId": "DGWAS-2578",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_HISPER",
    "phenotype": "Histrionic personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Histrionic personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_HISPER.gz"
  },
  {
    "accessionId": "DGWAS-2580",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_HYPERSOMNIA",
    "phenotype": "Hypersomnia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypersomnia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_HYPERSOMNIA.gz"
  },
  {
    "accessionId": "DGWAS-2581",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_INSOMNIA",
    "phenotype": "Insomnia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Insomnia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_INSOMNIA.gz"
  },
  {
    "accessionId": "DGWAS-2582",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_KELAMENT",
    "phenotype": "Kela-code for severe mental illness",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe mental illness (KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_KELAMENT.gz"
  },
  {
    "accessionId": "DGWAS-2585",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_MENTALUNSPE",
    "phenotype": "Mental disorders, not otherwise specified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mental disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_MENTALUNSPE.gz"
  },
  {
    "accessionId": "DGWAS-2586",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_MENTORG",
    "phenotype": "Other mental disorders due to brain damage and dysfunction and to physical disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Organic mental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_MENTORG.gz"
  },
  {
    "accessionId": "DGWAS-2587",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_MILDRET",
    "phenotype": "Mild mental retardation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mild intellectual disability",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_MILDRET.gz"
  },
  {
    "accessionId": "DGWAS-2589",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_MIXPER",
    "phenotype": "Mixed and other personality disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_MIXPER.gz"
  },
  {
    "accessionId": "DGWAS-259",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ULCERPROCT",
    "phenotype": "Ulcerative proctitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative proctitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ULCERPROCT.gz"
  },
  {
    "accessionId": "DGWAS-2590",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_MODRET",
    "phenotype": "Moderate mental retardation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Moderate intellectual disability",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_MODRET.gz"
  },
  {
    "accessionId": "DGWAS-2593",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_NEUROTICOTH",
    "phenotype": "Other neurotic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neurotic disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_NEUROTICOTH.gz"
  },
  {
    "accessionId": "DGWAS-2596",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_OTHERSUB",
    "phenotype": "Mental and behavioural disorders due to multiple drug use and use of multiple drugs and use of other psychoactive substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polysubstance use disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_OTHERSUB.gz"
  },
  {
    "accessionId": "DGWAS-2597",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_OTHPER",
    "phenotype": "Other specified and unspecified personality disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_OTHPER.gz"
  },
  {
    "accessionId": "DGWAS-2598",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_OTHRET",
    "phenotype": "Other and unspecified mental retardation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intellectual disability NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_OTHRET.gz"
  },
  {
    "accessionId": "DGWAS-26",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_IBD_STRICT",
    "phenotype": "Inflammatory bowel disease, strict (require KELA)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IBD (strict, KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_IBD_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-260",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_ULCEROTH",
    "phenotype": "Other ulcerative colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_ULCEROTH.gz"
  },
  {
    "accessionId": "DGWAS-2600",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PARAPER",
    "phenotype": "Paranoid personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paranoid personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PARAPER.gz"
  },
  {
    "accessionId": "DGWAS-2601",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PERSBEHORG",
    "phenotype": "Personality and behavioural disorders due to brain disease, damage and dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Organic personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PERSBEHORG.gz"
  },
  {
    "accessionId": "DGWAS-2602",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PERSMOOD",
    "phenotype": "Persistent mood disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Persistent mood disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PERSMOOD.gz"
  },
  {
    "accessionId": "DGWAS-2605",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PERVASIVE",
    "phenotype": "Pervasive developmental disorders excl. Autism + Asperger",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PDD (non-autism)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PERVASIVE.gz"
  },
  {
    "accessionId": "DGWAS-2607",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PHYSBEHOTH",
    "phenotype": "Unspecified behavioural syndromes associated with physiological disturbances and physical factors +Physiological and behavioural factors associated with disorders of diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral syndrome NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PHYSBEHOTH.gz"
  },
  {
    "accessionId": "DGWAS-2608",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PSYCHDEV",
    "phenotype": "Disorders of psychological development",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychological development disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PSYCHDEV.gz"
  },
  {
    "accessionId": "DGWAS-2609",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PSYCHDEVOTH",
    "phenotype": "Other and unspecified disorders of psychological development",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Development disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PSYCHDEVOTH.gz"
  },
  {
    "accessionId": "DGWAS-261",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_OTHNONINFUTER",
    "phenotype": "Other noninflammatory disorders of uterus, except cervix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninflammatory uterine disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_OTHNONINFUTER.gz"
  },
  {
    "accessionId": "DGWAS-2611",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PSYTRANS",
    "phenotype": "Acute and transient psychotic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute/transient psychotic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PSYTRANS.gz"
  },
  {
    "accessionId": "DGWAS-2612",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_PTSD",
    "phenotype": "Post-traumatic stress disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PTSD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_PTSD.gz"
  },
  {
    "accessionId": "DGWAS-2613",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SCHIZOAFF",
    "phenotype": "Schizoaffective disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizoaffective disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SCHIZOAFF.gz"
  },
  {
    "accessionId": "DGWAS-2615",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SCHIZPER",
    "phenotype": "Schizoid personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizoid personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SCHIZPER.gz"
  },
  {
    "accessionId": "DGWAS-2617",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SCHZPHR",
    "phenotype": "Schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SCHZPHR.gz"
  },
  {
    "accessionId": "DGWAS-2618",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SEDAHYP",
    "phenotype": "Mental and behavioural disorders due to sedatives or hypnotics",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sedative/hypnotic use disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SEDAHYP.gz"
  },
  {
    "accessionId": "DGWAS-262",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LOWBACKPAINORANDSCIATICA",
    "phenotype": "Lower back pain or/and sciatica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Low back pain/sciatica",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LOWBACKPAINORANDSCIATICA.gz"
  },
  {
    "accessionId": "DGWAS-2622",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SOCPHOB",
    "phenotype": "Social phobias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Social phobia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SOCPHOB.gz"
  },
  {
    "accessionId": "DGWAS-2624",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SPEECH",
    "phenotype": "Specific development disorders of speech and language",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Speech/language development disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SPEECH.gz"
  },
  {
    "accessionId": "DGWAS-2626",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_STRESSOTH",
    "phenotype": "Other reaction to severe stress, and adjustment disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adjustment disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_STRESSOTH.gz"
  },
  {
    "accessionId": "DGWAS-2627",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_SUBSNOALCO",
    "phenotype": "Substance use, excluding alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Substance use disorder (non-alcohol)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_SUBSNOALCO.gz"
  },
  {
    "accessionId": "DGWAS-2629",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_F5_VASCDEM",
    "phenotype": "Vascular dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_F5_VASCDEM.gz"
  },
  {
    "accessionId": "DGWAS-263",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_CERVICDISC",
    "phenotype": "Cervical disc disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical disc disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_CERVICDISC.gz"
  },
  {
    "accessionId": "DGWAS-2630",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FALLS",
    "phenotype": "Falls/tendency to fall",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Falls / tendency to fall",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FALLS.gz"
  },
  {
    "accessionId": "DGWAS-2632",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FELTY",
    "phenotype": "Felty syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Felty syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FELTY.gz"
  },
  {
    "accessionId": "DGWAS-2635",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FG_CARDMYO",
    "phenotype": "Cardiomyopathy (excluding other)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FG_CARDMYO.gz"
  },
  {
    "accessionId": "DGWAS-2636",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FG_CVD",
    "phenotype": "Cardiovascular diseases (excluding rheumatic etc)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiovascular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FG_CVD.gz"
  },
  {
    "accessionId": "DGWAS-2637",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FG_DOAAC",
    "phenotype": "Diseases of arteries, arterioles and capillaries (FINNGEN)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial/arteriolar/capillary disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FG_DOAAC.gz"
  },
  {
    "accessionId": "DGWAS-2638",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FG_OTHHEART",
    "phenotype": "Other heart diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FG_OTHHEART.gz"
  },
  {
    "accessionId": "DGWAS-264",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_DISORDSKINAPPENDIX",
    "phenotype": "Disorders of skin appendages",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin appendage disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_DISORDSKINAPPENDIX.gz"
  },
  {
    "accessionId": "DGWAS-2640",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_FTD",
    "phenotype": "Frontotemporal dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Frontotemporal dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_FTD.gz"
  },
  {
    "accessionId": "DGWAS-2641",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_AD_WIDE",
    "phenotype": "Alzheimer's disease, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_AD_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-2642",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ALCODEGEN",
    "phenotype": "Degeneration of the brain due to alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic brain degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ALCODEGEN.gz"
  },
  {
    "accessionId": "DGWAS-2644",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ALS",
    "phenotype": "Motor neuron disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Motor neuron disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ALS.gz"
  },
  {
    "accessionId": "DGWAS-2645",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ALZHEIMER",
    "phenotype": "Alzheimer's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ALZHEIMER.gz"
  },
  {
    "accessionId": "DGWAS-2647",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ATROPHCIRCUM",
    "phenotype": "Circumscribed brain atrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circumscribed brain atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ATROPHCIRCUM.gz"
  },
  {
    "accessionId": "DGWAS-2649",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_AUTONOM",
    "phenotype": "Autonomic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autonomic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_AUTONOM.gz"
  },
  {
    "accessionId": "DGWAS-265",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_INTESTOTH",
    "phenotype": "Other diseases of intestines",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_INTESTOTH.gz"
  },
  {
    "accessionId": "DGWAS-2651",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_BELLPA",
    "phenotype": "Bell's palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bell palsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_BELLPA.gz"
  },
  {
    "accessionId": "DGWAS-2652",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_BENINTRAHYP",
    "phenotype": "Benign intracranial hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign intracranial hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_BENINTRAHYP.gz"
  },
  {
    "accessionId": "DGWAS-2654",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_CARPTU",
    "phenotype": "Carpal tunnel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carpal tunnel syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_CARPTU.gz"
  },
  {
    "accessionId": "DGWAS-2656",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_CAUSALGIA",
    "phenotype": "Causalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Causalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_CAUSALGIA.gz"
  },
  {
    "accessionId": "DGWAS-2657",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_CERCYST",
    "phenotype": "Cerebral cysts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_CERCYST.gz"
  },
  {
    "accessionId": "DGWAS-2658",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_CERVROOT",
    "phenotype": "Cervical root disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical nerve root disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_CERVROOT.gz"
  },
  {
    "accessionId": "DGWAS-266",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_JUVEN_ARTHR",
    "phenotype": "Juvenile arthritis (FINNGEN)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Juvenile arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_JUVEN_ARTHR.gz"
  },
  {
    "accessionId": "DGWAS-2661",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_CNSABSC",
    "phenotype": "Intracranial and intraspinal abscess and granuloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracranial/intraspinal abscess/granuloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_CNSABSC.gz"
  },
  {
    "accessionId": "DGWAS-2665",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_DEGENOTH",
    "phenotype": "Other and unspecified degenerative diseases of nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nervous system degeneration NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_DEGENOTH.gz"
  },
  {
    "accessionId": "DGWAS-2669",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_DISSOTH",
    "phenotype": "Other acute disseminated demyelination",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute disseminated demyelination",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_DISSOTH.gz"
  },
  {
    "accessionId": "DGWAS-267",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_SINUSITIS",
    "phenotype": "Acute sinusitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute sinusitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_SINUSITIS.gz"
  },
  {
    "accessionId": "DGWAS-2670",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_DRUGPOLY",
    "phenotype": "Drug-induced polyneuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced polyneuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_DRUGPOLY.gz"
  },
  {
    "accessionId": "DGWAS-2671",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_DYSTON",
    "phenotype": "Dystonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dystonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_DYSTON.gz"
  },
  {
    "accessionId": "DGWAS-2675",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_EPLEPSY",
    "phenotype": "Epilepsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epilepsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_EPLEPSY.gz"
  },
  {
    "accessionId": "DGWAS-2676",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_FACOTH",
    "phenotype": "Other facial nerve disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial nerve disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_FACOTH.gz"
  },
  {
    "accessionId": "DGWAS-2677",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_FEMLAPOP",
    "phenotype": "Lesion of lateral popliteal nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lateral popliteal nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_FEMLAPOP.gz"
  },
  {
    "accessionId": "DGWAS-2678",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_FEMLE",
    "phenotype": "Lesion of femoral nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_FEMLE.gz"
  },
  {
    "accessionId": "DGWAS-2679",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_FEMMEPOP",
    "phenotype": "Lesion of medial popliteal nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Medial popliteal nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_FEMMEPOP.gz"
  },
  {
    "accessionId": "DGWAS-268",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_NONISCHCARDMYOP_STRICT",
    "phenotype": "Nonischemic cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonischemic cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_NONISCHCARDMYOP_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-2680",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_GUILBAR",
    "phenotype": "Guillain-Barre syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Guillain-Barre syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_GUILBAR.gz"
  },
  {
    "accessionId": "DGWAS-2682",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HCINOTH",
    "phenotype": "Hydrocephalus in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocephalus in other diseases",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HCINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2683",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HCNP",
    "phenotype": "Normal-pressure hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Normal pressure hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HCNP.gz"
  },
  {
    "accessionId": "DGWAS-2684",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HCOBSTR",
    "phenotype": "Obstructive hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstructive hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HCOBSTR.gz"
  },
  {
    "accessionId": "DGWAS-2686",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HEADACHE",
    "phenotype": "Other headache syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Headache syndrome NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HEADACHE.gz"
  },
  {
    "accessionId": "DGWAS-2687",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HEMIPLE",
    "phenotype": "Hemiplegia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemiplegia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HEMIPLE.gz"
  },
  {
    "accessionId": "DGWAS-2688",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HERATAXIA",
    "phenotype": "Hereditary ataxia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary ataxia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HERATAXIA.gz"
  },
  {
    "accessionId": "DGWAS-2689",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HEREMOSEN",
    "phenotype": "Hereditary motor and sensory neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary motor/sensory neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HEREMOSEN.gz"
  },
  {
    "accessionId": "DGWAS-269",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H7_EYELIDDIS",
    "phenotype": "Other disorders of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H7_EYELIDDIS.gz"
  },
  {
    "accessionId": "DGWAS-2690",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HERIPOTHUN",
    "phenotype": "Other and unspecified neuropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neuropathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HERIPOTHUN.gz"
  },
  {
    "accessionId": "DGWAS-2691",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HORNER",
    "phenotype": "Horner syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Horner syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HORNER.gz"
  },
  {
    "accessionId": "DGWAS-2692",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_HYDROCEPH",
    "phenotype": "Hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_HYDROCEPH.gz"
  },
  {
    "accessionId": "DGWAS-2693",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ICNEUROP",
    "phenotype": "Intercostal neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intercostal neuropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ICNEUROP.gz"
  },
  {
    "accessionId": "DGWAS-2695",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_LSPLEX",
    "phenotype": "Lumbosacral plexus disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lumbosacral plexus disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_LSPLEX.gz"
  },
  {
    "accessionId": "DGWAS-2696",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_LSROOT",
    "phenotype": "Lumbosacral root disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lumbosacral nerve root disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_LSROOT.gz"
  },
  {
    "accessionId": "DGWAS-2701",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MERALGIA",
    "phenotype": "Meralgia paraesthetica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meralgia paresthetica",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MERALGIA.gz"
  },
  {
    "accessionId": "DGWAS-2702",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MIGRAINE",
    "phenotype": "Migraine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MIGRAINE.gz"
  },
  {
    "accessionId": "DGWAS-2703",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MIGRAINE_NO_AURA",
    "phenotype": "Migraine without aura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine without aura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MIGRAINE_NO_AURA.gz"
  },
  {
    "accessionId": "DGWAS-2705",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MIGRAINE_NO_AURA_TRIPTAN",
    "phenotype": "Migraine without aura and triptan purchases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine without aura with triptan",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MIGRAINE_NO_AURA_TRIPTAN.gz"
  },
  {
    "accessionId": "DGWAS-2706",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MIGRAINE_WITH_AURA",
    "phenotype": "Migraine with aura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine with aura",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MIGRAINE_WITH_AURA.gz"
  },
  {
    "accessionId": "DGWAS-2712",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MONOOTHUNS",
    "phenotype": "Other and unspecified mononeuropathies, also in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mononeuropathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MONOOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2716",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MUSDYST",
    "phenotype": "Muscular dystrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscular dystrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MUSDYST.gz"
  },
  {
    "accessionId": "DGWAS-2717",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MYASTHENIA",
    "phenotype": "Myasthenia gravis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myasthenia gravis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MYASTHENIA.gz"
  },
  {
    "accessionId": "DGWAS-2718",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MYOMUSCINOTH",
    "phenotype": "Disorders of myoneural junction and muscle in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary myoneural/muscle disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MYOMUSCINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2719",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MYONEU",
    "phenotype": "Diseases of the myoneural junction and muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myoneural/muscle disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MYONEU.gz"
  },
  {
    "accessionId": "DGWAS-2722",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_MYOTDIS",
    "phenotype": "Myotonic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myotonic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_MYOTDIS.gz"
  },
  {
    "accessionId": "DGWAS-2723",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_NARCOCATA",
    "phenotype": "Narcolepsy and cataplexy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Narcolepsy/cataplexy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_NARCOCATA.gz"
  },
  {
    "accessionId": "DGWAS-2727",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_NEUROOTH",
    "phenotype": "Other disorders of nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nervous system disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_NEUROOTH.gz"
  },
  {
    "accessionId": "DGWAS-2728",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_OTHDEMYEL",
    "phenotype": "Other demyelinating diseases of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS demyelinating disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_OTHDEMYEL.gz"
  },
  {
    "accessionId": "DGWAS-2729",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_OTHNEU",
    "phenotype": "Other neurological diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neurological disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_OTHNEU.gz"
  },
  {
    "accessionId": "DGWAS-2730",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_PARALOTHUNS",
    "phenotype": "Other and unspecified paralytic syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic syndrome NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_PARALOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2731",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_PARDIPLE",
    "phenotype": "Paraplegia, diplegia of upper limbs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paraplegia/diplegia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_PARDIPLE.gz"
  },
  {
    "accessionId": "DGWAS-2732",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_PARKINSON",
    "phenotype": "Parkinson's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parkinson disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_PARKINSON.gz"
  },
  {
    "accessionId": "DGWAS-2734",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_PLANTAR",
    "phenotype": "Lesion of plantar nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Plantar nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_PLANTAR.gz"
  },
  {
    "accessionId": "DGWAS-2735",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_POLYOTHUNS",
    "phenotype": "Other and unspecified polyneuropathies, also in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyneuropathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_POLYOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2736",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_POSTOPNEURO",
    "phenotype": "Postprocedural disorders of nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural nervous system disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_POSTOPNEURO.gz"
  },
  {
    "accessionId": "DGWAS-2737",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_POSTVIRFAT",
    "phenotype": "Postviral fatigue syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postviral fatigue syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_POSTVIRFAT.gz"
  },
  {
    "accessionId": "DGWAS-2739",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_RADLES",
    "phenotype": "Lesion of radial nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Radial nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_RADLES.gz"
  },
  {
    "accessionId": "DGWAS-2740",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ROOTPLEXOTHUNS",
    "phenotype": "Other and unspecified nerve root and plexus disorders, also in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nerve root/plexus disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ROOTPLEXOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2742",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_SLEEPAPNO",
    "phenotype": "Sleep apnoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_SLEEPAPNO.gz"
  },
  {
    "accessionId": "DGWAS-2743",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_SLEEPAPNO_INCLAVO",
    "phenotype": "Sleep apnoea, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_SLEEPAPNO_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-2747",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_STATUSEPI",
    "phenotype": "Status epilepticus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Status epilepticus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_STATUSEPI.gz"
  },
  {
    "accessionId": "DGWAS-2750",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_TRINEU",
    "phenotype": "Trigeminal neuralgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigeminal neuralgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_TRINEU.gz"
  },
  {
    "accessionId": "DGWAS-2751",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_TRIOTHUNS",
    "phenotype": "Other and unspecified trigeminal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigeminal nerve disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_TRIOTHUNS.gz"
  },
  {
    "accessionId": "DGWAS-2752",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_ULLNLE",
    "phenotype": "Lesion of ulnar nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulnar nerve lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_ULLNLE.gz"
  },
  {
    "accessionId": "DGWAS-2753",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_XTRAPYR",
    "phenotype": "Extrapyramidal and movement disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Extrapyramidal/movement disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_XTRAPYR.gz"
  },
  {
    "accessionId": "DGWAS-2754",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_G6_XTRAPYROTH",
    "phenotype": "Other extrapyramidal and movement disorders in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary extrapyramidal/movement disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_G6_XTRAPYROTH.gz"
  },
  {
    "accessionId": "DGWAS-2755",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_GE",
    "phenotype": "Generalized epilepsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized epilepsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_GE.gz"
  },
  {
    "accessionId": "DGWAS-2759",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_GE_STRICT",
    "phenotype": "Generalized epilepsy, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized epilepsy (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_GE_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-276",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMA_SERONEG",
    "phenotype": "Seronegative rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seronegative RA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMA_SERONEG.gz"
  },
  {
    "accessionId": "DGWAS-2760",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_GOUT_IDIO",
    "phenotype": "Idiopathic gout",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic gout",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_GOUT_IDIO.gz"
  },
  {
    "accessionId": "DGWAS-2761",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_GOUT_KIDNEY",
    "phenotype": "Gout due to impairment of renal function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout due to renal impairment",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_GOUT_KIDNEY.gz"
  },
  {
    "accessionId": "DGWAS-2764",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_GRAVES_OPHT",
    "phenotype": "Graves ophthalmopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Graves ophthalmopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_GRAVES_OPHT.gz"
  },
  {
    "accessionId": "DGWAS-2766",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_AMBLYANOPSIA",
    "phenotype": "Amblyopia ex anopsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amblyopia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_AMBLYANOPSIA.gz"
  },
  {
    "accessionId": "DGWAS-2767",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_AMD",
    "phenotype": "Age-related macular degeneration (whether dry or wet)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AMD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_AMD.gz"
  },
  {
    "accessionId": "DGWAS-2769",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_ANOMAPUPFUNC",
    "phenotype": "Anomalies of pupillary function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pupillary function anomaly",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_ANOMAPUPFUNC.gz"
  },
  {
    "accessionId": "DGWAS-277",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CLEFT_HARD_PALATE_NOS",
    "phenotype": "Cleft hard palate NOS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cleft hard palate",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CLEFT_HARD_PALATE_NOS.gz"
  },
  {
    "accessionId": "DGWAS-2770",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_APHAKIA",
    "phenotype": "Aphakia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aphakia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_APHAKIA.gz"
  },
  {
    "accessionId": "DGWAS-2776",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_BLEPHAROCHALASIS",
    "phenotype": "Blepharochalasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blepharochalasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_BLEPHAROCHALASIS.gz"
  },
  {
    "accessionId": "DGWAS-2777",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_BLINDANDVISIMPAIRMENT",
    "phenotype": "Visual impairment including blindness (binocular or monocular)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual impairment/blindness",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_BLINDANDVISIMPAIRMENT.gz"
  },
  {
    "accessionId": "DGWAS-2779",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_BULLKERATOPATHY",
    "phenotype": "Bullous keratopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bullous keratopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_BULLKERATOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-278",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CLEFT_AND_CARIES",
    "phenotype": "Caries in Clefts patients",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries in cleft patients",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CLEFT_AND_CARIES.gz"
  },
  {
    "accessionId": "DGWAS-2781",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CATARACTSENILE",
    "phenotype": "Senile cataract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Senile cataract",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CATARACTSENILE.gz"
  },
  {
    "accessionId": "DGWAS-2782",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CENTRRETARTOCC",
    "phenotype": "Central retinal artery occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central retinal artery occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CENTRRETARTOCC.gz"
  },
  {
    "accessionId": "DGWAS-2783",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CHALAZION",
    "phenotype": "Chalazion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chalazion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CHALAZION.gz"
  },
  {
    "accessionId": "DGWAS-2785",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CHORIORETINFLAM",
    "phenotype": "Chorioretinal inflammation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chorioretinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CHORIORETINFLAM.gz"
  },
  {
    "accessionId": "DGWAS-2789",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CHORSCAR",
    "phenotype": "Chorioretinal scars",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chorioretinal scar",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CHORSCAR.gz"
  },
  {
    "accessionId": "DGWAS-279",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_PULM_INFECTIONS",
    "phenotype": "COPD/asthma/ILD related infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD/asthma/ILD-related infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_PULM_INFECTIONS.gz"
  },
  {
    "accessionId": "DGWAS-2794",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CONJUNCTIVITISACUNONATOPIC",
    "phenotype": "Conjunctivitis (acute, non atopic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute non-atopic conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CONJUNCTIVITISACUNONATOPIC.gz"
  },
  {
    "accessionId": "DGWAS-2795",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CONJUNCTIVITISATOPIC",
    "phenotype": "Atopic conjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atopic conjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CONJUNCTIVITISATOPIC.gz"
  },
  {
    "accessionId": "DGWAS-2799",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CONVERSTRAB",
    "phenotype": "Convergent concomitant strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Convergent strabismus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CONVERSTRAB.gz"
  },
  {
    "accessionId": "DGWAS-280",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_URETHRAOTH",
    "phenotype": "Other disorders of urethra and urinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urethral/urinary disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_URETHRAOTH.gz"
  },
  {
    "accessionId": "DGWAS-2800",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CORNEALDEFORM",
    "phenotype": "Keratoconus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Keratoconus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CORNEALDEFORM.gz"
  },
  {
    "accessionId": "DGWAS-2801",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CORNEALDYSTROPHY",
    "phenotype": "Corneal degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CORNEALDYSTROPHY.gz"
  },
  {
    "accessionId": "DGWAS-2802",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CORNEALNAS",
    "phenotype": "Other and unspecified corneal deformities and disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal deformity/disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CORNEALNAS.gz"
  },
  {
    "accessionId": "DGWAS-2803",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CORNEALOEDEMA",
    "phenotype": "Other corneal oedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal edema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CORNEALOEDEMA.gz"
  },
  {
    "accessionId": "DGWAS-2807",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_CORNULCER",
    "phenotype": "Corneal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_CORNULCER.gz"
  },
  {
    "accessionId": "DGWAS-2808",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_COULOURVISDEF",
    "phenotype": "Colour vision deficiencies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Color vision deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_COULOURVISDEF.gz"
  },
  {
    "accessionId": "DGWAS-281",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPONDYLINFLAMNAS",
    "phenotype": "Other specified/unspecified inflammatory spondylopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inflammatory spondylopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPONDYLINFLAMNAS.gz"
  },
  {
    "accessionId": "DGWAS-2812",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_DISORDERLENSNAS",
    "phenotype": "Other specified and unspecified disorders of lens",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lens disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_DISORDERLENSNAS.gz"
  },
  {
    "accessionId": "DGWAS-2813",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_DIVERGSTRAB",
    "phenotype": "Divergent concomitant strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Divergent strabismus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_DIVERGSTRAB.gz"
  },
  {
    "accessionId": "DGWAS-2815",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_ENTROPION",
    "phenotype": "Entropion and trichiasis of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Entropion/trichiasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_ENTROPION.gz"
  },
  {
    "accessionId": "DGWAS-2816",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_EPIPHORA",
    "phenotype": "Epiphora",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epiphora",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_EPIPHORA.gz"
  },
  {
    "accessionId": "DGWAS-2817",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_EPISCLERITIS",
    "phenotype": "Episcleritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Episcleritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_EPISCLERITIS.gz"
  },
  {
    "accessionId": "DGWAS-282",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LOWBACKPAIN",
    "phenotype": "Low back pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Low back pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LOWBACKPAIN.gz"
  },
  {
    "accessionId": "DGWAS-2822",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_EYELIDINFLAMMATION",
    "phenotype": "Other inflammation of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_EYELIDINFLAMMATION.gz"
  },
  {
    "accessionId": "DGWAS-2824",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_EYELIDNAS",
    "phenotype": "Other specified and unspecified  disorders of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_EYELIDNAS.gz"
  },
  {
    "accessionId": "DGWAS-2825",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_EYEOTH",
    "phenotype": "Other disorders of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/adnexa disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_EYEOTH.gz"
  },
  {
    "accessionId": "DGWAS-2826",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCCLOSEPRIM",
    "phenotype": "Primary angle-closure glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angle-closure glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCCLOSEPRIM.gz"
  },
  {
    "accessionId": "DGWAS-2827",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCNAS",
    "phenotype": "Other and unspecified glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCNAS.gz"
  },
  {
    "accessionId": "DGWAS-283",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_PSORI_NAS",
    "phenotype": "Other and unspecified psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_PSORI_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2831",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCOMA_NTG",
    "phenotype": "Normotensive glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Normal tension glaucoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCOMA_NTG.gz"
  },
  {
    "accessionId": "DGWAS-2832",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCOMA_POAG",
    "phenotype": "Primary open-angle glaucoma, strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary open-angle glaucoma (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCOMA_POAG.gz"
  },
  {
    "accessionId": "DGWAS-2834",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCSECINFLAM",
    "phenotype": "Glaucoma secondary to eye inflammation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma secondary to uveitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCSECINFLAM.gz"
  },
  {
    "accessionId": "DGWAS-2836",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLAUCSUSP",
    "phenotype": "Glaucoma suspect",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma suspect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLAUCSUSP.gz"
  },
  {
    "accessionId": "DGWAS-2838",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_GLOBEDEGENERATED",
    "phenotype": "Degenerative conditions of globe",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Degenerative globe condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_GLOBEDEGENERATED.gz"
  },
  {
    "accessionId": "DGWAS-2839",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_HEREDRETINADYST",
    "phenotype": "Hereditary retinal dystrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary retinal dystrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_HEREDRETINADYST.gz"
  },
  {
    "accessionId": "DGWAS-284",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_HYPETROPHICSCAR",
    "phenotype": "Hypertrophic scar",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic scar",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_HYPETROPHICSCAR.gz"
  },
  {
    "accessionId": "DGWAS-2840",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_HERPESKERATITIS",
    "phenotype": "Herpesviral keratitis and keratoconjunctivitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Herpesviral keratitis/keratoconjunctivitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_HERPESKERATITIS.gz"
  },
  {
    "accessionId": "DGWAS-2841",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_HETEROPHORIA",
    "phenotype": "Heterophoria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heterophoria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_HETEROPHORIA.gz"
  },
  {
    "accessionId": "DGWAS-2842",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_HORDEOLUM",
    "phenotype": "Hordeolum and other deep inflammation of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hordeolum",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_HORDEOLUM.gz"
  },
  {
    "accessionId": "DGWAS-2843",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_HYPERMETRO",
    "phenotype": "Hypermetropia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypermetropia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_HYPERMETRO.gz"
  },
  {
    "accessionId": "DGWAS-2847",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_IRIDOCHRONIC",
    "phenotype": "Chronic iridocyclitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic iridocyclitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_IRIDOCHRONIC.gz"
  },
  {
    "accessionId": "DGWAS-2849",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_IRIDOCYCLITISINOTH",
    "phenotype": "Iridocyclitis in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary iridocyclitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_IRIDOCYCLITISINOTH.gz"
  },
  {
    "accessionId": "DGWAS-285",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_FISTULA",
    "phenotype": "Colonic or urogenital fistula",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colonic/urogenital fistula",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_FISTULA.gz"
  },
  {
    "accessionId": "DGWAS-2851",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_IRIDONAS",
    "phenotype": "Other and unspecified iridocyclitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iridocyclitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_IRIDONAS.gz"
  },
  {
    "accessionId": "DGWAS-2854",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_KERATITISINOTH",
    "phenotype": "Keratitis and keratoconjunctivitis in other diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary keratitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_KERATITISINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2855",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_KERATITISOTH",
    "phenotype": "Other keratitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Keratitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_KERATITISOTH.gz"
  },
  {
    "accessionId": "DGWAS-2857",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_LACRIMALSYSTEM",
    "phenotype": "Disorders of lacrimal system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal system disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_LACRIMALSYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-2858",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_LACRIMINFLAMACU",
    "phenotype": "Inflammation of lacrimal passages (acute and unspecified)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute dacryocystitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_LACRIMINFLAMACU.gz"
  },
  {
    "accessionId": "DGWAS-286",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_JOINTPAIN",
    "phenotype": "Pain in joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_JOINTPAIN.gz"
  },
  {
    "accessionId": "DGWAS-2860",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_LAGOPHTALMOS",
    "phenotype": "Lagophthalmos",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lagophthalmos",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_LAGOPHTALMOS.gz"
  },
  {
    "accessionId": "DGWAS-2861",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_LENSDISLOCATIO",
    "phenotype": "Dislocation of lens",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lens dislocation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_LENSDISLOCATIO.gz"
  },
  {
    "accessionId": "DGWAS-2862",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_LIDLACRIMALORBIT",
    "phenotype": "Disorders of eyelid, lacrimal system and orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid/lacrimal/orbit disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_LIDLACRIMALORBIT.gz"
  },
  {
    "accessionId": "DGWAS-2864",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_MILDVISIMPBINOC",
    "phenotype": "Mild or no visual impairment, binocular",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Visual impairment - mild/none (binocular)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_MILDVISIMPBINOC.gz"
  },
  {
    "accessionId": "DGWAS-2865",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_MODVISIMPBINOC",
    "phenotype": "Moderate visual impairment, binocular",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Visual impairment - moderate (binocular)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_MODVISIMPBINOC.gz"
  },
  {
    "accessionId": "DGWAS-2866",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_MODVISIMPMONOC",
    "phenotype": "Moderate visual impairment, monocular",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Visual impairment - moderate (monocular)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_MODVISIMPMONOC.gz"
  },
  {
    "accessionId": "DGWAS-2867",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_MYOPIA",
    "phenotype": "Myopia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myopia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_MYOPIA.gz"
  },
  {
    "accessionId": "DGWAS-2869",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OCUMUSCLE",
    "phenotype": "Disorders of ocular muscles, binocular movement, accommodation and refraction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ocular motility/refraction disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OCUMUSCLE.gz"
  },
  {
    "accessionId": "DGWAS-287",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_ABAORTANEUR",
    "phenotype": "Abdominal aortic aneurysm (AAA)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal aortic aneurysm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_ABAORTANEUR.gz"
  },
  {
    "accessionId": "DGWAS-2870",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OCUPAIN",
    "phenotype": "Ocular pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ocular pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OCUPAIN.gz"
  },
  {
    "accessionId": "DGWAS-2871",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OPTATROPHY",
    "phenotype": "Optic atrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OPTATROPHY.gz"
  },
  {
    "accessionId": "DGWAS-2872",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OPTICDISCOTH",
    "phenotype": "Other disorders of optic disc",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic disc disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OPTICDISCOTH.gz"
  },
  {
    "accessionId": "DGWAS-2873",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OPTNERVE",
    "phenotype": "Disorders of optic nerve and visual pathways",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic nerve/visual pathway disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OPTNERVE.gz"
  },
  {
    "accessionId": "DGWAS-2874",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OPTNERVNAS",
    "phenotype": "Disorders of optic nerve, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic nerve disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OPTNERVNAS.gz"
  },
  {
    "accessionId": "DGWAS-2875",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OPTNEURITIS",
    "phenotype": "Optic neuritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic neuritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OPTNEURITIS.gz"
  },
  {
    "accessionId": "DGWAS-2877",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_ORBIT",
    "phenotype": "Disorders of orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orbital disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_ORBIT.gz"
  },
  {
    "accessionId": "DGWAS-2878",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_ORBITINFLAMACU",
    "phenotype": "Acute inflammation of orbit",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute orbital inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_ORBITINFLAMACU.gz"
  },
  {
    "accessionId": "DGWAS-288",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_G6_RLS",
    "phenotype": "Restless leg syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Restless legs syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_G6_RLS.gz"
  },
  {
    "accessionId": "DGWAS-2882",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OTHIRISCILIARY",
    "phenotype": "Other disorders of iris and ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iris/ciliary body disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OTHIRISCILIARY.gz"
  },
  {
    "accessionId": "DGWAS-2883",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_OTHRETARTOCC",
    "phenotype": "Other retinal artery occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal artery occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_OTHRETARTOCC.gz"
  },
  {
    "accessionId": "DGWAS-2884",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PAPILLOEDEMA",
    "phenotype": "Papilloedema, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Papilledema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PAPILLOEDEMA.gz"
  },
  {
    "accessionId": "DGWAS-2885",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PARASTRA3",
    "phenotype": "Third [oculomotor] nerve palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oculomotor palsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PARASTRA3.gz"
  },
  {
    "accessionId": "DGWAS-2886",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PARASTRA4",
    "phenotype": "Fourth [trochlear] nerve palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trochlear palsy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PARASTRA4.gz"
  },
  {
    "accessionId": "DGWAS-2889",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PARASTRANAS",
    "phenotype": "Other or unspecified paralytic strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic strabismus NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PARASTRANAS.gz"
  },
  {
    "accessionId": "DGWAS-2890",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PERIPHRETINADEGEN",
    "phenotype": "Peripheral retinal degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral retinal degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PERIPHRETINADEGEN.gz"
  },
  {
    "accessionId": "DGWAS-2891",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PRESBYOPIA",
    "phenotype": "Presbyopia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Presbyopia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PRESBYOPIA.gz"
  },
  {
    "accessionId": "DGWAS-2892",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PROLIFRETINOPATHOTH",
    "phenotype": "Other proliferative retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Proliferative retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PROLIFRETINOPATHOTH.gz"
  },
  {
    "accessionId": "DGWAS-2893",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PTERYGIUM",
    "phenotype": "Pterygium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pterygium",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PTERYGIUM.gz"
  },
  {
    "accessionId": "DGWAS-2894",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_PTOSIS",
    "phenotype": "Ptosis of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ptosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_PTOSIS.gz"
  },
  {
    "accessionId": "DGWAS-2896",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_REFRAACCOMMODIS",
    "phenotype": "Disorders of refraction and accommodation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Refraction/accommodation disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_REFRAACCOMMODIS.gz"
  },
  {
    "accessionId": "DGWAS-2897",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINAHAEMORR",
    "phenotype": "Retinal haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINAHAEMORR.gz"
  },
  {
    "accessionId": "DGWAS-2898",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINALBREAK",
    "phenotype": "Retinal breaks without detachment",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal break",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINALBREAK.gz"
  },
  {
    "accessionId": "DGWAS-2899",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINALDETACH",
    "phenotype": "Retinal detachments and breaks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment/break",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINALDETACH.gz"
  },
  {
    "accessionId": "DGWAS-29",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_CHRONTONSADEN",
    "phenotype": "Chronic diseases of tonsils and adenoids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic tonsil/adenoid disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_CHRONTONSADEN.gz"
  },
  {
    "accessionId": "DGWAS-2900",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINALDETACHBREAK",
    "phenotype": "Retinal detachment with retinal break",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment with break",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINALDETACHBREAK.gz"
  },
  {
    "accessionId": "DGWAS-2901",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINALDETACHOTH",
    "phenotype": "Other, unspecified and serous retinal detachments",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINALDETACHOTH.gz"
  },
  {
    "accessionId": "DGWAS-2902",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINALDETACHTRACTION",
    "phenotype": "Traction detachment of retina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traction retinal detachment",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINALDETACHTRACTION.gz"
  },
  {
    "accessionId": "DGWAS-2905",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINASEPAR",
    "phenotype": "Separation of retinal layers (serosa)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Serous retinal detachment",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINASEPAR.gz"
  },
  {
    "accessionId": "DGWAS-2906",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINAVASC",
    "phenotype": "Retinal vascular disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal vascular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINAVASC.gz"
  },
  {
    "accessionId": "DGWAS-2907",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOCHISISCYST",
    "phenotype": "Retinoschisis and retinal cysts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinoschisis/retinal cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOCHISISCYST.gz"
  },
  {
    "accessionId": "DGWAS-2908",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOPATHYDIAB",
    "phenotype": "Diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOPATHYDIAB.gz"
  },
  {
    "accessionId": "DGWAS-2909",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOPATHYDIAB_BKG",
    "phenotype": "Diabetic background retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic background retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOPATHYDIAB_BKG.gz"
  },
  {
    "accessionId": "DGWAS-2910",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOPATHYDIAB_BKG_SEVERE",
    "phenotype": "Severe diabetic background retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe diabetic background retinopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOPATHYDIAB_BKG_SEVERE.gz"
  },
  {
    "accessionId": "DGWAS-2911",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOPATHYDIAB_NAS",
    "phenotype": "Other diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOPATHYDIAB_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2913",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETINOPATPREMAT",
    "phenotype": "Retinopathy of prematurity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinopathy of prematurity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETINOPATPREMAT.gz"
  },
  {
    "accessionId": "DGWAS-2914",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETIVASCOCCLUSION",
    "phenotype": "Retinal vascular occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal vascular occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETIVASCOCCLUSION.gz"
  },
  {
    "accessionId": "DGWAS-2915",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_RETROBULBNEURINOTH",
    "phenotype": "Retrobulbar neuritis in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary retrobulbar neuritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_RETROBULBNEURINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2917",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_SCLERITIS",
    "phenotype": "Scleritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scleritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_SCLERITIS.gz"
  },
  {
    "accessionId": "DGWAS-2918",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_SEVVISIMPBINOC",
    "phenotype": "Severe visual impairment, binocular",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Visual impairment - severe (binocular)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_SEVVISIMPBINOC.gz"
  },
  {
    "accessionId": "DGWAS-2919",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_SEVVISIMPMONOC",
    "phenotype": "Severe visual impairment, monocular",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Visual impairment - severe (monocular)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_SEVVISIMPMONOC.gz"
  },
  {
    "accessionId": "DGWAS-2920",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_STENOLACRI",
    "phenotype": "Stenosis and insufficiency of lacrimal passages",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal stenosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_STENOLACRI.gz"
  },
  {
    "accessionId": "DGWAS-2921",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_STRABNAS",
    "phenotype": "Other specified and unspecified strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Strabismus NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_STRABNAS.gz"
  },
  {
    "accessionId": "DGWAS-2922",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_STRABOTH",
    "phenotype": "Other strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Strabismus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_STRABOTH.gz"
  },
  {
    "accessionId": "DGWAS-2923",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VASCCILIARY",
    "phenotype": "Hyphaema and other vascular disorders of iris and ciliary body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyphema/iris vascular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VASCCILIARY.gz"
  },
  {
    "accessionId": "DGWAS-2924",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VERTISTRAB",
    "phenotype": "Vertical strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertical strabismus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VERTISTRAB.gz"
  },
  {
    "accessionId": "DGWAS-2925",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VISDISTNAS",
    "phenotype": "Other and unspecified visual disturbances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual disturbance NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VISDISTNAS.gz"
  },
  {
    "accessionId": "DGWAS-2928",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VISUDISTURB",
    "phenotype": "Visual disturbances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual disturbance",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VISUDISTURB.gz"
  },
  {
    "accessionId": "DGWAS-2930",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VITRBODYGLOBE",
    "phenotype": "Disorders of vitreous body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VITRBODYGLOBE.gz"
  },
  {
    "accessionId": "DGWAS-2931",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VITRCRYSTAL",
    "phenotype": "Crystalline deposits in vitreous body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous crystalline deposit",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VITRCRYSTAL.gz"
  },
  {
    "accessionId": "DGWAS-2932",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_VITROPACIT",
    "phenotype": "Other vitreous opacities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous opacity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_VITROPACIT.gz"
  },
  {
    "accessionId": "DGWAS-2934",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H7_XANTHELASMA",
    "phenotype": "Xanthelasma of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Xanthelasma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H7_XANTHELASMA.gz"
  },
  {
    "accessionId": "DGWAS-2935",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_ABNAUDPER",
    "phenotype": "Other abnormal auditory perceptions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal auditory perception",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_ABNAUDPER.gz"
  },
  {
    "accessionId": "DGWAS-2936",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_BPV",
    "phenotype": "Benign paroxysmal vertigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign paroxysmal vertigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_BPV.gz"
  },
  {
    "accessionId": "DGWAS-2938",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_CHOLEASTOMA",
    "phenotype": "Cholesteatoma of middle ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear cholesteatoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_CHOLEASTOMA.gz"
  },
  {
    "accessionId": "DGWAS-2939",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_CHRON_SUPOTITIS",
    "phenotype": "Chronic suppurative otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic suppurative otitis media",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_CHRON_SUPOTITIS.gz"
  },
  {
    "accessionId": "DGWAS-2940",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_DISCON",
    "phenotype": "Discontinuity and dislocation of ear ossicles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ear ossicle discontinuity/dislocation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_DISCON.gz"
  },
  {
    "accessionId": "DGWAS-2941",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EUSTNAS",
    "phenotype": "Other disorders of Eustachian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eustachian tube disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EUSTNAS.gz"
  },
  {
    "accessionId": "DGWAS-2942",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EUSTSALP",
    "phenotype": "Eustachian salpingitis and obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eustachian salpingitis/obstruction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EUSTSALP.gz"
  },
  {
    "accessionId": "DGWAS-2943",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXTDISINOTH",
    "phenotype": "Disorder of external ear, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXTDISINOTH.gz"
  },
  {
    "accessionId": "DGWAS-2945",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXTERNAL",
    "phenotype": "Diseases of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXTERNAL.gz"
  },
  {
    "accessionId": "DGWAS-2946",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXTOTITIS",
    "phenotype": "Otitis externa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis externa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXTOTITIS.gz"
  },
  {
    "accessionId": "DGWAS-2947",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_ABSC",
    "phenotype": "Abscess of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_ABSC.gz"
  },
  {
    "accessionId": "DGWAS-2948",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_CELLUL",
    "phenotype": "Cellulitis of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear cellulitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_CELLUL.gz"
  },
  {
    "accessionId": "DGWAS-2949",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_CHOL",
    "phenotype": "Cholesteatoma of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear cholesteatoma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_CHOL.gz"
  },
  {
    "accessionId": "DGWAS-2950",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_INFNAS",
    "phenotype": "Other infective otitis externa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infective otitis externa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_INFNAS.gz"
  },
  {
    "accessionId": "DGWAS-2951",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_NAS",
    "phenotype": "Otitis externa, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis externa NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2952",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_NONINF",
    "phenotype": "Acute otitis externa, noninfective",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute noninfective otitis externa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_NONINF.gz"
  },
  {
    "accessionId": "DGWAS-2953",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_EXT_OTH",
    "phenotype": "Other otitis externa (chronic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic otitis externa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_EXT_OTH.gz"
  },
  {
    "accessionId": "DGWAS-2955",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_HL_DEAFMUT",
    "phenotype": "Deaf mutism, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deaf mutism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_HL_DEAFMUT.gz"
  },
  {
    "accessionId": "DGWAS-2956",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_HL_IDIOP",
    "phenotype": "Sudden idiopathic hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sudden hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_HL_IDIOP.gz"
  },
  {
    "accessionId": "DGWAS-2957",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_HL_MIX_NAS",
    "phenotype": "Mixed conductive and sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_HL_MIX_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2959",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_HL_PRESBY",
    "phenotype": "Presbycusis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Presbycusis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_HL_PRESBY.gz"
  },
  {
    "accessionId": "DGWAS-2960",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_HL_SEN_NAS",
    "phenotype": "Sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sensorineural hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_HL_SEN_NAS.gz"
  },
  {
    "accessionId": "DGWAS-2964",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_MASTACU",
    "phenotype": "Acute mastoiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute mastoiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_MASTACU.gz"
  },
  {
    "accessionId": "DGWAS-2965",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_MASTCHRON",
    "phenotype": "Chronic mastoiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic mastoiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_MASTCHRON.gz"
  },
  {
    "accessionId": "DGWAS-2967",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_MED_SUPP",
    "phenotype": "Suppurative and unspecified otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suppurative otitis media",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_MED_SUPP.gz"
  },
  {
    "accessionId": "DGWAS-2968",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_MENIERE",
    "phenotype": "Meniere disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meniere disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_MENIERE.gz"
  },
  {
    "accessionId": "DGWAS-297",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_POSTMENBLEED",
    "phenotype": "Postmenopausal bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmenopausal bleeding",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_POSTMENBLEED.gz"
  },
  {
    "accessionId": "DGWAS-2971",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_MYRINGACU",
    "phenotype": "Acute myringitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute myringitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_MYRINGACU.gz"
  },
  {
    "accessionId": "DGWAS-2974",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_NONSUPPNAS",
    "phenotype": "Nonsuppurative otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonsuppurative otitis media",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_NONSUPPNAS.gz"
  },
  {
    "accessionId": "DGWAS-2977",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_OTHHEARINGLOSS",
    "phenotype": "Other hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hearing loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_OTHHEARINGLOSS.gz"
  },
  {
    "accessionId": "DGWAS-2979",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_OTORRHAGIA",
    "phenotype": "Otorrhagia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otorrhagia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_OTORRHAGIA.gz"
  },
  {
    "accessionId": "DGWAS-298",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_DIALYSIS",
    "phenotype": "Dialysis",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Dialysis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_DIALYSIS.gz"
  },
  {
    "accessionId": "DGWAS-2980",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_OTOSCLE",
    "phenotype": "Otosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otosclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_OTOSCLE.gz"
  },
  {
    "accessionId": "DGWAS-2981",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_PERCHRONDR",
    "phenotype": "Perichondritis of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perichondritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_PERCHRONDR.gz"
  },
  {
    "accessionId": "DGWAS-2982",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_PERFORATION",
    "phenotype": "Perforation of tympanic membrane",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane perforation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_PERFORATION.gz"
  },
  {
    "accessionId": "DGWAS-2983",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_PERIPHVERTIGO",
    "phenotype": "Other peripheral vertigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral vertigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_PERIPHVERTIGO.gz"
  },
  {
    "accessionId": "DGWAS-2987",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_STENOEXTCAN",
    "phenotype": "Acquired stenosis of external ear canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired ear canal stenosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_STENOEXTCAN.gz"
  },
  {
    "accessionId": "DGWAS-2988",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_SUP_ACUTE",
    "phenotype": "Acute suppurative otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute suppurative otitis media",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_SUP_ACUTE.gz"
  },
  {
    "accessionId": "DGWAS-299",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SPONDYLOSIS",
    "phenotype": "Spondylosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SPONDYLOSIS.gz"
  },
  {
    "accessionId": "DGWAS-2990",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_TINNITUS",
    "phenotype": "Tinnitus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tinnitus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_TINNITUS.gz"
  },
  {
    "accessionId": "DGWAS-2991",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_VERTIGO",
    "phenotype": "Disorders of vestibular function (Vertigo)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vestibular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_VERTIGO.gz"
  },
  {
    "accessionId": "DGWAS-2992",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_VERTIGOCENT",
    "phenotype": "Vertigo of central origin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central vertigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_VERTIGOCENT.gz"
  },
  {
    "accessionId": "DGWAS-2993",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_VESTIBNEUR",
    "phenotype": "Vestibular neuronitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vestibular neuronitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_VESTIBNEUR.gz"
  },
  {
    "accessionId": "DGWAS-2994",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_H8_VESTIFUNCNAS",
    "phenotype": "Other/unspecified disorders of vestibular function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vestibular disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_H8_VESTIFUNCNAS.gz"
  },
  {
    "accessionId": "DGWAS-2995",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_HERING_BILATERAL",
    "phenotype": "Inguinal hernia, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral inguinal hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_HERING_BILATERAL.gz"
  },
  {
    "accessionId": "DGWAS-2998",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_HYPOTHY_REIMB",
    "phenotype": "Hypothyroidism, drug reimbursement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism (drug reimbursement)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_HYPOTHY_REIMB.gz"
  },
  {
    "accessionId": "DGWAS-3",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_I9_VARICVE",
    "phenotype": "Varicose veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varicose veins",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_I9_VARICVE.gz"
  },
  {
    "accessionId": "DGWAS-300",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SJOGREN",
    "phenotype": "Sicca syndrome [Sjogren]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sjogren syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SJOGREN.gz"
  },
  {
    "accessionId": "DGWAS-3000",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_AF",
    "phenotype": "Atrial fibrillation and flutter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrial fibrillation/flutter",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_AF.gz"
  },
  {
    "accessionId": "DGWAS-3001",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_AF_REIMB",
    "phenotype": "Atrial fibrillation and flutter with reimbursement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrial fibrillation/flutter (reimbursement)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_AF_REIMB.gz"
  },
  {
    "accessionId": "DGWAS-3002",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ANEURYSM",
    "phenotype": "Cerebral aneurysm, nonruptured",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral aneurysm nonruptured",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ANEURYSM.gz"
  },
  {
    "accessionId": "DGWAS-3004",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ANGIO",
    "phenotype": "Coronary angioplasty",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Coronary angioplasty",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ANGIO.gz"
  },
  {
    "accessionId": "DGWAS-3006",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_AORTDIS",
    "phenotype": "Dissection of aorta",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic dissection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_AORTDIS.gz"
  },
  {
    "accessionId": "DGWAS-3007",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ARTEMBTHR",
    "phenotype": "Arterial embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial embolism/thrombosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ARTEMBTHR.gz"
  },
  {
    "accessionId": "DGWAS-3008",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ARTEMBTHRLOW",
    "phenotype": "Arterial embolism and thrombosis of lower extremity artery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity arterial embolism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ARTEMBTHRLOW.gz"
  },
  {
    "accessionId": "DGWAS-3009",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ARTEMBTHRNAS",
    "phenotype": "Other arterial embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial embolism/thrombosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ARTEMBTHRNAS.gz"
  },
  {
    "accessionId": "DGWAS-301",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SHOULDER",
    "phenotype": "Shoulder lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder lesion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SHOULDER.gz"
  },
  {
    "accessionId": "DGWAS-3010",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ARTOTH",
    "phenotype": "Other diseases of arteries and capillaries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial/capillary disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ARTOTH.gz"
  },
  {
    "accessionId": "DGWAS-3012",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_AVBLOCK",
    "phenotype": "AV-block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AV block",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_AVBLOCK.gz"
  },
  {
    "accessionId": "DGWAS-3014",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CARDARR",
    "phenotype": "Cardiac arrest",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrest",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CARDARR.gz"
  },
  {
    "accessionId": "DGWAS-3015",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CARDMSEC",
    "phenotype": "Cardiomyopathies, Secondary/extrinsic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CARDMSEC.gz"
  },
  {
    "accessionId": "DGWAS-3016",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CARDMYO",
    "phenotype": "Cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CARDMYO.gz"
  },
  {
    "accessionId": "DGWAS-3018",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CARDMYOHYP",
    "phenotype": "Cardiomyopathy, Hypertrophic obstructive",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic obstructive cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CARDMYOHYP.gz"
  },
  {
    "accessionId": "DGWAS-3019",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CARDMYOINOTH",
    "phenotype": "Cardiomyopathy in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy in other diseases",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CARDMYOINOTH.gz"
  },
  {
    "accessionId": "DGWAS-302",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_SACROILIITIS",
    "phenotype": "Sacroiliitis, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sacroiliitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_SACROILIITIS.gz"
  },
  {
    "accessionId": "DGWAS-3023",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CEREBATHER",
    "phenotype": "Cerebral atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral atherosclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CEREBATHER.gz"
  },
  {
    "accessionId": "DGWAS-3024",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CEREBDOTH",
    "phenotype": "Other specified cerebrovascular diseases, other cerebrovascular disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebrovascular disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CEREBDOTH.gz"
  },
  {
    "accessionId": "DGWAS-3026",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CONDUCTIO",
    "phenotype": "Conduction disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conduction disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CONDUCTIO.gz"
  },
  {
    "accessionId": "DGWAS-3028",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_CVD_HARD",
    "phenotype": "Hard cardiovascular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hard cardiovascular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_CVD_HARD.gz"
  },
  {
    "accessionId": "DGWAS-3029",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_DISCER",
    "phenotype": "Dissection of cerebral arteries, nonruptured",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral artery dissection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_DISCER.gz"
  },
  {
    "accessionId": "DGWAS-303",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ARTHROSIS_OTH",
    "phenotype": "Other arthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthrosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ARTHROSIS_OTH.gz"
  },
  {
    "accessionId": "DGWAS-3030",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_DISVEINLYMPH",
    "phenotype": "Diseases of veins, lymphatic vessels and lymph nodes, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Venous/lymphatic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_DISVEINLYMPH.gz"
  },
  {
    "accessionId": "DGWAS-3031",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ENDOCARD",
    "phenotype": "Endocarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocarditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ENDOCARD.gz"
  },
  {
    "accessionId": "DGWAS-3032",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_E_DRONE",
    "phenotype": "Dronedarone medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Dronedarone",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_E_DRONE.gz"
  },
  {
    "accessionId": "DGWAS-3033",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HEARTFAIL",
    "phenotype": "Heart failure,strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HEARTFAIL.gz"
  },
  {
    "accessionId": "DGWAS-3035",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HEARTFAIL_AND_ANTIHYPERT",
    "phenotype": "Heart failure and antihypertensive medication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure with antihypertensive",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HEARTFAIL_AND_ANTIHYPERT.gz"
  },
  {
    "accessionId": "DGWAS-3037",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HEARTFAIL_AND_HYPERTCARDIOM",
    "phenotype": "Heart failure and hypertrophic cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure with HCM",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HEARTFAIL_AND_HYPERTCARDIOM.gz"
  },
  {
    "accessionId": "DGWAS-3038",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HEARTFAIL_AND_OVERWEIGHT",
    "phenotype": "Heart failure and bmi 25plus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure with BMI>25",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HEARTFAIL_AND_OVERWEIGHT.gz"
  },
  {
    "accessionId": "DGWAS-304",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_URTICARIA",
    "phenotype": "Urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_URTICARIA.gz"
  },
  {
    "accessionId": "DGWAS-3041",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HYPERTROCARDMYOP",
    "phenotype": "Hypertrophic cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HYPERTROCARDMYOP.gz"
  },
  {
    "accessionId": "DGWAS-3043",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HYPTENS",
    "phenotype": "Hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HYPTENS.gz"
  },
  {
    "accessionId": "DGWAS-3044",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HYPTENSEC",
    "phenotype": "Secondary hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HYPTENSEC.gz"
  },
  {
    "accessionId": "DGWAS-3045",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HYPTENSESS",
    "phenotype": "Hypertension, essential",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Essential hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HYPTENSESS.gz"
  },
  {
    "accessionId": "DGWAS-3048",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_HYPTENSRD",
    "phenotype": "Hypertensive Renal Disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive renal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_HYPTENSRD.gz"
  },
  {
    "accessionId": "DGWAS-3049",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_ICH",
    "phenotype": "Intracerebral haemmorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracerebral hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_ICH.gz"
  },
  {
    "accessionId": "DGWAS-305",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_DERMATHERP",
    "phenotype": "Dermatitis herpetiformis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatitis herpetiformis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_DERMATHERP.gz"
  },
  {
    "accessionId": "DGWAS-3050",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_IHD",
    "phenotype": "Ischaemic heart disease, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic heart disease (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_IHD.gz"
  },
  {
    "accessionId": "DGWAS-3051",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_INTRACRA",
    "phenotype": "Nontraumatic intracranial haemmorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontraumatic intracranial hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_INTRACRA.gz"
  },
  {
    "accessionId": "DGWAS-3052",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_K_CARDIAC",
    "phenotype": "Death due to cardiac causes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac death",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_K_CARDIAC.gz"
  },
  {
    "accessionId": "DGWAS-3053",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_LBBB",
    "phenotype": "Left bundle-branch block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "LBBB",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_LBBB.gz"
  },
  {
    "accessionId": "DGWAS-3054",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_LYMPHADE",
    "phenotype": "Nonspecific lymphadenitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonspecific lymphadenitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_LYMPHADE.gz"
  },
  {
    "accessionId": "DGWAS-3056",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_MI_COMPLICATIONS",
    "phenotype": "Complications following myocardial infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-MI complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_MI_COMPLICATIONS.gz"
  },
  {
    "accessionId": "DGWAS-3057",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_MI_STRICT",
    "phenotype": "Myocardial infarction, strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "MI (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_MI_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-3058",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_MYOCARD",
    "phenotype": "Myocarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myocarditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_MYOCARD.gz"
  },
  {
    "accessionId": "DGWAS-3059",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_NONISCHCARDMYOP",
    "phenotype": "Non-ischemic cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonischemic cardiomyopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_NONISCHCARDMYOP.gz"
  },
  {
    "accessionId": "DGWAS-306",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_HYPOPLASIA_ENAMEL",
    "phenotype": "Hypoplasia of dental enamel",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enamel hypoplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_HYPOPLASIA_ENAMEL.gz"
  },
  {
    "accessionId": "DGWAS-3061",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_NONRHEVALV",
    "phenotype": "Non-rheumatic valve diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonrheumatic valve disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_NONRHEVALV.gz"
  },
  {
    "accessionId": "DGWAS-3062",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_OTHANEUR",
    "phenotype": "Other aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aneurysm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_OTHANEUR.gz"
  },
  {
    "accessionId": "DGWAS-3065",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_OTHINTRACRA",
    "phenotype": "Other intracranial haemorrhages",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracranial hemorrhage NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_OTHINTRACRA.gz"
  },
  {
    "accessionId": "DGWAS-3066",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_OTHOTH",
    "phenotype": "Other other unspecified disorders of the circulatory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circulatory disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_OTHOTH.gz"
  },
  {
    "accessionId": "DGWAS-3067",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_OTHPER",
    "phenotype": "Other peripheral vascular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral vascular disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_OTHPER.gz"
  },
  {
    "accessionId": "DGWAS-3072",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_PHLETHROMBDVTLOW",
    "phenotype": "DVT of lower extremities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT lower extremity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_PHLETHROMBDVTLOW.gz"
  },
  {
    "accessionId": "DGWAS-3073",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_POSTAMI",
    "phenotype": "Status post-ami",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Status post-MI",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_POSTAMI.gz"
  },
  {
    "accessionId": "DGWAS-3076",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_PVT",
    "phenotype": "Portal vein thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Portal vein thrombosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_PVT.gz"
  },
  {
    "accessionId": "DGWAS-3077",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_RBBB",
    "phenotype": "Right bundle-branch block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "RBBB",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_RBBB.gz"
  },
  {
    "accessionId": "DGWAS-3078",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_REVASC",
    "phenotype": "Coronary revascularization (ANGIO or CABG)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Coronary revascularization",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_REVASC.gz"
  },
  {
    "accessionId": "DGWAS-3080",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_RHEUFEVHRT",
    "phenotype": "Rheumatic fever with heart involvement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic fever with carditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_RHEUFEVHRT.gz"
  },
  {
    "accessionId": "DGWAS-3083",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_SAH",
    "phenotype": "Subarachnoid haemmorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subarachnoid hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_SAH.gz"
  },
  {
    "accessionId": "DGWAS-3084",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_SAHANEUR",
    "phenotype": "Aneurysms, operations, SAH",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Aneurysm surgery/SAH",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_SAHANEUR.gz"
  },
  {
    "accessionId": "DGWAS-3086",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_SEQULAE",
    "phenotype": "Sequelae of cerebrovascular disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sequelae of stroke",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_SEQULAE.gz"
  },
  {
    "accessionId": "DGWAS-3087",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_STENOSIS",
    "phenotype": "Occlusion and stenosis of arteries, not leading to stroke",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial stenosis/occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_STENOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3088",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_STR",
    "phenotype": "Stroke, excluding SAH",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke (excl SAH)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_STR.gz"
  },
  {
    "accessionId": "DGWAS-3089",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_STR_EMBOLIC",
    "phenotype": "Embolic stroke",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embolic stroke",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_STR_EMBOLIC.gz"
  },
  {
    "accessionId": "DGWAS-3090",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_STR_EMBOLIC_WITH_FLIMMER",
    "phenotype": "Embolic stroke with flimmer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embolic stroke with atrial fibrillation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_STR_EMBOLIC_WITH_FLIMMER.gz"
  },
  {
    "accessionId": "DGWAS-3093",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_THROMBICV",
    "phenotype": "Nonpyogenic thrombosis of intracranial venous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral venous thrombosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_THROMBICV.gz"
  },
  {
    "accessionId": "DGWAS-3095",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_TIA",
    "phenotype": "Transient ischemic attack",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TIA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_TIA.gz"
  },
  {
    "accessionId": "DGWAS-3098",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_VARICVEOES",
    "phenotype": "Oesophageal varices",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal varices",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_VARICVEOES.gz"
  },
  {
    "accessionId": "DGWAS-31",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_J10_ASTHMA_EXMORE",
    "phenotype": "Asthma (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_J10_ASTHMA_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3101",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_VASCSYND",
    "phenotype": "Vascular syndromes of brain in cerebrovascular disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebrovascular syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_VASCSYND.gz"
  },
  {
    "accessionId": "DGWAS-3102",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_VEINSOTH",
    "phenotype": "Other disorders of veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vein disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_VEINSOTH.gz"
  },
  {
    "accessionId": "DGWAS-3104",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_I9_VTE",
    "phenotype": "Venous thromboembolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "VTE",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_I9_VTE.gz"
  },
  {
    "accessionId": "DGWAS-3105",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ILD",
    "phenotype": "Interstitial lung disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ILD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ILD.gz"
  },
  {
    "accessionId": "DGWAS-3107",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ILD_ENDPOINTS",
    "phenotype": "Interstitial lung disease endpoints",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ILD endpoint",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ILD_ENDPOINTS.gz"
  },
  {
    "accessionId": "DGWAS-3108",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ILD_INSUFFICIENCY",
    "phenotype": "ILD-related respiratory insufficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ILD-related respiratory insufficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ILD_INSUFFICIENCY.gz"
  },
  {
    "accessionId": "DGWAS-3112",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_INTERSTITIAL_CYSTIT_CHRONIC",
    "phenotype": "Interstitial cystitis (chronic), drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced interstitial cystitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_INTERSTITIAL_CYSTIT_CHRONIC.gz"
  },
  {
    "accessionId": "DGWAS-3113",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_INV_VENT",
    "phenotype": "Invasive ventilation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Invasive ventilation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_INV_VENT.gz"
  },
  {
    "accessionId": "DGWAS-3115",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_ABSCLUNGPNEUMO",
    "phenotype": "Abscess of lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_ABSCLUNGPNEUMO.gz"
  },
  {
    "accessionId": "DGWAS-3116",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_ACUTELOWERNAS",
    "phenotype": "Unspecified acute lower respiratory infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute lower respiratory infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_ACUTELOWERNAS.gz"
  },
  {
    "accessionId": "DGWAS-3117",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_ACUTEUPPERINFEC",
    "phenotype": "Acute upper respiratory infections of multiple and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute upper respiratory infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_ACUTEUPPERINFEC.gz"
  },
  {
    "accessionId": "DGWAS-3119",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_ASBESTPNEUMOC",
    "phenotype": "Pneumoconiosis due to asbestos and other mineral fibres",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asbestosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_ASBESTPNEUMOC.gz"
  },
  {
    "accessionId": "DGWAS-3122",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_ASTHMA_MAIN_EXMORE",
    "phenotype": "Asthma (only as main-diagnosis) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma (main diagnosis)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_ASTHMA_MAIN_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3124",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_BRONCHIECTASIS",
    "phenotype": "Bronchiectasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchiectasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_BRONCHIECTASIS.gz"
  },
  {
    "accessionId": "DGWAS-3125",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_BRONCHIOLITIS",
    "phenotype": "Acute bronchiolitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute bronchiolitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_BRONCHIOLITIS.gz"
  },
  {
    "accessionId": "DGWAS-3126",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_BRONCHITIS",
    "phenotype": "Acute bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute bronchitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_BRONCHITIS.gz"
  },
  {
    "accessionId": "DGWAS-3128",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_CHEMGASRESP",
    "phenotype": "Respiratory conditions due to inhalation of chemicals, gases, fumes and vapours",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chemical inhalation injury",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_CHEMGASRESP.gz"
  },
  {
    "accessionId": "DGWAS-3129",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_CHRONLARYNGITIS",
    "phenotype": "Chronic laryngitis and laryngotracheitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic laryngitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_CHRONLARYNGITIS.gz"
  },
  {
    "accessionId": "DGWAS-3135",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_EMPHYSEMA",
    "phenotype": "Emphysema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_EMPHYSEMA.gz"
  },
  {
    "accessionId": "DGWAS-3136",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_EPIGLOTTITIS",
    "phenotype": "Acute epiglottitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute epiglottitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_EPIGLOTTITIS.gz"
  },
  {
    "accessionId": "DGWAS-3137",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_EXTERLUNG",
    "phenotype": "Lung diseases due to external agents",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External agent lung disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_EXTERLUNG.gz"
  },
  {
    "accessionId": "DGWAS-3138",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_HYPERSPNEUMONI",
    "phenotype": "Hypersensitivity pneumonitis due to organic dust",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypersensitivity pneumonitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_HYPERSPNEUMONI.gz"
  },
  {
    "accessionId": "DGWAS-3139",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_INFLUENZA",
    "phenotype": "All influenza",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Influenza",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_INFLUENZA.gz"
  },
  {
    "accessionId": "DGWAS-314",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Z21_KIDNEY_TRANSPLANT_STATUS",
    "phenotype": "Kidney transplant status",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Kidney transplant",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Z21_KIDNEY_TRANSPLANT_STATUS.gz"
  },
  {
    "accessionId": "DGWAS-3140",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_INFLUPNEU",
    "phenotype": "Influenza and pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Influenza/pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_INFLUPNEU.gz"
  },
  {
    "accessionId": "DGWAS-3142",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_LARYNGITIS",
    "phenotype": "Acute laryngitis and tracheitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute laryngitis/tracheitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_LARYNGITIS.gz"
  },
  {
    "accessionId": "DGWAS-3144",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_LOWERINF",
    "phenotype": "Other acute lower respiratory infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute lower respiratory infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_LOWERINF.gz"
  },
  {
    "accessionId": "DGWAS-3145",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_NASALPOLYP",
    "phenotype": "Nasal polyp",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal polyp",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_NASALPOLYP.gz"
  },
  {
    "accessionId": "DGWAS-3149",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PLEURA",
    "phenotype": "Other diseases of pleura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PLEURA.gz"
  },
  {
    "accessionId": "DGWAS-315",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_POLLENALLERG",
    "phenotype": "Pollen allergy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pollen allergy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_POLLENALLERG.gz"
  },
  {
    "accessionId": "DGWAS-3152",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PLEURPLAGUE",
    "phenotype": "Pleural plaque",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural plaque",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PLEURPLAGUE.gz"
  },
  {
    "accessionId": "DGWAS-3153",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PNEUMOBACT",
    "phenotype": "Bacterial pneumoniae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PNEUMOBACT.gz"
  },
  {
    "accessionId": "DGWAS-3155",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PNEUMONIA",
    "phenotype": "All pneumoniae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PNEUMONIA.gz"
  },
  {
    "accessionId": "DGWAS-3156",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PNEUMONISOLLIQ",
    "phenotype": "Pneumonitis due to solids and liquids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aspiration pneumonitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PNEUMONISOLLIQ.gz"
  },
  {
    "accessionId": "DGWAS-316",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PRE_OR_ECLAMPSIA",
    "phenotype": "Pre-eclampsia or eclampsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia/eclampsia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PRE_OR_ECLAMPSIA.gz"
  },
  {
    "accessionId": "DGWAS-3162",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_PYOTHORAX",
    "phenotype": "Pyothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Empyema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_PYOTHORAX.gz"
  },
  {
    "accessionId": "DGWAS-3164",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_RESPOTHER",
    "phenotype": "Other diseases of the respiratory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_RESPOTHER.gz"
  },
  {
    "accessionId": "DGWAS-3165",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_SEPTDEV",
    "phenotype": "Deviated nasal septum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deviated nasal septum",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_SEPTDEV.gz"
  },
  {
    "accessionId": "DGWAS-3169",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_TONSILLECTOMY",
    "phenotype": "Tonsillectomy",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tonsillectomy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_TONSILLECTOMY.gz"
  },
  {
    "accessionId": "DGWAS-317",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_URINOTH",
    "phenotype": "Other diseases of urinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary system disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_URINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3170",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_TONSILLITIS",
    "phenotype": "Other and unspecified tonsillitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsillitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_TONSILLITIS.gz"
  },
  {
    "accessionId": "DGWAS-3171",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_UPPERDIS",
    "phenotype": "Other diseases of upper respiratory tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper respiratory disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_UPPERDIS.gz"
  },
  {
    "accessionId": "DGWAS-3172",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_UPPERINFEC",
    "phenotype": "Acute upper respiratory infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute upper respiratory infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_UPPERINFEC.gz"
  },
  {
    "accessionId": "DGWAS-3173",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_VIRALPNEUMO",
    "phenotype": "Viral pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral pneumonia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_VIRALPNEUMO.gz"
  },
  {
    "accessionId": "DGWAS-3174",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_J10_VOCALLARYNX",
    "phenotype": "Diseases of vocal cords and larynx+other diseases of upper respiratory tract, no elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vocal cord/larynx disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_J10_VOCALLARYNX.gz"
  },
  {
    "accessionId": "DGWAS-3177",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ABRASION",
    "phenotype": "Abrasion of teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth abrasion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ABRASION.gz"
  },
  {
    "accessionId": "DGWAS-3178",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ABSCANAL",
    "phenotype": "Abscess of anal and rectal regions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorectal abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ABSCANAL.gz"
  },
  {
    "accessionId": "DGWAS-3179",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ACHAL",
    "phenotype": "Achalasia of cardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Achalasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ACHAL.gz"
  },
  {
    "accessionId": "DGWAS-318",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_POLYPFEMGEN",
    "phenotype": "Polyp of the female genital tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital polyp",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_POLYPFEMGEN.gz"
  },
  {
    "accessionId": "DGWAS-3180",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ACUTGASTR",
    "phenotype": "Acute gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute gastritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ACUTGASTR.gz"
  },
  {
    "accessionId": "DGWAS-3182",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ADHE",
    "phenotype": "Intestinal adhesions without obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal adhesions",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ADHE.gz"
  },
  {
    "accessionId": "DGWAS-3183",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ALCGASTR",
    "phenotype": "Alcoholic gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic gastritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ALCGASTR.gz"
  },
  {
    "accessionId": "DGWAS-3184",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ALCOLIV",
    "phenotype": "Alcoholic liver disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic liver disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ALCOLIV.gz"
  },
  {
    "accessionId": "DGWAS-3186",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_APHTA_RECUR",
    "phenotype": "Recurring oral aphthae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent aphthous ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_APHTA_RECUR.gz"
  },
  {
    "accessionId": "DGWAS-3187",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_APHTA_RECUR_INCLAVO",
    "phenotype": "Recurring oral aphthae, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent aphthous ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_APHTA_RECUR_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3189",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_APPENDECTOMY",
    "phenotype": "Appendectomy",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Appendectomy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_APPENDECTOMY.gz"
  },
  {
    "accessionId": "DGWAS-319",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_GLOMER_NEPHRITIS",
    "phenotype": "Glomerulonephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glomerulonephritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_GLOMER_NEPHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-3190",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_APPENDOTH",
    "phenotype": "Other appendicitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendicitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_APPENDOTH.gz"
  },
  {
    "accessionId": "DGWAS-3191",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ASYMMETRY_JAW",
    "phenotype": "Asymmetry of jaw",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw asymmetry",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ASYMMETRY_JAW.gz"
  },
  {
    "accessionId": "DGWAS-3192",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ATTRITION",
    "phenotype": "Excessive attrition of teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth attrition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ATTRITION.gz"
  },
  {
    "accessionId": "DGWAS-3193",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_BARRET",
    "phenotype": "Barrett oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Barrett esophagus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_BARRET.gz"
  },
  {
    "accessionId": "DGWAS-3194",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_BILIAOTH",
    "phenotype": "Other diseases of biliary tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biliary tract disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_BILIAOTH.gz"
  },
  {
    "accessionId": "DGWAS-3195",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CARIES_1_ONLYAVO",
    "phenotype": "Dental caries 1, only avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CARIES_1_ONLYAVO.gz"
  },
  {
    "accessionId": "DGWAS-3196",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CARIES_2",
    "phenotype": "Dental caries 2",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CARIES_2.gz"
  },
  {
    "accessionId": "DGWAS-3197",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CARIES_DENTIN",
    "phenotype": "Dentinal caries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dentinal caries",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CARIES_DENTIN.gz"
  },
  {
    "accessionId": "DGWAS-3199",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHOLANGI",
    "phenotype": "Cholangitis (primary sclerosing, PSC)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PSC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHOLANGI.gz"
  },
  {
    "accessionId": "DGWAS-320",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMET_INFERT",
    "phenotype": "Endometriosis diagnosis and infertility diagnosis occurring together",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis with infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMET_INFERT.gz"
  },
  {
    "accessionId": "DGWAS-3200",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHOLANGI_STRICT",
    "phenotype": "Cholangitis (primary sclerosing, PSC), with reimbursement 202",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PSC (reimbursement)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHOLANGI_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-3201",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHOLECYST",
    "phenotype": "Cholecystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholecystitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHOLECYST.gz"
  },
  {
    "accessionId": "DGWAS-3202",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHOLECYSTECTOMY",
    "phenotype": "Cholecystectomy",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cholecystectomy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHOLECYSTECTOMY.gz"
  },
  {
    "accessionId": "DGWAS-3204",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHRONGASTR",
    "phenotype": "Chronic gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic gastritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHRONGASTR.gz"
  },
  {
    "accessionId": "DGWAS-3205",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHRONHEP",
    "phenotype": "Chronic hepatitis, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic hepatitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHRONHEP.gz"
  },
  {
    "accessionId": "DGWAS-3206",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CHRONPANC",
    "phenotype": "Chronic pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pancreatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CHRONPANC.gz"
  },
  {
    "accessionId": "DGWAS-3208",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CONSTIPATION",
    "phenotype": "Constipation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Constipation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CONSTIPATION.gz"
  },
  {
    "accessionId": "DGWAS-3209",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CROSSBITE",
    "phenotype": "Crossbite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crossbite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CROSSBITE.gz"
  },
  {
    "accessionId": "DGWAS-321",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_ENDOMETRIOSIS_DEEP",
    "phenotype": "Deep endometriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deep endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_ENDOMETRIOSIS_DEEP.gz"
  },
  {
    "accessionId": "DGWAS-3210",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_CROWDI_TEETH_INCLAVO",
    "phenotype": "Crowding of teeth, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental crowding",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_CROWDI_TEETH_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3211",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DEEP_BITE_INCLAVO",
    "phenotype": "Deep bite , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deep bite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DEEP_BITE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3213",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DENTOFACIAL_ANOMALIES",
    "phenotype": "Dentofacial anomalies [including malocclusion]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dentofacial anomaly",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DENTOFACIAL_ANOMALIES.gz"
  },
  {
    "accessionId": "DGWAS-3214",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DEPOSITS",
    "phenotype": "Deposits [accretions] on teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental deposit",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DEPOSITS.gz"
  },
  {
    "accessionId": "DGWAS-3215",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DIAHER",
    "phenotype": "Diaphragmatic hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diaphragmatic hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DIAHER.gz"
  },
  {
    "accessionId": "DGWAS-3217",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DISOESINOTH",
    "phenotype": "Disorders of oesophagus in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary esophageal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DISOESINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3219",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DISTAL_BITE_INCLAVO",
    "phenotype": "Distal bite , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Distal occlusion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DISTAL_BITE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-322",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_REACTARTH",
    "phenotype": "Reactive arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Reactive arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_REACTARTH.gz"
  },
  {
    "accessionId": "DGWAS-3220",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DIVERTIC",
    "phenotype": "Diverticular disease of intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diverticular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DIVERTIC.gz"
  },
  {
    "accessionId": "DGWAS-3221",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_DULC",
    "phenotype": "Duodenal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Duodenal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_DULC.gz"
  },
  {
    "accessionId": "DGWAS-3222",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_EMBED_TEETH_INCLAVO",
    "phenotype": "Embedded teeth, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embedded teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_EMBED_TEETH_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3223",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_EMBIMPACT_TEETH_INCLAVO",
    "phenotype": "Embedded and impacted teeth , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embedded/impacted teeth",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_EMBIMPACT_TEETH_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3224",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ENERCOLNONINF",
    "phenotype": "Noninfective enteritis and colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious enteritis/colitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ENERCOLNONINF.gz"
  },
  {
    "accessionId": "DGWAS-3225",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_EROSION",
    "phenotype": "Erosion of teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth erosion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_EROSION.gz"
  },
  {
    "accessionId": "DGWAS-3226",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_EROSION_INCLAVO",
    "phenotype": "Erosion of teeth, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth erosion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_EROSION_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3227",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ERUPTION_INCLAVO",
    "phenotype": "Tooth eruption problems , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth eruption problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ERUPTION_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3228",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_FEMHER",
    "phenotype": "Femoral hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_FEMHER.gz"
  },
  {
    "accessionId": "DGWAS-3229",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_FIBROCHIRLIV",
    "phenotype": "Fibrosis and cirrhosis of liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver fibrosis/cirrhosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_FIBROCHIRLIV.gz"
  },
  {
    "accessionId": "DGWAS-323",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_OSTEOPOROSIS",
    "phenotype": "Osteoporosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoporosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_OSTEOPOROSIS.gz"
  },
  {
    "accessionId": "DGWAS-3231",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_FUNCDYSP",
    "phenotype": "Functional dyspepsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Functional dyspepsia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_FUNCDYSP.gz"
  },
  {
    "accessionId": "DGWAS-3232",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_GALLBLAOTH",
    "phenotype": "Other diseases of gallbladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_GALLBLAOTH.gz"
  },
  {
    "accessionId": "DGWAS-3233",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_GASTRODUOULC",
    "phenotype": "Gastroduodenal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastroduodenal ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_GASTRODUOULC.gz"
  },
  {
    "accessionId": "DGWAS-3234",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_GINGIVA",
    "phenotype": "Other disorders of gingiva or/and edentulous alveolar ridge",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingival/alveolar disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_GINGIVA.gz"
  },
  {
    "accessionId": "DGWAS-3235",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_GINGIVITIS_PERIODONTAL",
    "phenotype": "Gingivitis and periodontal diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingivitis/periodontal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_GINGIVITIS_PERIODONTAL.gz"
  },
  {
    "accessionId": "DGWAS-3236",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_GINGIV_HYPERPLAS",
    "phenotype": "Gingival hyperplasia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingival hyperplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_GINGIV_HYPERPLAS.gz"
  },
  {
    "accessionId": "DGWAS-3239",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_HAEMORR",
    "phenotype": "Haemmorrhoids and perianal venous thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemorrhoids/perianal thrombosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_HAEMORR.gz"
  },
  {
    "accessionId": "DGWAS-324",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_MICROPOLYANG",
    "phenotype": "Microscopic polyangiitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Microscopic polyangiitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_MICROPOLYANG.gz"
  },
  {
    "accessionId": "DGWAS-3245",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_HYPOPLASIA_ENAMEL_INCLAVO",
    "phenotype": "Hypoplasia of dental enamel , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enamel hypoplasia (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_HYPOPLASIA_ENAMEL_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3246",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_HYPOPLASIA_ENAMEL_PRENATAL_INCLAVO",
    "phenotype": "Hypoplasia of dental enamel, prenatal , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prenatal enamel hypoplasia (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_HYPOPLASIA_ENAMEL_PRENATAL_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3247",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_HYPO_ONLY_INCLAVO",
    "phenotype": "Tooth agenesis EXCLUDE clefts and syndromes , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth agenesis (excl clefts/syndromes, incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_HYPO_ONLY_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3249",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_IBD_STRICT_PSC",
    "phenotype": "IBD (strict) with PSC",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IBD strict with PSC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_IBD_STRICT_PSC.gz"
  },
  {
    "accessionId": "DGWAS-325",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_MCTD",
    "phenotype": "Mixed connective tissue disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed connective tissue disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_MCTD.gz"
  },
  {
    "accessionId": "DGWAS-3253",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_IMPACTED_TEETH_INCLAVO",
    "phenotype": "Impacted teeth , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted teeth (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_IMPACTED_TEETH_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3256",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_JAWS",
    "phenotype": "Other diseases of jaws",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_JAWS.gz"
  },
  {
    "accessionId": "DGWAS-3258",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_LIP_ORAL_MUCOSA",
    "phenotype": "Other diseases of lip and oral mucosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lip/oral mucosa disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_LIP_ORAL_MUCOSA.gz"
  },
  {
    "accessionId": "DGWAS-326",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_URTICA_NAS",
    "phenotype": "Other and unspecified urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urticaria NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_URTICA_NAS.gz"
  },
  {
    "accessionId": "DGWAS-3260",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MAJOR_ANOMALI_JAW_SIZE_INCLAVO",
    "phenotype": "Major anomalies of jaw size , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major jaw size anomaly (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MAJOR_ANOMALI_JAW_SIZE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3261",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MALABSORB",
    "phenotype": "Intestinal malabsorption",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal malabsorption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MALABSORB.gz"
  },
  {
    "accessionId": "DGWAS-3267",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MESIAL_BITE",
    "phenotype": "Mesial bite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesial bite",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MESIAL_BITE.gz"
  },
  {
    "accessionId": "DGWAS-3268",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MIH_CARIES",
    "phenotype": "Molar incisor enamel hypoplasia, with caries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Molar incisor hypoplasia with caries",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MIH_CARIES.gz"
  },
  {
    "accessionId": "DGWAS-3269",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MIH_INCLAVO",
    "phenotype": "Molar incisor enamel hypoplasia , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Molar incisor hypoplasia (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MIH_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-327",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_L12_SEBORRKERAT",
    "phenotype": "Seborrhoeic keratosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seborrheic keratosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_L12_SEBORRKERAT.gz"
  },
  {
    "accessionId": "DGWAS-3270",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MISS_TEETH_ACCID_EXTR_PAROD",
    "phenotype": "Missing teeth due to accident, extraction or parodontitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Missing teeth (acquired)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MISS_TEETH_ACCID_EXTR_PAROD.gz"
  },
  {
    "accessionId": "DGWAS-3273",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MN_PROGN_INCLAVO",
    "phenotype": "Mandibular prognathia , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular prognathia (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MN_PROGN_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3275",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_MN_RETRGN_AND_SURG",
    "phenotype": "Mandibular retrognathia AND surgery (BSSRO)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular retrognathia with surgery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_MN_RETRGN_AND_SURG.gz"
  },
  {
    "accessionId": "DGWAS-3277",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OESOBST",
    "phenotype": "Oesophageal obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal obstruction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OESOBST.gz"
  },
  {
    "accessionId": "DGWAS-3278",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OESSTODUO",
    "phenotype": "Diseases of oesophagus, stomach and duodenum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophagus/stomach/duodenum disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OESSTODUO.gz"
  },
  {
    "accessionId": "DGWAS-3281",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OPEN_BITE_INCLAVO",
    "phenotype": "Open bite , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Open bite (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OPEN_BITE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3283",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL",
    "phenotype": "Diseases of oral cavity, salivary glands and jaws",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral/salivary/jaw disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL.gz"
  },
  {
    "accessionId": "DGWAS-3286",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LEUCOPLACIA_INCLAVO",
    "phenotype": "Oral leukoplakia, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral leukoplakia (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LEUCOPLACIA_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3287",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LEUCOPLAC_RELAT",
    "phenotype": "Oral leukoplakia and related diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral leukoplakia/related",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LEUCOPLAC_RELAT.gz"
  },
  {
    "accessionId": "DGWAS-3288",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LEUCOPLAC_RELAT_INCLAVO",
    "phenotype": "Oral leukoplakia and related diseases, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral leukoplakia/related (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LEUCOPLAC_RELAT_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3289",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LICHEN_HYPOT_THYRO",
    "phenotype": "Oral lichen ruber planus, hypothyreosis or thyroxin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral lichen planus with hypothyroidism/thyroxine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LICHEN_HYPOT_THYRO.gz"
  },
  {
    "accessionId": "DGWAS-3290",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LICHEN_PLANUS",
    "phenotype": "Oral lichen ruber planus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral lichen planus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LICHEN_PLANUS.gz"
  },
  {
    "accessionId": "DGWAS-3291",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LICHEN_PLANUS_INCLAVO",
    "phenotype": "Oral lichen ruber planus, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral lichen planus (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LICHEN_PLANUS_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3292",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LICHEN_PLANUS_WIDE",
    "phenotype": "Oral lichen ruber planus, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral lichen planus (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LICHEN_PLANUS_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-3293",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_ORAL_LICHEN_WIDE_HYPOT_THYRO",
    "phenotype": "Oral lichen ruber planus wide, hypothyreosis or thyroxin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral lichen planus wide with hypothyroidism/thyroxine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_ORAL_LICHEN_WIDE_HYPOT_THYRO.gz"
  },
  {
    "accessionId": "DGWAS-3295",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHANRECT",
    "phenotype": "Other diseases of anus and rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorectal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHANRECT.gz"
  },
  {
    "accessionId": "DGWAS-3296",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHAPPEND",
    "phenotype": "Other diseases of appendix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendiceal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHAPPEND.gz"
  },
  {
    "accessionId": "DGWAS-3299",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHDISOES",
    "phenotype": "Other diseases of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHDISOES.gz"
  },
  {
    "accessionId": "DGWAS-3300",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHDISSTOMDUOD",
    "phenotype": "Other diseases of stomach and duodenum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomach/duodenal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHDISSTOMDUOD.gz"
  },
  {
    "accessionId": "DGWAS-3301",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHENTERCOL",
    "phenotype": "Other noninfective gastroenteritis and colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious gastroenteritis/colitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHENTERCOL.gz"
  },
  {
    "accessionId": "DGWAS-3302",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHFUNC",
    "phenotype": "Other functional intestinal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Functional intestinal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHFUNC.gz"
  },
  {
    "accessionId": "DGWAS-3303",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHGASTR",
    "phenotype": "Other gastritis (incl. Duodenitis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastritis/duodenitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHGASTR.gz"
  },
  {
    "accessionId": "DGWAS-3305",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHINFLIV",
    "phenotype": "Other inflammatory liver diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inflammatory liver disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHINFLIV.gz"
  },
  {
    "accessionId": "DGWAS-3306",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHINT",
    "phenotype": "Other diseases of intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHINT.gz"
  },
  {
    "accessionId": "DGWAS-3307",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OTHPERITON",
    "phenotype": "Other diseases of peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OTHPERITON.gz"
  },
  {
    "accessionId": "DGWAS-3308",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_OVERJET",
    "phenotype": "Overjet",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overjet",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_OVERJET.gz"
  },
  {
    "accessionId": "DGWAS-3309",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PANCOTH",
    "phenotype": "Other diseases of pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PANCOTH.gz"
  },
  {
    "accessionId": "DGWAS-3310",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PARALIL",
    "phenotype": "Paralytic ileus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic ileus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PARALIL.gz"
  },
  {
    "accessionId": "DGWAS-3311",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PARODON_OPER",
    "phenotype": "Parodontitis or operation codes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Periodontitis/surgery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PARODON_OPER.gz"
  },
  {
    "accessionId": "DGWAS-3312",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PARODON_OPER_DENTAL_OPER",
    "phenotype": "Parodontitis or/and operation codes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Periodontitis/surgery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PARODON_OPER_DENTAL_OPER.gz"
  },
  {
    "accessionId": "DGWAS-3313",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PARODON_PERIAPIC_CHRONIC",
    "phenotype": "Chronic periapical parodontitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic periapical periodontitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PARODON_PERIAPIC_CHRONIC.gz"
  },
  {
    "accessionId": "DGWAS-3315",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PERIODONTAL_NOS",
    "phenotype": "Periodontal disease, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Periodontal disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PERIODONTAL_NOS.gz"
  },
  {
    "accessionId": "DGWAS-3316",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PERIODON_CHRON",
    "phenotype": "Chronic periodontitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic periodontitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PERIODON_CHRON.gz"
  },
  {
    "accessionId": "DGWAS-3317",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PERIODON_CHRON_COMPL",
    "phenotype": "Chronic periodontitis, complicated",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Complicated chronic periodontitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PERIODON_CHRON_COMPL.gz"
  },
  {
    "accessionId": "DGWAS-3319",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PERITONITIS",
    "phenotype": "Acute peritonitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute peritonitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PERITONITIS.gz"
  },
  {
    "accessionId": "DGWAS-3320",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_POSTOPDIS",
    "phenotype": "Postprocedural disorders of digestive system, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural digestive disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_POSTOPDIS.gz"
  },
  {
    "accessionId": "DGWAS-3321",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PSC_COLITIS_STRICT",
    "phenotype": "Colitis, primary sclerosing, strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary sclerosing colitis (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PSC_COLITIS_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-3323",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PULPITIS_1_ONLYAVO",
    "phenotype": "Dental pulpitis 1, only avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulpitis (avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PULPITIS_1_ONLYAVO.gz"
  },
  {
    "accessionId": "DGWAS-3325",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_PULP_PERIAPICAL",
    "phenotype": "Diseases of pulp and periapical tissues",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulp/periapical disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_PULP_PERIAPICAL.gz"
  },
  {
    "accessionId": "DGWAS-3326",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_REFLUX",
    "phenotype": "Gastro-oesophageal reflux disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GERD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_REFLUX.gz"
  },
  {
    "accessionId": "DGWAS-3327",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_REIMB_202",
    "phenotype": "KELA_REIMBURSEMENT_202",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "KELA reimbursement code 202",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_REIMB_202.gz"
  },
  {
    "accessionId": "DGWAS-3329",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_RETROG_MAXILLAE_INCLAVO",
    "phenotype": "Maxillary retrognathism , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maxillary retrognathism (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_RETROG_MAXILLAE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3331",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_SCISS_BITE_INCLAVO",
    "phenotype": "Scissor bite , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scissor bite (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_SCISS_BITE_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3332",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_STOMATITIS",
    "phenotype": "Stomatitis and related lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_STOMATITIS.gz"
  },
  {
    "accessionId": "DGWAS-3336",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_TEETH_HARD_NOS",
    "phenotype": "Disease of hard tissues of teeth, NOS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental hard tissue disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_TEETH_HARD_NOS.gz"
  },
  {
    "accessionId": "DGWAS-3337",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_TOOTH_DEV",
    "phenotype": "Disorders of tooth development and eruption",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth development/eruption disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_TOOTH_DEV.gz"
  },
  {
    "accessionId": "DGWAS-3339",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_UC_STRICT2",
    "phenotype": "Ulcerative colitis (strict definition, require KELA, min 2 HDR)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis (strict, KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_UC_STRICT2.gz"
  },
  {
    "accessionId": "DGWAS-3340",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_UC_STRICT_PSC",
    "phenotype": "Ulcerative colitis (strict) with PSC",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis strict with PSC",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_UC_STRICT_PSC.gz"
  },
  {
    "accessionId": "DGWAS-3341",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_K11_UMBHER",
    "phenotype": "Umbilical hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Umbilical hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_K11_UMBHER.gz"
  },
  {
    "accessionId": "DGWAS-3345",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KELA_DIAB_INSUL_EXMORE",
    "phenotype": "Diabetes, insulin treatment (Kela reimbursement) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes with insulin (KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KELA_DIAB_INSUL_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3346",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_ALCOH_EXMORE",
    "phenotype": "Alcohol abuse, main dg (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol abuse (main diagnosis)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_ALCOH_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3348",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_ANYMENTAL",
    "phenotype": "Any mental disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Any mental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_ANYMENTAL.gz"
  },
  {
    "accessionId": "DGWAS-3349",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_ANYMENTAL_SUICID_PREG_NERV_EXMORE",
    "phenotype": "Any mental disorder, or suicide (or attempt), or psychic disorders complicating pregnancy, partum or puerperium or nerve system disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mental disorder/suicide/perinatal/neurologic",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_ANYMENTAL_SUICID_PREG_NERV_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3352",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_CHILDEMOT_EXMORE",
    "phenotype": "Emotional disorders starting during childhood or adolescence (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood emotional disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_CHILDEMOT_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3353",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_CHILDOTH_EXMORE",
    "phenotype": "Other disorders starting during childhood or adolescence (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_CHILDOTH_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3355",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_CODUCTEMOT_EXMORE",
    "phenotype": "Mixed disorders of conduct and emotions (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed conduct/emotional disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_CODUCTEMOT_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3357",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_DEVWIDE_EXMORE",
    "phenotype": "Wide developmental disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pervasive developmental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_DEVWIDE_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3358",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_EATING_EXMORE",
    "phenotype": "KRA_PSY_EATING (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eating disorder (KRA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_EATING_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3359",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_HYPERKIN_EXMORE",
    "phenotype": "Hyperkinetic disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperkinetic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_HYPERKIN_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3360",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_MENTALRET_EXMORE",
    "phenotype": "Mental retardation (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intellectual disability",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_MENTALRET_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3362",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_PERSON_EXMORE",
    "phenotype": "Personality disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_PERSON_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3363",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_PUERPER_EXMORE",
    "phenotype": "Mental and behavioural disorders of puerperium, not classified elsewhere (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum mental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_PUERPER_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3364",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_SCHIZODEL_EXMORE",
    "phenotype": "Schizophrenia or delusion (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia/delusional disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_SCHIZODEL_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3365",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_SLEEP_NONORG_EXMORE",
    "phenotype": "Nonorganic sleeping disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonorganic sleep disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_SLEEP_NONORG_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3366",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_SPEELING_EXMORE",
    "phenotype": "Speech and linguistic disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Speech/language disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_SPEELING_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3367",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_SUBSTANCE_EXMORE",
    "phenotype": "Substance abuse (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Substance abuse",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_SUBSTANCE_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3368",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_TIC",
    "phenotype": "Tic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_TIC.gz"
  },
  {
    "accessionId": "DGWAS-3369",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_KRA_PSY_TIC_EXMORE",
    "phenotype": "Tic disorders (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_KRA_PSY_TIC_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3370",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ABSCESS_CUT",
    "phenotype": "Cutaneous abscess, furuncle and carbuncle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin abscess/furuncle/carbuncle",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ABSCESS_CUT.gz"
  },
  {
    "accessionId": "DGWAS-3371",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ACANTHNIGRICANS",
    "phenotype": "Acanthosis nigricans",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acanthosis nigricans",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ACANTHNIGRICANS.gz"
  },
  {
    "accessionId": "DGWAS-3372",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ACNE",
    "phenotype": "Acne",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ACNE.gz"
  },
  {
    "accessionId": "DGWAS-3373",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ACNE_CONGLOBLATA",
    "phenotype": "Acne conglobata",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne conglobata",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ACNE_CONGLOBLATA.gz"
  },
  {
    "accessionId": "DGWAS-3376",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ACTINKERA",
    "phenotype": "Actinic keratosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Actinic keratosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ACTINKERA.gz"
  },
  {
    "accessionId": "DGWAS-3377",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ALLERGICCONTACT",
    "phenotype": "Allergic contact dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic contact dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ALLERGICCONTACT.gz"
  },
  {
    "accessionId": "DGWAS-3379",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ALOPECAREATA",
    "phenotype": "Alopecia areata",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alopecia areata",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ALOPECAREATA.gz"
  },
  {
    "accessionId": "DGWAS-3381",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ATOPIC",
    "phenotype": "Atopic dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atopic dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ATOPIC.gz"
  },
  {
    "accessionId": "DGWAS-3382",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ATROPHICSKIN",
    "phenotype": "Atrophic disorders of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrophic skin disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ATROPHICSKIN.gz"
  },
  {
    "accessionId": "DGWAS-3384",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_BULLOTH",
    "phenotype": "Other bullous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bullous disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_BULLOTH.gz"
  },
  {
    "accessionId": "DGWAS-3385",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_BULLOUS",
    "phenotype": "Bullous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bullous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_BULLOUS.gz"
  },
  {
    "accessionId": "DGWAS-3389",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_CORNSANDCALLOS",
    "phenotype": "Corns and callosities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corns/callosities",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_CORNSANDCALLOS.gz"
  },
  {
    "accessionId": "DGWAS-3393",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_DERMATITISECZEMA",
    "phenotype": "Dermatitis and eczema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatitis/eczema",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_DERMATITISECZEMA.gz"
  },
  {
    "accessionId": "DGWAS-3397",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_DYSHIDROSIS",
    "phenotype": "Dyshidrosis [pompholyx]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dyshidrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_DYSHIDROSIS.gz"
  },
  {
    "accessionId": "DGWAS-3399",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_EPIDERMTHICKNAS",
    "phenotype": "Other and unspecified epidermal thickening",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epidermal thickening NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_EPIDERMTHICKNAS.gz"
  },
  {
    "accessionId": "DGWAS-34",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_ARTHROSIS_KNEE_PRIM_KNEESURG",
    "phenotype": "Gonarthrosis, primary, with knee surgery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary knee osteoarthritis with surgery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_ARTHROSIS_KNEE_PRIM_KNEESURG.gz"
  },
  {
    "accessionId": "DGWAS-3400",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ERYTHEMAMULTIF",
    "phenotype": "Erythema multiforme",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erythema multiforme",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ERYTHEMAMULTIF.gz"
  },
  {
    "accessionId": "DGWAS-3401",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ERYTHEMANODOSUM",
    "phenotype": "Erythema nodosum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erythema nodosum",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ERYTHEMANODOSUM.gz"
  },
  {
    "accessionId": "DGWAS-3403",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ERYTHRO_KELA",
    "phenotype": "Universal erythroderma, KELA reimbursement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Universal erythroderma (KELA)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ERYTHRO_KELA.gz"
  },
  {
    "accessionId": "DGWAS-3404",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ERYT_INTERTRIG",
    "phenotype": "Erythema intertrigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intertrigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ERYT_INTERTRIG.gz"
  },
  {
    "accessionId": "DGWAS-3406",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_FACTITIALDERMAT",
    "phenotype": "Factitial dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Factitial dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_FACTITIALDERMAT.gz"
  },
  {
    "accessionId": "DGWAS-3410",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_FOODDERMAT",
    "phenotype": "Dermatitis due to ingested food",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Food-induced dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_FOODDERMAT.gz"
  },
  {
    "accessionId": "DGWAS-3411",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_FOREIGNBODYGRANULOMA",
    "phenotype": "Foreign body granuloma of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Foreign body granuloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_FOREIGNBODYGRANULOMA.gz"
  },
  {
    "accessionId": "DGWAS-3412",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_GRANUANNU",
    "phenotype": "Granuloma annulare",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Granuloma annulare",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_GRANUANNU.gz"
  },
  {
    "accessionId": "DGWAS-3414",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_GRANULOMATOUSSKIN",
    "phenotype": "Granulomatous disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Granulomatous skin disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_GRANULOMATOUSSKIN.gz"
  },
  {
    "accessionId": "DGWAS-3419",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_HIDRADENITISSUP",
    "phenotype": "Hidradenitis suppurativa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hidradenitis suppurativa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_HIDRADENITISSUP.gz"
  },
  {
    "accessionId": "DGWAS-342",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEU_ARTHRITIS_OTH",
    "phenotype": "Other arthritis (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthritis NOS (FG)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEU_ARTHRITIS_OTH.gz"
  },
  {
    "accessionId": "DGWAS-3420",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_HIRSUTISM",
    "phenotype": "Hirsutism in women",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hirsutism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_HIRSUTISM.gz"
  },
  {
    "accessionId": "DGWAS-3425",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_INFECT_DERM",
    "phenotype": "Infective dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infective dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_INFECT_DERM.gz"
  },
  {
    "accessionId": "DGWAS-3426",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_INFECT_SKIN",
    "phenotype": "Infections of the skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin/subcutaneous infection",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_INFECT_SKIN.gz"
  },
  {
    "accessionId": "DGWAS-3428",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_INTERNALSUBSTANCEDERM",
    "phenotype": "Dermatitis due to substances taken internally",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic drug-induced dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_INTERNALSUBSTANCEDERM.gz"
  },
  {
    "accessionId": "DGWAS-3429",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LICHENPLANUS",
    "phenotype": "Lichen planus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen planus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LICHENPLANUS.gz"
  },
  {
    "accessionId": "DGWAS-343",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_VACTREL",
    "phenotype": "Vertebral, anorectal, cardiavascular, thracheoesophagial, renal and limb anomaly",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple congenital anomalies",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_VACTREL.gz"
  },
  {
    "accessionId": "DGWAS-3430",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LICHENPLANUS_INCLAVO",
    "phenotype": "Lichen planus, including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen planus (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LICHENPLANUS_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3431",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LICHENSCLERATROPH",
    "phenotype": "Lichen sclerosus et atrophicus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen sclerosus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LICHENSCLERATROPH.gz"
  },
  {
    "accessionId": "DGWAS-3432",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LICHENSIMPLEX",
    "phenotype": "Lichen simplex chronicus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen simplex chronicus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LICHENSIMPLEX.gz"
  },
  {
    "accessionId": "DGWAS-3433",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LICHSIMPANDPRURIGO",
    "phenotype": "Lichen simplex chronicus and prurigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen simplex/prurigo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LICHSIMPANDPRURIGO.gz"
  },
  {
    "accessionId": "DGWAS-3438",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LUPUS",
    "phenotype": "Lupus erythematosus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lupus erythematosus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LUPUS.gz"
  },
  {
    "accessionId": "DGWAS-3439",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_LYMPHADENITIS",
    "phenotype": "Acute lymphadenitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute lymphadenitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_LYMPHADENITIS.gz"
  },
  {
    "accessionId": "DGWAS-344",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_SEPTA_DEFEC",
    "phenotype": "Septal defects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Septal defect",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_SEPTA_DEFEC.gz"
  },
  {
    "accessionId": "DGWAS-3440",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_NAILDIS",
    "phenotype": "Nail disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nail disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_NAILDIS.gz"
  },
  {
    "accessionId": "DGWAS-3443",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_NAIL_INGROW",
    "phenotype": "Ingrowing nail",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ingrown nail",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_NAIL_INGROW.gz"
  },
  {
    "accessionId": "DGWAS-3445",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_NECROLIPOIDIC",
    "phenotype": "Necrobiosis lipoidica, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Necrobiosis lipoidica",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_NECROLIPOIDIC.gz"
  },
  {
    "accessionId": "DGWAS-3446",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_NONIONRADISKINNAS",
    "phenotype": "Other and unspecified skin changes due to chronic exposure to nonionizing radiation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic radiation skin change",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_NONIONRADISKINNAS.gz"
  },
  {
    "accessionId": "DGWAS-3447",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_OTHACUSKINSUN",
    "phenotype": "Other acute skin changes due to ultraviolet radiation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute UV skin change",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_OTHACUSKINSUN.gz"
  },
  {
    "accessionId": "DGWAS-3449",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_OTHERBULL",
    "phenotype": "Other and unspecified bullous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bullous disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_OTHERBULL.gz"
  },
  {
    "accessionId": "DGWAS-345",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_RETI",
    "phenotype": "Congenital retinoschisis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital retinoschisis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_RETI.gz"
  },
  {
    "accessionId": "DGWAS-3450",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_OTHERCONTACT",
    "phenotype": "Other contact dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Contact dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_OTHERCONTACT.gz"
  },
  {
    "accessionId": "DGWAS-3452",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_OTHERINFILTRATIVESKIN",
    "phenotype": "Other infiltrative disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infiltrative skin disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_OTHERINFILTRATIVESKIN.gz"
  },
  {
    "accessionId": "DGWAS-3454",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_OTHERSKINSUBCUTIS",
    "phenotype": "Other disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin/subcutaneous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_OTHERSKINSUBCUTIS.gz"
  },
  {
    "accessionId": "DGWAS-3456",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PAPULOSQUAMOUS",
    "phenotype": "Papulosquamous disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Papulosquamous disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PAPULOSQUAMOUS.gz"
  },
  {
    "accessionId": "DGWAS-3459",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PARAPSORI",
    "phenotype": "Parapsoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parapsoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PARAPSORI.gz"
  },
  {
    "accessionId": "DGWAS-346",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_POSTERI_SEGMENT_EYE",
    "phenotype": "Congenital malformations of posterior segment of eye",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital posterior segment malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_POSTERI_SEGMENT_EYE.gz"
  },
  {
    "accessionId": "DGWAS-3462",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PEMPHIGOID_BULL",
    "phenotype": "Bullous pemphigoid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bullous pemphigoid",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PEMPHIGOID_BULL.gz"
  },
  {
    "accessionId": "DGWAS-3463",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PEMPHIGOID_NAS",
    "phenotype": "Other and unspecified pemphigoid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pemphigoid NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PEMPHIGOID_NAS.gz"
  },
  {
    "accessionId": "DGWAS-3464",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PEMPHIGUS",
    "phenotype": "Pemphigus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pemphigus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PEMPHIGUS.gz"
  },
  {
    "accessionId": "DGWAS-3468",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PILONIDALCYST",
    "phenotype": "Pilonidal cyst",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pilonidal cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PILONIDALCYST.gz"
  },
  {
    "accessionId": "DGWAS-3469",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PITYROCHEA",
    "phenotype": "Pityriasis rosea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pityriasis rosea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PITYROCHEA.gz"
  },
  {
    "accessionId": "DGWAS-347",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_ASD",
    "phenotype": "Atrial septal defect",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ASD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_ASD.gz"
  },
  {
    "accessionId": "DGWAS-3470",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_POLYMORPHLIGHTERUPT",
    "phenotype": "Polymorphous light eruption",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polymorphous light eruption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_POLYMORPHLIGHTERUPT.gz"
  },
  {
    "accessionId": "DGWAS-3471",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PRURIGONAS",
    "phenotype": "Other  prurigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prurigo NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PRURIGONAS.gz"
  },
  {
    "accessionId": "DGWAS-3473",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PRURITUS",
    "phenotype": "Pruritus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pruritus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PRURITUS.gz"
  },
  {
    "accessionId": "DGWAS-3474",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PSORIASIS",
    "phenotype": "Psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PSORIASIS.gz"
  },
  {
    "accessionId": "DGWAS-3475",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PSORI_GUTTATE",
    "phenotype": "Guttate psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Guttate psoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PSORI_GUTTATE.gz"
  },
  {
    "accessionId": "DGWAS-3477",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PSORI_PUSTGEN",
    "phenotype": "Generalized pustular psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized pustular psoriasis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PSORI_PUSTGEN.gz"
  },
  {
    "accessionId": "DGWAS-3478",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PSORI_PUSTUPALM",
    "phenotype": "Pustulosis palmaris et plantaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Palmoplantar pustulosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PSORI_PUSTUPALM.gz"
  },
  {
    "accessionId": "DGWAS-3479",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PSORI_VULG",
    "phenotype": "Psoriasis vulgaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis vulgaris",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PSORI_VULG.gz"
  },
  {
    "accessionId": "DGWAS-348",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_PSORI_STRICT",
    "phenotype": "Psoriasis (vulgaris), strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis vulgaris (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_PSORI_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-3480",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PYODERMA",
    "phenotype": "Pyoderma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyoderma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PYODERMA.gz"
  },
  {
    "accessionId": "DGWAS-3482",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_PYOGENGRANUL",
    "phenotype": "Pyogenic granuloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic granuloma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_PYOGENGRANUL.gz"
  },
  {
    "accessionId": "DGWAS-3483",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_RHINOPHYMA",
    "phenotype": "Rhinophyma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rhinophyma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_RHINOPHYMA.gz"
  },
  {
    "accessionId": "DGWAS-3484",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ROSACEANAS",
    "phenotype": "Other and unspecified rosacea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rosacea NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ROSACEANAS.gz"
  },
  {
    "accessionId": "DGWAS-3486",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_SEBORRHOEIC",
    "phenotype": "Seborrhoeic dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seborrheic dermatitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_SEBORRHOEIC.gz"
  },
  {
    "accessionId": "DGWAS-3488",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_SKINSUBCUTISNAS",
    "phenotype": "Other and unspecified disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin/subcutaneous disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_SKINSUBCUTISNAS.gz"
  },
  {
    "accessionId": "DGWAS-349",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PREG_OTHER_MAT_DISORD",
    "phenotype": "Other maternal disorders predominantly related to pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal pregnancy disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PREG_OTHER_MAT_DISORD.gz"
  },
  {
    "accessionId": "DGWAS-3490",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_ULCERLOWLIMB",
    "phenotype": "Ulcer of lower limb, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_ULCERLOWLIMB.gz"
  },
  {
    "accessionId": "DGWAS-3492",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_URTICA_ALLERG",
    "phenotype": "Allergic urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_URTICA_ALLERG.gz"
  },
  {
    "accessionId": "DGWAS-3495",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_URTICA_DERTMATOG",
    "phenotype": "Dermatographic urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatographism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_URTICA_DERTMATOG.gz"
  },
  {
    "accessionId": "DGWAS-3496",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_URTICA_IDIOPAT",
    "phenotype": "Idiopathic urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic urticaria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_URTICA_IDIOPAT.gz"
  },
  {
    "accessionId": "DGWAS-3499",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_VITILIGO",
    "phenotype": "Vitiligo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitiligo",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_VITILIGO.gz"
  },
  {
    "accessionId": "DGWAS-350",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_PREECLAMPS",
    "phenotype": "Pre-eclampsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_PREECLAMPS.gz"
  },
  {
    "accessionId": "DGWAS-3500",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_L12_XEROSCUT",
    "phenotype": "Xerosis cutis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Xerosis cutis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_L12_XEROSCUT.gz"
  },
  {
    "accessionId": "DGWAS-3501",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_LOCALIZED_SKIN_ERUPT_DRUGS_MEDICAM",
    "phenotype": "Localized skin eruption due to drugs and medicaments",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Localized drug eruption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_LOCALIZED_SKIN_ERUPT_DRUGS_MEDICAM.gz"
  },
  {
    "accessionId": "DGWAS-3502",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ABSCTENDON",
    "phenotype": "Abscess of tendon sheath",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tendon sheath abscess",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ABSCTENDON.gz"
  },
  {
    "accessionId": "DGWAS-3503",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ACHILLESTEND",
    "phenotype": "Achilles tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Achilles tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ACHILLESTEND.gz"
  },
  {
    "accessionId": "DGWAS-3505",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ALGONEURO",
    "phenotype": "Algoneurodystrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Algoneurodystrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ALGONEURO.gz"
  },
  {
    "accessionId": "DGWAS-3507",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ANKYLOSISJOINT",
    "phenotype": "Ankylosis of joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint ankylosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ANKYLOSISJOINT.gz"
  },
  {
    "accessionId": "DGWAS-351",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_RENFAIL",
    "phenotype": "Renal failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal failure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_RENFAIL.gz"
  },
  {
    "accessionId": "DGWAS-3510",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHINOTH",
    "phenotype": "Arthropathies in other diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3511",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHROPATHIES",
    "phenotype": "Arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHROPATHIES.gz"
  },
  {
    "accessionId": "DGWAS-3512",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHROSIS",
    "phenotype": "Arthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHROSIS.gz"
  },
  {
    "accessionId": "DGWAS-3517",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHROSIS_POLY",
    "phenotype": "Polyarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarthrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHROSIS_POLY.gz"
  },
  {
    "accessionId": "DGWAS-3518",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHTROSIS_COX",
    "phenotype": "Coxarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip osteoarthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHTROSIS_COX.gz"
  },
  {
    "accessionId": "DGWAS-3519",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHTROSIS_COX_PRIM_HIPSURG",
    "phenotype": "Coxarthrosis, primary, with hip surgery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary hip OA with surgery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHTROSIS_COX_PRIM_HIPSURG.gz"
  },
  {
    "accessionId": "DGWAS-352",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_FEMALE_GENITAL_LSIL",
    "phenotype": "LSIL lesion of the cervix uteri, vagina or vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "LSIL (cervix/vagina/vulva)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_FEMALE_GENITAL_LSIL.gz"
  },
  {
    "accessionId": "DGWAS-3520",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ARTHTROSIS_COX_PRIM_ICD10",
    "phenotype": "Coxarthrosis, primary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary hip OA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ARTHTROSIS_COX_PRIM_ICD10.gz"
  },
  {
    "accessionId": "DGWAS-3521",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ATLOAXSUBLUX",
    "phenotype": "Atlantoaxial subluxation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atlantoaxial subluxation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ATLOAXSUBLUX.gz"
  },
  {
    "accessionId": "DGWAS-3523",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BEHCET",
    "phenotype": "Behcet's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behcet disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BEHCET.gz"
  },
  {
    "accessionId": "DGWAS-3526",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BONECONTINUITY",
    "phenotype": "Disorders of continuity of bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone continuity disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BONECONTINUITY.gz"
  },
  {
    "accessionId": "DGWAS-3529",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BONEHYPERTRPH",
    "phenotype": "Hypertrophy of bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BONEHYPERTRPH.gz"
  },
  {
    "accessionId": "DGWAS-353",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_CHRONKIDNEYDIS",
    "phenotype": "Chronic kidney disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic kidney disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_CHRONKIDNEYDIS.gz"
  },
  {
    "accessionId": "DGWAS-3532",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BURSITISHIPOTH",
    "phenotype": "Other bursitis of hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BURSITISHIPOTH.gz"
  },
  {
    "accessionId": "DGWAS-3533",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BURSITISKNEEOTH",
    "phenotype": "Other bursitis of knee",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BURSITISKNEEOTH.gz"
  },
  {
    "accessionId": "DGWAS-3534",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BURSITISOTH",
    "phenotype": "Other bursitis, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bursitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BURSITISOTH.gz"
  },
  {
    "accessionId": "DGWAS-3535",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_BURSOPATHY",
    "phenotype": "Other bursopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bursopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_BURSOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-3537",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CALCIFICTEND",
    "phenotype": "Calcific tendinitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Calcific shoulder tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CALCIFICTEND.gz"
  },
  {
    "accessionId": "DGWAS-3538",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CALCTENDINITIS",
    "phenotype": "Calcific tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Calcific tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CALCTENDINITIS.gz"
  },
  {
    "accessionId": "DGWAS-354",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_TRIGGERFINGER",
    "phenotype": "Trigger finger",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigger finger",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_TRIGGERFINGER.gz"
  },
  {
    "accessionId": "DGWAS-3540",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CERVICALGIA",
    "phenotype": "Cervicalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CERVICALGIA.gz"
  },
  {
    "accessionId": "DGWAS-3542",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CERVICOBRACHSDR",
    "phenotype": "Cervicobrachial syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicobrachial syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CERVICOBRACHSDR.gz"
  },
  {
    "accessionId": "DGWAS-3543",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CERVICOCRANSDR",
    "phenotype": "Cervicocranial syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicocranial syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CERVICOCRANSDR.gz"
  },
  {
    "accessionId": "DGWAS-3544",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CHONDROMALACIA",
    "phenotype": "Chondromalacia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondromalacia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CHONDROMALACIA.gz"
  },
  {
    "accessionId": "DGWAS-3547",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CHURGSTRAUSS",
    "phenotype": "Polyarteritis with lung involvement [Churg-Strauss]/EGPA",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "EGPA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CHURGSTRAUSS.gz"
  },
  {
    "accessionId": "DGWAS-3549",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CONNECTNAS",
    "phenotype": "Other specified/unspecified systemic involvement of connective tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic CTD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CONNECTNAS.gz"
  },
  {
    "accessionId": "DGWAS-355",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_LIMBPAIN",
    "phenotype": "Pain in limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Limb pain",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_LIMBPAIN.gz"
  },
  {
    "accessionId": "DGWAS-3550",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CONTRACTUREJOINT",
    "phenotype": "Contracture of joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint contracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CONTRACTUREJOINT.gz"
  },
  {
    "accessionId": "DGWAS-3551",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_CRYSTALARTH",
    "phenotype": "Other crystal arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crystal arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_CRYSTALARTH.gz"
  },
  {
    "accessionId": "DGWAS-3553",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DEFORMDORSO",
    "phenotype": "Deforming dorsopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deforming dorsopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DEFORMDORSO.gz"
  },
  {
    "accessionId": "DGWAS-3555",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DEQUERVAIN",
    "phenotype": "Radial styloid tenosynovitis [de Quervain]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "De Quervain tenosynovitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DEQUERVAIN.gz"
  },
  {
    "accessionId": "DGWAS-3556",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DERMATOMYOTH",
    "phenotype": "Other dermatomyositis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatomyositis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DERMATOMYOTH.gz"
  },
  {
    "accessionId": "DGWAS-3559",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DISCINFECTION",
    "phenotype": "Infection of intervertebral disc (pyogenic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic discitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DISCINFECTION.gz"
  },
  {
    "accessionId": "DGWAS-356",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_M13_HAMMERTOE",
    "phenotype": "Other hammer toe(s) (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired hammer toe",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_M13_HAMMERTOE.gz"
  },
  {
    "accessionId": "DGWAS-3560",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DISCITIS",
    "phenotype": "Discitis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Discitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DISCITIS.gz"
  },
  {
    "accessionId": "DGWAS-3563",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DORSALGIANAS",
    "phenotype": "Other/unspecified dorsalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsalgia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DORSALGIANAS.gz"
  },
  {
    "accessionId": "DGWAS-3564",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DORSOPATHY",
    "phenotype": "Dorsopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DORSOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-3565",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DORSOPATHYNAS",
    "phenotype": "Other specified/unspecified dorsopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DORSOPATHYNAS.gz"
  },
  {
    "accessionId": "DGWAS-3566",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DORSOPATHYOTH",
    "phenotype": "Other dorsopathies, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DORSOPATHYOTH.gz"
  },
  {
    "accessionId": "DGWAS-3567",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_DUPUTRYEN",
    "phenotype": "Palmar fascial fibromatosis [Dupuytren]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dupuytren contracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_DUPUTRYEN.gz"
  },
  {
    "accessionId": "DGWAS-3568",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_EARLY_LUMBAR_PROLAPSE",
    "phenotype": "Early lumbar disc prolapse, operated",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early lumbar disc prolapse (operated)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_EARLY_LUMBAR_PROLAPSE.gz"
  },
  {
    "accessionId": "DGWAS-3569",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ENTEROARTHR",
    "phenotype": "Enteropathic arthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enteropathic arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ENTEROARTHR.gz"
  },
  {
    "accessionId": "DGWAS-3570",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ENTESOPATHYLOW",
    "phenotype": "Enthesopathies of lower limb, excluding foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb enthesopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ENTESOPATHYLOW.gz"
  },
  {
    "accessionId": "DGWAS-3571",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ENTESOPATHYLOWNAS",
    "phenotype": "Other/unspecified enthesopathies of lower limb, excluding foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb enthesopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ENTESOPATHYLOWNAS.gz"
  },
  {
    "accessionId": "DGWAS-3572",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ENTESOPATHYNAS",
    "phenotype": "Other/unspecified enthesopathies, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enthesopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ENTESOPATHYNAS.gz"
  },
  {
    "accessionId": "DGWAS-3573",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ENTESOPATHYOTH",
    "phenotype": "Other enthesopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enthesopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ENTESOPATHYOTH.gz"
  },
  {
    "accessionId": "DGWAS-3574",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FATIGFRACT",
    "phenotype": "Fatigue fracture of vertebra",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertebral fatigue fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FATIGFRACT.gz"
  },
  {
    "accessionId": "DGWAS-3575",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FATPADHYPERTROPHY",
    "phenotype": "Hypertrophy of (infrapatellar) fat pad",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infrapatellar fat pad hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FATPADHYPERTROPHY.gz"
  },
  {
    "accessionId": "DGWAS-3576",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FIBROBLASTIC",
    "phenotype": "Fibroblastic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibroblastic disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FIBROBLASTIC.gz"
  },
  {
    "accessionId": "DGWAS-3578",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FIBROMYALGIA",
    "phenotype": "Fibromyalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibromyalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FIBROMYALGIA.gz"
  },
  {
    "accessionId": "DGWAS-3580",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FLATFOOT",
    "phenotype": "Flat foot [pes planus] (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired flat foot",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FLATFOOT.gz"
  },
  {
    "accessionId": "DGWAS-3581",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FOREIGNBODY",
    "phenotype": "Residual foreign body in soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Residual foreign body",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FOREIGNBODY.gz"
  },
  {
    "accessionId": "DGWAS-3582",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_FORESTIER",
    "phenotype": "Ankylosing hyperostosis [Forestier]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Forestier disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_FORESTIER.gz"
  },
  {
    "accessionId": "DGWAS-3583",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_GANGLION",
    "phenotype": "Ganglion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ganglion cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_GANGLION.gz"
  },
  {
    "accessionId": "DGWAS-3584",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_GIANTCELL",
    "phenotype": "Giant cell arteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Giant cell arteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_GIANTCELL.gz"
  },
  {
    "accessionId": "DGWAS-3585",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_GLUTEALTEND",
    "phenotype": "Gluteal tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gluteal tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_GLUTEALTEND.gz"
  },
  {
    "accessionId": "DGWAS-3587",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_HALLUDEFORMOTH",
    "phenotype": "Other deformity of hallux (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired hallux deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_HALLUDEFORMOTH.gz"
  },
  {
    "accessionId": "DGWAS-3588",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_HALLUXRIGIDUS",
    "phenotype": "Hallux rigidus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux rigidus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_HALLUXRIGIDUS.gz"
  },
  {
    "accessionId": "DGWAS-3589",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_HALLUXVALGUS",
    "phenotype": "Hallux valgus (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux valgus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_HALLUXVALGUS.gz"
  },
  {
    "accessionId": "DGWAS-3592",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_HYPERANG",
    "phenotype": "Hypersensitivity angiitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypersensitivity angiitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_HYPERANG.gz"
  },
  {
    "accessionId": "DGWAS-3595",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_IMPINGEMENT",
    "phenotype": "Impingement syndrome of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder impingement",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_IMPINGEMENT.gz"
  },
  {
    "accessionId": "DGWAS-3598",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_INTERVERTEB",
    "phenotype": "Other intervertebral disc disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intervertebral disc disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_INTERVERTEB.gz"
  },
  {
    "accessionId": "DGWAS-3599",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_JUVERHEU",
    "phenotype": "Juvenile rheuma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Juvenile rheumatic disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_JUVERHEU.gz"
  },
  {
    "accessionId": "DGWAS-3600",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_JUVOSTEOCHONRHIP",
    "phenotype": "Juvenile osteochondrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Juvenile osteochondrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_JUVOSTEOCHONRHIP.gz"
  },
  {
    "accessionId": "DGWAS-3602",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_KYPHOSIS",
    "phenotype": "Kyphosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kyphosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_KYPHOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3603",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_LATERALEPICOND",
    "phenotype": "Lateral epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lateral epicondylitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_LATERALEPICOND.gz"
  },
  {
    "accessionId": "DGWAS-3612",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MENISCUSDERANGEMENTS",
    "phenotype": "Meniscus derangement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meniscus derangement",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MENISCUSDERANGEMENTS.gz"
  },
  {
    "accessionId": "DGWAS-3613",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_METATARSALGIA",
    "phenotype": "Metatarsalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metatarsalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_METATARSALGIA.gz"
  },
  {
    "accessionId": "DGWAS-3615",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MONOARTHRITIS",
    "phenotype": "Monoarthritis, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Monoarthritis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MONOARTHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-3616",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MULTIFIBRO",
    "phenotype": "Multifocal fibrosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multifocal fibrosclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MULTIFIBRO.gz"
  },
  {
    "accessionId": "DGWAS-3617",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MUSCLE",
    "phenotype": "Disorders of muscles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MUSCLE.gz"
  },
  {
    "accessionId": "DGWAS-3618",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MUSCLEATROPH",
    "phenotype": "Muscle wasting and atrophy, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle wasting/atrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MUSCLEATROPH.gz"
  },
  {
    "accessionId": "DGWAS-3619",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MUSCLEDISNAS",
    "phenotype": "Other specified disorders of muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MUSCLEDISNAS.gz"
  },
  {
    "accessionId": "DGWAS-3621",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MUSCONTRAC",
    "phenotype": "Contracture of muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle contracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MUSCONTRAC.gz"
  },
  {
    "accessionId": "DGWAS-3622",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MUSCULOSKELEOTH",
    "phenotype": "Other disorders of the musculoskeletal system and connective tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Musculoskeletal/CT disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MUSCULOSKELEOTH.gz"
  },
  {
    "accessionId": "DGWAS-3623",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MYALGIA",
    "phenotype": "Myalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myalgia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MYALGIA.gz"
  },
  {
    "accessionId": "DGWAS-3624",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_MYOSITIS",
    "phenotype": "Myositis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myositis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_MYOSITIS.gz"
  },
  {
    "accessionId": "DGWAS-3628",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OLECRANONBURSITIS",
    "phenotype": "Olecranon bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Olecranon bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OLECRANONBURSITIS.gz"
  },
  {
    "accessionId": "DGWAS-3629",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEOCHONDRO",
    "phenotype": "Osteopathies and chondropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteopathy/chondropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEOCHONDRO.gz"
  },
  {
    "accessionId": "DGWAS-3630",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEOCHONDROPATHY",
    "phenotype": "Other osteochondropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteochondropathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEOCHONDROPATHY.gz"
  },
  {
    "accessionId": "DGWAS-3632",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEOMYELITIS",
    "phenotype": "Osteomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteomyelitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEOMYELITIS.gz"
  },
  {
    "accessionId": "DGWAS-3633",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEOMYELVERTEB",
    "phenotype": "Osteomyelitis of vertebra",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertebral osteomyelitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEOMYELVERTEB.gz"
  },
  {
    "accessionId": "DGWAS-3634",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEONECROSIS",
    "phenotype": "Osteonecrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteonecrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEONECROSIS.gz"
  },
  {
    "accessionId": "DGWAS-3635",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OSTEOPATHYINOTH",
    "phenotype": "Osteopathy in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary osteopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OSTEOPATHYINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3639",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_OVERLAP",
    "phenotype": "Other overlap syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overlap syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_OVERLAP.gz"
  },
  {
    "accessionId": "DGWAS-3642",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PALINDROMIC",
    "phenotype": "Palindromic rheumatism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Palindromic rheumatism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PALINDROMIC.gz"
  },
  {
    "accessionId": "DGWAS-3643",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PANNICULITIS",
    "phenotype": "Panniculitis affecting regions of neck and back",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panniculitis of neck/back",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PANNICULITIS.gz"
  },
  {
    "accessionId": "DGWAS-3646",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PATELLAOTH",
    "phenotype": "Other disorders of patella",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Patellar disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PATELLAOTH.gz"
  },
  {
    "accessionId": "DGWAS-3647",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PATELLARTEND",
    "phenotype": "Patellar tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Patellar tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PATELLARTEND.gz"
  },
  {
    "accessionId": "DGWAS-3648",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PERONEALTEND",
    "phenotype": "Peroneal tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peroneal tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PERONEALTEND.gz"
  },
  {
    "accessionId": "DGWAS-3649",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PLANTARFASC",
    "phenotype": "Plantar fascial fibromatosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Plantar fibromatosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PLANTARFASC.gz"
  },
  {
    "accessionId": "DGWAS-3650",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_POLNODOSA",
    "phenotype": "Polyarteritis nodosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarteritis nodosa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_POLNODOSA.gz"
  },
  {
    "accessionId": "DGWAS-3652",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_POLYARTHRITIS",
    "phenotype": "Polyarthritis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarthritis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_POLYARTHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-3653",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_POLYARTHROPATHIES",
    "phenotype": "Polyarthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_POLYARTHROPATHIES.gz"
  },
  {
    "accessionId": "DGWAS-3654",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_POLYMYALGIA",
    "phenotype": "Polymyalgia rheumatica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polymyalgia rheumatica",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_POLYMYALGIA.gz"
  },
  {
    "accessionId": "DGWAS-3655",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_POLYMYO",
    "phenotype": "Polymyositis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polymyositis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_POLYMYO.gz"
  },
  {
    "accessionId": "DGWAS-3658",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PSOASTEND",
    "phenotype": "Psoas tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoas tendinitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PSOASTEND.gz"
  },
  {
    "accessionId": "DGWAS-3660",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_PYOGARTH",
    "phenotype": "Pyogenic arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_PYOGARTH.gz"
  },
  {
    "accessionId": "DGWAS-3661",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_RADICULOPATHY",
    "phenotype": "Radiculopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Radiculopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_RADICULOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-3663",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_RECUDISLOCATIO",
    "phenotype": "Recurrent dislocation and subluxation of joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent joint dislocation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_RECUDISLOCATIO.gz"
  },
  {
    "accessionId": "DGWAS-3664",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_RHEUMA",
    "phenotype": "Rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatoid arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_RHEUMA.gz"
  },
  {
    "accessionId": "DGWAS-3665",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_RHEUMATISM",
    "phenotype": "Rheumatism, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatism NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_RHEUMATISM.gz"
  },
  {
    "accessionId": "DGWAS-3666",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_ROTATORCUFF",
    "phenotype": "Rotator cuff syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rotator cuff syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_ROTATORCUFF.gz"
  },
  {
    "accessionId": "DGWAS-3668",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SACROCOGG",
    "phenotype": "Sacrococcygeal disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sacrococcygeal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SACROCOGG.gz"
  },
  {
    "accessionId": "DGWAS-3671",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SCOLIOSIS",
    "phenotype": "Scoliosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scoliosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SCOLIOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3677",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SOFTOVERUSE",
    "phenotype": "Soft tissue disorders related to use, overuse and pressure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overuse soft tissue disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SOFTOVERUSE.gz"
  },
  {
    "accessionId": "DGWAS-3679",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SOFTTISSUENAS",
    "phenotype": "Other specified/unspecified soft tissue disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Soft tissue disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SOFTTISSUENAS.gz"
  },
  {
    "accessionId": "DGWAS-3680",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SOFTTISSUEOTH",
    "phenotype": "Other soft tissue disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Soft tissue disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SOFTTISSUEOTH.gz"
  },
  {
    "accessionId": "DGWAS-3684",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SPINSTENOSIS",
    "phenotype": "Spinal stenosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal stenosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SPINSTENOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3686",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SPONDYLOLISTHESIS",
    "phenotype": "Spondylolisthesis/Spondylolysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylolisthesis/spondylolysis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SPONDYLOLISTHESIS.gz"
  },
  {
    "accessionId": "DGWAS-3688",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SPONDYLOPATHY",
    "phenotype": "Spondylopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SPONDYLOPATHY.gz"
  },
  {
    "accessionId": "DGWAS-3689",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SPONDYLOPATHYNAS",
    "phenotype": "Other specified/unspecified spondylopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SPONDYLOPATHYNAS.gz"
  },
  {
    "accessionId": "DGWAS-3691",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SPONTRUPTSYNOTEND",
    "phenotype": "Spontaneous rupture of synovium and tendon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spontaneous synovium/tendon rupture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SPONTRUPTSYNOTEND.gz"
  },
  {
    "accessionId": "DGWAS-3692",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SYNOHYPERTROPH",
    "phenotype": "Synovial hypertrophy, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovial hypertrophy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SYNOHYPERTROPH.gz"
  },
  {
    "accessionId": "DGWAS-3693",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SYNOTEND",
    "phenotype": "Disorders of synovium and tendon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovium/tendon disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SYNOTEND.gz"
  },
  {
    "accessionId": "DGWAS-3694",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SYNOTENDINOTH",
    "phenotype": "Disorders of synovium and tendon in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary synovium/tendon disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SYNOTENDINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3695",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SYSTCONINOTH",
    "phenotype": "Systemic disorders of connective tissue in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary systemic CTD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SYSTCONINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3697",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_SYSTSLCE",
    "phenotype": "Systemic sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic sclerosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_SYSTSLCE.gz"
  },
  {
    "accessionId": "DGWAS-3698",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_TEMPARTERIT",
    "phenotype": "Temporal arteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Temporal arteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_TEMPARTERIT.gz"
  },
  {
    "accessionId": "DGWAS-3700",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_TENDOSYNOVITISNAS",
    "phenotype": "Other/unspecified synovitis and tenosynovitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovitis/tenosynovitis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_TENDOSYNOVITISNAS.gz"
  },
  {
    "accessionId": "DGWAS-3703",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_TIETZE",
    "phenotype": "Chondrocostal junction syndrome [Tietze]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tietze syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_TIETZE.gz"
  },
  {
    "accessionId": "DGWAS-3706",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_TRANSSYNOVITIS",
    "phenotype": "Transient synovitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transient synovitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_TRANSSYNOVITIS.gz"
  },
  {
    "accessionId": "DGWAS-3708",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_TROCHANTERICBURSITIS",
    "phenotype": "Trochanteric bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trochanteric bursitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_TROCHANTERICBURSITIS.gz"
  },
  {
    "accessionId": "DGWAS-3709",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_VALGUS",
    "phenotype": "Valgus deformity, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Valgus deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_VALGUS.gz"
  },
  {
    "accessionId": "DGWAS-3710",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_VARUS",
    "phenotype": "Varus deformity, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varus deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_VARUS.gz"
  },
  {
    "accessionId": "DGWAS-3713",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_M13_WEGENER",
    "phenotype": "Wegener granulomatosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Granulomatosis with polyangiitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_M13_WEGENER.gz"
  },
  {
    "accessionId": "DGWAS-3714",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MACULAR_CYST",
    "phenotype": "Macular cyst",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MACULAR_CYST.gz"
  },
  {
    "accessionId": "DGWAS-3715",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MACULAR_HOLE",
    "phenotype": "Macular hole",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular hole",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MACULAR_HOLE.gz"
  },
  {
    "accessionId": "DGWAS-3716",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MACULAR_PUCKER",
    "phenotype": "Macular pucker",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular pucker",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MACULAR_PUCKER.gz"
  },
  {
    "accessionId": "DGWAS-3717",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MACULA_NAS",
    "phenotype": "Degenerative macular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Degenerative macular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MACULA_NAS.gz"
  },
  {
    "accessionId": "DGWAS-3718",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MACULA_NAS_ADVERSE",
    "phenotype": "Degenerative macular diseases, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced macular degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MACULA_NAS_ADVERSE.gz"
  },
  {
    "accessionId": "DGWAS-3720",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MEMLOSS",
    "phenotype": "Memory loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Memory loss",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MEMLOSS.gz"
  },
  {
    "accessionId": "DGWAS-3722",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MIGRAINE_TRIPTAN",
    "phenotype": "Migraine, single triptan purchase ok & required. ICD-code if available is included",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MIGRAINE_TRIPTAN.gz"
  },
  {
    "accessionId": "DGWAS-3723",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MIGRAINE_UNSPE",
    "phenotype": "Migraine, unspecified, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced migraine NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MIGRAINE_UNSPE.gz"
  },
  {
    "accessionId": "DGWAS-3724",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MUCOPROCT",
    "phenotype": "Mucosal proctocolitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mucosal proctocolitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MUCOPROCT.gz"
  },
  {
    "accessionId": "DGWAS-3726",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_MYELOPROF_NONCML",
    "phenotype": "Myeloproliferative diseases (CML excluded)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloproliferative disease (non-CML)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_MYELOPROF_NONCML.gz"
  },
  {
    "accessionId": "DGWAS-3727",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ABNORMALBLEED",
    "phenotype": "Other abnormal uterine and caginal bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal uterine/vaginal bleeding",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ABNORMALBLEED.gz"
  },
  {
    "accessionId": "DGWAS-3728",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ACUTENEPHRITIC",
    "phenotype": "Acute nephritic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute nephritic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ACUTENEPHRITIC.gz"
  },
  {
    "accessionId": "DGWAS-3729",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ACUTERENFAIL",
    "phenotype": "Acute renal failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute renal failure",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ACUTERENFAIL.gz"
  },
  {
    "accessionId": "DGWAS-3730",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_AMENORRHEAPRIM",
    "phenotype": "Amenorrhoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amenorrhea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_AMENORRHEAPRIM.gz"
  },
  {
    "accessionId": "DGWAS-3732",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_BARTHOCYS",
    "phenotype": "Cyst of Bartholin Gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bartholin cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_BARTHOCYS.gz"
  },
  {
    "accessionId": "DGWAS-3733",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_BARTHOOTHNAS",
    "phenotype": "Other and unspecified disease of Bartholin gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bartholin disease NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_BARTHOOTHNAS.gz"
  },
  {
    "accessionId": "DGWAS-3734",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_BENIGNMAMDYSP",
    "phenotype": "Benign mammary dysplasia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign breast dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_BENIGNMAMDYSP.gz"
  },
  {
    "accessionId": "DGWAS-3738",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CALCULOWER",
    "phenotype": "Calculus of lower urinary tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower urinary tract stone",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CALCULOWER.gz"
  },
  {
    "accessionId": "DGWAS-3739",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CERVICAL_DYSPLASIA_ALL",
    "phenotype": "All dysplastic lesions of the cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CERVICAL_DYSPLASIA_ALL.gz"
  },
  {
    "accessionId": "DGWAS-3741",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CERVICAL_HSIL",
    "phenotype": "HSIL lesion of the cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical HSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CERVICAL_HSIL.gz"
  },
  {
    "accessionId": "DGWAS-3742",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CERVICAL_LSIL",
    "phenotype": "LSIL lesion of the cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical LSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CERVICAL_LSIL.gz"
  },
  {
    "accessionId": "DGWAS-3743",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CHRONEPHROPATH",
    "phenotype": "Chronic nephritic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic nephritic syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CHRONEPHROPATH.gz"
  },
  {
    "accessionId": "DGWAS-3745",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CHRONTUBULOINTNEPHRITIS",
    "phenotype": "Chronic tubulo-interstitial nephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic tubulointerstitial nephritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CHRONTUBULOINTNEPHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-3746",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CYSTITIS",
    "phenotype": "Cystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CYSTITIS.gz"
  },
  {
    "accessionId": "DGWAS-3747",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_CYSTKID",
    "phenotype": "Cyst of kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal cyst",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_CYSTKID.gz"
  },
  {
    "accessionId": "DGWAS-3749",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_DISIMPAIRRENTUB",
    "phenotype": "Disorders resulting from impaired renal tubular function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal tubular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_DISIMPAIRRENTUB.gz"
  },
  {
    "accessionId": "DGWAS-3750",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS",
    "phenotype": "Endometriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3754",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS_FALLOPIAN_TUBE",
    "phenotype": "Endometriosis of fallopian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tubal endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS_FALLOPIAN_TUBE.gz"
  },
  {
    "accessionId": "DGWAS-3755",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS_INTESTINE",
    "phenotype": "Endometriosis of intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS_INTESTINE.gz"
  },
  {
    "accessionId": "DGWAS-3756",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS_NOS",
    "phenotype": "Unspecified/other endometriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS_NOS.gz"
  },
  {
    "accessionId": "DGWAS-3759",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS_RECTPVAGSEPT_VAGINA",
    "phenotype": "Endometriosis of rectovaginal septum and vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectovaginal/vaginal endometriosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS_RECTPVAGSEPT_VAGINA.gz"
  },
  {
    "accessionId": "DGWAS-3760",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ENDOMETRIOSIS_UTERUS",
    "phenotype": "Adenomyosis (Endometriosis of uterus)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adenomyosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ENDOMETRIOSIS_UTERUS.gz"
  },
  {
    "accessionId": "DGWAS-3762",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_EROSECTROPUT",
    "phenotype": "Erosion and ectropion of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical erosion/ectropion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_EROSECTROPUT.gz"
  },
  {
    "accessionId": "DGWAS-3763",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FEMALEGENINF",
    "phenotype": "Inflammatory diseases of female pelvic organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pelvic inflammatory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FEMALEGENINF.gz"
  },
  {
    "accessionId": "DGWAS-3765",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FEMALEINFERT",
    "phenotype": "Female infertility",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FEMALEINFERT.gz"
  },
  {
    "accessionId": "DGWAS-3766",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FEMALE_GENITAL_DYSPLASIA_ALL",
    "phenotype": "All dysplastic lesions of the cervix uteri, vagina or vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FEMALE_GENITAL_DYSPLASIA_ALL.gz"
  },
  {
    "accessionId": "DGWAS-3768",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FEMALE_GENITAL_HSIL",
    "phenotype": "HSIL lesion of the cervix uteri, vagina or vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital HSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FEMALE_GENITAL_HSIL.gz"
  },
  {
    "accessionId": "DGWAS-3771",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FEMGENPAIN",
    "phenotype": "Pain and other conditions associated with female genital organs and menstrual cycle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital/menstrual disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FEMGENPAIN.gz"
  },
  {
    "accessionId": "DGWAS-3775",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FIOTHNAS",
    "phenotype": "Female infertility, cervigal, vaginal, other or unspecified origin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infertility NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FIOTHNAS.gz"
  },
  {
    "accessionId": "DGWAS-3777",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_FIUTERINE",
    "phenotype": "Female infertility, uterine origin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_FIUTERINE.gz"
  },
  {
    "accessionId": "DGWAS-3778",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_GALACTORRHEA",
    "phenotype": "Galactorrhea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Galactorrhea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_GALACTORRHEA.gz"
  },
  {
    "accessionId": "DGWAS-3779",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_GENITOUROTH",
    "phenotype": "Other disorders of the genitourinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genitourinary disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_GENITOUROTH.gz"
  },
  {
    "accessionId": "DGWAS-378",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_THYROIDITIS",
    "phenotype": "Thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroiditis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_THYROIDITIS.gz"
  },
  {
    "accessionId": "DGWAS-3780",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_GLOMEINOTH",
    "phenotype": "Glomerular disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary glomerular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_GLOMEINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3781",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_GLOMERULAR",
    "phenotype": "Glomerular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glomerular disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_GLOMERULAR.gz"
  },
  {
    "accessionId": "DGWAS-3784",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_HENOCHSCHONLEIN_NEPHRITIS",
    "phenotype": "Henoch-Schonlein purpura nephritis (HSPN)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "HSP nephritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_HENOCHSCHONLEIN_NEPHRITIS.gz"
  },
  {
    "accessionId": "DGWAS-3785",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_HYDROCELE",
    "phenotype": "Hydrocele",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocele",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_HYDROCELE.gz"
  },
  {
    "accessionId": "DGWAS-3789",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_IGA_NEPHROPATHY",
    "phenotype": "IgA nephropathy (IgA glomerulonephritis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IgA nephropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_IGA_NEPHROPATHY.gz"
  },
  {
    "accessionId": "DGWAS-379",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_SLE_OTH",
    "phenotype": "Other forms of systemic lupus erythematosus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SLE",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_SLE_OTH.gz"
  },
  {
    "accessionId": "DGWAS-3792",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_INFLAMALEGEN",
    "phenotype": "Inflammatory disorders of male genital organs, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_INFLAMALEGEN.gz"
  },
  {
    "accessionId": "DGWAS-3793",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_INFLAMMBREAST",
    "phenotype": "Inflammatory disorders of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast inflammation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_INFLAMMBREAST.gz"
  },
  {
    "accessionId": "DGWAS-3795",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ISOLPROTEINURIA",
    "phenotype": "Isolated proteinuria with specified morphological lesion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Proteinuria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ISOLPROTEINURIA.gz"
  },
  {
    "accessionId": "DGWAS-3796",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_KIDUROTH",
    "phenotype": "Other disorders of kidney and ureter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney/ureter disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_KIDUROTH.gz"
  },
  {
    "accessionId": "DGWAS-3797",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_LUMPNASBREAST",
    "phenotype": "Unspecified lump in breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast lump NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_LUMPNASBREAST.gz"
  },
  {
    "accessionId": "DGWAS-38",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_PROSTHYPERPLA",
    "phenotype": "Hyperplasia of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign prostatic hyperplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_PROSTHYPERPLA.gz"
  },
  {
    "accessionId": "DGWAS-380",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_RHEUMA_ARHTROPAT_REACTIVE",
    "phenotype": "Reactive arthropathies, FINNGEN",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Reactive arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_RHEUMA_ARHTROPAT_REACTIVE.gz"
  },
  {
    "accessionId": "DGWAS-3800",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_MALEINFERT",
    "phenotype": "Male infertility",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male infertility",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_MALEINFERT.gz"
  },
  {
    "accessionId": "DGWAS-3801",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_MENOPAUSOT",
    "phenotype": "Other menopausal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menopausal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_MENOPAUSOT.gz"
  },
  {
    "accessionId": "DGWAS-3803",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_MENSIRREG",
    "phenotype": "Irregular menses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Irregular menses",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_MENSIRREG.gz"
  },
  {
    "accessionId": "DGWAS-3805",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_NEPHRITICNAS",
    "phenotype": "Unspecified nephritic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nephritic syndrome NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_NEPHRITICNAS.gz"
  },
  {
    "accessionId": "DGWAS-3808",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OBSTRUREFLUROPATH",
    "phenotype": "Other obstructive and reflux uropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstructive/reflux uropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OBSTRUREFLUROPATH.gz"
  },
  {
    "accessionId": "DGWAS-3809",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OLIGOMEN",
    "phenotype": "Oligomenorrhoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oligomenorrhea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OLIGOMEN.gz"
  },
  {
    "accessionId": "DGWAS-381",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_OTHER_CONGEN_MALFO_HEART",
    "phenotype": "Other congenital malformations of heart",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital heart malformation NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_OTHER_CONGEN_MALFO_HEART.gz"
  },
  {
    "accessionId": "DGWAS-3814",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OTHFEMPELINF",
    "phenotype": "Other female pelvic inflammatory diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pelvic inflammatory disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OTHFEMPELINF.gz"
  },
  {
    "accessionId": "DGWAS-3815",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OTHINFVAGVULV",
    "phenotype": "Other inflammation of vagina/vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginitis/vulvitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OTHINFVAGVULV.gz"
  },
  {
    "accessionId": "DGWAS-382",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_N14_VULVAL_LSIL",
    "phenotype": "LSIL lesion of the vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar LSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_N14_VULVAL_LSIL.gz"
  },
  {
    "accessionId": "DGWAS-3820",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OTHNONINFVULV",
    "phenotype": "Other noninflammatory disorders of vulva and perineum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar/perineal disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OTHNONINFVULV.gz"
  },
  {
    "accessionId": "DGWAS-3824",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_OVAR_HYPERSTIM",
    "phenotype": "Ovarian hyperstimulation (induction)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian hyperstimulation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_OVAR_HYPERSTIM.gz"
  },
  {
    "accessionId": "DGWAS-3825",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_PHIMOSIS",
    "phenotype": "Redundant prepuce, phimosis and paraphimosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phimosis/paraphimosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_PHIMOSIS.gz"
  },
  {
    "accessionId": "DGWAS-3827",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_POSTMENATRVAG",
    "phenotype": "Postmenopausal atrophic vaginitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmenopausal atrophic vaginitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_POSTMENATRVAG.gz"
  },
  {
    "accessionId": "DGWAS-3829",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_PREMENSTSYNDROM",
    "phenotype": "Premenstrual syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PMS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_PREMENSTSYNDROM.gz"
  },
  {
    "accessionId": "DGWAS-3830",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_PROHERNOV",
    "phenotype": "Prolapse and hernia of ovary and fallopian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adnexal prolapse/hernia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_PROHERNOV.gz"
  },
  {
    "accessionId": "DGWAS-3831",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_PROSTAOTH",
    "phenotype": "Other disorders of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_PROSTAOTH.gz"
  },
  {
    "accessionId": "DGWAS-3834",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_PYELONEPHR",
    "phenotype": "Acute tubulo-interstitial nephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute tubulointerstitial nephritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_PYELONEPHR.gz"
  },
  {
    "accessionId": "DGWAS-3835",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_RECURANDPERHEAMATUR",
    "phenotype": "Recurrent and persistent haematuria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hematuria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_RECURANDPERHEAMATUR.gz"
  },
  {
    "accessionId": "DGWAS-3836",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_RENALCOLNAS",
    "phenotype": "Unspecified renal colic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal colic NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_RENALCOLNAS.gz"
  },
  {
    "accessionId": "DGWAS-3837",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_RENALTUB",
    "phenotype": "Renal tubulo-interstitial diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tubulointerstitial disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_RENALTUB.gz"
  },
  {
    "accessionId": "DGWAS-3841",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_RENFAILNAS",
    "phenotype": "Unspecified kidney failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney failure NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_RENFAILNAS.gz"
  },
  {
    "accessionId": "DGWAS-3842",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_SALPHOOPH",
    "phenotype": "Salpingitis and oophoritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salpingitis/oophoritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_SALPHOOPH.gz"
  },
  {
    "accessionId": "DGWAS-3843",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_SPERMATOCELE",
    "phenotype": "Spermatocele",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spermatocele",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_SPERMATOCELE.gz"
  },
  {
    "accessionId": "DGWAS-3845",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_TUBULOINTNEPHRNAS",
    "phenotype": "Tubulo-interstitial nephritis, not specified as acute or chronic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tubulointerstitial nephritis NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_TUBULOINTNEPHRNAS.gz"
  },
  {
    "accessionId": "DGWAS-3846",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_ULCERVAGVUL",
    "phenotype": "Ulcer of vagina/vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal/vulvar ulcer",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_ULCERVAGVUL.gz"
  },
  {
    "accessionId": "DGWAS-3847",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_UNSPECKIDCONTR",
    "phenotype": "Unspecified contracted kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Contracted kidney NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_UNSPECKIDCONTR.gz"
  },
  {
    "accessionId": "DGWAS-3854",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VAGINAL_HSIL",
    "phenotype": "HSIL lesion of the vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal HSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VAGINAL_HSIL.gz"
  },
  {
    "accessionId": "DGWAS-3855",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VAGINAL_LSIL",
    "phenotype": "LSIL lesion of the vagina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal LSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VAGINAL_LSIL.gz"
  },
  {
    "accessionId": "DGWAS-3856",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VAGINITIS",
    "phenotype": "Vaginitis/vulvovaginitis/vulvitis/abscess of vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginitis/vulvitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VAGINITIS.gz"
  },
  {
    "accessionId": "DGWAS-3857",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VULVAL_DYSPLASIA_ALL",
    "phenotype": "All dysplastic lesions of the vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar dysplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VULVAL_DYSPLASIA_ALL.gz"
  },
  {
    "accessionId": "DGWAS-3858",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VULVAL_HSIL",
    "phenotype": "HSIL lesion of the vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar HSIL",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VULVAL_HSIL.gz"
  },
  {
    "accessionId": "DGWAS-3860",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_N14_VULVOVAGINFINOTH",
    "phenotype": "Vulvovaginal ulceration/inflammation in other diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary vulvovaginal ulceration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_N14_VULVOVAGINFINOTH.gz"
  },
  {
    "accessionId": "DGWAS-3861",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_NAFLD",
    "phenotype": "Nonalcoholic fatty liver disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NAFLD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_NAFLD.gz"
  },
  {
    "accessionId": "DGWAS-3862",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_NASH",
    "phenotype": "Nonalcoholic steatohepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NASH",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_NASH.gz"
  },
  {
    "accessionId": "DGWAS-3863",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_NECROVASC_FG",
    "phenotype": "Other necrotizing vasculopathies (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Necrotizing vasculopathy NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_NECROVASC_FG.gz"
  },
  {
    "accessionId": "DGWAS-3864",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_NEURODEGOTH",
    "phenotype": "Other degenerative diseases of the nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nervous system degeneration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_NEURODEGOTH.gz"
  },
  {
    "accessionId": "DGWAS-3866",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_NONALLERG_ASTHMA_EXMORE",
    "phenotype": "Non-allergic asthma (mode) (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-allergic asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_NONALLERG_ASTHMA_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3867",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ABORT_FAILED",
    "phenotype": "Failed attempted abortion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Failed abortion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ABORT_FAILED.gz"
  },
  {
    "accessionId": "DGWAS-3868",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ABORT_MEDICAL",
    "phenotype": "Medical abortion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Medical abortion",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ABORT_MEDICAL.gz"
  },
  {
    "accessionId": "DGWAS-3869",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ABORT_OTHER",
    "phenotype": "Other abortion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abortion NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ABORT_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3872",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_AMNIOT_OTHER",
    "phenotype": "Other disorders of amniotic fluid and membranes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amniotic fluid/membrane disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_AMNIOT_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3873",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ANTENAT_ABNORM",
    "phenotype": "Abnormal findings on antenatal screening of mother",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal antenatal screen",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ANTENAT_ABNORM.gz"
  },
  {
    "accessionId": "DGWAS-3874",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ANTEPART_HAEM_NAS",
    "phenotype": "Antepartum haemorrhage, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Antepartum hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ANTEPART_HAEM_NAS.gz"
  },
  {
    "accessionId": "DGWAS-3877",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_COMPLIC_ABORT_ECTOP_MOLAR",
    "phenotype": "Complications following abortion and ectopic and molar pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Post-abortion complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_COMPLIC_ABORT_ECTOP_MOLAR.gz"
  },
  {
    "accessionId": "DGWAS-3880",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_CONCEPT_ABNORM",
    "phenotype": "Other abnormal products of conception",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal products of conception",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_CONCEPT_ABNORM.gz"
  },
  {
    "accessionId": "DGWAS-3881",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_DELIV_CAESAR",
    "phenotype": "Single delivery by caesarean section",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cesarean section delivery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_DELIV_CAESAR.gz"
  },
  {
    "accessionId": "DGWAS-3885",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_DELIV_PERIN_LACER",
    "phenotype": "Perineal laceration during delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perineal laceration",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_DELIV_PERIN_LACER.gz"
  },
  {
    "accessionId": "DGWAS-3886",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_DELIV_SPONT",
    "phenotype": "Single spontaneous delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spontaneous delivery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_DELIV_SPONT.gz"
  },
  {
    "accessionId": "DGWAS-3888",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_EXCESS_VOMIT_PREG",
    "phenotype": "Excessive vomiting in pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperemesis gravidarum",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_EXCESS_VOMIT_PREG.gz"
  },
  {
    "accessionId": "DGWAS-3889",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_EXIST_HYPERT_COMPLIC",
    "phenotype": "Pre-existing hypertension complicating pregnancy, childbirth and the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preexisting hypertension in pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_EXIST_HYPERT_COMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-3890",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_FAILED_INDUCT",
    "phenotype": "Failed induction of labour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Failed labor induction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_FAILED_INDUCT.gz"
  },
  {
    "accessionId": "DGWAS-3891",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_FALSE_LAB",
    "phenotype": "False labour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "False labor",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_FALSE_LAB.gz"
  },
  {
    "accessionId": "DGWAS-3893",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_GESTAT_OEDEM_PREINUR",
    "phenotype": "Gestational [pregnancy-induced] oedema and proteinuria without hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational edema/proteinuria",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_GESTAT_OEDEM_PREINUR.gz"
  },
  {
    "accessionId": "DGWAS-3894",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_HAEMORRH_EARLY_PREG",
    "phenotype": "Haemorrhage in early pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early pregnancy hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_HAEMORRH_EARLY_PREG.gz"
  },
  {
    "accessionId": "DGWAS-3897",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ICP_WIDE",
    "phenotype": "Intrahepatic Cholestasis of Pregnancy (ICP), incl. ICD-8",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ICP (incl ICD-8)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ICP_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-3898",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_ICP_WIDE_EXMORE",
    "phenotype": "Intrahepatic Cholestasis of Pregnancy (ICP), incl. ICD-8 (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ICP (incl ICD-8)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_ICP_WIDE_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3899",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_ABNORM_FORCES",
    "phenotype": "Abnormalities of forces of labour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labor force abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_ABNORM_FORCES.gz"
  },
  {
    "accessionId": "DGWAS-3901",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_FETAL_STRESS",
    "phenotype": "Labour and delivery complicated by fetal stress [distress]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fetal distress",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_FETAL_STRESS.gz"
  },
  {
    "accessionId": "DGWAS-3905",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_OBSTR_OTHER",
    "phenotype": "Other obstructed labour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstructed labor NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_OBSTR_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3906",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_OTHER",
    "phenotype": "Other complications of labour and delivery, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labor/delivery complication NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3907",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_PELVIC_ABNORM",
    "phenotype": "Obstructed labour due to maternal pelvic abnormality",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstructed labor (pelvic abnormality)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_PELVIC_ABNORM.gz"
  },
  {
    "accessionId": "DGWAS-3908",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_LABOUR_UMBILICAL",
    "phenotype": "Labour and delivery complicated by umbilical cord complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Umbilical cord complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_LABOUR_UMBILICAL.gz"
  },
  {
    "accessionId": "DGWAS-3909",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_CARE",
    "phenotype": "Maternal care related to the fetus and amniotic cavity and possible delivery problems",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for fetal/amniotic problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_CARE.gz"
  },
  {
    "accessionId": "DGWAS-3910",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_CARE_CERVICAL_INCOMPETENCE",
    "phenotype": "Maternal care for cervical incompetence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for cervical incompetence",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_CARE_CERVICAL_INCOMPETENCE.gz"
  },
  {
    "accessionId": "DGWAS-3912",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_CARE_FETAL_ABNORM",
    "phenotype": "Maternal care for known or suspected fetal abnormality and damage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for fetal abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_CARE_FETAL_ABNORM.gz"
  },
  {
    "accessionId": "DGWAS-3913",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_CARE_OTHER",
    "phenotype": "Maternal care for other known or suspected fetal problems",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for fetal problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_CARE_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3914",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_CARE_PELVIC_ABNORM",
    "phenotype": "Maternal care for known or suspected abnormality of pelvic organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for pelvic organ abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_CARE_PELVIC_ABNORM.gz"
  },
  {
    "accessionId": "DGWAS-3915",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MATERN_HYPERT_UNS",
    "phenotype": "Unspecified maternal hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal hypertension NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MATERN_HYPERT_UNS.gz"
  },
  {
    "accessionId": "DGWAS-3917",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MAT_CARE_MALPRESENT",
    "phenotype": "Maternal care for known or suspected malpresentation of fetus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for malpresentation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MAT_CARE_MALPRESENT.gz"
  },
  {
    "accessionId": "DGWAS-3918",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MEMBR_PREMAT_RUPT",
    "phenotype": "Premature rupture of membranes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PROM",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MEMBR_PREMAT_RUPT.gz"
  },
  {
    "accessionId": "DGWAS-3920",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_MULTIP_GEST_COMPLIC",
    "phenotype": "Complications specific to multiple gestation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple gestation complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_MULTIP_GEST_COMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-3921",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_OBSTET_TRAUMA_OTHER",
    "phenotype": "Other obstetric trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obstetric trauma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_OBSTET_TRAUMA_OTHER.gz"
  },
  {
    "accessionId": "DGWAS-3922",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_OTHER_MATERN_DIS_ELSEWHERE",
    "phenotype": "Other maternal diseases classifiable elsewhere but complicating pregnancy, childbirth and the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal disease in pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_OTHER_MATERN_DIS_ELSEWHERE.gz"
  },
  {
    "accessionId": "DGWAS-3923",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PLAC_DISORD",
    "phenotype": "Placental disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Placental disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PLAC_DISORD.gz"
  },
  {
    "accessionId": "DGWAS-3924",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PLAC_PRAEVIA",
    "phenotype": "Placenta praevia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Placenta previa",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PLAC_PRAEVIA.gz"
  },
  {
    "accessionId": "DGWAS-3925",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PLAC_PREMAT_SEPAR",
    "phenotype": "Premature separation of placenta [abruptio placentae]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Placental abruption",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PLAC_PREMAT_SEPAR.gz"
  },
  {
    "accessionId": "DGWAS-3926",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_POLYHYDR",
    "phenotype": "Polyhydramnios",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyhydramnios",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_POLYHYDR.gz"
  },
  {
    "accessionId": "DGWAS-3927",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_POOR_FETGRO",
    "phenotype": "Poor fetal growth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fetal growth restriction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_POOR_FETGRO.gz"
  },
  {
    "accessionId": "DGWAS-3929",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_POSTPART_HAEMORRH_PLACENTA",
    "phenotype": "Postpartum haemorrhage due to retained placenta",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum hemorrhage (retained placenta)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_POSTPART_HAEMORRH_PLACENTA.gz"
  },
  {
    "accessionId": "DGWAS-3930",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_POSTPART_HEAMORRH",
    "phenotype": "Postpartum haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum hemorrhage",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_POSTPART_HEAMORRH.gz"
  },
  {
    "accessionId": "DGWAS-3934",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREECLAMPS_CHRONIC_HYPERT",
    "phenotype": "Pre-eclampsia superimposed on chronic hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia with chronic hypertension",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREECLAMPS_CHRONIC_HYPERT.gz"
  },
  {
    "accessionId": "DGWAS-3935",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREEC_OR_FETGRO",
    "phenotype": "Pre-eclampsia or poor fetal growth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia/fetal growth restriction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREEC_OR_FETGRO.gz"
  },
  {
    "accessionId": "DGWAS-3936",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREG_ABORT",
    "phenotype": "Pregnancy with abortive outcome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abortive pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREG_ABORT.gz"
  },
  {
    "accessionId": "DGWAS-3937",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREG_ECTOP",
    "phenotype": "Ectopic pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectopic pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREG_ECTOP.gz"
  },
  {
    "accessionId": "DGWAS-3940",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREG_MATERN_CARE",
    "phenotype": "Maternal care for other conditions predominantly related to pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Maternal care for pregnancy condition",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREG_MATERN_CARE.gz"
  },
  {
    "accessionId": "DGWAS-3942",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREG_PROLONGED",
    "phenotype": "Prolonged pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postterm pregnancy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREG_PROLONGED.gz"
  },
  {
    "accessionId": "DGWAS-3943",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PREG_VENOUS_HAEMORRH",
    "phenotype": "Venous complications and haemorrhoids in pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy venous complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PREG_VENOUS_HAEMORRH.gz"
  },
  {
    "accessionId": "DGWAS-3944",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PRETERM",
    "phenotype": "Preterm labour and delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preterm labor/delivery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PRETERM.gz"
  },
  {
    "accessionId": "DGWAS-3949",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_PUERP_SEPSIS",
    "phenotype": "Puerperal sepsis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal sepsis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_PUERP_SEPSIS.gz"
  },
  {
    "accessionId": "DGWAS-3952",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_O15_VENOUS_COMPLIC",
    "phenotype": "Venous complications and haemorrhoids in the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal venous complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_O15_VENOUS_COMPLIC.gz"
  },
  {
    "accessionId": "DGWAS-3954",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_OSTEON_DRUGS",
    "phenotype": "Osteonecrosis due to drugs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced osteonecrosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_OSTEON_DRUGS.gz"
  },
  {
    "accessionId": "DGWAS-3955",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_OSTEOPOROSIS_FRACTURE_FG",
    "phenotype": "Osteoporosis with pathological fracture (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoporosis with pathological fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_OSTEOPOROSIS_FRACTURE_FG.gz"
  },
  {
    "accessionId": "DGWAS-3957",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_OSTPOPATFRCTURE_POSTEMENO",
    "phenotype": "Postmenopausal osteoporosis with pathological fracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmenopausal osteoporosis with fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_OSTPOPATFRCTURE_POSTEMENO.gz"
  },
  {
    "accessionId": "DGWAS-3958",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_OTHER_DRUGADVERS_SECONDA_PARKINSONI",
    "phenotype": "Other drug-induced secondary parkinsonism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced parkinsonism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_OTHER_DRUGADVERS_SECONDA_PARKINSONI.gz"
  },
  {
    "accessionId": "DGWAS-3959",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_OTHER_SYSTCON_FG",
    "phenotype": "Other systemic involvement of connective tissue (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic CTD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_OTHER_SYSTCON_FG.gz"
  },
  {
    "accessionId": "DGWAS-3961",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_BIRTH_ASPHYXIA",
    "phenotype": "Birth asphyxia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Birth asphyxia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_BIRTH_ASPHYXIA.gz"
  },
  {
    "accessionId": "DGWAS-3966",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_FET_NEWB_MATERN_COMPLICATIO_PREGNAC",
    "phenotype": "Fetus and newborn affected by maternal complications of pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Newborn affected by maternal pregnancy complication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_FET_NEWB_MATERN_COMPLICATIO_PREGNAC.gz"
  },
  {
    "accessionId": "DGWAS-3968",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_FET_NEWB_MATERN_FACTO_COMPLICATIO_PREGNAC_LABOUR_DELIV",
    "phenotype": "Fetus and newborn affected by maternal factors and by complications of pregnancy, labour and delivery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Newborn affected by maternal factors/complications",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_FET_NEWB_MATERN_FACTO_COMPLICATIO_PREGNAC_LABOUR_DELIV.gz"
  },
  {
    "accessionId": "DGWAS-3970",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_NEONTAL_JAUND_OTH_UNSP_CAUSES",
    "phenotype": "Neonatal jaundice from other and unspecified causes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neonatal jaundice NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_NEONTAL_JAUND_OTH_UNSP_CAUSES.gz"
  },
  {
    "accessionId": "DGWAS-3971",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_OTH_DISORD_ORIGINA_PERINA_PERIOD",
    "phenotype": "Other disorders originating in the perinatal period",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perinatal disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_OTH_DISORD_ORIGINA_PERINA_PERIOD.gz"
  },
  {
    "accessionId": "DGWAS-3972",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_OTH_INFECTIONS_SPECIFIC_PERINA_PERIOD",
    "phenotype": "Other infections specific to the perinatal period",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perinatal infection NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_OTH_INFECTIONS_SPECIFIC_PERINA_PERIOD.gz"
  },
  {
    "accessionId": "DGWAS-3973",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_RESPI_CARDIOV_DISORD_SPECIFIC_PERINA_PERIOD",
    "phenotype": "Respiratory and cardiovascular disorders specific to the perinatal period",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perinatal respiratory/cardiovascular disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_RESPI_CARDIOV_DISORD_SPECIFIC_PERINA_PERIOD.gz"
  },
  {
    "accessionId": "DGWAS-3974",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_RESPI_DISTR_NEWBO",
    "phenotype": "Respiratory distress of newborn",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neonatal respiratory distress",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_RESPI_DISTR_NEWBO.gz"
  },
  {
    "accessionId": "DGWAS-3976",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_P16_TRANSITO_DISORD_CARBOH_METABOLISM_SPECIFIC_FETUS_NEWBO",
    "phenotype": "Transitory disorders of carbohydrate metabolism specific to fetus and newborn",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neonatal transient carbohydrate disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_P16_TRANSITO_DISORD_CARBOH_METABOLISM_SPECIFIC_FETUS_NEWBO.gz"
  },
  {
    "accessionId": "DGWAS-3977",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PAIN",
    "phenotype": "Pain (limb, back, neck, head abdominally)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pain (various sites)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PAIN.gz"
  },
  {
    "accessionId": "DGWAS-3978",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PD2ND_EXMORE",
    "phenotype": "Secondary parkinsonism (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary parkinsonism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PD2ND_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3979",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PD_DEMENTIA_EXMORE",
    "phenotype": "Dementia due to Parkinson's disease (more control exclusions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parkinson disease dementia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PD_DEMENTIA_EXMORE.gz"
  },
  {
    "accessionId": "DGWAS-3982",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PHLEBI_THROMBOP_SUPERF_VESSE_LOWER_EXTREMITI",
    "phenotype": "Phlebitis and thrombophlebitis of superficial vessels of lower extremities, drug-induced",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Drug-induced superficial lower extremity thrombophlebitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PHLEBI_THROMBOP_SUPERF_VESSE_LOWER_EXTREMITI.gz"
  },
  {
    "accessionId": "DGWAS-3983",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PNEUMO_SEPTHICHE",
    "phenotype": "Pneumococcal septicemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumococcal septicemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PNEUMO_SEPTHICHE.gz"
  },
  {
    "accessionId": "DGWAS-3987",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_PRIM_KNEEARTHROSIS",
    "phenotype": "Primary gonarthrosis, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral primary knee OA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_PRIM_KNEEARTHROSIS.gz"
  },
  {
    "accessionId": "DGWAS-3990",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_ANKYLOGLOSSIA",
    "phenotype": "Ankyloglossia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankyloglossia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_ANKYLOGLOSSIA.gz"
  },
  {
    "accessionId": "DGWAS-3993",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_BALANC_REARR_STRUCTURAL_MARKERS_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Balanced rearrangements and structural markers, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Balanced chromosomal rearrangement",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_BALANC_REARR_STRUCTURAL_MARKERS_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-3995",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CLEFT_AND_CARIES_INCLAVO",
    "phenotype": "Caries in Clefts patients , including avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries in cleft patients (incl avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CLEFT_AND_CARIES_INCLAVO.gz"
  },
  {
    "accessionId": "DGWAS-3997",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CLEFT_LIP_AND_PALATE",
    "phenotype": "Cleft lip and palate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cleft lip and palate",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CLEFT_LIP_AND_PALATE.gz"
  },
  {
    "accessionId": "DGWAS-3998",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CLEFT_LIP_CLEFT_PALATE",
    "phenotype": "Cleft lip, lip and palate or palate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orofacial cleft",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CLEFT_LIP_CLEFT_PALATE.gz"
  },
  {
    "accessionId": "DGWAS-4001",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_DEFORMITI_FEET",
    "phenotype": "Congenital deformities of feet",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital foot deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_DEFORMITI_FEET.gz"
  },
  {
    "accessionId": "DGWAS-4003",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_HYDROCEPHALUS",
    "phenotype": "Congenital hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital hydrocephalus",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_HYDROCEPHALUS.gz"
  },
  {
    "accessionId": "DGWAS-4005",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_LENS_MALFO",
    "phenotype": "Congenital lens malformations",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital lens malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_LENS_MALFO.gz"
  },
  {
    "accessionId": "DGWAS-4008",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_CARDIAC_CHAMB_CONNECTIO",
    "phenotype": "Congenital malformations of cardiac chambers and connections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital cardiac chamber/connection malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_CARDIAC_CHAMB_CONNECTIO.gz"
  },
  {
    "accessionId": "DGWAS-4009",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_CIRCULATO_SYSTEM",
    "phenotype": "Congenital malformations of the circulatory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital circulatory malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_CIRCULATO_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-4013",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_EYE_EAR_FACE_NECK",
    "phenotype": "Congenital malformations of eye, ear, face and neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital eye/ear/face/neck malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_EYE_EAR_FACE_NECK.gz"
  },
  {
    "accessionId": "DGWAS-4016",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_GREAT_ARTERIES",
    "phenotype": "Congenital malformations of great arteries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital great artery malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_GREAT_ARTERIES.gz"
  },
  {
    "accessionId": "DGWAS-4017",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_MUSCULOS_SYSTEM_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Congenital malformations of the musculoskeletal system, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital musculoskeletal malformation NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_MUSCULOS_SYSTEM_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-4020",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_OVARIES_FALLOP_TUBES_BROAD_LIGAM",
    "phenotype": "Congenital malformations of ovaries, fallopian tubes and broad ligaments",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital adnexal malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_OVARIES_FALLOP_TUBES_BROAD_LIGAM.gz"
  },
  {
    "accessionId": "DGWAS-4022",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_PULMONARY_TRICU_VALVES",
    "phenotype": "Congenital malformations of pulmonary and tricuspid valves",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital pulmonary/tricuspid valve malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_PULMONARY_TRICU_VALVES.gz"
  },
  {
    "accessionId": "DGWAS-4025",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MALFO_TRACHEA_BRONCHUS",
    "phenotype": "Congenital malformations of trachea and bronchus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital tracheal/bronchial malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MALFO_TRACHEA_BRONCHUS.gz"
  },
  {
    "accessionId": "DGWAS-4028",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CONGEN_MUSCULOS_DEFORMITI_HEAD_FACE_SPINE_CHEST",
    "phenotype": "Congenital musculoskeletal deformities of head, face, spine and chest",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital head/face/spine/chest deformity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CONGEN_MUSCULOS_DEFORMITI_HEAD_FACE_SPINE_CHEST.gz"
  },
  {
    "accessionId": "DGWAS-4031",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_CRANIOSYNOSTOSIS",
    "phenotype": "Craniosynostosis EXCLUDE syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Craniosynostosis (excl syndromes)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_CRANIOSYNOSTOSIS.gz"
  },
  {
    "accessionId": "DGWAS-4033",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_DOWNS_SYNDR",
    "phenotype": "Down's syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Down syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_DOWNS_SYNDR.gz"
  },
  {
    "accessionId": "DGWAS-4034",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_EHLER_SYNDR",
    "phenotype": "Ehlers-Danlos syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ehlers-Danlos syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_EHLER_SYNDR.gz"
  },
  {
    "accessionId": "DGWAS-4037",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_LVOTO_NARROW",
    "phenotype": "Left ventricular outflow tract obstruction, narrow definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "LVOT obstruction (narrow)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_LVOTO_NARROW.gz"
  },
  {
    "accessionId": "DGWAS-4038",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CHROMOSOME_ABNORMALITI_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Other chromosome abnormalities, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chromosome abnormality NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CHROMOSOME_ABNORMALITI_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-4043",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_EAR",
    "phenotype": "Other congenital malformations of ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital ear malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_EAR.gz"
  },
  {
    "accessionId": "DGWAS-4044",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_FACE_NECK",
    "phenotype": "Other congenital malformations of face and neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital face/neck malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_FACE_NECK.gz"
  },
  {
    "accessionId": "DGWAS-4045",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_FEMALE_GENITALIA",
    "phenotype": "Other congenital malformations of female genitalia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital female genital malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_FEMALE_GENITALIA.gz"
  },
  {
    "accessionId": "DGWAS-4051",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_NERVOUS_SYSTEM",
    "phenotype": "Other congenital malformations of nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital nervous system malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_NERVOUS_SYSTEM.gz"
  },
  {
    "accessionId": "DGWAS-4052",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Other congenital malformations, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital malformation NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-4057",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_CONGEN_MALFO_UPPER_ALIME_TRACT",
    "phenotype": "Other congenital malformations of upper alimentary tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital upper GI malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_CONGEN_MALFO_UPPER_ALIME_TRACT.gz"
  },
  {
    "accessionId": "DGWAS-4060",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_OSTEOCHONDROD",
    "phenotype": "Other osteochondrodysplasias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteochondrodysplasia NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_OSTEOCHONDROD.gz"
  },
  {
    "accessionId": "DGWAS-4061",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_OTHER_SPECIFE_CONGEN_MALFO_SYNDR_AFFECTING_MULTIPLE_SYSTEMS",
    "phenotype": "Other specified congenital malformation syndromes affecting multiple systems",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital malformation syndrome",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_OTHER_SPECIFE_CONGEN_MALFO_SYNDR_AFFECTING_MULTIPLE_SYSTEMS.gz"
  },
  {
    "accessionId": "DGWAS-4062",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_PHAKOMATOSES_NOT_ELSEW_CLASSIFIED",
    "phenotype": "Phakomatoses, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phakomatosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_PHAKOMATOSES_NOT_ELSEW_CLASSIFIED.gz"
  },
  {
    "accessionId": "DGWAS-4066",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Q17_UNDES_TESTICLE",
    "phenotype": "Undescended testicle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cryptorchidism",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Q17_UNDES_TESTICLE.gz"
  },
  {
    "accessionId": "DGWAS-4070",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_REITER",
    "phenotype": "Reiter disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Reactive arthritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_REITER.gz"
  },
  {
    "accessionId": "DGWAS-4071",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RESP_ILL_DIS_CLASS_ELSEWHERE",
    "phenotype": "Respiratory disorders in diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary respiratory disorder",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RESP_ILL_DIS_CLASS_ELSEWHERE.gz"
  },
  {
    "accessionId": "DGWAS-4077",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RHEUMA_SEROPOS_OTH",
    "phenotype": "Other/unspecified seropositive rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seropositive RA NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RHEUMA_SEROPOS_OTH.gz"
  },
  {
    "accessionId": "DGWAS-4079",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RHEUMA_SEROPOS_WIDE",
    "phenotype": "Seropositive rheumatoid arthritis, wide",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seropositive RA (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RHEUMA_SEROPOS_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-4082",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_ANTIHYP",
    "phenotype": "Antihypertensive medication - note that there are other indications",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Antihypertensive",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_ANTIHYP.gz"
  },
  {
    "accessionId": "DGWAS-4083",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_ASTMA_BIOL",
    "phenotype": "Biological medicines for asthma",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Biologic for asthma",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_ASTMA_BIOL.gz"
  },
  {
    "accessionId": "DGWAS-4084",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_CODEINE_TRAMADOL",
    "phenotype": "Codeine or tramadol medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Codeine/tramadol",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_CODEINE_TRAMADOL.gz"
  },
  {
    "accessionId": "DGWAS-4085",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_CROHN_1STLINE",
    "phenotype": "First line medication for Crohn's disease",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "First-line Crohn medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_CROHN_1STLINE.gz"
  },
  {
    "accessionId": "DGWAS-4086",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_CROHN_2NDLINE",
    "phenotype": "Second line medication for Crohn's disease",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Second-line Crohn medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_CROHN_2NDLINE.gz"
  },
  {
    "accessionId": "DGWAS-4087",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_GLUCOSAMINE",
    "phenotype": "Glucosamine medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Glucosamine",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_GLUCOSAMINE.gz"
  },
  {
    "accessionId": "DGWAS-4088",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_INFERTILITY",
    "phenotype": "Medical treatment for female infertility",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Female infertility medication",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_INFERTILITY.gz"
  },
  {
    "accessionId": "DGWAS-4089",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_N05C",
    "phenotype": "Use of hypnotics and sedatives",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Hypnotic/sedative",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_N05C.gz"
  },
  {
    "accessionId": "DGWAS-4091",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_RHEUMA_BIOLOGICAL",
    "phenotype": "Biological medication for rheuma",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Biologic for rheumatic disease",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_RHEUMA_BIOLOGICAL.gz"
  },
  {
    "accessionId": "DGWAS-4092",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_RX_STATIN",
    "phenotype": "Statin medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Statin",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_RX_STATIN.gz"
  },
  {
    "accessionId": "DGWAS-4093",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SCND_OTH_COXARTHROSIS",
    "phenotype": "Other secondary coxarthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary hip OA",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SCND_OTH_COXARTHROSIS.gz"
  },
  {
    "accessionId": "DGWAS-4097",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SLE_FG",
    "phenotype": "SLE (Finngen)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SLE (Finngen)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SLE_FG.gz"
  },
  {
    "accessionId": "DGWAS-4099",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SMOKING",
    "phenotype": "Smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SMOKING.gz"
  },
  {
    "accessionId": "DGWAS-4100",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SMOKING_DEPEND",
    "phenotype": "Smoking dependency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nicotine dependence",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SMOKING_DEPEND.gz"
  },
  {
    "accessionId": "DGWAS-4102",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SPONDYLOPATHY_FG",
    "phenotype": "Spondylopathies (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylopathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SPONDYLOPATHY_FG.gz"
  },
  {
    "accessionId": "DGWAS-4104",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_FRACT_FOOT_ANKLE",
    "phenotype": "Fracture of foot, except ankle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Foot fracture (excl ankle)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_FRACT_FOOT_ANKLE.gz"
  },
  {
    "accessionId": "DGWAS-4106",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_FRACT_LOWER_LEG_INCLU_ANKLE",
    "phenotype": "Fracture of lower leg, including ankle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower leg/ankle fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_FRACT_LOWER_LEG_INCLU_ANKLE.gz"
  },
  {
    "accessionId": "DGWAS-4107",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_FRACT_LUMBAR_SPINE_PELVIS",
    "phenotype": "Fracture of lumbar spine and pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lumbar spine/pelvis fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_FRACT_LUMBAR_SPINE_PELVIS.gz"
  },
  {
    "accessionId": "DGWAS-4110",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_FRACT_SHOUL_UPPER_ARM",
    "phenotype": "Fracture of shoulder and upper arm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder/upper arm fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_FRACT_SHOUL_UPPER_ARM.gz"
  },
  {
    "accessionId": "DGWAS-4112",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_FRACT_WRIST_HAND_LEVEL",
    "phenotype": "Fracture at wrist and hand level",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Wrist/hand fracture",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_FRACT_WRIST_HAND_LEVEL.gz"
  },
  {
    "accessionId": "DGWAS-4113",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_TOXIC_EFFECT_ALCOHOL",
    "phenotype": "Toxic effect of alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic effect of alcohol",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_TOXIC_EFFECT_ALCOHOL.gz"
  },
  {
    "accessionId": "DGWAS-4114",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ST19_TOXIC_EFFECT_ETHAN",
    "phenotype": "Toxic effect of ethanol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ethanol toxicity",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ST19_TOXIC_EFFECT_ETHAN.gz"
  },
  {
    "accessionId": "DGWAS-4116",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_SYSTSCLE_STRICT",
    "phenotype": "Systemic sclerosis,strict definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic sclerosis (strict)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_SYSTSCLE_STRICT.gz"
  },
  {
    "accessionId": "DGWAS-4118",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_T1D_EARLY",
    "phenotype": "Type1 diabetes, definitions combined, early onset",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes (combined, early onset)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_T1D_EARLY.gz"
  },
  {
    "accessionId": "DGWAS-4119",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_T1D_STRICT2",
    "phenotype": "Type 1 diabetes, strict definition, subgroup 2",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes (strict, subgroup 2)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_T1D_STRICT2.gz"
  },
  {
    "accessionId": "DGWAS-4120",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_T1D_WIDE",
    "phenotype": "Type 1 diabetes, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes (wide)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_T1D_WIDE.gz"
  },
  {
    "accessionId": "DGWAS-4121",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_T1D_WIDE2",
    "phenotype": "Type 1 diabetes, wide definition, subgroup 2",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes (wide, subgroup 2)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_T1D_WIDE2.gz"
  },
  {
    "accessionId": "DGWAS-4122",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_T2D",
    "phenotype": "Type 2 diabetes, definitions combined",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes (combined)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_T2D.gz"
  },
  {
    "accessionId": "DGWAS-4124",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_TBC_RESP",
    "phenotype": "Respiratory tuberculosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory TB",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_TBC_RESP.gz"
  },
  {
    "accessionId": "DGWAS-4125",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_TEMPOROMANDIB",
    "phenotype": "Temporomandibular joint disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TMD",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_TEMPOROMANDIB.gz"
  },
  {
    "accessionId": "DGWAS-4127",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_THROMBOCYTAEMIA",
    "phenotype": "Essential (haemorrhagic) thrombocythaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Essential thrombocythemia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_THROMBOCYTAEMIA.gz"
  },
  {
    "accessionId": "DGWAS-4129",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_THYROTOXICOSIS",
    "phenotype": "Thyrotoxicosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_THYROTOXICOSIS.gz"
  },
  {
    "accessionId": "DGWAS-4130",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_TONGUEABNORMALITY",
    "phenotype": "Tongue abnormality",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tongue abnormality",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_TONGUEABNORMALITY.gz"
  },
  {
    "accessionId": "DGWAS-4132",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_TRAUMBRAIN_NONCONCUS",
    "phenotype": "severe traumatic brain injury, does not include concussion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe TBI (excl concussion)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_TRAUMBRAIN_NONCONCUS.gz"
  },
  {
    "accessionId": "DGWAS-4133",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_U22_COVID19_CONFIRMED",
    "phenotype": "Covid-19 confirmed case",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 confirmed",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_U22_COVID19_CONFIRMED.gz"
  },
  {
    "accessionId": "DGWAS-4134",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_U22_COVID19_SUSPECTED",
    "phenotype": "Covid-19 suspected case",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 suspected",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_U22_COVID19_SUSPECTED.gz"
  },
  {
    "accessionId": "DGWAS-4135",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ULCERENTER",
    "phenotype": "Ulcerative enterocolitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative enterocolitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ULCERENTER.gz"
  },
  {
    "accessionId": "DGWAS-4136",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ULCERILEO",
    "phenotype": "Ulcerative ileocolitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative ileocolitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ULCERILEO.gz"
  },
  {
    "accessionId": "DGWAS-4141",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_ULCER_ARTHR",
    "phenotype": "Arthropathy in ulcerative colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis arthropathy",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_ULCER_ARTHR.gz"
  },
  {
    "accessionId": "DGWAS-4142",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VD_MI",
    "phenotype": "Vascular dementia (multiple infarctions)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia (multi-infarct)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VD_MI.gz"
  },
  {
    "accessionId": "DGWAS-4143",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VD_MX",
    "phenotype": "Vascular dementia (mixed)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia (mixed)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VD_MX.gz"
  },
  {
    "accessionId": "DGWAS-4145",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VD_SC",
    "phenotype": "Vascular dementia (subcortical)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia (subcortical)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VD_SC.gz"
  },
  {
    "accessionId": "DGWAS-4146",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VD_SO",
    "phenotype": "Vascular dementia (sudden onset)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia (sudden onset)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VD_SO.gz"
  },
  {
    "accessionId": "DGWAS-4147",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VD_U",
    "phenotype": "Vascular dementia (undefined)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular dementia (undefined)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VD_U.gz"
  },
  {
    "accessionId": "DGWAS-4151",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VOCALCORDDYS",
    "phenotype": "Vocal cord dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vocal cord dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VOCALCORDDYS.gz"
  },
  {
    "accessionId": "DGWAS-4152",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_INTENTI_SELF_H_HANGI_STRANGU_SUFFO",
    "phenotype": "Intentional self-harm by hanging, strangulation and suffocation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-harm by hanging/suffocation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_INTENTI_SELF_H_HANGI_STRANGU_SUFFO.gz"
  },
  {
    "accessionId": "DGWAS-4153",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_INTENTI_SELF_H_JUMPI_A_HIGH_PLACE",
    "phenotype": "Intentional self-harm by jumping from a high place",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-harm by jumping",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_INTENTI_SELF_H_JUMPI_A_HIGH_PLACE.gz"
  },
  {
    "accessionId": "DGWAS-4154",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_INTENTI_SELF_H_SHARP_OBJECT",
    "phenotype": "Intentional self-harm by sharp object",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-harm by sharp object",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_INTENTI_SELF_H_SHARP_OBJECT.gz"
  },
  {
    "accessionId": "DGWAS-4155",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_INTENTI_SELF_H_UNSPE_MEANS",
    "phenotype": "Intentional self-harm by unspecified means",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-harm NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_INTENTI_SELF_H_UNSPE_MEANS.gz"
  },
  {
    "accessionId": "DGWAS-4156",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_INTENTI_SELF_P_EXPOS_OTHER_UNSPE_CHEMIC_NOXIO_SUBST",
    "phenotype": "Intentional self-poisoning by and exposure to other and unspecified chemicals and noxious substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intentional self-poisoning",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_INTENTI_SELF_P_EXPOS_OTHER_UNSPE_CHEMIC_NOXIO_SUBST.gz"
  },
  {
    "accessionId": "DGWAS-4157",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_VWXY20_SUICI_OTHER_INTENTI_SELF_H",
    "phenotype": "Suicide or other Intentional self-harm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suicide/intentional self-harm",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_VWXY20_SUICI_OTHER_INTENTI_SELF_H.gz"
  },
  {
    "accessionId": "DGWAS-4159",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_YERSINIAENTERITIS",
    "phenotype": "Enteritis due to Yersinia enterocolitica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Yersinia enteritis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_YERSINIAENTERITIS.gz"
  },
  {
    "accessionId": "DGWAS-4160",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Z21_ASYMP_HUMAN_IMMUNODEFICIENCY_VIRUS_HIV_INFECTION_STATUS",
    "phenotype": "Asymptomatic human immunodeficiency virus [HIV] infection status",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asymptomatic HIV",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Z21_ASYMP_HUMAN_IMMUNODEFICIENCY_VIRUS_HIV_INFECTION_STATUS.gz"
  },
  {
    "accessionId": "DGWAS-4162",
    "sources": "finngenR9",
    "phenocode": "finngen_R9_Z21_PROBL_RELATED_MEDICAL_FACILITI_OTH_HEALTH_CARE",
    "phenotype": "Problems related to medical facilities and other health care",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Healthcare problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r9/summary_stats/finngen_R9_Z21_PROBL_RELATED_MEDICAL_FACILITI_OTH_HEALTH_CARE.gz"
  },
  {
    "accessionId": "DGWAS-4165",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H69.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: H69 Other disorders of Eustachian tube",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eustachian tube disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H69.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4169",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D48.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D48 Neoplasm of uncertain or unknown behaviour of other and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round6/additive-tsvs/D48.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4171",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1067.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: peripheral vascular disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral vascular disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round8/additive-tsvs/20002_1067.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4172",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1076.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: heart failure/pulmonary odema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure/pulmonary edema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round9/additive-tsvs/20002_1076.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4173",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1066.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: heart/cardiac problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart/cardiac problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round10/additive-tsvs/20002_1066.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4175",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1077.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: heart arrhythmia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart arrhythmia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round12/additive-tsvs/20002_1077.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4236",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1648.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: fracture neck of femur / hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral neck/hip fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round73/additive-tsvs/20002_1648.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4241",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C49.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C49 Malignant neoplasm of other connective and soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Connective/soft tissue cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round78/additive-tsvs/C49.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4299",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_8.gwas.imputed_v3.female",
    "phenotype": "Illnesses of mother: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round136/additive-tsvs/20110_8.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4300",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_1.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round137/additive-tsvs/20107_1.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4306",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_11.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round143/additive-tsvs/20544_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4312",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_8.gwas.imputed_v3.female",
    "phenotype": "Illnesses of siblings: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round149/additive-tsvs/20111_8.gwas.imputed_v3.female.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4314",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_8.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round151/additive-tsvs/20107_8.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4321",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IX_CIRCULATORY.gwas.imputed_v3.male",
    "phenotype": "Diseases of the circulatory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circulatory disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round158/additive-tsvs/IX_CIRCULATORY.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4322",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_1.gwas.imputed_v3.female",
    "phenotype": "Illnesses of mother: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round159/additive-tsvs/20110_1.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4323",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_15.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Anxiety, nerves or generalized anxiety disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GAD/anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round160/additive-tsvs/20544_15.gwas.imputed_v3.both_sexes.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4328",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_2.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round165/additive-tsvs/20107_2.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4336",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_2.gwas.imputed_v3.female",
    "phenotype": "Illnesses of mother: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round173/additive-tsvs/20110_2.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4340",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_6.gwas.imputed_v3.female",
    "phenotype": "Illnesses of father: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round177/additive-tsvs/20107_6.gwas.imputed_v3.female.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4344",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_1.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round181/additive-tsvs/20111_1.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4349",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_9.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round186/additive-tsvs/20107_9.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4350",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_3.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round187/additive-tsvs/20107_3.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4351",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_9.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round188/additive-tsvs/20111_9.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4353",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_9.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round190/additive-tsvs/20110_9.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4362",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_13.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Prostate cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - prostate cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round199/additive-tsvs/20107_13.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4363",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_12.gwas.imputed_v3.female",
    "phenotype": "Illnesses of siblings: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round200/additive-tsvs/20111_12.gwas.imputed_v3.female.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4364",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_5.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Breast cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round201/additive-tsvs/20110_5.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4365",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_10.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round202/additive-tsvs/20110_10.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4375",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_2.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round212/additive-tsvs/20544_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4376",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_6.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Panic attacks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round213/additive-tsvs/20544_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4385",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1623.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: tennis elbow / lateral epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tennis elbow",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round222/additive-tsvs/20002_1623.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4388",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1548.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: acne/acne vulgaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne vulgaris",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round225/additive-tsvs/20002_1548.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4389",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1163.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: cholecystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholecystitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round226/additive-tsvs/20002_1163.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4391",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E23.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: E23 Hypofunction and other disorders of pituitary gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pituitary hypofunction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round228/additive-tsvs/E23.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4392",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_4.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round229/additive-tsvs/20107_4.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4393",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1438.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: polycythaemia vera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycythemia vera",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round230/additive-tsvs/20002_1438.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4395",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1504.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: anal fissure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal fissure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round232/additive-tsvs/20002_1504.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4399",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K11_CHOLANGI.gwas.imputed_v3.female",
    "phenotype": "Cholangitis (sclerosing)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sclerosing cholangitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round236/additive-tsvs/K11_CHOLANGI.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4403",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_RETVASCNAS.gwas.imputed_v3.female",
    "phenotype": "Other and unspecified vascular occlusions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular occlusion NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round240/additive-tsvs/H7_RETVASCNAS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4404",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E4_HYTHYNAS.gwas.imputed_v3.female",
    "phenotype": "Hypothyroidism,other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round241/additive-tsvs/E4_HYTHYNAS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4408",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_CARDMPRI.gwas.imputed_v3.female",
    "phenotype": "Cardiomyopathies, Primary/intrinsic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary cardiomyopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round245/additive-tsvs/I9_CARDMPRI.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4409",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1246.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: encephalitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Encephalitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round246/additive-tsvs/20002_1246.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4410",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1657.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: septicaemia / sepsis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Septicemia/sepsis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round247/additive-tsvs/20002_1657.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4413",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_12.gwas.imputed_v3.female",
    "phenotype": "Illnesses of mother: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round250/additive-tsvs/20110_12.gwas.imputed_v3.female.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4414",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I30.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I30 Acute pericarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pericarditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round251/additive-tsvs/I30.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4415",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1193.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: renal failure requiring dialysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal failure requiring dialysis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round252/additive-tsvs/20002_1193.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4417",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1605.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: femoral hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round254/additive-tsvs/20002_1605.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4418",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1384.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: scleroderma/systemic sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scleroderma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round255/additive-tsvs/20002_1384.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4419",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1497.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: pneumothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumothorax",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round256/additive-tsvs/20002_1497.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4420",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_VITRHAEMORR.gwas.imputed_v3.female",
    "phenotype": "Vitreous haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round257/additive-tsvs/H7_VITRHAEMORR.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4422",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1562.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: food intolerance",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Food intolerance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round259/additive-tsvs/20002_1562.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4423",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1509.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: gastroenteritis/dysentry",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastroenteritis/dysentery",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round260/additive-tsvs/20002_1509.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4424",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1437.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: myasthenia gravis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myasthenia gravis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round261/additive-tsvs/20002_1437.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4426",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "DM_BCKGRND_RETINOPAT.gwas.imputed_v3.both_sexes",
    "phenotype": "Background diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic background retinopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round263/additive-tsvs/DM_BCKGRND_RETINOPAT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4428",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1501.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: pyloric stenosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyloric stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round265/additive-tsvs/20002_1501.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4430",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H74.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: H74 Other disorders of middle ear and mastoid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear/mastoid disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round267/additive-tsvs/H74.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4431",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "HYPOTHYROIDISM.gwas.imputed_v3.female",
    "phenotype": "Hypothyroidism (congenital or acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round268/additive-tsvs/HYPOTHYROIDISM.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4432",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "CHRONSMALL.gwas.imputed_v3.male",
    "phenotype": "Crohn's disease of small interstine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (small intestine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round269/additive-tsvs/CHRONSMALL.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4433",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F43.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F43 Reaction to severe stress, and adjustment disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adjustment disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round270/additive-tsvs/F43.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4434",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1445.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: clotting disorder/excessive bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Clotting disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round271/additive-tsvs/20002_1445.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4436",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1254.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: peripheral nerve disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral nerve disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round273/additive-tsvs/20002_1254.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4437",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1661.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: vitiligo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitiligo",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round274/additive-tsvs/20002_1661.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4438",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1373.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: connective tissue disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Connective tissue disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round275/additive-tsvs/20002_1373.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4440",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1327.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: low platelets/platelet disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Low platelets/platelet disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round277/additive-tsvs/20002_1327.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4442",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D3_OTHERBLOOD.gwas.imputed_v3.female",
    "phenotype": "Oher diseases of blood and blood-forming organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round279/additive-tsvs/D3_OTHERBLOOD.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4443",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J46.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: J46 Status asthmaticus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Status asthmaticus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round280/additive-tsvs/J46.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4445",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_4.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round282/additive-tsvs/20110_4.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4446",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1668.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: allergy to house dust mite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "House dust mite allergy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round283/additive-tsvs/20002_1668.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4447",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1487.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: svt / supraventricular tachycardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SVT",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round284/additive-tsvs/20002_1487.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4448",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_5.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Breast cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round285/additive-tsvs/20111_5.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4449",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H92.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H92 Otalgia and effusion of ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otalgia/ear effusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round286/additive-tsvs/H92.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4450",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1523.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: trigemminal neuralgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigeminal neuralgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round287/additive-tsvs/20002_1523.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4452",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_14.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Autism, Asperger's or autistic spectrum disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autism spectrum disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round289/additive-tsvs/20544_14.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4453",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1491.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: brain haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round290/additive-tsvs/20002_1491.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4454",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_6.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round291/additive-tsvs/20110_6.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4456",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J86.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J86 Pyothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyothorax",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round293/additive-tsvs/J86.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4459",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K10.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: K10 Other diseases of jaws",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round296/additive-tsvs/K10.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4460",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E4_DM1NOCOMP.gwas.imputed_v3.female",
    "phenotype": "Type 1 diabetes without complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes uncomplicated",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round297/additive-tsvs/E4_DM1NOCOMP.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4461",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1525.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: benign / essential tremor",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign essential tremor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round298/additive-tsvs/20002_1525.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4462",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1550.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: lichen sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen sclerosus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round299/additive-tsvs/20002_1550.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4466",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D33.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D33 Benign neoplasm of brain and other parts of central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign brain/CNS neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round303/additive-tsvs/D33.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4468",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I46.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I46 Cardiac arrest",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrest",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round305/additive-tsvs/I46.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4470",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "CHIRHEP_NAS.gwas.imputed_v3.male",
    "phenotype": "Chirrosis of liver, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cirrhosis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round307/additive-tsvs/CHIRHEP_NAS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4472",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D07.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D07 Carcinoma in situ of other and unspecified genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital CIS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round309/additive-tsvs/D07.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4474",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1608.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: nephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nephritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round311/additive-tsvs/20002_1608.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4476",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1158.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: liver failure/cirrhosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver failure/cirrhosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round313/additive-tsvs/20002_1158.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4480",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_10.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round317/additive-tsvs/20107_10.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4481",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IBD_VIRAL_HEPATITIS.gwas.imputed_v3.male",
    "phenotype": "Viral hepatitis, IBD co-morbidity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round318/additive-tsvs/IBD_VIRAL_HEPATITIS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4484",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I08.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I08 Multiple valve diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple valve disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round321/additive-tsvs/I08.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4486",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1603.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: rectal prolapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal prolapse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round323/additive-tsvs/20002_1603.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4488",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1619.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: tendonitis / tendinitis / tenosynovitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tendinitis/tenosynovitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round325/additive-tsvs/20002_1619.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4489",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J20.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: J20 Acute bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round326/additive-tsvs/J20.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4491",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1468.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: diabetic neuropathy/ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic neuropathy/ulcers",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round328/additive-tsvs/20002_1468.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4492",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1526.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: polio / poliomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polio",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round329/additive-tsvs/20002_1526.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4494",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D09.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D09 Carcinoma in situ of other and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CIS of other sites",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round331/additive-tsvs/D09.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4495",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D38.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D38 Neoplasm of uncertain or unknown behaviour of middle ear and respiratory and intrathoracic organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (respiratory)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round332/additive-tsvs/D38.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4497",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1455.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: chronic skin ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic skin ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round334/additive-tsvs/20002_1455.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4498",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F33.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F33 Recurrent depressive disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round335/additive-tsvs/F33.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4499",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D44.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D44 Neoplasm of uncertain or unknown behaviour of endocrine glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (endocrine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round336/additive-tsvs/D44.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4501",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J96.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J96 Respiratory failure, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round338/additive-tsvs/J96.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4502",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D14.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D14 Benign neoplasm of middle ear and respiratory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign middle ear/respiratory neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round339/additive-tsvs/D14.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4503",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1080.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: pericardial problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pericardial problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round340/additive-tsvs/20002_1080.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4505",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1512.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: umbilical hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Umbilical hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round342/additive-tsvs/20002_1512.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4507",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1627.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture jaw",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round344/additive-tsvs/20002_1627.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4509",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J31.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J31 Chronic rhinitis, nasopharyngitis and pharyngitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic rhinitis/pharyngitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round346/additive-tsvs/J31.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4511",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1289.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round348/additive-tsvs/20002_1289.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4512",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1414.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: throat or larynx disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Throat/larynx disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round349/additive-tsvs/20002_1414.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4514",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1683.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: benign neuroma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign neuroma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round351/additive-tsvs/20002_1683.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4516",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1433.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: cerebral palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round353/additive-tsvs/20002_1433.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4518",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1258.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: chronic/degenerative neurological problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic degenerative neurologic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round355/additive-tsvs/20002_1258.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4521",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F20.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F20 Schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round358/additive-tsvs/F20.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4522",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IPF.gwas.imputed_v3.female",
    "phenotype": "Idiopathic pulmonary fibrosis (attempt to specificity)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic pulmonary fibrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round359/additive-tsvs/IPF.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4525",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J01.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: J01 Acute sinusitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute sinusitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round362/additive-tsvs/J01.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4526",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1517.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: prostatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round363/additive-tsvs/20002_1517.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4527",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1555.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: cervical polyps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical polyp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round364/additive-tsvs/20002_1555.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4529",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1224.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: thyroid problem (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round366/additive-tsvs/20002_1224.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4530",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1469.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: post-traumatic stress disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PTSD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round367/additive-tsvs/20002_1469.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4532",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F31.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F31 Bipolar affective disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round369/additive-tsvs/F31.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4539",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C91.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C91 Lymphoid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid leukemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round376/additive-tsvs/C91.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4541",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E4_THYTOXGOITDIF.gwas.imputed_v3.female",
    "phenotype": "Thyrotoxicosis with diffuse goitr",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis with diffuse goiter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round378/additive-tsvs/E4_THYTOXGOITDIF.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4542",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1508.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: jaundice (unknown cause)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaundice NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round379/additive-tsvs/20002_1508.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4543",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1573.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: shingles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Herpes zoster",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round380/additive-tsvs/20002_1573.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4545",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E22.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: E22 Hyperfunction of pituitary gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperpituitarism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round382/additive-tsvs/E22.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4546",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D47.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D47 Other neoplasms of uncertain or unknown behaviour of lymphoid, haematopoietic and related tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (lymphoid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round383/additive-tsvs/D47.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4547",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1613.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: blepharitis / eyelid infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blepharitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round384/additive-tsvs/20002_1613.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4548",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1251.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: spinal cord disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal cord disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round385/additive-tsvs/20002_1251.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4549",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H8_CONSENHEARINGLOSS.gwas.imputed_v3.male",
    "phenotype": "Conductive and sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed hearing loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round386/additive-tsvs/H8_CONSENHEARINGLOSS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4550",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H90.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H90 Conductive and sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed hearing loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round387/additive-tsvs/H90.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4551",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J15.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J15 Bacterial pneumonia, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial pneumonia NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round388/additive-tsvs/J15.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4552",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D39.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D39 Neoplasm of uncertain or unknown behaviour of female genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (female genital)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round389/additive-tsvs/D39.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4553",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K07.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K07 Dentofacial anomalies [including malocclusion]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dentofacial anomaly",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round390/additive-tsvs/K07.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4554",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I72.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I72 Other aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aneurysm NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round391/additive-tsvs/I72.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4555",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1222.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: type 1 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round392/additive-tsvs/20002_1222.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4556",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1274.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: eye infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round393/additive-tsvs/20002_1274.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4557",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1646.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture vertebra / crush fracture / vertebral collapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertebral fracture/collapse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round394/additive-tsvs/20002_1646.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4560",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D30.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D30 Benign neoplasm of urinary organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign urinary neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round397/additive-tsvs/D30.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4563",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D11.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D11 Benign neoplasm of major salivary glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign major salivary gland neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round400/additive-tsvs/D11.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4565",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_3.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round402/additive-tsvs/20110_3.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4567",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K06.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: K06 Other disorders of gingiva and edentulous alveolar ridge",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingival/alveolar disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round404/additive-tsvs/K06.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4568",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D21.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D21 Other benign neoplasms of connective and other soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round405/additive-tsvs/D21.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4569",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I12.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I12 Hypertensive renal disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive renal disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round406/additive-tsvs/I12.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4570",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1679.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: undescended testicle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Undescended testis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round407/additive-tsvs/20002_1679.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4571",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1200.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: ureteric obstruction/hydronephrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ureteric obstruction/hydronephrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round408/additive-tsvs/20002_1200.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4574",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1572.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: whooping cough / pertussis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pertussis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round411/additive-tsvs/20002_1572.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4577",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H81.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H81 Disorders of vestibular function",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vestibular disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round414/additive-tsvs/H81.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4578",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D16.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D16 Benign neoplasm of bone and articular cartilage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bone/cartilage neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round415/additive-tsvs/D16.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4579",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I24.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I24 Other acute ischaemic heart diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute ischemic heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round416/additive-tsvs/I24.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4580",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_2.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round417/additive-tsvs/20111_2.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4582",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E16.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E16 Other disorders of pancreatic internal secretion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic endocrine disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round419/additive-tsvs/E16.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4583",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1541.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: carpal tunnel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carpal tunnel syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round420/additive-tsvs/20002_1541.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4584",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1528.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: macular degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round421/additive-tsvs/20002_1528.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4585",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1570.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: rubella / german measles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rubella",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round422/additive-tsvs/20002_1570.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4586",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1194.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: renal failure not requiring dialysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal failure (non-dialysis)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round423/additive-tsvs/20002_1194.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4587",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J06.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J06 Acute upper respiratory infections of multiple and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute upper respiratory infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round424/additive-tsvs/J06.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4590",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D43.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D43 Neoplasm of uncertain or unknown behaviour of brain and central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (CNS)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round427/additive-tsvs/D43.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4591",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E14.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: E14 Unspecified diabetes mellitus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes mellitus NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round428/additive-tsvs/E14.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4592",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J36.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: J36 Peritonsillar abscess",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritonsillar abscess",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round429/additive-tsvs/J36.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4593",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_LACRIGLAND.gwas.imputed_v3.both_sexes",
    "phenotype": "Other disorders of lacrimal gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal gland disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round430/additive-tsvs/H7_LACRIGLAND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4594",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D75.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D75 Other diseases of blood and blood-forming organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round431/additive-tsvs/D75.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4595",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1238.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: pituitary adenoma/tumour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pituitary adenoma/tumor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round432/additive-tsvs/20002_1238.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4596",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K00.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: K00 Disorders of tooth development and eruption",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth development/eruption disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round433/additive-tsvs/K00.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4597",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1435.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: optic neuritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic neuritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round434/additive-tsvs/20002_1435.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4598",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1446.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round435/additive-tsvs/20002_1446.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4600",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1408.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: alcohol dependency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol dependence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round437/additive-tsvs/20002_1408.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4602",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J02.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J02 Acute pharyngitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pharyngitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round439/additive-tsvs/J02.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4603",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K09.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: K09 Cysts of oral region, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral cyst",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round440/additive-tsvs/K09.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4604",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1427.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: polycystic kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycystic kidney disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round441/additive-tsvs/20002_1427.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4607",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I31.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I31 Other diseases of pericardium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pericardial disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round444/additive-tsvs/I31.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4609",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J47.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J47 Bronchiectasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchiectasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round446/additive-tsvs/J47.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4612",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D28.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D28 Benign neoplasm of other and unspecified female genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign female genital neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round449/additive-tsvs/D28.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4614",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H80.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: H80 Otosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round451/additive-tsvs/H80.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4619",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H71.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H71 Cholesteatoma of middle ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear cholesteatoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round456/additive-tsvs/H71.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4625",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E27.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E27 Other disorders of adrenal gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round462/additive-tsvs/E27.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4626",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_LENS.gwas.imputed_v3.male",
    "phenotype": "Disorders of lens",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lens disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round463/additive-tsvs/H7_LENS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4627",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I65.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I65 Occlusion and stenosis of precerebral arteries, not resulting in cerebral infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Precerebral artery stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round464/additive-tsvs/I65.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4631",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C82.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C82 Follicular [nodular] non-Hodgkin's lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round468/additive-tsvs/C82.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4634",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J03.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J03 Acute tonsillitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute tonsillitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round471/additive-tsvs/J03.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4635",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1626.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture skull / head",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skull/head fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round472/additive-tsvs/20002_1626.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4637",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1563.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urticaria",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round474/additive-tsvs/20002_1563.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4638",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I70.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I70 Atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atherosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round475/additive-tsvs/I70.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4640",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I62.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I62 Other nontraumatic intracranial haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontraumatic intracranial hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round477/additive-tsvs/I62.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4641",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D10.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D10 Benign neoplasm of mouth and pharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oral/pharyngeal neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round478/additive-tsvs/D10.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4642",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1249.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: cranial nerve problem/palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cranial nerve palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round479/additive-tsvs/20002_1249.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4643",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K05.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K05 Gingivitis and periodontal diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingivitis/periodontal disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round480/additive-tsvs/K05.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4646",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "DM_RETINOPAT_NOS.gwas.imputed_v3.female",
    "phenotype": "Unclassified diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unclassified diabetic retinopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round483/additive-tsvs/DM_RETINOPAT_NOS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4647",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D45.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D45 Polycythaemia vera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycythemia vera",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round484/additive-tsvs/D45.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4648",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_12.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round485/additive-tsvs/20107_12.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4652",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1279.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: eye trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye trauma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round489/additive-tsvs/20002_1279.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4655",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1428.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroiditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round492/additive-tsvs/20002_1428.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4658",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E4_DM2NOCOMP.gwas.imputed_v3.female",
    "phenotype": "Type 2 diabetes without complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes uncomplicated",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round495/additive-tsvs/E4_DM2NOCOMP.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4659",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I51.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I51 Complications and ill-defined descriptions of heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart disease complication NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round496/additive-tsvs/I51.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4661",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C80.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C80 Malignant neoplasm without specification of site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round498/additive-tsvs/C80.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4664",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1191.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: gastrointestinal bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GI bleeding",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round501/additive-tsvs/20002_1191.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4665",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_HYPTENSHR.gwas.imputed_v3.female",
    "phenotype": "Hypertensive heart and/or renal disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive heart/renal disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round502/additive-tsvs/I9_HYPTENSHR.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4667",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F41.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F41 Other anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round504/additive-tsvs/F41.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4668",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D3_HYPERGAMMAGLONAS.gwas.imputed_v3.both_sexes",
    "phenotype": "Hypergammalglobulinemia, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypergammaglobulinemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round505/additive-tsvs/D3_HYPERGAMMAGLONAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4669",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1655.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: fracture metatarsal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metatarsal fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round506/additive-tsvs/20002_1655.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4670",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I86.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I86 Varicose veins of other sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varicose veins (other)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round507/additive-tsvs/I86.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4672",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1221.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: gestational diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round509/additive-tsvs/20002_1221.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4673",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K11_GALLBILPANC.gwas.imputed_v3.female",
    "phenotype": "Disorders of gallbladder, biliary tract and pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder/biliary/pancreas disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round510/additive-tsvs/K11_GALLBILPANC.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4674",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I87.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: I87 Other disorders of veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vein disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round511/additive-tsvs/I87.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4677",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1495.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: lymphoedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphedema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round514/additive-tsvs/20002_1495.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4678",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I74.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I74 Arterial embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial embolism/thrombosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round515/additive-tsvs/I74.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4681",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1544.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: dupuytren's contracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dupuytren contracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round518/additive-tsvs/20002_1544.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4682",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C71.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C71 Malignant neoplasm of brain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round519/additive-tsvs/C71.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4683",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J84.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J84 Other interstitial pulmonary diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Interstitial lung disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round520/additive-tsvs/J84.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4689",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_4.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round526/additive-tsvs/20111_4.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4691",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H91.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H91 Other hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hearing loss NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round528/additive-tsvs/H91.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4694",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1629.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: fracture face / orbit / eye socket",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial/orbit fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round531/additive-tsvs/20002_1629.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4697",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D26.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D26 Other benign neoplasms of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign uterine neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round534/additive-tsvs/D26.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4698",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1578.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: hepatitis a",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatitis A",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round535/additive-tsvs/20002_1578.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4699",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J93.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J93 Pneumothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumothorax",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round536/additive-tsvs/J93.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4702",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_4.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: A personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round539/additive-tsvs/20544_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4705",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1677.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: scarlet fever / scarlatina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scarlet fever",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round542/additive-tsvs/20002_1677.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4706",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I67.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I67 Other cerebrovascular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebrovascular disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round543/additive-tsvs/I67.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4707",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_6.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round544/additive-tsvs/20111_6.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4708",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F45.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: F45 Somatoform disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Somatoform disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round545/additive-tsvs/F45.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4709",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1322.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: myositis/myopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myositis/myopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round546/additive-tsvs/20002_1322.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4710",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D41.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D41 Neoplasm of uncertain or unknown behaviour of urinary organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (urinary)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round547/additive-tsvs/D41.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4711",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I42.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I42 Cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round548/additive-tsvs/I42.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4712",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J39.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J39 Other diseases of upper respiratory tract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper respiratory disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round549/additive-tsvs/J39.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4714",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I27.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: I27 Other pulmonary heart diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round551/additive-tsvs/I27.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4715",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I45.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I45 Other conduction disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conduction disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round552/additive-tsvs/I45.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4717",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D34.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D34 Benign neoplasm of thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign thyroid neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round554/additive-tsvs/D34.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4722",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1532.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: disc problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round559/additive-tsvs/20002_1532.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4726",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1441.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: malaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malaria",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round563/additive-tsvs/20002_1441.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4727",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C92.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C92 Myeloid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloid leukemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round564/additive-tsvs/C92.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4728",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1472.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: emphysema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round565/additive-tsvs/20002_1472.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4733",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C90.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C90 Multiple myeloma and malignant plasma cell neoplasms",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round570/additive-tsvs/C90.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4735",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_3.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round572/additive-tsvs/20111_3.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4739",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1377.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: polymyalgia rheumatica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polymyalgia rheumatica",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round576/additive-tsvs/20002_1377.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4741",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E4_THYTOXNAS.gwas.imputed_v3.female",
    "phenotype": "Thyrotoxicosis, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round578/additive-tsvs/E4_THYTOXNAS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4743",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F05.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: F05 Delirium, not induced by alcohol and other psychoactive substances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Delirium (non-substance)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round580/additive-tsvs/F05.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4745",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I61.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I61 Intracerebral haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracerebral hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round582/additive-tsvs/I61.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4747",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D35.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D35 Benign neoplasm of other and unspecified endocrine glands",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign endocrine neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round584/additive-tsvs/D35.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4748",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I89.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: I89 Other non-infective disorders of lymphatic vessels and lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfective lymphatic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round585/additive-tsvs/I89.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4752",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1510.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: dyspepsia / indigestion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dyspepsia/indigestion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round589/additive-tsvs/20002_1510.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4753",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I85.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I85 Oesophageal varices",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal varices",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round590/additive-tsvs/I85.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4755",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1518.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: erectile dysfunction / impotence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erectile dysfunction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round592/additive-tsvs/20002_1518.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4764",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1083.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: subdural haemorrhage/haematoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subdural hemorrhage/hematoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round601/additive-tsvs/20002_1083.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4765",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1250.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: bell's palsy/facial nerve palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bell palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round602/additive-tsvs/20002_1250.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4768",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D04.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D04 Carcinoma in situ of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin CIS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round605/additive-tsvs/D04.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4770",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1419.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: vocal cord polyp",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vocal cord polyp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round607/additive-tsvs/20002_1419.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4771",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D69.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D69 Purpura and other haemorrhagic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Purpura/hemorrhagic condition",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round608/additive-tsvs/D69.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4772",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I78.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I78 Diseases of capillaries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Capillary disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round609/additive-tsvs/I78.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4773",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C53.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C53 Malignant neoplasm of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round610/additive-tsvs/C53.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4775",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IBD_PULM.gwas.imputed_v3.female",
    "phenotype": "Respiratory diseases principally affecting the interstitium, IBD co-morbidites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Interstitial lung disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round612/additive-tsvs/IBD_PULM.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4778",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1293.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: bone disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round615/additive-tsvs/20002_1293.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4783",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20001_1073.gwas.imputed_v3.male",
    "phenotype": "Cancer code, self-reported: rodent ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rodent ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round620/additive-tsvs/20001_1073.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4785",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1364.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: breast disease (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round622/additive-tsvs/20002_1364.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4786",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D12.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D12 Benign neoplasm of colon, rectum, anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colorectal/anal neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round623/additive-tsvs/D12.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4788",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D36.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D36 Benign neoplasm of other and unspecified sites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign neoplasm NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round625/additive-tsvs/D36.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4789",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1372.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: vasculitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vasculitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round626/additive-tsvs/20002_1372.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4790",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "CARDIAC_ARRHYTM.gwas.imputed_v3.male",
    "phenotype": "Cardiac arrhytmias, COPD co-morbidities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrhythmia with COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round627/additive-tsvs/CARDIAC_ARRHYTM.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4794",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I33.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: I33 Acute and subacute endocarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocarditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round631/additive-tsvs/I33.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4795",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I34.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I34 Nonrheumatic mitral valve disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonrheumatic mitral valve disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round632/additive-tsvs/I34.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4796",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C45.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: C45 Mesothelioma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesothelioma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round633/additive-tsvs/C45.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4797",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1575.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: herpes simplex",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Herpes simplex",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round634/additive-tsvs/20002_1575.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4798",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20107_11.gwas.imputed_v3.male",
    "phenotype": "Illnesses of father: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round635/additive-tsvs/20107_11.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4799",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D61.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D61 Other aplastic anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aplastic anemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round636/additive-tsvs/D61.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4800",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_12.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Bulimia nervosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bulimia nervosa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round637/additive-tsvs/20544_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4807",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1267.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: spinal injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round644/additive-tsvs/20002_1267.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4809",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I60.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I60 Subarachnoid haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subarachnoid hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round646/additive-tsvs/I60.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4811",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_13.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Prostate cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - prostate cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round648/additive-tsvs/20111_13.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4816",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1660.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: rosacea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rosacea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round653/additive-tsvs/20002_1660.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4819",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_1.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Social anxiety or social phobia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Social anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round656/additive-tsvs/20544_1.gwas.imputed_v3.both_sexes.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4823",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_17.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Agoraphobia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agoraphobia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round660/additive-tsvs/20544_17.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4827",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_13.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Psychological over-eating or binge-eating",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binge eating disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round664/additive-tsvs/20544_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4832",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D13.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D13 Benign neoplasm of other and ill-defined parts of digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign digestive neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round669/additive-tsvs/D13.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4839",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J43.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: J43 Emphysema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round676/additive-tsvs/J43.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4843",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I77.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I77 Other disorders of arteries and arterioles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Artery/arteriole disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round680/additive-tsvs/I77.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4845",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C44.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C44 Other malignant neoplasms of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-melanoma skin cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round682/additive-tsvs/C44.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4847",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H83.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H83 Other diseases of inner ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inner ear disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round684/additive-tsvs/H83.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4854",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_10.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Mania, hypomania, bipolar or manic-depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round691/additive-tsvs/20544_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4857",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E10.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E10 Insulin-dependent diabetes mellitus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round694/additive-tsvs/E10.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4861",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1599.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: constipation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Constipation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round698/additive-tsvs/20002_1599.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4862",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D03.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D03 Melanoma in situ",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma in situ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round699/additive-tsvs/D03.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4863",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_GLAUCPRIMOPEN.gwas.imputed_v3.female",
    "phenotype": "Primary open-angle glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary open-angle glaucoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round700/additive-tsvs/H7_GLAUCPRIMOPEN.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4865",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1664.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: dysmenorrhoea / dysmenorrhea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dysmenorrhea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round702/additive-tsvs/20002_1664.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4866",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I44.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I44 Atrioventricular and left bundle-branch block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AV/LBBB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round703/additive-tsvs/I44.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4869",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_PULMOTHHD.gwas.imputed_v3.both_sexes",
    "phenotype": "Other pulmonary heart/vessel disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary heart/vessel disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round706/additive-tsvs/I9_PULMOTHHD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4870",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I48.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I48 Atrial fibrillation and flutter",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrial fibrillation/flutter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round707/additive-tsvs/I48.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4871",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I73.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I73 Other peripheral vascular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral vascular disease NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round708/additive-tsvs/I73.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4877",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20544_16.gwas.imputed_v3.both_sexes",
    "phenotype": "Mental health problems ever diagnosed by a professional: Anorexia nervosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorexia nervosa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round714/additive-tsvs/20544_16.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4878",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D89.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D89 Other disorders involving the immune mechanism, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immune disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round715/additive-tsvs/D89.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4881",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1533.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: disc degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round718/additive-tsvs/20002_1533.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4882",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1192.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: renal/kidney failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round719/additive-tsvs/20002_1192.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4883",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_11.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round720/additive-tsvs/20111_11.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4885",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F10.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: F10 Mental and behavioural disorders due to use of alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol use disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round722/additive-tsvs/F10.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4887",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D3_IMMUNEMECHANISMOTHER.gwas.imputed_v3.both_sexes",
    "phenotype": "Other disorders involving the immune mechanism, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Immune disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round724/additive-tsvs/D3_IMMUNEMECHANISMOTHER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4894",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20111_10.gwas.imputed_v3.male",
    "phenotype": "Illnesses of siblings: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round731/additive-tsvs/20111_10.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4897",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J35.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J35 Chronic diseases of tonsils and adenoids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic tonsil/adenoid disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round734/additive-tsvs/J35.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4898",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1485.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: irregular heart beat",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Irregular heartbeat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round735/additive-tsvs/20002_1485.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4900",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1256.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: acute infective polyneuritis/guillain-barre syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Guillain-Barre syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round737/additive-tsvs/20002_1256.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4901",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1454.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: blistering/desquamating skin disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blistering skin disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round738/additive-tsvs/20002_1454.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4903",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "III_BLOOD_IMMUN.gwas.imputed_v3.male",
    "phenotype": "Diseases of the blood and blood-forming organs and certain disorders involving the immune mechanism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood/immune disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round740/additive-tsvs/III_BLOOD_IMMUN.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4904",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I_INFECT_PARASIT.gwas.imputed_v3.male",
    "phenotype": "Certain infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious/parasitic disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round741/additive-tsvs/I_INFECT_PARASIT.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4907",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1631.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture clavicle / collar bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Clavicle fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round744/additive-tsvs/20002_1631.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4910",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1282.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: retinal artery/vein occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal artery/vein occlusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round747/additive-tsvs/20002_1282.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4912",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I82.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: I82 Other venous embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Venous embolism/thrombosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round749/additive-tsvs/I82.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4913",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H73.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: H73 Other disorders of tympanic membrane",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round750/additive-tsvs/H73.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4914",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H72.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: H72 Perforation of tympanic membrane",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane perforation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round751/additive-tsvs/H72.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4915",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I83.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I83 Varicose veins of lower extremities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity varicose veins",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round752/additive-tsvs/I83.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4917",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E21.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E21 Hyperparathyroidism and other disorders of parathyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperparathyroidism/parathyroid disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round754/additive-tsvs/E21.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4918",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1276.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: diabetic eye disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic eye disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round755/additive-tsvs/20002_1276.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4919",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1308.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: osteomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteomyelitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round756/additive-tsvs/20002_1308.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4928",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I64.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I64 Stroke, not specified as haemorrhage or infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round765/additive-tsvs/I64.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4929",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C64.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C64 Malignant neoplasm of kidney, except renal pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (non-pelvis)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round766/additive-tsvs/C64.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4930",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "CHRONNAS.gwas.imputed_v3.male",
    "phenotype": "Chron's disease NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round767/additive-tsvs/CHRONNAS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4935",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J40.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: J40 Bronchitis, not specified as acute or chronic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchitis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round772/additive-tsvs/J40.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4937",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E11.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E11 Non-insulin-dependent diabetes mellitus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round774/additive-tsvs/E11.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4938",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1477.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: psoriatic arthropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriatic arthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round775/additive-tsvs/20002_1477.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4939",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D32.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D32 Benign neoplasm of meninges",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign meningeal neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round776/additive-tsvs/D32.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4941",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20110_11.gwas.imputed_v3.male",
    "phenotype": "Illnesses of mother: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round778/additive-tsvs/20110_11.gwas.imputed_v3.male.v2.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4942",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1470.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: anorexia/bulimia/other eating disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eating disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round779/additive-tsvs/20002_1470.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4944",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D70.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D70 Agranulocytosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agranulocytosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round781/additive-tsvs/D70.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4946",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1558.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: ectopic pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectopic pregnancy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round783/additive-tsvs/20002_1558.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4952",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1531.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: post-natal depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postpartum depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round789/additive-tsvs/20002_1531.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4953",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1554.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: cervical intra-epithelial neoplasia (cin) / precancerous cells cervix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical CIN",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round790/additive-tsvs/20002_1554.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4955",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1371.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: sarcoidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoidosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round792/additive-tsvs/20002_1371.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4959",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E87.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: E87 Other disorders of fluid, electrolyte and acid-base balance",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fluid/electrolyte disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round796/additive-tsvs/E87.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4961",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1597.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: tinnitus / tiniitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tinnitus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round798/additive-tsvs/20002_1597.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4963",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C83.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: C83 Diffuse non-Hodgkin's lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diffuse NHL",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round800/additive-tsvs/C83.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4970",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1561.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: raynaud's phenomenon/disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Raynaud phenomenon",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round807/additive-tsvs/20002_1561.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4971",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D63.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D63 Anaemia in chronic diseases classified elsewhere",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia of chronic disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round808/additive-tsvs/D63.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4974",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1628.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture nose",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round811/additive-tsvs/20002_1628.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4978",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "DM_PERIPHATHERO.gwas.imputed_v3.male",
    "phenotype": "Peripheral atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral atherosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round815/additive-tsvs/DM_PERIPHATHERO.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4979",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J98.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: J98 Other respiratory disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round816/additive-tsvs/J98.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4980",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1290.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: deliberate self-harm/suicide attempt",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm/suicide attempt",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round817/additive-tsvs/20002_1290.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4984",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "F32.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: F32 Depressive episode",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depressive episode",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round821/additive-tsvs/F32.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4985",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D37.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D37 Neoplasm of uncertain or unknown behaviour of oral cavity and digestive organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior (oral/digestive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round822/additive-tsvs/D37.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4987",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1610.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: thyroid goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid goiter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round824/additive-tsvs/20002_1610.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4988",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I95.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I95 Hypotension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypotension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round825/additive-tsvs/I95.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4989",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IBD_BACT_INTEST_INFECTIONS.gwas.imputed_v3.male",
    "phenotype": "Bacterial intestinal infections, IBD co-morbidities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial intestinal infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round826/additive-tsvs/IBD_BACT_INTEST_INFECTIONS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4990",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I22.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I22 Subsequent myocardial infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subsequent MI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round827/additive-tsvs/I22.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4991",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D18.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D18 Haemangioma and lymphangioma, any site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemangioma/lymphangioma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round828/additive-tsvs/D18.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4994",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D86.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D86 Sarcoidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoidosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round831/additive-tsvs/D86.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-4995",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1494.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: varicose veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varicose veins",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round832/additive-tsvs/20002_1494.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5002",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E66.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E66 Obesity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round839/additive-tsvs/E66.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5005",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I35.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: I35 Nonrheumatic aortic valve disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonrheumatic aortic valve disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round842/additive-tsvs/I35.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5006",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1382.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: sjogren's syndrome/sicca syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sjogren syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round843/additive-tsvs/20002_1382.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5007",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1275.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: retinal problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round844/additive-tsvs/20002_1275.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5008",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D46.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: D46 Myelodysplastic syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myelodysplastic syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round845/additive-tsvs/D46.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5009",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1196.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: urinary tract infection/kidney infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "UTI/kidney infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round846/additive-tsvs/20002_1196.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5010",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J34.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J34 Other disorders of nose and nasal sinuses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nose/nasal sinus disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round847/additive-tsvs/J34.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5011",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1634.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture forearm / wrist",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Forearm/wrist fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round848/additive-tsvs/20002_1634.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5013",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1214.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: testicular problems (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round850/additive-tsvs/20002_1214.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5017",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E83.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: E83 Disorders of mineral metabolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mineral metabolism disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round854/additive-tsvs/E83.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5020",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1499.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: labyrinthitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labyrinthitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round857/additive-tsvs/20002_1499.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5021",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I49.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I49 Other cardiac arrhythmias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrhythmia NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round858/additive-tsvs/I49.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5025",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I71.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I71 Aortic aneurysm and dissection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic aneurysm/dissection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round862/additive-tsvs/I71.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5026",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E05.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: E05 Thyrotoxicosis [hyperthyroidism]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round863/additive-tsvs/E05.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5028",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J32.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J32 Chronic sinusitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic sinusitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round865/additive-tsvs/J32.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5030",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J13.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: J13 Pneumonia due to Streptococcus pneumoniae",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumococcal pneumonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round867/additive-tsvs/J13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5034",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_DVTANDPULM.gwas.imputed_v3.male",
    "phenotype": "DVT of lower extremities and pulmonary embolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT and PE",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round871/additive-tsvs/I9_DVTANDPULM.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5051",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1381.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: systemic lupus erythematosis/sle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SLE",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round888/additive-tsvs/20002_1381.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5054",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_HEARTFAIL_NS.gwas.imputed_v3.female",
    "phenotype": "Heart failure, not strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (broad)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round891/additive-tsvs/I9_HEARTFAIL_NS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5056",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K01.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K01 Embedded and impacted teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Embedded/impacted teeth",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round893/additive-tsvs/K01.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5061",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K04.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K04 Diseases of pulp and periapical tissues",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulp/periapical disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round898/additive-tsvs/K04.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5070",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1413.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: nasal/sinus disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal/sinus disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round907/additive-tsvs/20002_1413.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5073",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1471.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: atrial fibrillation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrial fibrillation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round910/additive-tsvs/20002_1471.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5074",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1403.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: female infertility",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female infertility",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round911/additive-tsvs/20002_1403.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5079",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "ENDOMETRIOSIS_NOS.gwas.imputed_v3.female",
    "phenotype": "Unsepcified/other endometriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round916/additive-tsvs/ENDOMETRIOSIS_NOS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5081",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1161.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: gall bladder disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round918/additive-tsvs/20002_1161.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5084",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D3_OTHERANAEMIA.gwas.imputed_v3.male",
    "phenotype": "Other anaemias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round921/additive-tsvs/D3_OTHERANAEMIA.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5087",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1350.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: polycystic ovaries/polycystic ovarian syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PCOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round924/additive-tsvs/20002_1350.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5088",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1287.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: anxiety/panic attacks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety/panic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round925/additive-tsvs/20002_1287.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5091",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C77.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C77 Secondary and unspecified malignant neoplasm of lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary lymph node cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round928/additive-tsvs/C77.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5092",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C67.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C67 Malignant neoplasm of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round929/additive-tsvs/C67.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5094",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J33.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: J33 Nasal polyp",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal polyp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round931/additive-tsvs/J33.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5095",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D06.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D06 Carcinoma in situ of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical CIS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round932/additive-tsvs/D06.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5096",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1082.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: transient ischaemic attack (tia)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TIA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round933/additive-tsvs/20002_1082.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5098",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K08.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K08 Other disorders of teeth and supporting structures",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental/supporting disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round935/additive-tsvs/K08.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5099",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "ENDOMETRIOSIS_UTERUS.gwas.imputed_v3.female",
    "phenotype": "Endometriosis of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round936/additive-tsvs/ENDOMETRIOSIS_UTERUS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5100",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K02.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: K02 Dental caries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round937/additive-tsvs/K02.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5102",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K11_APPENDIX.gwas.imputed_v3.male",
    "phenotype": "Diseases of appendix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendix disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round939/additive-tsvs/K11_APPENDIX.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5103",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1374.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: allergy/hypersensitivity/anaphylaxis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergy/anaphylaxis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round940/additive-tsvs/20002_1374.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5104",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1569.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: mumps / epidemic parotitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mumps",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round941/additive-tsvs/20002_1569.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5105",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "J90.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: J90 Pleural effusion, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural effusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round942/additive-tsvs/J90.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5106",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1294.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: back problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Back problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round943/additive-tsvs/20002_1294.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5108",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1663.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: abnormal smear (cervix)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal cervical smear",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round945/additive-tsvs/20002_1663.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5111",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "COPD_EARLYANDLATER.gwas.imputed_v3.male",
    "phenotype": "COPD, early/later onset",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round948/additive-tsvs/COPD_EARLYANDLATER.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5114",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D22.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: D22 Melanocytic naevi",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanocytic nevus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round951/additive-tsvs/D22.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5115",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1651.gwas.imputed_v3.male",
    "phenotype": "Non-cancer illness code, self-reported: fracture lower leg / ankle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower leg/ankle fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round952/additive-tsvs/20002_1651.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5116",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "H7_EYELIDNAS.gwas.imputed_v3.male",
    "phenotype": "Other specified and unspecified disorders of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round953/additive-tsvs/H7_EYELIDNAS.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5119",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I47.gwas.imputed_v3.male",
    "phenotype": "Diagnoses - main ICD10: I47 Paroxysmal tachycardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paroxysmal tachycardia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round956/additive-tsvs/I47.gwas.imputed_v3.male.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5134",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "K11_BARRET.gwas.imputed_v3.female",
    "phenotype": "Barret oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Barrett esophagus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round971/additive-tsvs/K11_BARRET.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5136",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1348.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: gynaecological disorder (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gynecological disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round973/additive-tsvs/20002_1348.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5150",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1405.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: other renal/kidney problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal/kidney problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round987/additive-tsvs/20002_1405.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5153",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C56.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: C56 Malignant neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round990/additive-tsvs/C56.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5155",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1353.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: vaginal prolapse/uterine prolapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal/uterine prolapse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round992/additive-tsvs/20002_1353.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5156",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1436.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: headaches (not migraine)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Headache",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round993/additive-tsvs/20002_1436.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5163",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "I9_HYPTENSPREG.gwas.imputed_v3.female",
    "phenotype": "Hypertension complicating pregnancy, childbirth, and the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1000/additive-tsvs/I9_HYPTENSPREG.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5166",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1559.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: miscarriage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Miscarriage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1003/additive-tsvs/20002_1559.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5167",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1511.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: abdominal hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1004/additive-tsvs/20002_1511.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5175",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1556.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: menorrhagia (unknown cause)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menorrhagia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1012/additive-tsvs/20002_1556.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5179",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "IBD_ENDOMETRIOSIS.gwas.imputed_v3.female",
    "phenotype": "Endometriosis, IBD co-morbidity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1016/additive-tsvs/IBD_ENDOMETRIOSIS.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5182",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "D27.gwas.imputed_v3.female",
    "phenotype": "Diagnoses - main ICD10: D27 Benign neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign ovarian neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1019/additive-tsvs/D27.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5185",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1352.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: uterine polyps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine polyp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1022/additive-tsvs/20002_1352.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5189",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1456.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: malabsorption/coeliac disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malabsorption/celiac disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1026/additive-tsvs/20002_1456.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5192",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1666.gwas.imputed_v3.female",
    "phenotype": "Non-cancer illness code, self-reported: benign breast lump",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign breast lump",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1029/additive-tsvs/20002_1666.gwas.imputed_v3.female.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5221",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "E86.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: E86 Volume depletion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Volume depletion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1058/additive-tsvs/E86.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5255",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1451.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: hereditary/genetic haematological disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hereditary hematologic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1092/additive-tsvs/20002_1451.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5265",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1514.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: cystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1102/additive-tsvs/20002_1514.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5308",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1639.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: fracture finger",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Finger fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1145/additive-tsvs/20002_1639.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5328",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1652.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: fracture tibia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tibia fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1165/additive-tsvs/20002_1652.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5346",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1567.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: infectious mononucleosis / glandular fever / epstein barr virus (ebv)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious mononucleosis/EBV",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1183/additive-tsvs/20002_1567.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5349",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1529.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: dry eyes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dry eye",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1186/additive-tsvs/20002_1529.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5362",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1542.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: fibromyalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibromyalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1199/additive-tsvs/20002_1542.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5415",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "C85.gwas.imputed_v3.both_sexes",
    "phenotype": "Diagnoses - main ICD10: C85 Other and unspecified types of non-Hodgkin's lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NHL NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1252/additive-tsvs/C85.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5427",
    "sources": "ukbbank_nealelab_v3",
    "phenocode": "20002_1257.gwas.imputed_v3.both_sexes",
    "phenotype": "Non-cancer illness code, self-reported: trapped nerve/compressed nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Entrapment neuropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round1264/additive-tsvs/20002_1257.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DGWAS-5518",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST003770",
    "phenotype": "Neuroticism",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Neuroticism",
    "pmid": "27089181",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST003770.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5524",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST004695",
    "phenotype": "Insomnia complaints",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Insomnia",
    "pmid": "28604731",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST004695.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5530",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST004988",
    "phenotype": "Breast cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer",
    "pmid": "29059683",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST004988.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5531",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005038",
    "phenotype": "Allergic disease (asthma, hay fever or eczema)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic disease",
    "pmid": "29083406",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005038.vcf.gz"
  },
  {
    "accessionId": "DGWAS-554",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_DYSPOLYGL",
    "phenotype": "Polyglandular dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyglandular dysfunction",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_DYSPOLYGL.gz"
  },
  {
    "accessionId": "DGWAS-5556",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005840",
    "phenotype": "Ischemic stroke (large artery atherosclerosis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic stroke (large artery)",
    "pmid": "29531354",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005840.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5557",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005841",
    "phenotype": "Ischemic stroke (small-vessel)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic stroke (small vessel)",
    "pmid": "29531354",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005841.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5558",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005842",
    "phenotype": "Ischemic stroke (cardioembolic)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic stroke (cardioembolic)",
    "pmid": "29531354",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005842.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5560",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005902",
    "phenotype": "Depression (broad)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression (broad)",
    "pmid": "29662059",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005902.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5561",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005903",
    "phenotype": "Major depressive disorder (ICD-10 coded)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major depressive disorder",
    "pmid": "29662059",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005903.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5562",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005904",
    "phenotype": "Major depressive disorder (probable)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major depressive disorder (probable)",
    "pmid": "29662059",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005904.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5563",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005920",
    "phenotype": "Paternal history of Alzheimer's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - Alzheimer disease",
    "pmid": "29777097",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005920.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5564",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005921",
    "phenotype": "Family history of Alzheimer's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - Alzheimer disease",
    "pmid": "29777097",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005921.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5565",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST005923",
    "phenotype": "Maternal history of Alzheimer's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - Alzheimer disease",
    "pmid": "29777097",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST005923.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5569",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST006464",
    "phenotype": "Endometrial cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometrial cancer",
    "pmid": "30093612",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST006464.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5572",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST006475",
    "phenotype": "Depressed affect",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depressed affect",
    "pmid": "29942085",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST006475.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5582",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST006940",
    "phenotype": "Neurociticism",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Neuroticism",
    "pmid": "29500382",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST006940.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5584",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007090",
    "phenotype": "Knee osteoarthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee osteoarthritis",
    "pmid": "30664745",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007090.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5585",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007091",
    "phenotype": "Osteoarthritis (hip)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip osteoarthritis",
    "pmid": "30664745",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007091.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5586",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007092",
    "phenotype": "Osteoarthritis of the hip or knee",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip/knee osteoarthritis",
    "pmid": "30664745",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007092.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5589",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007516",
    "phenotype": "Type 2 diabetes (adjusted for BMI)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes (BMI-adjusted)",
    "pmid": "29632382",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007516.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5591",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007799",
    "phenotype": "Asthma (adult onset)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adult-onset asthma",
    "pmid": "30929738",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007799.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5592",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST007800",
    "phenotype": "Asthma (childhood onset)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood-onset asthma",
    "pmid": "30929738",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST007800.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5601",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST010723",
    "phenotype": "Early age-related macular degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early AMD",
    "pmid": "32843070",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST010723.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5603",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST010776",
    "phenotype": "COVID-19 (RELEASE 4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 (Release 4)",
    "pmid": "32404885",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST010776.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5604",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST010777",
    "phenotype": "COVID-19 (hospitalized vs population) RELEASE 4",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 hospitalized (Release 4)",
    "pmid": "32404885",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST010777.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5605",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST010778",
    "phenotype": "COVID-19 (covid vs lab/self reported negative) RELEASE 4",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 (Release 4)",
    "pmid": "32404885",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST010778.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5610",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST010783",
    "phenotype": "COVID-19 (very severe respiratory confirmed vs population) RELEASE 4",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 severe (Release 4)",
    "pmid": "32404885",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST010783.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5611",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST90000025",
    "phenotype": "Appendicular lean mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Appendicular lean mass",
    "pmid": "33097823",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST90000025.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5614",
    "sources": "IEU database",
    "phenocode": "ebi-a-GCST90000032",
    "phenotype": "Myeloproliferative neoplasms",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloproliferative neoplasm",
    "pmid": "33057200",
    "download": "https://gwas.mrcieu.ac.uk/files/ebi-a-GCST90000032.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5616",
    "sources": "IEU database",
    "phenocode": "ieu-a-1000",
    "phenotype": "Depressive symptoms",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depressive symptoms",
    "pmid": "27089181",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1000.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5648",
    "sources": "IEU database",
    "phenocode": "ieu-a-1126",
    "phenotype": "Breast cancer (Combined Oncoarray; iCOGS; GWAS meta analysis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (meta)",
    "pmid": "29059683",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1126.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5649",
    "sources": "IEU database",
    "phenocode": "ieu-a-1127",
    "phenotype": "ER+ Breast cancer (Combined Oncoarray; iCOGS; GWAS meta analysis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ER+ breast cancer",
    "pmid": "29059683",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1127.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5650",
    "sources": "IEU database",
    "phenocode": "ieu-a-1128",
    "phenotype": "ER- Breast cancer (Combined Oncoarray; iCOGS; GWAS meta analysis)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ER- breast cancer",
    "pmid": "29059683",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1128.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5651",
    "sources": "IEU database",
    "phenocode": "ieu-a-1129",
    "phenotype": "Breast cancer (Oncoarray)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (Oncoarray)",
    "pmid": "29059683",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1129.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5673",
    "sources": "IEU database",
    "phenocode": "ieu-a-1188",
    "phenotype": "Major Depressive Disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major depressive disorder",
    "pmid": "29700475",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-1188.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5739",
    "sources": "IEU database",
    "phenocode": "ieu-a-93",
    "phenotype": "Overweight",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overweight",
    "pmid": "23563607",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-a-93.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5764",
    "sources": "IEU database",
    "phenocode": "ieu-b-105",
    "phenotype": "FVC",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Forced vital capacity",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-105.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5775",
    "sources": "IEU database",
    "phenocode": "ieu-b-46",
    "phenotype": "Urinary sodium-potassium ratio",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urinary Na/K ratio",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-46.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5782",
    "sources": "IEU database",
    "phenocode": "ieu-b-4862",
    "phenotype": "Chronotype",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Chronotype",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4862.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5783",
    "sources": "IEU database",
    "phenocode": "ieu-b-4874",
    "phenotype": "Bladder cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4874.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5784",
    "sources": "IEU database",
    "phenocode": "ieu-b-4875",
    "phenotype": "brain cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4875.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5785",
    "sources": "IEU database",
    "phenocode": "ieu-b-4876",
    "phenotype": "cervical cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4876.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5786",
    "sources": "IEU database",
    "phenocode": "ieu-b-4913",
    "phenotype": "Laryngeal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Laryngeal cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4913.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5787",
    "sources": "IEU database",
    "phenocode": "ieu-b-4914",
    "phenotype": "Leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leukemia",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4914.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5788",
    "sources": "IEU database",
    "phenocode": "ieu-b-4915",
    "phenotype": "Liver & bile duct cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver/bile duct cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4915.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5789",
    "sources": "IEU database",
    "phenocode": "ieu-b-4953",
    "phenotype": "Liver cell carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatocellular carcinoma",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4953.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5792",
    "sources": "IEU database",
    "phenocode": "ieu-b-4956",
    "phenotype": "Lymphoid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid leukemia",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4956.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5793",
    "sources": "IEU database",
    "phenocode": "ieu-b-4957",
    "phenotype": "Multiple myeloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4957.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5795",
    "sources": "IEU database",
    "phenocode": "ieu-b-4959",
    "phenotype": "Malignant non-melanoma skin cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-melanoma skin cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4959.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5796",
    "sources": "IEU database",
    "phenocode": "ieu-b-4960",
    "phenotype": "Oesophageal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4960.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5797",
    "sources": "IEU database",
    "phenocode": "ieu-b-4961",
    "phenotype": "Oral cavity cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral cavity cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4961.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5798",
    "sources": "IEU database",
    "phenocode": "ieu-b-4962",
    "phenotype": "Oral and oropharyngeal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral/oropharyngeal cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4962.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5799",
    "sources": "IEU database",
    "phenocode": "ieu-b-4963",
    "phenotype": "Ovarian cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4963.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5800",
    "sources": "IEU database",
    "phenocode": "ieu-b-4964",
    "phenotype": "Pan cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pan cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4964.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5802",
    "sources": "IEU database",
    "phenocode": "ieu-b-4967",
    "phenotype": "Appendicitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendicitis",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4967.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5803",
    "sources": "IEU database",
    "phenocode": "ieu-b-4968",
    "phenotype": "Oropharyngeal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oropharyngeal cancer",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4968.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5804",
    "sources": "IEU database",
    "phenocode": "ieu-b-4969",
    "phenotype": "Melanoma skin cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4969.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5806",
    "sources": "IEU database",
    "phenocode": "ieu-b-4971",
    "phenotype": "Cholecystitits",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholecystitis",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4971.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5809",
    "sources": "IEU database",
    "phenocode": "ieu-b-4976",
    "phenotype": "Pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4976.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5811",
    "sources": "IEU database",
    "phenocode": "ieu-b-4978",
    "phenotype": "Pneumonia (critical care)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia (critical care)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4978.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5812",
    "sources": "IEU database",
    "phenocode": "ieu-b-4979",
    "phenotype": "Pneumonia (death)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia (death)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4979.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5813",
    "sources": "IEU database",
    "phenocode": "ieu-b-4980",
    "phenotype": "Sepsis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4980.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5814",
    "sources": "IEU database",
    "phenocode": "ieu-b-4981",
    "phenotype": "Sepsis (28 day death in critical care)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis (28-day death in CC)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4981.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5815",
    "sources": "IEU database",
    "phenocode": "ieu-b-4982",
    "phenotype": "Sepsis (critical care)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis (critical care)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-4982.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5816",
    "sources": "IEU database",
    "phenocode": "ieu-b-5063",
    "phenotype": "URTI",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper respiratory tract infection",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-5063.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5817",
    "sources": "IEU database",
    "phenocode": "ieu-b-5065",
    "phenotype": "UTI",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary tract infection",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-5065.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5820",
    "sources": "IEU database",
    "phenocode": "ieu-b-5086",
    "phenotype": "Sepsis (28 day death)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis (28-day death)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-5086.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5821",
    "sources": "IEU database",
    "phenocode": "ieu-b-5088",
    "phenotype": "Sepsis (under 75)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis (under 75)",
    "pmid": "",
    "download": "https://gwas.mrcieu.ac.uk/files/ieu-b-5088.vcf.gz"
  },
  {
    "accessionId": "DGWAS-5906",
    "sources": "GWAS catalog",
    "phenocode": "GCST006980",
    "phenotype": "Fractures",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fracture",
    "pmid": "30598549",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST006001-GCST007000/GCST006980"
  },
  {
    "accessionId": "DGWAS-5914",
    "sources": "GWAS catalog",
    "phenocode": "GCST008105",
    "phenotype": "Diverticular disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diverticular disease",
    "pmid": "30661054",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST008001-GCST009000/GCST008105"
  },
  {
    "accessionId": "DGWAS-5919",
    "sources": "GWAS catalog",
    "phenocode": "GCST009156",
    "phenotype": "Uterine fibroids and heavy menstrual bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine fibroids/menorrhagia",
    "pmid": "31649266",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009156"
  },
  {
    "accessionId": "DGWAS-5920",
    "sources": "GWAS catalog",
    "phenocode": "GCST009157",
    "phenotype": "Heavy menstrual bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menorrhagia",
    "pmid": "31649266",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009157"
  },
  {
    "accessionId": "DGWAS-5923",
    "sources": "GWAS catalog",
    "phenocode": "GCST009541",
    "phenotype": "Heart failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure",
    "pmid": "31919418",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009541"
  },
  {
    "accessionId": "DGWAS-5924",
    "sources": "GWAS catalog",
    "phenocode": "GCST009602",
    "phenotype": "Metabolic syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metabolic syndrome",
    "pmid": "31589552",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009602"
  },
  {
    "accessionId": "DGWAS-5930",
    "sources": "GWAS catalog",
    "phenocode": "GCST009959",
    "phenotype": "Retinal detachment or retinal break",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment/break",
    "pmid": "31816047",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST009001-GCST010000/GCST009959"
  },
  {
    "accessionId": "DGWAS-5945",
    "sources": "GWAS catalog",
    "phenocode": "GCST011073",
    "phenotype": "COVID-19 (RELEASE 5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 (Release 5)",
    "pmid": "32404885",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011073"
  },
  {
    "accessionId": "DGWAS-5947",
    "sources": "GWAS catalog",
    "phenocode": "GCST011075",
    "phenotype": "COVID-19 (very severe respiratory confirmed vs population) RELEASE 5",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 severe (Release 5)",
    "pmid": "32404885",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011075"
  },
  {
    "accessionId": "DGWAS-5951",
    "sources": "GWAS catalog",
    "phenocode": "GCST011081",
    "phenotype": "COVID-19 (hospitalized vs population) RELEASE 5",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COVID-19 hospitalized (Release 5)",
    "pmid": "32404885",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST011001-GCST012000/GCST011081"
  },
  {
    "accessionId": "DGWAS-5963",
    "sources": "GWAS catalog",
    "phenocode": "GCST90000512",
    "phenotype": "Frozen shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adhesive capsulitis",
    "pmid": "34111113",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90000001-GCST90001000/GCST90000512"
  },
  {
    "accessionId": "DGWAS-5964",
    "sources": "GWAS catalog",
    "phenocode": "GCST90000514",
    "phenotype": "Gastroesophageal reflux disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GERD",
    "pmid": "34187846",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90000001-GCST90001000/GCST90000514"
  },
  {
    "accessionId": "DGWAS-5985",
    "sources": "GWAS catalog",
    "phenocode": "GCST90012857",
    "phenotype": "Falling risk",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Falls risk",
    "pmid": "32999390",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012857"
  },
  {
    "accessionId": "DGWAS-5986",
    "sources": "GWAS catalog",
    "phenocode": "GCST90012877",
    "phenotype": "Alzheimer's disease or family history of Alzheimer's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Alzheimer disease/family history",
    "pmid": "33589840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90012001-GCST90013000/GCST90012877"
  },
  {
    "accessionId": "DGWAS-5988",
    "sources": "GWAS catalog",
    "phenocode": "GCST90013410",
    "phenotype": "Basal cell carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "BCC",
    "pmid": "33549134",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90013001-GCST90014000/GCST90013410"
  },
  {
    "accessionId": "DGWAS-599",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_O15_DELIV_MULTIP",
    "phenotype": "Multiple delivery",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Multiple delivery",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_O15_DELIV_MULTIP.gz"
  },
  {
    "accessionId": "DGWAS-5990",
    "sources": "GWAS catalog",
    "phenocode": "GCST90014023",
    "phenotype": "Type 1 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "34012112",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90014001-GCST90015000/GCST90014023"
  },
  {
    "accessionId": "DGWAS-5991",
    "sources": "GWAS catalog",
    "phenocode": "GCST90014033",
    "phenotype": "Haemorrhoidal disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemorrhoids",
    "pmid": "33888516",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90014001-GCST90015000/GCST90014033"
  },
  {
    "accessionId": "DGWAS-6004",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029015",
    "phenotype": "Autoimmune traits",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autoimmune trait",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029015"
  },
  {
    "accessionId": "DGWAS-6006",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029017",
    "phenotype": "Eczema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eczema",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029017"
  },
  {
    "accessionId": "DGWAS-6008",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029019",
    "phenotype": "Cardiovascular disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiovascular disease",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029019"
  },
  {
    "accessionId": "DGWAS-6009",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029020",
    "phenotype": "Dermatologic disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dermatologic disease",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029020"
  },
  {
    "accessionId": "DGWAS-6010",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029021",
    "phenotype": "High cholesterol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypercholesterolemia",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029021"
  },
  {
    "accessionId": "DGWAS-6011",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029022",
    "phenotype": "Hypothyroidism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029022"
  },
  {
    "accessionId": "DGWAS-6012",
    "sources": "GWAS catalog",
    "phenocode": "GCST90029023",
    "phenotype": "Respiratory or ear-nose-throat disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory/ENT disease",
    "pmid": "29892013",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90029001-GCST90030000/GCST90029023"
  },
  {
    "accessionId": "DGWAS-6014",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041712",
    "phenotype": "Bacterial infection, not otherwise specified (PheCode 41)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial infection NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041712"
  },
  {
    "accessionId": "DGWAS-6015",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041715",
    "phenotype": "Chronic hepatitis (PheCode 70.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic hepatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041715"
  },
  {
    "accessionId": "DGWAS-6016",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041716",
    "phenotype": "Hepatitis, not otherwise specified (PheCode 70.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatitis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041716"
  },
  {
    "accessionId": "DGWAS-6017",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041717",
    "phenotype": "HIV infection, symptomatic (PheCode 71.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Symptomatic HIV",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041717"
  },
  {
    "accessionId": "DGWAS-6018",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041718",
    "phenotype": "Viral warts & HPV (PheCode 78)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral warts/HPV",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041718"
  },
  {
    "accessionId": "DGWAS-6019",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041719",
    "phenotype": "Viral infection (PheCode 79)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041719"
  },
  {
    "accessionId": "DGWAS-6020",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041720",
    "phenotype": "Postoperative infection (PheCode 80)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postoperative infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041720"
  },
  {
    "accessionId": "DGWAS-6021",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041721",
    "phenotype": "Infection/inflammation of internal prosthetic device; implant; and graft (PheCode 81)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prosthetic device infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041721"
  },
  {
    "accessionId": "DGWAS-6022",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041722",
    "phenotype": "Burns (PheCode 1000)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Burns",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041722"
  },
  {
    "accessionId": "DGWAS-6023",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041733",
    "phenotype": "Crushing injury (PheCode 1006)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crush injury",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041733"
  },
  {
    "accessionId": "DGWAS-6024",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041736",
    "phenotype": "Crushing or internal injury to organs (PheCode 1008)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crush/internal organ injury",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041736"
  },
  {
    "accessionId": "DGWAS-6025",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041750",
    "phenotype": "Injury, not otherwise specified (PheCode 1009)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Injury NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041750"
  },
  {
    "accessionId": "DGWAS-6026",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041751",
    "phenotype": "Other tests (PheCode 1010)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Other tests",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041751"
  },
  {
    "accessionId": "DGWAS-6027",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041771",
    "phenotype": "Candidiasis (PheCode 112)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Candidiasis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041771"
  },
  {
    "accessionId": "DGWAS-6028",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041776",
    "phenotype": "Arthropod-borne diseases (PheCode 133)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthropod-borne disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041776"
  },
  {
    "accessionId": "DGWAS-6029",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041791",
    "phenotype": "Cancer of tongue (PheCode 145.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tongue cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041791"
  },
  {
    "accessionId": "DGWAS-6030",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041792",
    "phenotype": "Cancer of major salivary glands (PheCode 145.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major salivary gland cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041792"
  },
  {
    "accessionId": "DGWAS-6031",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041793",
    "phenotype": "Cancer of mouth (PheCode 145)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mouth cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041793"
  },
  {
    "accessionId": "DGWAS-6032",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041799",
    "phenotype": "Cancer of oropharynx (PheCode 149.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oropharyngeal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041799"
  },
  {
    "accessionId": "DGWAS-6033",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041800",
    "phenotype": "Cancer of larynx (PheCode 149.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Laryngeal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041800"
  },
  {
    "accessionId": "DGWAS-6034",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041805",
    "phenotype": "Cancer of esophagus (PheCode 150)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041805"
  },
  {
    "accessionId": "DGWAS-6035",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041806",
    "phenotype": "Cancer of stomach (PheCode 151)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041806"
  },
  {
    "accessionId": "DGWAS-6036",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041807",
    "phenotype": "Colon cancer (PheCode 153.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041807"
  },
  {
    "accessionId": "DGWAS-6037",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041808",
    "phenotype": "Malignant neoplasm of rectum, rectosigmoid junction, and anus (PheCode 153.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal/rectosigmoid/anal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041808"
  },
  {
    "accessionId": "DGWAS-6038",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041812",
    "phenotype": "Malignant neoplasm of liver, primary (PheCode 155.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary liver cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041812"
  },
  {
    "accessionId": "DGWAS-6039",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041813",
    "phenotype": "Cancer of liver and intrahepatic bile duct (PheCode 155)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver/intrahepatic bile duct cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041813"
  },
  {
    "accessionId": "DGWAS-6040",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041814",
    "phenotype": "Pancreatic cancer (PheCode 157)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041814"
  },
  {
    "accessionId": "DGWAS-6041",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041815",
    "phenotype": "Neoplasm of unspecified nature of digestive system (PheCode 158)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Digestive neoplasm NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041815"
  },
  {
    "accessionId": "DGWAS-6042",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041816",
    "phenotype": "Malignant neoplasm of small intestine, including duodenum (PheCode 159.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041816"
  },
  {
    "accessionId": "DGWAS-6043",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041817",
    "phenotype": "Malignant neoplasm of gallbladder and extrahepatic bile ducts (PheCode 159.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder/extrahepatic bile duct cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041817"
  },
  {
    "accessionId": "DGWAS-6044",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041818",
    "phenotype": "Malignant neoplasm of retroperitoneum and peritoneum (PheCode 159.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retroperitoneal/peritoneal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041818"
  },
  {
    "accessionId": "DGWAS-6045",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041819",
    "phenotype": "Malignant neoplasm of other and ill-defined sites within the digestive organs and peritoneum (PheCode 159)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Digestive cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041819"
  },
  {
    "accessionId": "DGWAS-6046",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041821",
    "phenotype": "Cancer of bronchus; lung (PheCode 165.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchus/lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041821"
  },
  {
    "accessionId": "DGWAS-6047",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041822",
    "phenotype": "Cancer within the respiratory system (PheCode 165)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041822"
  },
  {
    "accessionId": "DGWAS-6048",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041824",
    "phenotype": "Bone cancer (PheCode 170.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041824"
  },
  {
    "accessionId": "DGWAS-6049",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041825",
    "phenotype": "Cancer of connective tissue (PheCode 170.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Connective tissue cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041825"
  },
  {
    "accessionId": "DGWAS-6050",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041829",
    "phenotype": "Melanomas of skin (PheCode 172.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin melanoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041829"
  },
  {
    "accessionId": "DGWAS-6051",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041830",
    "phenotype": "Other non-epithelial cancer of skin (PheCode 172.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-epithelial skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041830"
  },
  {
    "accessionId": "DGWAS-6052",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041831",
    "phenotype": "Carcinoma in situ of skin (PheCode 172.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041831"
  },
  {
    "accessionId": "DGWAS-6053",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041832",
    "phenotype": "Neoplasm of uncertain behavior of skin (PheCode 173)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin neoplasm uncertain behavior",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041832"
  },
  {
    "accessionId": "DGWAS-6054",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041833",
    "phenotype": "Malignant neoplasm of female breast (PheCode 174.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041833"
  },
  {
    "accessionId": "DGWAS-6055",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041834",
    "phenotype": "Breast cancer [female] (PheCode 174.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041834"
  },
  {
    "accessionId": "DGWAS-6056",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041835",
    "phenotype": "Neoplasm of uncertain behavior of breast (PheCode 174.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast neoplasm uncertain behavior",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041835"
  },
  {
    "accessionId": "DGWAS-6057",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041846",
    "phenotype": "Cervical cancer (PheCode 180.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041846"
  },
  {
    "accessionId": "DGWAS-6058",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041847",
    "phenotype": "Cervical intraepithelial neoplasia [CIN] [Cervical dysplasia] (PheCode 180.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CIN/cervical dysplasia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041847"
  },
  {
    "accessionId": "DGWAS-6059",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041848",
    "phenotype": "Malignant neoplasm of uterus (PheCode 182)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041848"
  },
  {
    "accessionId": "DGWAS-6060",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041850",
    "phenotype": "Malignant neoplasm of ovary (PheCode 184.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041850"
  },
  {
    "accessionId": "DGWAS-6061",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041851",
    "phenotype": "Cancer of other female genital organs (excluding uterus and ovary) (PheCode 184.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other female genital cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041851"
  },
  {
    "accessionId": "DGWAS-6062",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041852",
    "phenotype": "Cancer of other female genital organs (PheCode 184)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041852"
  },
  {
    "accessionId": "DGWAS-6063",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041853",
    "phenotype": "Cancer of prostate (PheCode 185)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041853"
  },
  {
    "accessionId": "DGWAS-6064",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041854",
    "phenotype": "Malignant neoplasm of testis (PheCode 187.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041854"
  },
  {
    "accessionId": "DGWAS-6065",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041855",
    "phenotype": "Cancer of other male genital organs (PheCode 187)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other male genital cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041855"
  },
  {
    "accessionId": "DGWAS-6066",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041856",
    "phenotype": "Malignant neoplasm of kidney, except pelvis (PheCode 189.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (non-pelvis)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041856"
  },
  {
    "accessionId": "DGWAS-6067",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041857",
    "phenotype": "Malignant neoplasm of bladder (PheCode 189.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041857"
  },
  {
    "accessionId": "DGWAS-6068",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041858",
    "phenotype": "Cancer of bladder (PheCode 189.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041858"
  },
  {
    "accessionId": "DGWAS-6069",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041859",
    "phenotype": "Malignant neoplasm of other urinary organs (PheCode 189.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other urinary cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041859"
  },
  {
    "accessionId": "DGWAS-6070",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041860",
    "phenotype": "Cancer of eye (PheCode 190)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041860"
  },
  {
    "accessionId": "DGWAS-6071",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041861",
    "phenotype": "Cancer of brain (PheCode 191.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041861"
  },
  {
    "accessionId": "DGWAS-6072",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041862",
    "phenotype": "Malignant and unknown neoplasms of brain and nervous system (PheCode 191)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain/nervous system cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041862"
  },
  {
    "accessionId": "DGWAS-6073",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041865",
    "phenotype": "Thyroid cancer (PheCode 193)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041865"
  },
  {
    "accessionId": "DGWAS-6074",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041867",
    "phenotype": "Malignant neoplasm, other (PheCode 195.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041867"
  },
  {
    "accessionId": "DGWAS-6075",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041869",
    "phenotype": "Cancer, suspected or other (PheCode 195)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suspected/other cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041869"
  },
  {
    "accessionId": "DGWAS-6076",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041872",
    "phenotype": "Secondary malignancy of lymph nodes (PheCode 198.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary lymph node cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041872"
  },
  {
    "accessionId": "DGWAS-6077",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041873",
    "phenotype": "Secondary malignancy of respiratory organs (PheCode 198.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary respiratory cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041873"
  },
  {
    "accessionId": "DGWAS-6078",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041874",
    "phenotype": "Secondary malignant neoplasm of digestive systems (PheCode 198.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary digestive cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041874"
  },
  {
    "accessionId": "DGWAS-6079",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041875",
    "phenotype": "Secondary malignant neoplasm of liver (PheCode 198.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary liver cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041875"
  },
  {
    "accessionId": "DGWAS-6080",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041876",
    "phenotype": "Secondary malignancy of brain/spine (PheCode 198.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary CNS cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041876"
  },
  {
    "accessionId": "DGWAS-6081",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041877",
    "phenotype": "Secondary malignancy of bone (PheCode 198.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary bone cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041877"
  },
  {
    "accessionId": "DGWAS-6082",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041878",
    "phenotype": "Secondary malignant neoplasm of skin (PheCode 198.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041878"
  },
  {
    "accessionId": "DGWAS-6083",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041880",
    "phenotype": "Secondary malignant neoplasm (PheCode 198)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary malignancy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041880"
  },
  {
    "accessionId": "DGWAS-6084",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041882",
    "phenotype": "Neoplasm of uncertain behavior (PheCode 199)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm uncertain behavior",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041882"
  },
  {
    "accessionId": "DGWAS-6085",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041883",
    "phenotype": "Polycythemia vera (PheCode 200.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycythemia vera",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041883"
  },
  {
    "accessionId": "DGWAS-6086",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041885",
    "phenotype": "Cancer code, self-reported: lung cancer (UKB data field 20001_1001)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041885"
  },
  {
    "accessionId": "DGWAS-6087",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041886",
    "phenotype": "Cancer code, self-reported: breast cancer (UKB data field 20001_1002)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041886"
  },
  {
    "accessionId": "DGWAS-6088",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041887",
    "phenotype": "Cancer code, self-reported: skin cancer (UKB data field 20001_1003)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041887"
  },
  {
    "accessionId": "DGWAS-6089",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041888",
    "phenotype": "Cancer code, self-reported: cancer of lip/mouth/pharynx/oral cavity (UKB data field 20001_1004)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral/pharyngeal cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041888"
  },
  {
    "accessionId": "DGWAS-6090",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041889",
    "phenotype": "Cancer code, self-reported: larynx/throat cancer (UKB data field 20001_1006)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Laryngeal/throat cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041889"
  },
  {
    "accessionId": "DGWAS-6091",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041890",
    "phenotype": "Cancer code, self-reported: tongue cancer (UKB data field 20001_1011)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tongue cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041890"
  },
  {
    "accessionId": "DGWAS-6092",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041891",
    "phenotype": "Cancer code, self-reported: oesophageal cancer (UKB data field 20001_1017)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041891"
  },
  {
    "accessionId": "DGWAS-6093",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041892",
    "phenotype": "Cancer code, self-reported: stomach cancer (UKB data field 20001_1018)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041892"
  },
  {
    "accessionId": "DGWAS-6094",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041893",
    "phenotype": "Cancer code, self-reported: small intestine/small bowel cancer (UKB data field 20001_1019)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041893"
  },
  {
    "accessionId": "DGWAS-6095",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041894",
    "phenotype": "Cancer code, self-reported: large bowel cancer/colorectal cancer (UKB data field 20001_1020)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colorectal cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041894"
  },
  {
    "accessionId": "DGWAS-6096",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041895",
    "phenotype": "Cancer code, self-reported: colon cancer/sigmoid cancer (UKB data field 20001_1022)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon/sigmoid cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041895"
  },
  {
    "accessionId": "DGWAS-6097",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041896",
    "phenotype": "Cancer code, self-reported: rectal cancer (UKB data field 20001_1023)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041896"
  },
  {
    "accessionId": "DGWAS-6098",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041897",
    "phenotype": "Cancer code, self-reported: liver/hepatocellular cancer (UKB data field 20001_1024)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver/HCC (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041897"
  },
  {
    "accessionId": "DGWAS-6099",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041898",
    "phenotype": "Cancer code, self-reported: eye and/or adnexal cancer (UKB data field 20001_1030)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/adnexal cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041898"
  },
  {
    "accessionId": "DGWAS-6100",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041899",
    "phenotype": "Cancer code, self-reported: brain cancer / primary malignant brain tumour (UKB data field 20001_1032)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041899"
  },
  {
    "accessionId": "DGWAS-6101",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041900",
    "phenotype": "Cancer code, self-reported: kidney/renal cell cancer (UKB data field 20001_1034)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041900"
  },
  {
    "accessionId": "DGWAS-6102",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041901",
    "phenotype": "Cancer code, self-reported: bladder cancer (UKB data field 20001_1035)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041901"
  },
  {
    "accessionId": "DGWAS-6103",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041902",
    "phenotype": "Cancer code, self-reported: ovarian cancer (UKB data field 20001_1039)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041902"
  },
  {
    "accessionId": "DGWAS-6104",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041903",
    "phenotype": "Cancer code, self-reported: uterine/endometrial cancer (UKB data field 20001_1040)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine/endometrial cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041903"
  },
  {
    "accessionId": "DGWAS-6105",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041904",
    "phenotype": "Cancer code, self-reported: cervical cancer (UKB data field 20001_1041)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041904"
  },
  {
    "accessionId": "DGWAS-6106",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041905",
    "phenotype": "Cancer code, self-reported: prostate cancer (UKB data field 20001_1044)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041905"
  },
  {
    "accessionId": "DGWAS-6107",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041906",
    "phenotype": "Cancer code, self-reported: testicular cancer (UKB data field 20001_1045)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041906"
  },
  {
    "accessionId": "DGWAS-6108",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041907",
    "phenotype": "Cancer code, self-reported: lymphoma (UKB data field 20001_1047)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041907"
  },
  {
    "accessionId": "DGWAS-6109",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041908",
    "phenotype": "Cancer code, self-reported: leukaemia (UKB data field 20001_1048)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leukemia (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041908"
  },
  {
    "accessionId": "DGWAS-6110",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041909",
    "phenotype": "Cancer code, self-reported: multiple myeloma (UKB data field 20001_1050)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041909"
  },
  {
    "accessionId": "DGWAS-6111",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041910",
    "phenotype": "Cancer code, self-reported: hodgkins lymphoma / hodgkins disease (UKB data field 20001_1052)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hodgkin lymphoma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041910"
  },
  {
    "accessionId": "DGWAS-6112",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041911",
    "phenotype": "Cancer code, self-reported: non-hodgkins lymphoma (UKB data field 20001_1053)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-Hodgkin lymphoma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041911"
  },
  {
    "accessionId": "DGWAS-6113",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041912",
    "phenotype": "Cancer code, self-reported: chronic lymphocytic (UKB data field 20001_1055)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CLL (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041912"
  },
  {
    "accessionId": "DGWAS-6114",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041913",
    "phenotype": "Cancer code, self-reported: chronic myeloid (UKB data field 20001_1056)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CML (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041913"
  },
  {
    "accessionId": "DGWAS-6115",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041914",
    "phenotype": "Cancer code, self-reported: malignant melanoma (UKB data field 20001_1059)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041914"
  },
  {
    "accessionId": "DGWAS-6116",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041915",
    "phenotype": "Cancer code, self-reported: non-melanoma skin cancer (UKB data field 20001_1060)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-melanoma skin cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041915"
  },
  {
    "accessionId": "DGWAS-6117",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041916",
    "phenotype": "Cancer code, self-reported: basal cell carcinoma (UKB data field 20001_1061)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "BCC (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041916"
  },
  {
    "accessionId": "DGWAS-6118",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041917",
    "phenotype": "Cancer code, self-reported: squamous cell carcinoma (UKB data field 20001_1062)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SCC (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041917"
  },
  {
    "accessionId": "DGWAS-6119",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041918",
    "phenotype": "Cancer code, self-reported: primary bone cancer (UKB data field 20001_1063)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary bone cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041918"
  },
  {
    "accessionId": "DGWAS-6120",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041919",
    "phenotype": "Cancer code, self-reported: thyroid cancer (UKB data field 20001_1065)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041919"
  },
  {
    "accessionId": "DGWAS-6121",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041920",
    "phenotype": "Cancer code, self-reported: sarcoma/fibrosarcoma (UKB data field 20001_1068)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoma/fibrosarcoma (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041920"
  },
  {
    "accessionId": "DGWAS-6122",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041921",
    "phenotype": "Cancer code, self-reported: malignant lymph node, unspecified (UKB data field 20001_1070)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malignant lymph node (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041921"
  },
  {
    "accessionId": "DGWAS-6123",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041922",
    "phenotype": "Cancer code, self-reported: cin/pre-cancer cells cervix (UKB data field 20001_1072)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical CIN/pre-cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041922"
  },
  {
    "accessionId": "DGWAS-6124",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041923",
    "phenotype": "Cancer code, self-reported: rodent ulcer (UKB data field 20001_1073)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rodent ulcer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041923"
  },
  {
    "accessionId": "DGWAS-6125",
    "sources": "GWAS catalog",
    "phenocode": "GCST90041924",
    "phenotype": "Cancer code, self-reported: unclassifiable (UKB data field 20001_99999)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unclassifiable cancer (self-reported)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90041001-GCST90042000/GCST90041924"
  },
  {
    "accessionId": "DGWAS-6126",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042662",
    "phenotype": "Myeloproliferative disease (PheCode 200)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloproliferative disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042662"
  },
  {
    "accessionId": "DGWAS-6127",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042664",
    "phenotype": "Illnesses of father: Heart disease (UKB data field 20107_1)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - heart disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042664"
  },
  {
    "accessionId": "DGWAS-6128",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042665",
    "phenotype": "Illnesses of father: Alzheimer's disease/dementia (UKB data field 20107_10)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - dementia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042665"
  },
  {
    "accessionId": "DGWAS-6129",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042668",
    "phenotype": "Illnesses of father: Parkinson's disease (UKB data field 20107_11)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - Parkinson disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042668"
  },
  {
    "accessionId": "DGWAS-6130",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042669",
    "phenotype": "Illnesses of father: Severe depression (UKB data field 20107_12)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - severe depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042669"
  },
  {
    "accessionId": "DGWAS-6131",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042670",
    "phenotype": "Illnesses of father: Prostate cancer (UKB data field 20107_13)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - prostate cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042670"
  },
  {
    "accessionId": "DGWAS-6132",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042671",
    "phenotype": "Illnesses of father: Stroke (UKB data field 20107_2)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - stroke",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042671"
  },
  {
    "accessionId": "DGWAS-6133",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042672",
    "phenotype": "Illnesses of father: Lung cancer (UKB data field 20107_3)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042672"
  },
  {
    "accessionId": "DGWAS-6134",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042673",
    "phenotype": "Illnesses of father: Bowel cancer (UKB data field 20107_4)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - bowel cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042673"
  },
  {
    "accessionId": "DGWAS-6135",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042674",
    "phenotype": "Illnesses of father: Chronic bronchitis/emphysema (UKB data field 20107_6)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - COPD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042674"
  },
  {
    "accessionId": "DGWAS-6136",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042675",
    "phenotype": "Illnesses of father: High blood pressure (UKB data field 20107_8)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042675"
  },
  {
    "accessionId": "DGWAS-6137",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042676",
    "phenotype": "Illnesses of father: Diabetes (UKB data field 20107_9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042676"
  },
  {
    "accessionId": "DGWAS-6138",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042677",
    "phenotype": "Illnesses of mother: Heart disease (UKB data field 20110_1)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - heart disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042677"
  },
  {
    "accessionId": "DGWAS-6139",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042678",
    "phenotype": "Illnesses of mother: Alzheimer's disease/dementia (UKB data field 20110_10)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - dementia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042678"
  },
  {
    "accessionId": "DGWAS-6140",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042681",
    "phenotype": "Illnesses of mother: Parkinson's disease (UKB data field 20110_11)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - Parkinson disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042681"
  },
  {
    "accessionId": "DGWAS-6141",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042682",
    "phenotype": "Illnesses of mother: Severe depression (UKB data field 20110_12)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - severe depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042682"
  },
  {
    "accessionId": "DGWAS-6142",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042683",
    "phenotype": "Illnesses of mother: Stroke (UKB data field 20110_2)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - stroke",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042683"
  },
  {
    "accessionId": "DGWAS-6143",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042684",
    "phenotype": "Illnesses of mother: Lung cancer (UKB data field 20110_3)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042684"
  },
  {
    "accessionId": "DGWAS-6144",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042685",
    "phenotype": "Illnesses of mother: Bowel cancer (UKB data field 20110_4)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - bowel cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042685"
  },
  {
    "accessionId": "DGWAS-6145",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042686",
    "phenotype": "Illnesses of mother: Breast cancer (UKB data field 20110_5)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042686"
  },
  {
    "accessionId": "DGWAS-6146",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042687",
    "phenotype": "Illnesses of mother: Chronic bronchitis/emphysema (UKB data field 20110_6)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - COPD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042687"
  },
  {
    "accessionId": "DGWAS-6147",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042688",
    "phenotype": "Illnesses of mother: High blood pressure (UKB data field 20110_8)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042688"
  },
  {
    "accessionId": "DGWAS-6148",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042689",
    "phenotype": "Illnesses of mother: Diabetes (UKB data field 20110_9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042689"
  },
  {
    "accessionId": "DGWAS-6149",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042690",
    "phenotype": "Illnesses of siblings: Heart disease (UKB data field 20111_1)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - heart disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042690"
  },
  {
    "accessionId": "DGWAS-6150",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042691",
    "phenotype": "Illnesses of siblings: Alzheimer's disease/dementia (UKB data field 20111_10)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - dementia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042691"
  },
  {
    "accessionId": "DGWAS-6151",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042694",
    "phenotype": "Illnesses of siblings: Parkinson's disease (UKB data field 20111_11)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - Parkinson disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042694"
  },
  {
    "accessionId": "DGWAS-6152",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042695",
    "phenotype": "Illnesses of siblings: Severe depression (UKB data field 20111_12)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - severe depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042695"
  },
  {
    "accessionId": "DGWAS-6153",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042696",
    "phenotype": "Illnesses of siblings: Prostate cancer (UKB data field 20111_13)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - prostate cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042696"
  },
  {
    "accessionId": "DGWAS-6154",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042697",
    "phenotype": "Illnesses of siblings: Stroke (UKB data field 20111_2)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - stroke",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042697"
  },
  {
    "accessionId": "DGWAS-6155",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042698",
    "phenotype": "Illnesses of siblings: Lung cancer (UKB data field 20111_3)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042698"
  },
  {
    "accessionId": "DGWAS-6156",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042699",
    "phenotype": "Illnesses of siblings: Bowel cancer (UKB data field 20111_4)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - bowel cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042699"
  },
  {
    "accessionId": "DGWAS-6157",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042700",
    "phenotype": "Illnesses of siblings: Breast cancer (UKB data field 20111_5)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042700"
  },
  {
    "accessionId": "DGWAS-6158",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042701",
    "phenotype": "Illnesses of siblings: Chronic bronchitis/emphysema (UKB data field 20111_6)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - COPD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042701"
  },
  {
    "accessionId": "DGWAS-6159",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042702",
    "phenotype": "Illnesses of siblings: High blood pressure (UKB data field 20111_8)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042702"
  },
  {
    "accessionId": "DGWAS-6160",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042703",
    "phenotype": "Illnesses of siblings: Diabetes (UKB data field 20111_9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042703"
  },
  {
    "accessionId": "DGWAS-6161",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042719",
    "phenotype": "Bipolar and major depression status: Bipolar I Disorder (UKB data field 20126_1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar I disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042719"
  },
  {
    "accessionId": "DGWAS-6162",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042720",
    "phenotype": "Bipolar and major depression status: Bipolar II Disorder (UKB data field 20126_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar II disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042720"
  },
  {
    "accessionId": "DGWAS-6163",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042721",
    "phenotype": "Bipolar and major depression status: Probable Recurrent major depression (severe) (UKB data field 20126_3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent major depression (severe)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042721"
  },
  {
    "accessionId": "DGWAS-6164",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042722",
    "phenotype": "Bipolar and major depression status: Probable Recurrent major depression (moderate) (UKB data field 20126_4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent major depression (moderate)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042722"
  },
  {
    "accessionId": "DGWAS-6165",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042723",
    "phenotype": "Bipolar and major depression status: Single Probable major depression episode (UKB data field 20126_5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Single major depression episode",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042723"
  },
  {
    "accessionId": "DGWAS-6166",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042738",
    "phenotype": "Hodgkin's disease (PheCode 201)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hodgkin lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042738"
  },
  {
    "accessionId": "DGWAS-6167",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042739",
    "phenotype": "Nodular lymphoma (PheCode 202.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nodular lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042739"
  },
  {
    "accessionId": "DGWAS-6168",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042740",
    "phenotype": "Large cell lymphoma (PheCode 202.24)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Large cell lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042740"
  },
  {
    "accessionId": "DGWAS-6169",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042741",
    "phenotype": "Non-Hodgkins lymphoma (PheCode 202.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-Hodgkin lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042741"
  },
  {
    "accessionId": "DGWAS-6170",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042757",
    "phenotype": "Lymphoid leukemia, chronic (PheCode 204.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic lymphoid leukemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042757"
  },
  {
    "accessionId": "DGWAS-6171",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042758",
    "phenotype": "Myeloid leukemia, acute (PheCode 204.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute myeloid leukemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042758"
  },
  {
    "accessionId": "DGWAS-6172",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042759",
    "phenotype": "Myeloid leukemia, chronic (PheCode 204.22)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic myeloid leukemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042759"
  },
  {
    "accessionId": "DGWAS-6173",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042760",
    "phenotype": "Multiple myeloma (PheCode 204.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042760"
  },
  {
    "accessionId": "DGWAS-6179",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042797",
    "phenotype": "Ever self harmed (UKB data field 20480)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm history",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042797"
  },
  {
    "accessionId": "DGWAS-6180",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042803",
    "phenotype": "Leukemia (PheCode 204)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leukemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042803"
  },
  {
    "accessionId": "DGWAS-6185",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042827",
    "phenotype": "Substances taken for depression: Unprescribed medication (more than once) (UKB data field 20546_1)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Unprescribed medication for depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042827"
  },
  {
    "accessionId": "DGWAS-6186",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042828",
    "phenotype": "Substances taken for depression: Medication prescribed to you (for at least two weeks) (UKB data field 20546_3)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Prescribed medication for depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042828"
  },
  {
    "accessionId": "DGWAS-6187",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042829",
    "phenotype": "Substances taken for depression: Drugs or alcohol (more than once) (UKB data field 20546_4)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Drugs/alcohol for depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042829"
  },
  {
    "accessionId": "DGWAS-6188",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042830",
    "phenotype": "Activities undertaken to treat depression: Talking therapies, such as psychotherapy, counselling, group therapy or CBT (UKB data field 20547_1)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Talk therapy for depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042830"
  },
  {
    "accessionId": "DGWAS-6189",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042831",
    "phenotype": "Activities undertaken to treat depression: Other therapeutic activities such as mindfulness, yoga or art classes (UKB data field 20547_3)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Complementary therapy for depression",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042831"
  },
  {
    "accessionId": "DGWAS-6190",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042841",
    "phenotype": "Substances taken for anxiety: Medication prescribed to you (for at least two weeks) (UKB data field 20549_3)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Prescribed medication for anxiety",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042841"
  },
  {
    "accessionId": "DGWAS-6191",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042845",
    "phenotype": "Substance of prescription or over-the-counter medication addiction: A sedative, benzodiazepine or sleeping tablet (UKB data field 20551_1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sedative/benzodiazepine addiction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042845"
  },
  {
    "accessionId": "DGWAS-6192",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042846",
    "phenotype": "Substance of prescription or over-the-counter medication addiction: A painkiller (UKB data field 20551_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Painkiller addiction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042846"
  },
  {
    "accessionId": "DGWAS-6193",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042851",
    "phenotype": "Methods of self-harm used: Stopping prescribed medication (UKB data field 20553_3)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - stopping medication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042851"
  },
  {
    "accessionId": "DGWAS-6194",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042852",
    "phenotype": "Methods of self-harm used: Ingesting a medication in excess of the normal dose (UKB data field 20553_4)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - overdose",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042852"
  },
  {
    "accessionId": "DGWAS-6195",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042853",
    "phenotype": "Methods of self-harm used: Self-injury such as self-cutting, scratching or hitting, etc. (UKB data field 20553_5)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - self-injury",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042853"
  },
  {
    "accessionId": "DGWAS-6196",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042860",
    "phenotype": "Benign neoplasm of colon (PheCode 208)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colon neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042860"
  },
  {
    "accessionId": "DGWAS-6197",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042862",
    "phenotype": "Seen psychiatrist for nerves anxiety tension or depression (UKB data field 2100)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychiatrist visit for mental health",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042862"
  },
  {
    "accessionId": "DGWAS-6198",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042863",
    "phenotype": "Benign neoplasm of lip, oral cavity, and pharynx (PheCode 210)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign oral/pharyngeal neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042863"
  },
  {
    "accessionId": "DGWAS-6199",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042864",
    "phenotype": "Benign neoplasm of other parts of digestive system (PheCode 211)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign digestive neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042864"
  },
  {
    "accessionId": "DGWAS-6200",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042865",
    "phenotype": "Benign neoplasm of respiratory and intrathoracic organs (PheCode 212)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign respiratory/intrathoracic neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042865"
  },
  {
    "accessionId": "DGWAS-6201",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042866",
    "phenotype": "Benign neoplasm of bone and articular cartilage (PheCode 213)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign bone/cartilage neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042866"
  },
  {
    "accessionId": "DGWAS-6202",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042867",
    "phenotype": "Lipoma of skin and subcutaneous tissue (PheCode 214.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042867"
  },
  {
    "accessionId": "DGWAS-6203",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042868",
    "phenotype": "Lipoma (PheCode 214)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042868"
  },
  {
    "accessionId": "DGWAS-6204",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042869",
    "phenotype": "Other benign neoplasm of connective and other soft tissue (PheCode 215)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign soft tissue neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042869"
  },
  {
    "accessionId": "DGWAS-6205",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042870",
    "phenotype": "Benign neoplasm of skin (PheCode 216)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign skin neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042870"
  },
  {
    "accessionId": "DGWAS-6206",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042871",
    "phenotype": "Nevus, non-neoplastic (PheCode 217.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nevus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042871"
  },
  {
    "accessionId": "DGWAS-6207",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042872",
    "phenotype": "Uterine leiomyoma (PheCode 218.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine leiomyoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042872"
  },
  {
    "accessionId": "DGWAS-6208",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042873",
    "phenotype": "Other benign neoplasm of uterus (PheCode 218.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign uterine neoplasm NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042873"
  },
  {
    "accessionId": "DGWAS-6209",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042876",
    "phenotype": "Benign neoplasm of ovary (PheCode 220)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign ovarian neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042876"
  },
  {
    "accessionId": "DGWAS-6210",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042877",
    "phenotype": "Benign neoplasm of other female genital organs (PheCode 221)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign female genital neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042877"
  },
  {
    "accessionId": "DGWAS-6211",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042879",
    "phenotype": "Benign neoplasm of male genital organs (PheCode 222)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign male genital neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042879"
  },
  {
    "accessionId": "DGWAS-6212",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042880",
    "phenotype": "Benign neoplasm of kidney and other urinary organs (PheCode 223)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign urinary neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042880"
  },
  {
    "accessionId": "DGWAS-6213",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042883",
    "phenotype": "Hearing difficulty/problems: I am completely deaf (UKB data field 2247_99)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing difficulty - completely deaf",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042883"
  },
  {
    "accessionId": "DGWAS-6214",
    "sources": "GWAS catalog",
    "phenocode": "GCST90042884",
    "phenotype": "Benign neoplasm of brain, cranial nerves, meninges (PheCode 225.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign brain/cranial nerve/meninges neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90042001-GCST90043000/GCST90042884"
  },
  {
    "accessionId": "DGWAS-6215",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043608",
    "phenotype": "Benign neoplasm of thyroid glands (PheCode 226)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign thyroid neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043608"
  },
  {
    "accessionId": "DGWAS-6216",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043609",
    "phenotype": "Benign neoplasm of adrenal gland (PheCode 227.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign adrenal neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043609"
  },
  {
    "accessionId": "DGWAS-6217",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043610",
    "phenotype": "Benign neoplasm of parathyroid gland (PheCode 227.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign parathyroid neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043610"
  },
  {
    "accessionId": "DGWAS-6218",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043611",
    "phenotype": "Benign neoplasm of pituitary gland and craniopharyngeal duct (pouch) (PheCode 227.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pituitary neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043611"
  },
  {
    "accessionId": "DGWAS-6219",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043612",
    "phenotype": "Hemangioma and lymphangioma, any site (PheCode 228)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemangioma/lymphangioma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043612"
  },
  {
    "accessionId": "DGWAS-6220",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043613",
    "phenotype": "Benign neoplasm of unspecified sites (PheCode 229)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign neoplasm NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043613"
  },
  {
    "accessionId": "DGWAS-6221",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043614",
    "phenotype": "Wheeze or whistling in the chest in last year (UKB data field 2316)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Wheeze past year",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043614"
  },
  {
    "accessionId": "DGWAS-6222",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043615",
    "phenotype": "Chest pain or discomfort (UKB data field 2335)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain/discomfort",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043615"
  },
  {
    "accessionId": "DGWAS-6223",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043616",
    "phenotype": "Hair/balding pattern: Pattern 1 (UKB data field 2395_1)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Balding pattern 1",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043616"
  },
  {
    "accessionId": "DGWAS-6224",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043620",
    "phenotype": "Simple and unspecified goiter (PheCode 240)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Goiter NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043620"
  },
  {
    "accessionId": "DGWAS-6225",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043621",
    "phenotype": "Nontoxic uninodular goiter (PheCode 241.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic single thyroid nodule",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043621"
  },
  {
    "accessionId": "DGWAS-6226",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043622",
    "phenotype": "Nontoxic multinodular goiter (PheCode 241.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontoxic multinodular goiter",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043622"
  },
  {
    "accessionId": "DGWAS-6227",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043624",
    "phenotype": "Graves' disease (PheCode 242.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Graves disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043624"
  },
  {
    "accessionId": "DGWAS-6228",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043625",
    "phenotype": "Thyrotoxicosis with or without goiter (PheCode 242)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043625"
  },
  {
    "accessionId": "DGWAS-6229",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043626",
    "phenotype": "Hypothyroidism, not otherwise specified (PheCode 244.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043626"
  },
  {
    "accessionId": "DGWAS-6230",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043627",
    "phenotype": "Diabetes mellitus (UKB data field 2443)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes mellitus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043627"
  },
  {
    "accessionId": "DGWAS-6231",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043628",
    "phenotype": "Cancer (UKB data field 2453)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043628"
  },
  {
    "accessionId": "DGWAS-6232",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043630",
    "phenotype": "Other disorders of thyroid (PheCode 246)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043630"
  },
  {
    "accessionId": "DGWAS-6233",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043633",
    "phenotype": "Type 1 diabetes with ketoacidosis (PheCode 250.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with DKA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043633"
  },
  {
    "accessionId": "DGWAS-6234",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043634",
    "phenotype": "Type 1 diabetes with ophthalmic manifestations (PheCode 250.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with eye complications",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043634"
  },
  {
    "accessionId": "DGWAS-6235",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043635",
    "phenotype": "Type 1 diabetes (PheCode 250.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043635"
  },
  {
    "accessionId": "DGWAS-6236",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043636",
    "phenotype": "Type 2 diabetes with ketoacidosis (PheCode 250.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with DKA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043636"
  },
  {
    "accessionId": "DGWAS-6237",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043637",
    "phenotype": "Type 2 diabetes with ophthalmic manifestations (PheCode 250.23)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with eye complications",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043637"
  },
  {
    "accessionId": "DGWAS-6238",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043638",
    "phenotype": "Type 2 diabetes (PheCode 250.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043638"
  },
  {
    "accessionId": "DGWAS-6239",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043640",
    "phenotype": "Diabetic retinopathy (PheCode 250.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043640"
  },
  {
    "accessionId": "DGWAS-6240",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043641",
    "phenotype": "Hypoglycemia (PheCode 251.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypoglycemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043641"
  },
  {
    "accessionId": "DGWAS-6241",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043642",
    "phenotype": "Hyperparathyroidism (PheCode 252.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperparathyroidism",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043642"
  },
  {
    "accessionId": "DGWAS-6242",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043643",
    "phenotype": "Pituitary hypofunction (PheCode 253.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypopituitarism",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043643"
  },
  {
    "accessionId": "DGWAS-6243",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043644",
    "phenotype": "Glucocorticoid deficiency (PheCode 255.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adrenal insufficiency",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043644"
  },
  {
    "accessionId": "DGWAS-6244",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043645",
    "phenotype": "Mineral deficiency NEC (PheCode 262)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mineral deficiency",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043645"
  },
  {
    "accessionId": "DGWAS-6245",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043659",
    "phenotype": "Proteinuria (PheCode 269)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Proteinuria",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043659"
  },
  {
    "accessionId": "DGWAS-6246",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043660",
    "phenotype": "Paraproteinemia (PheCode 270.32)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paraproteinemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043660"
  },
  {
    "accessionId": "DGWAS-6247",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043662",
    "phenotype": "Gout (PheCode 274.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043662"
  },
  {
    "accessionId": "DGWAS-6248",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043663",
    "phenotype": "Chondrocalcinosis (PheCode 274.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondrocalcinosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043663"
  },
  {
    "accessionId": "DGWAS-6249",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043664",
    "phenotype": "Disorders of iron metabolism (PheCode 275.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron metabolism disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043664"
  },
  {
    "accessionId": "DGWAS-6250",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043665",
    "phenotype": "Disorders of calcium/phosphorus metabolism (PheCode 275.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Calcium/phosphorus metabolism disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043665"
  },
  {
    "accessionId": "DGWAS-6251",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043666",
    "phenotype": "Hyposmolality and/or hyponatremia (PheCode 276.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyponatremia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043666"
  },
  {
    "accessionId": "DGWAS-6252",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043667",
    "phenotype": "Hyperpotassemia (PheCode 276.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperkalemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043667"
  },
  {
    "accessionId": "DGWAS-6253",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043668",
    "phenotype": "Hypopotassemia (PheCode 276.14)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypokalemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043668"
  },
  {
    "accessionId": "DGWAS-6254",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043669",
    "phenotype": "Hypovolemia (PheCode 276.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypovolemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043669"
  },
  {
    "accessionId": "DGWAS-6255",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043670",
    "phenotype": "Ever had stillbirth, spontaneous miscarriage or termination (UKB data field 2774)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pregnancy loss history",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043670"
  },
  {
    "accessionId": "DGWAS-6256",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043672",
    "phenotype": "Obesity (PheCode 278.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043672"
  },
  {
    "accessionId": "DGWAS-6257",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043675",
    "phenotype": "Iron deficiency anemias, unspecified or not due to blood loss (PheCode 280.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency anemia NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043675"
  },
  {
    "accessionId": "DGWAS-6258",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043676",
    "phenotype": "Iron deficiency anemia secondary to blood loss (chronic) (PheCode 280.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency anemia (chronic blood loss)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043676"
  },
  {
    "accessionId": "DGWAS-6259",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043680",
    "phenotype": "Aplastic anemia (PheCode 284)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aplastic anemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043680"
  },
  {
    "accessionId": "DGWAS-6260",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043681",
    "phenotype": "Anemia in neoplastic disease (PheCode 285.22)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia of neoplastic disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043681"
  },
  {
    "accessionId": "DGWAS-6261",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043682",
    "phenotype": "Other anemias (PheCode 285)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anemia NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043682"
  },
  {
    "accessionId": "DGWAS-6262",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043683",
    "phenotype": "Primary thrombocytopenia (PheCode 287.31)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary thrombocytopenia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043683"
  },
  {
    "accessionId": "DGWAS-6263",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043684",
    "phenotype": "Thrombocytopenia (PheCode 287.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thrombocytopenia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043684"
  },
  {
    "accessionId": "DGWAS-6264",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043688",
    "phenotype": "Neutropenia (PheCode 288.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neutropenia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043688"
  },
  {
    "accessionId": "DGWAS-6265",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043689",
    "phenotype": "Diseases of white blood cells (PheCode 288)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "White blood cell disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043689"
  },
  {
    "accessionId": "DGWAS-6266",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043690",
    "phenotype": "Lymphadenitis (PheCode 289.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphadenitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043690"
  },
  {
    "accessionId": "DGWAS-6267",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043691",
    "phenotype": "Polycythemia, secondary (PheCode 289.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary polycythemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043691"
  },
  {
    "accessionId": "DGWAS-6268",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043692",
    "phenotype": "Other diseases of blood and blood-forming organs (PheCode 289)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043692"
  },
  {
    "accessionId": "DGWAS-6269",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043693",
    "phenotype": "Delirium due to conditions classified elsewhere (PheCode 290.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Delirium",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043693"
  },
  {
    "accessionId": "DGWAS-6270",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043695",
    "phenotype": "Delirium dementia and amnestic and other cognitive disorders (PheCode 290)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cognitive disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043695"
  },
  {
    "accessionId": "DGWAS-6271",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043696",
    "phenotype": "Transient mental disorders due to conditions classified elsewhere (PheCode 291.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transient mental disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043696"
  },
  {
    "accessionId": "DGWAS-6272",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043697",
    "phenotype": "Alteration of consciousness (PheCode 291.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Altered consciousness",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043697"
  },
  {
    "accessionId": "DGWAS-6273",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043698",
    "phenotype": "Aphasia/speech disturbance (PheCode 292.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aphasia/speech disturbance",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043698"
  },
  {
    "accessionId": "DGWAS-6274",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043699",
    "phenotype": "Memory loss (PheCode 292.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Memory loss",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043699"
  },
  {
    "accessionId": "DGWAS-6275",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043700",
    "phenotype": "Altered mental status (PheCode 292.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Altered mental status",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043700"
  },
  {
    "accessionId": "DGWAS-6276",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043701",
    "phenotype": "Neurological disorders (PheCode 292)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neurological disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043701"
  },
  {
    "accessionId": "DGWAS-6277",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043702",
    "phenotype": "Swelling, mass, or lump in head and neck [Space-occupying lesion, intracranial, not otherwise specified] (PheCode 293.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracranial space-occupying lesion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043702"
  },
  {
    "accessionId": "DGWAS-6278",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043704",
    "phenotype": "Schizophrenia (PheCode 295.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043704"
  },
  {
    "accessionId": "DGWAS-6279",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043705",
    "phenotype": "Paranoid disorders (PheCode 295.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paranoid disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043705"
  },
  {
    "accessionId": "DGWAS-6280",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043706",
    "phenotype": "Psychosis (PheCode 295.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043706"
  },
  {
    "accessionId": "DGWAS-6281",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043708",
    "phenotype": "Bipolar (PheCode 296.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043708"
  },
  {
    "accessionId": "DGWAS-6282",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043709",
    "phenotype": "Major depressive disorder (PheCode 296.22)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major depressive disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043709"
  },
  {
    "accessionId": "DGWAS-6283",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043711",
    "phenotype": "Agorophobia, social phobia, and panic disorder (PheCode 300.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety/phobic disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043711"
  },
  {
    "accessionId": "DGWAS-6284",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043712",
    "phenotype": "Anxiety disorder (PheCode 300.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043712"
  },
  {
    "accessionId": "DGWAS-6286",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043714",
    "phenotype": "Anxiety disorders (PheCode 300)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043714"
  },
  {
    "accessionId": "DGWAS-6287",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043715",
    "phenotype": "Personality disorders (PheCode 301)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043715"
  },
  {
    "accessionId": "DGWAS-6288",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043716",
    "phenotype": "Sexual and gender identity disorders (PheCode 302)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sexual/gender identity disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043716"
  },
  {
    "accessionId": "DGWAS-6289",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043717",
    "phenotype": "Psychogenic disorder (PheCode 303.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychogenic disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043717"
  },
  {
    "accessionId": "DGWAS-6290",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043718",
    "phenotype": "Adjustment reaction (PheCode 304)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adjustment disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043718"
  },
  {
    "accessionId": "DGWAS-6291",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043719",
    "phenotype": "Tension headache (PheCode 306.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tension headache",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043719"
  },
  {
    "accessionId": "DGWAS-6292",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043725",
    "phenotype": "Substance addiction and disorders (PheCode 316)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Substance use disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043725"
  },
  {
    "accessionId": "DGWAS-6293",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043726",
    "phenotype": "Alcoholic liver damage (PheCode 317.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholic liver disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043726"
  },
  {
    "accessionId": "DGWAS-6294",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043727",
    "phenotype": "Alcoholism (PheCode 317.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcoholism",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043727"
  },
  {
    "accessionId": "DGWAS-6295",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043728",
    "phenotype": "Alcohol-related disorders (PheCode 317)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol-related disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043728"
  },
  {
    "accessionId": "DGWAS-6296",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043729",
    "phenotype": "Meningitis (PheCode 320)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043729"
  },
  {
    "accessionId": "DGWAS-6297",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043730",
    "phenotype": "Encephalitis (PheCode 323)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Encephalitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043730"
  },
  {
    "accessionId": "DGWAS-6298",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043731",
    "phenotype": "Sleep apnea (PheCode 327.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043731"
  },
  {
    "accessionId": "DGWAS-6299",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043732",
    "phenotype": "Sleep disorders (PheCode 327)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043732"
  },
  {
    "accessionId": "DGWAS-630",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_LUNG_TRANSPLANTATION",
    "phenotype": "Lung transplantation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lung transplant",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_LUNG_TRANSPLANTATION.gz"
  },
  {
    "accessionId": "DGWAS-6300",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043733",
    "phenotype": "Hydrocephalus (PheCode 331.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocephalus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043733"
  },
  {
    "accessionId": "DGWAS-6301",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043734",
    "phenotype": "Parkinson's disease (PheCode 332)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Parkinson disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043734"
  },
  {
    "accessionId": "DGWAS-6302",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043735",
    "phenotype": "Torsion dystonia (PheCode 333.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Torsion dystonia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043735"
  },
  {
    "accessionId": "DGWAS-6303",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043736",
    "phenotype": "Anterior horn cell disease (PheCode 334.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anterior horn cell disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043736"
  },
  {
    "accessionId": "DGWAS-6304",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043737",
    "phenotype": "Degenerative disease of the spinal cord (PheCode 334)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal cord degeneration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043737"
  },
  {
    "accessionId": "DGWAS-6305",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043738",
    "phenotype": "Multiple sclerosis (PheCode 335)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple sclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043738"
  },
  {
    "accessionId": "DGWAS-6306",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043739",
    "phenotype": "Acute pain (PheCode 338.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043739"
  },
  {
    "accessionId": "DGWAS-6307",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043740",
    "phenotype": "Chronic pain (PheCode 338.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043740"
  },
  {
    "accessionId": "DGWAS-6308",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043742",
    "phenotype": "Other headache syndromes (PheCode 339)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Headache syndrome NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043742"
  },
  {
    "accessionId": "DGWAS-6309",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043743",
    "phenotype": "Migrain with aura (PheCode 340.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine with aura",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043743"
  },
  {
    "accessionId": "DGWAS-6310",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043744",
    "phenotype": "Neck/shoulder pain for three months (UKB data field 3404)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic neck/shoulder pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043744"
  },
  {
    "accessionId": "DGWAS-6311",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043745",
    "phenotype": "Migraine (PheCode 340)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Migraine",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043745"
  },
  {
    "accessionId": "DGWAS-6312",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043747",
    "phenotype": "Other demyelinating diseases of central nervous system (PheCode 341)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS demyelinating disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043747"
  },
  {
    "accessionId": "DGWAS-6313",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043748",
    "phenotype": "Hemiplegia (PheCode 342)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemiplegia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043748"
  },
  {
    "accessionId": "DGWAS-6314",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043752",
    "phenotype": "Other paralytic syndromes (PheCode 344)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043752"
  },
  {
    "accessionId": "DGWAS-6315",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043753",
    "phenotype": "Generalized convulsive epilepsy (PheCode 345.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized convulsive epilepsy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043753"
  },
  {
    "accessionId": "DGWAS-6316",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043754",
    "phenotype": "Partial epilepsy (PheCode 345.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Partial epilepsy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043754"
  },
  {
    "accessionId": "DGWAS-6317",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043755",
    "phenotype": "Epilepsy (PheCode 345.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epilepsy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043755"
  },
  {
    "accessionId": "DGWAS-6318",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043756",
    "phenotype": "Convulsions (PheCode 345.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Convulsions",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043756"
  },
  {
    "accessionId": "DGWAS-6319",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043757",
    "phenotype": "Epilepsy, recurrent seizures, convulsions (PheCode 345)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epilepsy/seizure disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043757"
  },
  {
    "accessionId": "DGWAS-6320",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043758",
    "phenotype": "Other conditions of brain, not otherwise specified (PheCode 348.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain condition NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043758"
  },
  {
    "accessionId": "DGWAS-6321",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043759",
    "phenotype": "Other and unspecified disorders of the nervous system (PheCode 349)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nervous system disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043759"
  },
  {
    "accessionId": "DGWAS-6322",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043760",
    "phenotype": "Abnormal involuntary movements (PheCode 350.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Involuntary movement disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043760"
  },
  {
    "accessionId": "DGWAS-6323",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043762",
    "phenotype": "Lack of coordination (PheCode 350.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lack of coordination",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043762"
  },
  {
    "accessionId": "DGWAS-6324",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043763",
    "phenotype": "Other peripheral nerve disorders (PheCode 351)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral nerve disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043763"
  },
  {
    "accessionId": "DGWAS-6325",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043764",
    "phenotype": "Trigeminal nerve disorders [CN5] (PheCode 352.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigeminal nerve disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043764"
  },
  {
    "accessionId": "DGWAS-6326",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043765",
    "phenotype": "Facial nerve disorders [CN7] (PheCode 352.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial nerve disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043765"
  },
  {
    "accessionId": "DGWAS-6327",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043766",
    "phenotype": "Nerve root and plexus disorders (PheCode 353)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nerve root/plexus disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043766"
  },
  {
    "accessionId": "DGWAS-6328",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043767",
    "phenotype": "Back pain for three months (UKB data field 3571)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic back pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043767"
  },
  {
    "accessionId": "DGWAS-6329",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043768",
    "phenotype": "Inflammatory and toxic neuropathy (PheCode 357)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inflammatory/toxic neuropathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043768"
  },
  {
    "accessionId": "DGWAS-6330",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043769",
    "phenotype": "Myasthenia gravis (PheCode 358.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myasthenia gravis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043769"
  },
  {
    "accessionId": "DGWAS-6331",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043770",
    "phenotype": "Myopathy (PheCode 359.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043770"
  },
  {
    "accessionId": "DGWAS-6333",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043773",
    "phenotype": "Retinal detachment with retinal defect (PheCode 361.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment with defect",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043773"
  },
  {
    "accessionId": "DGWAS-6334",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043775",
    "phenotype": "Retinal detachments and defects (PheCode 361)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment/defect",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043775"
  },
  {
    "accessionId": "DGWAS-6335",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043777",
    "phenotype": "Retinal vascular changes and abnomalities (PheCode 362.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal vascular changes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043777"
  },
  {
    "accessionId": "DGWAS-6336",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043778",
    "phenotype": "Other retinal disorders (PheCode 362)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043778"
  },
  {
    "accessionId": "DGWAS-6337",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043779",
    "phenotype": "Corneal dystrophy (PheCode 364.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal dystrophy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043779"
  },
  {
    "accessionId": "DGWAS-6338",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043780",
    "phenotype": "Corneal opacity and other disorders of cornea (PheCode 364)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal opacity/disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043780"
  },
  {
    "accessionId": "DGWAS-6339",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043781",
    "phenotype": "Primary open angle glaucoma (PheCode 365.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary open-angle glaucoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043781"
  },
  {
    "accessionId": "DGWAS-6340",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043782",
    "phenotype": "Primary angle-closure glaucoma (PheCode 365.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angle-closure glaucoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043782"
  },
  {
    "accessionId": "DGWAS-6341",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043783",
    "phenotype": "Glaucoma (PheCode 365)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043783"
  },
  {
    "accessionId": "DGWAS-6342",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043785",
    "phenotype": "Cataract (PheCode 366)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cataract",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043785"
  },
  {
    "accessionId": "DGWAS-6343",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043786",
    "phenotype": "Diplopia and disorders of binocular vision (PheCode 368.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diplopia/binocular vision disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043786"
  },
  {
    "accessionId": "DGWAS-6344",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043787",
    "phenotype": "Subjective visual disturbances (PheCode 368.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subjective visual disturbance",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043787"
  },
  {
    "accessionId": "DGWAS-6345",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043789",
    "phenotype": "Infection of the eye (PheCode 369)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043789"
  },
  {
    "accessionId": "DGWAS-6346",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043790",
    "phenotype": "Corneal ulcer (PheCode 370.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043790"
  },
  {
    "accessionId": "DGWAS-6347",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043791",
    "phenotype": "Uveitis, noninfectious or not otherwise specified (PheCode 371.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious uveitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043791"
  },
  {
    "accessionId": "DGWAS-6348",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043792",
    "phenotype": "Inflammation of eyelids (PheCode 371.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid inflammation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043792"
  },
  {
    "accessionId": "DGWAS-6349",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043793",
    "phenotype": "Disorders of conjunctiva (PheCode 372)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conjunctival disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043793"
  },
  {
    "accessionId": "DGWAS-6350",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043795",
    "phenotype": "Ectropion or entropion (PheCode 374.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectropion/entropion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043795"
  },
  {
    "accessionId": "DGWAS-6351",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043796",
    "phenotype": "Ptosis of eyelid (PheCode 374.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ptosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043796"
  },
  {
    "accessionId": "DGWAS-6353",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043798",
    "phenotype": "Other disorders of eyelids (PheCode 374)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043798"
  },
  {
    "accessionId": "DGWAS-6354",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043799",
    "phenotype": "Epiphora (PheCode 375.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epiphora",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043799"
  },
  {
    "accessionId": "DGWAS-6355",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043801",
    "phenotype": "Disorders of lacrimal system (PheCode 375)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal system disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043801"
  },
  {
    "accessionId": "DGWAS-6356",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043802",
    "phenotype": "Optic neuritis/neuropathy (PheCode 377.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Optic neuritis/neuropathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043802"
  },
  {
    "accessionId": "DGWAS-6358",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043804",
    "phenotype": "Strabismus (not specified as paralytic) (PheCode 378.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Strabismus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043804"
  },
  {
    "accessionId": "DGWAS-6359",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043805",
    "phenotype": "Paralytic strabismus (PheCode 378.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic strabismus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043805"
  },
  {
    "accessionId": "DGWAS-6360",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043806",
    "phenotype": "Disorders of vitreous body (PheCode 379.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043806"
  },
  {
    "accessionId": "DGWAS-6361",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043807",
    "phenotype": "Aphakia and other disorders of lens (PheCode 379.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aphakia/lens disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043807"
  },
  {
    "accessionId": "DGWAS-6363",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043809",
    "phenotype": "Other disorders of eye (PheCode 379)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043809"
  },
  {
    "accessionId": "DGWAS-6364",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043810",
    "phenotype": "Otitis externa (PheCode 380.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis externa",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043810"
  },
  {
    "accessionId": "DGWAS-6365",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043811",
    "phenotype": "Impacted cerumen (PheCode 380.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted cerumen",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043811"
  },
  {
    "accessionId": "DGWAS-6366",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043812",
    "phenotype": "Disorders of external ear (PheCode 380)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External ear disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043812"
  },
  {
    "accessionId": "DGWAS-6367",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043813",
    "phenotype": "Suppurative and unspecified otitis media (PheCode 381.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suppurative otitis media NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043813"
  },
  {
    "accessionId": "DGWAS-6368",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043814",
    "phenotype": "Otitis media (PheCode 381.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis media",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043814"
  },
  {
    "accessionId": "DGWAS-6369",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043815",
    "phenotype": "Eustachian tube disorders (PheCode 381.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eustachian tube disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043815"
  },
  {
    "accessionId": "DGWAS-6370",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043816",
    "phenotype": "Mastoiditis & related conditions (PheCode 381.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mastoiditis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043816"
  },
  {
    "accessionId": "DGWAS-6371",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043817",
    "phenotype": "Otorrhea (PheCode 381.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otorrhea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043817"
  },
  {
    "accessionId": "DGWAS-6372",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043818",
    "phenotype": "Otalgia (PheCode 382)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otalgia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043818"
  },
  {
    "accessionId": "DGWAS-6373",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043819",
    "phenotype": "Otosclerosis (PheCode 383)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otosclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043819"
  },
  {
    "accessionId": "DGWAS-6374",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043820",
    "phenotype": "Perforation of tympanic membrane (PheCode 384.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane perforation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043820"
  },
  {
    "accessionId": "DGWAS-6375",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043821",
    "phenotype": "Other disorders of tympanic membrane (PheCode 384)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanic membrane disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043821"
  },
  {
    "accessionId": "DGWAS-6376",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043822",
    "phenotype": "Cholesteatoma (PheCode 385.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholesteatoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043822"
  },
  {
    "accessionId": "DGWAS-6377",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043823",
    "phenotype": "Tympanosclerosis and middle ear disease related to otitis media (PheCode 385.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tympanosclerosis/middle ear disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043823"
  },
  {
    "accessionId": "DGWAS-6378",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043829",
    "phenotype": "Other disorders of middle ear and mastoid (PheCode 385)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Middle ear/mastoid disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043829"
  },
  {
    "accessionId": "DGWAS-6379",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043830",
    "phenotype": "Meniere's disease (PheCode 386.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meniere disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043830"
  },
  {
    "accessionId": "DGWAS-6380",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043831",
    "phenotype": "Peripheral or central vertigo (PheCode 386.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral/central vertigo",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043831"
  },
  {
    "accessionId": "DGWAS-6381",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043832",
    "phenotype": "Labyrinthitis (PheCode 386.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labyrinthitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043832"
  },
  {
    "accessionId": "DGWAS-6382",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043833",
    "phenotype": "Dizziness and giddiness (Light-headedness and vertigo) (PheCode 386.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dizziness/vertigo",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043833"
  },
  {
    "accessionId": "DGWAS-6383",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043834",
    "phenotype": "Sensorineural hearing loss (PheCode 389.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sensorineural hearing loss",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043834"
  },
  {
    "accessionId": "DGWAS-6384",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043835",
    "phenotype": "Conductive hearing loss (PheCode 389.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conductive hearing loss",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043835"
  },
  {
    "accessionId": "DGWAS-6385",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043836",
    "phenotype": "Hearing loss (PheCode 389)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hearing loss",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043836"
  },
  {
    "accessionId": "DGWAS-6386",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043837",
    "phenotype": "Mitral valve disease (PheCode 394.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mitral valve disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043837"
  },
  {
    "accessionId": "DGWAS-6387",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043838",
    "phenotype": "Aortic valve disease (PheCode 394.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic valve disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043838"
  },
  {
    "accessionId": "DGWAS-6388",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043839",
    "phenotype": "Disease of tricuspid valve (PheCode 394.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tricuspid valve disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043839"
  },
  {
    "accessionId": "DGWAS-6389",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043840",
    "phenotype": "Rheumatic disease of the heart valves (PheCode 394)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic valve disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043840"
  },
  {
    "accessionId": "DGWAS-6390",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043841",
    "phenotype": "Nonrheumatic mitral valve disorders (PheCode 395.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonrheumatic mitral valve disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043841"
  },
  {
    "accessionId": "DGWAS-6391",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043842",
    "phenotype": "ICD10 C01: Malignant neoplasm of base of tongue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Base of tongue cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043842"
  },
  {
    "accessionId": "DGWAS-6392",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043843",
    "phenotype": "ICD10 C09.9: Malignant neoplasm of tonsil, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsil cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043843"
  },
  {
    "accessionId": "DGWAS-6393",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043844",
    "phenotype": "ICD10 C15.5: Malignant neoplasm of lower third of esophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower esophageal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043844"
  },
  {
    "accessionId": "DGWAS-6394",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043845",
    "phenotype": "ICD10 C15.9: Malignant neoplasm of esophagus, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043845"
  },
  {
    "accessionId": "DGWAS-6395",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043846",
    "phenotype": "ICD10 C16.0: Malignant neoplasm of cardia of stomach",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric cardia cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043846"
  },
  {
    "accessionId": "DGWAS-6396",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043847",
    "phenotype": "ICD10 C16.9: Malignant neoplasm of stomach, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043847"
  },
  {
    "accessionId": "DGWAS-6397",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043848",
    "phenotype": "ICD10 C18.0: Malignant neoplasm of cecum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cecal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043848"
  },
  {
    "accessionId": "DGWAS-6398",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043849",
    "phenotype": "ICD10 C18.2: Malignant neoplasm of ascending colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ascending colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043849"
  },
  {
    "accessionId": "DGWAS-6399",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043850",
    "phenotype": "ICD10 C18.3: Malignant neoplasm of hepatic flexure of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatic flexure colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043850"
  },
  {
    "accessionId": "DGWAS-6400",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043851",
    "phenotype": "ICD10 C18.4: Malignant neoplasm of transverse colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transverse colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043851"
  },
  {
    "accessionId": "DGWAS-6401",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043852",
    "phenotype": "ICD10 C18.5: Malignant neoplasm of splenic flexure of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Splenic flexure colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043852"
  },
  {
    "accessionId": "DGWAS-6402",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043853",
    "phenotype": "ICD10 C18.6: Malignant neoplasm of descending colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Descending colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043853"
  },
  {
    "accessionId": "DGWAS-6403",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043854",
    "phenotype": "ICD10 C18.7: Malignant neoplasm of sigmoid colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sigmoid colon cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043854"
  },
  {
    "accessionId": "DGWAS-6404",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043855",
    "phenotype": "ICD10 C18.9: Malignant neoplasm of colon, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043855"
  },
  {
    "accessionId": "DGWAS-6405",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043856",
    "phenotype": "ICD10 C19: Malignant neoplasm of rectosigmoid junction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectosigmoid cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043856"
  },
  {
    "accessionId": "DGWAS-6406",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043857",
    "phenotype": "ICD10 C20: Malignant neoplasm of rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043857"
  },
  {
    "accessionId": "DGWAS-6407",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043858",
    "phenotype": "ICD10 C22.0: Liver cell carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hepatocellular carcinoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043858"
  },
  {
    "accessionId": "DGWAS-6408",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043859",
    "phenotype": "ICD10 C22.1: Intrahepatic bile duct carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intrahepatic bile duct cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043859"
  },
  {
    "accessionId": "DGWAS-6409",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043860",
    "phenotype": "ICD10 C25.0: Malignant neoplasm of head of pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic head cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043860"
  },
  {
    "accessionId": "DGWAS-6410",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043861",
    "phenotype": "ICD10 C25.9: Malignant neoplasm of pancreas, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043861"
  },
  {
    "accessionId": "DGWAS-6411",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043862",
    "phenotype": "ICD10 C32.0: Malignant neoplasm of glottis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glottic cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043862"
  },
  {
    "accessionId": "DGWAS-6412",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043863",
    "phenotype": "ICD10 C34.1: Malignant neoplasm of upper lobe, bronchus or lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper lobe lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043863"
  },
  {
    "accessionId": "DGWAS-6413",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043864",
    "phenotype": "ICD10 C34.3: Malignant neoplasm of lower lobe, bronchus or lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower lobe lung cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043864"
  },
  {
    "accessionId": "DGWAS-6414",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043865",
    "phenotype": "ICD10 C34.9: Malignant neoplasm of unspecified part of bronchus or lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043865"
  },
  {
    "accessionId": "DGWAS-6415",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043866",
    "phenotype": "ICD10 C43.3: Malignant melanoma of other and unspecified parts of face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial melanoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043866"
  },
  {
    "accessionId": "DGWAS-6416",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043867",
    "phenotype": "ICD10 C43.5: Malignant melanoma of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Truncal melanoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043867"
  },
  {
    "accessionId": "DGWAS-6417",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043868",
    "phenotype": "ICD10 C43.6: Malignant melanoma of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb melanoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043868"
  },
  {
    "accessionId": "DGWAS-6418",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043869",
    "phenotype": "ICD10 C43.7: Malignant melanoma of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb melanoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043869"
  },
  {
    "accessionId": "DGWAS-6419",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043870",
    "phenotype": "ICD10 C43.9: Malignant melanoma of skin, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043870"
  },
  {
    "accessionId": "DGWAS-6420",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043871",
    "phenotype": "ICD10 C44.0:  Other and unspecified malignant neoplasm of skin of lip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lip skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043871"
  },
  {
    "accessionId": "DGWAS-6421",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043872",
    "phenotype": "ICD10 C44.1: Other and unspecified malignant neoplasm of skin of eyelid, including canthus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eyelid skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043872"
  },
  {
    "accessionId": "DGWAS-6422",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043873",
    "phenotype": "ICD10 C44.2: Other and unspecified malignant neoplasm of skin of ear and external auricular canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ear skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043873"
  },
  {
    "accessionId": "DGWAS-6423",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043874",
    "phenotype": "ICD10 C44.3: Other and unspecified malignant neoplasm of skin of other and unspecified parts of face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043874"
  },
  {
    "accessionId": "DGWAS-6424",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043875",
    "phenotype": "ICD10 C44.4: Other and unspecified malignant neoplasm of skin of scalp and neck",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Scalp/neck skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043875"
  },
  {
    "accessionId": "DGWAS-6425",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043876",
    "phenotype": "ICD10 C44.5: Other and unspecified malignant neoplasm of skin of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Truncal skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043876"
  },
  {
    "accessionId": "DGWAS-6426",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043877",
    "phenotype": "ICD10 C44.6: Other and unspecified malignant neoplasm of skin of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043877"
  },
  {
    "accessionId": "DGWAS-6427",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043878",
    "phenotype": "ICD10 C44.7: Other and unspecified malignant neoplasm of skin of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043878"
  },
  {
    "accessionId": "DGWAS-6428",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043879",
    "phenotype": "ICD10 C44.8: Overlapping lesion of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overlapping skin cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043879"
  },
  {
    "accessionId": "DGWAS-6429",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043880",
    "phenotype": "ICD10 C44.9:  Malignant neoplasm of skin, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043880"
  },
  {
    "accessionId": "DGWAS-6430",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043881",
    "phenotype": "ICD10 C45.0: Mesothelioma of pleura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleural mesothelioma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043881"
  },
  {
    "accessionId": "DGWAS-6431",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043882",
    "phenotype": "ICD10 C49.2: Malignant neoplasm of connective and soft tissue of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb soft tissue cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043882"
  },
  {
    "accessionId": "DGWAS-6432",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043883",
    "phenotype": "ICD10 C50.1: Malignant neoplasm of central portion of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043883"
  },
  {
    "accessionId": "DGWAS-6433",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043884",
    "phenotype": "ICD10 C50.2: Malignant neoplasm of upper-inner quadrant of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper-inner breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043884"
  },
  {
    "accessionId": "DGWAS-6434",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043885",
    "phenotype": "ICD10 C50.3: Malignant neoplasm of lower-inner quadrant of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower-inner breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043885"
  },
  {
    "accessionId": "DGWAS-6435",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043886",
    "phenotype": "ICD10 C50.4: Malignant neoplasm of upper-outer quadrant of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper-outer breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043886"
  },
  {
    "accessionId": "DGWAS-6436",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043887",
    "phenotype": "ICD10 C50.5: Malignant neoplasm of lower-outer quadrant of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower-outer breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043887"
  },
  {
    "accessionId": "DGWAS-6437",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043888",
    "phenotype": "ICD10 C50.8: Malignant neoplasm of overlapping sites of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overlapping breast cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043888"
  },
  {
    "accessionId": "DGWAS-6438",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043889",
    "phenotype": "ICD10 C50.9: Malignant neoplasm of breast of unspecified site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043889"
  },
  {
    "accessionId": "DGWAS-6439",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043890",
    "phenotype": "ICD10 C51.9: Malignant neoplasm of vulva, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043890"
  },
  {
    "accessionId": "DGWAS-6440",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043891",
    "phenotype": "ICD10 C53.9: Malignant neoplasm of cervix uteri, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043891"
  },
  {
    "accessionId": "DGWAS-6441",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043892",
    "phenotype": "ICD10 C54.1: Malignant neoplasm of endometrium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometrial cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043892"
  },
  {
    "accessionId": "DGWAS-6442",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043893",
    "phenotype": "ICD10 C56: Malignant neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043893"
  },
  {
    "accessionId": "DGWAS-6443",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043894",
    "phenotype": "ICD10 C61: Malignant neoplasm of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043894"
  },
  {
    "accessionId": "DGWAS-6444",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043895",
    "phenotype": "ICD10 C62.1: Malignant neoplasm of descended testis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Descended testis cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043895"
  },
  {
    "accessionId": "DGWAS-6445",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043896",
    "phenotype": "ICD10 C62.9: Malignant neoplasm of testis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043896"
  },
  {
    "accessionId": "DGWAS-6446",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043897",
    "phenotype": "ICD10 C64: Malignant neoplasm of kidney, except renal pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (non-pelvis)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043897"
  },
  {
    "accessionId": "DGWAS-6447",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043898",
    "phenotype": "ICD10 C67.9: Malignant neoplasm of bladder, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043898"
  },
  {
    "accessionId": "DGWAS-6448",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043899",
    "phenotype": "ICD10 C71.1: Malignant neoplasm of brain, frontal lobe",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Frontal lobe brain cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043899"
  },
  {
    "accessionId": "DGWAS-6449",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043900",
    "phenotype": "ICD10 C71.2: Malignant neoplasm of brain, temporal lobe",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Temporal lobe brain cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043900"
  },
  {
    "accessionId": "DGWAS-6450",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043901",
    "phenotype": "ICD10 C71.9: Malignant neoplasm of brain, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043901"
  },
  {
    "accessionId": "DGWAS-6451",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043902",
    "phenotype": "ICD10 C73: Malignant neoplasm of thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043902"
  },
  {
    "accessionId": "DGWAS-6452",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043903",
    "phenotype": "ICD10 C80: Malignant neoplasm without specification of site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043903"
  },
  {
    "accessionId": "DGWAS-6453",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043904",
    "phenotype": "ICD10 C81.1: Nodular sclerosis classical Hodgkin lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nodular sclerosis Hodgkin lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043904"
  },
  {
    "accessionId": "DGWAS-6454",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043905",
    "phenotype": "ICD10 C82.9: Follicular lymphoma, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular lymphoma NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043905"
  },
  {
    "accessionId": "DGWAS-6455",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043906",
    "phenotype": "ICD10 C83.3: Diffuse large B-cell lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DLBCL",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043906"
  },
  {
    "accessionId": "DGWAS-6456",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043907",
    "phenotype": "ICD10 C83.8: Other non-follicular lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-follicular lymphoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043907"
  },
  {
    "accessionId": "DGWAS-6457",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043908",
    "phenotype": "ICD10 C85.7: Other specified types of non-Hodgkin lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other specified NHL",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043908"
  },
  {
    "accessionId": "DGWAS-6458",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043909",
    "phenotype": "ICD10 C85.9: Non-Hodgkin lymphoma, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NHL NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043909"
  },
  {
    "accessionId": "DGWAS-6459",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043910",
    "phenotype": "ICD10 C90.0: Multiple myeloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043910"
  },
  {
    "accessionId": "DGWAS-6460",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043911",
    "phenotype": "ICD10 C91.1: Chronic lymphocytic leukemia of B-cell type",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "B-cell CLL",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043911"
  },
  {
    "accessionId": "DGWAS-6461",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043912",
    "phenotype": "ICD10 C92.0: Acute myeloblastic leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute myeloblastic leukemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043912"
  },
  {
    "accessionId": "DGWAS-6462",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043913",
    "phenotype": "ICD10 C92.1: Chronic myeloid leukaemia, BCR/ABL-positive",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CML",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043913"
  },
  {
    "accessionId": "DGWAS-6463",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043914",
    "phenotype": "ICD10 D01.0: Carcinoma in situ of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043914"
  },
  {
    "accessionId": "DGWAS-6464",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043915",
    "phenotype": "ICD10 D01.2: Carcinoma in situ of anus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043915"
  },
  {
    "accessionId": "DGWAS-6465",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043916",
    "phenotype": "ICD10 D03.3: Melanoma in situ of other and unspecified parts of face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial melanoma in situ",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043916"
  },
  {
    "accessionId": "DGWAS-6466",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043917",
    "phenotype": "ICD10 D03.5: Melanoma in situ of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Truncal melanoma in situ",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043917"
  },
  {
    "accessionId": "DGWAS-6467",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043918",
    "phenotype": "ICD10 D03.6: Melanoma in situ of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb melanoma in situ",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043918"
  },
  {
    "accessionId": "DGWAS-6468",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043919",
    "phenotype": "ICD10 D03.7: Melanoma in situ of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb melanoma in situ",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043919"
  },
  {
    "accessionId": "DGWAS-6469",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043920",
    "phenotype": "ICD10 D04.3: Carcinoma in situ of skin of other and unspecified parts of face",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial skin CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043920"
  },
  {
    "accessionId": "DGWAS-6470",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043921",
    "phenotype": "ICD10 D04.5: Carcinoma in situ of skin of trunk",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Truncal skin CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043921"
  },
  {
    "accessionId": "DGWAS-6471",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043922",
    "phenotype": "ICD10 D04.6: Carcinoma in situ of skin of upper limb, including shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb skin CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043922"
  },
  {
    "accessionId": "DGWAS-6472",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043923",
    "phenotype": "ICD10 D04.7: Carcinoma in situ of skin of lower limb, including hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb skin CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043923"
  },
  {
    "accessionId": "DGWAS-6473",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043924",
    "phenotype": "ICD10 D04.9: Carcinoma in situ of skin, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin CIS NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043924"
  },
  {
    "accessionId": "DGWAS-6474",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043925",
    "phenotype": "ICD10 D05.0: Lobular carcinoma in situ of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast lobular CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043925"
  },
  {
    "accessionId": "DGWAS-6475",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043926",
    "phenotype": "ICD10 D05.1: Intraductal carcinoma in situ of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast intraductal CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043926"
  },
  {
    "accessionId": "DGWAS-6476",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043927",
    "phenotype": "ICD10 D05.7: Other carcinoma in situ of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast CIS other",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043927"
  },
  {
    "accessionId": "DGWAS-6477",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043928",
    "phenotype": "ICD10 D05.9: Unspecified type of carcinoma in situ of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast CIS NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043928"
  },
  {
    "accessionId": "DGWAS-6478",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043929",
    "phenotype": "ICD10 D06.1: Carcinoma in situ of exocervix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Exocervical CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043929"
  },
  {
    "accessionId": "DGWAS-6479",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043930",
    "phenotype": "ICD10 D06.9: Carcinoma in situ of cervix, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical CIS NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043930"
  },
  {
    "accessionId": "DGWAS-6480",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043931",
    "phenotype": "ICD10 D07.1: Carcinoma in situ of vulva",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043931"
  },
  {
    "accessionId": "DGWAS-6481",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043932",
    "phenotype": "ICD10 D07.5: Carcinoma in situ of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043932"
  },
  {
    "accessionId": "DGWAS-6482",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043933",
    "phenotype": "ICD10 D09.0: Carcinoma in situ of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder CIS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043933"
  },
  {
    "accessionId": "DGWAS-6483",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043934",
    "phenotype": "ICD10 D32.0: Benign neoplasm of cerebral meninges",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cerebral meninges neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043934"
  },
  {
    "accessionId": "DGWAS-6484",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043935",
    "phenotype": "ICD10 D33.3: Benign neoplasm of brain, supratentorial",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign supratentorial brain neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043935"
  },
  {
    "accessionId": "DGWAS-6485",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043936",
    "phenotype": "ICD10 D35.2: Benign neoplasm of pituitary gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign pituitary neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043936"
  },
  {
    "accessionId": "DGWAS-6486",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043937",
    "phenotype": "ICD10 D37.4: Benign neoplasm of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign colon neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043937"
  },
  {
    "accessionId": "DGWAS-6487",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043938",
    "phenotype": "ICD10 D41.4: Neoplasm of uncertain behavior of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder neoplasm uncertain behavior",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043938"
  },
  {
    "accessionId": "DGWAS-6488",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043939",
    "phenotype": "ICD10 D45: Polycythaemia vera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polycythemia vera",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043939"
  },
  {
    "accessionId": "DGWAS-6489",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043940",
    "phenotype": "ICD10 D46.9: Myelodysplastic syndrome, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "MDS NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043940"
  },
  {
    "accessionId": "DGWAS-6490",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043941",
    "phenotype": "ICD10 D47.1: Chronic myeloproliferative disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic myeloproliferative disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043941"
  },
  {
    "accessionId": "DGWAS-6491",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043942",
    "phenotype": "ICD10 D47.2: Monoclonal gammopathy of undetermined significance",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "MGUS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043942"
  },
  {
    "accessionId": "DGWAS-6492",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043943",
    "phenotype": "Behaviour of cancer tumour: benign, PHESANT recoding (UKB data field 40012_0)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign cancer tumor",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043943"
  },
  {
    "accessionId": "DGWAS-6493",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043945",
    "phenotype": "Behaviour of cancer tumour: carcinoma in situ, PHESANT recoding (UKB data field 40012_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carcinoma in situ",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043945"
  },
  {
    "accessionId": "DGWAS-6494",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043947",
    "phenotype": "Behaviour of cancer tumour: malignant, microinvasive, PHESANT recoding (UKB data field 40012_5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malignant microinvasive cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043947"
  },
  {
    "accessionId": "DGWAS-6495",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043948",
    "phenotype": "Behaviour of cancer tumour: malignant, metastatic site, PHESANT recoding (UKB data field 40012_6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metastatic cancer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043948"
  },
  {
    "accessionId": "DGWAS-6496",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043949",
    "phenotype": "Essential hypertension (PheCode 401.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Essential hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043949"
  },
  {
    "accessionId": "DGWAS-6497",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043950",
    "phenotype": "Hypertensive chronic kidney disease (PheCode 401.22)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive CKD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043950"
  },
  {
    "accessionId": "DGWAS-6500",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043953",
    "phenotype": "Unstable angina (intermediate coronary syndrome) (PheCode 411.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unstable angina",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043953"
  },
  {
    "accessionId": "DGWAS-6501",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043954",
    "phenotype": "Myocardial infarction (PheCode 411.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myocardial infarction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043954"
  },
  {
    "accessionId": "DGWAS-6502",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043955",
    "phenotype": "Angina pectoris (PheCode 411.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angina pectoris",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043955"
  },
  {
    "accessionId": "DGWAS-6503",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043956",
    "phenotype": "Aneurysm and dissection of heart (PheCode 411.41)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac aneurysm/dissection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043956"
  },
  {
    "accessionId": "DGWAS-6504",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043957",
    "phenotype": "Coronary atherosclerosis (PheCode 411.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coronary atherosclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043957"
  },
  {
    "accessionId": "DGWAS-6505",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043958",
    "phenotype": "Other chronic ischemic heart disease, unspecified (PheCode 411.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic ischemic heart disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043958"
  },
  {
    "accessionId": "DGWAS-6506",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043959",
    "phenotype": "Other acute and subacute forms of ischemic heart disease (PheCode 411.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute/subacute ischemic heart disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043959"
  },
  {
    "accessionId": "DGWAS-6507",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043960",
    "phenotype": "Other forms of chronic heart disease (PheCode 414)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic heart disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043960"
  },
  {
    "accessionId": "DGWAS-6508",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043961",
    "phenotype": "Primary pulmonary hypertension (PheCode 415.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary pulmonary hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043961"
  },
  {
    "accessionId": "DGWAS-6509",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043962",
    "phenotype": "Pulmonary heart disease (PheCode 415)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary heart disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043962"
  },
  {
    "accessionId": "DGWAS-651",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MIH",
    "phenotype": "Molar incisor enamel hypoplasia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Molar incisor hypoplasia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MIH.gz"
  },
  {
    "accessionId": "DGWAS-6510",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043963",
    "phenotype": "Cardiomegaly (PheCode 416)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomegaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043963"
  },
  {
    "accessionId": "DGWAS-6511",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043964",
    "phenotype": "Precordial pain (PheCode 418.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Precordial pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043964"
  },
  {
    "accessionId": "DGWAS-6512",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043965",
    "phenotype": "Nonspecific chest pain (PheCode 418)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonspecific chest pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043965"
  },
  {
    "accessionId": "DGWAS-6513",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043966",
    "phenotype": "Acute pericarditis (PheCode 420.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pericarditis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043966"
  },
  {
    "accessionId": "DGWAS-6514",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043968",
    "phenotype": "Endocarditis (PheCode 420.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocarditis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043968"
  },
  {
    "accessionId": "DGWAS-6515",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043969",
    "phenotype": "Primary/intrinsic cardiomyopathies (PheCode 425.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary cardiomyopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043969"
  },
  {
    "accessionId": "DGWAS-6516",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043970",
    "phenotype": "First degree AV block (PheCode 426.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "First-degree AV block",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043970"
  },
  {
    "accessionId": "DGWAS-6517",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043971",
    "phenotype": "Second degree AV block (PheCode 426.23)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Second-degree AV block",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043971"
  },
  {
    "accessionId": "DGWAS-6518",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043972",
    "phenotype": "Atrioventricular block, complete (PheCode 426.24)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Complete AV block",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043972"
  },
  {
    "accessionId": "DGWAS-6519",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043973",
    "phenotype": "Left bundle branch block (PheCode 426.32)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "LBBB",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043973"
  },
  {
    "accessionId": "DGWAS-6520",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043974",
    "phenotype": "Anomalous atrioventricular excitation (PheCode 426.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pre-excitation syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043974"
  },
  {
    "accessionId": "DGWAS-6521",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043975",
    "phenotype": "Paroxysmal supraventricular tachycardia (PheCode 427.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PSVT",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043975"
  },
  {
    "accessionId": "DGWAS-6522",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043976",
    "phenotype": "Paroxysmal ventricular tachycardia (PheCode 427.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ventricular tachycardia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043976"
  },
  {
    "accessionId": "DGWAS-6523",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043977",
    "phenotype": "Atrial fibrillation and flutter (PheCode 427.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrial fibrillation/flutter",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043977"
  },
  {
    "accessionId": "DGWAS-6524",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043978",
    "phenotype": "Other specified cardiac dysrhythmias (PheCode 427.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac dysrhythmia NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043978"
  },
  {
    "accessionId": "DGWAS-6525",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043979",
    "phenotype": "Cardiac arrest (PheCode 427.42)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrest",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043979"
  },
  {
    "accessionId": "DGWAS-6526",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043980",
    "phenotype": "Arrhythmia (cardiac), not otherwise specified (PheCode 427.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arrhythmia NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043980"
  },
  {
    "accessionId": "DGWAS-6527",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043981",
    "phenotype": "Premature beats (PheCode 427.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Premature beats",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043981"
  },
  {
    "accessionId": "DGWAS-6528",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043982",
    "phenotype": "Tachycardia, not otherwise specified (PheCode 427.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tachycardia NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043982"
  },
  {
    "accessionId": "DGWAS-6529",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043983",
    "phenotype": "Sinoatrial node dysfunction (Bradycardia) (PheCode 427.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sinus node dysfunction/bradycardia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043983"
  },
  {
    "accessionId": "DGWAS-6530",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043984",
    "phenotype": "Palpitations (PheCode 427.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Palpitations",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043984"
  },
  {
    "accessionId": "DGWAS-6531",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043985",
    "phenotype": "Congestive heart failure (CHF), not otherwise specified (PheCode 428.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CHF NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043985"
  },
  {
    "accessionId": "DGWAS-6532",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043986",
    "phenotype": "Heart failure, not otherwise specified (PheCode 428.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043986"
  },
  {
    "accessionId": "DGWAS-6533",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043987",
    "phenotype": "Abnormal function study of cardiovascular system (PheCode 429.2)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abnormal cardiovascular function study",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043987"
  },
  {
    "accessionId": "DGWAS-6534",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043988",
    "phenotype": "Symptoms involving cardiovascular system (PheCode 429.3)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cardiovascular symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043988"
  },
  {
    "accessionId": "DGWAS-6535",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043993",
    "phenotype": "Subarachnoid hemorrhage (PheCode 430.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subarachnoid hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043993"
  },
  {
    "accessionId": "DGWAS-6536",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043994",
    "phenotype": "Intracerebral hemorrhage (PheCode 430.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracerebral hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043994"
  },
  {
    "accessionId": "DGWAS-6537",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043995",
    "phenotype": "Subdural hemorrhage (PheCode 430.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Subdural hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043995"
  },
  {
    "accessionId": "DGWAS-6538",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043996",
    "phenotype": "Intracranial hemorrhage (PheCode 430)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracranial hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043996"
  },
  {
    "accessionId": "DGWAS-6539",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043997",
    "phenotype": "Occlusion of cerebral arteries, with cerebral infarction (PheCode 433.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral artery occlusion with infarction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043997"
  },
  {
    "accessionId": "DGWAS-6540",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043998",
    "phenotype": "Occlusion and stenosis of precerebral arteries (PheCode 433.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Precerebral artery stenosis/occlusion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043998"
  },
  {
    "accessionId": "DGWAS-6541",
    "sources": "GWAS catalog",
    "phenocode": "GCST90043999",
    "phenotype": "Cerebral artery occlusion, with cerebral infarction (PheCode 433.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral artery occlusion with infarction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90043999"
  },
  {
    "accessionId": "DGWAS-6542",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044000",
    "phenotype": "Occlusion of cerebral arteries (PheCode 433.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral artery occlusion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90043001-GCST90044000/GCST90044000"
  },
  {
    "accessionId": "DGWAS-6543",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044001",
    "phenotype": "Transient cerebral ischemia (PheCode 433.31)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TIA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044001"
  },
  {
    "accessionId": "DGWAS-6544",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044002",
    "phenotype": "Cerebral ischemia (PheCode 433.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral ischemia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044002"
  },
  {
    "accessionId": "DGWAS-6545",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044003",
    "phenotype": "Cerebral aneurysm (PheCode 433.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral aneurysm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044003"
  },
  {
    "accessionId": "DGWAS-6546",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044004",
    "phenotype": "Cerebrovascular disease (PheCode 433)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebrovascular disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044004"
  },
  {
    "accessionId": "DGWAS-6547",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044005",
    "phenotype": "Atherosclerosis of the extremities (PheCode 440.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral atherosclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044005"
  },
  {
    "accessionId": "DGWAS-6548",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044006",
    "phenotype": "Atherosclerosis (PheCode 440)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atherosclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044006"
  },
  {
    "accessionId": "DGWAS-6549",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044007",
    "phenotype": "Acute vascular insufficiency of intestine (PheCode 441.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute intestinal vascular insufficiency",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044007"
  },
  {
    "accessionId": "DGWAS-6550",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044008",
    "phenotype": "Vascular insufficiency of intestine (PheCode 441)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal vascular insufficiency",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044008"
  },
  {
    "accessionId": "DGWAS-6551",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044009",
    "phenotype": "Abdominal aortic aneurysm (PheCode 442.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal aortic aneurysm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044009"
  },
  {
    "accessionId": "DGWAS-6552",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044010",
    "phenotype": "Aortic aneurysm (PheCode 442.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic aneurysm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044010"
  },
  {
    "accessionId": "DGWAS-6553",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044011",
    "phenotype": "Aneurysm of artery of lower extremity (PheCode 442.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity artery aneurysm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044011"
  },
  {
    "accessionId": "DGWAS-6554",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044012",
    "phenotype": "Aneurysm of other specified artery (PheCode 442.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other specified artery aneurysm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044012"
  },
  {
    "accessionId": "DGWAS-6555",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044013",
    "phenotype": "Raynaud's syndrome (PheCode 443.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Raynaud syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044013"
  },
  {
    "accessionId": "DGWAS-6556",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044014",
    "phenotype": "Peripheral angiopathy in diseases classified elsewhere (PheCode 443.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary peripheral angiopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044014"
  },
  {
    "accessionId": "DGWAS-6557",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044015",
    "phenotype": "Peripheral vascular disease, unspecified (PheCode 443.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral vascular disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044015"
  },
  {
    "accessionId": "DGWAS-6558",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044016",
    "phenotype": "Arterial embolism and thrombosis of lower extremity artery (PheCode 444.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity arterial embolism/thrombosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044016"
  },
  {
    "accessionId": "DGWAS-6559",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044017",
    "phenotype": "Arterial embolism and thrombosis (PheCode 444)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial embolism/thrombosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044017"
  },
  {
    "accessionId": "DGWAS-6560",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044018",
    "phenotype": "Wegener's granulomatosis (PheCode 446.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Granulomatosis with polyangiitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044018"
  },
  {
    "accessionId": "DGWAS-6561",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044019",
    "phenotype": "Giant cell arteritis (PheCode 446.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Giant cell arteritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044019"
  },
  {
    "accessionId": "DGWAS-6562",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044020",
    "phenotype": "Arteritis, not otherwise specified (PheCode 446.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arteritis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044020"
  },
  {
    "accessionId": "DGWAS-6563",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044021",
    "phenotype": "Stricture of artery (PheCode 447.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Artery stricture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044021"
  },
  {
    "accessionId": "DGWAS-6564",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044022",
    "phenotype": "Other disorders of arteries and arterioles (PheCode 447)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Artery/arteriole disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044022"
  },
  {
    "accessionId": "DGWAS-6565",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044024",
    "phenotype": "Noninfectious disorders of lymphatic channels (PheCode 450)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious lymphatic disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044024"
  },
  {
    "accessionId": "DGWAS-6566",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044025",
    "phenotype": "Phlebitis and thrombophlebitis of lower extremities (PheCode 451.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity phlebitis/thrombophlebitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044025"
  },
  {
    "accessionId": "DGWAS-6567",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044026",
    "phenotype": "Phlebitis and thrombophlebitis (PheCode 451)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phlebitis/thrombophlebitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044026"
  },
  {
    "accessionId": "DGWAS-6568",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044027",
    "phenotype": "Other venous embolism and thrombosis (PheCode 452)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Venous embolism/thrombosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044027"
  },
  {
    "accessionId": "DGWAS-6569",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044028",
    "phenotype": "Varicose veins of lower extremity, symptomtic (PheCode 454.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Symptomatic lower extremity varicose veins",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044028"
  },
  {
    "accessionId": "DGWAS-657",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CARIES_3_OPER_ONLYAVO",
    "phenotype": "Dental caries 3 and operation codes, only avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries (avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CARIES_3_OPER_ONLYAVO.gz"
  },
  {
    "accessionId": "DGWAS-6570",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044029",
    "phenotype": "Varicose veins of lower extremity (PheCode 454.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity varicose veins",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044029"
  },
  {
    "accessionId": "DGWAS-6571",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044030",
    "phenotype": "Varicose veins (PheCode 454)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Varicose veins",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044030"
  },
  {
    "accessionId": "DGWAS-6572",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044031",
    "phenotype": "Hemorrhoids (PheCode 455)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemorrhoids",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044031"
  },
  {
    "accessionId": "DGWAS-6573",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044032",
    "phenotype": "Orthostatic hypotension (PheCode 458.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orthostatic hypotension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044032"
  },
  {
    "accessionId": "DGWAS-6574",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044033",
    "phenotype": "Iatrogenic hypotension (PheCode 458.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iatrogenic hypotension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044033"
  },
  {
    "accessionId": "DGWAS-6575",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044034",
    "phenotype": "Hypotension, not otherwise specified (PheCode 458.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypotension NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044034"
  },
  {
    "accessionId": "DGWAS-6576",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044035",
    "phenotype": "Circulatory disease NEC (PheCode 459.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circulatory disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044035"
  },
  {
    "accessionId": "DGWAS-6577",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044039",
    "phenotype": "Acute sinusitis (PheCode 464)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute sinusitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044039"
  },
  {
    "accessionId": "DGWAS-6578",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044040",
    "phenotype": "Acute pharyngitis (PheCode 465.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pharyngitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044040"
  },
  {
    "accessionId": "DGWAS-6579",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044041",
    "phenotype": "Acute laryngitis and tracheitis (PheCode 465.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute laryngitis/tracheitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044041"
  },
  {
    "accessionId": "DGWAS-6580",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044043",
    "phenotype": "Acute upper respiratory infections of multiple or unspecified sites (PheCode 465)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute upper respiratory infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044043"
  },
  {
    "accessionId": "DGWAS-6581",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044046",
    "phenotype": "Nasal polyps (PheCode 471)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nasal polyp",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044046"
  },
  {
    "accessionId": "DGWAS-6582",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044047",
    "phenotype": "Chronic pharyngitis and nasopharyngitis (PheCode 472)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pharyngitis/nasopharyngitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044047"
  },
  {
    "accessionId": "DGWAS-6583",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044048",
    "phenotype": "Paralysis/spasm of vocal cords or larynx (PheCode 473.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vocal cord paralysis/spasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044048"
  },
  {
    "accessionId": "DGWAS-6584",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044049",
    "phenotype": "Voice disturbance (PheCode 473.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Voice disturbance",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044049"
  },
  {
    "accessionId": "DGWAS-6585",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044050",
    "phenotype": "Diseases of the larynx and vocal cords (PheCode 473)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Larynx/vocal cord disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044050"
  },
  {
    "accessionId": "DGWAS-6586",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044051",
    "phenotype": "Acute tonsillitis (PheCode 474.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute tonsillitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044051"
  },
  {
    "accessionId": "DGWAS-6587",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044052",
    "phenotype": "Chronic tonsillitis and adenoiditis (PheCode 474.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic tonsillitis/adenoiditis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044052"
  },
  {
    "accessionId": "DGWAS-6588",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044053",
    "phenotype": "Acute and chronic tonsillitis (PheCode 474)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsillitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044053"
  },
  {
    "accessionId": "DGWAS-6589",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044054",
    "phenotype": "Chronic sinusitis (PheCode 475)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic sinusitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044054"
  },
  {
    "accessionId": "DGWAS-6590",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044055",
    "phenotype": "Epistaxis or throat hemorrhage (PheCode 477)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epistaxis/throat hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044055"
  },
  {
    "accessionId": "DGWAS-6591",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044056",
    "phenotype": "Throat pain (PheCode 478)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Throat pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044056"
  },
  {
    "accessionId": "DGWAS-6592",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044058",
    "phenotype": "Other upper respiratory disease (PheCode 479)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper respiratory disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044058"
  },
  {
    "accessionId": "DGWAS-6593",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044059",
    "phenotype": "Pneumococcal pneumonia (PheCode 480.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumococcal pneumonia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044059"
  },
  {
    "accessionId": "DGWAS-6594",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044060",
    "phenotype": "Bacterial pneumonia (PheCode 480.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial pneumonia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044060"
  },
  {
    "accessionId": "DGWAS-6595",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044061",
    "phenotype": "Bronchopneumonia and lung abscess (PheCode 480.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchopneumonia/lung abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044061"
  },
  {
    "accessionId": "DGWAS-6596",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044067",
    "phenotype": "Pneumonia (PheCode 480)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044067"
  },
  {
    "accessionId": "DGWAS-6597",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044068",
    "phenotype": "Influenza (PheCode 481)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Influenza",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044068"
  },
  {
    "accessionId": "DGWAS-6598",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044069",
    "phenotype": "Acute bronchitis and bronchiolitis (PheCode 483)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute bronchitis/bronchiolitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044069"
  },
  {
    "accessionId": "DGWAS-6599",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044071",
    "phenotype": "Asthma with exacerbation (PheCode 495.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma with exacerbation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044071"
  },
  {
    "accessionId": "DGWAS-6600",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044072",
    "phenotype": "Asthma (PheCode 495)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044072"
  },
  {
    "accessionId": "DGWAS-6601",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044073",
    "phenotype": "Emphysema (PheCode 496.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044073"
  },
  {
    "accessionId": "DGWAS-6602",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044074",
    "phenotype": "Obstructive chronic bronchitis (PheCode 496.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic obstructive bronchitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044074"
  },
  {
    "accessionId": "DGWAS-6603",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044075",
    "phenotype": "Bronchiectasis (PheCode 496.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchiectasis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044075"
  },
  {
    "accessionId": "DGWAS-6604",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044076",
    "phenotype": "Chronic airway obstruction (PheCode 496)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044076"
  },
  {
    "accessionId": "DGWAS-6605",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044077",
    "phenotype": "Bronchitis (PheCode 497)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044077"
  },
  {
    "accessionId": "DGWAS-6606",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044078",
    "phenotype": "Pneumonitis due to inhalation of food or vomitus (PheCode 501)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aspiration pneumonitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044078"
  },
  {
    "accessionId": "DGWAS-6607",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044079",
    "phenotype": "Postinflammatory pulmonary fibrosis (PheCode 502)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postinflammatory pulmonary fibrosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044079"
  },
  {
    "accessionId": "DGWAS-6608",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044080",
    "phenotype": "Pulmonary congestion and hypostasis (PheCode 503)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary congestion/hypostasis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044080"
  },
  {
    "accessionId": "DGWAS-6609",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044081",
    "phenotype": "Other alveolar and parietoalveolar pneumonopathy (PheCode 504)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alveolar pneumonopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044081"
  },
  {
    "accessionId": "DGWAS-6610",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044082",
    "phenotype": "Empyema and pneumothorax (PheCode 506)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Empyema/pneumothorax",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044082"
  },
  {
    "accessionId": "DGWAS-6611",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044083",
    "phenotype": "Pleurisy; pleural effusion (PheCode 507)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pleurisy/pleural effusion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044083"
  },
  {
    "accessionId": "DGWAS-6612",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044084",
    "phenotype": "Pulmonary collapse; interstitial and compensatory emphysema (PheCode 508)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary collapse/emphysema",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044084"
  },
  {
    "accessionId": "DGWAS-6613",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044085",
    "phenotype": "Respiratory failure (PheCode 509.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory failure",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044085"
  },
  {
    "accessionId": "DGWAS-6614",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044086",
    "phenotype": "Respiratory insufficiency (PheCode 509.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory insufficiency",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044086"
  },
  {
    "accessionId": "DGWAS-6615",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044087",
    "phenotype": "Other diseases of lung (PheCode 510)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044087"
  },
  {
    "accessionId": "DGWAS-6616",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044088",
    "phenotype": "Painful respiration (PheCode 512.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Painful respiration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044088"
  },
  {
    "accessionId": "DGWAS-6617",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044089",
    "phenotype": "Shortness of breath (PheCode 512.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shortness of breath",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044089"
  },
  {
    "accessionId": "DGWAS-6618",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044090",
    "phenotype": "Cough (PheCode 512.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cough",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044090"
  },
  {
    "accessionId": "DGWAS-6619",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044091",
    "phenotype": "Other dyspnea (PheCode 512.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dyspnea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044091"
  },
  {
    "accessionId": "DGWAS-6620",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044092",
    "phenotype": "Hyperventilation (PheCode 513.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperventilation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044092"
  },
  {
    "accessionId": "DGWAS-6621",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044093",
    "phenotype": "Abnormal findings examination of lungs (PheCode 514)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abnormal lung exam",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044093"
  },
  {
    "accessionId": "DGWAS-6622",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044094",
    "phenotype": "Hemoptysis (PheCode 516.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hemoptysis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044094"
  },
  {
    "accessionId": "DGWAS-6623",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044095",
    "phenotype": "Other diseases of respiratory system, NEC (PheCode 519.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044095"
  },
  {
    "accessionId": "DGWAS-6624",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044096",
    "phenotype": "Symptoms involving respiratory system and other chest symptoms (PheCode 519.9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Respiratory/chest symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044096"
  },
  {
    "accessionId": "DGWAS-6625",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044098",
    "phenotype": "Dental caries (PheCode 521.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044098"
  },
  {
    "accessionId": "DGWAS-6626",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044099",
    "phenotype": "Periapical abscess (PheCode 522.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Periapical abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044099"
  },
  {
    "accessionId": "DGWAS-6627",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044100",
    "phenotype": "Diseases of pulp and periapical tissues (PheCode 522)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulp/periapical disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044100"
  },
  {
    "accessionId": "DGWAS-6628",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044101",
    "phenotype": "Acute periodontitis (PheCode 523.31)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute periodontitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044101"
  },
  {
    "accessionId": "DGWAS-6629",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044102",
    "phenotype": "Chronic periodontitis (PheCode 523.32)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic periodontitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044102"
  },
  {
    "accessionId": "DGWAS-6630",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044103",
    "phenotype": "Gingival and periodontal diseases (PheCode 523)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gingival/periodontal disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044103"
  },
  {
    "accessionId": "DGWAS-6631",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044104",
    "phenotype": "Anomalies of tooth position/malocclusion (PheCode 524.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malocclusion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044104"
  },
  {
    "accessionId": "DGWAS-6632",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044105",
    "phenotype": "Other diseases of the teeth and supporting structures (PheCode 525)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental/supporting disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044105"
  },
  {
    "accessionId": "DGWAS-6633",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044106",
    "phenotype": "Cysts of the jaws (PheCode 526.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044106"
  },
  {
    "accessionId": "DGWAS-6634",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044107",
    "phenotype": "Temporomandibular joint disorder, unspecified (PheCode 526.41)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "TMD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044107"
  },
  {
    "accessionId": "DGWAS-6635",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044108",
    "phenotype": "Jaw disease, not otherwise specified (PheCode 526.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaw disease NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044108"
  },
  {
    "accessionId": "DGWAS-6636",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044109",
    "phenotype": "Sialoadenitis (PheCode 527.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sialoadenitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044109"
  },
  {
    "accessionId": "DGWAS-6637",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044110",
    "phenotype": "Other specified diseases of the salivary glands (PheCode 527.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salivary gland disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044110"
  },
  {
    "accessionId": "DGWAS-6638",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044111",
    "phenotype": "Stomatitis and mucositis (ulcerative) (PheCode 528.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomatitis/mucositis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044111"
  },
  {
    "accessionId": "DGWAS-6639",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044112",
    "phenotype": "Cellulitis and abscess of oral soft tissues (PheCode 528.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044112"
  },
  {
    "accessionId": "DGWAS-6640",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044113",
    "phenotype": "Cyst of the salivary gland (PheCode 528.41)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salivary gland cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044113"
  },
  {
    "accessionId": "DGWAS-6641",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044114",
    "phenotype": "Diseases of lips (PheCode 528.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lip disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044114"
  },
  {
    "accessionId": "DGWAS-6642",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044115",
    "phenotype": "Leukoplakia of oral mucosa (PheCode 528.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral leukoplakia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044115"
  },
  {
    "accessionId": "DGWAS-6643",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044116",
    "phenotype": "Sialolithiasis (PheCode 528.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Salivary stone",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044116"
  },
  {
    "accessionId": "DGWAS-6644",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044117",
    "phenotype": "Diseases of the oral soft tissues, excluding lesions specific for gingiva and tongue (PheCode 528)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral soft tissue disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044117"
  },
  {
    "accessionId": "DGWAS-6645",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044118",
    "phenotype": "Glossitis (PheCode 529.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glossitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044118"
  },
  {
    "accessionId": "DGWAS-6646",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044119",
    "phenotype": "Diseases and other conditions of the tongue (PheCode 529)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tongue disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044119"
  },
  {
    "accessionId": "DGWAS-6647",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044120",
    "phenotype": "GERD (PheCode 530.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GERD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044120"
  },
  {
    "accessionId": "DGWAS-6648",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044121",
    "phenotype": "Ulcer of esophagus (PheCode 530.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044121"
  },
  {
    "accessionId": "DGWAS-6649",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044122",
    "phenotype": "Reflux esophagitis (PheCode 530.14)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Reflux esophagitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044122"
  },
  {
    "accessionId": "DGWAS-6650",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044123",
    "phenotype": "Esophagitis, GERD and related diseases (PheCode 530.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophagitis/GERD",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044123"
  },
  {
    "accessionId": "DGWAS-6651",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044124",
    "phenotype": "Esophageal bleeding (varices/hemorrhage) (PheCode 530.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal bleeding",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044124"
  },
  {
    "accessionId": "DGWAS-6652",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044125",
    "phenotype": "Stricture and stenosis of esophagus (PheCode 530.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal stricture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044125"
  },
  {
    "accessionId": "DGWAS-6653",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044126",
    "phenotype": "Disorders of esophageal motility (PheCode 530.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal motility disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044126"
  },
  {
    "accessionId": "DGWAS-6654",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044127",
    "phenotype": "Gastroesophageal laceration-hemorrhage syndrome (PheCode 530.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mallory-Weiss syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044127"
  },
  {
    "accessionId": "DGWAS-6655",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044128",
    "phenotype": "Heartburn (PheCode 530.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heartburn",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044128"
  },
  {
    "accessionId": "DGWAS-6656",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044129",
    "phenotype": "Diseases of esophagus (PheCode 530)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044129"
  },
  {
    "accessionId": "DGWAS-6657",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044130",
    "phenotype": "Hemorrhage from gastrointestinal ulcer (PheCode 531.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GI ulcer hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044130"
  },
  {
    "accessionId": "DGWAS-6658",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044131",
    "phenotype": "Gastric ulcer (PheCode 531.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastric ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044131"
  },
  {
    "accessionId": "DGWAS-6659",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044132",
    "phenotype": "Duodenal ulcer (PheCode 531.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Duodenal ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044132"
  },
  {
    "accessionId": "DGWAS-6660",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044133",
    "phenotype": "Peptic ulcer, site unspecified (PheCode 531.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peptic ulcer NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044133"
  },
  {
    "accessionId": "DGWAS-6661",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044134",
    "phenotype": "Dysphagia (PheCode 532)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dysphagia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044134"
  },
  {
    "accessionId": "DGWAS-6662",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044135",
    "phenotype": "Acute gastritis (PheCode 535.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute gastritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044135"
  },
  {
    "accessionId": "DGWAS-6663",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044136",
    "phenotype": "Atrophic gastritis (PheCode 535.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrophic gastritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044136"
  },
  {
    "accessionId": "DGWAS-6664",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044137",
    "phenotype": "Duodenitis (PheCode 535.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Duodenitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044137"
  },
  {
    "accessionId": "DGWAS-6665",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044138",
    "phenotype": "Other specified gastritis (PheCode 535.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastritis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044138"
  },
  {
    "accessionId": "DGWAS-6666",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044139",
    "phenotype": "Gastritis and duodenitis (PheCode 535)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastritis/duodenitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044139"
  },
  {
    "accessionId": "DGWAS-6667",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044140",
    "phenotype": "Other disorders of stomach and duodenum (PheCode 537)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomach/duodenal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044140"
  },
  {
    "accessionId": "DGWAS-6668",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044141",
    "phenotype": "Acute appendicitis (PheCode 540.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute appendicitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044141"
  },
  {
    "accessionId": "DGWAS-6669",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044142",
    "phenotype": "Appendicitis (PheCode 540.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendicitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044142"
  },
  {
    "accessionId": "DGWAS-6670",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044143",
    "phenotype": "Appendiceal conditions (PheCode 540)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendiceal condition",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044143"
  },
  {
    "accessionId": "DGWAS-6673",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044147",
    "phenotype": "Inguinal hernia (PheCode 550.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inguinal hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044147"
  },
  {
    "accessionId": "DGWAS-6674",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044148",
    "phenotype": "Diaphragmatic hernia (PheCode 550.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diaphragmatic hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044148"
  },
  {
    "accessionId": "DGWAS-6675",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044149",
    "phenotype": "Femoral hernia (PheCode 550.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044149"
  },
  {
    "accessionId": "DGWAS-6676",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044150",
    "phenotype": "Umbilical hernia (PheCode 550.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Umbilical hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044150"
  },
  {
    "accessionId": "DGWAS-6677",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044151",
    "phenotype": "Ventral hernia (PheCode 550.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ventral hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044151"
  },
  {
    "accessionId": "DGWAS-6678",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044152",
    "phenotype": "Abdominal hernia (PheCode 550)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal hernia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044152"
  },
  {
    "accessionId": "DGWAS-6679",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044153",
    "phenotype": "Regional enteritis (PheCode 555.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Regional enteritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044153"
  },
  {
    "accessionId": "DGWAS-6680",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044154",
    "phenotype": "Ulcerative colitis (chronic) (PheCode 555.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis (chronic)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044154"
  },
  {
    "accessionId": "DGWAS-6681",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044155",
    "phenotype": "Ulcerative colitis (PheCode 555.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044155"
  },
  {
    "accessionId": "DGWAS-6682",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044156",
    "phenotype": "Ulceration of intestine (PheCode 556.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal ulceration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044156"
  },
  {
    "accessionId": "DGWAS-6683",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044157",
    "phenotype": "Ulceration of the lower GI tract (PheCode 556)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower GI ulceration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044157"
  },
  {
    "accessionId": "DGWAS-6684",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044158",
    "phenotype": "Celiac disease (PheCode 557.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Celiac disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044158"
  },
  {
    "accessionId": "DGWAS-6685",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044159",
    "phenotype": "Intestinal malabsorption (non-celiac) (PheCode 557)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal malabsorption",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044159"
  },
  {
    "accessionId": "DGWAS-6686",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044160",
    "phenotype": "Noninfectious gastroenteritis (PheCode 558)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious gastroenteritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044160"
  },
  {
    "accessionId": "DGWAS-6687",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044162",
    "phenotype": "Impaction of intestine (PheCode 560.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal impaction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044162"
  },
  {
    "accessionId": "DGWAS-6688",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044165",
    "phenotype": "Diarrhea (PheCode 561.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diarrhea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044165"
  },
  {
    "accessionId": "DGWAS-6689",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044166",
    "phenotype": "Flatulence (PheCode 561.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Flatulence",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044166"
  },
  {
    "accessionId": "DGWAS-6690",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044170",
    "phenotype": "Symptoms involving digestive system (PheCode 561)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Digestive symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044170"
  },
  {
    "accessionId": "DGWAS-6691",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044171",
    "phenotype": "Diverticulosis (PheCode 562.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diverticulosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044171"
  },
  {
    "accessionId": "DGWAS-6692",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044172",
    "phenotype": "Constipation (PheCode 563)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Constipation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044172"
  },
  {
    "accessionId": "DGWAS-6693",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044173",
    "phenotype": "Irritable Bowel Syndrome (PheCode 564.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "IBS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044173"
  },
  {
    "accessionId": "DGWAS-6694",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044175",
    "phenotype": "Personal history of diseases of digestive system (PheCode 564.9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Personal history of digestive disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044175"
  },
  {
    "accessionId": "DGWAS-6695",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044176",
    "phenotype": "Functional digestive disorders (PheCode 564)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Functional digestive disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044176"
  },
  {
    "accessionId": "DGWAS-6696",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044177",
    "phenotype": "Anal and rectal polyp (PheCode 565.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal/rectal polyp",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044177"
  },
  {
    "accessionId": "DGWAS-6697",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044178",
    "phenotype": "Anal and rectal conditions (PheCode 565)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal/rectal condition",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044178"
  },
  {
    "accessionId": "DGWAS-6698",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044181",
    "phenotype": "Peritonitis and retroperitoneal infections (PheCode 567)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritonitis/retroperitoneal infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044181"
  },
  {
    "accessionId": "DGWAS-6699",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044182",
    "phenotype": "Peritoneal adhesions (postoperative) (postinfection) (PheCode 568.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal adhesions",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044182"
  },
  {
    "accessionId": "DGWAS-6700",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044183",
    "phenotype": "Toxic gastroenteritis and colitis (PheCode 569.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toxic gastroenteritis/colitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044183"
  },
  {
    "accessionId": "DGWAS-6701",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044184",
    "phenotype": "Gastrointestinal complications (PheCode 569.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GI complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044184"
  },
  {
    "accessionId": "DGWAS-6702",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044185",
    "phenotype": "Other disorders of intestine (PheCode 569)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044185"
  },
  {
    "accessionId": "DGWAS-6703",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044186",
    "phenotype": "Cirrhosis of liver without mention of alcohol (PheCode 571.51)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-alcoholic cirrhosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044186"
  },
  {
    "accessionId": "DGWAS-6704",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044187",
    "phenotype": "Other chronic nonalcoholic liver disease (PheCode 571.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic nonalcoholic liver disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044187"
  },
  {
    "accessionId": "DGWAS-6705",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044188",
    "phenotype": "Primary biliary cirrhosis (PheCode 571.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary biliary cirrhosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044188"
  },
  {
    "accessionId": "DGWAS-6706",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044189",
    "phenotype": "Liver abscess and sequelae of chronic liver disease (PheCode 571.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver abscess/sequelae",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044189"
  },
  {
    "accessionId": "DGWAS-6707",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044190",
    "phenotype": "Ascites (non malignant) (PheCode 572)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ascites",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044190"
  },
  {
    "accessionId": "DGWAS-6708",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044191",
    "phenotype": "Jaundice (not of newborn) (PheCode 573.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Jaundice",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044191"
  },
  {
    "accessionId": "DGWAS-6709",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044192",
    "phenotype": "Abnormal results of function study of liver (PheCode 573.7)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abnormal liver function test",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044192"
  },
  {
    "accessionId": "DGWAS-6710",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044193",
    "phenotype": "Other disorders of liver (PheCode 573)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044193"
  },
  {
    "accessionId": "DGWAS-6711",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044194",
    "phenotype": "Cholelithiasis with acute cholecystitis (PheCode 574.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholelithiasis with acute cholecystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044194"
  },
  {
    "accessionId": "DGWAS-6712",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044195",
    "phenotype": "Cholelithiasis with other cholecystitis (PheCode 574.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholelithiasis with cholecystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044195"
  },
  {
    "accessionId": "DGWAS-6713",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044196",
    "phenotype": "Cholelithiasis (PheCode 574.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholelithiasis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044196"
  },
  {
    "accessionId": "DGWAS-6714",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044197",
    "phenotype": "Calculus of bile duct (PheCode 574.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bile duct stone",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044197"
  },
  {
    "accessionId": "DGWAS-6715",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044198",
    "phenotype": "Cholecystitis without cholelithiasis (PheCode 574.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholecystitis without stones",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044198"
  },
  {
    "accessionId": "DGWAS-6716",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044199",
    "phenotype": "Cholangitis (PheCode 575.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholangitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044199"
  },
  {
    "accessionId": "DGWAS-6717",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044200",
    "phenotype": "Obstruction of bile duct (PheCode 575.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bile duct obstruction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044200"
  },
  {
    "accessionId": "DGWAS-6718",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044201",
    "phenotype": "Other disorders of gallbladder (PheCode 575.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044201"
  },
  {
    "accessionId": "DGWAS-6719",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044202",
    "phenotype": "Other disorders of biliary tract (PheCode 575.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Biliary tract disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044202"
  },
  {
    "accessionId": "DGWAS-6720",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044203",
    "phenotype": "Nonspecific abnormal findings on radiological and other examination of biliary tract (PheCode 575.9)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abnormal biliary tract exam",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044203"
  },
  {
    "accessionId": "DGWAS-6721",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044204",
    "phenotype": "Acute pancreatitis (PheCode 577.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute pancreatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044204"
  },
  {
    "accessionId": "DGWAS-6722",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044205",
    "phenotype": "Chronic pancreatitis (PheCode 577.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pancreatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044205"
  },
  {
    "accessionId": "DGWAS-6723",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044206",
    "phenotype": "Cyst and pseudocyst of pancreas (PheCode 577.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cyst/pseudocyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044206"
  },
  {
    "accessionId": "DGWAS-6724",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044207",
    "phenotype": "Diseases of pancreas (PheCode 577)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044207"
  },
  {
    "accessionId": "DGWAS-6725",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044208",
    "phenotype": "Hematemesis (PheCode 578.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hematemesis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044208"
  },
  {
    "accessionId": "DGWAS-6726",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044209",
    "phenotype": "Blood in stool (PheCode 578.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood in stool",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044209"
  },
  {
    "accessionId": "DGWAS-6727",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044210",
    "phenotype": "Hemorrhage of rectum and anus (PheCode 578.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal/anal hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044210"
  },
  {
    "accessionId": "DGWAS-6728",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044211",
    "phenotype": "Hemorrhage of gastrointestinal tract (PheCode 578.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GI hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044211"
  },
  {
    "accessionId": "DGWAS-6729",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044213",
    "phenotype": "Other symptoms involving abdomen and pelvis (PheCode 579)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abdominal/pelvic symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044213"
  },
  {
    "accessionId": "DGWAS-6730",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044214",
    "phenotype": "Nephrotic syndrome without mention of glomerulonephritis (PheCode 580.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nephrotic syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044214"
  },
  {
    "accessionId": "DGWAS-6731",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044221",
    "phenotype": "Acute renal failure (PheCode 585.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute renal failure",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044221"
  },
  {
    "accessionId": "DGWAS-6732",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044222",
    "phenotype": "Renal failure, not otherwise specified (PheCode 585.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal failure NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044222"
  },
  {
    "accessionId": "DGWAS-6733",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044223",
    "phenotype": "Chronic renal failure [CKD] (PheCode 585.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic kidney disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044223"
  },
  {
    "accessionId": "DGWAS-6734",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044227",
    "phenotype": "Cyst of kidney, acquired (PheCode 586.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired renal cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044227"
  },
  {
    "accessionId": "DGWAS-6735",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044228",
    "phenotype": "Stricture/obstruction of ureter (PheCode 586.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ureteric stricture/obstruction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044228"
  },
  {
    "accessionId": "DGWAS-6736",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044229",
    "phenotype": "Other disorders of the kidney and ureters (PheCode 586)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney/ureter disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044229"
  },
  {
    "accessionId": "DGWAS-6737",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044230",
    "phenotype": "Pyelonephritis (PheCode 590)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyelonephritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044230"
  },
  {
    "accessionId": "DGWAS-6738",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044231",
    "phenotype": "Urinary tract infection (PheCode 591)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "UTI",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044231"
  },
  {
    "accessionId": "DGWAS-6739",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044232",
    "phenotype": "Acute cystitis (PheCode 592.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute cystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044232"
  },
  {
    "accessionId": "DGWAS-6740",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044233",
    "phenotype": "Chronic cystitis (PheCode 592.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic cystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044233"
  },
  {
    "accessionId": "DGWAS-6741",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044234",
    "phenotype": "Chronic interstitial cystitis (PheCode 592.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic interstitial cystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044234"
  },
  {
    "accessionId": "DGWAS-6742",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044235",
    "phenotype": "Cystitis (PheCode 592.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044235"
  },
  {
    "accessionId": "DGWAS-6743",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044236",
    "phenotype": "Hematuria (PheCode 593)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hematuria",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044236"
  },
  {
    "accessionId": "DGWAS-6744",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044237",
    "phenotype": "Calculus of kidney (PheCode 594.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney stone",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044237"
  },
  {
    "accessionId": "DGWAS-6745",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044238",
    "phenotype": "Calculus of lower urinary tract (PheCode 594.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower urinary tract stone",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044238"
  },
  {
    "accessionId": "DGWAS-6746",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044239",
    "phenotype": "Calculus of ureter (PheCode 594.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ureteric stone",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044239"
  },
  {
    "accessionId": "DGWAS-6747",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044240",
    "phenotype": "Renal colic (PheCode 594.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal colic",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044240"
  },
  {
    "accessionId": "DGWAS-6748",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044241",
    "phenotype": "Urinary calculus (PheCode 594)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary calculus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044241"
  },
  {
    "accessionId": "DGWAS-6749",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044242",
    "phenotype": "Hydronephrosis (PheCode 595)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydronephrosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044242"
  },
  {
    "accessionId": "DGWAS-6750",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044243",
    "phenotype": "Bladder neck obstruction (PheCode 596.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder neck obstruction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044243"
  },
  {
    "accessionId": "DGWAS-6751",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044244",
    "phenotype": "Functional disorders of bladder (PheCode 596.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Functional bladder disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044244"
  },
  {
    "accessionId": "DGWAS-6752",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044245",
    "phenotype": "Other disorders of bladder (PheCode 596)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044245"
  },
  {
    "accessionId": "DGWAS-6753",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044246",
    "phenotype": "Urethral stricture (not specified as infectious) (PheCode 597.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urethral stricture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044246"
  },
  {
    "accessionId": "DGWAS-6754",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044247",
    "phenotype": "Other disorders of urethra and urinary tract (PheCode 597)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urethral/urinary tract disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044247"
  },
  {
    "accessionId": "DGWAS-6755",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044248",
    "phenotype": "Abnormal findings on examination of urine (PheCode 598)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Abnormal urine exam",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044248"
  },
  {
    "accessionId": "DGWAS-6756",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044249",
    "phenotype": "Urinary obstruction (PheCode 599.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary obstruction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044249"
  },
  {
    "accessionId": "DGWAS-6757",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044250",
    "phenotype": "Retention of urine (PheCode 599.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary retention",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044250"
  },
  {
    "accessionId": "DGWAS-6758",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044251",
    "phenotype": "Dysuria (PheCode 599.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dysuria",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044251"
  },
  {
    "accessionId": "DGWAS-6759",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044252",
    "phenotype": "Urinary incontinence (PheCode 599.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary incontinence",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044252"
  },
  {
    "accessionId": "DGWAS-6760",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044253",
    "phenotype": "Frequency of urination and polyuria (PheCode 599.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyuria/frequent urination",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044253"
  },
  {
    "accessionId": "DGWAS-6761",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044254",
    "phenotype": "Other abnormality of urination (PheCode 599.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urination abnormality",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044254"
  },
  {
    "accessionId": "DGWAS-6762",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044256",
    "phenotype": "Other symptoms/disorders or the urinary system (PheCode 599)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary system disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044256"
  },
  {
    "accessionId": "DGWAS-6763",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044257",
    "phenotype": "Hyperplasia of prostate (PheCode 600)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign prostatic hyperplasia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044257"
  },
  {
    "accessionId": "DGWAS-6764",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044258",
    "phenotype": "Acute prostatitis (PheCode 601.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute prostatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044258"
  },
  {
    "accessionId": "DGWAS-6765",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044259",
    "phenotype": "Chronic prostatitis (PheCode 601.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic prostatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044259"
  },
  {
    "accessionId": "DGWAS-6766",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044260",
    "phenotype": "Prostatitis (PheCode 601.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044260"
  },
  {
    "accessionId": "DGWAS-6767",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044261",
    "phenotype": "Balanoposthitis (PheCode 601.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Balanoposthitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044261"
  },
  {
    "accessionId": "DGWAS-6768",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044262",
    "phenotype": "Other inflammatory disorders of male genital organs (PheCode 601.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital inflammation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044262"
  },
  {
    "accessionId": "DGWAS-6770",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044271",
    "phenotype": "Other disorders of prostate (PheCode 602)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044271"
  },
  {
    "accessionId": "DGWAS-6771",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044272",
    "phenotype": "Hydrocele (PheCode 603.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocele",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044272"
  },
  {
    "accessionId": "DGWAS-6772",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044274",
    "phenotype": "Other disorders of testis (PheCode 603)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044274"
  },
  {
    "accessionId": "DGWAS-6773",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044275",
    "phenotype": "Redundant prepuce and phimosis/BXO (PheCode 604.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phimosis/BXO",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044275"
  },
  {
    "accessionId": "DGWAS-6774",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044276",
    "phenotype": "Disorders of penis (PheCode 604)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Penile disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044276"
  },
  {
    "accessionId": "DGWAS-6775",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044277",
    "phenotype": "Erectile dysfunction [ED] (PheCode 605)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erectile dysfunction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044277"
  },
  {
    "accessionId": "DGWAS-6776",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044278",
    "phenotype": "Other disorders of male genital organs (PheCode 608)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044278"
  },
  {
    "accessionId": "DGWAS-6777",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044280",
    "phenotype": "Cystic mastopathy (PheCode 610.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cystic mastopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044280"
  },
  {
    "accessionId": "DGWAS-6778",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044281",
    "phenotype": "Fibroadenosis of breast (PheCode 610.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibroadenosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044281"
  },
  {
    "accessionId": "DGWAS-6779",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044282",
    "phenotype": "Fibrosclerosis of breast (PheCode 610.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast fibrosclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044282"
  },
  {
    "accessionId": "DGWAS-6780",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044283",
    "phenotype": "Benign neoplasm of breast (PheCode 610.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign breast neoplasm",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044283"
  },
  {
    "accessionId": "DGWAS-6781",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044284",
    "phenotype": "Other specified benign mammary dysplasias (PheCode 610.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign breast dysplasia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044284"
  },
  {
    "accessionId": "DGWAS-6782",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044285",
    "phenotype": "Lump or mass in breast (PheCode 611.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast lump",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044285"
  },
  {
    "accessionId": "DGWAS-6783",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044286",
    "phenotype": "Hypertrophy of breast (Gynecomastia) (PheCode 612.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gynecomastia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044286"
  },
  {
    "accessionId": "DGWAS-6784",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044287",
    "phenotype": "Inflammatory disease of breast (PheCode 613.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mastitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044287"
  },
  {
    "accessionId": "DGWAS-6785",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044288",
    "phenotype": "Other signs and symptoms in breast (PheCode 613.7)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Breast symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044288"
  },
  {
    "accessionId": "DGWAS-6786",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044289",
    "phenotype": "Other specified disorders of breast (PheCode 613.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044289"
  },
  {
    "accessionId": "DGWAS-6787",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044290",
    "phenotype": "Breast disorder, not otherwise specified (PheCode 613.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044290"
  },
  {
    "accessionId": "DGWAS-6788",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044298",
    "phenotype": "Pelvic peritoneal adhesions, female (postoperative) (postinfection) (PheCode 614.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female pelvic adhesions",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044298"
  },
  {
    "accessionId": "DGWAS-6789",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044299",
    "phenotype": "Chronic inflammatory pelvic disease (PheCode 614.32)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic PID",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044299"
  },
  {
    "accessionId": "DGWAS-6790",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044300",
    "phenotype": "Pelvic inflammatory disease, not otherwise specified (PheCode 614.33)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "PID NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044300"
  },
  {
    "accessionId": "DGWAS-6791",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044301",
    "phenotype": "Inflammatory diseases of uterus, except cervix (PheCode 614.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine inflammation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044301"
  },
  {
    "accessionId": "DGWAS-6792",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044302",
    "phenotype": "Cervicitis and endocervicitis (PheCode 614.51)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044302"
  },
  {
    "accessionId": "DGWAS-6793",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044303",
    "phenotype": "Vaginitis and vulvovaginitis (PheCode 614.52)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044303"
  },
  {
    "accessionId": "DGWAS-6794",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044304",
    "phenotype": "Cyst or abscess of Bartholin's gland (PheCode 614.53)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bartholin cyst/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044304"
  },
  {
    "accessionId": "DGWAS-6795",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044305",
    "phenotype": "Abscess or ulceration of vulva (PheCode 614.54)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar abscess/ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044305"
  },
  {
    "accessionId": "DGWAS-6796",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044306",
    "phenotype": "Inflammatory disease of cervix, vagina, and vulva (PheCode 614.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower genital tract inflammation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044306"
  },
  {
    "accessionId": "DGWAS-6797",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044330",
    "phenotype": "Reason for glasses/contact lenses: For a 'squint' or 'turn' in an eye since childhood (called 'strabismus') (UKB data field 6147_5)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Strabismus (reason for glasses)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044330"
  },
  {
    "accessionId": "DGWAS-6798",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044331",
    "phenotype": "Reason for glasses/contact lenses: For a 'lazy' eye or an eye with poor vision since childhood (called 'amblyopia') (UKB data field 6147_6)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Amblyopia (reason for glasses)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044331"
  },
  {
    "accessionId": "DGWAS-6799",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044333",
    "phenotype": "Eye problems/disorders: Diabetes related eye disease (UKB data field 6148_1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic eye disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044333"
  },
  {
    "accessionId": "DGWAS-6800",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044334",
    "phenotype": "Eye problems/disorders: PHESANT recoding (UKB data field 6148_100)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye problem (PHESANT)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044334"
  },
  {
    "accessionId": "DGWAS-6801",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044335",
    "phenotype": "Eye problems/disorders: Glaucoma (UKB data field 6148_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044335"
  },
  {
    "accessionId": "DGWAS-6802",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044337",
    "phenotype": "Eye problems/disorders: Cataract (UKB data field 6148_4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cataract",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044337"
  },
  {
    "accessionId": "DGWAS-6803",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044338",
    "phenotype": "Eye problems/disorders: Macular degeneration (UKB data field 6148_5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular degeneration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044338"
  },
  {
    "accessionId": "DGWAS-6804",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044342",
    "phenotype": "Mouth/teeth dental problems: Painful gums (UKB data field 6149_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gum pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044342"
  },
  {
    "accessionId": "DGWAS-6805",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044343",
    "phenotype": "Mouth/teeth dental problems: Bleeding gums (UKB data field 6149_3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bleeding gums",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044343"
  },
  {
    "accessionId": "DGWAS-6806",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044344",
    "phenotype": "Mouth/teeth dental problems: Loose teeth (UKB data field 6149_4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Loose teeth",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044344"
  },
  {
    "accessionId": "DGWAS-6807",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044345",
    "phenotype": "Mouth/teeth dental problems: Toothache (UKB data field 6149_5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toothache",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044345"
  },
  {
    "accessionId": "DGWAS-6808",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044347",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Heart attack (UKB data field 6150_1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart attack",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044347"
  },
  {
    "accessionId": "DGWAS-6809",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044348",
    "phenotype": "Vascular/heart problems diagnosed by doctor: PHESANT recoding (UKB data field 6150_100)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vascular/heart problem (PHESANT)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044348"
  },
  {
    "accessionId": "DGWAS-6810",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044349",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Angina (UKB data field 6150_2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angina",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044349"
  },
  {
    "accessionId": "DGWAS-6811",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044350",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Stroke (UKB data field 6150_3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044350"
  },
  {
    "accessionId": "DGWAS-6812",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044351",
    "phenotype": "Vascular/heart problems diagnosed by doctor: High blood pressure (UKB data field 6150_4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertension",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044351"
  },
  {
    "accessionId": "DGWAS-6813",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044360",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Blood clot in the leg (DVT) (UKB data field 6152_5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044360"
  },
  {
    "accessionId": "DGWAS-6814",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044361",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Emphysema/chronic bronchitis (UKB data field 6152_6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema/chronic bronchitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044361"
  },
  {
    "accessionId": "DGWAS-6815",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044362",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Blood clot in the lung (UKB data field 6152_7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary embolism",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044362"
  },
  {
    "accessionId": "DGWAS-6816",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044363",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Asthma (UKB data field 6152_8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044363"
  },
  {
    "accessionId": "DGWAS-6817",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044364",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Hayfever, allergic rhinitis or eczema (UKB data field 6152_9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hay fever/allergic rhinitis/eczema",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044364"
  },
  {
    "accessionId": "DGWAS-6818",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044411",
    "phenotype": "Endometriosis (PheCode 615)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044411"
  },
  {
    "accessionId": "DGWAS-6819",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044440",
    "phenotype": "Disorders secondary to childbirth, surgery, trauma (PheCode 617)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary female genital disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044440"
  },
  {
    "accessionId": "DGWAS-6820",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044441",
    "phenotype": "Prolapse of vaginal walls (PheCode 618.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal wall prolapse",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044441"
  },
  {
    "accessionId": "DGWAS-6821",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044442",
    "phenotype": "Uterine/Uterovaginal prolapse (PheCode 618.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine/vaginal prolapse",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044442"
  },
  {
    "accessionId": "DGWAS-6822",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044443",
    "phenotype": "Prolapse of vaginal vault after hysterectomy (PheCode 618.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal vault prolapse",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044443"
  },
  {
    "accessionId": "DGWAS-6823",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044444",
    "phenotype": "Vaginal enterocele, congenital or acquired (PheCode 618.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal enterocele",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044444"
  },
  {
    "accessionId": "DGWAS-6824",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044445",
    "phenotype": "Genital prolapse (PheCode 618)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genital prolapse",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044445"
  },
  {
    "accessionId": "DGWAS-6825",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044446",
    "phenotype": "Noninflammatory disorders of ovary, fallopian tube, and broad ligament (PheCode 619.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninflammatory adnexal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044446"
  },
  {
    "accessionId": "DGWAS-6826",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044447",
    "phenotype": "Disorders of uterus, NEC (PheCode 619.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044447"
  },
  {
    "accessionId": "DGWAS-6827",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044449",
    "phenotype": "Noninflammatory disorders of vagina (PheCode 619.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vaginal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044449"
  },
  {
    "accessionId": "DGWAS-6828",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044450",
    "phenotype": "Noninflammatory disorders of vulva and perineum (PheCode 619.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vulvar/perineal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044450"
  },
  {
    "accessionId": "DGWAS-6829",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044451",
    "phenotype": "Noninflammatory female genital disorders (PheCode 619)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninflammatory female genital disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044451"
  },
  {
    "accessionId": "DGWAS-6830",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044452",
    "phenotype": "Endometrial hyperplasia (PheCode 621)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometrial hyperplasia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044452"
  },
  {
    "accessionId": "DGWAS-6831",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044453",
    "phenotype": "Polyp of corpus uteri (PheCode 622.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine corpus polyp",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044453"
  },
  {
    "accessionId": "DGWAS-6832",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044454",
    "phenotype": "Mucous polyp of cervix (PheCode 622.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical polyp",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044454"
  },
  {
    "accessionId": "DGWAS-6833",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044455",
    "phenotype": "Polyp of female genital organs (PheCode 622)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital polyp",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044455"
  },
  {
    "accessionId": "DGWAS-6834",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044456",
    "phenotype": "Hypertrophy of female genital organs (PheCode 623)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital hypertrophy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044456"
  },
  {
    "accessionId": "DGWAS-6835",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044457",
    "phenotype": "Dystrophy of female genital tract (PheCode 624.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital tract dystrophy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044457"
  },
  {
    "accessionId": "DGWAS-6836",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044458",
    "phenotype": "stress incontinence, female (PheCode 624.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female stress incontinence",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044458"
  },
  {
    "accessionId": "DGWAS-6837",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044459",
    "phenotype": "Dyspareunia (PheCode 625.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dyspareunia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044459"
  },
  {
    "accessionId": "DGWAS-6838",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044460",
    "phenotype": "Pain and other symptoms associated with female genital organs (PheCode 625)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Female genital pain/symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044460"
  },
  {
    "accessionId": "DGWAS-6839",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044461",
    "phenotype": "Excessive or frequent menstruation (PheCode 626.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menorrhagia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044461"
  },
  {
    "accessionId": "DGWAS-6840",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044462",
    "phenotype": "Irregular menstrual cycle (PheCode 626.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Irregular menstrual cycle",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044462"
  },
  {
    "accessionId": "DGWAS-6841",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044463",
    "phenotype": "Irregular menstrual bleeding (PheCode 626.14)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Irregular menstrual bleeding",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044463"
  },
  {
    "accessionId": "DGWAS-6842",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044464",
    "phenotype": "Irregular menstrual cycle/bleeding (PheCode 626.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menstrual irregularity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044464"
  },
  {
    "accessionId": "DGWAS-6843",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044465",
    "phenotype": "Dysmenorrhea (PheCode 626.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dysmenorrhea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044465"
  },
  {
    "accessionId": "DGWAS-6844",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044466",
    "phenotype": "Infertility, female (PheCode 626.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female infertility",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044466"
  },
  {
    "accessionId": "DGWAS-6845",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044467",
    "phenotype": "Disorders of menstruation and other abnormal bleeding from female genital tract (PheCode 626)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menstrual/bleeding disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044467"
  },
  {
    "accessionId": "DGWAS-6846",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044468",
    "phenotype": "Postmenopausal bleeding (PheCode 627.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmenopausal bleeding",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044468"
  },
  {
    "accessionId": "DGWAS-6847",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044469",
    "phenotype": "Symptomatic menopause (PheCode 627.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Symptomatic menopause",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044469"
  },
  {
    "accessionId": "DGWAS-6848",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044470",
    "phenotype": "Postmenopausal atrophic vaginitis (PheCode 627.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postmenopausal atrophic vaginitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044470"
  },
  {
    "accessionId": "DGWAS-6849",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044471",
    "phenotype": "Premenopausal menorrhagia (PheCode 627.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Premenopausal menorrhagia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044471"
  },
  {
    "accessionId": "DGWAS-6850",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044472",
    "phenotype": "Menopausal and postmenopausal disorders (PheCode 627)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Menopausal/postmenopausal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044472"
  },
  {
    "accessionId": "DGWAS-6851",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044473",
    "phenotype": "Ovarian cyst (PheCode 628)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044473"
  },
  {
    "accessionId": "DGWAS-6852",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044474",
    "phenotype": "Missed abortion/Hydatidiform mole (PheCode 634.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydatidiform mole",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044474"
  },
  {
    "accessionId": "DGWAS-6853",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044475",
    "phenotype": "Ectopic pregnancy (PheCode 634.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectopic pregnancy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044475"
  },
  {
    "accessionId": "DGWAS-6854",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044476",
    "phenotype": "Miscarriage; stillbirth (PheCode 634)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Miscarriage/stillbirth",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044476"
  },
  {
    "accessionId": "DGWAS-6855",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044477",
    "phenotype": "Antepartum hemorrhage, abruptio placentae, and placenta previa (PheCode 635.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Antepartum hemorrhage/abruptio/placenta previa",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044477"
  },
  {
    "accessionId": "DGWAS-6856",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044478",
    "phenotype": "Hemorrhage in early pregnancy (PheCode 636.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early pregnancy hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044478"
  },
  {
    "accessionId": "DGWAS-6857",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044479",
    "phenotype": "Preeclampsia and eclampsia (PheCode 642.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia/eclampsia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044479"
  },
  {
    "accessionId": "DGWAS-6858",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044480",
    "phenotype": "Hyperemesis gravidarum (PheCode 643.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperemesis gravidarum",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044480"
  },
  {
    "accessionId": "DGWAS-6859",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044481",
    "phenotype": "Late pregnancy and failed induction (PheCode 645)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Late pregnancy/failed induction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044481"
  },
  {
    "accessionId": "DGWAS-6860",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044482",
    "phenotype": "Other complications of pregnancy NEC (PheCode 646)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044482"
  },
  {
    "accessionId": "DGWAS-6861",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044483",
    "phenotype": "Infections of genitourinary tract during pregnancy (PheCode 647.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy GU infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044483"
  },
  {
    "accessionId": "DGWAS-6862",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044484",
    "phenotype": "Diabetes or abnormal glucose tolerance complicating pregnancy (PheCode 649.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational diabetes",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044484"
  },
  {
    "accessionId": "DGWAS-6863",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044485",
    "phenotype": "Multiple gestation (PheCode 651)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple gestation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044485"
  },
  {
    "accessionId": "DGWAS-6864",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044486",
    "phenotype": "Malposition and malpresentation of fetus or obstruction (PheCode 652)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Malpresentation/obstruction",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044486"
  },
  {
    "accessionId": "DGWAS-6865",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044487",
    "phenotype": "Known or suspected fetal abnormality affecting management of mother (PheCode 655)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fetal abnormality affecting mother",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044487"
  },
  {
    "accessionId": "DGWAS-6866",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044488",
    "phenotype": "Fetal distress and abnormal forces of labor (PheCode 661)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fetal distress/abnormal labor forces",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044488"
  },
  {
    "accessionId": "DGWAS-6867",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044489",
    "phenotype": "Complications of labor and delivery NEC (PheCode 669)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labor/delivery complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044489"
  },
  {
    "accessionId": "DGWAS-6868",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044494",
    "phenotype": "Other complications of the puerperium NEC (PheCode 674)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Puerperal complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044494"
  },
  {
    "accessionId": "DGWAS-6869",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044495",
    "phenotype": "Cellulitis and abscess of fingers/toes (PheCode 681.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Finger/toe cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044495"
  },
  {
    "accessionId": "DGWAS-6870",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044496",
    "phenotype": "Cellulitis and abscess of face/neck (PheCode 681.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Face/neck cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044496"
  },
  {
    "accessionId": "DGWAS-6871",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044497",
    "phenotype": "Cellulitis and abscess of arm/hand (PheCode 681.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arm/hand cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044497"
  },
  {
    "accessionId": "DGWAS-6872",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044498",
    "phenotype": "Cellulitis and abscess of leg, except foot (PheCode 681.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leg cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044498"
  },
  {
    "accessionId": "DGWAS-6873",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044499",
    "phenotype": "Cellulitis and abscess of foot, toe (PheCode 681.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Foot/toe cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044499"
  },
  {
    "accessionId": "DGWAS-6874",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044500",
    "phenotype": "Cellulitis and abscess of trunk (PheCode 681.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Truncal cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044500"
  },
  {
    "accessionId": "DGWAS-6875",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044501",
    "phenotype": "Superficial cellulitis and abscess (PheCode 681)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Superficial cellulitis/abscess",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044501"
  },
  {
    "accessionId": "DGWAS-6876",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044502",
    "phenotype": "Carbuncle and furuncle (PheCode 686.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carbuncle/furuncle",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044502"
  },
  {
    "accessionId": "DGWAS-6877",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044503",
    "phenotype": "Pilonidal cyst (PheCode 686.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pilonidal cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044503"
  },
  {
    "accessionId": "DGWAS-6878",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044504",
    "phenotype": "Pyogenic granuloma (PheCode 686.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic granuloma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044504"
  },
  {
    "accessionId": "DGWAS-6879",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044505",
    "phenotype": "Other local infections of skin and subcutaneous tissue (PheCode 686)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Local skin infection",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044505"
  },
  {
    "accessionId": "DGWAS-6880",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044506",
    "phenotype": "Rash and other nonspecific skin eruption (PheCode 687.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rash/skin eruption",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044506"
  },
  {
    "accessionId": "DGWAS-6881",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044509",
    "phenotype": "Disorder of skin and subcutaneous tissue, not otherwise specified (PheCode 689)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044509"
  },
  {
    "accessionId": "DGWAS-6882",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044510",
    "phenotype": "Other dyschromia (PheCode 694.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dyschromia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044510"
  },
  {
    "accessionId": "DGWAS-6883",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044511",
    "phenotype": "Rosacea (PheCode 695.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rosacea",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044511"
  },
  {
    "accessionId": "DGWAS-6884",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044512",
    "phenotype": "Systemic lupus erythematosus (PheCode 695.42)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "SLE",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044512"
  },
  {
    "accessionId": "DGWAS-6885",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044513",
    "phenotype": "Prurigo and Lichen (PheCode 695.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prurigo/lichen",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044513"
  },
  {
    "accessionId": "DGWAS-6886",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044514",
    "phenotype": "Unspecified erythematous condition (PheCode 695.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Erythematous condition NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044514"
  },
  {
    "accessionId": "DGWAS-6887",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044515",
    "phenotype": "Psoriasis vulgaris (PheCode 696.41)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis vulgaris",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044515"
  },
  {
    "accessionId": "DGWAS-6888",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044516",
    "phenotype": "Psoriatic arthropathy (PheCode 696.42)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriatic arthritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044516"
  },
  {
    "accessionId": "DGWAS-6889",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044517",
    "phenotype": "Psoriasis (PheCode 696.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044517"
  },
  {
    "accessionId": "DGWAS-6890",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044518",
    "phenotype": "Sarcoidosis (PheCode 697)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoidosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044518"
  },
  {
    "accessionId": "DGWAS-6891",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044519",
    "phenotype": "Pruritus and related conditions (PheCode 698)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pruritus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044519"
  },
  {
    "accessionId": "DGWAS-6892",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044520",
    "phenotype": "Corns and callosities (PheCode 700)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corns/callosities",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044520"
  },
  {
    "accessionId": "DGWAS-6893",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044521",
    "phenotype": "Scar conditions and fibrosis of skin (PheCode 701.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin scar/fibrosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044521"
  },
  {
    "accessionId": "DGWAS-6894",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044522",
    "phenotype": "Keloid scar (PheCode 701.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Keloid scar",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044522"
  },
  {
    "accessionId": "DGWAS-6895",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044523",
    "phenotype": "Abnormal granulation tissue (PheCode 701.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abnormal granulation tissue",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044523"
  },
  {
    "accessionId": "DGWAS-6896",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044525",
    "phenotype": "Actinic keratosis (PheCode 702.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Actinic keratosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044525"
  },
  {
    "accessionId": "DGWAS-6897",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044526",
    "phenotype": "Seborrheic keratosis (PheCode 702.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seborrheic keratosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044526"
  },
  {
    "accessionId": "DGWAS-6898",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044527",
    "phenotype": "Ingrowing nail (PheCode 703.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ingrown nail",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044527"
  },
  {
    "accessionId": "DGWAS-6899",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044528",
    "phenotype": "Diseases of nail, not otherwise specified (PheCode 703)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nail disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044528"
  },
  {
    "accessionId": "DGWAS-6900",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044529",
    "phenotype": "Diseases of hair and hair follicles (PheCode 704)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hair/follicle disease",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044529"
  },
  {
    "accessionId": "DGWAS-6901",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044530",
    "phenotype": "Hidradenitis (PheCode 705.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hidradenitis suppurativa",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044530"
  },
  {
    "accessionId": "DGWAS-6902",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044531",
    "phenotype": "Hyperhidrosis (PheCode 705.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hyperhidrosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044531"
  },
  {
    "accessionId": "DGWAS-6903",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044532",
    "phenotype": "Sebaceous cyst (PheCode 706.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sebaceous cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044532"
  },
  {
    "accessionId": "DGWAS-6904",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044533",
    "phenotype": "Chronic ulcer of skin (PheCode 707)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic skin ulcer",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044533"
  },
  {
    "accessionId": "DGWAS-6905",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044534",
    "phenotype": "Sicca syndrome (PheCode 709.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sjogren syndrome",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044534"
  },
  {
    "accessionId": "DGWAS-6906",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044535",
    "phenotype": "Systemic sclerosis (PheCode 709.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic sclerosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044535"
  },
  {
    "accessionId": "DGWAS-6907",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044536",
    "phenotype": "Unspecified diffuse connective tissue disease (PheCode 709.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diffuse CTD NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044536"
  },
  {
    "accessionId": "DGWAS-6908",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044537",
    "phenotype": "Chronic osteomyelitis (PheCode 710.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic osteomyelitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044537"
  },
  {
    "accessionId": "DGWAS-6909",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044538",
    "phenotype": "Unspecified osteomyelitis (PheCode 710.19)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteomyelitis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044538"
  },
  {
    "accessionId": "DGWAS-6910",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044539",
    "phenotype": "Pyogenic arthritis (PheCode 711.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic arthritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044539"
  },
  {
    "accessionId": "DGWAS-6911",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044540",
    "phenotype": "Rheumatoid arthritis (PheCode 714.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatoid arthritis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044540"
  },
  {
    "accessionId": "DGWAS-6912",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044541",
    "phenotype": "Rheumatoid arthritis and other inflammatory polyarthropathies (PheCode 714)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inflammatory polyarthropathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044541"
  },
  {
    "accessionId": "DGWAS-6913",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044542",
    "phenotype": "Ankylosing spondylitis (PheCode 715.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankylosing spondylitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044542"
  },
  {
    "accessionId": "DGWAS-6914",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044543",
    "phenotype": "Other inflammatory spondylopathies (PheCode 715)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Inflammatory spondylopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044543"
  },
  {
    "accessionId": "DGWAS-6915",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044544",
    "phenotype": "Unspecified monoarthritis (PheCode 716.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Monoarthritis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044544"
  },
  {
    "accessionId": "DGWAS-6916",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044545",
    "phenotype": "Arthropathy, not otherwise specified (PheCode 716.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthropathy NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044545"
  },
  {
    "accessionId": "DGWAS-6917",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044546",
    "phenotype": "Polymyalgia Rheumatica (PheCode 717)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polymyalgia rheumatica",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044546"
  },
  {
    "accessionId": "DGWAS-6918",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044547",
    "phenotype": "Spinal stenosis (PheCode 720)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal stenosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044547"
  },
  {
    "accessionId": "DGWAS-6919",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044548",
    "phenotype": "Spondylosis without myelopathy (PheCode 721.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylosis without myelopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044548"
  },
  {
    "accessionId": "DGWAS-6920",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044549",
    "phenotype": "Spondylosis with myelopathy (PheCode 721.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylosis with myelopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044549"
  },
  {
    "accessionId": "DGWAS-6921",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044550",
    "phenotype": "Other allied disorders of spine (PheCode 721.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other spinal disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044550"
  },
  {
    "accessionId": "DGWAS-6922",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044551",
    "phenotype": "Spondylosis and allied disorders (PheCode 721)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044551"
  },
  {
    "accessionId": "DGWAS-6923",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044552",
    "phenotype": "Displacement of intervertebral disc (PheCode 722.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc displacement",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044552"
  },
  {
    "accessionId": "DGWAS-6924",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044553",
    "phenotype": "Degeneration of intervertebral disc (PheCode 722.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc degeneration",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044553"
  },
  {
    "accessionId": "DGWAS-6925",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044554",
    "phenotype": "Intervertebral disc disorder with myelopathy (PheCode 722.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc disorder with myelopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044554"
  },
  {
    "accessionId": "DGWAS-6926",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044555",
    "phenotype": "Other and unspecified disc disorder (PheCode 722.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Disc disorder NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044555"
  },
  {
    "accessionId": "DGWAS-6927",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044558",
    "phenotype": "Enthesopathy (PheCode 726.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enthesopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044558"
  },
  {
    "accessionId": "DGWAS-6928",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044559",
    "phenotype": "Synoviopathy (PheCode 726.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synoviopathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044559"
  },
  {
    "accessionId": "DGWAS-6929",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044560",
    "phenotype": "Bursitis (PheCode 726.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bursitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044560"
  },
  {
    "accessionId": "DGWAS-6930",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044562",
    "phenotype": "Synovitis and tenosynovitis (PheCode 727.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovitis/tenosynovitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044562"
  },
  {
    "accessionId": "DGWAS-6931",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044563",
    "phenotype": "Ganglion and cyst of synovium, tendon, and bursa (PheCode 727.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ganglion/synovial cyst",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044563"
  },
  {
    "accessionId": "DGWAS-6932",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044564",
    "phenotype": "Rupture of synovium (PheCode 727.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovial rupture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044564"
  },
  {
    "accessionId": "DGWAS-6933",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044565",
    "phenotype": "Rupture of tendon, nontraumatic (PheCode 727.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontraumatic tendon rupture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044565"
  },
  {
    "accessionId": "DGWAS-6934",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044566",
    "phenotype": "Contracture of tendon (sheath) (PheCode 727.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tendon contracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044566"
  },
  {
    "accessionId": "DGWAS-6935",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044567",
    "phenotype": "Other disorders of synovium, tendon, and bursa (PheCode 727)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovium/tendon/bursa disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044567"
  },
  {
    "accessionId": "DGWAS-6936",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044568",
    "phenotype": "Laxity of ligament or hypermobility syndrome (PheCode 728.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ligament laxity/hypermobility",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044568"
  },
  {
    "accessionId": "DGWAS-6937",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044569",
    "phenotype": "Contracture of palmar fascia [Dupuytren's disease] (PheCode 728.71)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dupuytren contracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044569"
  },
  {
    "accessionId": "DGWAS-6938",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044570",
    "phenotype": "Fasciitis (PheCode 728.7)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fasciitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044570"
  },
  {
    "accessionId": "DGWAS-6939",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044571",
    "phenotype": "Rheumatism, unspecified and fibrositis (PheCode 729.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatism/fibrositis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044571"
  },
  {
    "accessionId": "DGWAS-6940",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044572",
    "phenotype": "Other disorders of soft tissues (PheCode 729)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Soft tissue disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044572"
  },
  {
    "accessionId": "DGWAS-6941",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044573",
    "phenotype": "Osteochondropathies (PheCode 732)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteochondropathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044573"
  },
  {
    "accessionId": "DGWAS-6942",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044574",
    "phenotype": "Aseptic necrosis of bone (PheCode 733.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aseptic bone necrosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044574"
  },
  {
    "accessionId": "DGWAS-6943",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044575",
    "phenotype": "Malunion and nonunion of fracture (PheCode 733.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fracture malunion/nonunion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044575"
  },
  {
    "accessionId": "DGWAS-6944",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044576",
    "phenotype": "Other disorders of bone and cartilage (PheCode 733)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone/cartilage disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044576"
  },
  {
    "accessionId": "DGWAS-6945",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044577",
    "phenotype": "Flat foot (PheCode 735.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Flat foot",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044577"
  },
  {
    "accessionId": "DGWAS-6946",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044578",
    "phenotype": "Hammer toe (acquired) (PheCode 735.21)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired hammer toe",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044578"
  },
  {
    "accessionId": "DGWAS-6947",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044579",
    "phenotype": "Hallux rigidus (PheCode 735.23)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux rigidus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044579"
  },
  {
    "accessionId": "DGWAS-6948",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044581",
    "phenotype": "Hallux valgus (Bunion) (PheCode 735.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux valgus",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044581"
  },
  {
    "accessionId": "DGWAS-6949",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044584",
    "phenotype": "Other acquired deformities of limbs (PheCode 736)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired limb deformity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044584"
  },
  {
    "accessionId": "DGWAS-6950",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044585",
    "phenotype": "Kyphoscoliosis and scoliosis (PheCode 737.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kyphoscoliosis/scoliosis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044585"
  },
  {
    "accessionId": "DGWAS-6951",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044586",
    "phenotype": "Acquired spondylolisthesis (PheCode 738.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired spondylolisthesis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044586"
  },
  {
    "accessionId": "DGWAS-6952",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044587",
    "phenotype": "Other acquired musculoskeletal deformity (PheCode 738)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acquired musculoskeletal deformity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044587"
  },
  {
    "accessionId": "DGWAS-6953",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044588",
    "phenotype": "Contracture of joint (PheCode 739)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint contracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044588"
  },
  {
    "accessionId": "DGWAS-6954",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044589",
    "phenotype": "Osteoarthrosis, localized, primary (PheCode 740.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary localized OA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044589"
  },
  {
    "accessionId": "DGWAS-6955",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044590",
    "phenotype": "Osteoarthrosis, localized, secondary (PheCode 740.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary localized OA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044590"
  },
  {
    "accessionId": "DGWAS-6956",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044591",
    "phenotype": "Osteoarthritis; localized (PheCode 740.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Localized OA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044591"
  },
  {
    "accessionId": "DGWAS-6957",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044592",
    "phenotype": "Osteoarthrosis, generalized (PheCode 740.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized OA",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044592"
  },
  {
    "accessionId": "DGWAS-6958",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044593",
    "phenotype": "Osteoarthrosis, not otherwise specified (PheCode 740.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "OA NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044593"
  },
  {
    "accessionId": "DGWAS-6959",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044594",
    "phenotype": "Stiffness of joint (PheCode 741.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint stiffness",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044594"
  },
  {
    "accessionId": "DGWAS-6960",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044595",
    "phenotype": "Joint effusions (PheCode 741.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint effusion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044595"
  },
  {
    "accessionId": "DGWAS-6961",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044596",
    "phenotype": "Symptoms and disorders of the joints (PheCode 741)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint symptom/disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044596"
  },
  {
    "accessionId": "DGWAS-6962",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044597",
    "phenotype": "Loose body in joint (PheCode 742.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Loose joint body",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044597"
  },
  {
    "accessionId": "DGWAS-6963",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044598",
    "phenotype": "Articular cartilage disorder (PheCode 742.8)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Articular cartilage disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044598"
  },
  {
    "accessionId": "DGWAS-6964",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044599",
    "phenotype": "Other derangement of joint (PheCode 742.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint derangement NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044599"
  },
  {
    "accessionId": "DGWAS-6965",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044600",
    "phenotype": "Osteoporosis, not otherwise specified (PheCode 743.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoporosis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044600"
  },
  {
    "accessionId": "DGWAS-6966",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044601",
    "phenotype": "Osteopenia or other disorder of bone and cartilage (PheCode 743.9)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteopenia/bone disorder",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044601"
  },
  {
    "accessionId": "DGWAS-6967",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044603",
    "phenotype": "Cardiac shunt/ heart septal defect (PheCode 747.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac shunt/septal defect",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044603"
  },
  {
    "accessionId": "DGWAS-6968",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044604",
    "phenotype": "Congenital anomalies of great vessels (PheCode 747.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital great vessel anomaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044604"
  },
  {
    "accessionId": "DGWAS-6969",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044605",
    "phenotype": "Congenital anomalies of peripheral vascular system (PheCode 747.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital peripheral vascular anomaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044605"
  },
  {
    "accessionId": "DGWAS-6970",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044607",
    "phenotype": "Congenital anomalies of mouth/tongue (PheCode 750.13)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital mouth/tongue anomaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044607"
  },
  {
    "accessionId": "DGWAS-6971",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044608",
    "phenotype": "Congenital anomalies of female genital organs (PheCode 751.11)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital female genital anomaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044608"
  },
  {
    "accessionId": "DGWAS-6972",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044609",
    "phenotype": "Congenital anomalies of male genital organs (PheCode 751.12)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital male genital anomaly",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044609"
  },
  {
    "accessionId": "DGWAS-6973",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044610",
    "phenotype": "Congenital deformities of feet (PheCode 755.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital foot deformity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044610"
  },
  {
    "accessionId": "DGWAS-6974",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044611",
    "phenotype": "Congenital osteodystrophies (PheCode 756.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital osteodystrophy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044611"
  },
  {
    "accessionId": "DGWAS-6975",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044612",
    "phenotype": "Back pain (PheCode 760)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Back pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044612"
  },
  {
    "accessionId": "DGWAS-6976",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044613",
    "phenotype": "Cervicalgia (PheCode 761)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicalgia",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044613"
  },
  {
    "accessionId": "DGWAS-6977",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044614",
    "phenotype": "Sciatica (PheCode 764)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sciatica",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044614"
  },
  {
    "accessionId": "DGWAS-6978",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044615",
    "phenotype": "Cervical radiculitis (PheCode 765)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical radiculitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044615"
  },
  {
    "accessionId": "DGWAS-6979",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044616",
    "phenotype": "Neuralgia, neuritis, and radiculitis, not otherwise specified (PheCode 766)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neuralgia/neuritis/radiculitis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044616"
  },
  {
    "accessionId": "DGWAS-6980",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044617",
    "phenotype": "Myalgia and myositis unspecified (PheCode 770)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myalgia/myositis NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044617"
  },
  {
    "accessionId": "DGWAS-6981",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044619",
    "phenotype": "Musculoskeletal symptoms referable to limbs (PheCode 771)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Limb musculoskeletal symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044619"
  },
  {
    "accessionId": "DGWAS-6982",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044620",
    "phenotype": "Symptoms of the muscles (PheCode 772)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle symptom",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044620"
  },
  {
    "accessionId": "DGWAS-6983",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044623",
    "phenotype": "Edema (PheCode 782.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Edema",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044623"
  },
  {
    "accessionId": "DGWAS-6984",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044624",
    "phenotype": "Fever of unknown origin (PheCode 783)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fever of unknown origin",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044624"
  },
  {
    "accessionId": "DGWAS-6985",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044625",
    "phenotype": "Abdominal pain (PheCode 785)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal pain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044625"
  },
  {
    "accessionId": "DGWAS-6986",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044626",
    "phenotype": "Syncope and collapse (PheCode 788)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Syncope/collapse",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044626"
  },
  {
    "accessionId": "DGWAS-6987",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044627",
    "phenotype": "Nausea and vomiting (PheCode 789)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nausea/vomiting",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044627"
  },
  {
    "accessionId": "DGWAS-6988",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044629",
    "phenotype": "Gangrene (PheCode 791)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gangrene",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044629"
  },
  {
    "accessionId": "DGWAS-6989",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044632",
    "phenotype": "Fracture of neck of femur (PheCode 800.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femoral neck fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044632"
  },
  {
    "accessionId": "DGWAS-6990",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044633",
    "phenotype": "Fracture of unspecified part of femur (PheCode 800.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Femur fracture NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044633"
  },
  {
    "accessionId": "DGWAS-6991",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044634",
    "phenotype": "Fracture of tibia and fibula (PheCode 800.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tibia/fibula fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044634"
  },
  {
    "accessionId": "DGWAS-6992",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044635",
    "phenotype": "Fracture of patella (PheCode 800.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Patella fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044635"
  },
  {
    "accessionId": "DGWAS-6993",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044636",
    "phenotype": "Fracture of lower limb (PheCode 800)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044636"
  },
  {
    "accessionId": "DGWAS-6994",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044637",
    "phenotype": "Fracture of ankle and foot (PheCode 801)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankle/foot fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044637"
  },
  {
    "accessionId": "DGWAS-6995",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044638",
    "phenotype": "Fracture of pelvis (PheCode 802)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pelvis fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044638"
  },
  {
    "accessionId": "DGWAS-6996",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044639",
    "phenotype": "Fracture of humerus (PheCode 803.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Humerus fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044639"
  },
  {
    "accessionId": "DGWAS-6997",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044641",
    "phenotype": "Fracture of clavicle or scapula (PheCode 803.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Clavicle/scapula fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044641"
  },
  {
    "accessionId": "DGWAS-6998",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044642",
    "phenotype": "Fracture of upper limb (PheCode 803)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Upper limb fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044642"
  },
  {
    "accessionId": "DGWAS-6999",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044643",
    "phenotype": "Fracture of hand or wrist (PheCode 804)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hand/wrist fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044643"
  },
  {
    "accessionId": "DGWAS-7000",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044644",
    "phenotype": "Fracture of vertebral column without mention of spinal cord injury (PheCode 805)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vertebral fracture (no cord injury)",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044644"
  },
  {
    "accessionId": "DGWAS-7001",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044645",
    "phenotype": "Fracture of ribs (PheCode 807)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rib fracture",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044645"
  },
  {
    "accessionId": "DGWAS-7002",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044646",
    "phenotype": "Fracture of unspecified bones (PheCode 809)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bone fracture NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044646"
  },
  {
    "accessionId": "DGWAS-7003",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044647",
    "phenotype": "Concussion (PheCode 817)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Concussion",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044647"
  },
  {
    "accessionId": "DGWAS-7004",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044648",
    "phenotype": "Intracranial hemorrhage (injury) (PheCode 818)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic intracranial hemorrhage",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044648"
  },
  {
    "accessionId": "DGWAS-7005",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044649",
    "phenotype": "Skull and face fracture and other intercranial injury (PheCode 819)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skull/face fracture/intracranial injury",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044649"
  },
  {
    "accessionId": "DGWAS-7006",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044651",
    "phenotype": "Internal derangement of knee (PheCode 835)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Internal knee derangement",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044651"
  },
  {
    "accessionId": "DGWAS-7007",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044652",
    "phenotype": "Traumatic arthropathy (PheCode 836)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic arthropathy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044652"
  },
  {
    "accessionId": "DGWAS-7008",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044653",
    "phenotype": "Joint/ligament sprain (PheCode 840.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint/ligament sprain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044653"
  },
  {
    "accessionId": "DGWAS-7009",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044654",
    "phenotype": "Sprains and strains (PheCode 840)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sprain/strain",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044654"
  },
  {
    "accessionId": "DGWAS-7010",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044655",
    "phenotype": "Hemorrhage or hematoma complicating a procedure (PheCode 850)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural hemorrhage/hematoma",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044655"
  },
  {
    "accessionId": "DGWAS-7011",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044657",
    "phenotype": "Complication of colostomy or enterostomy (PheCode 853)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colostomy/enterostomy complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044657"
  },
  {
    "accessionId": "DGWAS-7012",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044658",
    "phenotype": "Complications of cardiac/vascular device, implant, and graft (PheCode 854)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac/vascular device complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044658"
  },
  {
    "accessionId": "DGWAS-7013",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044659",
    "phenotype": "Mechanical complication of unspecified genitourinary device, implant, and graft (PheCode 857)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GU device complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044659"
  },
  {
    "accessionId": "DGWAS-7014",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044660",
    "phenotype": "Complication of internal orthopedic device (PheCode 858)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Orthopedic device complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044660"
  },
  {
    "accessionId": "DGWAS-7015",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044662",
    "phenotype": "Open wound or laceration of eye or eyelid (PheCode 870.1)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/eyelid open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044662"
  },
  {
    "accessionId": "DGWAS-7016",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044663",
    "phenotype": "Open wound of ear (PheCode 870.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ear open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044663"
  },
  {
    "accessionId": "DGWAS-7017",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044664",
    "phenotype": "Other open wound of head and face (PheCode 870.3)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Head/face open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044664"
  },
  {
    "accessionId": "DGWAS-7018",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044665",
    "phenotype": "Open wound of nose and sinus (PheCode 870.4)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nose/sinus open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044665"
  },
  {
    "accessionId": "DGWAS-7019",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044666",
    "phenotype": "Open wound of lip and mouth (PheCode 870.5)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lip/mouth open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044666"
  },
  {
    "accessionId": "DGWAS-7020",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044667",
    "phenotype": "Open wound of neck (PheCode 870.6)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neck open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044667"
  },
  {
    "accessionId": "DGWAS-7021",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044668",
    "phenotype": "Open wounds of head; neck; and trunk (PheCode 870)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Head/neck/trunk open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044668"
  },
  {
    "accessionId": "DGWAS-7022",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044670",
    "phenotype": "Open wounds of extremities (PheCode 871)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Extremity open wound",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044670"
  },
  {
    "accessionId": "DGWAS-7023",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044671",
    "phenotype": "Traumatic amputation (PheCode 872)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic amputation",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044671"
  },
  {
    "accessionId": "DGWAS-7024",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044672",
    "phenotype": "Broken tooth (PheCode 873)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Broken tooth",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044672"
  },
  {
    "accessionId": "DGWAS-7025",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044673",
    "phenotype": "Complication of amputation stump (PheCode 874)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Amputation stump complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044673"
  },
  {
    "accessionId": "DGWAS-7026",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044676",
    "phenotype": "Toxic effect of venom (PheCode 913)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Venom toxicity",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044676"
  },
  {
    "accessionId": "DGWAS-7027",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044679",
    "phenotype": "Allergic reaction to food (PheCode 930)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Food allergy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044679"
  },
  {
    "accessionId": "DGWAS-7028",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044680",
    "phenotype": "Chronic dermatitis due to solar radiation (PheCode 938.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic solar dermatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044680"
  },
  {
    "accessionId": "DGWAS-7029",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044681",
    "phenotype": "Atopic/contact dermatitis due to other or unspecified (PheCode 939)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atopic/contact dermatitis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044681"
  },
  {
    "accessionId": "DGWAS-7030",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044682",
    "phenotype": "Anaphylactic shock, not otherwise specified (PheCode 946)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anaphylactic shock NOS",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044682"
  },
  {
    "accessionId": "DGWAS-7031",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044683",
    "phenotype": "Urticaria (PheCode 947)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urticaria",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044683"
  },
  {
    "accessionId": "DGWAS-7032",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044684",
    "phenotype": "Allergies, other (PheCode 949)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other allergy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044684"
  },
  {
    "accessionId": "DGWAS-7033",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044685",
    "phenotype": "Certain early complications of trauma or procedure (PheCode 958)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Early trauma/procedure complication",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044685"
  },
  {
    "accessionId": "DGWAS-7034",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044687",
    "phenotype": "Poisoning by analgesics, antipyretics, and antirheumatics (PheCode 965)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Analgesic/antipyretic/antirheumatic poisoning",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044687"
  },
  {
    "accessionId": "DGWAS-7035",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044689",
    "phenotype": "Poisoning by psychotropic agents (PheCode 969)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychotropic agent poisoning",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044689"
  },
  {
    "accessionId": "DGWAS-7036",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044690",
    "phenotype": "Poisoning by agents primarily affecting the cardiovascular system (PheCode 972)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiovascular agent poisoning",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044690"
  },
  {
    "accessionId": "DGWAS-7037",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044691",
    "phenotype": "Adverse drug events and drug allergies (PheCode 979)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adverse drug event/allergy",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044691"
  },
  {
    "accessionId": "DGWAS-7038",
    "sources": "GWAS catalog",
    "phenocode": "GCST90044692",
    "phenotype": "Sepsis (PheCode 994.2)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sepsis",
    "pmid": "34737426",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90044001-GCST90045000/GCST90044692"
  },
  {
    "accessionId": "DGWAS-7047",
    "sources": "GWAS catalog",
    "phenocode": "GCST90095084",
    "phenotype": "Intrahepatic cholestasis of pregnancy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intrahepatic cholestasis of pregnancy",
    "pmid": "35977952",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90095001-GCST90096000/GCST90095084"
  },
  {
    "accessionId": "DGWAS-7048",
    "sources": "GWAS catalog",
    "phenocode": "GCST90104003",
    "phenotype": "Familial combined hyperlipidemia defined by Brunzell criteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial combined hyperlipidemia (Brunzell)",
    "pmid": "34906840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104003"
  },
  {
    "accessionId": "DGWAS-7049",
    "sources": "GWAS catalog",
    "phenocode": "GCST90104004",
    "phenotype": "Familial combined hyperlipidemia defined by Goldstein criteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial combined hyperlipidemia (Goldstein)",
    "pmid": "34906840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104004"
  },
  {
    "accessionId": "DGWAS-7050",
    "sources": "GWAS catalog",
    "phenocode": "GCST90104005",
    "phenotype": "Familial combined hyperlipidemia defined by Dutch criteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial combined hyperlipidemia (Dutch)",
    "pmid": "34906840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104005"
  },
  {
    "accessionId": "DGWAS-7051",
    "sources": "GWAS catalog",
    "phenocode": "GCST90104006",
    "phenotype": "Familial combined hyperlipidemia defined by Consensus criteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial combined hyperlipidemia (Consensus)",
    "pmid": "34906840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104006"
  },
  {
    "accessionId": "DGWAS-7052",
    "sources": "GWAS catalog",
    "phenocode": "GCST90104007",
    "phenotype": "Familial combined hyperlipidemia defined by Mexico criteria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Familial combined hyperlipidemia (Mexico)",
    "pmid": "34906840",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90104001-GCST90105000/GCST90104007"
  },
  {
    "accessionId": "DGWAS-7060",
    "sources": "GWAS catalog",
    "phenocode": "GCST90128518",
    "phenotype": "Gallstone disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cholelithiasis",
    "pmid": "34651315",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90128001-GCST90129000/GCST90128518"
  },
  {
    "accessionId": "DGWAS-7061",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129428",
    "phenotype": "Arthrosis of first carpometacarpal joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "First CMC joint arthrosis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129428"
  },
  {
    "accessionId": "DGWAS-7062",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129429",
    "phenotype": "Arthrosis and/or arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthrosis/arthritis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129429"
  },
  {
    "accessionId": "DGWAS-7063",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129430",
    "phenotype": "Chronic back pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic back pain",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129430"
  },
  {
    "accessionId": "DGWAS-7066",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129433",
    "phenotype": "Crohn's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129433"
  },
  {
    "accessionId": "DGWAS-7070",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129438",
    "phenotype": "Enthesopathies, excluding lower limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Enthesopathy (non-lower limb)",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129438"
  },
  {
    "accessionId": "DGWAS-7072",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129440",
    "phenotype": "Gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastritis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129440"
  },
  {
    "accessionId": "DGWAS-7073",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129441",
    "phenotype": "Chronic widespread pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic widespread pain",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129441"
  },
  {
    "accessionId": "DGWAS-7075",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129443",
    "phenotype": "Chronic headache",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic headache",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129443"
  },
  {
    "accessionId": "DGWAS-7076",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129444",
    "phenotype": "Hip arthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip arthrosis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129444"
  },
  {
    "accessionId": "DGWAS-7077",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129445",
    "phenotype": "Chronic hip pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic hip pain",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129445"
  },
  {
    "accessionId": "DGWAS-7079",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129447",
    "phenotype": "Knee arthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee arthrosis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129447"
  },
  {
    "accessionId": "DGWAS-7081",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129452",
    "phenotype": "Esophagitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophagitis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129452"
  },
  {
    "accessionId": "DGWAS-7084",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129456",
    "phenotype": "Prostatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostatitis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129456"
  },
  {
    "accessionId": "DGWAS-7085",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129457",
    "phenotype": "Seropositive rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seropositive RA",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129457"
  },
  {
    "accessionId": "DGWAS-7086",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129459",
    "phenotype": "Ulcerative colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129459"
  },
  {
    "accessionId": "DGWAS-7087",
    "sources": "GWAS catalog",
    "phenocode": "GCST90129460",
    "phenotype": "Urinary colic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Renal colic",
    "pmid": "37219871",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90129001-GCST90130000/GCST90129460"
  },
  {
    "accessionId": "DGWAS-709",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_CMV_PNEUMONIA",
    "phenotype": "Cytomegaloviral pneumonitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CMV pneumonitis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_CMV_PNEUMONIA.gz"
  },
  {
    "accessionId": "DGWAS-7090",
    "sources": "GWAS catalog",
    "phenocode": "GCST90134279",
    "phenotype": "Osteoarthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoarthritis",
    "pmid": "36411363",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90134001-GCST90135000/GCST90134279"
  },
  {
    "accessionId": "DGWAS-7092",
    "sources": "GWAS catalog",
    "phenocode": "GCST90137411",
    "phenotype": "Basal cell carcinoma (MTAG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Basal cell carcinoma",
    "pmid": "36496446",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90137001-GCST90138000/GCST90137411"
  },
  {
    "accessionId": "DGWAS-7093",
    "sources": "GWAS catalog",
    "phenocode": "GCST90137412",
    "phenotype": "Squamous cell carcinoma (MTAG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Squamous cell carcinoma",
    "pmid": "36496446",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90137001-GCST90138000/GCST90137412"
  },
  {
    "accessionId": "DGWAS-7094",
    "sources": "GWAS catalog",
    "phenocode": "GCST90161240",
    "phenotype": "Hip fracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip fracture",
    "pmid": "36260985",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90161001-GCST90162000/GCST90161240"
  },
  {
    "accessionId": "DGWAS-7096",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225524",
    "phenotype": "ICD10 F40.2: Specific (isolated) phobias",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Specific phobia",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225524"
  },
  {
    "accessionId": "DGWAS-7097",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225525",
    "phenotype": "ICD10 F41.0: Panic disorder [episodic paroxysmal anxiety]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panic disorder",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225525"
  },
  {
    "accessionId": "DGWAS-7098",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225526",
    "phenotype": "ICD10 F41.2: Mixed anxiety and depressive disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed anxiety/depressive disorder",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225526"
  },
  {
    "accessionId": "DGWAS-7099",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225527",
    "phenotype": "ICD10 F41.9: Anxiety disorder, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder NOS",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225527"
  },
  {
    "accessionId": "DGWAS-7100",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225528",
    "phenotype": "ICD10 F40 F41 F42: any anxiety disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder (any)",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225528"
  },
  {
    "accessionId": "DGWAS-7101",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225529",
    "phenotype": "ICD10 F41: Other anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other anxiety disorder",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225529"
  },
  {
    "accessionId": "DGWAS-7102",
    "sources": "GWAS catalog",
    "phenocode": "GCST90225530",
    "phenotype": "ICD10 F40: Phobic anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Phobic anxiety disorder",
    "pmid": "37259642",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90225001-GCST90226000/GCST90225530"
  },
  {
    "accessionId": "DGWAS-7106",
    "sources": "GWAS catalog",
    "phenocode": "GCST90245818",
    "phenotype": "acne vulgaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acne vulgaris",
    "pmid": "36922633",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90245001-GCST90246000/GCST90245818"
  },
  {
    "accessionId": "DGWAS-7107",
    "sources": "GWAS catalog",
    "phenocode": "GCST90267361",
    "phenotype": "Sleep apnea syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea syndrome",
    "pmid": "36525587",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267361"
  },
  {
    "accessionId": "DGWAS-7108",
    "sources": "GWAS catalog",
    "phenocode": "GCST90267362",
    "phenotype": "Sleep apnea (MTAG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea",
    "pmid": "36525587",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267362"
  },
  {
    "accessionId": "DGWAS-7109",
    "sources": "GWAS catalog",
    "phenocode": "GCST90267363",
    "phenotype": "Sleep apnea (adjusted for BMI)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea (BMI-adjusted)",
    "pmid": "36525587",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267363"
  },
  {
    "accessionId": "DGWAS-7110",
    "sources": "GWAS catalog",
    "phenocode": "GCST90267364",
    "phenotype": "Sleep apnea (MTAG) (adjusted for BMI)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea (MTAG, BMI-adjusted)",
    "pmid": "36525587",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90267001-GCST90268000/GCST90267364"
  },
  {
    "accessionId": "DGWAS-7112",
    "sources": "GWAS catalog",
    "phenocode": "GCST90268400",
    "phenotype": "Central serous chorioretinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Central serous chorioretinopathy",
    "pmid": "37079300",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90268001-GCST90269000/GCST90268400"
  },
  {
    "accessionId": "DGWAS-7125",
    "sources": "GWAS catalog",
    "phenocode": "GCST90271713",
    "phenotype": "Raynauds phenomenon disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Raynaud phenomenon",
    "pmid": "37828025",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271713"
  },
  {
    "accessionId": "DGWAS-7126",
    "sources": "GWAS catalog",
    "phenocode": "GCST90271714",
    "phenotype": "Primary Raynaud's phenomenon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary Raynaud phenomenon",
    "pmid": "37828025",
    "download": "http://ftp.ebi.ac.uk/pub/databases/gwas/summary_statistics/GCST90271001-GCST90272000/GCST90271714"
  },
  {
    "accessionId": "DGWAS-746",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Z21_LUNG_TRANSPLANT_STATUS",
    "phenotype": "Lung transplant status",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lung transplant status",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Z21_LUNG_TRANSPLANT_STATUS.gz"
  },
  {
    "accessionId": "DGWAS-762",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CONGEN_MALFO_GREAT_VEINS",
    "phenotype": "Congenital malformations of great veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital great vein malformation",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CONGEN_MALFO_GREAT_VEINS.gz"
  },
  {
    "accessionId": "DGWAS-764",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_Q17_CLEFT_LIP_OR_LIP_AND_PALATE",
    "phenotype": "Cleft lip and cleft lip and palate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cleft lip/palate",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_Q17_CLEFT_LIP_OR_LIP_AND_PALATE.gz"
  },
  {
    "accessionId": "DGWAS-874",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_MN_PROGN",
    "phenotype": "Mandibular prognathia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mandibular prognathia",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_MN_PROGN.gz"
  },
  {
    "accessionId": "DGWAS-880",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_ERUPTION",
    "phenotype": "Tooth eruption problems",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tooth eruption problem",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_ERUPTION.gz"
  },
  {
    "accessionId": "DGWAS-885",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CARIES_2_OPER_ONLYAVO",
    "phenotype": "Dental caries 2 and operation codes, only avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries (avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CARIES_2_OPER_ONLYAVO.gz"
  },
  {
    "accessionId": "DGWAS-886",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_K11_CARIES_1_OPER_ONLYAVO",
    "phenotype": "Dental caries 1 and operation codes, only avohilmo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dental caries (avohilmo)",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_K11_CARIES_1_OPER_ONLYAVO.gz"
  },
  {
    "accessionId": "DGWAS-918",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_H8_OTORRHOEA",
    "phenotype": "Otorrhoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otorrhea",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_H8_OTORRHOEA.gz"
  },
  {
    "accessionId": "DGWAS-993",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_METABONAS",
    "phenotype": "Metabolic disorder, other/unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metabolic disorder NOS",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_METABONAS.gz"
  },
  {
    "accessionId": "DGWAS-994",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_LIPOMATOSIS",
    "phenotype": "Lipomatosis, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lipomatosis",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_LIPOMATOSIS.gz"
  },
  {
    "accessionId": "DGWAS-995",
    "sources": "finngenR10",
    "phenocode": "finngen_R10_E4_LACTOCON",
    "phenotype": "Congenital lactase deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital lactase deficiency",
    "pmid": "",
    "download": "https://storage.googleapis.com/finngen-public-data-r10/summary_stats/finngen_R10_E4_LACTOCON.gz"
  },
  {
    "accessionId": "is_female_ukb",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "is_female_ukb",
    "phenotype": "Inferred genetic sex",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Demographic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/is_female.gwas.imputed_v3.tsv.bgz -O is_female.gwas.imputed_v3.tsv.bgz"
  },
  {
    "accessionId": "age_ukb",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "age_ukb",
    "phenotype": "Age at recruitment",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Demographic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/age.gwas.imputed_v3.both_sexes.tsv.bgz -O age.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100001_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100001",
    "phenotype": "Food weight",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – quantity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100001_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100001_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100002_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100002",
    "phenotype": "Energy",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100002_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100002_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100003_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100003",
    "phenotype": "Protein",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100003_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100003_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100004_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100004",
    "phenotype": "Fat",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100004_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100004_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100005_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100005",
    "phenotype": "Carbohydrate",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100005_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100005_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100006_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100006",
    "phenotype": "Saturated fat",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100006_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100006_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100007_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100007",
    "phenotype": "Polyunsaturated fat",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100008_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100008",
    "phenotype": "Total sugars",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – macronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100008_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100008_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100009_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100009",
    "phenotype": "Englyst dietary fibre",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – carbohydrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100009_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100009_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100010",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100010",
    "phenotype": "Portion size",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – quantity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100010.gwas.imputed_v3.both_sexes.tsv.bgz -O 100010.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100011_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100011",
    "phenotype": "Iron",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient (mineral)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100011_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100011_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100012_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100012",
    "phenotype": "Vitamin B6",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100012_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100012_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100013_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100013",
    "phenotype": "Vitamin B12",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100013_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100013_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100014_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100014",
    "phenotype": "Folate",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100014_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100014_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100015_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100015",
    "phenotype": "Vitamin C",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100015_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100015_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100016_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100016",
    "phenotype": "Potassium",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient (mineral)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100016_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100016_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100017_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100017",
    "phenotype": "Magnesium",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient (mineral)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100017_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100017_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100018_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100018",
    "phenotype": "Retinol",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100018_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100018_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100019_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100019",
    "phenotype": "Carotene",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100019_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100019_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100021_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100021",
    "phenotype": "Vitamin D",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100022",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100022",
    "phenotype": "Alcohol",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100022.gwas.imputed_v3.both_sexes.tsv.bgz -O 100022.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100023_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100023",
    "phenotype": "Starch",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – carbohydrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100023_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100023_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100024_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100024",
    "phenotype": "Calcium",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient (mineral)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100024_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100024_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100025_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100025",
    "phenotype": "Vitamin E",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – micronutrient ",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100025_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 100025_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1001",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1001",
    "phenotype": "Duration of strenuous sports",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1001.gwas.imputed_v3.both_sexes.tsv.bgz -O 1001.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100150",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100150",
    "phenotype": "Drinking water intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100150.gwas.imputed_v3.both_sexes.tsv.bgz -O 100150.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100160",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100160",
    "phenotype": "Low calorie drink intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100160.gwas.imputed_v3.both_sexes.tsv.bgz -O 100160.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100170",
    "phenotype": "Fizzy drink intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100170.gwas.imputed_v3.both_sexes.tsv.bgz -O 100170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100190",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100190",
    "phenotype": "Orange juice intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100190.gwas.imputed_v3.both_sexes.tsv.bgz -O 100190.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100240",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100240",
    "phenotype": "Coffee consumed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100240.gwas.imputed_v3.both_sexes.tsv.bgz -O 100240.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100250",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100250",
    "phenotype": "Instant coffee intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100250.gwas.imputed_v3.both_sexes.tsv.bgz -O 100250.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100260",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100260",
    "phenotype": "Added milk to instant coffee",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (additive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100260.gwas.imputed_v3.both_sexes.tsv.bgz -O 100260.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100270",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100270",
    "phenotype": "Filtered coffee intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100270.gwas.imputed_v3.both_sexes.tsv.bgz -O 100270.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100280",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100280",
    "phenotype": "Added milk to filtered coffee",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (additive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100280.gwas.imputed_v3.both_sexes.tsv.bgz -O 100280.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100360",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100360",
    "phenotype": "Decaffeinated coffee",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100360.gwas.imputed_v3.both_sexes.tsv.bgz -O 100360.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100370",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100370",
    "phenotype": "Intake of sugar added to coffee",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (additive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100370.gwas.imputed_v3.both_sexes.tsv.bgz -O 100370.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100390",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100390",
    "phenotype": "Tea consumed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100390.gwas.imputed_v3.both_sexes.tsv.bgz -O 100390.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100400",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100400",
    "phenotype": "Standard tea intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100400.gwas.imputed_v3.both_sexes.tsv.bgz -O 100400.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100460",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100460",
    "phenotype": "Added milk to standard tea",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (additive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100460.gwas.imputed_v3.both_sexes.tsv.bgz -O 100460.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100520",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100520",
    "phenotype": "Milk intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100520.gwas.imputed_v3.both_sexes.tsv.bgz -O 100520.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100580",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100580",
    "phenotype": "Alcohol consumed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100580.gwas.imputed_v3.both_sexes.tsv.bgz -O 100580.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100590",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100590",
    "phenotype": "Red wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100590.gwas.imputed_v3.both_sexes.tsv.bgz -O 100590.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100630",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100630",
    "phenotype": "Rose wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100630.gwas.imputed_v3.both_sexes.tsv.bgz -O 100630.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100670",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100670",
    "phenotype": "White wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100670.gwas.imputed_v3.both_sexes.tsv.bgz -O 100670.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100710",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100710",
    "phenotype": "Beer/cider intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100710.gwas.imputed_v3.both_sexes.tsv.bgz -O 100710.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100720",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100720",
    "phenotype": "Fortified wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100720.gwas.imputed_v3.both_sexes.tsv.bgz -O 100720.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100730",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100730",
    "phenotype": "Spirits intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (ethanol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100730.gwas.imputed_v3.both_sexes.tsv.bgz -O 100730.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100760",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100760",
    "phenotype": "Breakfast cereal consumed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – cereal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100760.gwas.imputed_v3.both_sexes.tsv.bgz -O 100760.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100890",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100890",
    "phenotype": "Milk added to cereal",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (additive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100890.gwas.imputed_v3.both_sexes.tsv.bgz -O 100890.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_0",
    "phenotype": "Type milk consumed: did not have milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2102",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2102",
    "phenotype": "Type milk consumed: semiskimmed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2102.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2102.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2103",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2103",
    "phenotype": "Type milk consumed: skimmed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2103.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2103.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2104",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2104",
    "phenotype": "Type milk consumed: wholemilk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2104.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2104.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2105",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2105",
    "phenotype": "Type milk consumed: soya with calcium",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2105.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2105.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2106",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2106",
    "phenotype": "Type milk consumed: soya without calcium",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2106.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2106.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2107",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2107",
    "phenotype": "Type milk consumed: goat/sheep milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2107.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2107.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2108",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2108",
    "phenotype": "Type milk consumed: rice/oat/vegetable milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2108.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2108.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2109",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2109",
    "phenotype": "Type milk consumed: powdered milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2109.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2109.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100920_2110",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100920_2110",
    "phenotype": "Type milk consumed: cholesterol lowering milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (choice)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100920_2110.gwas.imputed_v3.both_sexes.tsv.bgz -O 100920_2110.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "100940",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "100940",
    "phenotype": "Bread consumed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – cereal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/100940.gwas.imputed_v3.both_sexes.tsv.bgz -O 100940.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1011",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1011",
    "phenotype": "Frequency of light DIY in last 4 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical / leisure activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1011.gwas.imputed_v3.both_sexes.tsv.bgz -O 1011.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102",
    "phenotype": "Pulse rate, automated reading",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Vital sign / physiological",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102080",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102080",
    "phenotype": "Yogurt/ice-cream consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102080.gwas.imputed_v3.both_sexes.tsv.bgz -O 102080.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1021",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1021",
    "phenotype": "Duration of light DIY",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical / leisure activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1021.gwas.imputed_v3.both_sexes.tsv.bgz -O 1021.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102130",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102130",
    "phenotype": "Dessert consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102130.gwas.imputed_v3.both_sexes.tsv.bgz -O 102130.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102190",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102190",
    "phenotype": "Cake intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102190.gwas.imputed_v3.both_sexes.tsv.bgz -O 102190.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102250",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102250",
    "phenotype": "Sweet snack consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102250.gwas.imputed_v3.both_sexes.tsv.bgz -O 102250.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102280",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102280",
    "phenotype": "Milk chocolate intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102280.gwas.imputed_v3.both_sexes.tsv.bgz -O 102280.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102290",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102290",
    "phenotype": "Dark chocolate intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102290.gwas.imputed_v3.both_sexes.tsv.bgz -O 102290.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102330",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102330",
    "phenotype": "Sweets intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102330.gwas.imputed_v3.both_sexes.tsv.bgz -O 102330.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102360",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102360",
    "phenotype": "Sweet biscuits intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – sweets",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102360.gwas.imputed_v3.both_sexes.tsv.bgz -O 102360.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102400",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102400",
    "phenotype": "Savoury snack consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – snacks",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102400.gwas.imputed_v3.both_sexes.tsv.bgz -O 102400.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102440",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102440",
    "phenotype": "Unsalted nuts intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – nuts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102440.gwas.imputed_v3.both_sexes.tsv.bgz -O 102440.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102460",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102460",
    "phenotype": "Crisp intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – snacks",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102460.gwas.imputed_v3.both_sexes.tsv.bgz -O 102460.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102700",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102700",
    "phenotype": "Starchy food consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – carbohydrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102700.gwas.imputed_v3.both_sexes.tsv.bgz -O 102700.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102800",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102800",
    "phenotype": "Cheese consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102800.gwas.imputed_v3.both_sexes.tsv.bgz -O 102800.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102820",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102820",
    "phenotype": "Hard cheese intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102820.gwas.imputed_v3.both_sexes.tsv.bgz -O 102820.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102830",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102830",
    "phenotype": "Soft cheese intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102830.gwas.imputed_v3.both_sexes.tsv.bgz -O 102830.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102840",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102840",
    "phenotype": "Blue cheese intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102840.gwas.imputed_v3.both_sexes.tsv.bgz -O 102840.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "102930",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "102930",
    "phenotype": "Egg consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – protein foods",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/102930.gwas.imputed_v3.both_sexes.tsv.bgz -O 102930.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103000",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103000",
    "phenotype": "Meat consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103000.gwas.imputed_v3.both_sexes.tsv.bgz -O 103000.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103020",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103020",
    "phenotype": "Beef intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103020.gwas.imputed_v3.both_sexes.tsv.bgz -O 103020.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103060",
    "phenotype": "Poultry intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103060.gwas.imputed_v3.both_sexes.tsv.bgz -O 103060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103070",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103070",
    "phenotype": "Bacon intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat (processed)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103070.gwas.imputed_v3.both_sexes.tsv.bgz -O 103070.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1031",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1031",
    "phenotype": "Frequency of friend/family visits",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Social activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1031.gwas.imputed_v3.both_sexes.tsv.bgz -O 1031.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103120",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103120",
    "phenotype": "Fat removed from meat",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (preparation)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103120.gwas.imputed_v3.both_sexes.tsv.bgz -O 103120.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103130",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103130",
    "phenotype": "Skin removed from poultry",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (preparation)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103130.gwas.imputed_v3.both_sexes.tsv.bgz -O 103130.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103140",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103140",
    "phenotype": "Fish consumer",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fish",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103140.gwas.imputed_v3.both_sexes.tsv.bgz -O 103140.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103250",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103250",
    "phenotype": "Vegetarian alternatives intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – plant protein",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103250.gwas.imputed_v3.both_sexes.tsv.bgz -O 103250.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "103990",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "103990",
    "phenotype": "Vegetable consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/103990.gwas.imputed_v3.both_sexes.tsv.bgz -O 103990.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104020",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104020",
    "phenotype": "Fried potatoes intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables (starchy)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104020.gwas.imputed_v3.both_sexes.tsv.bgz -O 104020.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104090",
    "phenotype": "Side salad intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104090.gwas.imputed_v3.both_sexes.tsv.bgz -O 104090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104170",
    "phenotype": "Carrot intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104170.gwas.imputed_v3.both_sexes.tsv.bgz -O 104170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104210",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104210",
    "phenotype": "Cucumber intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104210.gwas.imputed_v3.both_sexes.tsv.bgz -O 104210.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104240",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104240",
    "phenotype": "Lettuce intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104240.gwas.imputed_v3.both_sexes.tsv.bgz -O 104240.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104290",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104290",
    "phenotype": "Sweet pepper intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104290.gwas.imputed_v3.both_sexes.tsv.bgz -O 104290.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104340",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104340",
    "phenotype": "Fresh tomato intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104340.gwas.imputed_v3.both_sexes.tsv.bgz -O 104340.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104400",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104400",
    "phenotype": "Fruit consumers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104400.gwas.imputed_v3.both_sexes.tsv.bgz -O 104400.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104450",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104450",
    "phenotype": "Apple intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104450.gwas.imputed_v3.both_sexes.tsv.bgz -O 104450.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104460",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104460",
    "phenotype": "Banana intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104460.gwas.imputed_v3.both_sexes.tsv.bgz -O 104460.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104530",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104530",
    "phenotype": "Orange intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104530.gwas.imputed_v3.both_sexes.tsv.bgz -O 104530.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104670",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104670",
    "phenotype": "Vitamin supplement user",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary supplement (when used as drug)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104670.gwas.imputed_v3.both_sexes.tsv.bgz -O 104670.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104900",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104900",
    "phenotype": "Time spent doing vigorous physical activity",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104900.gwas.imputed_v3.both_sexes.tsv.bgz -O 104900.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104910",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104910",
    "phenotype": "Time spent doing moderate physical activity",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104910.gwas.imputed_v3.both_sexes.tsv.bgz -O 104910.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "104920",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "104920",
    "phenotype": "Time spent doing light physical activity",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Physical activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/104920.gwas.imputed_v3.both_sexes.tsv.bgz -O 104920.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1050",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1050",
    "phenotype": "Time spend outdoors in summer",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Outdoor / lifestyle",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1050.gwas.imputed_v3.both_sexes.tsv.bgz -O 1050.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1060",
    "phenotype": "Time spent outdoors in winter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Outdoor / lifestyle",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1060.gwas.imputed_v3.both_sexes.tsv.bgz -O 1060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1070",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1070",
    "phenotype": "Time spent watching television (TV)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sedentary behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1070.gwas.imputed_v3.both_sexes.tsv.bgz -O 1070.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1080",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1080",
    "phenotype": "Time spent using computer",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sedentary behavior / screen time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1080.gwas.imputed_v3.both_sexes.tsv.bgz -O 1080.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1090",
    "phenotype": "Time spent driving",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Transportation behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1090.gwas.imputed_v3.both_sexes.tsv.bgz -O 1090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1100",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1100",
    "phenotype": "Drive faster than motorway speed limit",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Driving behavior / risk",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1100.gwas.imputed_v3.both_sexes.tsv.bgz -O 1100.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "110001",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "110001",
    "phenotype": "Invitation to complete online 24-hour recall dietary questionnaire, acceptance",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Study compliance (behavioral)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/110001.gwas.imputed_v3.both_sexes.tsv.bgz -O 110001.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1110",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1110",
    "phenotype": "Length of mobile phone use",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1110.gwas.imputed_v3.both_sexes.tsv.bgz -O 1110.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1120",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1120",
    "phenotype": "Weekly usage of mobile phone in last 3 months",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1120.gwas.imputed_v3.both_sexes.tsv.bgz -O 1120.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1130",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1130",
    "phenotype": "Hands-free device/speakerphone use with mobile phone in last 3 month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1130.gwas.imputed_v3.both_sexes.tsv.bgz -O 1130.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1140",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1140",
    "phenotype": "Difference in mobile phone use compared to two years previously",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use (change)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1140.gwas.imputed_v3.both_sexes.tsv.bgz -O 1140.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1150_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1150_1",
    "phenotype": "Usual side of head for mobile phone use: Left",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use (preference)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1150_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1150_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1150_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1150_2",
    "phenotype": "Usual side of head for mobile phone use: Right",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use (preference)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1150_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1150_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1150_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1150_3",
    "phenotype": "Usual side of head for mobile phone use: Equally left and right",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Electronic device use (preference)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1150_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1150_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1160",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1160",
    "phenotype": "Sleep duration",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1160.gwas.imputed_v3.both_sexes.tsv.bgz -O 1160.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1170",
    "phenotype": "Getting up in morning",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep behavior (chronotype)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1170.gwas.imputed_v3.both_sexes.tsv.bgz -O 1170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1180",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1180",
    "phenotype": "Morning/evening person (chronotype)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep behavior (chronotype)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1180.gwas.imputed_v3.both_sexes.tsv.bgz -O 1180.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1190",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1190",
    "phenotype": "Nap during day",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1190.gwas.imputed_v3.both_sexes.tsv.bgz -O 1190.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1200",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1200",
    "phenotype": "Sleeplessness / insomnia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-reported symptom (can be disease)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1200.gwas.imputed_v3.both_sexes.tsv.bgz -O 1200.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1210",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1210",
    "phenotype": "Snoring",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep behavior (or sign)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1210.gwas.imputed_v3.both_sexes.tsv.bgz -O 1210.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1220",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1220",
    "phenotype": "Daytime dozing / sleeping (narcolepsy)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1220.gwas.imputed_v3.both_sexes.tsv.bgz -O 1220.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "12336_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "12336",
    "phenotype": "Ventricular rate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cardiac electrophysiology",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/12336_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 12336_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "12338_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "12338",
    "phenotype": "P duration",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cardiac electrophysiology",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/12338_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 12338_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "12340_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "12340",
    "phenotype": "QRS duration",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cardiac electrophysiology",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/12340_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 12340_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1239",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1239",
    "phenotype": "Current tobacco smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking / nicotine use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1239.gwas.imputed_v3.both_sexes.tsv.bgz -O 1239.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1249",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1249",
    "phenotype": "Past tobacco smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking / nicotine use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1249.gwas.imputed_v3.both_sexes.tsv.bgz -O 1249.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1259",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1259",
    "phenotype": "Smoking/smokers in household",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Environmental smoking (passive) – but can be Behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1259.gwas.imputed_v3.both_sexes.tsv.bgz -O 1259.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1269",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1269",
    "phenotype": "Exposure to tobacco smoke at home",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Environmental smoking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1269.gwas.imputed_v3.both_sexes.tsv.bgz -O 1269.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1279",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1279",
    "phenotype": "Exposure to tobacco smoke outside home",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Environmental smoking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1279.gwas.imputed_v3.both_sexes.tsv.bgz -O 1279.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1289",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1289",
    "phenotype": "Cooked vegetable intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1289.gwas.imputed_v3.both_sexes.tsv.bgz -O 1289.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "129_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "129",
    "phenotype": "Place of birth in UK - north co-ordinate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Geographic / demographic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/129_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 129_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1299",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1299",
    "phenotype": "Salad / raw vegetable intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – vegetables",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1299.gwas.imputed_v3.both_sexes.tsv.bgz -O 1299.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "130_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "130",
    "phenotype": "Place of birth in UK - east co-ordinate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Geographic / demographic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1309",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1309",
    "phenotype": "Fresh fruit intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1309.gwas.imputed_v3.both_sexes.tsv.bgz -O 1309.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1319",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1319",
    "phenotype": "Dried fruit intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fruit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1319.gwas.imputed_v3.both_sexes.tsv.bgz -O 1319.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1329",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1329",
    "phenotype": "Oily fish intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fish",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1329.gwas.imputed_v3.both_sexes.tsv.bgz -O 1329.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1339",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1339",
    "phenotype": "Non-oily fish intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – fish",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1339.gwas.imputed_v3.both_sexes.tsv.bgz -O 1339.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "134",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "134",
    "phenotype": "Number of self-reported cancers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-reported cancer history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/134.gwas.imputed_v3.both_sexes.tsv.bgz -O 134.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1349",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1349",
    "phenotype": "Processed meat intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat (processed)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1349.gwas.imputed_v3.both_sexes.tsv.bgz -O 1349.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "135",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "135",
    "phenotype": "Number of self-reported non-cancer illnesses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Self-reported morbidity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/135.gwas.imputed_v3.both_sexes.tsv.bgz -O 135.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1359",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1359",
    "phenotype": "Poultry intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat (already above, but repeated)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1359.gwas.imputed_v3.both_sexes.tsv.bgz -O 1359.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "136",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "136",
    "phenotype": "Number of operations, self-reported",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Medical history (surgical)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/136.gwas.imputed_v3.both_sexes.tsv.bgz -O 136.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1369",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1369",
    "phenotype": "Beef intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1369.gwas.imputed_v3.both_sexes.tsv.bgz -O 1369.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "137",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "137",
    "phenotype": "Number of treatments/medications taken",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Medication count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/137.gwas.imputed_v3.both_sexes.tsv.bgz -O 137.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1379",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1379",
    "phenotype": "Lamb/mutton intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1379.gwas.imputed_v3.both_sexes.tsv.bgz -O 1379.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1389",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1389",
    "phenotype": "Pork intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – meat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1389.gwas.imputed_v3.both_sexes.tsv.bgz -O 1389.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1408",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1408",
    "phenotype": "Cheese intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1408.gwas.imputed_v3.both_sexes.tsv.bgz -O 1408.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1418_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1418_1",
    "phenotype": "Milk type used: Full cream",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1418_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1418_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1418_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1418_2",
    "phenotype": "Milk type used: Semi-skimmed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1418_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1418_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1418_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1418_3",
    "phenotype": "Milk type used: Skimmed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1418_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1418_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1418_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1418_4",
    "phenotype": "Milk type used: Soya",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1418_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 1418_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1418_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1418_6",
    "phenotype": "Milk type used: Never/rarely have milk",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1418_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 1418_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1428_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1428_0",
    "phenotype": "Spread type: Never/rarely use spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Spread choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1428_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 1428_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1428_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1428_1",
    "phenotype": "Spread type: Butter/spreadable butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Spread choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1428_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1428_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1428_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1428_2",
    "phenotype": "Spread type: Flora Pro-Active/Benecol",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Spread choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1428_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1428_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1438_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1438",
    "phenotype": "Bread intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – cereal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1438_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 1438_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1448_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1448_1",
    "phenotype": "Bread type: White",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Bread type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1448_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1448_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1448_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1448_2",
    "phenotype": "Bread type: Brown",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Bread type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1448_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1448_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1448_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1448_3",
    "phenotype": "Bread type: Wholemeal or wholegrain",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Bread type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1448_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1448_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1458",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1458",
    "phenotype": "Cereal intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary intake – cereal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1458.gwas.imputed_v3.both_sexes.tsv.bgz -O 1458.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1468_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1468_1",
    "phenotype": "Cereal type: Bran cereal (e.g. All Bran, Branflakes)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cereal type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1468_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1468_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1468_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1468_2",
    "phenotype": "Cereal type: Biscuit cereal (e.g. Weetabix)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cereal type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1468_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1468_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1468_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1468_3",
    "phenotype": "Cereal type: Oat cereal (e.g. Ready Brek, porridge)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cereal type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1468_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1468_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1468_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1468_4",
    "phenotype": "Cereal type: Muesli",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cereal type choice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1468_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 1468_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1478",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1478",
    "phenotype": "Salt added to food",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (preparation)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1478.gwas.imputed_v3.both_sexes.tsv.bgz -O 1478.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1488_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1488",
    "phenotype": "Tea intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1488_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 1488_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1498",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1498",
    "phenotype": "Coffee intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1498.gwas.imputed_v3.both_sexes.tsv.bgz -O 1498.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1508_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1508_1",
    "phenotype": "Coffee type: Decaffeinated coffee (any type)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1508_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1508_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1508_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1508_2",
    "phenotype": "Coffee type: Instant coffee",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1508_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1508_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1508_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1508_3",
    "phenotype": "Coffee type: Ground coffee (include espresso, filter etc)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Psychoactive substance (caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1508_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1508_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1518",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1518",
    "phenotype": "Hot drink temperature",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary behavior (preference)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1518.gwas.imputed_v3.both_sexes.tsv.bgz -O 1518.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1528",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1528",
    "phenotype": "Water intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Beverage consumption (non‑psychoactive)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1528.gwas.imputed_v3.both_sexes.tsv.bgz -O 1528.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1538_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1538_0",
    "phenotype": "Major dietary changes in the last 5 years: No",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary change",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1538_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 1538_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1538_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1538_1",
    "phenotype": "Major dietary changes in the last 5 years: Yes, because of illness",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary change due to illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1538_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1538_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1548",
    "phenotype": "Variation in diet",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Dietary variation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1548.gwas.imputed_v3.both_sexes.tsv.bgz -O 1548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1558",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1558",
    "phenotype": "Alcohol intake frequency.",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1558.gwas.imputed_v3.both_sexes.tsv.bgz -O 1558.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1568",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1568",
    "phenotype": "Average weekly red wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1568.gwas.imputed_v3.both_sexes.tsv.bgz -O 1568.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1578",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1578",
    "phenotype": "Average weekly champagne plus white wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1578.gwas.imputed_v3.both_sexes.tsv.bgz -O 1578.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1588",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1588",
    "phenotype": "Average weekly beer plus cider intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1588.gwas.imputed_v3.both_sexes.tsv.bgz -O 1588.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1598",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1598",
    "phenotype": "Average weekly spirits intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1598.gwas.imputed_v3.both_sexes.tsv.bgz -O 1598.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1608",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1608",
    "phenotype": "Average weekly fortified wine intake",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1608.gwas.imputed_v3.both_sexes.tsv.bgz -O 1608.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1618",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1618",
    "phenotype": "Alcohol usually taken with meals",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol consumption pattern",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1618.gwas.imputed_v3.both_sexes.tsv.bgz -O 1618.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1628",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1628",
    "phenotype": "Alcohol intake versus 10 years previously",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol change over time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1628.gwas.imputed_v3.both_sexes.tsv.bgz -O 1628.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1677",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1677",
    "phenotype": "Breastfed as a baby",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Early life history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1677.gwas.imputed_v3.both_sexes.tsv.bgz -O 1677.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1687",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1687",
    "phenotype": "Comparative body size at age 10",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body size history (recall)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1687.gwas.imputed_v3.both_sexes.tsv.bgz -O 1687.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1697",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1697",
    "phenotype": "Comparative height size at age 10",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Height history (recall)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1697.gwas.imputed_v3.both_sexes.tsv.bgz -O 1697.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1707_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1707_1",
    "phenotype": "Handedness (chirality/laterality): Right-handed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Biological trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1707_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1707_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1707_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1707_2",
    "phenotype": "Handedness (chirality/laterality): Left-handed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Biological trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1707_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1707_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1707_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1707_3",
    "phenotype": "Handedness (chirality/laterality): Use both right and left hands equally",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Biological trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1707_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1707_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1717",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1717",
    "phenotype": "Skin colour",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait (pigmentation)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1717.gwas.imputed_v3.both_sexes.tsv.bgz -O 1717.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1727",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1727",
    "phenotype": "Ease of skin tanning",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait (response to sun)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1727.gwas.imputed_v3.both_sexes.tsv.bgz -O 1727.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1737",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1737",
    "phenotype": "Childhood sunburn occasions",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Sun exposure history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1737.gwas.imputed_v3.both_sexes.tsv.bgz -O 1737.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1747_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1747_1",
    "phenotype": "Hair colour (natural, before greying): Blonde",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1747_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 1747_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1747_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1747_2",
    "phenotype": "Hair colour (natural, before greying): Red",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1747_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 1747_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1747_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1747_3",
    "phenotype": "Hair colour (natural, before greying): Light brown",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1747_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 1747_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1747_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1747_4",
    "phenotype": "Hair colour (natural, before greying): Dark brown",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1747_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 1747_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1747_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1747_5",
    "phenotype": "Hair colour (natural, before greying): Black",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1747_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 1747_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1757",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1757",
    "phenotype": "Facial ageing",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Physical trait / ageing",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1757.gwas.imputed_v3.both_sexes.tsv.bgz -O 1757.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1767",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1767",
    "phenotype": "Adopted as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Early life circumstance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1767.gwas.imputed_v3.both_sexes.tsv.bgz -O 1767.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1777",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1777",
    "phenotype": "Part of a multiple birth",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Birth characteristic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1777.gwas.imputed_v3.both_sexes.tsv.bgz -O 1777.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1787",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1787",
    "phenotype": "Maternal smoking around birth",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Prenatal exposure (historical)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1787.gwas.imputed_v3.both_sexes.tsv.bgz -O 1787.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1797",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1797",
    "phenotype": "Father still alive",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family status",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1797.gwas.imputed_v3.both_sexes.tsv.bgz -O 1797.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1807_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1807",
    "phenotype": "Father's age at death",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1807_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 1807_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1883",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1883",
    "phenotype": "Number of full sisters",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family composition",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1883.gwas.imputed_v3.both_sexes.tsv.bgz -O 1883.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "189_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "189",
    "phenotype": "Townsend deprivation index at recruitment",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Socioeconomic / demographic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/189_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 189_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1920",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1920",
    "phenotype": "Mood swings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1920.gwas.imputed_v3.both_sexes.tsv.bgz -O 1920.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1930",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1930",
    "phenotype": "Miserableness",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1930.gwas.imputed_v3.both_sexes.tsv.bgz -O 1930.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1940",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1940",
    "phenotype": "Irritability",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1940.gwas.imputed_v3.both_sexes.tsv.bgz -O 1940.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1950",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1950",
    "phenotype": "Sensitivity / hurt feelings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1950.gwas.imputed_v3.both_sexes.tsv.bgz -O 1950.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1960",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1960",
    "phenotype": "Fed-up feelings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1960.gwas.imputed_v3.both_sexes.tsv.bgz -O 1960.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1970",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1970",
    "phenotype": "Nervous feelings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1970.gwas.imputed_v3.both_sexes.tsv.bgz -O 1970.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1980",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1980",
    "phenotype": "Worrier / anxious feelings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1980.gwas.imputed_v3.both_sexes.tsv.bgz -O 1980.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "1990",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "1990",
    "phenotype": "Tense / 'highly strung'",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/1990.gwas.imputed_v3.both_sexes.tsv.bgz -O 1990.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2000",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2000",
    "phenotype": "Worry too long after embarrassment",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychological / emotional state",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2000.gwas.imputed_v3.both_sexes.tsv.bgz -O 2000.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1001",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1001",
    "phenotype": "Cancer code, self-reported: lung cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1001.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1001.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1003",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1003",
    "phenotype": "Cancer code, self-reported: skin cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "skin cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1003.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1003.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1006",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1006",
    "phenotype": "Cancer code, self-reported: larynx/throat cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "larynx/throat cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1006.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1006.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1011",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1011",
    "phenotype": "Cancer code, self-reported: tongue cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tongue cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1011.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1011.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1017",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1017",
    "phenotype": "Cancer code, self-reported: oesophageal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "oesophageal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1017.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1017.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1018",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1018",
    "phenotype": "Cancer code, self-reported: stomach cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "stomach cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1018.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1018.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1019",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1019",
    "phenotype": "Cancer code, self-reported: small intestine/small bowel cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "small intestine/small bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1019.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1019.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1020",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1020",
    "phenotype": "Cancer code, self-reported: large bowel cancer/colorectal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "large bowel cancer/colorectal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1020.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1020.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1022",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1022",
    "phenotype": "Cancer code, self-reported: colon cancer/sigmoid cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "colon cancer/sigmoid cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1022.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1022.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1023",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1023",
    "phenotype": "Cancer code, self-reported: rectal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rectal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1023.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1023.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1024",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1024",
    "phenotype": "Cancer code, self-reported: liver/hepatocellular cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "liver/hepatocellular cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1024.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1024.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1030",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1030",
    "phenotype": "Cancer code, self-reported: eye and/or adnexal cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "eye and/or adnexal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1030.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1030.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1032",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1032",
    "phenotype": "Cancer code, self-reported: brain cancer / primary malignant brain tumour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "brain cancer / primary malignant brain tumour",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1032.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1032.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1034",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1034",
    "phenotype": "Cancer code, self-reported: kidney/renal cell cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "kidney/renal cell cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1034.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1034.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1035",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1035",
    "phenotype": "Cancer code, self-reported: bladder cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bladder cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1035.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1035.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1048",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1048",
    "phenotype": "Cancer code, self-reported: leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "leukaemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1048.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1048.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1050",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1050",
    "phenotype": "Cancer code, self-reported: multiple myeloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "multiple myeloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1050.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1050.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1052",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1052",
    "phenotype": "Cancer code, self-reported: hodgkins lymphoma / hodgkins disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hodgkins lymphoma / hodgkins disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1052.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1052.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1053",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1053",
    "phenotype": "Cancer code, self-reported: non-hodgkins lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "non-hodgkins lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1053.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1053.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1055",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1055",
    "phenotype": "Cancer code, self-reported: chronic lymphocytic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic lymphocytic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1055.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1055.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1059",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1059",
    "phenotype": "Cancer code, self-reported: malignant melanoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "malignant melanoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1059.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1059.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1060",
    "phenotype": "Cancer code, self-reported: non-melanoma skin cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "non-melanoma skin cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1060.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1061",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1061",
    "phenotype": "Cancer code, self-reported: basal cell carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "basal cell carcinoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1061.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1061.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1062",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1062",
    "phenotype": "Cancer code, self-reported: squamous cell carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "squamous cell carcinoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1062.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1062.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1063",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1063",
    "phenotype": "Cancer code, self-reported: primary bone cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "primary bone cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1063.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1063.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1065",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1065",
    "phenotype": "Cancer code, self-reported: thyroid cancer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "thyroid cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1065.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1065.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1068",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1068",
    "phenotype": "Cancer code, self-reported: sarcoma/fibrosarcoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "sarcoma/fibrosarcoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1068.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1068.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_1073",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_1073",
    "phenotype": "Cancer code, self-reported: rodent ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rodent ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_1073.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_1073.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20001_99999",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20001_99999",
    "phenotype": "Cancer code, self-reported: unclassifiable",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "unclassifiable cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20001_99999.gwas.imputed_v3.both_sexes.tsv.bgz -O 20001_99999.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1065",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1065",
    "phenotype": "Non-cancer illness code, self-reported: hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1065.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1065.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1066",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1066",
    "phenotype": "Non-cancer illness code, self-reported: heart/cardiac problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "heart/cardiac problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1066.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1066.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1067",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1067",
    "phenotype": "Non-cancer illness code, self-reported: peripheral vascular disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peripheral vascular disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1067.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1067.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1072",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1072",
    "phenotype": "Non-cancer illness code, self-reported: essential hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "essential hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1072.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1072.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1074",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1074",
    "phenotype": "Non-cancer illness code, self-reported: angina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "angina",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1074.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1074.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1075",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1075",
    "phenotype": "Non-cancer illness code, self-reported: heart attack/myocardial infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "heart attack/myocardial infarction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1075.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1075.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1076",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1076",
    "phenotype": "Non-cancer illness code, self-reported: heart failure/pulmonary odema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "heart failure/pulmonary odema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1076.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1076.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1077",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1077",
    "phenotype": "Non-cancer illness code, self-reported: heart arrhythmia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "heart arrhythmia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1077.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1077.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1078",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1078",
    "phenotype": "Non-cancer illness code, self-reported: heart valve problem/heart murmur",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "heart valve problem/heart murmur",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1078.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1078.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1079",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1079",
    "phenotype": "Non-cancer illness code, self-reported: cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cardiomyopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1079.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1079.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1080",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1080",
    "phenotype": "Non-cancer illness code, self-reported: pericardial problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pericardial problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1080.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1080.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1081",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1081",
    "phenotype": "Non-cancer illness code, self-reported: stroke",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1081.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1081.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1082",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1082",
    "phenotype": "Non-cancer illness code, self-reported: transient ischaemic attack (tia)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "transient ischaemic attack (tia)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1082.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1082.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1083",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1083",
    "phenotype": "Non-cancer illness code, self-reported: subdural haemorrhage/haematoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "subdural haemorrhage/haematoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1083.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1083.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1086",
    "phenotype": "Non-cancer illness code, self-reported: subarachnoid haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "subarachnoid haemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1087",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1087",
    "phenotype": "Non-cancer illness code, self-reported: leg claudication/ intermittent claudication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "leg claudication/intermittent claudication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1087.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1087.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1093",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1093",
    "phenotype": "Non-cancer illness code, self-reported: pulmonary embolism +/- dvt",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pulmonary embolism +/- dvt",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1093.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1093.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1094",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1094",
    "phenotype": "Non-cancer illness code, self-reported: deep venous thrombosis (dvt)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "deep venous thrombosis (dvt)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1094.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1094.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1111",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1111",
    "phenotype": "Non-cancer illness code, self-reported: asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1111.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1111.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1112",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1112",
    "phenotype": "Non-cancer illness code, self-reported: chronic obstructive airways disease/copd",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic obstructive airways disease/copd",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1112.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1112.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1113",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1113",
    "phenotype": "Non-cancer illness code, self-reported: emphysema/chronic bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "emphysema/chronic bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1113.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1113.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1114",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1114",
    "phenotype": "Non-cancer illness code, self-reported: bronchiectasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bronchiectasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1114.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1114.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1115",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1115",
    "phenotype": "Non-cancer illness code, self-reported: interstitial lung disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "interstitial lung disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1115.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1115.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1120",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1120",
    "phenotype": "Non-cancer illness code, self-reported: asbestosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "asbestosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1120.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1120.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1123",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1123",
    "phenotype": "Non-cancer illness code, self-reported: sleep apnoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "sleep apnoea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1123.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1123.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1125",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1125",
    "phenotype": "Non-cancer illness code, self-reported: pleurisy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pleurisy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1125.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1125.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1126",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1126",
    "phenotype": "Non-cancer illness code, self-reported: spontaneous pneumothorax/recurrent pneumothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "spontaneous pneumothorax/recurrent pneumothorax",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1126.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1126.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1134",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1134",
    "phenotype": "Non-cancer illness code, self-reported: oesophageal disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "oesophageal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1134.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1134.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1135",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1135",
    "phenotype": "Non-cancer illness code, self-reported: stomach disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "stomach disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1135.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1135.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1136",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1136",
    "phenotype": "Non-cancer illness code, self-reported: liver/biliary/pancreas problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "liver/biliary/pancreas problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1136.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1136.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1138",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1138",
    "phenotype": "Non-cancer illness code, self-reported: gastro-oesophageal reflux (gord) / gastric reflux",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gastro-oesophageal reflux (gord) / gastric reflux",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1138.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1138.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1139",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1139",
    "phenotype": "Non-cancer illness code, self-reported: oesophagitis/barretts oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "oesophagitis/barretts oesophagus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1139.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1139.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1142",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1142",
    "phenotype": "Non-cancer illness code, self-reported: gastric/stomach ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gastric/stomach ulcers",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1142.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1142.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1143",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1143",
    "phenotype": "Non-cancer illness code, self-reported: gastritis/gastric erosions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gastritis/gastric erosions",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1143.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1143.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1154",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1154",
    "phenotype": "Non-cancer illness code, self-reported: irritable bowel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "irritable bowel syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1154.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1154.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1155",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1155",
    "phenotype": "Non-cancer illness code, self-reported: hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1155.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1155.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1156",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1156",
    "phenotype": "Non-cancer illness code, self-reported: infective/viral hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "infective/viral hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1156.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1156.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1157",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1157",
    "phenotype": "Non-cancer illness code, self-reported: non-infective hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "non-infective hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1157.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1157.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1158",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1158",
    "phenotype": "Non-cancer illness code, self-reported: liver failure/cirrhosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "liver failure/cirrhosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1158.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1158.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1161",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1161",
    "phenotype": "Non-cancer illness code, self-reported: gall bladder disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gall bladder disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1161.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1161.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1162",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1162",
    "phenotype": "Non-cancer illness code, self-reported: cholelithiasis/gall stones",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cholelithiasis/gall stones",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1162.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1162.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1163",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1163",
    "phenotype": "Non-cancer illness code, self-reported: cholecystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cholecystitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1163.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1163.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1165",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1165",
    "phenotype": "Non-cancer illness code, self-reported: pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pancreatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1165.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1165.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1190",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1190",
    "phenotype": "Non-cancer illness code, self-reported: peritonitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peritonitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1190.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1190.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1191",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1191",
    "phenotype": "Non-cancer illness code, self-reported: gastrointestinal bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gastrointestinal bleeding",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1191.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1191.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1192",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1192",
    "phenotype": "Non-cancer illness code, self-reported: renal/kidney failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "renal/kidney failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1192.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1192.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1193",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1193",
    "phenotype": "Non-cancer illness code, self-reported: renal failure requiring dialysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "renal failure requiring dialysis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1193.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1193.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1194",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1194",
    "phenotype": "Non-cancer illness code, self-reported: renal failure not requiring dialysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "renal failure not requiring dialysis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1194.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1194.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1196",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1196",
    "phenotype": "Non-cancer illness code, self-reported: urinary tract infection/kidney infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "urinary tract infection/kidney infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1196.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1196.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1197",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1197",
    "phenotype": "Non-cancer illness code, self-reported: kidney stone/ureter stone/bladder stone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "kidney stone/ureter stone/bladder stone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1197.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1197.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1200",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1200",
    "phenotype": "Non-cancer illness code, self-reported: ureteric obstruction/hydronephrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ureteric obstruction/hydronephrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1200.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1200.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1201",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1201",
    "phenotype": "Non-cancer illness code, self-reported: bladder problem (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bladder problem (not cancer)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1201.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1201.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1202",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1202",
    "phenotype": "Non-cancer illness code, self-reported: urinary frequency / incontinence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "urinary frequency / incontinence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1202.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1202.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1220",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1220",
    "phenotype": "Non-cancer illness code, self-reported: diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1220.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1220.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1222",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1222",
    "phenotype": "Non-cancer illness code, self-reported: type 1 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "type 1 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1222.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1222.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1223",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1223",
    "phenotype": "Non-cancer illness code, self-reported: type 2 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "type 2 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1223.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1223.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1224",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1224",
    "phenotype": "Non-cancer illness code, self-reported: thyroid problem (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "thyroid problem (not cancer)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1224.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1224.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1225",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1225",
    "phenotype": "Non-cancer illness code, self-reported: hyperthyroidism/thyrotoxicosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hyperthyroidism/thyrotoxicosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1225.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1225.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1226",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1226",
    "phenotype": "Non-cancer illness code, self-reported: hypothyroidism/myxoedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hypothyroidism/myxoedema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1226.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1226.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1229",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1229",
    "phenotype": "Non-cancer illness code, self-reported: parathyroid gland problem (not cancer)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "parathyroid gland problem (not cancer)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1229.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1229.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1234",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1234",
    "phenotype": "Non-cancer illness code, self-reported: adrenocortical insufficiency/addison's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "adrenocortical insufficiency/addison's disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1234.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1234.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1238",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1238",
    "phenotype": "Non-cancer illness code, self-reported: pituitary adenoma/tumour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pituitary adenoma/tumour",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1238.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1238.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1240",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1240",
    "phenotype": "Non-cancer illness code, self-reported: neurological injury/trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "neurological injury/trauma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1240.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1240.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1242",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1242",
    "phenotype": "Non-cancer illness code, self-reported: eye/eyelid problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "eye/eyelid problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1242.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1242.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1243",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1243",
    "phenotype": "Non-cancer illness code, self-reported: psychological/psychiatric problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "psychological/psychiatric problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1243.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1243.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1246",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1246",
    "phenotype": "Non-cancer illness code, self-reported: encephalitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "encephalitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1246.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1246.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1247",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1247",
    "phenotype": "Non-cancer illness code, self-reported: meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "meningitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1247.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1247.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1249",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1249",
    "phenotype": "Non-cancer illness code, self-reported: cranial nerve problem/palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cranial nerve problem/palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1249.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1249.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1250",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1250",
    "phenotype": "Non-cancer illness code, self-reported: bell's palsy/facial nerve palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bell's palsy/facial nerve palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1250.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1250.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1251",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1251",
    "phenotype": "Non-cancer illness code, self-reported: spinal cord disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "spinal cord disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1251.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1251.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1254",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1254",
    "phenotype": "Non-cancer illness code, self-reported: peripheral nerve disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peripheral nerve disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1254.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1254.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1255",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1255",
    "phenotype": "Non-cancer illness code, self-reported: peripheral neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peripheral neuropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1255.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1255.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1256",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1256",
    "phenotype": "Non-cancer illness code, self-reported: acute infective polyneuritis/guillain-barre syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "acute infective polyneuritis/guillain-barre syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1256.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1256.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1257",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1257",
    "phenotype": "Non-cancer illness code, self-reported: trapped nerve/compressed nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "trapped nerve/compressed nerve",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1257.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1257.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1258",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1258",
    "phenotype": "Non-cancer illness code, self-reported: chronic/degenerative neurological problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic/degenerative neurological problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1258.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1258.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1261",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1261",
    "phenotype": "Non-cancer illness code, self-reported: multiple sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "multiple sclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1261.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1261.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1262",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1262",
    "phenotype": "Non-cancer illness code, self-reported: parkinsons disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "parkinsons disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1262.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1262.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1264",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1264",
    "phenotype": "Non-cancer illness code, self-reported: epilepsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "epilepsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1264.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1264.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1265",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1265",
    "phenotype": "Non-cancer illness code, self-reported: migraine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "migraine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1265.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1265.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1266",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1266",
    "phenotype": "Non-cancer illness code, self-reported: head injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "head injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1266.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1266.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1267",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1267",
    "phenotype": "Non-cancer illness code, self-reported: spinal injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "spinal injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1267.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1267.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1274",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1274",
    "phenotype": "Non-cancer illness code, self-reported: eye infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "eye infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1274.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1274.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1275",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1275",
    "phenotype": "Non-cancer illness code, self-reported: retinal problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "retinal problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1275.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1275.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1276",
    "phenotype": "Non-cancer illness code, self-reported: diabetic eye disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "diabetic eye disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1276.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1277",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1277",
    "phenotype": "Non-cancer illness code, self-reported: glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "glaucoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1277.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1277.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1278",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1278",
    "phenotype": "Non-cancer illness code, self-reported: cataract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cataract",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1278.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1278.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1279",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1279",
    "phenotype": "Non-cancer illness code, self-reported: eye trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "eye trauma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1279.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1279.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1281",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1281",
    "phenotype": "Non-cancer illness code, self-reported: retinal detachment",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "retinal detachment",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1281.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1281.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1282",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1282",
    "phenotype": "Non-cancer illness code, self-reported: retinal artery/vein occlusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "retinal artery/vein occlusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1282.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1282.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1286",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1286",
    "phenotype": "Non-cancer illness code, self-reported: depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1286.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1286.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1287",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1287",
    "phenotype": "Non-cancer illness code, self-reported: anxiety/panic attacks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "anxiety/panic attacks",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1287.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1287.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1288",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1288",
    "phenotype": "Non-cancer illness code, self-reported: nervous breakdown",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "nervous breakdown",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1288.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1288.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1289",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1289",
    "phenotype": "Non-cancer illness code, self-reported: schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "schizophrenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1289.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1289.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1290",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1290",
    "phenotype": "Non-cancer illness code, self-reported: deliberate self-harm/suicide attempt",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "deliberate self-harm/suicide attempt",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1290.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1290.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1291",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1291",
    "phenotype": "Non-cancer illness code, self-reported: mania/bipolar disorder/manic depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "mania/bipolar disorder/manic depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1291.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1291.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1293",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1293",
    "phenotype": "Non-cancer illness code, self-reported: bone disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bone disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1293.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1293.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1294",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1294",
    "phenotype": "Non-cancer illness code, self-reported: back problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "back problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1294.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1294.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1295",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1295",
    "phenotype": "Non-cancer illness code, self-reported: joint disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "joint disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1295.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1295.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1297",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1297",
    "phenotype": "Non-cancer illness code, self-reported: muscle/soft tissue problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "muscle/soft tissue problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1297.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1297.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1308",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1308",
    "phenotype": "Non-cancer illness code, self-reported: osteomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "osteomyelitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1308.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1308.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1309",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1309",
    "phenotype": "Non-cancer illness code, self-reported: osteoporosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "osteoporosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1309.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1309.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1311",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1311",
    "phenotype": "Non-cancer illness code, self-reported: spine arthritis/spondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "spine arthritis/spondylitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1311.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1311.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1312",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1312",
    "phenotype": "Non-cancer illness code, self-reported: prolapsed disc/slipped disc",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "prolapsed disc/slipped disc",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1312.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1312.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1313",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1313",
    "phenotype": "Non-cancer illness code, self-reported: ankylosing spondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ankylosing spondylitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1313.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1313.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1322",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1322",
    "phenotype": "Non-cancer illness code, self-reported: myositis/myopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "myositis/myopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1322.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1322.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1327",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1327",
    "phenotype": "Non-cancer illness code, self-reported: low platelets/platelet disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "low platelets/platelet disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1327.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1327.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1330",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1330",
    "phenotype": "Non-cancer illness code, self-reported: iron deficiency anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "iron deficiency anaemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1330.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1330.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1331",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1331",
    "phenotype": "Non-cancer illness code, self-reported: pernicious anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pernicious anaemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1331.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1331.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1371",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1371",
    "phenotype": "Non-cancer illness code, self-reported: sarcoidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "sarcoidosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1371.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1371.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1372",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1372",
    "phenotype": "Non-cancer illness code, self-reported: vasculitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "vasculitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1372.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1372.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1373",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1373",
    "phenotype": "Non-cancer illness code, self-reported: connective tissue disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "connective tissue disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1373.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1373.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1374",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1374",
    "phenotype": "Non-cancer illness code, self-reported: allergy/hypersensitivity/anaphylaxis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "allergy/hypersensitivity/anaphylaxis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1374.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1374.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1377",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1377",
    "phenotype": "Non-cancer illness code, self-reported: polymyalgia rheumatica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "polymyalgia rheumatica",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1377.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1377.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1381",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1381",
    "phenotype": "Non-cancer illness code, self-reported: systemic lupus erythematosis/sle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "systemic lupus erythematosis/sle",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1381.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1381.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1382",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1382",
    "phenotype": "Non-cancer illness code, self-reported: sjogren's syndrome/sicca syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "sjogren's syndrome/sicca syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1382.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1382.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1384",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1384",
    "phenotype": "Non-cancer illness code, self-reported: scleroderma/systemic sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "scleroderma/systemic sclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1384.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1384.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1385",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1385",
    "phenotype": "Non-cancer illness code, self-reported: allergy or anaphylactic reaction to food",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "allergy or anaphylactic reaction to food",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1385.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1385.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1386",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1386",
    "phenotype": "Non-cancer illness code, self-reported: allergy or anaphylactic reaction to drug",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "allergy or anaphylactic reaction to drug",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1386.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1386.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1387",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1387",
    "phenotype": "Non-cancer illness code, self-reported: hayfever/allergic rhinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hayfever/allergic rhinitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1387.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1387.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1394",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1394",
    "phenotype": "Non-cancer illness code, self-reported: peripheral nerve injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peripheral nerve injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1394.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1394.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1398",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1398",
    "phenotype": "Non-cancer illness code, self-reported: pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pneumonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1398.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1398.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1400",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1400",
    "phenotype": "Non-cancer illness code, self-reported: peptic ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "peptic ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1400.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1400.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1406",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1406",
    "phenotype": "Non-cancer illness code, self-reported: muscle or soft tissue injuries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "muscle or soft tissue injuries",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1406.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1406.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1407",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1407",
    "phenotype": "Non-cancer illness code, self-reported: burns",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "burns",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1407.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1407.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1408",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1408",
    "phenotype": "Non-cancer illness code, self-reported: alcohol dependency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "alcohol dependency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1408.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1408.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1412",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1412",
    "phenotype": "Non-cancer illness code, self-reported: bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1412.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1412.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1413",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1413",
    "phenotype": "Non-cancer illness code, self-reported: nasal/sinus disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "nasal/sinus disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1413.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1413.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1414",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1414",
    "phenotype": "Non-cancer illness code, self-reported: throat or larynx disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "throat or larynx disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1414.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1414.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1415",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1415",
    "phenotype": "Non-cancer illness code, self-reported: ear/vestibular disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ear/vestibular disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1415.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1415.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1416",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1416",
    "phenotype": "Non-cancer illness code, self-reported: chronic sinusitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic sinusitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1416.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1416.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1417",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1417",
    "phenotype": "Non-cancer illness code, self-reported: nasal polyps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "nasal polyps",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1417.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1417.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1419",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1419",
    "phenotype": "Non-cancer illness code, self-reported: vocal cord polyp",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "vocal cord polyp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1419.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1419.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1420",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1420",
    "phenotype": "Non-cancer illness code, self-reported: otosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "otosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1420.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1420.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1421",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1421",
    "phenotype": "Non-cancer illness code, self-reported: meniere's disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "meniere's disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1421.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1421.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1425",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1425",
    "phenotype": "Non-cancer illness code, self-reported: cerebral aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cerebral aneurysm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1425.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1425.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1427",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1427",
    "phenotype": "Non-cancer illness code, self-reported: polycystic kidney",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "polycystic kidney",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1427.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1427.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1428",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1428",
    "phenotype": "Non-cancer illness code, self-reported: thyroiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "thyroiditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1428.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1428.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1430",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1430",
    "phenotype": "Non-cancer illness code, self-reported: hypopituitarism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hypopituitarism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1430.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1430.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1433",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1433",
    "phenotype": "Non-cancer illness code, self-reported: cerebral palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cerebral palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1433.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1433.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1435",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1435",
    "phenotype": "Non-cancer illness code, self-reported: optic neuritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "optic neuritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1435.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1435.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1436",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1436",
    "phenotype": "Non-cancer illness code, self-reported: headaches (not migraine)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "headaches (not migraine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1436.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1436.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1437",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1437",
    "phenotype": "Non-cancer illness code, self-reported: myasthenia gravis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "myasthenia gravis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1437.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1437.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1438",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1438",
    "phenotype": "Non-cancer illness code, self-reported: polycythaemia vera",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "polycythaemia vera",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1438.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1438.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1439",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1439",
    "phenotype": "Non-cancer illness code, self-reported: hiv/aids",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hiv/aids",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1439.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1439.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1440",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1440",
    "phenotype": "Non-cancer illness code, self-reported: tuberculosis (tb)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tuberculosis (tb)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1440.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1440.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1441",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1441",
    "phenotype": "Non-cancer illness code, self-reported: malaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "malaria",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1441.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1441.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1442",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1442",
    "phenotype": "Non-cancer illness code, self-reported: helicobacter pylori",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "helicobacter pylori",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1442.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1442.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1445",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1445",
    "phenotype": "Non-cancer illness code, self-reported: clotting disorder/excessive bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "clotting disorder/excessive bleeding",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1445.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1445.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1446",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1446",
    "phenotype": "Non-cancer illness code, self-reported: anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "anaemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1446.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1446.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1451",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1451",
    "phenotype": "Non-cancer illness code, self-reported: hereditary/genetic haematological disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hereditary/genetic haematological disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1451.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1451.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1452",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1452",
    "phenotype": "Non-cancer illness code, self-reported: eczema/dermatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "eczema/dermatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1452.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1452.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1453",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1453",
    "phenotype": "Non-cancer illness code, self-reported: psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "psoriasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1453.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1453.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1454",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1454",
    "phenotype": "Non-cancer illness code, self-reported: blistering/desquamating skin disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "blistering/desquamating skin disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1454.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1454.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1455",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1455",
    "phenotype": "Non-cancer illness code, self-reported: chronic skin ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic skin ulcers",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1455.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1455.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1456",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1456",
    "phenotype": "Non-cancer illness code, self-reported: malabsorption/coeliac disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "malabsorption/coeliac disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1456.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1456.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1457",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1457",
    "phenotype": "Non-cancer illness code, self-reported: duodenal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "duodenal ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1457.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1457.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1458",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1458",
    "phenotype": "Non-cancer illness code, self-reported: diverticular disease/diverticulitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "diverticular disease/diverticulitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1458.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1458.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1459",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1459",
    "phenotype": "Non-cancer illness code, self-reported: colitis/not crohns or ulcerative colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "colitis/not crohns or ulcerative colitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1459.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1459.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1460",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1460",
    "phenotype": "Non-cancer illness code, self-reported: rectal or colon adenoma/polyps",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rectal or colon adenoma/polyps",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1460.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1460.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1461",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1461",
    "phenotype": "Non-cancer illness code, self-reported: inflammatory bowel disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "inflammatory bowel disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1461.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1461.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1462",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1462",
    "phenotype": "Non-cancer illness code, self-reported: crohns disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "crohns disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1462.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1462.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1463",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1463",
    "phenotype": "Non-cancer illness code, self-reported: ulcerative colitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ulcerative colitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1463.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1463.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1464",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1464",
    "phenotype": "Non-cancer illness code, self-reported: rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rheumatoid arthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1464.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1464.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1465",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1465",
    "phenotype": "Non-cancer illness code, self-reported: osteoarthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "osteoarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1465.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1465.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1466",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1466",
    "phenotype": "Non-cancer illness code, self-reported: gout",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gout",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1466.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1466.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1468",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1468",
    "phenotype": "Non-cancer illness code, self-reported: diabetic neuropathy/ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "diabetic neuropathy/ulcers",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1468.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1468.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1469",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1469",
    "phenotype": "Non-cancer illness code, self-reported: post-traumatic stress disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "post-traumatic stress disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1469.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1469.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1471",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1471",
    "phenotype": "Non-cancer illness code, self-reported: atrial fibrillation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "atrial fibrillation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1471.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1471.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1472",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1472",
    "phenotype": "Non-cancer illness code, self-reported: emphysema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "emphysema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1472.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1472.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1473",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1473",
    "phenotype": "Non-cancer illness code, self-reported: high cholesterol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "high cholesterol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1473.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1473.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1474",
    "phenotype": "Non-cancer illness code, self-reported: hiatus hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hiatus hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1474.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1476",
    "phenotype": "Non-cancer illness code, self-reported: sciatica",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "sciatica",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1476.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1477",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1477",
    "phenotype": "Non-cancer illness code, self-reported: psoriatic arthropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "psoriatic arthropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1477.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1477.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1478",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1478",
    "phenotype": "Non-cancer illness code, self-reported: cervical spondylosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cervical spondylosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1478.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1478.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1479",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1479",
    "phenotype": "Non-cancer illness code, self-reported: rheumatic fever",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rheumatic fever",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1479.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1479.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1482",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1482",
    "phenotype": "Non-cancer illness code, self-reported: chronic fatigue syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chronic fatigue syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1482.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1482.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1485",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1485",
    "phenotype": "Non-cancer illness code, self-reported: irregular heart beat",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "irregular heart beat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1485.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1485.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1487",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1487",
    "phenotype": "Non-cancer illness code, self-reported: svt / supraventricular tachycardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "svt / supraventricular tachycardia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1487.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1487.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1491",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1491",
    "phenotype": "Non-cancer illness code, self-reported: brain haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "brain haemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1491.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1491.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1494",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1494",
    "phenotype": "Non-cancer illness code, self-reported: varicose veins",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "varicose veins",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1494.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1494.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1495",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1495",
    "phenotype": "Non-cancer illness code, self-reported: lymphoedema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "lymphoedema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1495.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1495.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1497",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1497",
    "phenotype": "Non-cancer illness code, self-reported: pneumothorax",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pneumothorax",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1497.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1497.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1499",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1499",
    "phenotype": "Non-cancer illness code, self-reported: labyrinthitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "labyrinthitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1499.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1499.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1500",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1500",
    "phenotype": "Non-cancer illness code, self-reported: vertigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "vertigo",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1500.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1500.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1501",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1501",
    "phenotype": "Non-cancer illness code, self-reported: pyloric stenosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "pyloric stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1501.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1501.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1502",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1502",
    "phenotype": "Non-cancer illness code, self-reported: appendicitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "appendicitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1502.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1502.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1504",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1504",
    "phenotype": "Non-cancer illness code, self-reported: anal fissure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "anal fissure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1504.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1504.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1505",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1505",
    "phenotype": "Non-cancer illness code, self-reported: haemorrhoids / piles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "haemorrhoids / piles",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1505.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1505.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1508",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1508",
    "phenotype": "Non-cancer illness code, self-reported: jaundice (unknown cause)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "jaundice (unknown cause)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1508.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1508.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1509",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1509",
    "phenotype": "Non-cancer illness code, self-reported: gastroenteritis/dysentry",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "gastroenteritis/dysentry",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1509.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1509.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1510",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1510",
    "phenotype": "Non-cancer illness code, self-reported: dyspepsia / indigestion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "dyspepsia / indigestion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1510.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1510.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1511",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1511",
    "phenotype": "Non-cancer illness code, self-reported: abdominal hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "abdominal hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1511.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1511.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1512",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1512",
    "phenotype": "Non-cancer illness code, self-reported: umbilical hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "umbilical hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1512.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1512.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1513",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1513",
    "phenotype": "Non-cancer illness code, self-reported: inguinal hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "inguinal hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1513.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1513.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1514",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1514",
    "phenotype": "Non-cancer illness code, self-reported: cystitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cystitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1514.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1514.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1523",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1523",
    "phenotype": "Non-cancer illness code, self-reported: trigemminal neuralgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "trigemminal neuralgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1523.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1523.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1525",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1525",
    "phenotype": "Non-cancer illness code, self-reported: benign / essential tremor",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "benign / essential tremor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1525.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1525.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1526",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1526",
    "phenotype": "Non-cancer illness code, self-reported: polio / poliomyelitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "polio / poliomyelitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1526.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1526.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1528",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1528",
    "phenotype": "Non-cancer illness code, self-reported: macular degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "macular degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1528.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1528.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1529",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1529",
    "phenotype": "Non-cancer illness code, self-reported: dry eyes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "dry eyes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1529.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1529.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1530",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1530",
    "phenotype": "Non-cancer illness code, self-reported: iritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "iritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1530.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1530.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1532",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1532",
    "phenotype": "Non-cancer illness code, self-reported: disc problem",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "disc problem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1532.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1532.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1533",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1533",
    "phenotype": "Non-cancer illness code, self-reported: disc degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "disc degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1533.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1533.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1534",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1534",
    "phenotype": "Non-cancer illness code, self-reported: back pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "back pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1534.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1534.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1535",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1535",
    "phenotype": "Non-cancer illness code, self-reported: scoliosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "scoliosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1535.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1535.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1536",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1536",
    "phenotype": "Non-cancer illness code, self-reported: spinal stenosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "spinal stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1536.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1536.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1537",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1537",
    "phenotype": "Non-cancer illness code, self-reported: joint pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "joint pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1537.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1537.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1538",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1538",
    "phenotype": "Non-cancer illness code, self-reported: arthritis (nos)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "arthritis (nos)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1538.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1538.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1540",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1540",
    "phenotype": "Non-cancer illness code, self-reported: plantar fascitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "plantar fascitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1540.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1540.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1541",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1541",
    "phenotype": "Non-cancer illness code, self-reported: carpal tunnel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "carpal tunnel syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1541.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1541.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1542",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1542",
    "phenotype": "Non-cancer illness code, self-reported: fibromyalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fibromyalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1542.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1542.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1544",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1544",
    "phenotype": "Non-cancer illness code, self-reported: dupuytren's contracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "dupuytren's contracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1544.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1544.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1545",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1545",
    "phenotype": "Non-cancer illness code, self-reported: neck problem/injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "neck problem/injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1545.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1545.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1548",
    "phenotype": "Non-cancer illness code, self-reported: acne/acne vulgaris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "acne/acne vulgaris",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1548.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1549",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1549",
    "phenotype": "Non-cancer illness code, self-reported: lichen planus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "lichen planus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1549.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1549.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1550",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1550",
    "phenotype": "Non-cancer illness code, self-reported: lichen sclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "lichen sclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1550.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1550.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1561",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1561",
    "phenotype": "Non-cancer illness code, self-reported: raynaud's phenomenon/disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "raynaud's phenomenon/disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1561.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1561.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1562",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1562",
    "phenotype": "Non-cancer illness code, self-reported: food intolerance",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "food intolerance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1562.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1562.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1563",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1563",
    "phenotype": "Non-cancer illness code, self-reported: urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "urticaria",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1563.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1563.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1567",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1567",
    "phenotype": "Non-cancer illness code, self-reported: infectious mononucleosis / glandular fever / epstein barr virus (ebv)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "infectious mononucleosis / glandular fever / ebv",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1567.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1567.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1568",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1568",
    "phenotype": "Non-cancer illness code, self-reported: measles / morbillivirus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "measles / morbillivirus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1568.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1568.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1569",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1569",
    "phenotype": "Non-cancer illness code, self-reported: mumps / epidemic parotitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "mumps / epidemic parotitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1569.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1569.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1570",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1570",
    "phenotype": "Non-cancer illness code, self-reported: rubella / german measles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rubella / german measles",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1570.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1570.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1571",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1571",
    "phenotype": "Non-cancer illness code, self-reported: chickenpox",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "chickenpox",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1571.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1571.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1572",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1572",
    "phenotype": "Non-cancer illness code, self-reported: whooping cough / pertussis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "whooping cough / pertussis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1572.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1572.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1573",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1573",
    "phenotype": "Non-cancer illness code, self-reported: shingles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "shingles",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1573.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1573.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1575",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1575",
    "phenotype": "Non-cancer illness code, self-reported: herpes simplex",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "herpes simplex",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1575.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1575.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1578",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1578",
    "phenotype": "Non-cancer illness code, self-reported: hepatitis a",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "hepatitis a",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1578.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1578.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1585",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1585",
    "phenotype": "Non-cancer illness code, self-reported: mitral regurgitation / incompetence",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "mitral regurgitation / incompetence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1585.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1585.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1597",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1597",
    "phenotype": "Non-cancer illness code, self-reported: tinnitus / tiniitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tinnitus / tiniitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1597.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1597.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1598",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1598",
    "phenotype": "Non-cancer illness code, self-reported: tonsiltis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tonsiltis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1598.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1598.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1599",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1599",
    "phenotype": "Non-cancer illness code, self-reported: constipation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "constipation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1599.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1599.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1602",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1602",
    "phenotype": "Non-cancer illness code, self-reported: bowel / intestinal obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bowel / intestinal obstruction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1602.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1602.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1603",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1603",
    "phenotype": "Non-cancer illness code, self-reported: rectal prolapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rectal prolapse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1603.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1603.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1605",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1605",
    "phenotype": "Non-cancer illness code, self-reported: femoral hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "femoral hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1605.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1605.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1608",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1608",
    "phenotype": "Non-cancer illness code, self-reported: nephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "nephritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1608.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1608.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1610",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1610",
    "phenotype": "Non-cancer illness code, self-reported: thyroid goitre",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "thyroid goitre",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1610.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1610.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1613",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1613",
    "phenotype": "Non-cancer illness code, self-reported: blepharitis / eyelid infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "blepharitis / eyelid infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1613.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1613.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1614",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1614",
    "phenotype": "Non-cancer illness code, self-reported: stress",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "stress",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1614.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1614.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1616",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1616",
    "phenotype": "Non-cancer illness code, self-reported: insomnia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "insomnia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1616.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1616.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1617",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1617",
    "phenotype": "Non-cancer illness code, self-reported: osteopenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "osteopenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1617.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1617.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1619",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1619",
    "phenotype": "Non-cancer illness code, self-reported: tendonitis / tendinitis / tenosynovitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tendonitis / tendinitis / tenosynovitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1619.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1619.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1620",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1620",
    "phenotype": "Non-cancer illness code, self-reported: bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "bursitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1620.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1620.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1623",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1623",
    "phenotype": "Non-cancer illness code, self-reported: tennis elbow / lateral epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "tennis elbow / lateral epicondylitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1623.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1623.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1625",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1625",
    "phenotype": "Non-cancer illness code, self-reported: cellulitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "cellulitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1625.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1625.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1626",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1626",
    "phenotype": "Non-cancer illness code, self-reported: fracture skull / head",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture skull / head",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1626.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1626.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1627",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1627",
    "phenotype": "Non-cancer illness code, self-reported: fracture jaw",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture jaw",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1627.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1627.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1628",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1628",
    "phenotype": "Non-cancer illness code, self-reported: fracture nose",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture nose",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1628.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1628.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1629",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1629",
    "phenotype": "Non-cancer illness code, self-reported: fracture face / orbit / eye socket",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture face / orbit / eye socket",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1629.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1629.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1631",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1631",
    "phenotype": "Non-cancer illness code, self-reported: fracture clavicle / collar bone",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture clavicle / collar bone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1631.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1631.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1632",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1632",
    "phenotype": "Non-cancer illness code, self-reported: fracture shoulder / scapula",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture shoulder / scapula",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1632.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1632.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1633",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1633",
    "phenotype": "Non-cancer illness code, self-reported: fracture upper arm / humerus / elbow",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture upper arm / humerus / elbow",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1633.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1633.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1634",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1634",
    "phenotype": "Non-cancer illness code, self-reported: fracture forearm / wrist",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture forearm / wrist",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1634.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1634.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1635",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1635",
    "phenotype": "Non-cancer illness code, self-reported: fracture radius",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture radius",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1635.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1635.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1636",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1636",
    "phenotype": "Non-cancer illness code, self-reported: fracture ulna",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture ulna",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1636.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1636.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1637",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1637",
    "phenotype": "Non-cancer illness code, self-reported: fracture wrist / colles fracture",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture wrist / colles fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1637.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1637.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1638",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1638",
    "phenotype": "Non-cancer illness code, self-reported: fracture hand",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture hand",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1638.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1638.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1639",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1639",
    "phenotype": "Non-cancer illness code, self-reported: fracture finger",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture finger",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1639.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1639.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1644",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1644",
    "phenotype": "Non-cancer illness code, self-reported: fracture rib",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture rib",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1644.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1644.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1646",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1646",
    "phenotype": "Non-cancer illness code, self-reported: fracture vertebra / crush fracture / vertebral collapse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture vertebra / crush fracture / vertebral collapse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1646.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1646.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1647",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1647",
    "phenotype": "Non-cancer illness code, self-reported: fracture pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture pelvis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1647.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1647.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1648",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1648",
    "phenotype": "Non-cancer illness code, self-reported: fracture neck of femur / hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture neck of femur / hip",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1648.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1648.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1649",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1649",
    "phenotype": "Non-cancer illness code, self-reported: fracture shaft of femur",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture shaft of femur",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1649.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1649.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1650",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1650",
    "phenotype": "Non-cancer illness code, self-reported: fracture patella / knee",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture patella / knee",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1650.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1650.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1651",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1651",
    "phenotype": "Non-cancer illness code, self-reported: fracture lower leg / ankle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture lower leg / ankle",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1651.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1651.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1652",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1652",
    "phenotype": "Non-cancer illness code, self-reported: fracture tibia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture tibia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1652.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1652.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1653",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1653",
    "phenotype": "Non-cancer illness code, self-reported: fracture fibula",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture fibula",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1653.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1653.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1654",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1654",
    "phenotype": "Non-cancer illness code, self-reported: fracture foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture foot",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1654.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1654.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1655",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1655",
    "phenotype": "Non-cancer illness code, self-reported: fracture metatarsal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture metatarsal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1655.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1655.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1656",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1656",
    "phenotype": "Non-cancer illness code, self-reported: fracture toe",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "fracture toe",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1656.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1656.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1657",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1657",
    "phenotype": "Non-cancer illness code, self-reported: septicaemia / sepsis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "septicaemia / sepsis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1657.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1657.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1660",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1660",
    "phenotype": "Non-cancer illness code, self-reported: rosacea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "rosacea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1660.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1660.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1661",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1661",
    "phenotype": "Non-cancer illness code, self-reported: vitiligo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "vitiligo",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1661.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1661.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1668",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1668",
    "phenotype": "Non-cancer illness code, self-reported: allergy to house dust mite",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "allergy to house dust mite",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1668.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1668.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1677",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1677",
    "phenotype": "Non-cancer illness code, self-reported: scarlet fever / scarlatina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "scarlet fever / scarlatina",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1677.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1677.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_1683",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_1683",
    "phenotype": "Non-cancer illness code, self-reported: benign neuroma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "benign neuroma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_1683.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_1683.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20002_99999",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20002_99999",
    "phenotype": "Non-cancer illness code, self-reported: unclassifiable",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "unclassifiable non-cancer illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20002_99999.gwas.imputed_v3.both_sexes.tsv.bgz -O 20002_99999.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140851088",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140851088",
    "phenotype": "Treatment/medication code: senokot 7.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (senna)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140851088.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140851088.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140851812",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140851812",
    "phenotype": "Treatment/medication code: gtn 400micrograms spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (glyceryl trinitrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140851812.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140851812.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140852756",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140852756",
    "phenotype": "Treatment/medication code: vitamin a",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin A",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140852756.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140852756.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140852948",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140852948",
    "phenotype": "Treatment/medication code: calcium+vitamin d 500units tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin/mineral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140852948.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140852948.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140852976",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140852976",
    "phenotype": "Treatment/medication code: multivitamins",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "multivitamin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140852976.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140852976.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140856342",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140856342",
    "phenotype": "Treatment/medication code: syndol tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic combination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140856342.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140856342.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140858452",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140858452",
    "phenotype": "Treatment/medication code: hepacon b12 1mg/1ml injection",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B12",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140858452.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140858452.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860696",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860696",
    "phenotype": "Treatment/medication code: lisinopril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860696.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860696.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860728",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860728",
    "phenotype": "Treatment/medication code: quinapril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860728.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860728.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860750",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860750",
    "phenotype": "Treatment/medication code: captopril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860750.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860750.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860802",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860802",
    "phenotype": "Treatment/medication code: coversyl 2mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860802.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860802.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860806",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860806",
    "phenotype": "Treatment/medication code: ramipril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860806.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860806.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860834",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860834",
    "phenotype": "Treatment/medication code: glyceryl trinitrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (glyceryl trinitrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860834.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860834.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860840",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860840",
    "phenotype": "Treatment/medication code: nitrolingual 400micrograms spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (glyceryl trinitrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860840.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860840.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860904",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860904",
    "phenotype": "Treatment/medication code: trandolapril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860904.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860904.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860954",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860954",
    "phenotype": "Treatment/medication code: isosorbide mononitrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (nitrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860954.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860954.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140860976",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140860976",
    "phenotype": "Treatment/medication code: imdur 60mg durule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (isosorbide mononitrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140860976.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140860976.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861088",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861088",
    "phenotype": "Treatment/medication code: nifedipine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive / antianginal (calcium channel blocker)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861088.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861088.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861090",
    "phenotype": "Treatment/medication code: adalat 5mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (nifedipine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861090.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861120",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861120",
    "phenotype": "Treatment/medication code: coracten sr 10mg m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (nifedipine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861120.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861120.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861128",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861128",
    "phenotype": "Treatment/medication code: tildiem 60mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (diltiazem)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861128.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861128.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861138",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861138",
    "phenotype": "Treatment/medication code: adizem-60 m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (diltiazem)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861138.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861138.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861166",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861166",
    "phenotype": "Treatment/medication code: dilzem sr 60mg long acting m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (diltiazem)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861166.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861166.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861202",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861202",
    "phenotype": "Treatment/medication code: istin 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (amlodipine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861202.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861202.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861276",
    "phenotype": "Treatment/medication code: lacidipine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (calcium channel blocker)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861276.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861778",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861778",
    "phenotype": "Treatment/medication code: dipyridamole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiplatelet",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861778.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861778.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861780",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861780",
    "phenotype": "Treatment/medication code: persantin 25mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiplatelet (dipyridamole)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861780.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861780.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861806",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861806",
    "phenotype": "Treatment/medication code: aspirin 75mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiplatelet (aspirin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861806.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861806.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861924",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861924",
    "phenotype": "Treatment/medication code: bezafibrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lipid-lowering (fibrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861924.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861924.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861936",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861936",
    "phenotype": "Treatment/medication code: questran 4g/sachet powder",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lipid-lowering (bile acid sequestrant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861936.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861936.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861954",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861954",
    "phenotype": "Treatment/medication code: fenofibrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lipid-lowering (fibrate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861954.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861954.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861958",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861958",
    "phenotype": "Treatment/medication code: simvastatin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "statin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861958.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861958.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140861998",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140861998",
    "phenotype": "Treatment/medication code: ventolin 100micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (salbutamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140861998.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140861998.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862060",
    "phenotype": "Treatment/medication code: ventolin 2mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (salbutamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862060.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862086",
    "phenotype": "Treatment/medication code: salamol 100micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (salbutamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862144",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862144",
    "phenotype": "Treatment/medication code: salmeterol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (long-acting beta agonist)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862144.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862144.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862148",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862148",
    "phenotype": "Treatment/medication code: serevent 25mcg inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (salmeterol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862148.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862148.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862168",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862168",
    "phenotype": "Treatment/medication code: bricanyl 250mcg inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (terbutaline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862168.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862168.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862236",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862236",
    "phenotype": "Treatment/medication code: atrovent 20micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (ipratropium)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862236.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862236.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862266",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862266",
    "phenotype": "Treatment/medication code: phyllocontin continus 225mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "xanthine bronchodilator (aminophylline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862266.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862266.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862380",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862380",
    "phenotype": "Treatment/medication code: becloforte 250micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (beclometasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862380.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862380.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862382",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862382",
    "phenotype": "Treatment/medication code: becotide 50 inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (beclometasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862382.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862382.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862438",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862438",
    "phenotype": "Treatment/medication code: uniphyllin continus 200mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "xanthine bronchodilator (theophylline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862438.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862438.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862476",
    "phenotype": "Treatment/medication code: beclazone 50 inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (beclometasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862476.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862526",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862526",
    "phenotype": "Treatment/medication code: sodium cromoglycate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mast cell stabiliser",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862526.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862526.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862572",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862572",
    "phenotype": "Treatment/medication code: budesonide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862572.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862572.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862574",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862574",
    "phenotype": "Treatment/medication code: pulmicort ls 50micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (budesonide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862574.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862574.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862628",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862628",
    "phenotype": "Treatment/medication code: piriton 4mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine (chlorphenamine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862628.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862628.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862770",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862770",
    "phenotype": "Treatment/medication code: zirtek 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine (cetirizine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862770.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862770.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862772",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862772",
    "phenotype": "Treatment/medication code: loratadine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862772.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862772.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862776",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862776",
    "phenotype": "Treatment/medication code: clarityn 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine (loratadine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862776.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862776.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862944",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862944",
    "phenotype": "Treatment/medication code: carbocisteine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mucolytic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862944.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862944.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140862952",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140862952",
    "phenotype": "Treatment/medication code: mucodyne 375mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mucolytic (carbocisteine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140862952.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140862952.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140863144",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140863144",
    "phenotype": "Treatment/medication code: zopiclone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "hypnotic (non-benzodiazepine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140863144.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140863144.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140863152",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140863152",
    "phenotype": "Treatment/medication code: diazepam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "benzodiazepine (anxiolytic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140863152.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140863152.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140863182",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140863182",
    "phenotype": "Treatment/medication code: nitrazepam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "benzodiazepine (hypnotic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140863182.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140863182.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140863202",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140863202",
    "phenotype": "Treatment/medication code: temazepam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "benzodiazepine (hypnotic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140863202.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140863202.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140863302",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140863302",
    "phenotype": "Treatment/medication code: lorazepam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "benzodiazepine (anxiolytic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140863302.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140863302.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864070",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864070",
    "phenotype": "Treatment/medication code: kapake tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (codeine + paracetamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864070.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864070.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864184",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864184",
    "phenotype": "Treatment/medication code: dovonex 50micrograms/g cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antipsoriatic (calcipotriol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864184.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864184.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864286",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864286",
    "phenotype": "Treatment/medication code: flixotide 25micrograms inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (fluticasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864286.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864286.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864734",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864734",
    "phenotype": "Treatment/medication code: combivent inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator combination (ipratropium + salbutamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864734.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864734.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864752",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864752",
    "phenotype": "Treatment/medication code: lansoprazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "proton pump inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864752.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864752.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864950",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864950",
    "phenotype": "Treatment/medication code: bisoprolol fumarate+hydrochlorothiazide 10mg/6.25mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (beta-blocker + diuretic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864950.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864950.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864952",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864952",
    "phenotype": "Treatment/medication code: lisinopril+hydrochlorothiazide 10mg/12.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (ACE inhibitor + diuretic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864952.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864952.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140864992",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140864992",
    "phenotype": "Treatment/medication code: tramadol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (opioid-like)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140864992.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140864992.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865000",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865000",
    "phenotype": "Treatment/medication code: zydol 50mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (tramadol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865000.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865000.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865010",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865010",
    "phenotype": "Treatment/medication code: viscotears liquid eye gel",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865010.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865010.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865016",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865016",
    "phenotype": "Treatment/medication code: zolpidem",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "hypnotic (non-benzodiazepine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865016.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865016.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865336",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865336",
    "phenotype": "Treatment/medication code: spasmonal 60mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (alverine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865336.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865336.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865350",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865350",
    "phenotype": "Treatment/medication code: fybogel mebeverine sachet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic + bulk laxative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865350.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865350.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865354",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865354",
    "phenotype": "Treatment/medication code: gaviscon liquid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antacid / alginate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865354.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865354.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865382",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865382",
    "phenotype": "Treatment/medication code: merbentyl 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (dicycloverine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865382.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865382.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865394",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865394",
    "phenotype": "Treatment/medication code: hyoscine butylbromide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865394.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865394.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865396",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865396",
    "phenotype": "Treatment/medication code: buscopan 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (hyoscine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865396.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865396.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865414",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865414",
    "phenotype": "Treatment/medication code: peppermint oil product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (herbal)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865414.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865414.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865416",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865416",
    "phenotype": "Treatment/medication code: colpermin 0.2ml m/r gel e/c capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (peppermint oil)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865416.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865416.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865426",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865426",
    "phenotype": "Treatment/medication code: cimetidine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "H2 antagonist",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865426.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865426.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865564",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865564",
    "phenotype": "Treatment/medication code: imodium 2mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiarrheal (loperamide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865564.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865564.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865578",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865578",
    "phenotype": "Treatment/medication code: mesalazine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate (IBD)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865578.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865578.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865580",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865580",
    "phenotype": "Treatment/medication code: asacol 400mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate (mesalazine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865580.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865580.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865588",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865588",
    "phenotype": "Treatment/medication code: pentasa sr 250mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate (mesalazine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865588.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865588.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865634",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865634",
    "phenotype": "Treatment/medication code: omeprazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "proton pump inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865634.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865634.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865654",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865654",
    "phenotype": "Treatment/medication code: codeine phosphate+kaolin 10mg/3g/10ml mixture",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiarrheal (opioid + adsorbent)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865654.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865654.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865668",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865668",
    "phenotype": "Treatment/medication code: sulphasalazine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate / disease-modifying",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865668.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865668.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865670",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865670",
    "phenotype": "Treatment/medication code: salazopyrin 500mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "sulphasalazine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865670.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865670.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865716",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865716",
    "phenotype": "Treatment/medication code: senna",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (stimulant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865716.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865716.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865752",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865752",
    "phenotype": "Treatment/medication code: ispaghula husk",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bulk laxative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865752.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865752.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865786",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865786",
    "phenotype": "Treatment/medication code: bisacodyl",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (stimulant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865786.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865786.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865800",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865800",
    "phenotype": "Treatment/medication code: lactulose product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (osmotic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865800.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865800.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140865872",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140865872",
    "phenotype": "Treatment/medication code: magnesium citrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (osmotic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140865872.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140865872.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866026",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866026",
    "phenotype": "Treatment/medication code: creon e/c granules in capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "pancreatic enzyme",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866026.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866026.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866078",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866078",
    "phenotype": "Treatment/medication code: indapamide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (thiazide-like)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866078.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866078.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866116",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866116",
    "phenotype": "Treatment/medication code: frusemide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (loop)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866116.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866116.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866122",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866122",
    "phenotype": "Treatment/medication code: bendrofluazide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (thiazide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866122.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866122.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866236",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866236",
    "phenotype": "Treatment/medication code: spironolactone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (aldosterone antagonist)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866236.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866236.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866280",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866280",
    "phenotype": "Treatment/medication code: bumetanide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (loop)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866280.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866280.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866466",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866466",
    "phenotype": "Treatment/medication code: securon 40mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (bumetanide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866466.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866466.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866738",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866738",
    "phenotype": "Treatment/medication code: atenolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866738.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866738.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866800",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866800",
    "phenotype": "Treatment/medication code: half-inderal la 80mg m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker (propranolol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866800.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866800.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140866804",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140866804",
    "phenotype": "Treatment/medication code: inderal 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker (propranolol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140866804.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140866804.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867444",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867444",
    "phenotype": "Treatment/medication code: risperidone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antipsychotic (atypical)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867444.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867444.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867490",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867490",
    "phenotype": "Treatment/medication code: lithium product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mood stabiliser (lithium)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867490.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867490.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867504",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867504",
    "phenotype": "Treatment/medication code: priadel 200mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lithium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867504.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867504.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867726",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867726",
    "phenotype": "Treatment/medication code: lofepramine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867726.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867726.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867818",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867818",
    "phenotype": "Treatment/medication code: nortriptyline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867818.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867818.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867876",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867876",
    "phenotype": "Treatment/medication code: prozac 20mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SSRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867876.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867876.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867878",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867878",
    "phenotype": "Treatment/medication code: sertraline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SSRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867878.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867878.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867888",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867888",
    "phenotype": "Treatment/medication code: paroxetine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SSRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867888.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867888.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140867998",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140867998",
    "phenotype": "Treatment/medication code: motilium 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prokinetic / antiemetic (domperidone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140867998.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140867998.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868064",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868064",
    "phenotype": "Treatment/medication code: serc-8 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antivertigo (betahistine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868064.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868064.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868080",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868080",
    "phenotype": "Treatment/medication code: cyclizine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiemetic (antihistamine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868080.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868080.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868170",
    "phenotype": "Treatment/medication code: prochlorperazine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiemetic / antipsychotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868170.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868172",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868172",
    "phenotype": "Treatment/medication code: stemetil 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prochlorperazine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868172.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868172.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868226",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868226",
    "phenotype": "Treatment/medication code: aspirin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiplatelet / analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868226.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868226.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868364",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868364",
    "phenotype": "Treatment/medication code: prednisone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid (systemic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868364.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868364.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868426",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868426",
    "phenotype": "Treatment/medication code: triamcinolone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868426.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868426.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140868772",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140868772",
    "phenotype": "Treatment/medication code: didronel 200mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bisphosphonate (etidronate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140868772.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140868772.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140869848",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140869848",
    "phenotype": "Treatment/medication code: methotrexate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "disease-modifying antirheumatic / immunosuppressant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140869848.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140869848.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140869930",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140869930",
    "phenotype": "Treatment/medication code: azathioprine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "immunosuppressant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140869930.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140869930.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870306",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870306",
    "phenotype": "Treatment/medication code: iron+folic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "hematinic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870306.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870306.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870390",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870390",
    "phenotype": "Treatment/medication code: ferrous sulphate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870390.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870390.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870422",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870422",
    "phenotype": "Treatment/medication code: folic acid product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin (folic acid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870422.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870422.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870488",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870488",
    "phenotype": "Treatment/medication code: forceval capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "multivitamin + mineral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870488.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870488.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870570",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870570",
    "phenotype": "Treatment/medication code: vitamin b12 preparation",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B12",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870570.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870570.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870788",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870788",
    "phenotype": "Treatment/medication code: calcium salts",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870788.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870788.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870856",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870856",
    "phenotype": "Treatment/medication code: calcichew 1.25g chewable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870856.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870856.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870862",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870862",
    "phenotype": "Treatment/medication code: calcichew forte 2.5g chewable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870862.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870862.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870954",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870954",
    "phenotype": "Treatment/medication code: vitamin d product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870954.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870954.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140870956",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140870956",
    "phenotype": "Treatment/medication code: alfacalcidol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin D analogue",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140870956.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140870956.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871024",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871024",
    "phenotype": "Treatment/medication code: vitamin b compound tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "B vitamin complex",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871024.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871024.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871050",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871050",
    "phenotype": "Treatment/medication code: calcichew d3 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871050.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871050.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871052",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871052",
    "phenotype": "Treatment/medication code: calcium carbonate+cholecalciferol 1.25g/5micrograms tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871052.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871052.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871112",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871112",
    "phenotype": "Treatment/medication code: vitamin e product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin E",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871112.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871112.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871168",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871168",
    "phenotype": "Treatment/medication code: voltarol 25mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID (diclofenac)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871168.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871168.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871188",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871188",
    "phenotype": "Treatment/medication code: etodolac",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871188.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871188.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871196",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871196",
    "phenotype": "Treatment/medication code: lodine 200mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID (etodolac)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871196.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871196.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871266",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871266",
    "phenotype": "Treatment/medication code: arthrotec tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID + misoprostol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871266.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871266.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871310",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871310",
    "phenotype": "Treatment/medication code: ibuprofen",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871310.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871310.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871336",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871336",
    "phenotype": "Treatment/medication code: indomethacin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871336.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871336.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871462",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871462",
    "phenotype": "Treatment/medication code: naproxen",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871462.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871462.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871472",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871472",
    "phenotype": "Treatment/medication code: naprosyn 250mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID (naproxen)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871472.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871472.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871506",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871506",
    "phenotype": "Treatment/medication code: ketoprofen",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871506.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871506.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871542",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871542",
    "phenotype": "Treatment/medication code: mefenamic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871542.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871542.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871666",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871666",
    "phenotype": "Treatment/medication code: piroxicam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871666.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871666.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871680",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871680",
    "phenotype": "Treatment/medication code: tylex capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (paracetamol + codeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871680.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871680.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871688",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871688",
    "phenotype": "Treatment/medication code: solpadol caplet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (paracetamol + codeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871688.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871688.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871692",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871692",
    "phenotype": "Treatment/medication code: morphine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871692.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871692.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140871732",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140871732",
    "phenotype": "Treatment/medication code: buprenorphine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic / substitution",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140871732.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140871732.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872036",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872036",
    "phenotype": "Treatment/medication code: paramax tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiemetic + analgesic (?) likely paracetamol + metoclopramide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872036.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872036.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872072",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872072",
    "phenotype": "Treatment/medication code: tegretol 100mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant (carbamazepine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872072.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872072.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872112",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872112",
    "phenotype": "Treatment/medication code: epanutin 25mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant (phenytoin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872112.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872112.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872150",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872150",
    "phenotype": "Treatment/medication code: clonazepam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "benzodiazepine (anticonvulsant / anxiolytic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872150.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872150.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872198",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872198",
    "phenotype": "Treatment/medication code: sodium valproate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant (valproate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872198.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872198.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872200",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872200",
    "phenotype": "Treatment/medication code: epilim 100mg crushable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "sodium valproate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872200.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872200.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872228",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872228",
    "phenotype": "Treatment/medication code: gabapentin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant / neuropathic pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872228.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872228.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872290",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872290",
    "phenotype": "Treatment/medication code: lamotrigine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872290.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872290.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872338",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872338",
    "phenotype": "Treatment/medication code: madopar 62.5 capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiparkinson (levodopa + benserazide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872338.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872338.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872492",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872492",
    "phenotype": "Treatment/medication code: nicotine product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nicotine product",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872492.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872492.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140872694",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140872694",
    "phenotype": "Treatment/medication code: flucloxacillin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (penicillinase-resistant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140872694.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140872694.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873394",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873394",
    "phenotype": "Treatment/medication code: doxycycline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (tetracycline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873394.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873394.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873450",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873450",
    "phenotype": "Treatment/medication code: tetracycline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873450.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873450.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873474",
    "phenotype": "Treatment/medication code: lymecycline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (tetracycline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873474.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873476",
    "phenotype": "Treatment/medication code: tetralysal 300 capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lymecycline",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873476.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873480",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873480",
    "phenotype": "Treatment/medication code: minocycline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (tetracycline)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873480.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873480.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873548",
    "phenotype": "Treatment/medication code: oxytetracycline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873548.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873608",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873608",
    "phenotype": "Treatment/medication code: erythromycin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (macrolide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873608.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873608.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140873966",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140873966",
    "phenotype": "Treatment/medication code: trimethoprim",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140873966.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140873966.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874014",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874014",
    "phenotype": "Treatment/medication code: metronidazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (anaerobic / antiprotozoal)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874014.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874014.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874126",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874126",
    "phenotype": "Treatment/medication code: nitrofurantoin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "urinary antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874126.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874126.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874138",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874138",
    "phenotype": "Treatment/medication code: ciprofloxacin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (fluoroquinolone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874138.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874138.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874370",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874370",
    "phenotype": "Treatment/medication code: aciclovir",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiviral (herpes)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874370.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874370.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874420",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874420",
    "phenotype": "Treatment/medication code: quinine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antimalarial / muscle cramp",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874420.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874420.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874686",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874686",
    "phenotype": "Treatment/medication code: glucophage 500mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiabetic (metformin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874686.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874686.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874744",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874744",
    "phenotype": "Treatment/medication code: gliclazide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiabetic (sulphonylurea)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874744.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874744.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874790",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874790",
    "phenotype": "Treatment/medication code: betamethasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874790.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874790.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874852",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874852",
    "phenotype": "Treatment/medication code: thyroxine sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thyroid hormone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874852.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874852.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874866",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874866",
    "phenotype": "Treatment/medication code: carbimazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antithyroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874866.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874866.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874896",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874896",
    "phenotype": "Treatment/medication code: hydrocortisone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874896.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874896.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140874930",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140874930",
    "phenotype": "Treatment/medication code: prednisolone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid (systemic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140874930.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140874930.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875336",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875336",
    "phenotype": "Treatment/medication code: nabumetone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875336.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875336.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875392",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875392",
    "phenotype": "Treatment/medication code: plaquenil 200mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "disease-modifying (hydroxychloroquine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875392.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875392.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875408",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875408",
    "phenotype": "Treatment/medication code: allopurinol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "xanthine oxidase inhibitor (gout)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875408.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875408.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875420",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875420",
    "phenotype": "Treatment/medication code: baclofen",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "muscle relaxant (GABA agonist)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875420.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875420.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875486",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875486",
    "phenotype": "Treatment/medication code: colchicine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antigout",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875486.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875486.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875632",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875632",
    "phenotype": "Treatment/medication code: movelat gel",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "topical NSAID (mucopolysaccharide + salicylic acid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875632.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875632.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875840",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875840",
    "phenotype": "Treatment/medication code: timolol 0.25% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic beta-blocker (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875840.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875840.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140875990",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140875990",
    "phenotype": "Treatment/medication code: hypromellose",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140875990.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140875990.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140876076",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140876076",
    "phenotype": "Treatment/medication code: flixonase 50micrograms aqueous nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nasal corticosteroid (fluticasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140876076.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140876076.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140876136",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140876136",
    "phenotype": "Treatment/medication code: beconase 50micrograms nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nasal corticosteroid (beclometasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140876136.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140876136.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140876146",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140876146",
    "phenotype": "Treatment/medication code: rhinocort 50micrograms nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nasal corticosteroid (budesonide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140876146.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140876146.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140876404",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140876404",
    "phenotype": "Treatment/medication code: aqueous cream bp",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140876404.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140876404.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140876592",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140876592",
    "phenotype": "Treatment/medication code: multivitamin+mineral preparations",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "multivitamin + mineral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140876592.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140876592.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140877630",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140877630",
    "phenotype": "Treatment/medication code: calcium+ergocalciferol tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D2",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140877630.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140877630.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140877826",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140877826",
    "phenotype": "Treatment/medication code: sodium bicarbonate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "systemic alkaliniser / antacid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140877826.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140877826.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140877892",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140877892",
    "phenotype": "Treatment/medication code: voltarol emulgel",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "topical NSAID (diclofenac)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140877892.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140877892.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878036",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878036",
    "phenotype": "Treatment/medication code: diclofenac sodium+misoprostol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID + gastroprotective",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878036.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878036.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878172",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878172",
    "phenotype": "Treatment/medication code: tears naturale eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878172.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878172.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878186",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878186",
    "phenotype": "Treatment/medication code: liquifilm tears 1.4% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878186.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878186.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878226",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878226",
    "phenotype": "Treatment/medication code: diprobase cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878226.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878226.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878304",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878304",
    "phenotype": "Treatment/medication code: e45 cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878304.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878304.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140878324",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140878324",
    "phenotype": "Treatment/medication code: oilatum cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140878324.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140878324.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879392",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879392",
    "phenotype": "Treatment/medication code: manevac granules",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (ispaghula)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879392.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879392.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879404",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879404",
    "phenotype": "Treatment/medication code: docusate sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (stool softener)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879404.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879404.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879406",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879406",
    "phenotype": "Treatment/medication code: ranitidine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "H2 antagonist",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879406.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879406.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879424",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879424",
    "phenotype": "Treatment/medication code: alverine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879424.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879424.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879428",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879428",
    "phenotype": "Treatment/medication code: mebeverine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879428.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879428.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879430",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879430",
    "phenotype": "Treatment/medication code: domperidone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prokinetic / antiemetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879430.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879430.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879464",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879464",
    "phenotype": "Treatment/medication code: loperamide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiarrheal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879464.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879464.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879494",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879494",
    "phenotype": "Treatment/medication code: metoclopramide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiemetic / prokinetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879494.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879494.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879540",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879540",
    "phenotype": "Treatment/medication code: fluoxetine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SSRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879540.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879540.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879616",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879616",
    "phenotype": "Treatment/medication code: amitriptyline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879616.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879616.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879620",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879620",
    "phenotype": "Treatment/medication code: clomipramine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879620.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879620.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879628",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879628",
    "phenotype": "Treatment/medication code: dothiepin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879628.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879628.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879630",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879630",
    "phenotype": "Treatment/medication code: imipramine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (tricyclic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879630.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879630.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879634",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879634",
    "phenotype": "Treatment/medication code: trazodone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SARI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879634.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879634.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879644",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879644",
    "phenotype": "Treatment/medication code: amantadine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiparkinson / antiviral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879644.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879644.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879658",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879658",
    "phenotype": "Treatment/medication code: chlorpromazine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antipsychotic (phenothiazine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879658.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879658.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879760",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879760",
    "phenotype": "Treatment/medication code: bisoprolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879760.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879760.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879762",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879762",
    "phenotype": "Treatment/medication code: celiprolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879762.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879762.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879778",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879778",
    "phenotype": "Treatment/medication code: doxazosin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "alpha-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879778.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879778.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879792",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879792",
    "phenotype": "Treatment/medication code: terbutaline",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879792.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879792.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879798",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879798",
    "phenotype": "Treatment/medication code: terazosin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "alpha-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879798.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879798.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879802",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879802",
    "phenotype": "Treatment/medication code: amlodipine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879802.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879802.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879806",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879806",
    "phenotype": "Treatment/medication code: diltiazem",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879806.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879806.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879818",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879818",
    "phenotype": "Treatment/medication code: metoprolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879818.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879818.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879842",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879842",
    "phenotype": "Treatment/medication code: propranolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879842.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879842.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879854",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879854",
    "phenotype": "Treatment/medication code: sotalol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker / antiarrhythmic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879854.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879854.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140879866",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140879866",
    "phenotype": "Treatment/medication code: timolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140879866.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140879866.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140880072",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140880072",
    "phenotype": "Treatment/medication code: gamolenic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "essential fatty acid (evening primrose oil)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140880072.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140880072.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140880086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140880086",
    "phenotype": "Treatment/medication code: calcipotriol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin D analogue (antipsoriatic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140880086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140880086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140880956",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140880956",
    "phenotype": "Treatment/medication code: fentanyl",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140880956.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140880956.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881320",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881320",
    "phenotype": "Treatment/medication code: magnesium carbonate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antacid / magnesium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881320.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881320.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881446",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881446",
    "phenotype": "Treatment/medication code: proctosedyl ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "topical haemorrhoid (corticosteroid + local anaesthetic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881446.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881446.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881472",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881472",
    "phenotype": "Treatment/medication code: lacri-lube eye ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881472.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881472.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881474",
    "phenotype": "Treatment/medication code: normacol granules",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bulk laxative (sterculia)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881474.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881702",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881702",
    "phenotype": "Treatment/medication code: adalate 10mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nifedipine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881702.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881702.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881856",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881856",
    "phenotype": "Treatment/medication code: salbutamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881856.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881856.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140881882",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140881882",
    "phenotype": "Treatment/medication code: timoptol 0.25% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "timolol ophthalmic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140881882.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140881882.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882236",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882236",
    "phenotype": "Treatment/medication code: seroxat 20mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "paroxetine (SSRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882236.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882236.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882272",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882272",
    "phenotype": "Treatment/medication code: oramorph 10mg/5ml oral solution",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "morphine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882272.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882272.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882394",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882394",
    "phenotype": "Treatment/medication code: paracetamol + codeine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic combination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882394.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882394.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882498",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882498",
    "phenotype": "Treatment/medication code: penicillin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882498.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882498.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882618",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882618",
    "phenotype": "Treatment/medication code: diprosalic ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "topical corticosteroid + salicylic acid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882618.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882618.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882626",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882626",
    "phenotype": "Treatment/medication code: betnesol 0.1% eye/ear/nose drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "betamethasone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882626.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882626.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882694",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882694",
    "phenotype": "Treatment/medication code: betnovate cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "betamethasone topical",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882694.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882694.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882728",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882728",
    "phenotype": "Treatment/medication code: otomize ear spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ear spray (dexamethasone + acetic acid + neomycin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882728.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882728.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882776",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882776",
    "phenotype": "Treatment/medication code: fucibet cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "fusidic acid + betamethasone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882776.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882776.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882782",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882782",
    "phenotype": "Treatment/medication code: dermovate cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "clobetasol (potent corticosteroid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882782.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882782.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882800",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882800",
    "phenotype": "Treatment/medication code: eumovate cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "clobetasone (mild corticosteroid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882800.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882800.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140882910",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140882910",
    "phenotype": "Treatment/medication code: daktacort cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "miconazole + hydrocortisone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140882910.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140882910.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883066",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883066",
    "phenotype": "Treatment/medication code: insulin product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "insulin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883066.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883066.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883468",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883468",
    "phenotype": "Treatment/medication code: clonidine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive / other",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883468.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883468.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883476",
    "phenotype": "Treatment/medication code: procyclidine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticholinergic (antiparkinson)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883476.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883504",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883504",
    "phenotype": "Treatment/medication code: cetirizine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883504.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883504.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883524",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883524",
    "phenotype": "Treatment/medication code: cinnarizine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antivertigo / antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883524.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883524.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883548",
    "phenotype": "Treatment/medication code: ipratropium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator (anticholinergic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883548.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883568",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883568",
    "phenotype": "Treatment/medication code: oxybutynin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticholinergic (overactive bladder)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883568.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883568.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883656",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883656",
    "phenotype": "Treatment/medication code: hydroxyzine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine / anxiolytic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883656.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883656.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883664",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883664",
    "phenotype": "Treatment/medication code: pizotifen",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antimigraine (serotonin antagonist)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883664.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883664.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883748",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883748",
    "phenotype": "Treatment/medication code: selenium product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mineral supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883748.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883748.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140883968",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140883968",
    "phenotype": "Treatment/medication code: carmellose",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140883968.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140883968.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884308",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884308",
    "phenotype": "Treatment/medication code: hydroxychloroquine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "disease-modifying / antimalarial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884308.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884308.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884412",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884412",
    "phenotype": "Treatment/medication code: sumatriptan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antimigraine (triptan)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884412.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884412.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884444",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884444",
    "phenotype": "Treatment/medication code: codeine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884444.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884444.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884464",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884464",
    "phenotype": "Treatment/medication code: dihydrocodeine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884464.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884464.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884488",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884488",
    "phenotype": "Treatment/medication code: diclofenac",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884488.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884488.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884516",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884516",
    "phenotype": "Treatment/medication code: thyroxine product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thyroid hormone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884516.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884516.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884600",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884600",
    "phenotype": "Treatment/medication code: metformin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiabetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884600.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884600.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884654",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884654",
    "phenotype": "Treatment/medication code: beclomethasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884654.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884654.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884672",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884672",
    "phenotype": "Treatment/medication code: fludrocortisone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mineralocorticoid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884672.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884672.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884696",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884696",
    "phenotype": "Treatment/medication code: clobetasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid (topical)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884696.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884696.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140884700",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140884700",
    "phenotype": "Treatment/medication code: trimovate ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "clobetasone + nystatin + oxytetracycline",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140884700.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140884700.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888092",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888092",
    "phenotype": "Treatment/medication code: elocon cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mometasone (corticosteroid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888092.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888092.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888098",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888098",
    "phenotype": "Treatment/medication code: fluticasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888098.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888098.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888172",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888172",
    "phenotype": "Treatment/medication code: mometasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888172.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888172.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888266",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888266",
    "phenotype": "Treatment/medication code: warfarin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticoagulant (vitamin K antagonist)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888266.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888266.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888362",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888362",
    "phenotype": "Treatment/medication code: pyridoxine preparation",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B6",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888362.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888362.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888366",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888366",
    "phenotype": "Treatment/medication code: thiamine preparation",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B1",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888366.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888366.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888386",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888386",
    "phenotype": "Treatment/medication code: iron product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888386.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888386.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888390",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888390",
    "phenotype": "Treatment/medication code: ferrous salt product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888390.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888390.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888502",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888502",
    "phenotype": "Treatment/medication code: amiodarone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiarrhythmic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888502.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888502.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888510",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888510",
    "phenotype": "Treatment/medication code: verapamil",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888510.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888510.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888512",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888512",
    "phenotype": "Treatment/medication code: amiloride",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diuretic (potassium-sparing)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888512.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888512.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888538",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888538",
    "phenotype": "Treatment/medication code: zinc product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mineral supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888538.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888538.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888552",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888552",
    "phenotype": "Treatment/medication code: enalapril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ACE inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888552.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888552.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888556",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888556",
    "phenotype": "Treatment/medication code: fosinopril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ACE inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888556.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888556.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888560",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888560",
    "phenotype": "Treatment/medication code: perindopril",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ACE inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888560.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888560.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888570",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888570",
    "phenotype": "Treatment/medication code: flecainide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiarrhythmic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888570.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888570.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888594",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888594",
    "phenotype": "Treatment/medication code: fluvastatin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "statin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888594.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888594.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888646",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888646",
    "phenotype": "Treatment/medication code: felodipine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888646.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888646.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888648",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888648",
    "phenotype": "Treatment/medication code: pravastatin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "statin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888648.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888648.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888688",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888688",
    "phenotype": "Treatment/medication code: betahistine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antivertigo",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888688.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888688.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888758",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888758",
    "phenotype": "Treatment/medication code: penicillin v",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888758.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888758.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140888762",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140888762",
    "phenotype": "Treatment/medication code: ismn - isosorbide mononitrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140888762.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140888762.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909368",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909368",
    "phenotype": "Treatment/medication code: carvedilol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909368.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909368.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909482",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909482",
    "phenotype": "Treatment/medication code: opticrom allergy eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mast cell stabiliser (sodium cromoglicate)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909482.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909482.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909578",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909578",
    "phenotype": "Treatment/medication code: losec 10mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "omeprazole",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909578.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909578.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909674",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909674",
    "phenotype": "Treatment/medication code: cod liver oil capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "omega-3 / vitamin A,D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909674.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909674.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909702",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909702",
    "phenotype": "Treatment/medication code: sulfasalazine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate (already)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909702.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909702.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909708",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909708",
    "phenotype": "Treatment/medication code: furosemide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "loop diuretic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909708.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909708.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909726",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909726",
    "phenotype": "Treatment/medication code: vitamin c product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin C",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909726.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909726.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909766",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909766",
    "phenotype": "Treatment/medication code: multivitamins capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "multivitamin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909766.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909766.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909786",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909786",
    "phenotype": "Treatment/medication code: beclometasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909786.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909786.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909788",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909788",
    "phenotype": "Treatment/medication code: sodium cromoglicate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mast cell stabiliser",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909788.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909788.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909790",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909790",
    "phenotype": "Treatment/medication code: chlorphenamine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909790.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909790.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909806",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909806",
    "phenotype": "Treatment/medication code: dosulepin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "tricyclic antidepressant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909806.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909806.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909872",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909872",
    "phenotype": "Treatment/medication code: vitamin b1 preparation",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thiamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909872.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909872.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909874",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909874",
    "phenotype": "Treatment/medication code: vitamin b6 preparation",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "pyridoxine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909874.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909874.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909936",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909936",
    "phenotype": "Treatment/medication code: indometacin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909936.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909936.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140909954",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140909954",
    "phenotype": "Treatment/medication code: acyclovir",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiviral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140909954.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140909954.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910494",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910494",
    "phenotype": "Treatment/medication code: b12 - hydroxocobalamin prep",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B12",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910494.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910494.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910498",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910498",
    "phenotype": "Treatment/medication code: flu - influenza vaccine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vaccine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910498.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910498.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910512",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910512",
    "phenotype": "Treatment/medication code: ismo - isosorbide mononitrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910512.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910512.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910548",
    "phenotype": "Treatment/medication code: iron sulphate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910548.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910640",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910640",
    "phenotype": "Treatment/medication code: luteine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal / supplement (lutein)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910640.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910640.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910698",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910698",
    "phenotype": "Treatment/medication code: oil of peppermint",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antispasmodic (herbal)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910698.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910698.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910766",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910766",
    "phenotype": "Treatment/medication code: nicorandil",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antianginal (potassium channel activator)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910766.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910766.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910814",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910814",
    "phenotype": "Treatment/medication code: sodium thyroxine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "levothyroxine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910814.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910814.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140910832",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140910832",
    "phenotype": "Treatment/medication code: sodium warfarin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "warfarin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140910832.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140910832.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911638",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911638",
    "phenotype": "Treatment/medication code: kelp+garlic product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal / dietary supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911638.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911638.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911640",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911640",
    "phenotype": "Treatment/medication code: lecithin product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dietary supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911640.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911640.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911642",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911642",
    "phenotype": "Treatment/medication code: tacrolimus",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "immunosuppressant (calcineurin inhibitor)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911642.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911642.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911658",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911658",
    "phenotype": "Treatment/medication code: imigran 50mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "sumatriptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911658.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911658.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911682",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911682",
    "phenotype": "Treatment/medication code: selenium ace tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "selenium + vitamins",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911682.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911682.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911698",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911698",
    "phenotype": "Treatment/medication code: slozem 120mg m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diltiazem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911698.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911698.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911730",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911730",
    "phenotype": "Treatment/medication code: flax oil tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "omega-3 supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911730.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911730.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911732",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911732",
    "phenotype": "Treatment/medication code: garlic product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911732.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911732.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911734",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911734",
    "phenotype": "Treatment/medication code: ginkgo forte tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal supplement (ginkgo)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911734.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911734.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911736",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911736",
    "phenotype": "Treatment/medication code: ginseng product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911736.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911736.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140911754",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140911754",
    "phenotype": "Treatment/medication code: anadin tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (aspirin/paracetamol/caffeine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140911754.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140911754.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140913292",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140913292",
    "phenotype": "Treatment/medication code: synalar 1:10 cream",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "fluocinolone (corticosteroid)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140913292.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140913292.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140916282",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140916282",
    "phenotype": "Treatment/medication code: venlafaxine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SNRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140916282.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140916282.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140916288",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140916288",
    "phenotype": "Treatment/medication code: efexor 37.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "venlafaxine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140916288.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140916288.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140916356",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140916356",
    "phenotype": "Treatment/medication code: losartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "angiotensin II receptor blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140916356.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140916356.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140916682",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140916682",
    "phenotype": "Treatment/medication code: evening primrose oil",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal supplement (GLA)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140916682.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140916682.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140916980",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140916980",
    "phenotype": "Treatment/medication code: zantac 75 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ranitidine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140916980.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140916980.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140917034",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140917034",
    "phenotype": "Treatment/medication code: airomir 100micrograms cfc-free inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "salbutamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140917034.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140917034.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140917428",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140917428",
    "phenotype": "Treatment/medication code: angitil sr 90 m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diltiazem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140917428.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140917428.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140921600",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140921600",
    "phenotype": "Treatment/medication code: citalopram",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "SSRI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140921600.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140921600.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140921828",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140921828",
    "phenotype": "Treatment/medication code: dicloflex 25mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diclofenac",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140921828.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140921828.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140922174",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140922174",
    "phenotype": "Treatment/medication code: alendronate sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bisphosphonate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140922174.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140922174.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140922714",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140922714",
    "phenotype": "Treatment/medication code: dorzolamide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "carbonic anhydrase inhibitor (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140922714.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140922714.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923276",
    "phenotype": "Treatment/medication code: co-amilozide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "amiloride + hydrochlorothiazide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923276.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923336",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923336",
    "phenotype": "Treatment/medication code: co-tenidone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "atenolol + chlortalidone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923336.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923336.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923346",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923346",
    "phenotype": "Treatment/medication code: co-codamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "codeine + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923346.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923346.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923348",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923348",
    "phenotype": "Treatment/medication code: co-proxamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dextropropoxyphene + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923348.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923348.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923350",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923350",
    "phenotype": "Treatment/medication code: co-dydramol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dihydrocodeine + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923350.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923350.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923402",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923402",
    "phenotype": "Treatment/medication code: co-amilofruse",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "amiloride + furosemide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923402.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923402.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923484",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923484",
    "phenotype": "Treatment/medication code: topiramate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant / antimigraine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923484.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923484.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923572",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923572",
    "phenotype": "Treatment/medication code: adipine mr 10 m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nifedipine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923572.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923572.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923670",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923670",
    "phenotype": "Treatment/medication code: gtn - glyceryl trinitrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923670.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923670.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140923688",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140923688",
    "phenotype": "Treatment/medication code: zoton 15mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lansoprazole",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140923688.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140923688.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140925800",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140925800",
    "phenotype": "Treatment/medication code: movicol oral powder",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "laxative (macrogol + electrolytes)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140925800.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140925800.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140925978",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140925978",
    "phenotype": "Treatment/medication code: mycophenolate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "immunosuppressant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140925978.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140925978.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140926606",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140926606",
    "phenotype": "Treatment/medication code: salbutamol 100micrograms spacehaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "salbutamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140926606.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140926606.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140926732",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140926732",
    "phenotype": "Treatment/medication code: meloxicam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "NSAID",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140926732.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140926732.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140926780",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140926780",
    "phenotype": "Treatment/medication code: adizem-xl plus m/r capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diltiazem",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140926780.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140926780.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140926922",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140926922",
    "phenotype": "Treatment/medication code: antihistamine 60mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine (likely fexofenadine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140926922.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140926922.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140927086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140927086",
    "phenotype": "Treatment/medication code: arthrotec 50 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "diclofenac + misoprostol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140927086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140927086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140927320",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140927320",
    "phenotype": "Treatment/medication code: dermol 500 lotion",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient / antimicrobial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140927320.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140927320.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140927328",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140927328",
    "phenotype": "Treatment/medication code: terbinafine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antifungal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140927328.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140927328.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140927730",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140927730",
    "phenotype": "Treatment/medication code: epaderm ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140927730.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140927730.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140928004",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140928004",
    "phenotype": "Treatment/medication code: zimovane ls 3.75mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "zopiclone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140928004.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140928004.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140928274",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140928274",
    "phenotype": "Treatment/medication code: ropinirole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dopamine agonist (Parkinson’s / RLS)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140928274.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140928274.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140928284",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140928284",
    "phenotype": "Treatment/medication code: moxonidine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihypertensive (central)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140928284.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140928284.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140928916",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140928916",
    "phenotype": "Treatment/medication code: olanzapine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antipsychotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140928916.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140928916.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1140929012",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1140929012",
    "phenotype": "Treatment/medication code: pantoprazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "proton pump inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1140929012.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1140929012.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141145630",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141145630",
    "phenotype": "Treatment/medication code: nitromin 400micrograms cfc-free spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "glyceryl trinitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141145630.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141145630.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141145638",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141145638",
    "phenotype": "Treatment/medication code: nasobec aqueous 50micrograms nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beclometasone nasal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141145638.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141145638.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141145660",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141145660",
    "phenotype": "Treatment/medication code: valsartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "angiotensin II receptor blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141145660.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141145660.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141145668",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141145668",
    "phenotype": "Treatment/medication code: diovan 40mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "valsartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141145668.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141145668.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141145812",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141145812",
    "phenotype": "Treatment/medication code: minerals - magnesium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "magnesium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141145812.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141145812.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146138",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146138",
    "phenotype": "Treatment/medication code: lipitor 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "atorvastatin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146138.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146138.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146188",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146188",
    "phenotype": "Treatment/medication code: latanoprost",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prostaglandin analogue (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146188.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146188.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146198",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146198",
    "phenotype": "Treatment/medication code: xalatan 0.005% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "latanoprost",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146198.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146198.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146234",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146234",
    "phenotype": "Treatment/medication code: atorvastatin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "statin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146234.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146234.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146428",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146428",
    "phenotype": "Treatment/medication code: fexofenadine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146428.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146428.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146508",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146508",
    "phenotype": "Treatment/medication code: nasacort 55micrograms aqueous nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "triamcinolone nasal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146508.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146508.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146606",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146606",
    "phenotype": "Treatment/medication code: calcium carbonate+cholecalciferol 1.25g/200iu tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146606.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146606.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141146612",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141146612",
    "phenotype": "Treatment/medication code: calceos chewable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141146612.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141146612.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141150620",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141150620",
    "phenotype": "Treatment/medication code: zolmitriptan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "triptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141150620.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141150620.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141150624",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141150624",
    "phenotype": "Treatment/medication code: zomig 2.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "zolmitriptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141150624.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141150624.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141150750",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141150750",
    "phenotype": "Treatment/medication code: brimonidine tartrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "alpha agonist (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141150750.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141150750.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141150944",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141150944",
    "phenotype": "Treatment/medication code: nasonex 0.05% aqueous nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mometasone nasal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141150944.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141150944.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141151016",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141151016",
    "phenotype": "Treatment/medication code: losartan potassium+hydrochlorothiazide 50mg/12.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB + diuretic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141151016.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141151016.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141151284",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141151284",
    "phenotype": "Treatment/medication code: naratriptan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "triptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141151284.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141151284.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141151288",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141151288",
    "phenotype": "Treatment/medication code: naramig 2.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "naratriptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141151288.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141151288.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141151946",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141151946",
    "phenotype": "Treatment/medication code: cipramil 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "citalopram",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141151946.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141151946.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141152590",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141152590",
    "phenotype": "Treatment/medication code: glimepiride",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "sulphonylurea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141152590.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141152590.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141152732",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141152732",
    "phenotype": "Treatment/medication code: mirtazapine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (NaSSA)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141152732.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141152732.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141152848",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141152848",
    "phenotype": "Treatment/medication code: quetiapine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antipsychotic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141152848.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141152848.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141152998",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141152998",
    "phenotype": "Treatment/medication code: irbesartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141152998.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141152998.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141153006",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141153006",
    "phenotype": "Treatment/medication code: aprovel 75mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "irbesartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141153006.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141153006.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141153026",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141153026",
    "phenotype": "Treatment/medication code: lercanidipine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141153026.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141153026.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141153032",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141153032",
    "phenotype": "Treatment/medication code: zanidip 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lercanidipine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141153032.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141153032.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141153242",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141153242",
    "phenotype": "Treatment/medication code: balsalazide disodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "aminosalicylate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141153242.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141153242.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141156836",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141156836",
    "phenotype": "Treatment/medication code: candesartan cilexetil",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141156836.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141156836.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141156846",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141156846",
    "phenotype": "Treatment/medication code: amias 2mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "candesartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141156846.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141156846.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157126",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157126",
    "phenotype": "Treatment/medication code: montelukast product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "leukotriene receptor antagonist",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157126.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157126.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157132",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157132",
    "phenotype": "Treatment/medication code: singulair 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "montelukast",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157132.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157132.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157178",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157178",
    "phenotype": "Treatment/medication code: senna product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "stimulant laxative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157178.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157178.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157252",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157252",
    "phenotype": "Treatment/medication code: glyceryl trinitrate product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "nitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157252.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157252.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157264",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157264",
    "phenotype": "Treatment/medication code: salmeterol product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "LABA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157264.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157264.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157294",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157294",
    "phenotype": "Treatment/medication code: hydrocortisone product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157294.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157294.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157402",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157402",
    "phenotype": "Treatment/medication code: prednisolone product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157402.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157402.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157418",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157418",
    "phenotype": "Treatment/medication code: budesonide product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157418.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157418.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157458",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157458",
    "phenotype": "Treatment/medication code: hypromellose product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157458.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157458.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157486",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157486",
    "phenotype": "Treatment/medication code: salbutamol product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bronchodilator",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157486.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157486.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141157494",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141157494",
    "phenotype": "Treatment/medication code: ispaghula husk product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bulk laxative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141157494.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141157494.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141162764",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141162764",
    "phenotype": "Treatment/medication code: tolterodine l-tartrate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticholinergic (overactive bladder)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141162764.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141162764.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141162824",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141162824",
    "phenotype": "Treatment/medication code: detrusitol 1mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "tolterodine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141162824.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141162824.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141164060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141164060",
    "phenotype": "Treatment/medication code: pramipexole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dopamine agonist",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141164060.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141164060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141164086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141164086",
    "phenotype": "Treatment/medication code: salmeterol+fluticasone propionate",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "LABA + ICS combination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141164086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141164086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141164276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141164276",
    "phenotype": "Treatment/medication code: nebivolol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beta-blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141164276.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141164276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141164828",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141164828",
    "phenotype": "Treatment/medication code: adcal-d3 1.5g/10micrograms chewable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141164828.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141164828.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141164872",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141164872",
    "phenotype": "Treatment/medication code: sinemet-62.5 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "levodopa + carbidopa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141164872.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141164872.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141166006",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141166006",
    "phenotype": "Treatment/medication code: telmisartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141166006.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141166006.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141166086",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141166086",
    "phenotype": "Treatment/medication code: rennie duo oral suspension",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antacid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141166086.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141166086.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141166294",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141166294",
    "phenotype": "Treatment/medication code: leflunomide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "disease-modifying antirheumatic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141166294.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141166294.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141167334",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141167334",
    "phenotype": "Treatment/medication code: colofac-100 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mebeverine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141167334.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141167334.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141167594",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141167594",
    "phenotype": "Treatment/medication code: qvar 50 inhaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beclometasone (extra-fine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141167594.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141167594.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141167708",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141167708",
    "phenotype": "Treatment/medication code: beclomist 50micrograms nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beclometasone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141167708.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141167708.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141167932",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141167932",
    "phenotype": "Treatment/medication code: rizatriptan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "triptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141167932.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141167932.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141167940",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141167940",
    "phenotype": "Treatment/medication code: maxalt 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "rizatriptan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141167940.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141167940.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168108",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168108",
    "phenotype": "Treatment/medication code: isotard 25xl m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "isosorbide mononitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168108.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168108.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168122",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168122",
    "phenotype": "Treatment/medication code: solpadol capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "codeine + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168122.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168122.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168318",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168318",
    "phenotype": "Treatment/medication code: clopidogrel",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiplatelet",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168318.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168318.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168322",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168322",
    "phenotype": "Treatment/medication code: plavix 75mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "clopidogrel",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168322.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168322.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168554",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168554",
    "phenotype": "Treatment/medication code: migraleve tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antimigraine (buclizine + codeine + paracetamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168554.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168554.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168584",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168584",
    "phenotype": "Treatment/medication code: rabeprazole sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "proton pump inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168584.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168584.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168590",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168590",
    "phenotype": "Treatment/medication code: pariet 10mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "rabeprazole",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168590.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168590.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168680",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168680",
    "phenotype": "Treatment/medication code: orlistat",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "lipase inhibitor (anti-obesity)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168680.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168680.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168684",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168684",
    "phenotype": "Treatment/medication code: xenical 120mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "orlistat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168684.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168684.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141168752",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141168752",
    "phenotype": "Treatment/medication code: peptac liquid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "alginate / antacid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141168752.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141168752.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141169520",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141169520",
    "phenotype": "Treatment/medication code: cosopt 2%/0.5% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "dorzolamide + timolol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141169520.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141169520.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141169844",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141169844",
    "phenotype": "Treatment/medication code: dexamethasone+hypromellose 0.1%/0.5% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "corticosteroid + lubricant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141169844.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141169844.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171038",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171038",
    "phenotype": "Treatment/medication code: oxycodone hydrochloride",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "opioid analgesic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171038.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171038.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171152",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171152",
    "phenotype": "Treatment/medication code: cardicor 1.25mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bisoprolol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171152.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171152.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171336",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171336",
    "phenotype": "Treatment/medication code: eprosartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171336.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171336.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171496",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171496",
    "phenotype": "Treatment/medication code: trospium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticholinergic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171496.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171496.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171646",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171646",
    "phenotype": "Treatment/medication code: pioglitazone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thiazolidinedione (antidiabetic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171646.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171646.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171932",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171932",
    "phenotype": "Treatment/medication code: levetiracetam",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171932.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171932.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171940",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171940",
    "phenotype": "Treatment/medication code: keppra 250mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "levetiracetam",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171940.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171940.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141171948",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141171948",
    "phenotype": "Treatment/medication code: adcal 600mg chewable tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141171948.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141171948.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172492",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172492",
    "phenotype": "Treatment/medication code: micardis 20mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "telmisartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172492.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172492.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172698",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172698",
    "phenotype": "Treatment/medication code: monomax xl 60mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "isosorbide mononitrate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172698.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172698.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172838",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172838",
    "phenotype": "Treatment/medication code: depakote 250mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "valproate semisodium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172838.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172838.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172918",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172918",
    "phenotype": "Treatment/medication code: celluvisc 1% single-use eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "carmellose (lubricant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172918.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172918.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172924",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172924",
    "phenotype": "Treatment/medication code: desloratadine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172924.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172924.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141172928",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141172928",
    "phenotype": "Treatment/medication code: neoclarityn 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "desloratadine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141172928.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141172928.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141173328",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141173328",
    "phenotype": "Treatment/medication code: ursodeoxycholic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bile acid (gallstone / liver)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141173328.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141173328.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141173348",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141173348",
    "phenotype": "Treatment/medication code: hydroxocobalamin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin B12",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141173348.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141173348.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141174032",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141174032",
    "phenotype": "Treatment/medication code: doublebase gel",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "emollient",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141174032.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141174032.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141174508",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141174508",
    "phenotype": "Treatment/medication code: reductil 10mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "sibutramine (withdrawn) – appetite suppressant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141174508.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141174508.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141174520",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141174520",
    "phenotype": "Treatment/medication code: symbicort 100/6 turbohaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "budesonide + formoterol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141174520.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141174520.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141175684",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141175684",
    "phenotype": "Treatment/medication code: risedronate sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bisphosphonate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141175684.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141175684.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141175690",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141175690",
    "phenotype": "Treatment/medication code: actonel 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "risedronate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141175690.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141175690.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176284",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176284",
    "phenotype": "Treatment/medication code: brinzolamide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "carbonic anhydrase inhibitor (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176284.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176284.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176288",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176288",
    "phenotype": "Treatment/medication code: azopt 10mg/ml eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "brinzolamide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176288.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176288.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176570",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176570",
    "phenotype": "Treatment/medication code: fosamax 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "alendronate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176570.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176570.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176662",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176662",
    "phenotype": "Treatment/medication code: celecoxib",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "COX-2 inhibitor (NSAID)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176662.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176662.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176668",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176668",
    "phenotype": "Treatment/medication code: celebrex 100mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "celecoxib",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176668.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176668.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176670",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176670",
    "phenotype": "Treatment/medication code: celebrex 200mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "celecoxib",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176670.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176670.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176732",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176732",
    "phenotype": "Treatment/medication code: carbomers",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ophthalmic lubricant / topical gel",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176732.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176732.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141176832",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141176832",
    "phenotype": "Treatment/medication code: seretide 50 evohaler",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "fluticasone + salmeterol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141176832.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141176832.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141177526",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141177526",
    "phenotype": "Treatment/medication code: esomeprazole",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "proton pump inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141177526.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141177526.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141177532",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141177532",
    "phenotype": "Treatment/medication code: nexium 20mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "esomeprazole",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141177532.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141177532.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141177600",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141177600",
    "phenotype": "Treatment/medication code: rosiglitazone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thiazolidinedione",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141177600.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141177600.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141178052",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141178052",
    "phenotype": "Treatment/medication code: zapain caplet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "codeine + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141178052.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141178052.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141179764",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141179764",
    "phenotype": "Treatment/medication code: tenofovir",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antiviral (HIV / hepatitis B)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141179764.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141179764.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141179914",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141179914",
    "phenotype": "Treatment/medication code: bimatoprost",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prostaglandin analogue (glaucoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141179914.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141179914.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141179920",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141179920",
    "phenotype": "Treatment/medication code: lumigan 0.3mg/ml eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bimatoprost",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141179920.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141179920.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141179974",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141179974",
    "phenotype": "Treatment/medication code: cozaar 25mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "losartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141179974.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141179974.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141179992",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141179992",
    "phenotype": "Treatment/medication code: dovobet ointment",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcipotriol + betamethasone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141179992.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141179992.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180036",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180036",
    "phenotype": "Treatment/medication code: fybogel orange s/f granules",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ispaghula husk",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180036.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180036.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180140",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180140",
    "phenotype": "Treatment/medication code: etoricoxib",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "COX-2 inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180140.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180140.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180148",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180148",
    "phenotype": "Treatment/medication code: arcoxia 60mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "etoricoxib",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180148.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180148.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180150",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180150",
    "phenotype": "Treatment/medication code: arcoxia 90mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "etoricoxib",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180150.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180150.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180212",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180212",
    "phenotype": "Treatment/medication code: escitalopram",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "SSRI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180212.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180212.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180226",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180226",
    "phenotype": "Treatment/medication code: amoxicillin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (penicillin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180226.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180226.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180314",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180314",
    "phenotype": "Treatment/medication code: ibandronic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "bisphosphonate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180314.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180314.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180342",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180342",
    "phenotype": "Treatment/medication code: beclometasone dipropionate+salbutamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ICS + SABA combination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180342.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180342.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180392",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180392",
    "phenotype": "Treatment/medication code: cefalexin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antibiotic (cephalosporin)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180392.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180392.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180662",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180662",
    "phenotype": "Treatment/medication code: zirtek allergy 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "cetirizine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180662.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180662.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141180936",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141180936",
    "phenotype": "Treatment/medication code: calcium carbonate+colecalciferol 1.25g/5micrograms tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "calcium + vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141180936.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141180936.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141181868",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141181868",
    "phenotype": "Treatment/medication code: omacor 1g capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "omega-3 fatty acid",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141181868.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141181868.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141182628",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141182628",
    "phenotype": "Treatment/medication code: tiotropium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "long-acting anticholinergic (COPD)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141182628.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141182628.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141182632",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141182632",
    "phenotype": "Treatment/medication code: spiriva 18micrograms inhalation capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "tiotropium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141182632.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141182632.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141184726",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141184726",
    "phenotype": "Treatment/medication code: xalacom 0.005%/0.5% eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "latanoprost + timolol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141184726.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141184726.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141184748",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141184748",
    "phenotype": "Treatment/medication code: levocetirizine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141184748.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141184748.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141185316",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141185316",
    "phenotype": "Treatment/medication code: travoprost",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "prostaglandin analogue",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141185316.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141185316.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141185326",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141185326",
    "phenotype": "Treatment/medication code: travatan 40micrograms/ml eye drops",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "travoprost",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141185326.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141185326.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141187230",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141187230",
    "phenotype": "Treatment/medication code: care cetirizine hayfever relief 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "cetirizine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141187230.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141187230.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141187776",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141187776",
    "phenotype": "Treatment/medication code: nurofen 200mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ibuprofen",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141187776.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141187776.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141188146",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141188146",
    "phenotype": "Treatment/medication code: simvador 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "simvastatin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141188146.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141188146.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141188442",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141188442",
    "phenotype": "Treatment/medication code: glucosamine product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "supplement (joint health)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141188442.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141188442.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141188594",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141188594",
    "phenotype": "Treatment/medication code: humira 40mg injection solution 0.8ml prefilled syringe",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "adalimumab (biologic)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141188594.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141188594.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141188658",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141188658",
    "phenotype": "Treatment/medication code: asacol mr 400mg e/c tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "mesalazine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141188658.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141188658.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141189090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141189090",
    "phenotype": "Treatment/medication code: rosiglitazone 1mg / metformin 500mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidiabetic combination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141189090.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141189090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141189094",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141189094",
    "phenotype": "Treatment/medication code: avandamet 1mg / 500mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "rosiglitazone + metformin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141189094.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141189094.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141190158",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141190158",
    "phenotype": "Treatment/medication code: cipralex 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "escitalopram",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141190158.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141190158.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141190160",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141190160",
    "phenotype": "Treatment/medication code: vascalpha 5mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "amlodipine? (likely diltiazem variant) – assume calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141190160.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141190160.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141190960",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141190960",
    "phenotype": "Treatment/medication code: tramacet 325mg/37.5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "tramadol + paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141190960.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141190960.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141191044",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141191044",
    "phenotype": "Treatment/medication code: levothyroxine sodium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thyroid hormone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141191044.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141191044.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141191748",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141191748",
    "phenotype": "Treatment/medication code: respiratory mometasone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "inhaled corticosteroid (mometasone)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141191748.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141191748.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141192410",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141192410",
    "phenotype": "Treatment/medication code: rosuvastatin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "statin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141192410.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141192410.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141192414",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141192414",
    "phenotype": "Treatment/medication code: crestor 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "rosuvastatin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141192414.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141192414.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141192736",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141192736",
    "phenotype": "Treatment/medication code: ezetimibe",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "cholesterol absorption inhibitor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141192736.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141192736.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141192740",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141192740",
    "phenotype": "Treatment/medication code: ezetrol 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ezetimibe",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141192740.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141192740.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141192916",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141192916",
    "phenotype": "Treatment/medication code: rino clenil 50micrograms nasal spray",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "beclometasone",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141192916.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141192916.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141193282",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141193282",
    "phenotype": "Treatment/medication code: olmesartan",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ARB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141193282.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141193282.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141193346",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141193346",
    "phenotype": "Treatment/medication code: olmetec 10mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "olmesartan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141193346.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141193346.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141194224",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141194224",
    "phenotype": "Treatment/medication code: allergy relief antihistamine 4mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antihistamine (likely chlorphenamine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141194224.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141194224.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141194386",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141194386",
    "phenotype": "Treatment/medication code: telfast 30 tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "fexofenadine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141194386.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141194386.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141194794",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141194794",
    "phenotype": "Treatment/medication code: bendroflumethiazide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "thiazide diuretic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141194794.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141194794.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141195044",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141195044",
    "phenotype": "Treatment/medication code: hydroxycarbamide",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antimetabolite / hydroxyurea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141195044.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141195044.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141195224",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141195224",
    "phenotype": "Treatment/medication code: formoterol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "LABA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141195224.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141195224.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141195232",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141195232",
    "phenotype": "Treatment/medication code: budesonide+formoterol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "ICS + LABA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141195232.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141195232.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141199858",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141199858",
    "phenotype": "Treatment/medication code: cardioplen xl 5mg m/r tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "amlodipine? (likely) – calcium channel blocker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141199858.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141199858.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200004",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200004",
    "phenotype": "Treatment/medication code: pregabalin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant / neuropathic pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200004.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200004.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200072",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200072",
    "phenotype": "Treatment/medication code: lyrica 25mg capsule",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "pregabalin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200072.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200072.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200108",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200108",
    "phenotype": "Treatment/medication code: cymalon cranberry 1.5g/5ml liquid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "urinary health (cranberry extract) – supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200108.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200108.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200322",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200322",
    "phenotype": "Treatment/medication code: solifenacin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticholinergic (overactive bladder)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200322.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200322.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200384",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200384",
    "phenotype": "Treatment/medication code: vesicare 5mg tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "solifenacin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200384.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200384.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200564",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200564",
    "phenotype": "Treatment/medication code: duloxetine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "antidepressant (SNRI)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200564.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200564.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200708",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200708",
    "phenotype": "Treatment/medication code: strontium product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "strontium (bone health)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200708.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200708.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1141200768",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1141200768",
    "phenotype": "Treatment/medication code: protelos 2g sachets",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "strontium ranelate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1141200768.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1141200768.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1187",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1187",
    "phenotype": "Treatment/medication code: chondroitin product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "supplement (joint)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1187.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1187.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1189",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1189",
    "phenotype": "Treatment/medication code: co-enzyme q10/ubiquinone/bio-quinone/coenzyme q10",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "supplement (CoQ10)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1189.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1189.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1193",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1193",
    "phenotype": "Treatment/medication code: omega-3/fish oil supplement",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "omega-3 supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1193.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1193.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1195",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1195",
    "phenotype": "Treatment/medication code: vitamin c product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "vitamin C",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1195.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1195.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1197",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1197",
    "phenotype": "Treatment/medication code: evening primrose oil product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "GLA supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1197.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1197.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1199",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1199",
    "phenotype": "Treatment/medication code: food supplement/plant/herbal extract",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal / food supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1199.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1199.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1201",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1201",
    "phenotype": "Treatment/medication code: st john's wort/hypericum [ctsu]",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal (antidepressant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1201.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1201.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_1203",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_1203",
    "phenotype": "Treatment/medication code: aloe vera product",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "herbal / topical",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_1203.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_1203.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_2038459704",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_2038459704",
    "phenotype": "Treatment/medication code: carbamazepine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_2038459704.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_2038459704.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_2038459814",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_2038459814",
    "phenotype": "Treatment/medication code: digoxin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "cardiac glycoside",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_2038459814.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_2038459814.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_2038460068",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_2038460068",
    "phenotype": "Treatment/medication code: phenobarbitone",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "barbiturate (anticonvulsant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_2038460068.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_2038460068.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_2038460076",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_2038460076",
    "phenotype": "Treatment/medication code: phenytoin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "anticonvulsant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_2038460076.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_2038460076.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_2038460150",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_2038460150",
    "phenotype": "Treatment/medication code: paracetamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "analgesic (paracetamol)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_2038460150.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_2038460150.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20003_99999",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20003_99999",
    "phenotype": "Treatment/medication code: Free-text entry, unable to be coded",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "uncoded / unknown",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20003_99999.gwas.imputed_v3.both_sexes.tsv.bgz -O 20003_99999.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20007_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20007",
    "phenotype": "Interpolated Age of participant when cancer first diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at cancer diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20015_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20015",
    "phenotype": "Sitting height",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body measurement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20015_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20015_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20016_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20016",
    "phenotype": "Fluid intelligence score",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cognitive score",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20016_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20016_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20018",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20018",
    "phenotype": "Prospective memory result",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Prospective memory",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20018.gwas.imputed_v3.both_sexes.tsv.bgz -O 20018.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20019_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20019",
    "phenotype": "Speech-reception-threshold (SRT) estimate (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing threshold",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20019_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20019_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20021_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20021",
    "phenotype": "Speech-reception-threshold (SRT) estimate (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing threshold",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20022_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20022",
    "phenotype": "Birth weight",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Birth weight",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20022_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20022_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20023_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20023",
    "phenotype": "Mean time to correctly identify matches",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Reaction time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20023_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20023_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_468",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_468",
    "phenotype": "Vitamin and/or mineral supplement use: Multivitamin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Multivitamin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_468.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_468.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_469",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_469",
    "phenotype": "Vitamin and/or mineral supplement use: Multivitamin with iron",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Multivitamin with iron",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_469.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_469.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_470",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_470",
    "phenotype": "Vitamin and/or mineral supplement use: Multivitamin with calcium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Multivitamin with calcium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_470.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_470.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_471",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_471",
    "phenotype": "Vitamin and/or mineral supplement use: Multivitamin with multimineral",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Multivitamin with multimineral",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_471.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_471.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_472",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_472",
    "phenotype": "Vitamin and/or mineral supplement use: Fish oil",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Fish oil supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_472.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_472.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_473",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_473",
    "phenotype": "Vitamin and/or mineral supplement use: Glucosamine/chondroitin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Glucosamine/chondroitin supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_473.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_473.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_474",
    "phenotype": "Vitamin and/or mineral supplement use: Evening primrose",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Evening primrose oil supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_474.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_475",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_475",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin A",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin A",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_475.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_475.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_476",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin B6",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin B6",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_476.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_477",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_477",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin B12",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin B12",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_477.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_477.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_478",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_478",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin C",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin C",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_478.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_478.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_479",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_479",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin D",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_479.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_479.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_480",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_480",
    "phenotype": "Vitamin and/or mineral supplement use: Vitamin E",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin E",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_480.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_480.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_481",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_481",
    "phenotype": "Vitamin and/or mineral supplement use: Folic acid",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Folic acid supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_481.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_481.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_482",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_482",
    "phenotype": "Vitamin and/or mineral supplement use: Chromium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Chromium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_482.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_482.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_483",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_483",
    "phenotype": "Vitamin and/or mineral supplement use: Magnesium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Magnesium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_483.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_483.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_484",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_484",
    "phenotype": "Vitamin and/or mineral supplement use: Selenium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Selenium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_484.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_484.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_485",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_485",
    "phenotype": "Vitamin and/or mineral supplement use: Calcium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_485.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_485.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_486",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_486",
    "phenotype": "Vitamin and/or mineral supplement use: Iron",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_486.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_486.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20084_487",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20084_487",
    "phenotype": "Vitamin and/or mineral supplement use: Zinc",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Zinc supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20084_487.gwas.imputed_v3.both_sexes.tsv.bgz -O 20084_487.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20086_10",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20086_10",
    "phenotype": "Type of special diet followed: Low calorie",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Special diet - low calorie",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20086_10.gwas.imputed_v3.both_sexes.tsv.bgz -O 20086_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20086_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20086_11",
    "phenotype": "Type of special diet followed: Vegetarian",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Special diet - vegetarian",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20086_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 20086_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20086_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20086_12",
    "phenotype": "Type of special diet followed: Vegan",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Special diet - vegan",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20086_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 20086_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20086_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20086_8",
    "phenotype": "Type of special diet followed: Gluten-free",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Special diet - gluten free",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20086_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 20086_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20086_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20086_9",
    "phenotype": "Type of special diet followed: Lactose-free",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Special diet - lactose free",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20086_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 20086_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20089_461",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20089_461",
    "phenotype": "Type of meals eaten: Takeaway meals",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meal type - takeaway",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20089_461.gwas.imputed_v3.both_sexes.tsv.bgz -O 20089_461.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20089_462",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20089_462",
    "phenotype": "Type of meals eaten: Restaurant meals",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meal type - restaurant",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20089_462.gwas.imputed_v3.both_sexes.tsv.bgz -O 20089_462.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20089_463",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20089_463",
    "phenotype": "Type of meals eaten: Bought sandwiches",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meal type - bought sandwiches",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20089_463.gwas.imputed_v3.both_sexes.tsv.bgz -O 20089_463.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20089_464",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20089_464",
    "phenotype": "Type of meals eaten: Ready meals",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meal type - ready meals",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20089_464.gwas.imputed_v3.both_sexes.tsv.bgz -O 20089_464.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20089_465",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20089_465",
    "phenotype": "Type of meals eaten: Home cooked meals",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meal type - home cooked",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20089_465.gwas.imputed_v3.both_sexes.tsv.bgz -O 20089_465.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_352",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_352",
    "phenotype": "Type of fat/oil used in cooking: Cooking fat unknown",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - unknown",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_352.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_352.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_353",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_353",
    "phenotype": "Type of fat/oil used in cooking: Olive oil",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - olive oil",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_353.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_353.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_354",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_354",
    "phenotype": "Type of fat/oil used in cooking: Sunflower oil",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - sunflower oil",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_354.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_354.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_355",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_355",
    "phenotype": "Type of fat/oil used in cooking: Vegetable oil",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - vegetable oil",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_355.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_355.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_356",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_356",
    "phenotype": "Type of fat/oil used in cooking: Rapeseed oil",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - rapeseed oil",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_356.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_356.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_359",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_359",
    "phenotype": "Type of fat/oil used in cooking: Butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - butter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_359.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_359.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_360",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_360",
    "phenotype": "Type of fat/oil used in cooking: Spreadable butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - spreadable butter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_360.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_360.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_361",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_361",
    "phenotype": "Type of fat/oil used in cooking: Low fat butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat butter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_361.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_361.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_362",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_362",
    "phenotype": "Type of fat/oil used in cooking: Normal fat butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat butter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_362.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_362.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_363",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_363",
    "phenotype": "Type of fat/oil used in cooking: Unknown fat butter",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - unknown fat butter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_363.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_363.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_364",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_364",
    "phenotype": "Type of fat/oil used in cooking: Lard",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - lard",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_364.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_364.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_365",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_365",
    "phenotype": "Type of fat/oil used in cooking: Olive spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_365.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_365.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_366",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_366",
    "phenotype": "Type of fat/oil used in cooking: Very low fat olive spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - very low fat olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_366.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_366.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_367",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_367",
    "phenotype": "Type of fat/oil used in cooking: Low fat olive spread for",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_367.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_367.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_368",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_368",
    "phenotype": "Type of fat/oil used in cooking: Normal fat olive spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_368.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_368.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_369",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_369",
    "phenotype": "Type of fat/oil used in cooking: Cholesterol lowering olive spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - cholesterol lowering olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_369.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_369.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_370",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_370",
    "phenotype": "Type of fat/oil used in cooking: Unknown olive spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - unknown olive spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_370.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_370.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_371",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_371",
    "phenotype": "Type of fat/oil used in cooking: Polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_371.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_371.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_372",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_372",
    "phenotype": "Type of fat/oil used in cooking: Very low fat polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - very low fat polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_372.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_372.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_373",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_373",
    "phenotype": "Type of fat/oil used in cooking: Low fat polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_373.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_373.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_374",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_374",
    "phenotype": "Type of fat/oil used in cooking: Normal fat polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_374.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_374.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_375",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_375",
    "phenotype": "Type of fat/oil used in cooking: Cholesterol lowering polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - cholesterol lowering polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_375.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_375.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_376",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_376",
    "phenotype": "Type of fat/oil used in cooking: Unknown polyunsaturated margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - unknown polyunsaturated margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_376.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_376.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_377",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_377",
    "phenotype": "Type of fat/oil used in cooking: Dairy spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - dairy spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_377.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_377.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_379",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_379",
    "phenotype": "Type of fat/oil used in cooking: Low fat dairy spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat dairy spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_379.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_379.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_380",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_380",
    "phenotype": "Type of fat/oil used in cooking: Normal fat dairy spread",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat dairy spread",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_380.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_380.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_383",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_383",
    "phenotype": "Type of fat/oil used in cooking: Soya margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - soya margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_383.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_383.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_385",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_385",
    "phenotype": "Type of fat/oil used in cooking: Low fat soya margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat soya margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_385.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_385.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_386",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_386",
    "phenotype": "Type of fat/oil used in cooking: Normal fat soya margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat soya margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_386.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_386.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_391",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_391",
    "phenotype": "Type of fat/oil used in cooking: Low fat soft margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - low fat soft margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_391.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_391.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_392",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_392",
    "phenotype": "Type of fat/oil used in cooking: Normal fat soft margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - normal fat soft margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_392.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_392.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_394",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_394",
    "phenotype": "Type of fat/oil used in cooking: Unknown soft margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - unknown soft margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_394.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_394.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20090_395",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20090_395",
    "phenotype": "Type of fat/oil used in cooking: Hard margarine",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cooking fat - hard margarine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20090_395.gwas.imputed_v3.both_sexes.tsv.bgz -O 20090_395.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20095_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20095_1",
    "phenotype": "Size of white wine glass drunk: small (125ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "White wine glass size - small",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20095_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20095_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20095_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20095_2",
    "phenotype": "Size of white wine glass drunk: medium (175ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "White wine glass size - medium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20095_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20095_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20095_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20095_3",
    "phenotype": "Size of white wine glass drunk: large (250ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "White wine glass size - large",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20095_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20095_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20096_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20096_1",
    "phenotype": "Size of red wine glass drunk: small (125ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Red wine glass size - small",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20096_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20096_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20096_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20096_2",
    "phenotype": "Size of red wine glass drunk: medium (175ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Red wine glass size - medium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20096_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20096_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20096_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20096_3",
    "phenotype": "Size of red wine glass drunk: large (250ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Red wine glass size - large",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20096_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20096_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20097_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20097_1",
    "phenotype": "Size of rose wine glass drunk: small (125ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Rose wine glass size - small",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20097_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20097_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20097_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20097_2",
    "phenotype": "Size of rose wine glass drunk: medium (175ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Rose wine glass size - medium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20097_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20097_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20097_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20097_3",
    "phenotype": "Size of rose wine glass drunk: large (250ml)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Rose wine glass size - large",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20097_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20097_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2010",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2010",
    "phenotype": "Suffer from 'nerves'",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-reported nervousness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2010.gwas.imputed_v3.both_sexes.tsv.bgz -O 2010.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_1",
    "phenotype": "Illnesses of father: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_10",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_10",
    "phenotype": "Illnesses of father: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_10.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_11",
    "phenotype": "Illnesses of father: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_12",
    "phenotype": "Illnesses of father: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_13",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_13",
    "phenotype": "Illnesses of father: Prostate cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - prostate cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_13.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_2",
    "phenotype": "Illnesses of father: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_3",
    "phenotype": "Illnesses of father: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_4",
    "phenotype": "Illnesses of father: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_6",
    "phenotype": "Illnesses of father: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_8",
    "phenotype": "Illnesses of father: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20107_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20107_9",
    "phenotype": "Illnesses of father: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - father - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20107_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 20107_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_1",
    "phenotype": "Illnesses of mother: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_10",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_10",
    "phenotype": "Illnesses of mother: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_10.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_11",
    "phenotype": "Illnesses of mother: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_12",
    "phenotype": "Illnesses of mother: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_2",
    "phenotype": "Illnesses of mother: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_3",
    "phenotype": "Illnesses of mother: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_4",
    "phenotype": "Illnesses of mother: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_5",
    "phenotype": "Illnesses of mother: Breast cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_6",
    "phenotype": "Illnesses of mother: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_8",
    "phenotype": "Illnesses of mother: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20110_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20110_9",
    "phenotype": "Illnesses of mother: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - mother - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20110_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 20110_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_1",
    "phenotype": "Illnesses of siblings: Heart disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_10",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_10",
    "phenotype": "Illnesses of siblings: Alzheimer's disease/dementia",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_10.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_11",
    "phenotype": "Illnesses of siblings: Parkinson's disease",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - Parkinson disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_12",
    "phenotype": "Illnesses of siblings: Severe depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - severe depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_13",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_13",
    "phenotype": "Illnesses of siblings: Prostate cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - prostate cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_13.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_2",
    "phenotype": "Illnesses of siblings: Stroke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_3",
    "phenotype": "Illnesses of siblings: Lung cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_4",
    "phenotype": "Illnesses of siblings: Bowel cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - bowel cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_5",
    "phenotype": "Illnesses of siblings: Breast cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_6",
    "phenotype": "Illnesses of siblings: Chronic bronchitis/emphysema",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_8",
    "phenotype": "Illnesses of siblings: High blood pressure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20111_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20111_9",
    "phenotype": "Illnesses of siblings: Diabetes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family history - sibling - diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20111_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 20111_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20116_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20116_0",
    "phenotype": "Smoking status: Never",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking status - never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20116_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20116_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20116_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20116_1",
    "phenotype": "Smoking status: Previous",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking status - previous",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20116_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20116_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20116_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20116_2",
    "phenotype": "Smoking status: Current",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking status - current",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20116_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20116_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20117_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20117_0",
    "phenotype": "Alcohol drinker status: Never",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol drinking status - never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20117_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20117_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20117_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20117_1",
    "phenotype": "Alcohol drinker status: Previous",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol drinking status - previous",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20117_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20117_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20117_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20117_2",
    "phenotype": "Alcohol drinker status: Current",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol drinking status - current",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20117_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20117_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20121_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20121",
    "phenotype": "Cascot confidence score",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cognitive confidence score",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20121_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20121_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20122",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20122",
    "phenotype": "Bipolar disorder status",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20122.gwas.imputed_v3.both_sexes.tsv.bgz -O 20122.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_0",
    "phenotype": "Bipolar and major depression status: No Bipolar or Depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "No bipolar or depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_1",
    "phenotype": "Bipolar and major depression status: Bipolar I Disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar I disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_2",
    "phenotype": "Bipolar and major depression status: Bipolar II Disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar II disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_3",
    "phenotype": "Bipolar and major depression status: Probable Recurrent major depression (severe)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent major depression - severe",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_4",
    "phenotype": "Bipolar and major depression status: Probable Recurrent major depression (moderate)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent major depression - moderate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20126_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20126_5",
    "phenotype": "Bipolar and major depression status: Single Probable major depression episode",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Single major depression episode",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20126_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20126_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20127_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20127",
    "phenotype": "Neuroticism score",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Neuroticism score",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20127_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20127_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20128",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20128",
    "phenotype": "Number of fluid intelligence questions attempted within time limit",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fluid intelligence attempts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20128.gwas.imputed_v3.both_sexes.tsv.bgz -O 20128.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20150_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20150",
    "phenotype": "Forced expiratory volume in 1-second (FEV1), Best measure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lung function - FEV1",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20150_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20150_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20151_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20151",
    "phenotype": "Forced vital capacity (FVC), Best measure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lung function - FVC",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20151_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20151_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20152",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20152",
    "phenotype": "Reproduciblity of spirometry measurement using ERS/ATS criteria",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Spirometry reproducibility",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20152.gwas.imputed_v3.both_sexes.tsv.bgz -O 20152.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20153_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20153",
    "phenotype": "Forced expiratory volume in 1-second (FEV1), predicted",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FEV1 predicted",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20153_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20153_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20154_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20154",
    "phenotype": "Forced expiratory volume in 1-second (FEV1), predicted percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FEV1 percent predicted",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20154_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20154_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20160",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20160",
    "phenotype": "Ever smoked",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever smoked",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20160.gwas.imputed_v3.both_sexes.tsv.bgz -O 20160.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2020",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2020",
    "phenotype": "Loneliness, isolation",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Loneliness / isolation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2020.gwas.imputed_v3.both_sexes.tsv.bgz -O 2020.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2030",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2030",
    "phenotype": "Guilty feelings",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Guilty feelings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2030.gwas.imputed_v3.both_sexes.tsv.bgz -O 2030.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2040",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2040",
    "phenotype": "Risk taking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Risk taking behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2040.gwas.imputed_v3.both_sexes.tsv.bgz -O 2040.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20401",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20401",
    "phenotype": "Ever addicted to any substance or behaviour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Addiction - any substance or behavior",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20401.gwas.imputed_v3.both_sexes.tsv.bgz -O 20401.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20403",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20403",
    "phenotype": "Amount of alcohol drunk on a typical drinking day",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol amount per drinking day",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20403.gwas.imputed_v3.both_sexes.tsv.bgz -O 20403.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20404",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20404",
    "phenotype": "Ever physically dependent on alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol dependence - ever",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20404.gwas.imputed_v3.both_sexes.tsv.bgz -O 20404.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20405_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20405_0",
    "phenotype": "Ever had known person concerned about, or recommend reduction of, alcohol consumption: No",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Concern about drinking - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20405_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20405_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20405_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20405_1",
    "phenotype": "Ever had known person concerned about, or recommend reduction of, alcohol consumption: Yes, but not in the last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Concern about drinking - yes, not in last year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20405_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20405_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20405_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20405_2",
    "phenotype": "Ever had known person concerned about, or recommend reduction of, alcohol consumption: Yes, during the last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Concern about drinking - yes, in last year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20405_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20405_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20406",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20406",
    "phenotype": "Ever addicted to alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20406.gwas.imputed_v3.both_sexes.tsv.bgz -O 20406.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20407",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20407",
    "phenotype": "Frequency of failure to fulfil normal expectations due to drinking alcohol in last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - failure to fulfill expectations",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20407.gwas.imputed_v3.both_sexes.tsv.bgz -O 20407.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20408",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20408",
    "phenotype": "Frequency of memory loss due to drinking alcohol in last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - memory loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20408.gwas.imputed_v3.both_sexes.tsv.bgz -O 20408.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20409",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20409",
    "phenotype": "Frequency of feeling guilt or remorse after drinking alcohol in last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - guilt after drinking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20409.gwas.imputed_v3.both_sexes.tsv.bgz -O 20409.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20411_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20411_0",
    "phenotype": "Ever been injured or injured someone else through drinking alcohol: No",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - injury - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20411_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20411_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20411_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20411_1",
    "phenotype": "Ever been injured or injured someone else through drinking alcohol: Yes, but not in the last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - injury - yes, not last year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20411_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20411_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20411_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20411_2",
    "phenotype": "Ever been injured or injured someone else through drinking alcohol: Yes, during the last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - injury - yes, last year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20411_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20411_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20412",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20412",
    "phenotype": "Frequency of needing morning drink of alcohol after heavy drinking session in last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - morning need",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20412.gwas.imputed_v3.both_sexes.tsv.bgz -O 20412.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20413",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20413",
    "phenotype": "Frequency of inability to cease drinking in last year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - inability to stop",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20413.gwas.imputed_v3.both_sexes.tsv.bgz -O 20413.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20414",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20414",
    "phenotype": "Frequency of drinking alcohol",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol drinking frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20414.gwas.imputed_v3.both_sexes.tsv.bgz -O 20414.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20415",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20415",
    "phenotype": "Ongoing addiction to alcohol",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ongoing alcohol addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20415.gwas.imputed_v3.both_sexes.tsv.bgz -O 20415.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20416",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20416",
    "phenotype": "Frequency of consuming six or more units of alcohol",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol - 6+ units frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20416.gwas.imputed_v3.both_sexes.tsv.bgz -O 20416.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20417",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20417",
    "phenotype": "Tense, sore, or aching muscles during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - muscle tension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20417.gwas.imputed_v3.both_sexes.tsv.bgz -O 20417.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20418",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20418",
    "phenotype": "Impact on normal roles during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - role impact",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20418.gwas.imputed_v3.both_sexes.tsv.bgz -O 20418.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20419",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20419",
    "phenotype": "Difficulty concentrating during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - concentration difficulty",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20419.gwas.imputed_v3.both_sexes.tsv.bgz -O 20419.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20420_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20420",
    "phenotype": "Longest period spent worried or anxious",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Longest anxious period",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20420_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20420_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20421",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20421",
    "phenotype": "Ever felt worried, tense, or anxious for most of a month or longer",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever prolonged anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20421.gwas.imputed_v3.both_sexes.tsv.bgz -O 20421.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20422",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20422",
    "phenotype": "More irritable than usual during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - irritability",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20422.gwas.imputed_v3.both_sexes.tsv.bgz -O 20422.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20423",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20423",
    "phenotype": "Keyed up or on edge during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - on edge",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20423.gwas.imputed_v3.both_sexes.tsv.bgz -O 20423.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20425",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20425",
    "phenotype": "Ever worried more than most people would in similar situation",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Excessive worrying",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20425.gwas.imputed_v3.both_sexes.tsv.bgz -O 20425.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20426",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20426",
    "phenotype": "Restless during period of worst anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - restlessness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20426.gwas.imputed_v3.both_sexes.tsv.bgz -O 20426.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20427",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20427",
    "phenotype": "Frequent trouble falling or staying asleep during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - insomnia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20427.gwas.imputed_v3.both_sexes.tsv.bgz -O 20427.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20428",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20428",
    "phenotype": "Professional informed about anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sought help for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20428.gwas.imputed_v3.both_sexes.tsv.bgz -O 20428.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20429",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20429",
    "phenotype": "Easily tired during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - fatigue",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20429.gwas.imputed_v3.both_sexes.tsv.bgz -O 20429.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20431",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20431",
    "phenotype": "Ever addicted to a behaviour or miscellanous",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20431.gwas.imputed_v3.both_sexes.tsv.bgz -O 20431.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20432",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20432",
    "phenotype": "Ongoing behavioural or miscellanous addiction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ongoing behavioral addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20432.gwas.imputed_v3.both_sexes.tsv.bgz -O 20432.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20433_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20433",
    "phenotype": "Age at first episode of depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at first depression episode",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20433_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20433_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20434_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20434",
    "phenotype": "Age at last episode of depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at last depression episode",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20434_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20434_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20435",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20435",
    "phenotype": "Difficulty concentrating during worst depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression - concentration difficulty",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20435.gwas.imputed_v3.both_sexes.tsv.bgz -O 20435.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20436",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20436",
    "phenotype": "Fraction of day affected during worst episode of depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Depression - fraction of day affected",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20436.gwas.imputed_v3.both_sexes.tsv.bgz -O 20436.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20437",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20437",
    "phenotype": "Thoughts of death during worst depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression - death thoughts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20437.gwas.imputed_v3.both_sexes.tsv.bgz -O 20437.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20438",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20438",
    "phenotype": "Duration of worst depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Depression - longest duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20438.gwas.imputed_v3.both_sexes.tsv.bgz -O 20438.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20439",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20439",
    "phenotype": "Frequency of depressed days during worst episode of depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Depression - frequency of depressed days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20439.gwas.imputed_v3.both_sexes.tsv.bgz -O 20439.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20440",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20440",
    "phenotype": "Impact on normal roles during worst period of depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression - role impact",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20440.gwas.imputed_v3.both_sexes.tsv.bgz -O 20440.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20441",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20441",
    "phenotype": "Ever had prolonged loss of interest in normal activities",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Loss of interest",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20441.gwas.imputed_v3.both_sexes.tsv.bgz -O 20441.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20442",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20442",
    "phenotype": "Lifetime number of depressed periods",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of depression episodes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20442.gwas.imputed_v3.both_sexes.tsv.bgz -O 20442.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20445",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20445",
    "phenotype": "Depression possibly related to childbirth",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Postpartum depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20445.gwas.imputed_v3.both_sexes.tsv.bgz -O 20445.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20446",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20446",
    "phenotype": "Ever had prolonged feelings of sadness or depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Prolonged sadness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20446.gwas.imputed_v3.both_sexes.tsv.bgz -O 20446.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20447",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20447",
    "phenotype": "Depression possibly related to stressful or traumatic event",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Stress-related depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20447.gwas.imputed_v3.both_sexes.tsv.bgz -O 20447.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20448",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20448",
    "phenotype": "Professional informed about depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sought help for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20448.gwas.imputed_v3.both_sexes.tsv.bgz -O 20448.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20449",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20449",
    "phenotype": "Feelings of tiredness during worst episode of depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression - fatigue",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20449.gwas.imputed_v3.both_sexes.tsv.bgz -O 20449.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20450",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20450",
    "phenotype": "Feelings of worthlessness during worst period of depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression - worthlessness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20450.gwas.imputed_v3.both_sexes.tsv.bgz -O 20450.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20453",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20453",
    "phenotype": "Ever taken cannabis",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cannabis use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20453.gwas.imputed_v3.both_sexes.tsv.bgz -O 20453.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20454",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20454",
    "phenotype": "Maximum frequency of taking cannabis",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Cannabis - max frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20454.gwas.imputed_v3.both_sexes.tsv.bgz -O 20454.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20455_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20455",
    "phenotype": "Age when last took cannabis",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at last cannabis use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20455_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 20455_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20456",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20456",
    "phenotype": "Ever addicted to illicit or recreational drugs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Illicit/recreational drug addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20456.gwas.imputed_v3.both_sexes.tsv.bgz -O 20456.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20458",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20458",
    "phenotype": "General happiness",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "General happiness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20458.gwas.imputed_v3.both_sexes.tsv.bgz -O 20458.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20459",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20459",
    "phenotype": "General happiness with own health",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Happiness with health",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20459.gwas.imputed_v3.both_sexes.tsv.bgz -O 20459.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20460",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20460",
    "phenotype": "Belief that own life is meaningful",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Meaning in life",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20460.gwas.imputed_v3.both_sexes.tsv.bgz -O 20460.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20462",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20462",
    "phenotype": "Distress caused by unusual or psychotic experiences",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Distress from psychotic experiences",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20462.gwas.imputed_v3.both_sexes.tsv.bgz -O 20462.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20463",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20463",
    "phenotype": "Ever heard an un-real voice",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Auditory hallucination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20463.gwas.imputed_v3.both_sexes.tsv.bgz -O 20463.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20466",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20466",
    "phenotype": "Ever prescribed a medication for unusual or psychotic experiences",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for psychotic experiences",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20466.gwas.imputed_v3.both_sexes.tsv.bgz -O 20466.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20467",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20467",
    "phenotype": "Frequency of unusual or psychotic experiences in past year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Frequency of psychotic experiences",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20467.gwas.imputed_v3.both_sexes.tsv.bgz -O 20467.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20468",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20468",
    "phenotype": "Ever believed in an un-real conspiracy against self",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Paranoid delusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20468.gwas.imputed_v3.both_sexes.tsv.bgz -O 20468.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20471",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20471",
    "phenotype": "Ever seen an un-real vision",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Visual hallucination",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20471.gwas.imputed_v3.both_sexes.tsv.bgz -O 20471.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20474",
    "phenotype": "Ever believed in un-real communications or signs",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Delusion of reference",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20474.gwas.imputed_v3.both_sexes.tsv.bgz -O 20474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20477",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20477",
    "phenotype": "Ever talked to a health professional about unusual or psychotic experiences",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sought help for psychosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20477.gwas.imputed_v3.both_sexes.tsv.bgz -O 20477.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20479",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20479",
    "phenotype": "Ever thought that life not worth living",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Life not worth living",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20479.gwas.imputed_v3.both_sexes.tsv.bgz -O 20479.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20480",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20480",
    "phenotype": "Ever self-harmed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20480.gwas.imputed_v3.both_sexes.tsv.bgz -O 20480.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20481",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20481",
    "phenotype": "Self-harmed in past year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm past year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20481.gwas.imputed_v3.both_sexes.tsv.bgz -O 20481.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20482",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20482",
    "phenotype": "Number of times self-harmed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Self-harm frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20482.gwas.imputed_v3.both_sexes.tsv.bgz -O 20482.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20483",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20483",
    "phenotype": "Ever attempted suicide",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Suicide attempt",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20483.gwas.imputed_v3.both_sexes.tsv.bgz -O 20483.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20485",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20485",
    "phenotype": "Ever contemplated self-harm",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Contemplated self-harm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20485.gwas.imputed_v3.both_sexes.tsv.bgz -O 20485.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20486",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20486",
    "phenotype": "Contemplated self-harm in past year",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Contemplated self-harm past year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20486.gwas.imputed_v3.both_sexes.tsv.bgz -O 20486.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20487",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20487",
    "phenotype": "Felt hated by family member as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Childhood - felt hated",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20487.gwas.imputed_v3.both_sexes.tsv.bgz -O 20487.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20488",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20488",
    "phenotype": "Physically abused by family as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Childhood physical abuse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20488.gwas.imputed_v3.both_sexes.tsv.bgz -O 20488.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20489",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20489",
    "phenotype": "Felt loved as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Childhood - felt loved",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20489.gwas.imputed_v3.both_sexes.tsv.bgz -O 20489.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20490",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20490",
    "phenotype": "Sexually molested as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Childhood sexual abuse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20490.gwas.imputed_v3.both_sexes.tsv.bgz -O 20490.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20491",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20491",
    "phenotype": "Someone to take to doctor when needed as a child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Childhood - access to doctor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20491.gwas.imputed_v3.both_sexes.tsv.bgz -O 20491.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20492",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20492",
    "phenotype": "Longest period of mania or irritability",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Longest mania/irritability period",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20492.gwas.imputed_v3.both_sexes.tsv.bgz -O 20492.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20493",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20493",
    "phenotype": "Severity of problems due to mania or irritability",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mania/irritability severity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20493.gwas.imputed_v3.both_sexes.tsv.bgz -O 20493.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20494",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20494",
    "phenotype": "Felt irritable or had angry outbursts in past month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Irritability past month",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20494.gwas.imputed_v3.both_sexes.tsv.bgz -O 20494.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20495",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20495",
    "phenotype": "Avoided activities or situations because of previous stressful experience in past month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Avoidance due to stress",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20495.gwas.imputed_v3.both_sexes.tsv.bgz -O 20495.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20496",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20496",
    "phenotype": "Felt distant from other people in past month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Emotional detachment",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20496.gwas.imputed_v3.both_sexes.tsv.bgz -O 20496.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20497",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20497",
    "phenotype": "Repeated disturbing thoughts of stressful experience in past month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Intrusive thoughts of stressor",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20497.gwas.imputed_v3.both_sexes.tsv.bgz -O 20497.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20498",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20498",
    "phenotype": "Felt very upset when reminded of stressful experience in past month",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Distress upon reminder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20498.gwas.imputed_v3.both_sexes.tsv.bgz -O 20498.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20499",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20499",
    "phenotype": "Ever sought or received professional help for mental distress",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sought help for mental distress",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20499.gwas.imputed_v3.both_sexes.tsv.bgz -O 20499.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2050",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2050",
    "phenotype": "Frequency of depressed mood in last 2 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depressed mood frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2050.gwas.imputed_v3.both_sexes.tsv.bgz -O 2050.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20500",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20500",
    "phenotype": "Ever suffered mental distress preventing usual activities",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mental distress with role impairment",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20500.gwas.imputed_v3.both_sexes.tsv.bgz -O 20500.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20501",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20501",
    "phenotype": "Ever had period of mania / excitability",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania/excitability history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20501.gwas.imputed_v3.both_sexes.tsv.bgz -O 20501.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20502",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20502",
    "phenotype": "Ever had period extreme irritability",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Extreme irritability history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20502.gwas.imputed_v3.both_sexes.tsv.bgz -O 20502.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20503",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20503",
    "phenotype": "Ever addicted to prescription or over-the-counter medication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prescription/OTC medication addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20503.gwas.imputed_v3.both_sexes.tsv.bgz -O 20503.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20504",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20504",
    "phenotype": "Ongoing addiction or dependence to over-the-counter medication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ongoing OTC medication dependence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20504.gwas.imputed_v3.both_sexes.tsv.bgz -O 20504.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20505",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20505",
    "phenotype": "Recent easy annoyance or irritability",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Irritability",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20505.gwas.imputed_v3.both_sexes.tsv.bgz -O 20505.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20506",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20506",
    "phenotype": "Recent feelings or nervousness or anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety feelings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20506.gwas.imputed_v3.both_sexes.tsv.bgz -O 20506.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20507",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20507",
    "phenotype": "Recent feelings of inadequacy",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Inadequacy feelings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20507.gwas.imputed_v3.both_sexes.tsv.bgz -O 20507.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20508",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20508",
    "phenotype": "Recent trouble concentrating on things",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Concentration difficulty",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20508.gwas.imputed_v3.both_sexes.tsv.bgz -O 20508.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20509",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20509",
    "phenotype": "Recent inability to stop or control worrying",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Uncontrolled worry",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20509.gwas.imputed_v3.both_sexes.tsv.bgz -O 20509.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20510",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20510",
    "phenotype": "Recent feelings of depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depressed feelings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20510.gwas.imputed_v3.both_sexes.tsv.bgz -O 20510.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20511",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20511",
    "phenotype": "Recent poor appetite or overeating",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Appetite change",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20511.gwas.imputed_v3.both_sexes.tsv.bgz -O 20511.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20512",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20512",
    "phenotype": "Recent feelings of foreboding",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Foreboding feelings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20512.gwas.imputed_v3.both_sexes.tsv.bgz -O 20512.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20513",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20513",
    "phenotype": "Recent thoughts of suicide or self-harm",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Suicidal ideation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20513.gwas.imputed_v3.both_sexes.tsv.bgz -O 20513.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20514",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20514",
    "phenotype": "Recent lack of interest or pleasure in doing things",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anhedonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20514.gwas.imputed_v3.both_sexes.tsv.bgz -O 20514.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20515",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20515",
    "phenotype": "Recent trouble relaxing",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Trouble relaxing",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20515.gwas.imputed_v3.both_sexes.tsv.bgz -O 20515.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20516",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20516",
    "phenotype": "Recent restlessness",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Restlessness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20516.gwas.imputed_v3.both_sexes.tsv.bgz -O 20516.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20517",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20517",
    "phenotype": "Trouble falling or staying asleep, or sleeping too much",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Insomnia / hypersomnia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20517.gwas.imputed_v3.both_sexes.tsv.bgz -O 20517.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20518",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20518",
    "phenotype": "Recent changes in speed/amount of moving or speaking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychomotor change",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20518.gwas.imputed_v3.both_sexes.tsv.bgz -O 20518.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20519",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20519",
    "phenotype": "Recent feelings of tiredness or low energy",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Fatigue",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20519.gwas.imputed_v3.both_sexes.tsv.bgz -O 20519.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20520",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20520",
    "phenotype": "Recent worrying too much about different things",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Excessive worry",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20520.gwas.imputed_v3.both_sexes.tsv.bgz -O 20520.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20521",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20521",
    "phenotype": "Belittlement by partner or ex-partner as an adult",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adult belittlement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20521.gwas.imputed_v3.both_sexes.tsv.bgz -O 20521.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20522",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20522",
    "phenotype": "Been in a confiding relationship as an adult",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adult confiding relationship",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20522.gwas.imputed_v3.both_sexes.tsv.bgz -O 20522.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20523",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20523",
    "phenotype": "Physical violence by partner or ex-partner as an adult",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adult physical violence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20523.gwas.imputed_v3.both_sexes.tsv.bgz -O 20523.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20524",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20524",
    "phenotype": "Sexual interference by partner or ex-partner without consent as an adult",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adult sexual assault",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20524.gwas.imputed_v3.both_sexes.tsv.bgz -O 20524.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20525",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20525",
    "phenotype": "Able to pay rent/mortgage as an adult",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adult financial stability",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20525.gwas.imputed_v3.both_sexes.tsv.bgz -O 20525.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20526",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20526",
    "phenotype": "Been in serious accident believed to be life-threatening",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life-threatening accident",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20526.gwas.imputed_v3.both_sexes.tsv.bgz -O 20526.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20527",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20527",
    "phenotype": "Been involved in combat or exposed to war-zone",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Combat exposure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20527.gwas.imputed_v3.both_sexes.tsv.bgz -O 20527.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20528",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20528",
    "phenotype": "Diagnosed with life-threatening illness",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Life-threatening illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20528.gwas.imputed_v3.both_sexes.tsv.bgz -O 20528.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20529",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20529",
    "phenotype": "Victim of physically violent crime",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Violent crime victim",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20529.gwas.imputed_v3.both_sexes.tsv.bgz -O 20529.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20530",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20530",
    "phenotype": "Witnessed sudden violent death",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Witness violent death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20530.gwas.imputed_v3.both_sexes.tsv.bgz -O 20530.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20531",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20531",
    "phenotype": "Victim of sexual assault",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Sexual assault victim",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20531.gwas.imputed_v3.both_sexes.tsv.bgz -O 20531.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20532",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20532",
    "phenotype": "Did your sleep change?",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep change",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20532.gwas.imputed_v3.both_sexes.tsv.bgz -O 20532.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20533",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20533",
    "phenotype": "Trouble falling asleep",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sleep initiation difficulty",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20533.gwas.imputed_v3.both_sexes.tsv.bgz -O 20533.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20534",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20534",
    "phenotype": "Sleeping too much",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Hypersomnia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20534.gwas.imputed_v3.both_sexes.tsv.bgz -O 20534.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20535",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20535",
    "phenotype": "Waking too early",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Early awakening",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20535.gwas.imputed_v3.both_sexes.tsv.bgz -O 20535.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20536_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20536_0",
    "phenotype": "Weight change during worst episode of depression: Stayed about the same or was on a diet",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression weight change - same / diet",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20536_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 20536_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20536_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20536_1",
    "phenotype": "Weight change during worst episode of depression: Gained weight",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression weight change - gain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20536_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20536_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20536_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20536_2",
    "phenotype": "Weight change during worst episode of depression: Lost weight",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression weight change - loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20536_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20536_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20536_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20536_3",
    "phenotype": "Weight change during worst episode of depression: Both gained and lost some weight during the episode",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Depression weight change - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20536_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20536_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20537",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20537",
    "phenotype": "Frequency of difficulty controlling worry during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - worry control difficulty frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20537.gwas.imputed_v3.both_sexes.tsv.bgz -O 20537.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20538",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20538",
    "phenotype": "Worried most days during period of worst anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - worry most days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20538.gwas.imputed_v3.both_sexes.tsv.bgz -O 20538.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20539",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20539",
    "phenotype": "Frequency of inability to stop worrying during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - unable to stop worry frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20539.gwas.imputed_v3.both_sexes.tsv.bgz -O 20539.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20540",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20540",
    "phenotype": "Multiple worries during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - multiple worries",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20540.gwas.imputed_v3.both_sexes.tsv.bgz -O 20540.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20541",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20541",
    "phenotype": "Difficulty stopping worrying during worst period of anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - difficulty stopping worry",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20541.gwas.imputed_v3.both_sexes.tsv.bgz -O 20541.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20542",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20542",
    "phenotype": "Stronger worrying (than other people) during period of worst anxiety",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anxiety - stronger worry",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20542.gwas.imputed_v3.both_sexes.tsv.bgz -O 20542.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20543",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20543",
    "phenotype": "Number of things worried about during worst period of anxiety",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Anxiety - number of worries",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20543.gwas.imputed_v3.both_sexes.tsv.bgz -O 20543.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_1",
    "phenotype": "Mental health problems ever diagnosed by a professional: Social anxiety or social phobia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Social anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_10",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_10",
    "phenotype": "Mental health problems ever diagnosed by a professional: Mania, hypomania, bipolar or manic-depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bipolar disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_10.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_10.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_11",
    "phenotype": "Mental health problems ever diagnosed by a professional: Depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_12",
    "phenotype": "Mental health problems ever diagnosed by a professional: Bulimia nervosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bulimia nervosa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_13",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_13",
    "phenotype": "Mental health problems ever diagnosed by a professional: Psychological over-eating or binge-eating",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Binge eating disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_13.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_14",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_14",
    "phenotype": "Mental health problems ever diagnosed by a professional: Autism, Asperger's or autistic spectrum disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Autism spectrum disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_14.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_14.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_15",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_15",
    "phenotype": "Mental health problems ever diagnosed by a professional: Anxiety, nerves or generalized anxiety disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Generalized anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_15.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_15.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_16",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_16",
    "phenotype": "Mental health problems ever diagnosed by a professional: Anorexia nervosa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anorexia nervosa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_16.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_16.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_17",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_17",
    "phenotype": "Mental health problems ever diagnosed by a professional: Agoraphobia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Agoraphobia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_17.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_17.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_2",
    "phenotype": "Mental health problems ever diagnosed by a professional: Schizophrenia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_3",
    "phenotype": "Mental health problems ever diagnosed by a professional: Any other type of psychosis or psychotic illness",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psychotic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_4",
    "phenotype": "Mental health problems ever diagnosed by a professional: A personality disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_5",
    "phenotype": "Mental health problems ever diagnosed by a professional: Any other phobia (eg disabling fear of heights or spiders)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Specific phobia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_6",
    "phenotype": "Mental health problems ever diagnosed by a professional: Panic attacks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20544_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20544_7",
    "phenotype": "Mental health problems ever diagnosed by a professional: Obsessive compulsive disorder (OCD)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "OCD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20544_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 20544_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20546_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20546_1",
    "phenotype": "Substances taken for depression: Unprescribed medication (more than once)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Unprescribed medication for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20546_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20546_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20546_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20546_3",
    "phenotype": "Substances taken for depression: Medication prescribed to you (for at least two weeks)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Prescribed medication for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20546_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20546_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20546_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20546_4",
    "phenotype": "Substances taken for depression: Drugs or alcohol (more than once)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Drugs/alcohol for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20546_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20546_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20547_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20547_1",
    "phenotype": "Activities undertaken to treat depression: Talking therapies, such as psychotherapy, counselling, group therapy or CBT",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Talk therapy for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20547_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20547_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20547_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20547_3",
    "phenotype": "Activities undertaken to treat depression: Other therapeutic activities such as mindfulness, yoga or art classes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Complementary therapy for depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20547_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20547_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_1",
    "phenotype": "Manifestations of mania or irritability: I was more talkative than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - talkative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_2",
    "phenotype": "Manifestations of mania or irritability: I was more restless than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - restless",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_3",
    "phenotype": "Manifestations of mania or irritability: My thoughts were racing",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - racing thoughts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_5",
    "phenotype": "Manifestations of mania or irritability: I needed less sleep than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - reduced sleep need",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_6",
    "phenotype": "Manifestations of mania or irritability: I was more creative or had more ideas than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - increased creativity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_7",
    "phenotype": "Manifestations of mania or irritability: I was easily distracted",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - distractibility",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_8",
    "phenotype": "Manifestations of mania or irritability: I was more confident than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - increased confidence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20548_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20548_9",
    "phenotype": "Manifestations of mania or irritability: I was more active than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - increased activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20548_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 20548_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20549_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20549_1",
    "phenotype": "Substances taken for anxiety: Unprescribed medication (more than once)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Unprescribed medication for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20549_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20549_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20549_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20549_3",
    "phenotype": "Substances taken for anxiety: Medication prescribed to you (for at least two weeks)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Prescribed medication for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20549_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20549_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20549_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20549_4",
    "phenotype": "Substances taken for anxiety: Drugs or alcohol (more than once)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Drugs/alcohol for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20549_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20549_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20550_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20550_1",
    "phenotype": "Activities undertaken to treat anxiety: Talking therapies, such as psychotherapy, counselling, group therapy or CBT",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Talk therapy for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20550_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20550_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20550_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20550_3",
    "phenotype": "Activities undertaken to treat anxiety: Other therapeutic activities such as mindfulness, yoga or art classes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Complementary therapy for anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20550_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20550_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20551_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20551_1",
    "phenotype": "Substance of prescription or over-the-counter medication addiction: A sedative, benzodiazepine or sleeping tablet",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Addicted to sedative/benzodiazepine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20551_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20551_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20551_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20551_2",
    "phenotype": "Substance of prescription or over-the-counter medication addiction: A painkiller",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Addicted to painkiller",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20551_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20551_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20551_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20551_3",
    "phenotype": "Substance of prescription or over-the-counter medication addiction: Something else",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Addicted to other medication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20551_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20551_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20552_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20552_1",
    "phenotype": "Behavioural and miscellaneous addictions: Something else not mentioned",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other behavioral addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20552_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20552_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20552_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20552_2",
    "phenotype": "Behavioural and miscellaneous addictions: A behaviour",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral addiction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20552_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 20552_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20553_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20553_1",
    "phenotype": "Methods of self-harm used: Something not listed",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm method - other",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20553_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20553_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20553_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20553_3",
    "phenotype": "Methods of self-harm used: Stopping prescribed medication",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - stopping medication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20553_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20553_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20553_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20553_4",
    "phenotype": "Methods of self-harm used: Ingesting a medication in excess of the normal dose",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - overdose",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20553_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20553_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20553_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20553_5",
    "phenotype": "Methods of self-harm used: Self-injury such as self-cutting, scratching or hitting, etc.",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - self-injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20553_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20553_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20553_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20553_6",
    "phenotype": "Methods of self-harm used: Ingesting alcohol or a recreational or illicit drug",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Self-harm - substance ingestion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20553_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20553_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20554_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20554_1",
    "phenotype": "Actions taken following self-harm: See anyone from psychiatric or mental health services, including liaison services",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Post-self-harm - mental health services",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20554_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 20554_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20554_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20554_3",
    "phenotype": "Actions taken following self-harm: Need hospital treatment (eg A&E)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Post-self-harm - hospital treatment",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20554_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 20554_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20554_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20554_4",
    "phenotype": "Actions taken following self-harm: Use a helpline / voluntary organization",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Post-self-harm - helpline",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20554_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 20554_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20554_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20554_5",
    "phenotype": "Actions taken following self-harm: See own GP",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Post-self-harm - GP",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20554_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 20554_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "20554_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "20554_6",
    "phenotype": "Actions taken following self-harm: Receive help from friends / family / neighbours",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Post-self-harm - social support",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/20554_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 20554_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2060",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2060",
    "phenotype": "Frequency of unenthusiasm / disinterest in last 2 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Anhedonia frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2060.gwas.imputed_v3.both_sexes.tsv.bgz -O 2060.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2070",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2070",
    "phenotype": "Frequency of tenseness / restlessness in last 2 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Tension/restlessness frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2070.gwas.imputed_v3.both_sexes.tsv.bgz -O 2070.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2080",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2080",
    "phenotype": "Frequency of tiredness / lethargy in last 2 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Fatigue frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2080.gwas.imputed_v3.both_sexes.tsv.bgz -O 2080.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2090",
    "phenotype": "Seen doctor (GP) for nerves, anxiety, tension or depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "GP visit for mental health",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2090.gwas.imputed_v3.both_sexes.tsv.bgz -O 2090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2100",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2100",
    "phenotype": "Seen a psychiatrist for nerves, anxiety, tension or depression",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Psychiatrist visit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2100.gwas.imputed_v3.both_sexes.tsv.bgz -O 2100.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "21001_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "21001",
    "phenotype": "Body mass index (BMI)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body mass index",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/21001_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 21001_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "21002_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "21002",
    "phenotype": "Weight",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body weight",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/21002_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 21002_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "21021_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "21021",
    "phenotype": "Pulse wave Arterial Stiffness index",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arterial stiffness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/21021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 21021_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2110",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2110",
    "phenotype": "Able to confide",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Able to confide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2110.gwas.imputed_v3.both_sexes.tsv.bgz -O 2110.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2129",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2129",
    "phenotype": "Answered sexual history questions",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sexual history answered",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2129.gwas.imputed_v3.both_sexes.tsv.bgz -O 2129.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2139_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2139",
    "phenotype": "Age first had sexual intercourse",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at first intercourse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2139_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2139_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2149",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2149",
    "phenotype": "Lifetime number of sexual partners",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lifetime sexual partners",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2149.gwas.imputed_v3.both_sexes.tsv.bgz -O 2149.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2159",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2159",
    "phenotype": "Ever had same-sex intercourse",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Same-sex intercourse history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2159.gwas.imputed_v3.both_sexes.tsv.bgz -O 2159.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2178",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2178",
    "phenotype": "Overall health rating",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Self-rated health",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2178.gwas.imputed_v3.both_sexes.tsv.bgz -O 2178.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2188",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2188",
    "phenotype": "Long-standing illness, disability or infirmity",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Long-standing illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2188.gwas.imputed_v3.both_sexes.tsv.bgz -O 2188.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2207",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2207",
    "phenotype": "Wears glasses or contact lenses",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Vision correction use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2207.gwas.imputed_v3.both_sexes.tsv.bgz -O 2207.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22126",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22126",
    "phenotype": "Doctor diagnosed hayfever or allergic rhinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergic rhinitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22126.gwas.imputed_v3.both_sexes.tsv.bgz -O 22126.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22127",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22127",
    "phenotype": "Doctor diagnosed asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22127.gwas.imputed_v3.both_sexes.tsv.bgz -O 22127.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22128",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22128",
    "phenotype": "Doctor diagnosed emphysema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22128.gwas.imputed_v3.both_sexes.tsv.bgz -O 22128.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22129",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22129",
    "phenotype": "Doctor diagnosed chronic bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22129.gwas.imputed_v3.both_sexes.tsv.bgz -O 22129.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22130",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22130",
    "phenotype": "Doctor diagnosed COPD (chronic obstructive pulmonary disease)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22130.gwas.imputed_v3.both_sexes.tsv.bgz -O 22130.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22133",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22133",
    "phenotype": "Doctor diagnosed sarcoidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sarcoidosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22133.gwas.imputed_v3.both_sexes.tsv.bgz -O 22133.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22134",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22134",
    "phenotype": "Doctor diagnosed bronchiectasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchiectasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22134.gwas.imputed_v3.both_sexes.tsv.bgz -O 22134.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22137",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22137",
    "phenotype": "Doctor diagnosed tuberculosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tuberculosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22137.gwas.imputed_v3.both_sexes.tsv.bgz -O 22137.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22140",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22140",
    "phenotype": "Doctor diagnosed lung cancer (not mesothelioma)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22140.gwas.imputed_v3.both_sexes.tsv.bgz -O 22140.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22146_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22146",
    "phenotype": "Age hayfever or allergic rhinitis diagnosed by doctor",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at allergic rhinitis diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22146_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22146_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22147_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22147",
    "phenotype": "Age asthma diagnosed by doctor",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at asthma diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22147_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22147_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22166",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22166",
    "phenotype": "Recent medication for hayfever or allergic rhinitis",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for allergic rhinitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22166.gwas.imputed_v3.both_sexes.tsv.bgz -O 22166.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22167",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22167",
    "phenotype": "Recent medication for asthma",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22167.gwas.imputed_v3.both_sexes.tsv.bgz -O 22167.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22169",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22169",
    "phenotype": "Recent medication for chronic bronchitis",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for chronic bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22169.gwas.imputed_v3.both_sexes.tsv.bgz -O 22169.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2217_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2217",
    "phenotype": "Age started wearing glasses or contact lenses",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at starting vision correction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2217_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2217_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22170",
    "phenotype": "Recent medication for COPD (Chronic Obstructive Pulmonary Disease)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22170.gwas.imputed_v3.both_sexes.tsv.bgz -O 22170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22174",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22174",
    "phenotype": "Recent medication for bronchiectasis",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Medication for bronchiectasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22174.gwas.imputed_v3.both_sexes.tsv.bgz -O 22174.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2227",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2227",
    "phenotype": "Other eye problems",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Other eye problems",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2227.gwas.imputed_v3.both_sexes.tsv.bgz -O 2227.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2237",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2237",
    "phenotype": "Plays computer games",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Computer gaming",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2237.gwas.imputed_v3.both_sexes.tsv.bgz -O 2237.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2247_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2247_0",
    "phenotype": "Hearing difficulty/problems: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing difficulty - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2247_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 2247_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2247_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2247_1",
    "phenotype": "Hearing difficulty/problems: Yes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing difficulty - yes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2247_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 2247_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22501_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22501",
    "phenotype": "Year ended full time education",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Year ended full-time education",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22501_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22501_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22502",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22502",
    "phenotype": "Cough on most days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Chronic cough",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22502.gwas.imputed_v3.both_sexes.tsv.bgz -O 22502.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22503_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22503",
    "phenotype": "Years of cough on most days",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chronic cough duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22503_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22503_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22504",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22504",
    "phenotype": "Bring up phlegm/sputum/mucus on most days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Chronic sputum production",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22504.gwas.imputed_v3.both_sexes.tsv.bgz -O 22504.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22506_111",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22506_111",
    "phenotype": "Tobacco smoking: Smokes on most or all days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Current daily smoker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22506_111.gwas.imputed_v3.both_sexes.tsv.bgz -O 22506_111.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22506_112",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22506_112",
    "phenotype": "Tobacco smoking: Occasionally",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Occasional smoker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22506_112.gwas.imputed_v3.both_sexes.tsv.bgz -O 22506_112.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22506_113",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22506_113",
    "phenotype": "Tobacco smoking: Ex-smoker",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former smoker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22506_113.gwas.imputed_v3.both_sexes.tsv.bgz -O 22506_113.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22506_114",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22506_114",
    "phenotype": "Tobacco smoking: Never smoked",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Never smoker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22506_114.gwas.imputed_v3.both_sexes.tsv.bgz -O 22506_114.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22507_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22507",
    "phenotype": "Age of stopping smoking",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at smoking cessation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22507_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22507_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2257",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2257",
    "phenotype": "Hearing difficulty/problems with background noise",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing difficulty with background noise",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2257.gwas.imputed_v3.both_sexes.tsv.bgz -O 2257.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22604_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22604_1",
    "phenotype": "Work hours - lumped category: 15 to less-than-20 hours",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work hours 15-20",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22604_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22604_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22604_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22604_2",
    "phenotype": "Work hours - lumped category: 20 to less-than-30 hours",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work hours 20-30",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22604_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22604_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22604_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22604_3",
    "phenotype": "Work hours - lumped category: 30 to 40 hours",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work hours 30-40",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22604_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 22604_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22604_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22604_4",
    "phenotype": "Work hours - lumped category: Over 40 hours",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work hours >40",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22604_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 22604_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22605_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22605",
    "phenotype": "Work hours per week - exact value",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work hours per week",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22605_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22605_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22606_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22606_0",
    "phenotype": "Workplace very noisy: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace noise exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22606_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22606_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22606_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22606_1",
    "phenotype": "Workplace very noisy: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace noise exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22606_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22606_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22606_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22606_2",
    "phenotype": "Workplace very noisy: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace noise exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22606_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22606_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22607_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22607_0",
    "phenotype": "Workplace very cold: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace cold exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22607_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22607_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22607_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22607_1",
    "phenotype": "Workplace very cold: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace cold exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22607_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22607_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22607_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22607_2",
    "phenotype": "Workplace very cold: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace cold exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22607_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22607_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22608_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22608_0",
    "phenotype": "Workplace very hot: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace heat exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22608_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22608_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22608_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22608_1",
    "phenotype": "Workplace very hot: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace heat exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22608_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22608_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22608_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22608_2",
    "phenotype": "Workplace very hot: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace heat exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22608_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22608_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22609_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22609_0",
    "phenotype": "Workplace very dusty: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace dust exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22609_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22609_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22609_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22609_1",
    "phenotype": "Workplace very dusty: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace dust exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22609_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22609_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22609_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22609_2",
    "phenotype": "Workplace very dusty: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace dust exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22609_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22609_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22610_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22610_0",
    "phenotype": "Workplace full of chemical or other fumes: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace fume exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22610_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22610_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22610_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22610_1",
    "phenotype": "Workplace full of chemical or other fumes: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace fume exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22610_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22610_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22610_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22610_2",
    "phenotype": "Workplace full of chemical or other fumes: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace fume exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22610_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22610_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22611_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22611_0",
    "phenotype": "Workplace had a lot of cigarette smoke from other people smoking: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace ETS exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22611_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22611_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22611_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22611_1",
    "phenotype": "Workplace had a lot of cigarette smoke from other people smoking: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace ETS exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22611_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22611_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22611_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22611_2",
    "phenotype": "Workplace had a lot of cigarette smoke from other people smoking: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace ETS exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22611_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22611_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22612_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22612_0",
    "phenotype": "Worked with materials containing asbestos: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Asbestos exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22612_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22612_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22612_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22612_1",
    "phenotype": "Worked with materials containing asbestos: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Asbestos exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22612_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22612_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22612_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22612_2",
    "phenotype": "Worked with materials containing asbestos: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Asbestos exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22612_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22612_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22613_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22613_0",
    "phenotype": "Worked with paints, thinners or glues: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Paint/thinner exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22613_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22613_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22613_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22613_1",
    "phenotype": "Worked with paints, thinners or glues: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Paint/thinner exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22613_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22613_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22613_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22613_2",
    "phenotype": "Worked with paints, thinners or glues: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Paint/thinner exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22613_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22613_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22614_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22614_0",
    "phenotype": "Worked with pesticides: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pesticide exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22614_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22614_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22614_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22614_1",
    "phenotype": "Worked with pesticides: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pesticide exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22614_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22614_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22614_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22614_2",
    "phenotype": "Worked with pesticides: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pesticide exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22614_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22614_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22615_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22615_0",
    "phenotype": "Workplace had a lot of diesel exhaust: Rarely/never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Diesel exhaust exposure - rarely/never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22615_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22615_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22615_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22615_1",
    "phenotype": "Workplace had a lot of diesel exhaust: Sometimes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Diesel exhaust exposure - sometimes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22615_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22615_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22615_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22615_2",
    "phenotype": "Workplace had a lot of diesel exhaust: Often",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Diesel exhaust exposure - often",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22615_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 22615_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22618_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22618_0",
    "phenotype": "Breathing problems improved/stopped away from workplace or on holiday: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work-related breathing improvement - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22618_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 22618_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22618_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22618_1",
    "phenotype": "Breathing problems improved/stopped away from workplace or on holiday: Yes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Work-related breathing improvement - yes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22618_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 22618_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22641_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22641",
    "phenotype": "Period spent working mix of day and night shifts",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Shift work - mixed",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22641_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22641_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22642",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22642",
    "phenotype": "Usual length of each night shift during mixed shift periods",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Night shift duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22642.gwas.imputed_v3.both_sexes.tsv.bgz -O 22642.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22643_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22643",
    "phenotype": "Number of night shifts worked monthly during mixed shift periods",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Night shifts per month",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22643_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22643_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22644_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22644",
    "phenotype": "Consecutive night shifts during mixed shift periods",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Consecutive night shifts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22644_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22644_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22645",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22645",
    "phenotype": "Rest days during mixed shift periods",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Rest days after night shifts",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22645.gwas.imputed_v3.both_sexes.tsv.bgz -O 22645.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_101",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_101",
    "phenotype": "Gap coding: Paid work for less than 15 hours per week on average or lasting less than 6 months",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - paid work <15h",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_101.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_101.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_102",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_102",
    "phenotype": "Gap coding: Unpaid or voluntary work",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - voluntary",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_102.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_102.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_103",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_103",
    "phenotype": "Gap coding: Full-time or part-time education",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - education",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_103.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_103.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_105",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_105",
    "phenotype": "Gap coding: Looking after the home and/or family",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - home/family",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_105.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_105.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_106",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_106",
    "phenotype": "Gap coding: Unable to work due to sickness or disability",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - sickness/disability",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_106.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_106.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_107",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_107",
    "phenotype": "Gap coding: Unemployed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - unemployed",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_107.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_107.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22660_108",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22660_108",
    "phenotype": "Gap coding: Retired",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Employment gap - retired",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22660_108.gwas.imputed_v3.both_sexes.tsv.bgz -O 22660_108.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2267",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2267",
    "phenotype": "Use of sun/uv protection",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Sun/UV protection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2267.gwas.imputed_v3.both_sexes.tsv.bgz -O 2267.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22702_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22702",
    "phenotype": "Home location - east co-ordinate (rounded)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Home east coordinate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22702_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22702_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "22704_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "22704",
    "phenotype": "Home location - north co-ordinate (rounded)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Home north coordinate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/22704_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 22704_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2277",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2277",
    "phenotype": "Frequency of solarium/sunlamp use",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Solarium/sunlamp use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2277.gwas.imputed_v3.both_sexes.tsv.bgz -O 2277.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2296",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2296",
    "phenotype": "Falls in the last year",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Falls past year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2296.gwas.imputed_v3.both_sexes.tsv.bgz -O 2296.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2306",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2306",
    "phenotype": "Weight change compared with 1 year ago",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Weight change over 1 year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2306.gwas.imputed_v3.both_sexes.tsv.bgz -O 2306.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23098_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23098",
    "phenotype": "Weight",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body weight",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23098_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23098_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23099_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23099",
    "phenotype": "Body fat percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body fat percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23099_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23099_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23100_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23100",
    "phenotype": "Whole body fat mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Whole body fat mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23101_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23101",
    "phenotype": "Whole body fat-free mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Whole body fat-free mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23102_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23102",
    "phenotype": "Whole body water mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Whole body water mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23104_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23104",
    "phenotype": "Body mass index (BMI)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Body mass index",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23105_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23105",
    "phenotype": "Basal metabolic rate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Basal metabolic rate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23106_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23106",
    "phenotype": "Impedance of whole body",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Whole body impedance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23107_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23107",
    "phenotype": "Impedance of leg (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg impedance - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23107_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23107_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23108_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23108",
    "phenotype": "Impedance of leg (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg impedance - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23108_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23108_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23109_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23109",
    "phenotype": "Impedance of arm (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm impedance - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23109_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23109_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23110_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23110",
    "phenotype": "Impedance of arm (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm impedance - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23111_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23111",
    "phenotype": "Leg fat percentage (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat percent - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23111_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23111_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23112_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23112",
    "phenotype": "Leg fat mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23112_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23112_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23113_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23113",
    "phenotype": "Leg fat-free mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat-free mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23113_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23113_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23114_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23114",
    "phenotype": "Leg predicted mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg predicted mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23114_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23114_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23115_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23115",
    "phenotype": "Leg fat percentage (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat percent - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23115_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23115_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23116_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23116",
    "phenotype": "Leg fat mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23116_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23116_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23117_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23117",
    "phenotype": "Leg fat-free mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg fat-free mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23117_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23117_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23118_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23118",
    "phenotype": "Leg predicted mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg predicted mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23118_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23118_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23119_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23119",
    "phenotype": "Arm fat percentage (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat percent - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23120_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23120",
    "phenotype": "Arm fat mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23121_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23121",
    "phenotype": "Arm fat-free mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat-free mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23121_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23121_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23122_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23122",
    "phenotype": "Arm predicted mass (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm predicted mass - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23122_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23122_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23123_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23123",
    "phenotype": "Arm fat percentage (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat percent - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23123_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23123_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23124_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23124",
    "phenotype": "Arm fat mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23124_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23124_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23125_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23125",
    "phenotype": "Arm fat-free mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm fat-free mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23125_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23125_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23126_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23126",
    "phenotype": "Arm predicted mass (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Arm predicted mass - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23126_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23126_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23127_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23127",
    "phenotype": "Trunk fat percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Trunk fat percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23127_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23127_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23128_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23128",
    "phenotype": "Trunk fat mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Trunk fat mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23128_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23128_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23129_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23129",
    "phenotype": "Trunk fat-free mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Trunk fat-free mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23129_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23129_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "23130_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "23130",
    "phenotype": "Trunk predicted mass",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Trunk predicted mass",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/23130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 23130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2316",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2316",
    "phenotype": "Wheeze or whistling in the chest in last year",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Wheeze past year",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2316.gwas.imputed_v3.both_sexes.tsv.bgz -O 2316.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2335",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2335",
    "phenotype": "Chest pain or discomfort",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain/discomfort",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2335.gwas.imputed_v3.both_sexes.tsv.bgz -O 2335.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2345",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2345",
    "phenotype": "Ever had bowel cancer screening",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Bowel cancer screening ever",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2345.gwas.imputed_v3.both_sexes.tsv.bgz -O 2345.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2355",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2355",
    "phenotype": "Most recent bowel cancer screening",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Time since bowel screening",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2355.gwas.imputed_v3.both_sexes.tsv.bgz -O 2355.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2365",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2365",
    "phenotype": "Ever had prostate specific antigen (PSA) test",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "PSA test ever",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2365.gwas.imputed_v3.both_sexes.tsv.bgz -O 2365.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2375",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2375",
    "phenotype": "Relative age of first facial hair",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age of first facial hair (relative)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2375.gwas.imputed_v3.both_sexes.tsv.bgz -O 2375.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2385",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2385",
    "phenotype": "Relative age voice broke",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age voice broke (relative)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2385.gwas.imputed_v3.both_sexes.tsv.bgz -O 2385.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2395_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2395_1",
    "phenotype": "Hair/balding pattern: Pattern 1",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Balding pattern 1",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2395_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 2395_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2395_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2395_2",
    "phenotype": "Hair/balding pattern: Pattern 2",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Balding pattern 2",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2395_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 2395_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2395_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2395_3",
    "phenotype": "Hair/balding pattern: Pattern 3",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Balding pattern 3",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2395_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 2395_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2395_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2395_4",
    "phenotype": "Hair/balding pattern: Pattern 4",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Balding pattern 4",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2395_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 2395_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2405",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2405",
    "phenotype": "Number of children fathered",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of children fathered",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2405.gwas.imputed_v3.both_sexes.tsv.bgz -O 2405.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2415",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2415",
    "phenotype": "Had major operations",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Major operations history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2415.gwas.imputed_v3.both_sexes.tsv.bgz -O 2415.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2443",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2443",
    "phenotype": "Diabetes diagnosed by doctor",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2443.gwas.imputed_v3.both_sexes.tsv.bgz -O 2443.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2453",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2453",
    "phenotype": "Cancer diagnosed by doctor",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer (any)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2453.gwas.imputed_v3.both_sexes.tsv.bgz -O 2453.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2463",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2463",
    "phenotype": "Fractured/broken bones in last 5 years",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fractures past 5 years",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2463.gwas.imputed_v3.both_sexes.tsv.bgz -O 2463.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2624",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2624",
    "phenotype": "Frequency of heavy DIY in last 4 weeks",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Heavy DIY frequency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2624.gwas.imputed_v3.both_sexes.tsv.bgz -O 2624.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2634",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2634",
    "phenotype": "Duration of heavy DIY",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heavy DIY duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2634.gwas.imputed_v3.both_sexes.tsv.bgz -O 2634.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2644",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2644",
    "phenotype": "Light smokers, at least 100 smokes in lifetime",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Light smoker (100+ lifetime)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2644.gwas.imputed_v3.both_sexes.tsv.bgz -O 2644.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2664_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2664_1",
    "phenotype": "Reason for reducing amount of alcohol drunk: Illness or ill health",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol reduction reason - illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2664_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 2664_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2664_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2664_2",
    "phenotype": "Reason for reducing amount of alcohol drunk: Doctor's advice",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol reduction reason - doctor advice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2664_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 2664_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2664_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2664_3",
    "phenotype": "Reason for reducing amount of alcohol drunk: Health precaution",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol reduction reason - health precaution",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2664_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 2664_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2664_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2664_4",
    "phenotype": "Reason for reducing amount of alcohol drunk: Financial reasons",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Alcohol reduction reason - financial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2664_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 2664_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2684",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2684",
    "phenotype": "Years since last breast cancer screening / mammogram",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Years since last mammogram",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2684.gwas.imputed_v3.both_sexes.tsv.bgz -O 2684.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2704",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2704",
    "phenotype": "Years since last cervical smear test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Years since last cervical smear",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2704.gwas.imputed_v3.both_sexes.tsv.bgz -O 2704.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2714",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2714",
    "phenotype": "Age when periods started (menarche)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at menarche",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2714.gwas.imputed_v3.both_sexes.tsv.bgz -O 2714.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2724",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2724",
    "phenotype": "Had menopause",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Menopause status",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2724.gwas.imputed_v3.both_sexes.tsv.bgz -O 2724.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2744",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2744",
    "phenotype": "Birth weight of first child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "First child birth weight",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2744.gwas.imputed_v3.both_sexes.tsv.bgz -O 2744.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2754_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2754",
    "phenotype": "Age at first live birth",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at first live birth",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2754_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2754_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2764_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2764",
    "phenotype": "Age at last live birth",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at last live birth",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2764_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2764_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2794_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2794",
    "phenotype": "Age started oral contraceptive pill",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Age at starting oral contraceptive",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2794_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2794_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2814",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2814",
    "phenotype": "Ever used hormone-replacement therapy (HRT)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "HRT ever use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2814.gwas.imputed_v3.both_sexes.tsv.bgz -O 2814.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2834",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2834",
    "phenotype": "Bilateral oophorectomy (both ovaries removed)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Bilateral oophorectomy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2834.gwas.imputed_v3.both_sexes.tsv.bgz -O 2834.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2867_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2867",
    "phenotype": "Age started smoking in former smokers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Age at smoking start (former smokers)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2867_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2867_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2877_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2877_1",
    "phenotype": "Type of tobacco previously smoked: Manufactured cigarettes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Previous tobacco type - manufactured cigarettes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2877_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 2877_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2877_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2877_2",
    "phenotype": "Type of tobacco previously smoked: Hand-rolled cigarettes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Previous tobacco type - hand-rolled",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2877_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 2877_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2877_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2877_3",
    "phenotype": "Type of tobacco previously smoked: Cigars or pipes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Previous tobacco type - cigars/pipes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2877_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 2877_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2887",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2887",
    "phenotype": "Number of cigarettes previously smoked daily",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Previous cigarettes per day",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2887.gwas.imputed_v3.both_sexes.tsv.bgz -O 2887.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2907",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2907",
    "phenotype": "Ever stopped smoking for 6+ months",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking cessation >6 months",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2907.gwas.imputed_v3.both_sexes.tsv.bgz -O 2907.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2926",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2926",
    "phenotype": "Number of unsuccessful stop-smoking attempts",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Failed quit attempts count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2926.gwas.imputed_v3.both_sexes.tsv.bgz -O 2926.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2936",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2936",
    "phenotype": "Likelihood of resuming smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Likelihood of relapse to smoking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2936.gwas.imputed_v3.both_sexes.tsv.bgz -O 2936.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2956",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2956",
    "phenotype": "General pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pain (general)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2956.gwas.imputed_v3.both_sexes.tsv.bgz -O 2956.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2966_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2966",
    "phenotype": "Age high blood pressure diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at hypertension diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2966_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2966_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2976_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2976",
    "phenotype": "Age diabetes diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at diabetes diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2976_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 2976_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "2986",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "2986",
    "phenotype": "Started insulin within one year diagnosis of diabetes",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Insulin started within 1 year of diabetes diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/2986.gwas.imputed_v3.both_sexes.tsv.bgz -O 2986.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30000_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30000",
    "phenotype": "White blood cell (leukocyte) count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "White blood cell count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30000_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30000_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30010_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30010",
    "phenotype": "Red blood cell (erythrocyte) count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Red blood cell count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30010_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30010_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30020_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30020",
    "phenotype": "Haemoglobin concentration",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hemoglobin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30020_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30020_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30030_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30030",
    "phenotype": "Haematocrit percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hematocrit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30030_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30030_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30040_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30040",
    "phenotype": "Mean corpuscular volume",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "MCV",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30040_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30040_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3005",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3005",
    "phenotype": "Fracture resulting from simple fall",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fracture from simple fall",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3005.gwas.imputed_v3.both_sexes.tsv.bgz -O 3005.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30050_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30050",
    "phenotype": "Mean corpuscular haemoglobin",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "MCH",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30050_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30050_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30060_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30060",
    "phenotype": "Mean corpuscular haemoglobin concentration",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "MCHC",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30060_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30060_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30070_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30070",
    "phenotype": "Red blood cell (erythrocyte) distribution width",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "RDW",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30070_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30070_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30080_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30080",
    "phenotype": "Platelet count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Platelet count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30080_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30080_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30090_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30090",
    "phenotype": "Platelet crit",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Platelet crit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30090_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30090_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30100_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30100",
    "phenotype": "Mean platelet (thrombocyte) volume",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "MPV",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30110_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30110",
    "phenotype": "Platelet distribution width",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "PDW",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30120_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30120",
    "phenotype": "Lymphocyte count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lymphocyte count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30130_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30130",
    "phenotype": "Monocyte count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Monocyte count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30130_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30140_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30140",
    "phenotype": "Neutrophill count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Neutrophil count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30140_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30140_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30150",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30150",
    "phenotype": "Eosinophill count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Eosinophil count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30150.gwas.imputed_v3.both_sexes.tsv.bgz -O 30150.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30160",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30160",
    "phenotype": "Basophill count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Basophil count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30160.gwas.imputed_v3.both_sexes.tsv.bgz -O 30160.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30170",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30170",
    "phenotype": "Nucleated red blood cell count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "NRBC count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30170.gwas.imputed_v3.both_sexes.tsv.bgz -O 30170.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30180_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30180",
    "phenotype": "Lymphocyte percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lymphocyte percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30180_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30180_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30190_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30190",
    "phenotype": "Monocyte percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Monocyte percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30190_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30190_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30200_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30200",
    "phenotype": "Neutrophill percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Neutrophil percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30200_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30200_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30210_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30210",
    "phenotype": "Eosinophill percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Eosinophil percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30210_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30210_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30220_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30220",
    "phenotype": "Basophill percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Basophil percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30220_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30220_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30230",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30230",
    "phenotype": "Nucleated red blood cell percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "NRBC percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30230.gwas.imputed_v3.both_sexes.tsv.bgz -O 30230.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30240_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30240",
    "phenotype": "Reticulocyte percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Reticulocyte percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30240_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30240_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30250_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30250",
    "phenotype": "Reticulocyte count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Reticulocyte count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30250_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30250_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30260_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30260",
    "phenotype": "Mean reticulocyte volume",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mean reticulocyte volume",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30260_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30260_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30270_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30270",
    "phenotype": "Mean sphered cell volume",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mean sphered cell volume",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30270_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30270_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30280_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30280",
    "phenotype": "Immature reticulocyte fraction",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Immature reticulocyte fraction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30280_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30280_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30290_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30290",
    "phenotype": "High light scatter reticulocyte percentage",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "High light scatter reticulocyte percent",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30290_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30290_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30300_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30300",
    "phenotype": "High light scatter reticulocyte count",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "High light scatter reticulocyte count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30300_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30300_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30500_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30500",
    "phenotype": "Microalbumin in urine",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urine microalbumin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30500_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30500_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30510_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30510",
    "phenotype": "Creatinine (enzymatic) in urine",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urine creatinine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30510_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30510_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30520_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30520",
    "phenotype": "Potassium in urine",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urine potassium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30520_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30520_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30530_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30530",
    "phenotype": "Sodium in urine",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urine sodium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30530_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 30530_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3062_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3062",
    "phenotype": "Forced vital capacity (FVC)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FVC",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3062_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3062_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3063_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3063",
    "phenotype": "Forced expiratory volume in 1-second (FEV1)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FEV1",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3063_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3063_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3064_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3064",
    "phenotype": "Peak expiratory flow (PEF)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "PEF",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3064_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3064_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3079",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3079",
    "phenotype": "Pace-maker",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pacemaker presence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3079.gwas.imputed_v3.both_sexes.tsv.bgz -O 3079.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3082",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3082",
    "phenotype": "Fractured heel",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heel fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3082.gwas.imputed_v3.both_sexes.tsv.bgz -O 3082.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3089",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3089",
    "phenotype": "Caffeine drink within last hour",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Caffeine drink in last hour",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3089.gwas.imputed_v3.both_sexes.tsv.bgz -O 3089.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3090",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3090",
    "phenotype": "Used an inhaler for chest within last hour",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Inhaler use in last hour",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3090.gwas.imputed_v3.both_sexes.tsv.bgz -O 3090.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3143_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3143",
    "phenotype": "Ankle spacing width",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Ankle spacing width (unspecified)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3143_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3143_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3144_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3144",
    "phenotype": "Heel Broadband ultrasound attenuation, direct entry",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BUA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3144_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3144_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3147_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3147",
    "phenotype": "Heel quantitative ultrasound index (QUI), direct entry",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel QUI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3147_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3147_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3148_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3148",
    "phenotype": "Heel bone mineral density (BMD)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3148_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3148_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3159",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3159",
    "phenotype": "Smoked cigarette or pipe within last hour",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Smoked in last hour",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3159.gwas.imputed_v3.both_sexes.tsv.bgz -O 3159.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3160_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3160",
    "phenotype": "Weight, manual entry",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Weight (manual)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3160_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3160_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3393",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3393",
    "phenotype": "Hearing aid user",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing aid use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3393.gwas.imputed_v3.both_sexes.tsv.bgz -O 3393.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3404",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3404",
    "phenotype": "Neck/shoulder pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neck/shoulder pain chronic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3404.gwas.imputed_v3.both_sexes.tsv.bgz -O 3404.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3414",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3414",
    "phenotype": "Hip pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip pain chronic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3414.gwas.imputed_v3.both_sexes.tsv.bgz -O 3414.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3436_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3436",
    "phenotype": "Age started smoking in current smokers",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Age at smoking start (current smokers)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3436_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3436_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3446_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3446_1",
    "phenotype": "Type of tobacco currently smoked: Manufactured cigarettes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Current tobacco type - manufactured",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3446_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 3446_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3446_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3446_2",
    "phenotype": "Type of tobacco currently smoked: Hand-rolled cigarettes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Current tobacco type - hand-rolled",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3446_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 3446_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3446_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3446_3",
    "phenotype": "Type of tobacco currently smoked: Cigars or pipes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Current tobacco type - cigars/pipes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3446_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 3446_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3456",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3456",
    "phenotype": "Number of cigarettes currently smoked daily (current cigarette smokers)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Current cigarettes per day",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3456.gwas.imputed_v3.both_sexes.tsv.bgz -O 3456.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3466",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3466",
    "phenotype": "Time from waking to first cigarette",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Time to first cigarette after waking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3466.gwas.imputed_v3.both_sexes.tsv.bgz -O 3466.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3476",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3476",
    "phenotype": "Difficulty not smoking for 1 day",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Difficulty abstaining 1 day",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3476.gwas.imputed_v3.both_sexes.tsv.bgz -O 3476.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3486",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3486",
    "phenotype": "Ever tried to stop smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever attempted smoking cessation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3486.gwas.imputed_v3.both_sexes.tsv.bgz -O 3486.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3496",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3496",
    "phenotype": "Wants to stop smoking",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Desire to stop smoking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3496.gwas.imputed_v3.both_sexes.tsv.bgz -O 3496.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3526_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3526",
    "phenotype": "Mother's age at death",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mother's age at death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3526_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3526_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3536_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3536",
    "phenotype": "Age started hormone-replacement therapy (HRT)",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Age at HRT start",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3536_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3536_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3571",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3571",
    "phenotype": "Back pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Back pain chronic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3571.gwas.imputed_v3.both_sexes.tsv.bgz -O 3571.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3581_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3581",
    "phenotype": "Age at menopause (last menstrual period)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at menopause",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3581_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3581_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3591",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3591",
    "phenotype": "Ever had hysterectomy (womb removed)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hysterectomy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3591.gwas.imputed_v3.both_sexes.tsv.bgz -O 3591.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3606",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3606",
    "phenotype": "Chest pain or discomfort walking normally",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain on walking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3606.gwas.imputed_v3.both_sexes.tsv.bgz -O 3606.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3616",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3616",
    "phenotype": "Chest pain due to walking ceases when standing still",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain relieved by standing",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3616.gwas.imputed_v3.both_sexes.tsv.bgz -O 3616.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3627_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3627",
    "phenotype": "Age angina diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at angina diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3627_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3627_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3669",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3669",
    "phenotype": "Lifetime number of same-sex sexual partners",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lifetime same-sex partners",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3669.gwas.imputed_v3.both_sexes.tsv.bgz -O 3669.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3710",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3710",
    "phenotype": "Length of menstrual cycle",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Menstrual cycle length",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3710.gwas.imputed_v3.both_sexes.tsv.bgz -O 3710.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3731",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3731",
    "phenotype": "Former alcohol drinker",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former alcohol drinker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3731.gwas.imputed_v3.both_sexes.tsv.bgz -O 3731.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3741",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3741",
    "phenotype": "Stomach/abdominal pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal pain chronic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3741.gwas.imputed_v3.both_sexes.tsv.bgz -O 3741.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3751",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3751",
    "phenotype": "Chest pain or discomfort when walking uphill or hurrying",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain on exertion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3751.gwas.imputed_v3.both_sexes.tsv.bgz -O 3751.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3761_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3761",
    "phenotype": "Age hay fever, rhinitis or eczema diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at allergy/eczema diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3761_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3761_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3773",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3773",
    "phenotype": "Knee pain for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee pain chronic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3773.gwas.imputed_v3.both_sexes.tsv.bgz -O 3773.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3786_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3786",
    "phenotype": "Age asthma diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at asthma diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3786_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3786_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3799",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3799",
    "phenotype": "Headaches for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic headache",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3799.gwas.imputed_v3.both_sexes.tsv.bgz -O 3799.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3829",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3829",
    "phenotype": "Number of stillbirths",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Stillbirth count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3829.gwas.imputed_v3.both_sexes.tsv.bgz -O 3829.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3839",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3839",
    "phenotype": "Number of spontaneous miscarriages",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Miscarriage count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3839.gwas.imputed_v3.both_sexes.tsv.bgz -O 3839.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3849",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3849",
    "phenotype": "Number of pregnancy terminations",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pregnancy termination count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3849.gwas.imputed_v3.both_sexes.tsv.bgz -O 3849.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3859_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3859_1",
    "phenotype": "Reason former drinker stopped drinking alcohol: Illness or ill health",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former drinker reason - illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3859_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 3859_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3859_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3859_2",
    "phenotype": "Reason former drinker stopped drinking alcohol: Doctor's advice",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former drinker reason - doctor advice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3859_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 3859_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3859_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3859_3",
    "phenotype": "Reason former drinker stopped drinking alcohol: Health precaution",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former drinker reason - health precaution",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3859_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 3859_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3859_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3859_4",
    "phenotype": "Reason former drinker stopped drinking alcohol: Financial reasons",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former drinker reason - financial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3859_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 3859_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3872_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3872",
    "phenotype": "Age of primiparous women at birth of child",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at first birth (primipara)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3872_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3872_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3894_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3894",
    "phenotype": "Age heart attack diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at heart attack diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3894_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 3894_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "3912",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "3912",
    "phenotype": "Adopted father still alive",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Adopted father alive status",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/3912.gwas.imputed_v3.both_sexes.tsv.bgz -O 3912.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C159",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C159",
    "phenotype": "Underlying (primary) cause of death: ICD10: C15.9 Oesophagus, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - esophagus cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C159.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C159.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C169",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C169",
    "phenotype": "Underlying (primary) cause of death: ICD10: C16.9 Stomach, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - stomach cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C169.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C169.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C189",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C189",
    "phenotype": "Underlying (primary) cause of death: ICD10: C18.9 Colon, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - colon cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C189.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C189.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C19",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C19",
    "phenotype": "Underlying (primary) cause of death: ICD10: C19 Malignant neoplasm of rectosigmoid junction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - rectosigmoid cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C19.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C19.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C20",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C20",
    "phenotype": "Underlying (primary) cause of death: ICD10: C20 Malignant neoplasm of rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - rectal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C20.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C20.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C221",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C221",
    "phenotype": "Underlying (primary) cause of death: ICD10: C22.1 Intrahepatic bile duct carcinoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - intrahepatic bile duct cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C221.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C221.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C259",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C259",
    "phenotype": "Underlying (primary) cause of death: ICD10: C25.9 Pancreas, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - pancreatic cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C259.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C259.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C349",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C349",
    "phenotype": "Underlying (primary) cause of death: ICD10: C34.9 Bronchus or lung, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C349.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C349.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C439",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C439",
    "phenotype": "Underlying (primary) cause of death: ICD10: C43.9 Malignant melanoma of skin, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - melanoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C439.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C439.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C459",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C459",
    "phenotype": "Underlying (primary) cause of death: ICD10: C45.9 Mesothelioma, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - mesothelioma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C459.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C459.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C509",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C509",
    "phenotype": "Underlying (primary) cause of death: ICD10: C50.9 Breast, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C509.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C509.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C56",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C56",
    "phenotype": "Underlying (primary) cause of death: ICD10: C56 Malignant neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - ovarian cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C56.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C56.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C64",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C64",
    "phenotype": "Underlying (primary) cause of death: ICD10: C64 Malignant neoplasm of kidney, except renal pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - kidney cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C64.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C64.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C679",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C679",
    "phenotype": "Underlying (primary) cause of death: ICD10: C67.9 Bladder, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - bladder cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C679.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C679.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C719",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C719",
    "phenotype": "Underlying (primary) cause of death: ICD10: C71.9 Brain, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - brain cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C719.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C719.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C80",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C80",
    "phenotype": "Underlying (primary) cause of death: ICD10: C80 Malignant neoplasm without specification of site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - cancer NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C80.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C80.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C900",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C900",
    "phenotype": "Underlying (primary) cause of death: ICD10: C90.0 Multiple myeloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - multiple myeloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C900.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C900.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_C920",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_C920",
    "phenotype": "Underlying (primary) cause of death: ICD10: C92.0 Acute myeloid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - acute myeloid leukemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_C920.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_C920.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_G122",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_G122",
    "phenotype": "Underlying (primary) cause of death: ICD10: G12.2 Motor neuron disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - motor neuron disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_G122.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_G122.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_I219",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_I219",
    "phenotype": "Underlying (primary) cause of death: ICD10: I21.9 Acute myocardial infarction, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - acute MI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_I219.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_I219.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_I251",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_I251",
    "phenotype": "Underlying (primary) cause of death: ICD10: I25.1 Atherosclerotic heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - atherosclerotic heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_I251.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_I251.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_I259",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_I259",
    "phenotype": "Underlying (primary) cause of death: ICD10: I25.9 Chronic ischaemic heart disease, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - chronic ischemic heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_I259.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_I259.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40001_I64",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40001_I64",
    "phenotype": "Underlying (primary) cause of death: ICD10: I64 Stroke, not specified as haemorrhage or infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cause of death - stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40001_I64.gwas.imputed_v3.both_sexes.tsv.bgz -O 40001_I64.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40007_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40007",
    "phenotype": "Age at death",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 40007_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "40009",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "40009",
    "phenotype": "Reported occurrences of cancer",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of cancer occurrences",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/40009.gwas.imputed_v3.both_sexes.tsv.bgz -O 40009.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4012_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4012",
    "phenotype": "Age deep-vein thrombosis (DVT, blood clot in leg) diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at DVT diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4012_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4012_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "403",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "403",
    "phenotype": "Number of times snap-button pressed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Snap-button presses count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/403.gwas.imputed_v3.both_sexes.tsv.bgz -O 403.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "404_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "404",
    "phenotype": "Duration to first press of snap-button in each round",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Reaction time - snap-button",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/404_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 404_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4041",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4041",
    "phenotype": "Gestational diabetes only",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4041.gwas.imputed_v3.both_sexes.tsv.bgz -O 4041.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4056_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4056",
    "phenotype": "Age stroke diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at stroke diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4056_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4056_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4067",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4067",
    "phenotype": "Facial pains for 3+ months",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic facial pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4067.gwas.imputed_v3.both_sexes.tsv.bgz -O 4067.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4079_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4079",
    "phenotype": "Diastolic blood pressure, automated reading",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Diastolic BP (auto)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4079_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4079_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4080_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4080",
    "phenotype": "Systolic blood pressure, automated reading",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Systolic BP (auto)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4080_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4080_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4100_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4100",
    "phenotype": "Ankle spacing width (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Ankle spacing width - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4101_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4101",
    "phenotype": "Heel broadband ultrasound attenuation (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BUA - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4104_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4104",
    "phenotype": "Heel quantitative ultrasound index (QUI), direct entry (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel QUI - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4105_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4105",
    "phenotype": "Heel bone mineral density (BMD) (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4106_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4106",
    "phenotype": "Heel bone mineral density (BMD) T-score, automated (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD T-score - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4119_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4119",
    "phenotype": "Ankle spacing width (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Ankle spacing width - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4120_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4120",
    "phenotype": "Heel broadband ultrasound attenuation (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BUA - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4120_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41215_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41215_0",
    "phenotype": "Detention categories: Informal, not formally detained",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Psychiatric detention - informal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41215_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 41215_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41215_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41215_1",
    "phenotype": "Detention categories: Formally detained under Part II, Mental Health Act 1983",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Psychiatric detention - formal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41215_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 41215_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41218_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41218_1",
    "phenotype": "History of psychiatric care on admission: One or more previous psychiatric episodes with this Health Care Provider",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Previous psychiatric episodes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41218_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 41218_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41219_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41219_1",
    "phenotype": "Anaesthetics administered during delivery: General anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia during delivery - general",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41219_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 41219_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41219_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41219_2",
    "phenotype": "Anaesthetics administered during delivery: Epidural or caudal anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia during delivery - epidural/caudal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41219_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 41219_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41219_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41219_3",
    "phenotype": "Anaesthetics administered during delivery: Spinal anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia during delivery - spinal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41219_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 41219_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41219_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41219_6",
    "phenotype": "Anaesthetics administered during delivery: Epidural or caudal, and spinal anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia during delivery - combined",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41219_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 41219_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41220_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41220_1",
    "phenotype": "Anaesthetics administered post delivery: General anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia post delivery - general",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41220_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 41220_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41220_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41220_2",
    "phenotype": "Anaesthetics administered post delivery: Epidural or caudal anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia post delivery - epidural/caudal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41220_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 41220_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41220_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41220_3",
    "phenotype": "Anaesthetics administered post delivery: Spinal anaesthetic",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Anesthesia post delivery - spinal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41220_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 41220_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41221_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41221_0",
    "phenotype": "Delivery methods: Spontaneous vertex",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Delivery - spontaneous vertex",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41221_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 41221_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41221_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41221_2",
    "phenotype": "Delivery methods: Low forceps, not breech",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Delivery - low forceps",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41221_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 41221_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41221_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41221_4",
    "phenotype": "Delivery methods: Ventouse, vacuum extraction",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Delivery - ventouse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41221_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 41221_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41221_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41221_7",
    "phenotype": "Delivery methods: Elective caesarean section",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Delivery - elective C-section",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41221_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 41221_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41221_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41221_8",
    "phenotype": "Delivery methods: Emergency caesarean section",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Delivery - emergency C-section",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41221_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 41221_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4123_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4123",
    "phenotype": "Heel quantitative ultrasound index (QUI), direct entry (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel QUI - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4123_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4123_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41231_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41231_1",
    "phenotype": "Hospital episode type: General episode",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hospital episode - general",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41231_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 41231_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "41235",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "41235",
    "phenotype": "Spells in hospital",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hospital spells count",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/41235.gwas.imputed_v3.both_sexes.tsv.bgz -O 41235.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4124_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4124",
    "phenotype": "Heel bone mineral density (BMD) (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4124_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4124_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4125_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4125",
    "phenotype": "Heel bone mineral density (BMD) T-score, automated (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD T-score - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4125_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4125_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4194_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4194",
    "phenotype": "Pulse rate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pulse rate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4194_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4194_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4195_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4195",
    "phenotype": "Pulse wave reflection index",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pulse wave reflection index",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4195_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4195_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4196_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4196",
    "phenotype": "Pulse wave peak to peak time",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Pulse wave peak-to-peak time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4196_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4196_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4230_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4230",
    "phenotype": "Signal-to-noise-ratio (SNR) of triplet (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "SNR of triplet - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4230_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4230_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4233_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4233",
    "phenotype": "Mean signal-to-noise ratio (SNR), (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mean SNR - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4233_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4233_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4241_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4241",
    "phenotype": "Signal-to-noise-ratio (SNR) of triplet (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "SNR of triplet - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4241_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4241_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4244_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4244",
    "phenotype": "Mean signal-to-noise ratio (SNR), (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Mean SNR - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4244_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4244_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4260",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4260",
    "phenotype": "Round of numeric memory test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Numeric memory test round",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4260.gwas.imputed_v3.both_sexes.tsv.bgz -O 4260.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4269",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4269",
    "phenotype": "Number of triplets attempted (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Triplets attempted - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4269.gwas.imputed_v3.both_sexes.tsv.bgz -O 4269.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4270",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4270",
    "phenotype": "Volume level set by participant (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Volume level - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4270.gwas.imputed_v3.both_sexes.tsv.bgz -O 4270.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4276",
    "phenotype": "Number of triplets attempted (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Triplets attempted - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4276.gwas.imputed_v3.both_sexes.tsv.bgz -O 4276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4277",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4277",
    "phenotype": "Volume level set by participant (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Volume level - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4277.gwas.imputed_v3.both_sexes.tsv.bgz -O 4277.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4282",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4282",
    "phenotype": "Maximum digits remembered correctly",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Max digits remembered",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4282.gwas.imputed_v3.both_sexes.tsv.bgz -O 4282.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4283",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4283",
    "phenotype": "Number of rounds of numeric memory test performed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Numeric memory test rounds",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4283.gwas.imputed_v3.both_sexes.tsv.bgz -O 4283.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4407",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4407",
    "phenotype": "Average monthly red wine intake",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Red wine intake (monthly)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4407.gwas.imputed_v3.both_sexes.tsv.bgz -O 4407.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4418",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4418",
    "phenotype": "Average monthly champagne plus white wine intake",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Champagne/white wine intake (monthly)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4418.gwas.imputed_v3.both_sexes.tsv.bgz -O 4418.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4429",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4429",
    "phenotype": "Average monthly beer plus cider intake",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Beer/cider intake (monthly)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4429.gwas.imputed_v3.both_sexes.tsv.bgz -O 4429.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4440",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4440",
    "phenotype": "Average monthly spirits intake",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Spirits intake (monthly)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4440.gwas.imputed_v3.both_sexes.tsv.bgz -O 4440.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4451",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4451",
    "phenotype": "Average monthly fortified wine intake",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Fortified wine intake (monthly)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4451.gwas.imputed_v3.both_sexes.tsv.bgz -O 4451.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4501",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4501",
    "phenotype": "Non-accidental death in close genetic family",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Family - non-accidental death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4501.gwas.imputed_v3.both_sexes.tsv.bgz -O 4501.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4526",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4526",
    "phenotype": "Happiness",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Happiness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4526.gwas.imputed_v3.both_sexes.tsv.bgz -O 4526.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4548",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4548",
    "phenotype": "Health satisfaction",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Health satisfaction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4548.gwas.imputed_v3.both_sexes.tsv.bgz -O 4548.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4559",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4559",
    "phenotype": "Family relationship satisfaction",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Family satisfaction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4559.gwas.imputed_v3.both_sexes.tsv.bgz -O 4559.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4570",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4570",
    "phenotype": "Friendships satisfaction",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Friendship satisfaction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4570.gwas.imputed_v3.both_sexes.tsv.bgz -O 4570.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4581",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4581",
    "phenotype": "Financial situation satisfaction",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Financial satisfaction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4581.gwas.imputed_v3.both_sexes.tsv.bgz -O 4581.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4598",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4598",
    "phenotype": "Ever depressed for a whole week",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever depressed whole week",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4598.gwas.imputed_v3.both_sexes.tsv.bgz -O 4598.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "46_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "46",
    "phenotype": "Hand grip strength (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Grip strength - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/46_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 46_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4609_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4609",
    "phenotype": "Longest period of depression",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Longest depression period",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4609_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4609_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4620",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4620",
    "phenotype": "Number of depression episodes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of depression episodes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4620.gwas.imputed_v3.both_sexes.tsv.bgz -O 4620.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4631",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4631",
    "phenotype": "Ever unenthusiastic/disinterested for a whole week",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever anhedonia whole week",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4631.gwas.imputed_v3.both_sexes.tsv.bgz -O 4631.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4642",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4642",
    "phenotype": "Ever manic/hyper for 2 days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever manic/hyper 2+ days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4642.gwas.imputed_v3.both_sexes.tsv.bgz -O 4642.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4653",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4653",
    "phenotype": "Ever highly irritable/argumentative for 2 days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Ever irritable 2+ days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4653.gwas.imputed_v3.both_sexes.tsv.bgz -O 4653.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4674",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4674",
    "phenotype": "Private healthcare",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Private healthcare use",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4674.gwas.imputed_v3.both_sexes.tsv.bgz -O 4674.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "47_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "47",
    "phenotype": "Hand grip strength (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Grip strength - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/47_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 47_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4700_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4700",
    "phenotype": "Age cataract diagnosed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at cataract diagnosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4700_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 4700_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4717",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4717",
    "phenotype": "Shortness of breath walking on level ground",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "SOB on level ground",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4717.gwas.imputed_v3.both_sexes.tsv.bgz -O 4717.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4728",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4728",
    "phenotype": "Leg pain on walking",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain on walking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4728.gwas.imputed_v3.both_sexes.tsv.bgz -O 4728.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "48_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "48",
    "phenotype": "Waist circumference",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Waist circumference",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/48_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 48_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4803_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4803_0",
    "phenotype": "Tinnitus: No, never",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus - never",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4803_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 4803_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4803_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4803_11",
    "phenotype": "Tinnitus: Yes, now most or all of the time",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus - most/all time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4803_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 4803_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4803_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4803_12",
    "phenotype": "Tinnitus: Yes, now a lot of the time",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus - a lot of time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4803_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 4803_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4803_13",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4803_13",
    "phenotype": "Tinnitus: Yes, now some of the time",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus - some time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4803_13.gwas.imputed_v3.both_sexes.tsv.bgz -O 4803_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4803_14",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4803_14",
    "phenotype": "Tinnitus: Yes, but not now, but have in the past",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus - past only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4803_14.gwas.imputed_v3.both_sexes.tsv.bgz -O 4803_14.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4814",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4814",
    "phenotype": "Tinnitus severity/nuisance",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Tinnitus severity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4814.gwas.imputed_v3.both_sexes.tsv.bgz -O 4814.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4825",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4825",
    "phenotype": "Noisy workplace",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Workplace noise",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4825.gwas.imputed_v3.both_sexes.tsv.bgz -O 4825.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4836",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4836",
    "phenotype": "Loud music exposure frequency",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Loud music exposure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4836.gwas.imputed_v3.both_sexes.tsv.bgz -O 4836.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4849_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4849_0",
    "phenotype": "Hearing test done: No, I am unable to do this",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Hearing test - unable",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4849_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 4849_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4849_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4849_1",
    "phenotype": "Hearing test done: Yes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Hearing test - done",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4849_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 4849_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4849_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4849_11",
    "phenotype": "Hearing test done: I can only hear on the right side",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing - right only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4849_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 4849_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4849_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4849_12",
    "phenotype": "Hearing test done: I can only hear on the left side",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hearing - left only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4849_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 4849_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "49_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "49",
    "phenotype": "Hip circumference",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hip circumference",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/49_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 49_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4924",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4924",
    "phenotype": "Attempted fluid intelligence (FI) test.",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Attempted FI test",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4924.gwas.imputed_v3.both_sexes.tsv.bgz -O 4924.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4935",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4935",
    "phenotype": "FI1 : numeric addition test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI1 - numeric addition",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4935.gwas.imputed_v3.both_sexes.tsv.bgz -O 4935.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4946",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4946",
    "phenotype": "FI2 : identify largest number",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI2 - largest number",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4946.gwas.imputed_v3.both_sexes.tsv.bgz -O 4946.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4957",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4957",
    "phenotype": "FI3 : word interpolation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI3 - word interpolation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4957.gwas.imputed_v3.both_sexes.tsv.bgz -O 4957.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4968",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4968",
    "phenotype": "FI4 : positional arithmetic",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI4 - positional arithmetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4968.gwas.imputed_v3.both_sexes.tsv.bgz -O 4968.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4979",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4979",
    "phenotype": "FI5 : family relationship calculation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI5 - family relationship",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4979.gwas.imputed_v3.both_sexes.tsv.bgz -O 4979.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "4990",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "4990",
    "phenotype": "FI6 : conditional arithmetic",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI6 - conditional arithmetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/4990.gwas.imputed_v3.both_sexes.tsv.bgz -O 4990.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "50_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "50",
    "phenotype": "Standing height",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Standing height",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/50_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 50_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5001",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5001",
    "phenotype": "FI7 : synonym",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI7 - synonym",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5001.gwas.imputed_v3.both_sexes.tsv.bgz -O 5001.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5012",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5012",
    "phenotype": "FI8 : chained arithmetic",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI8 - chained arithmetic",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5012.gwas.imputed_v3.both_sexes.tsv.bgz -O 5012.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5057",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5057",
    "phenotype": "Number of older siblings",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of older siblings",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5057.gwas.imputed_v3.both_sexes.tsv.bgz -O 5057.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5084_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5084",
    "phenotype": "Spherical power (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Spherical power - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5084_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5084_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5085_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5085",
    "phenotype": "Spherical power (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Spherical power - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5085_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5085_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5086_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5086",
    "phenotype": "Cylindrical power (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cylindrical power - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5086_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5086_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5087_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5087",
    "phenotype": "Cylindrical power (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cylindrical power - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5087_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5087_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5088_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5088",
    "phenotype": "Astigmatism angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5088_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5088_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5089_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5089",
    "phenotype": "Astigmatism angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5089_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5089_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5096_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5096",
    "phenotype": "3mm weak meridian (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm weak meridian - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5096_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5096_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5097_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5097",
    "phenotype": "6mm weak meridian (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm weak meridian - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5097_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5097_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5098_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5098",
    "phenotype": "6mm weak meridian (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm weak meridian - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5098_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5098_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5099_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5099",
    "phenotype": "3mm weak meridian (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm weak meridian - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5099_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5099_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5100_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5100",
    "phenotype": "3mm weak meridian angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm weak meridian angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5100_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5101_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5101",
    "phenotype": "6mm weak meridian angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm weak meridian angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5101_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5102_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5102",
    "phenotype": "6mm weak meridian angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm weak meridian angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5102_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5103_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5103",
    "phenotype": "3mm weak meridian angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm weak meridian angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5103_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5103_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5104_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5104",
    "phenotype": "3mm strong meridian angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm strong meridian angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5104_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5105_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5105",
    "phenotype": "6mm strong meridian angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm strong meridian angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5105_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5106_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5106",
    "phenotype": "6mm strong meridian angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm strong meridian angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5106_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5107_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5107",
    "phenotype": "3mm strong meridian angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm strong meridian angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5107_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5107_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5108_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5108",
    "phenotype": "3mm asymmetry angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm asymmetry angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5108_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5108_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5109_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5109",
    "phenotype": "6mm asymmetry angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm asymmetry angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5109_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5109_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5110_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5110",
    "phenotype": "6mm asymmetry angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm asymmetry angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5110_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5111_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5111",
    "phenotype": "3mm asymmetry angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm asymmetry angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5111_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5111_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5112_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5112",
    "phenotype": "3mm cylindrical power angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm cylindrical power angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5112_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5112_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5113_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5113",
    "phenotype": "6mm cylindrical power angle (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm cylindrical power angle - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5113_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5113_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5114_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5114",
    "phenotype": "6mm cylindrical power angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm cylindrical power angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5114_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5114_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5115_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5115",
    "phenotype": "3mm cylindrical power angle (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm cylindrical power angle - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5115_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5115_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5116_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5116",
    "phenotype": "3mm cylindrical power (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm cylindrical power - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5116_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5116_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5117_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5117",
    "phenotype": "6mm cylindrical power (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm cylindrical power - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5117_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5117_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5118_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5118",
    "phenotype": "6mm cylindrical power (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm cylindrical power - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5118_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5118_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5119_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5119",
    "phenotype": "3mm cylindrical power (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm cylindrical power - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5119_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5132_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5132",
    "phenotype": "3mm strong meridian (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm strong meridian - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5132_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5132_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5133_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5133",
    "phenotype": "6mm strong meridian (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm strong meridian - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5133_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5133_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5134_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5134",
    "phenotype": "6mm strong meridian (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm strong meridian - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5134_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5134_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5135_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5135",
    "phenotype": "3mm strong meridian (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm strong meridian - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5135_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5135_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5156_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5156",
    "phenotype": "3mm asymmetry index (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm asymmetry index - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5156_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5156_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5157_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5157",
    "phenotype": "6mm asymmetry index (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm asymmetry index - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5157_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5157_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5158_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5158",
    "phenotype": "6mm asymmetry index (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm asymmetry index - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5158_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5158_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5159_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5159",
    "phenotype": "3mm asymmetry index (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm asymmetry index - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5159_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5159_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5160_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5160",
    "phenotype": "3mm regularity index (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm regularity index - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5160_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5160_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5161_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5161",
    "phenotype": "6mm regularity index (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm regularity index - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5161_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5161_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5162_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5162",
    "phenotype": "6mm regularity index (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "6mm regularity index - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5162_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5162_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5163_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5163",
    "phenotype": "3mm regularity index (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "3mm regularity index - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5163_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5163_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5181",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5181",
    "phenotype": "Ever had eye surgery",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Eye surgery history",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5181.gwas.imputed_v3.both_sexes.tsv.bgz -O 5181.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5182_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5182_1",
    "phenotype": "Both eyes present: Yes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Both eyes present",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5182_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5182_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5183",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5183",
    "phenotype": "Current eye infection",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5183.gwas.imputed_v3.both_sexes.tsv.bgz -O 5183.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5201_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5201",
    "phenotype": "logMAR, final (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "logMAR visual acuity - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5201_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5201_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5208_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5208",
    "phenotype": "logMAR, final (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "logMAR visual acuity - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5208_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5208_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5221",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5221",
    "phenotype": "Index of best refractometry result (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best refractometry index - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5221.gwas.imputed_v3.both_sexes.tsv.bgz -O 5221.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5237",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5237",
    "phenotype": "3mm index of best keratometry results (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best keratometry index (3mm) - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5237.gwas.imputed_v3.both_sexes.tsv.bgz -O 5237.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5251",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5251",
    "phenotype": "6mm index of best keratometry results (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best keratometry index (6mm) - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5251.gwas.imputed_v3.both_sexes.tsv.bgz -O 5251.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5254_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5254",
    "phenotype": "Intra-ocular pressure, corneal-compensated (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "IOP (corneal-compensated) - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5254_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5254_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5255_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5255",
    "phenotype": "Intra-ocular pressure, Goldmann-correlated (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "IOP (Goldmann) - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5255_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5255_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5256_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5256",
    "phenotype": "Corneal hysteresis (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Corneal hysteresis - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5256_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5256_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5257_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5257",
    "phenotype": "Corneal resistance factor (right)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Corneal resistance factor - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5257_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5257_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5262_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5262",
    "phenotype": "Intra-ocular pressure, corneal-compensated (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "IOP (corneal-compensated) - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5262_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5262_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5263_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5263",
    "phenotype": "Intra-ocular pressure, Goldmann-correlated (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "IOP (Goldmann) - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5263_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5263_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5264_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5264",
    "phenotype": "Corneal hysteresis (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Corneal hysteresis - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5264_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5264_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5265_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5265",
    "phenotype": "Corneal resistance factor (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Corneal resistance factor - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5265_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5265_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5276",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5276",
    "phenotype": "Index of best refractometry result (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best refractometry index - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5276.gwas.imputed_v3.both_sexes.tsv.bgz -O 5276.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5292",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5292",
    "phenotype": "3mm index of best keratometry results (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best keratometry index (3mm) - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5292.gwas.imputed_v3.both_sexes.tsv.bgz -O 5292.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5306",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5306",
    "phenotype": "6mm index of best keratometry results (left)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Best keratometry index (6mm) - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5306.gwas.imputed_v3.both_sexes.tsv.bgz -O 5306.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5324_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5324_0",
    "phenotype": "Ever had cataract surgery: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cataract surgery - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5324_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 5324_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5324_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5324_2",
    "phenotype": "Ever had cataract surgery: Right eye only",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cataract surgery - right only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5324_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5324_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5324_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5324_3",
    "phenotype": "Ever had cataract surgery: Left eye only",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cataract surgery - left only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5324_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5324_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5324_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5324_4",
    "phenotype": "Ever had cataract surgery: Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cataract surgery - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5324_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 5324_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5325_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5325_0",
    "phenotype": "Ever had refractive laser eye surgery: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Refractive laser surgery - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5325_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 5325_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5325_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5325_2",
    "phenotype": "Ever had refractive laser eye surgery: Right eye only",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Refractive laser surgery - right only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5325_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5325_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5325_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5325_3",
    "phenotype": "Ever had refractive laser eye surgery: Left eye only",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Refractive laser surgery - left only",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5325_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5325_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5325_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5325_4",
    "phenotype": "Ever had refractive laser eye surgery: Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Refractive laser surgery - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5325_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 5325_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5327_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5327_0",
    "phenotype": "Ever had laser treatment for glaucoma or high eye pressure: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Laser for glaucoma - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5327_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 5327_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5327_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5327_4",
    "phenotype": "Ever had laser treatment for glaucoma or high eye pressure: Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Laser for glaucoma - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5327_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 5327_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5328_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5328_0",
    "phenotype": "Ever had corneal graft surgery: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Corneal graft - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5328_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 5328_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5375_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5375",
    "phenotype": "Longest period of unenthusiasm / disinterest",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Longest anhedonia period",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5375_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5375_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5386",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5386",
    "phenotype": "Number of unenthusiastic/disinterested episodes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Number of anhedonia episodes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5386.gwas.imputed_v3.both_sexes.tsv.bgz -O 5386.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5452",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5452",
    "phenotype": "Leg pain when standing still or sitting",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain at rest",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5452.gwas.imputed_v3.both_sexes.tsv.bgz -O 5452.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5463",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5463",
    "phenotype": "Leg pain in calf/calves",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain location - calf",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5463.gwas.imputed_v3.both_sexes.tsv.bgz -O 5463.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5474",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5474",
    "phenotype": "Leg pain when walking uphill or hurrying",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain on uphill",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5474.gwas.imputed_v3.both_sexes.tsv.bgz -O 5474.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5485",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5485",
    "phenotype": "Leg pain when walking normally",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain on walking normal",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5485.gwas.imputed_v3.both_sexes.tsv.bgz -O 5485.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5496",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5496",
    "phenotype": "Leg pain when walking ever disappears while walking",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain disappears while walking",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5496.gwas.imputed_v3.both_sexes.tsv.bgz -O 5496.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5507",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5507",
    "phenotype": "Leg pain on walking : action taken",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Leg pain - action taken",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5507.gwas.imputed_v3.both_sexes.tsv.bgz -O 5507.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5518",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5518",
    "phenotype": "Leg pain on walking : effect of standing still",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg pain - effect of standing",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5518.gwas.imputed_v3.both_sexes.tsv.bgz -O 5518.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5529",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5529",
    "phenotype": "Surgery on leg arteries (other than for varicose veins)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Leg artery surgery",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5529.gwas.imputed_v3.both_sexes.tsv.bgz -O 5529.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5540_0",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5540_0",
    "phenotype": "Surgery/amputation of toe or leg: No",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Toe/leg amputation - no",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5540_0.gwas.imputed_v3.both_sexes.tsv.bgz -O 5540_0.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5540_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5540_1",
    "phenotype": "Surgery/amputation of toe or leg: Yes, toes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Toe/leg amputation - toes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5540_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5540_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5556",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5556",
    "phenotype": "FI9 : concept interpolation",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI9 - concept interpolation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5556.gwas.imputed_v3.both_sexes.tsv.bgz -O 5556.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5610_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5610_1",
    "phenotype": "Which eye(s) affected by presbyopia: Right eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Presbyopia - right eye",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5610_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5610_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5610_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5610_2",
    "phenotype": "Which eye(s) affected by presbyopia: Left eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Presbyopia - left eye",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5610_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5610_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5610_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5610_3",
    "phenotype": "Which eye(s) affected by presbyopia: Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Presbyopia - both eyes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5610_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5610_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5663",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5663",
    "phenotype": "Length of longest manic/irritable episode",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Longest manic/irritable episode length",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5663.gwas.imputed_v3.both_sexes.tsv.bgz -O 5663.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5674",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5674",
    "phenotype": "Severity of manic/irritable episodes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Manic/irritable severity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5674.gwas.imputed_v3.both_sexes.tsv.bgz -O 5674.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5699",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5699",
    "phenotype": "FI10 : arithmetic sequence recognition",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI10 - arithmetic sequence",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5699.gwas.imputed_v3.both_sexes.tsv.bgz -O 5699.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5779",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5779",
    "phenotype": "FI11 : antonym",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI11 - antonym",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5779.gwas.imputed_v3.both_sexes.tsv.bgz -O 5779.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5832_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5832_1",
    "phenotype": "Which eye(s) affected by hypermetropia (long sight): Right eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hypermetropia - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5832_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5832_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5832_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5832_2",
    "phenotype": "Which eye(s) affected by hypermetropia (long sight): Left eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hypermetropia - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5832_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5832_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5832_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5832_3",
    "phenotype": "Which eye(s) affected by hypermetropia (long sight): Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hypermetropia - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5832_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5832_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5843_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5843_1",
    "phenotype": "Which eye(s) affected by myopia (short sight): Right eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Myopia - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5843_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5843_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5843_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5843_2",
    "phenotype": "Which eye(s) affected by myopia (short sight): Left eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Myopia - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5843_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5843_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5843_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5843_3",
    "phenotype": "Which eye(s) affected by myopia (short sight): Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Myopia - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5843_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5843_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5855_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5855_1",
    "phenotype": "Which eye(s) affected by astigmatism: Right eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism - right",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5855_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 5855_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5855_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5855_2",
    "phenotype": "Which eye(s) affected by astigmatism: Left eye",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism - left",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5855_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 5855_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5855_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5855_3",
    "phenotype": "Which eye(s) affected by astigmatism: Both eyes",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism - both",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5855_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 5855_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5866",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5866",
    "phenotype": "FI13 : subset inclusion logic",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "FI13 - subset inclusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5866.gwas.imputed_v3.both_sexes.tsv.bgz -O 5866.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5959",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5959",
    "phenotype": "Previously smoked cigarettes on most/all days",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Former daily smoker",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5959.gwas.imputed_v3.both_sexes.tsv.bgz -O 5959.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5983_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5983",
    "phenotype": "ECG, heart rate",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ECG heart rate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5983_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5983_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5984_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5984",
    "phenotype": "ECG, load",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ECG load",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5984_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5984_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5986_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5986",
    "phenotype": "ECG, phase time",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ECG phase time",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5986_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 5986_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5992",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5992",
    "phenotype": "ECG, phase duration",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ECG phase duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5992.gwas.imputed_v3.both_sexes.tsv.bgz -O 5992.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "5993",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "5993",
    "phenotype": "ECG, number of stages in a phase",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ECG stages per phase",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/5993.gwas.imputed_v3.both_sexes.tsv.bgz -O 5993.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6015",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6015",
    "phenotype": "Chest pain felt during physical activity",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain during activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6015.gwas.imputed_v3.both_sexes.tsv.bgz -O 6015.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6016",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6016",
    "phenotype": "Chest pain felt outside physical activity",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Chest pain at rest",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6016.gwas.imputed_v3.both_sexes.tsv.bgz -O 6016.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6017",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6017",
    "phenotype": "Able to walk or cycle unaided for 10 minutes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mobility - walk/cycle 10 min",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6017.gwas.imputed_v3.both_sexes.tsv.bgz -O 6017.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6020_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6020_1",
    "phenotype": "Completion status of test: Fully completed",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test - full completion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6020_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6020_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6020_31",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6020_31",
    "phenotype": "Completion status of test: Participant wanted to stop early",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test - early stop (participant)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6020_31.gwas.imputed_v3.both_sexes.tsv.bgz -O 6020_31.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6020_33",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6020_33",
    "phenotype": "Completion status of test: Heart rate reached safety level",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test - heart rate limit",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6020_33.gwas.imputed_v3.both_sexes.tsv.bgz -O 6020_33.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6032_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6032",
    "phenotype": "Maximum workload during fitness test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test max workload",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6032_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 6032_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6033_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6033",
    "phenotype": "Maximum heart rate during fitness test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test max heart rate",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6033_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 6033_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6034",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6034",
    "phenotype": "Target heart rate achieved",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test target heart rate achieved",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6034.gwas.imputed_v3.both_sexes.tsv.bgz -O 6034.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6038_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6038",
    "phenotype": "Number of trend entries",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test trend entries",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6038_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 6038_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6039",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6039",
    "phenotype": "Duration of fitness test",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Fitness test duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6039.gwas.imputed_v3.both_sexes.tsv.bgz -O 6039.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6070_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6070_1",
    "phenotype": "OCT measured (right): Measurable",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "OCT right - measurable",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6070_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6070_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6070_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6070_6",
    "phenotype": "OCT measured (right): Not performed - equipment failure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "OCT right - equipment failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6070_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6070_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6072_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6072_1",
    "phenotype": "OCT measured (left): Measurable",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "OCT left - measurable",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6072_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6072_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6072_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6072_6",
    "phenotype": "OCT measured (left): Not performed - equipment failure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "OCT left - equipment failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6072_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6072_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6144_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6144_1",
    "phenotype": "Never eat eggs, dairy, wheat, sugar: Eggs or foods containing eggs",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Food avoidance - eggs",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6144_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6144_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6144_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6144_2",
    "phenotype": "Never eat eggs, dairy, wheat, sugar: Dairy products",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Food avoidance - dairy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6144_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6144_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6144_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6144_3",
    "phenotype": "Never eat eggs, dairy, wheat, sugar: Wheat products",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Food avoidance - wheat",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6144_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6144_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6144_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6144_4",
    "phenotype": "Never eat eggs, dairy, wheat, sugar: Sugar or foods/drinks containing sugar",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Food avoidance - sugar",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6144_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6144_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6144_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6144_5",
    "phenotype": "Never eat eggs, dairy, wheat, sugar: I eat all of the above",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Food avoidance - none",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6144_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6144_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_1",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Serious illness, injury or assault to yourself",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - self illness/injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_2",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Serious illness, injury or assault of a close relative",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - relative illness/injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_3",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Death of a close relative",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - relative death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_4",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Death of a spouse or partner",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - spouse death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_5",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Marital separation/divorce",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - marital separation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6145_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6145_6",
    "phenotype": "Illness, injury, bereavement, stress in last 2 years: Financial difficulties",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Life event - financial difficulty",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6145_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6145_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6146_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6146_1",
    "phenotype": "Attendance/disability/mobility allowance: Attendance allowance",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Disability benefit - attendance allowance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6146_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6146_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6146_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6146_2",
    "phenotype": "Attendance/disability/mobility allowance: Disability living allowance",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Disability benefit - DLA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6146_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6146_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6146_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6146_3",
    "phenotype": "Attendance/disability/mobility allowance: Blue badge",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Disability benefit - blue badge",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6146_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6146_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_1",
    "phenotype": "Reason for glasses/contact lenses: For short-sightedness, i.e. only or mainly for distance viewing such as driving, cinema etc (called 'myopia')",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Myopia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_2",
    "phenotype": "Reason for glasses/contact lenses: For long-sightedness, i.e. for distance and near, but particularly for near tasks like reading (called 'hypermetropia')",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Hypermetropia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_3",
    "phenotype": "Reason for glasses/contact lenses: For just reading/near work as you are getting older (called 'presbyopia')",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Presbyopia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_4",
    "phenotype": "Reason for glasses/contact lenses: For 'astigmatism'",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Astigmatism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_5",
    "phenotype": "Reason for glasses/contact lenses: For a 'squint' or 'turn' in an eye since childhood (called 'strabismus')",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Strabismus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6147_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6147_6",
    "phenotype": "Reason for glasses/contact lenses: For a 'lazy' eye or an eye with poor vision since childhood (called 'amblyopia')",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Amblyopia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6147_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6147_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6148_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6148_1",
    "phenotype": "Eye problems/disorders: Diabetes related eye disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic eye disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6148_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6148_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6148_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6148_2",
    "phenotype": "Eye problems/disorders: Glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6148_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6148_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6148_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6148_3",
    "phenotype": "Eye problems/disorders: Injury or trauma resulting in loss of vision",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic vision loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6148_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6148_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6148_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6148_4",
    "phenotype": "Eye problems/disorders: Cataract",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cataract",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6148_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6148_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6148_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6148_5",
    "phenotype": "Eye problems/disorders: Macular degeneration",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6148_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6148_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_1",
    "phenotype": "Mouth/teeth dental problems: Mouth ulcers",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mouth ulcers",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_2",
    "phenotype": "Mouth/teeth dental problems: Painful gums",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gum pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_3",
    "phenotype": "Mouth/teeth dental problems: Bleeding gums",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bleeding gums",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_4",
    "phenotype": "Mouth/teeth dental problems: Loose teeth",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Loose teeth",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_5",
    "phenotype": "Mouth/teeth dental problems: Toothache",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Toothache",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6149_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6149_6",
    "phenotype": "Mouth/teeth dental problems: Dentures",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Dentures",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6149_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6149_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6150_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6150_1",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Heart attack",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart attack",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6150_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6150_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6150_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6150_2",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Angina",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angina",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6150_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6150_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6150_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6150_3",
    "phenotype": "Vascular/heart problems diagnosed by doctor: Stroke",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6150_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6150_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6150_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6150_4",
    "phenotype": "Vascular/heart problems diagnosed by doctor: High blood pressure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6150_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6150_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_1",
    "phenotype": "Fractured bone site(s): Ankle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ankle fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_2",
    "phenotype": "Fractured bone site(s): Leg",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Leg fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_3",
    "phenotype": "Fractured bone site(s): Hip",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_4",
    "phenotype": "Fractured bone site(s): Spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spine fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_5",
    "phenotype": "Fractured bone site(s): Wrist",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Wrist fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6151_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6151_6",
    "phenotype": "Fractured bone site(s): Arm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arm fracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6151_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6151_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6152_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6152_5",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Blood clot in the leg (DVT)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6152_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6152_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6152_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6152_6",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Emphysema/chronic bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Emphysema/chronic bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6152_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6152_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6152_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6152_7",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Blood clot in the lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pulmonary embolism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6152_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 6152_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6152_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6152_8",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6152_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 6152_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6152_9",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6152_9",
    "phenotype": "Blood clot, DVT, bronchitis, emphysema, asthma, rhinitis, eczema, allergy diagnosed by doctor: Hayfever, allergic rhinitis or eczema",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Allergy/eczema",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6152_9.gwas.imputed_v3.both_sexes.tsv.bgz -O 6152_9.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6153_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6153_1",
    "phenotype": "Medication for cholesterol, blood pressure, diabetes, or take exogenous hormones: Cholesterol lowering medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Cholesterol medication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6153_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6153_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6153_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6153_2",
    "phenotype": "Medication for cholesterol, blood pressure, diabetes, or take exogenous hormones: Blood pressure medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Antihypertensive",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6153_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6153_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6153_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6153_3",
    "phenotype": "Medication for cholesterol, blood pressure, diabetes, or take exogenous hormones: Insulin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Insulin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6153_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6153_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6153_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6153_4",
    "phenotype": "Medication for cholesterol, blood pressure, diabetes, or take exogenous hormones: Hormone replacement therapy",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "HRT",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6153_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6153_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6153_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6153_5",
    "phenotype": "Medication for cholesterol, blood pressure, diabetes, or take exogenous hormones: Oral contraceptive pill or minipill",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Oral contraceptive",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6153_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6153_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_1",
    "phenotype": "Medication for pain relief, constipation, heartburn: Aspirin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Aspirin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_2",
    "phenotype": "Medication for pain relief, constipation, heartburn: Ibuprofen (e.g. Nurofen)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Ibuprofen",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_3",
    "phenotype": "Medication for pain relief, constipation, heartburn: Paracetamol",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Paracetamol",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_4",
    "phenotype": "Medication for pain relief, constipation, heartburn: Ranitidine (e.g. Zantac)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Ranitidine",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_5",
    "phenotype": "Medication for pain relief, constipation, heartburn: Omeprazole (e.g. Zanprol)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Omeprazole",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6154_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6154_6",
    "phenotype": "Medication for pain relief, constipation, heartburn: Laxatives (e.g. Dulcolax, Senokot)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Laxative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6154_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6154_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_1",
    "phenotype": "Vitamin and mineral supplements: Vitamin A",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin A",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_2",
    "phenotype": "Vitamin and mineral supplements: Vitamin B",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin B",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_3",
    "phenotype": "Vitamin and mineral supplements: Vitamin C",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin C",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_4",
    "phenotype": "Vitamin and mineral supplements: Vitamin D",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin D",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_5",
    "phenotype": "Vitamin and mineral supplements: Vitamin E",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Vitamin E",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_6",
    "phenotype": "Vitamin and mineral supplements: Folic acid or Folate (Vit B9)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Folic acid supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6155_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6155_7",
    "phenotype": "Vitamin and mineral supplements: Multivitamins +/- minerals",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Multivitamin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6155_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 6155_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6156_11",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6156_11",
    "phenotype": "Manic/hyper symptoms: I was more active than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - increased activity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6156_11.gwas.imputed_v3.both_sexes.tsv.bgz -O 6156_11.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6156_12",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6156_12",
    "phenotype": "Manic/hyper symptoms: I was more talkative than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - talkative",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6156_12.gwas.imputed_v3.both_sexes.tsv.bgz -O 6156_12.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6156_13",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6156_13",
    "phenotype": "Manic/hyper symptoms: I needed less sleep than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - reduced sleep need",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6156_13.gwas.imputed_v3.both_sexes.tsv.bgz -O 6156_13.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6156_14",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6156_14",
    "phenotype": "Manic/hyper symptoms: I was more creative or had more ideas than usual",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - increased creativity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6156_14.gwas.imputed_v3.both_sexes.tsv.bgz -O 6156_14.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6156_15",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6156_15",
    "phenotype": "Manic/hyper symptoms: All of the above",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Mania - all symptoms",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6156_15.gwas.imputed_v3.both_sexes.tsv.bgz -O 6156_15.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6157_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6157_1",
    "phenotype": "Why stopped smoking: Illness or ill health",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking cessation reason - illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6157_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6157_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6157_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6157_2",
    "phenotype": "Why stopped smoking: Doctor's advice",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking cessation reason - doctor advice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6157_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6157_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6157_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6157_3",
    "phenotype": "Why stopped smoking: Health precaution",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking cessation reason - health precaution",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6157_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6157_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6157_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6157_4",
    "phenotype": "Why stopped smoking: Financial reasons",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking cessation reason - financial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6157_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6157_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6158_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6158_1",
    "phenotype": "Why reduced smoking: Illness or ill health",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking reduction reason - illness",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6158_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6158_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6158_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6158_2",
    "phenotype": "Why reduced smoking: Doctor's advice",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking reduction reason - doctor advice",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6158_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6158_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6158_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6158_3",
    "phenotype": "Why reduced smoking: Health precaution",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking reduction reason - health precaution",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6158_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6158_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6158_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6158_4",
    "phenotype": "Why reduced smoking: Financial reasons",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Smoking reduction reason - financial",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6158_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6158_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_1",
    "phenotype": "Pain type(s) experienced in last month: Headache",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Headache",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_2",
    "phenotype": "Pain type(s) experienced in last month: Facial pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Facial pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_3",
    "phenotype": "Pain type(s) experienced in last month: Neck or shoulder pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neck/shoulder pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_4",
    "phenotype": "Pain type(s) experienced in last month: Back pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Back pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_5",
    "phenotype": "Pain type(s) experienced in last month: Stomach or abdominal pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Abdominal pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_6",
    "phenotype": "Pain type(s) experienced in last month: Hip pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_7",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_7",
    "phenotype": "Pain type(s) experienced in last month: Knee pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_7.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_7.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6159_8",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6159_8",
    "phenotype": "Pain type(s) experienced in last month: Pain all over the body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Widespread pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6159_8.gwas.imputed_v3.both_sexes.tsv.bgz -O 6159_8.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6160_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6160_1",
    "phenotype": "Leisure/social activities: Sports club or gym",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Leisure activity - sports/gym",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6160_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6160_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6160_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6160_2",
    "phenotype": "Leisure/social activities: Pub or social club",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Leisure activity - pub/social club",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6160_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6160_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6160_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6160_3",
    "phenotype": "Leisure/social activities: Religious group",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Leisure activity - religious",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6160_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6160_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6160_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6160_4",
    "phenotype": "Leisure/social activities: Adult education class",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Leisure activity - adult education",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6160_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6160_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6177_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6177_1",
    "phenotype": "Medication for cholesterol, blood pressure or diabetes: Cholesterol lowering medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Cholesterol medication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6177_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6177_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6177_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6177_2",
    "phenotype": "Medication for cholesterol, blood pressure or diabetes: Blood pressure medication",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Antihypertensive",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6177_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6177_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6177_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6177_3",
    "phenotype": "Medication for cholesterol, blood pressure or diabetes: Insulin",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Insulin",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6177_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6177_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_1",
    "phenotype": "Mineral and other dietary supplements: Fish oil (including cod liver oil)",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Fish oil supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_1.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_2",
    "phenotype": "Mineral and other dietary supplements: Glucosamine",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Glucosamine supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_2.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_3",
    "phenotype": "Mineral and other dietary supplements: Calcium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Calcium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_3.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_4",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_4",
    "phenotype": "Mineral and other dietary supplements: Zinc",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Zinc supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_4.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_4.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_5",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_5",
    "phenotype": "Mineral and other dietary supplements: Iron",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Iron supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_5.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_5.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "6179_6",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "6179_6",
    "phenotype": "Mineral and other dietary supplements: Selenium",
    "phenotypicCategory": "Drug",
    "phenotypicSubcategory": "Selenium supplement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/6179_6.gwas.imputed_v3.both_sexes.tsv.bgz -O 6179_6.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "78_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "78",
    "phenotype": "Heel bone mineral density (BMD) T-score, automated",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Heel BMD T-score",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/78_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 78_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "84_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "84",
    "phenotype": "Cancer year/age first occurred",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at first cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/84_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 84_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "845",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "845",
    "phenotype": "Age completed full time education",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Age at end of full-time education",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/845.gwas.imputed_v3.both_sexes.tsv.bgz -O 845.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "864",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "864",
    "phenotype": "Number of days/week walked 10+ minutes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Walking days per week",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/864.gwas.imputed_v3.both_sexes.tsv.bgz -O 864.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "874_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "874",
    "phenotype": "Duration of walks",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Walking duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/874_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 874_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "884",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "884",
    "phenotype": "Number of days/week of moderate physical activity 10+ minutes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Moderate activity days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/884.gwas.imputed_v3.both_sexes.tsv.bgz -O 884.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "894",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "894",
    "phenotype": "Duration of moderate activity",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Moderate activity duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/894.gwas.imputed_v3.both_sexes.tsv.bgz -O 894.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "904",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "904",
    "phenotype": "Number of days/week of vigorous physical activity 10+ minutes",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Vigorous activity days",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/904.gwas.imputed_v3.both_sexes.tsv.bgz -O 904.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "914_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "914",
    "phenotype": "Duration of vigorous activity",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Vigorous activity duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/914_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 914_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "924",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "924",
    "phenotype": "Usual walking pace",
    "phenotypicCategory": "Behavior",
    "phenotypicSubcategory": "Walking pace",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/924.gwas.imputed_v3.both_sexes.tsv.bgz -O 924.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "93_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "93",
    "phenotype": "Systolic blood pressure, manual reading",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Systolic BP (manual)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/93_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 93_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "94_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "94",
    "phenotype": "Diastolic blood pressure, manual reading",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Diastolic BP (manual)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/94_irnt.gwas.imputed_v3.both_sexes.tsv.bgz -O 94_irnt.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "981",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "981",
    "phenotype": "Duration walking for pleasure",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Walking for pleasure duration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/981.gwas.imputed_v3.both_sexes.tsv.bgz -O 981.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_INFECTIONS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_INFECTIONS",
    "phenotype": "Certain infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious disease category",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_INTESTINAL_INFECTIONS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_INTESTINAL_INFECTIONS",
    "phenotype": "Intestinal infectious diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_INTESTINAL_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_INTESTINAL_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_MYCOSES",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_MYCOSES",
    "phenotype": "Mycoses",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fungal infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_MYCOSES.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_MYCOSES.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_SEXUAL_TRANSMISSION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_SEXUAL_TRANSMISSION",
    "phenotype": "Infections with a predominantly sexual mode of transmission",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "STI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_SEXUAL_TRANSMISSION.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_SEXUAL_TRANSMISSION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_VIRAL_CNS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_VIRAL_CNS",
    "phenotype": "Viral infections of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS viral infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_VIRAL_CNS.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_VIRAL_CNS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_VIRAL_HEPATITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_VIRAL_HEPATITIS",
    "phenotype": "Viral hepatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_VIRAL_HEPATITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_VIRAL_HEPATITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AB1_VIRAL_SKIN_MUCOUS_MEMBRANE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AB1_VIRAL_SKIN_MUCOUS_MEMBRANE",
    "phenotype": "Viral infections characterized by skin and mucous membrane lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral skin/mucous infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AB1_VIRAL_SKIN_MUCOUS_MEMBRANE.gwas.imputed_v3.both_sexes.tsv.bgz -O AB1_VIRAL_SKIN_MUCOUS_MEMBRANE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AD",
    "phenotype": "Alzheimer’s disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alzheimer disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AD.gwas.imputed_v3.both_sexes.tsv.bgz -O AD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "AMN2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "AMN2",
    "phenotype": "Transient global amnesia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Transient global amnesia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/AMN2.gwas.imputed_v3.both_sexes.tsv.bgz -O AMN2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_CHILD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_CHILD",
    "phenotype": "Childhood asthma (age<16)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_CHILD.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_CHILD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_EOSINOPHIL_SUGG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_EOSINOPHIL_SUGG",
    "phenotype": "Suggestive for eosinophilic asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eosinophilic asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_EOSINOPHIL_SUGG.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_EOSINOPHIL_SUGG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_HOSPITAL1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_HOSPITAL1",
    "phenotype": "Asthma, hospital admissions 1",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Asthma hospital admissions",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_HOSPITAL1.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_HOSPITAL1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_MEDICATIO_COMORB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_MEDICATIO_COMORB",
    "phenotype": "Medication related adverse effects",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adverse drug effect",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_MEDICATIO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_MEDICATIO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_MODE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_MODE",
    "phenotype": "Asthma (mode)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_MODE.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_MODE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ASTHMA_PNEUMONIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ASTHMA_PNEUMONIA",
    "phenotype": "Asthma-related pneumonia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma-related pneumonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ASTHMA_PNEUMONIA.gwas.imputed_v3.both_sexes.tsv.bgz -O ASTHMA_PNEUMONIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "BRONCHITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "BRONCHITIS",
    "phenotype": "Bronchitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bronchitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/BRONCHITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O BRONCHITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_ANUS_ANALCANAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_ANUS_ANALCANAL",
    "phenotype": "Malignant neoplasm of anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_ANUS_ANALCANAL.gwas.imputed_v3.both_sexes.tsv.bgz -O C_ANUS_ANALCANAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_BLADDER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_BLADDER",
    "phenotype": "Malignant neoplasm of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_BLADDER.gwas.imputed_v3.both_sexes.tsv.bgz -O C_BLADDER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_BRAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_BRAIN",
    "phenotype": "Malignant neoplasm of brain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_BRAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O C_BRAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_BREAST_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_BREAST_3",
    "phenotype": "Malignant neoplasm of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_BREAST_3.gwas.imputed_v3.both_sexes.tsv.bgz -O C_BREAST_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_BRONCHUS_LUNG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_BRONCHUS_LUNG",
    "phenotype": "Malignant neoplasm of bronchus and lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_BRONCHUS_LUNG.gwas.imputed_v3.both_sexes.tsv.bgz -O C_BRONCHUS_LUNG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_CERVIX_UTERI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_CERVIX_UTERI",
    "phenotype": "Malignant neoplasm of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_CERVIX_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz -O C_CERVIX_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_COLON",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_COLON",
    "phenotype": "Malignant neoplasm of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_COLON.gwas.imputed_v3.both_sexes.tsv.bgz -O C_COLON.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_CORPUS_UTERI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_CORPUS_UTERI",
    "phenotype": "Malignant neoplasm of corpus uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_CORPUS_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz -O C_CORPUS_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_DIFFICILE_ENTEROCOLITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_DIFFICILE_ENTEROCOLITIS",
    "phenotype": "Enterocolitis due to Clostridium difficile",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "C. diff colitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_DIFFICILE_ENTEROCOLITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_DIFFICILE_ENTEROCOLITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_EYE_ADNEXA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_EYE_ADNEXA",
    "phenotype": "Malignant neoplasm of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_FOLLICULAR_LYMPHOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_FOLLICULAR_LYMPHOMA",
    "phenotype": "Follicular lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Follicular lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_FOLLICULAR_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_FOLLICULAR_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_HODGKIN_LYMPHOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_HODGKIN_LYMPHOMA",
    "phenotype": "Hodgkin lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hodgkin lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_HODGKIN_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_HODGKIN_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_KIDNEY_NOTRENALPELVIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_KIDNEY_NOTRENALPELVIS",
    "phenotype": "Malignant neoplasm of kidney, except renal pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_KIDNEY_NOTRENALPELVIS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_KIDNEY_NOTRENALPELVIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_LARYNX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_LARYNX",
    "phenotype": "Malignant neoplasm of larynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Laryngeal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_LARYNX.gwas.imputed_v3.both_sexes.tsv.bgz -O C_LARYNX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_LIVER_INTRAHEPATIC_BILE_DUCTS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_LIVER_INTRAHEPATIC_BILE_DUCTS",
    "phenotype": "Malignant neoplasm of liver and intrahepatic bile ducts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_LIVER_INTRAHEPATIC_BILE_DUCTS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_LIVER_INTRAHEPATIC_BILE_DUCTS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_LYMPHNODES_SECONDARY_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_LYMPHNODES_SECONDARY_NAS",
    "phenotype": "Secondary and unspecified malignant neoplasm of lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary lymph node cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_LYMPHNODES_SECONDARY_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_LYMPHNODES_SECONDARY_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_LYMPHOID_LEUKAEMIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_LYMPHOID_LEUKAEMIA",
    "phenotype": "Lymphoid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid leukemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_LYMPHOID_LEUKAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_LYMPHOID_LEUKAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_LYMPHOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_LYMPHOMA",
    "phenotype": "Lymphomas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_MELANOMA_SKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_MELANOMA_SKIN",
    "phenotype": "Malignant melanoma of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_MELANOMA_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O C_MELANOMA_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_MESOTHELIOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_MESOTHELIOMA",
    "phenotype": "Mesothelioma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesothelioma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_MESOTHELIOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_MESOTHELIOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_MULTIPLE_MYELOMA_PLASMA_CELL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_MULTIPLE_MYELOMA_PLASMA_CELL",
    "phenotype": "Multiple myeloma and malignant plasma cell neoplasms",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Multiple myeloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_MULTIPLE_MYELOMA_PLASMA_CELL.gwas.imputed_v3.both_sexes.tsv.bgz -O C_MULTIPLE_MYELOMA_PLASMA_CELL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_MYELOID-LEUKAEMIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_MYELOID-LEUKAEMIA",
    "phenotype": "Myeloid leukaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myeloid leukemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_MYELOID-LEUKAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_MYELOID-LEUKAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_NONFOLLICULAR_LYMPHOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_NONFOLLICULAR_LYMPHOMA",
    "phenotype": "Non-follicular lymphoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Non-follicular lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_NONFOLLICULAR_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_NONFOLLICULAR_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_OESOPHAGUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_OESOPHAGUS",
    "phenotype": "Malignant neoplasm of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_OESOPHAGUS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_OESOPHAGUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_OVARY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_OVARY",
    "phenotype": "Malignant neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz -O C_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_PANCREAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_PANCREAS",
    "phenotype": "Malignant neoplasm of pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_PANCREAS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_PANCREAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_PROSTATE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_PROSTATE",
    "phenotype": "Malignant neoplasm of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_PROSTATE.gwas.imputed_v3.both_sexes.tsv.bgz -O C_PROSTATE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_RECTOISIGMOID_JUNCTION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_RECTOISIGMOID_JUNCTION",
    "phenotype": "Malignant neoplasm of rectosigmoid junction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectosigmoid cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_RECTOISIGMOID_JUNCTION.gwas.imputed_v3.both_sexes.tsv.bgz -O C_RECTOISIGMOID_JUNCTION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_RECTUM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_RECTUM",
    "phenotype": "Malignant neoplasm of rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_RECTUM.gwas.imputed_v3.both_sexes.tsv.bgz -O C_RECTUM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_SECONDARY_RESPIRATORY_DIGESTIVE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_SECONDARY_RESPIRATORY_DIGESTIVE",
    "phenotype": "Secondary malignant neoplasm of respiratory and digestive organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary respiratory/digestive cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_SECONDARY_RESPIRATORY_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz -O C_SECONDARY_RESPIRATORY_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_SECONDARY_WITHOUT_SITESPEC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_SECONDARY_WITHOUT_SITESPEC",
    "phenotype": "Malignant neoplasm, without specification of site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_SECONDARY_WITHOUT_SITESPEC.gwas.imputed_v3.both_sexes.tsv.bgz -O C_SECONDARY_WITHOUT_SITESPEC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_SMALL_INTESTINE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_SMALL_INTESTINE",
    "phenotype": "Malignant neoplasm of small intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_SMALL_INTESTINE.gwas.imputed_v3.both_sexes.tsv.bgz -O C_SMALL_INTESTINE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_STOMACH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_STOMACH",
    "phenotype": "Malignant neoplasm of stomach",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomach cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_STOMACH.gwas.imputed_v3.both_sexes.tsv.bgz -O C_STOMACH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_STROKE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_STROKE",
    "phenotype": "STROKE",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_STROKE.gwas.imputed_v3.both_sexes.tsv.bgz -O C_STROKE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_TESTIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_TESTIS",
    "phenotype": "Malignant neoplasm of testis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_TESTIS.gwas.imputed_v3.both_sexes.tsv.bgz -O C_TESTIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_THYROID_GLAND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_THYROID_GLAND",
    "phenotype": "Malignant neoplasm of thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_THYROID_GLAND.gwas.imputed_v3.both_sexes.tsv.bgz -O C_THYROID_GLAND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_TNK_LYMPHOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_TNK_LYMPHOMA",
    "phenotype": "Mature T/NK-cell lymphomas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "T/NK-cell lymphoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_TNK_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C_TNK_LYMPHOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C_TONSIL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C_TONSIL",
    "phenotype": "Malignant neoplasm of tonsil",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsil cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C_TONSIL.gwas.imputed_v3.both_sexes.tsv.bgz -O C_TONSIL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_ANUS_ANALCANAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_ANUS_ANALCANAL",
    "phenotype": "Malignant neoplasm of anus and anal canal",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anal cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_ANUS_ANALCANAL.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_ANUS_ANALCANAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_BLADDER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_BLADDER",
    "phenotype": "Malignant neoplasm of bladder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bladder cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_BLADDER.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_BLADDER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_BRAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_BRAIN",
    "phenotype": "Malignant neoplasm of brain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Brain cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_BRAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_BRAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_BREAST_3",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_BREAST_3",
    "phenotype": "Malignant neoplasm of breast",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Breast cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_BREAST_3.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_BREAST_3.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_BRONCHUS_LUNG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_BRONCHUS_LUNG",
    "phenotype": "Malignant neoplasm of bronchus and lung",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_BRONCHUS_LUNG.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_BRONCHUS_LUNG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_CERVIX_UTERI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_CERVIX_UTERI",
    "phenotype": "Malignant neoplasm of cervix uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervical cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_CERVIX_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_CERVIX_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_COLON",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_COLON",
    "phenotype": "Malignant neoplasm of colon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Colon cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_COLON.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_COLON.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_CORPUS_UTERI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_CORPUS_UTERI",
    "phenotype": "Malignant neoplasm of corpus uteri",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_CORPUS_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_CORPUS_UTERI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_DIGESTIVE_ORGANS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_DIGESTIVE_ORGANS",
    "phenotype": "Malignant neoplasm of digestive organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Digestive organ cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_DIGESTIVE_ORGANS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_DIGESTIVE_ORGANS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_ENDOCRINE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_ENDOCRINE",
    "phenotype": "Malignant neoplasm of endocrine gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocrine gland cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_ENDOCRINE.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_ENDOCRINE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_EYE_ADNEXA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_EYE_ADNEXA",
    "phenotype": "Malignant neoplasm of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_EYE_BRAIN_NEURO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_EYE_BRAIN_NEURO",
    "phenotype": "Malignant neoplasm of eye, brain and central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_EYE_BRAIN_NEURO.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_EYE_BRAIN_NEURO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_FEMALE_GENITAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_FEMALE_GENITAL",
    "phenotype": "malignant neoplasm of female genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Female genital cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_FEMALE_GENITAL.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_FEMALE_GENITAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_KIDNEY_NOTRENALPELVIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_KIDNEY_NOTRENALPELVIS",
    "phenotype": "Malignant neoplasm of kidney, except renal pelvis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Kidney cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_KIDNEY_NOTRENALPELVIS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_KIDNEY_NOTRENALPELVIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_LARYNX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_LARYNX",
    "phenotype": "Malignant neoplasm of larynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Laryngeal cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_LARYNX.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_LARYNX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_LIP_ORAL_PHARYNX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_LIP_ORAL_PHARYNX",
    "phenotype": "Malignant neoplasm of lip, oral cavity and pharynx",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Oral/pharyngeal cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_LIP_ORAL_PHARYNX.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_LIP_ORAL_PHARYNX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_LIVER_INTRAHEPATIC_BILE_DUCTS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_LIVER_INTRAHEPATIC_BILE_DUCTS",
    "phenotype": "Malignant neoplasm of liver and intrahepatic bile ducts",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_LIVER_INTRAHEPATIC_BILE_DUCTS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_LIVER_INTRAHEPATIC_BILE_DUCTS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_LYMPHNODES_SECONDARY_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_LYMPHNODES_SECONDARY_NAS",
    "phenotype": "Secondary and unspecified malignant neoplasm of lymph nodes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary lymph node cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_LYMPHNODES_SECONDARY_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_LYMPHNODES_SECONDARY_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_MALE_GENITAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_MALE_GENITAL",
    "phenotype": "malignant neoplasm of male genital organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Male genital cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_MALE_GENITAL.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_MALE_GENITAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_MELANOMA_SKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_MELANOMA_SKIN",
    "phenotype": "Malignant melanoma of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Melanoma (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_MELANOMA_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_MELANOMA_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_MESOTHELIOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_MESOTHELIOMA",
    "phenotype": "Mesothelioma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesothelioma (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_MESOTHELIOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_MESOTHELIOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_MESTOTHEL_SOFTTISSUE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_MESTOTHEL_SOFTTISSUE",
    "phenotype": "Melignant neoplasm of mesothelium and soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mesothelial/soft tissue cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_MESTOTHEL_SOFTTISSUE.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_MESTOTHEL_SOFTTISSUE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_OESOPHAGUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_OESOPHAGUS",
    "phenotype": "Malignant neoplasm of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_OESOPHAGUS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_OESOPHAGUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_OVARY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_OVARY",
    "phenotype": "Malignant neoplasm of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_PANCREAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_PANCREAS",
    "phenotype": "Malignant neoplasm of pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pancreatic cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_PANCREAS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_PANCREAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_PRIMARY_LYMPHOID_HEMATOPOIETIC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_PRIMARY_LYMPHOID_HEMATOPOIETIC",
    "phenotype": "Primary_lymphoid and hematopoietic malignant neoplasms",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lymphoid/hematopoietic cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_PRIMARY_LYMPHOID_HEMATOPOIETIC.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_PRIMARY_LYMPHOID_HEMATOPOIETIC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_PROSTATE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_PROSTATE",
    "phenotype": "Malignant neoplasm of prostate",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prostate cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_PROSTATE.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_PROSTATE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_RECTOISIGMOID_JUNCTION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_RECTOISIGMOID_JUNCTION",
    "phenotype": "Malignant neoplasm of rectosigmoid junction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectosigmoid cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_RECTOISIGMOID_JUNCTION.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_RECTOISIGMOID_JUNCTION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_RECTUM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_RECTUM",
    "phenotype": "Malignant neoplasm of rectum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rectal cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_RECTUM.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_RECTUM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_RESPIRATORY_INTRATHORACIC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_RESPIRATORY_INTRATHORACIC",
    "phenotype": "Malignant neoplasm of respiratory system and intrathoracic organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_RESPIRATORY_INTRATHORACIC.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_RESPIRATORY_INTRATHORACIC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_SECONDARY_RESPIRATORY_DIGESTIVE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_SECONDARY_RESPIRATORY_DIGESTIVE",
    "phenotype": "Secondary malignant neoplasm of respiratory and digestive organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary respiratory/digestive cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_SECONDARY_RESPIRATORY_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_SECONDARY_RESPIRATORY_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_SECONDARY_WITHOUT_SITESPEC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_SECONDARY_WITHOUT_SITESPEC",
    "phenotype": "Malignant neoplasm, without specification of site",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cancer NOS (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_SECONDARY_WITHOUT_SITESPEC.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_SECONDARY_WITHOUT_SITESPEC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_SKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_SKIN",
    "phenotype": "Malignant neoplasm of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin cancer (non-melanoma)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_SKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_SMALL_INTESTINE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_SMALL_INTESTINE",
    "phenotype": "Malignant neoplasm of small intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small intestine cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_SMALL_INTESTINE.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_SMALL_INTESTINE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_STOMACH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_STOMACH",
    "phenotype": "Malignant neoplasm of stomach",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stomach cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_STOMACH.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_STOMACH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_TESTIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_TESTIS",
    "phenotype": "Malignant neoplasm of testis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Testicular cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_TESTIS.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_TESTIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_THYROID_GLAND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_THYROID_GLAND",
    "phenotype": "Malignant neoplasm of thyroid gland",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyroid cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_THYROID_GLAND.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_THYROID_GLAND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_TONSIL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_TONSIL",
    "phenotype": "Malignant neoplasm of tonsil",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Tonsil cancer (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_TONSIL.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_TONSIL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_UNCERTAIN_SECONDARY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_UNCERTAIN_SECONDARY",
    "phenotype": "Secondary uncertain malignant neoplasm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary uncertain cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_UNCERTAIN_SECONDARY.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_UNCERTAIN_SECONDARY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "C3_URINARY_TRACT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "C3_URINARY_TRACT",
    "phenotype": "Malignant neoplasm of urinary organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urinary organ cancer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/C3_URINARY_TRACT.gwas.imputed_v3.both_sexes.tsv.bgz -O C3_URINARY_TRACT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CAMPYLOENTERITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CAMPYLOENTERITIS",
    "phenotype": "Campylobacter enteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Campylobacter enteritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CAMPYLOENTERITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O CAMPYLOENTERITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CARDIAC_ARRHYTM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CARDIAC_ARRHYTM",
    "phenotype": "Cardiac arrhytmias, COPD co-morbidities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac arrhythmia with COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CARDIAC_ARRHYTM.gwas.imputed_v3.both_sexes.tsv.bgz -O CARDIAC_ARRHYTM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CHILDHOOD_ALLERGY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CHILDHOOD_ALLERGY",
    "phenotype": "Childhood allergy (age < 16)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Childhood allergy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CHILDHOOD_ALLERGY.gwas.imputed_v3.both_sexes.tsv.bgz -O CHILDHOOD_ALLERGY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CHIRHEP_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CHIRHEP_NAS",
    "phenotype": "Chirrosis of liver, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver cirrhosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CHIRHEP_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O CHIRHEP_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CHRONLARGE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CHRONLARGE",
    "phenotype": "Crohn's disease of large intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (large intestine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CHRONLARGE.gwas.imputed_v3.both_sexes.tsv.bgz -O CHRONLARGE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CHRONNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CHRONNAS",
    "phenotype": "Chron's disease NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CHRONNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O CHRONNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CHRONSMALL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CHRONSMALL",
    "phenotype": "Crohn's disease of small interstine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crohn disease (small intestine)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CHRONSMALL.gwas.imputed_v3.both_sexes.tsv.bgz -O CHRONSMALL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "COLITNONINFNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "COLITNONINFNAS",
    "phenotype": "Noninfectious colitis NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Noninfectious colitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/COLITNONINFNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O COLITNONINFNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "CONGEN_HEART_ARTER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "CONGEN_HEART_ARTER",
    "phenotype": "Congenital malformations of heart and great arteries",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital heart malformation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/CONGEN_HEART_ARTER.gwas.imputed_v3.both_sexes.tsv.bgz -O CONGEN_HEART_ARTER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "COPD_EARLYANDLATER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "COPD_EARLYANDLATER",
    "phenotype": "COPD, early/later onset",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/COPD_EARLYANDLATER.gwas.imputed_v3.both_sexes.tsv.bgz -O COPD_EARLYANDLATER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "COPD_EXCL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "COPD_EXCL",
    "phenotype": "COPD differential diagnosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD differential",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/COPD_EXCL.gwas.imputed_v3.both_sexes.tsv.bgz -O COPD_EXCL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "COPD_OPPORTUNIST_INFECTIONS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "COPD_OPPORTUNIST_INFECTIONS",
    "phenotype": "COPD related to chronic (opportunist) infections",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "COPD with chronic infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/COPD_OPPORTUNIST_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz -O COPD_OPPORTUNIST_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "COX_ARTHROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "COX_ARTHROSIS",
    "phenotype": "Coxarthrosis [arthrosis of hip](FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hip osteoarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/COX_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O COX_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_ANAEMIA_IRONDEF",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_ANAEMIA_IRONDEF",
    "phenotype": "Iron deficiency anaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Iron deficiency anemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_ANAEMIA_IRONDEF.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_ANAEMIA_IRONDEF.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_HYPERGAMMAGLONAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_HYPERGAMMAGLONAS",
    "phenotype": "Hypergammalglobulinemia, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypergammaglobulinemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_HYPERGAMMAGLONAS.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_HYPERGAMMAGLONAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_ITP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_ITP",
    "phenotype": "Idiopathic thrombocytopenic purpura",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ITP",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_ITP.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_ITP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_OTHERBLOOD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_OTHERBLOOD",
    "phenotype": "Oher diseases of blood and blood-forming organs",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Other blood disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_OTHERBLOOD.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_OTHERBLOOD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_PURPURA_AND3_OTHER_HAEMORRHAGIC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_PURPURA_AND3_OTHER_HAEMORRHAGIC",
    "phenotype": "Purpura and other haemorrhagic conditions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Purpura",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_PURPURA_AND3_OTHER_HAEMORRHAGIC.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_PURPURA_AND3_OTHER_HAEMORRHAGIC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_SCNDPOLYCYTHAEMIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_SCNDPOLYCYTHAEMIA",
    "phenotype": "Secondary polycythaemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Secondary polycythemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_SCNDPOLYCYTHAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_SCNDPOLYCYTHAEMIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "D3_THROMBOCYTOPENIANAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "D3_THROMBOCYTOPENIANAS",
    "phenotype": "Thrombocytopenia, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thrombocytopenia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/D3_THROMBOCYTOPENIANAS.gwas.imputed_v3.both_sexes.tsv.bgz -O D3_THROMBOCYTOPENIANAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_BCKGRND_RETINOPAT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_BCKGRND_RETINOPAT",
    "phenotype": "Background diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_BCKGRND_RETINOPAT.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_BCKGRND_RETINOPAT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_HYPOGLYC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_HYPOGLYC",
    "phenotype": "Diabetic hypoglycemia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic hypoglycemia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_HYPOGLYC.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_HYPOGLYC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_KETOACIDOSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_KETOACIDOSIS",
    "phenotype": "Diabetic ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DKA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_KETOACIDOSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_KETOACIDOSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_PERIPH_ANGIOPATHY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_PERIPH_ANGIOPATHY",
    "phenotype": "Peripheral angiopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral angiopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_PERIPH_ANGIOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_PERIPH_ANGIOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_PERIPHATHERO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_PERIPHATHERO",
    "phenotype": "Peripheral atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral atherosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_PERIPHATHERO.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_PERIPHATHERO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "DM_RETINOPAT_NOS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "DM_RETINOPAT_NOS",
    "phenotype": "Unclassified diabetic retinopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetic retinopathy NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/DM_RETINOPAT_NOS.gwas.imputed_v3.both_sexes.tsv.bgz -O DM_RETINOPAT_NOS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM1",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM1",
    "phenotype": "Type 1 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM1.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM1.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM1KETO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM1KETO",
    "phenotype": "Type 1 diabetes with ketoacidosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with DKA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM1KETO.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM1KETO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM1NOCOMP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM1NOCOMP",
    "phenotype": "Type 1 diabetes without complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes uncomplicated",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM1NOCOMP.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM1NOCOMP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM1OPTH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM1OPTH",
    "phenotype": "Type 1 diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 1 diabetes with eye complications",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM1OPTH.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM1OPTH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM2",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM2",
    "phenotype": "Type 2 diabetes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM2.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM2.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM2NOCOMP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM2NOCOMP",
    "phenotype": "Type 2 diabetes without complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes uncomplicated",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM2NOCOMP.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM2NOCOMP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM2OPTH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM2OPTH",
    "phenotype": "Type 2 diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with eye complications",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM2OPTH.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM2OPTH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DM2PERIPH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DM2PERIPH",
    "phenotype": "Type 2 diabetes with peripheral circulatory complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Type 2 diabetes with peripheral complications",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DM2PERIPH.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DM2PERIPH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_DMNASOPTH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_DMNASOPTH",
    "phenotype": "Unspecified diabetes with ophthalmic complications",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diabetes NOS with eye complications",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_DMNASOPTH.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_DMNASOPTH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_OBESITY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_OBESITY",
    "phenotype": "Obesity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Obesity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_OBESITY.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_OBESITY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_THYTOXGOITDIF",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_THYTOXGOITDIF",
    "phenotype": "Thyrotoxicosis with diffuse goitr",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis with goiter",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_THYTOXGOITDIF.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_THYTOXGOITDIF.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "E4_THYTOXNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "E4_THYTOXNAS",
    "phenotype": "Thyrotoxicosis, other and/or unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/E4_THYTOXNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O E4_THYTOXNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ENDOMETRIOSIS_NOS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ENDOMETRIOSIS_NOS",
    "phenotype": "Unsepcified/other endometriosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ENDOMETRIOSIS_NOS.gwas.imputed_v3.both_sexes.tsv.bgz -O ENDOMETRIOSIS_NOS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ENDOMETRIOSIS_OVARY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ENDOMETRIOSIS_OVARY",
    "phenotype": "Endometriosis of ovary",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ovarian endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ENDOMETRIOSIS_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz -O ENDOMETRIOSIS_OVARY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ENDOMETRIOSIS_PELVICPERITONEUM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ENDOMETRIOSIS_PELVICPERITONEUM",
    "phenotype": "Endometriosis of pelvic peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ENDOMETRIOSIS_PELVICPERITONEUM.gwas.imputed_v3.both_sexes.tsv.bgz -O ENDOMETRIOSIS_PELVICPERITONEUM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ENDOMETRIOSIS_UTERUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ENDOMETRIOSIS_UTERUS",
    "phenotype": "Endometriosis of uterus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Uterine endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ENDOMETRIOSIS_UTERUS.gwas.imputed_v3.both_sexes.tsv.bgz -O ENDOMETRIOSIS_UTERUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_ALCOHOLAC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_ALCOHOLAC",
    "phenotype": "Acute alcohol intoxication",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute alcohol intoxication",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_ALCOHOLAC.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_ALCOHOLAC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_ALLANXIOUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_ALLANXIOUS",
    "phenotype": "All anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_ALLANXIOUS.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_ALLANXIOUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_BEHAVE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_BEHAVE",
    "phenotype": "Behavioural syndromes associated with physiological disturbances and physical factors",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Behavioral syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_BEHAVE.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_BEHAVE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_DEMENTIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_DEMENTIA",
    "phenotype": "Dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_DEMENTIA.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_DEMENTIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_DEPRESSIO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_DEPRESSIO",
    "phenotype": "Depression",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Depression",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_DEPRESSIO.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_DEPRESSIO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_MOOD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_MOOD",
    "phenotype": "Mood [affective] disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mood disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_MOOD.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_MOOD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_PANIC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_PANIC",
    "phenotype": "Panic disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Panic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_PANIC.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_PANIC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_PERSONALITY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_PERSONALITY",
    "phenotype": "Specific personality disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_PERSONALITY.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_PERSONALITY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "F5_SCHIZO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "F5_SCHIZO",
    "phenotype": "Schizophrenia, schizotypal and delusional disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia spectrum",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/F5_SCHIZO.gwas.imputed_v3.both_sexes.tsv.bgz -O F5_SCHIZO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "FIBRO_COMORB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "FIBRO_COMORB",
    "phenotype": "Fibromyalgia related co-morbidities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibromyalgia comorbidities",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/FIBRO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz -O FIBRO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_ALS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_ALS",
    "phenotype": "Motor neuron disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Motor neuron disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_ALS.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_ALS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_BELLPA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_BELLPA",
    "phenotype": "Bell's palsy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bell palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_BELLPA.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_BELLPA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_CARPTU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_CARPTU",
    "phenotype": "Carpal tunnel syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Carpal tunnel syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_CARPTU.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_CARPTU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_CONCUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_CONCUS",
    "phenotype": "Concussion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Concussion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_CONCUS.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_CONCUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_CPETAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_CPETAL",
    "phenotype": "Cerebral palsy and other paralytic syndromes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral palsy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_CPETAL.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_CPETAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_DEMYEL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_DEMYEL",
    "phenotype": "Demyelenating diseases of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Demyelinating disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_DEMYEL.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_DEMYEL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_DIFBRAININJ",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_DIFBRAININJ",
    "phenotype": "Diffuse brain injury",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diffuse brain injury",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_DIFBRAININJ.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_DIFBRAININJ.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_EPIPAROX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_EPIPAROX",
    "phenotype": "Episodal and paroxysmal disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paroxysmal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_EPIPAROX.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_EPIPAROX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_GUILBAR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_GUILBAR",
    "phenotype": "Guillain-Barre syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Guillain-Barre syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_GUILBAR.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_GUILBAR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_HYDROCEPH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_HYDROCEPH",
    "phenotype": "Hydrocephalus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hydrocephalus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_HYDROCEPH.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_HYDROCEPH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_INTRACRATRAUMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_INTRACRATRAUMA",
    "phenotype": "Intracranial trauma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intracranial trauma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_INTRACRATRAUMA.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_INTRACRATRAUMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_MYONEU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_MYONEU",
    "phenotype": "Diseases of the myoneural junction and muscle",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myoneural/muscle disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_MYONEU.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_MYONEU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_NERPLEX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_NERPLEX",
    "phenotype": "Nerve, nerve root and plexus disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nerve root/plexus disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_NERPLEX.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_NERPLEX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_NEUATR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_NEUATR",
    "phenotype": "Systemic atrophies primarly affecting the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Systemic CNS atrophy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_NEUATR.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_NEUATR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_NEUINFL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_NEUINFL",
    "phenotype": "Inflammatory diseases of the central nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "CNS inflammatory disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_NEUINFL.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_NEUINFL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_PLANTAR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_PLANTAR",
    "phenotype": "Lesion of plantar nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Plantar nerve lesion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_PLANTAR.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_PLANTAR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_SAHTRAU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_SAHTRAU",
    "phenotype": "Traumatic subarachnoid haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic subarachnoid hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_SAHTRAU.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_SAHTRAU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_SDHTRAU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_SDHTRAU",
    "phenotype": "Traumatic subdural haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Traumatic subdural hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_SDHTRAU.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_SDHTRAU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_SLEEPAPNO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_SLEEPAPNO",
    "phenotype": "Sleep apnoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep apnea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_SLEEPAPNO.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_SLEEPAPNO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_TRINEU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_TRINEU",
    "phenotype": "Trigeminal neuralgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigeminal neuralgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_TRINEU.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_TRINEU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_ULLNLE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_ULLNLE",
    "phenotype": "Lesion of ulnar nerve",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulnar nerve lesion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_ULLNLE.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_ULLNLE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "G6_XTRAPYR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "G6_XTRAPYR",
    "phenotype": "Extrapyramidal and movement disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Extrapyramidal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/G6_XTRAPYR.gwas.imputed_v3.both_sexes.tsv.bgz -O G6_XTRAPYR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "GLOMER_NEPHRITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "GLOMER_NEPHRITIS",
    "phenotype": "Glomerulonephritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glomerulonephritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/GLOMER_NEPHRITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O GLOMER_NEPHRITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "GOUT_NOS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "GOUT_NOS",
    "phenotype": "Gout, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/GOUT_NOS.gwas.imputed_v3.both_sexes.tsv.bgz -O GOUT_NOS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "GOUT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "GOUT",
    "phenotype": "Gout, FINNGEN",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gout",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/GOUT.gwas.imputed_v3.both_sexes.tsv.bgz -O GOUT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_BCKRNDRETINOPAT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_BCKRNDRETINOPAT",
    "phenotype": "Background retinopathy and retinal vascular changes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_BCKRNDRETINOPAT.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_BCKRNDRETINOPAT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_BLEPHAROCHALASIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_BLEPHAROCHALASIS",
    "phenotype": "Blepharochalasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blepharochalasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_BLEPHAROCHALASIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_BLEPHAROCHALASIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_CHALAZION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_CHALAZION",
    "phenotype": "Chalazion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chalazion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_CHALAZION.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_CHALAZION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_CONVERSTRAB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_CONVERSTRAB",
    "phenotype": "Convergent concomitant strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Convergent strabismus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_CONVERSTRAB.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_CONVERSTRAB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_CORNULCER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_CORNULCER",
    "phenotype": "Corneal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Corneal ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_CORNULCER.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_CORNULCER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_DIPLOPIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_DIPLOPIA",
    "phenotype": "Diplopia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Diplopia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_DIPLOPIA.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_DIPLOPIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_DIVERGSTRAB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_DIVERGSTRAB",
    "phenotype": "Divergent concomitant strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Divergent strabismus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_DIVERGSTRAB.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_DIVERGSTRAB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_ECTROPION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_ECTROPION",
    "phenotype": "Ectropion of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ectropion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_ECTROPION.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_ECTROPION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_ENTROPION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_ENTROPION",
    "phenotype": "Entropion and trichiasis of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Entropion/trichiasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_ENTROPION.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_ENTROPION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_EPIPHORA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_EPIPHORA",
    "phenotype": "Epiphora",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Epiphora",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_EPIPHORA.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_EPIPHORA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_EYEPOSTOP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_EYEPOSTOP",
    "phenotype": "Postprocedural disorders of eye and adnexa, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural eye disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_EYEPOSTOP.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_EYEPOSTOP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_GLAUCCLOSEPRIM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_GLAUCCLOSEPRIM",
    "phenotype": "Primary angle-closure glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Angle-closure glaucoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_GLAUCCLOSEPRIM.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_GLAUCCLOSEPRIM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_GLAUCPRIMOPEN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_GLAUCPRIMOPEN",
    "phenotype": "Primary open-angle glaucoma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Open-angle glaucoma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_GLAUCPRIMOPEN.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_GLAUCPRIMOPEN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_GLAUCSUSP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_GLAUCSUSP",
    "phenotype": "Glaucoma suspect",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glaucoma suspect",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_GLAUCSUSP.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_GLAUCSUSP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_KERATITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_KERATITIS",
    "phenotype": "Keratitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Keratitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_KERATITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_KERATITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_LACRIMALSYSTEM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_LACRIMALSYSTEM",
    "phenotype": "Disorders of lacrimal system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_LACRIMALSYSTEM.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_LACRIMALSYSTEM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_LENS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_LENS",
    "phenotype": "Disorders of lens",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lens disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_LENS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_LENS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_MACULADEGEN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_MACULADEGEN",
    "phenotype": "Degeneration of macula and posterior pole",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Macular degeneration",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_MACULADEGEN.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_MACULADEGEN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_PARASTRAB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_PARASTRAB",
    "phenotype": "Paralytic strabismus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic strabismus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_PARASTRAB.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_PARASTRAB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_POSTOPEYENAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_POSTOPEYENAS",
    "phenotype": "Oher and unspecified postprocedural disorders of eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Postprocedural eye disorder NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_POSTOPEYENAS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_POSTOPEYENAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_PTERYGIUM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_PTERYGIUM",
    "phenotype": "Pterygium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pterygium",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_PTERYGIUM.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_PTERYGIUM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_PTOSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_PTOSIS",
    "phenotype": "Ptosis of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ptosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_PTOSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_PTOSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_REFRAACCOMMODIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_REFRAACCOMMODIS",
    "phenotype": "Disorders of refraction and accommodation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Refraction disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_REFRAACCOMMODIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_REFRAACCOMMODIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_RETINALBREAK",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_RETINALBREAK",
    "phenotype": "Retinal breaks without detachment",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal break",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_RETINALBREAK.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_RETINALBREAK.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_RETINALDETACH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_RETINALDETACH",
    "phenotype": "Retinal detachments and breaks",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment/break",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_RETINALDETACH.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_RETINALDETACH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_RETINALDETACHBREAK",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_RETINALDETACHBREAK",
    "phenotype": "Retinal detachment with retinal break",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal detachment with break",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_RETINALDETACHBREAK.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_RETINALDETACHBREAK.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_RETINAVASC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_RETINAVASC",
    "phenotype": "Retinal vascular disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Retinal vascular disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_RETINAVASC.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_RETINAVASC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_STENOLACRI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_STENOLACRI",
    "phenotype": "Stenosis and insufficiency of lacrimal passages",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lacrimal stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_STENOLACRI.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_STENOLACRI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_VISUDISTURB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_VISUDISTURB",
    "phenotype": "Visual disturbances",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Visual disturbance",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_VISUDISTURB.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_VISUDISTURB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_VITRBODYGLOBE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_VITRBODYGLOBE",
    "phenotype": "Disorders of vitreous body",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_VITRBODYGLOBE.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_VITRBODYGLOBE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_VITRHAEMORR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_VITRHAEMORR",
    "phenotype": "Vitreous haemorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitreous hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_VITRHAEMORR.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_VITRHAEMORR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H7_XANTHELASMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H7_XANTHELASMA",
    "phenotype": "Xanthelasma of eyelid",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Xanthelasma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H7_XANTHELASMA.gwas.imputed_v3.both_sexes.tsv.bgz -O H7_XANTHELASMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_BPV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_BPV",
    "phenotype": "Benign paroxysmal vertigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Benign paroxysmal vertigo",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_BPV.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_BPV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_CERUMEN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_CERUMEN",
    "phenotype": "Impacted cerumen",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Impacted cerumen",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_CERUMEN.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_CERUMEN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_CHRON_SUPOTITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_CHRON_SUPOTITIS",
    "phenotype": "Chronic suppurative otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic suppurative otitis media",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_CHRON_SUPOTITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_CHRON_SUPOTITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_CONSENHEARINGLOSS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_CONSENHEARINGLOSS",
    "phenotype": "Conductive and sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mixed hearing loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_CONSENHEARINGLOSS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_CONSENHEARINGLOSS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_EXT_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_EXT_NAS",
    "phenotype": "Otitis externa, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis externa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_EXT_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_EXT_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_EXTOTITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_EXTOTITIS",
    "phenotype": "Otitis externa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis externa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_EXTOTITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_EXTOTITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_HL_CON_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_HL_CON_NAS",
    "phenotype": "Conductive hearing loss, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conductive hearing loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_HL_CON_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_HL_CON_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_HL_SEN_NAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_HL_SEN_NAS",
    "phenotype": "Sensorineural hearing loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sensorineural hearing loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_HL_SEN_NAS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_HL_SEN_NAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_LABYRINTHITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_LABYRINTHITIS",
    "phenotype": "Labyrinthitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Labyrinthitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_LABYRINTHITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_LABYRINTHITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_MED_SUPP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_MED_SUPP",
    "phenotype": "Suppurative and unspecified otitis media",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Suppurative otitis media",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_MED_SUPP.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_MED_SUPP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_MENIERE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_MENIERE",
    "phenotype": "Ménière disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meniere disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_MENIERE.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_MENIERE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_OTALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_OTALGIA",
    "phenotype": "Otalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_OTALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_OTALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_OTIMEDNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_OTIMEDNAS",
    "phenotype": "Otitis media, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otitis media",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_OTIMEDNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_OTIMEDNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_OTORRHOEA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_OTORRHOEA",
    "phenotype": "Otorrhoea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Otorrhea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_OTORRHOEA.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_OTORRHOEA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_PERCHRONDR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_PERCHRONDR",
    "phenotype": "Perichondritis of external ear",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Perichondritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_PERCHRONDR.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_PERCHRONDR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "H8_VERTIGO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "H8_VERTIGO",
    "phenotype": "Disorders of vestibular function (Vertigo)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vestibular disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/H8_VERTIGO.gwas.imputed_v3.both_sexes.tsv.bgz -O H8_VERTIGO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "HEARTFAIL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "HEARTFAIL",
    "phenotype": "Heart failure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/HEARTFAIL.gwas.imputed_v3.both_sexes.tsv.bgz -O HEARTFAIL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "HYPOTHYROIDISM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "HYPOTHYROIDISM",
    "phenotype": "Hypothyroidism (congenital or acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypothyroidism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/HYPOTHYROIDISM.gwas.imputed_v3.both_sexes.tsv.bgz -O HYPOTHYROIDISM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "HYPTENSPREG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "HYPTENSPREG",
    "phenotype": "Pregnancy hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gestational hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/HYPTENSPREG.gwas.imputed_v3.both_sexes.tsv.bgz -O HYPTENSPREG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I_INFECT_PARASIT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I_INFECT_PARASIT",
    "phenotype": "Certain infectious and parasitic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Infectious disease category",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I_INFECT_PARASIT.gwas.imputed_v3.both_sexes.tsv.bgz -O I_INFECT_PARASIT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_ANEURYSM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_ANEURYSM",
    "phenotype": "Cerebral aneurysm, nonruptured",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cerebral aneurysm nonruptured",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_ANEURYSM.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_ANEURYSM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_AORTANEUR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_AORTANEUR",
    "phenotype": "Aortic aneurysm",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic aneurysm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_AORTANEUR.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_AORTANEUR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_AORTDIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_AORTDIS",
    "phenotype": "Dissection of aorta",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Aortic dissection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_AORTDIS.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_AORTDIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_ARTEMBTHR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_ARTEMBTHR",
    "phenotype": "Arterial embolism and thrombosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arterial embolism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_ARTEMBTHR.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_ARTEMBTHR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_ARTEMBTHRLOW",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_ARTEMBTHRLOW",
    "phenotype": "Arterial embolism and thrombosis of lower extremity artery",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower extremity arterial embolism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_ARTEMBTHRLOW.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_ARTEMBTHRLOW.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_AVBLOCK",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_AVBLOCK",
    "phenotype": "AV-block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "AV block",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_AVBLOCK.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_AVBLOCK.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CARDMPRI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CARDMPRI",
    "phenotype": "Cardiomyopathies, Primary/intrinsic",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Primary cardiomyopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CARDMPRI.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CARDMPRI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CARDMYO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CARDMYO",
    "phenotype": "Cardiomyopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiomyopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CARDMYO.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CARDMYO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CHD_NOREV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CHD_NOREV",
    "phenotype": "Major coronary heart disease event excluding revascularizations",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major CHD event (excl revasc)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CHD_NOREV.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CHD_NOREV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CHD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CHD",
    "phenotype": "Major coronary heart disease event",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Major CHD event",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CHD.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CHD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CONDUCTIO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CONDUCTIO",
    "phenotype": "Conduction disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Conduction disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CONDUCTIO.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CONDUCTIO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_CORATHER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_CORATHER",
    "phenotype": "Coronary atherosclerosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Coronary atherosclerosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_CORATHER.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_CORATHER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_DISVEINLYMPH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_DISVEINLYMPH",
    "phenotype": "Diseases of veins, lymphatic vessels and lymph nodes, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Venous/lymphatic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_DISVEINLYMPH.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_DISVEINLYMPH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_DVTANDPULM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_DVTANDPULM",
    "phenotype": "DVT of lower extremities and pulmonary embolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT and PE",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_DVTANDPULM.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_DVTANDPULM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_ENDOCARD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_ENDOCARD",
    "phenotype": "Endocarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocarditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_ENDOCARD.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_ENDOCARD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HEARTFAIL_NS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HEARTFAIL_NS",
    "phenotype": "Heart failure, not strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (broad)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HEARTFAIL_NS.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HEARTFAIL_NS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HEARTFAIL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HEARTFAIL",
    "phenotype": "Heart failure,strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Heart failure (strict)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HEARTFAIL.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HEARTFAIL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HYPERTENSION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HYPERTENSION",
    "phenotype": "Hypertensive diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HYPERTENSION.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HYPERTENSION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HYPTENS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HYPTENS",
    "phenotype": "Hypertension",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HYPTENS.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HYPTENS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HYPTENSHR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HYPTENSHR",
    "phenotype": "Hypertensive heart and/or renal disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertensive heart/renal disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HYPTENSHR.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HYPTENSHR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_HYPTENSPREG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_HYPTENSPREG",
    "phenotype": "Hypertension complicating pregnancy, childbirth, and the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy hypertension",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_HYPTENSPREG.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_HYPTENSPREG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_IHD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_IHD",
    "phenotype": "Ischaemic heart disease, wide definition",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic heart disease (wide)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_IHD.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_IHD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_INTRACRA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_INTRACRA",
    "phenotype": "Nontraumatic intracranial haemmorrhage",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nontraumatic intracranial hemorrhage",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_INTRACRA.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_INTRACRA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_K_CARDIAC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_K_CARDIAC",
    "phenotype": "Death due to cardiac causes",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cardiac death",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_K_CARDIAC.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_K_CARDIAC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_LBBB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_LBBB",
    "phenotype": "Left bundle-branch block",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "LBBB",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_LBBB.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_LBBB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_MI_STRICT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_MI_STRICT",
    "phenotype": "Myocardial infarction, strict",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "MI (strict)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_MI_STRICT.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_MI_STRICT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_MI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_MI",
    "phenotype": "Myocardial infarction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "MI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_MI.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_MI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_NONRHEVALV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_NONRHEVALV",
    "phenotype": "Non-rheumatic valve diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nonrheumatic valve disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_NONRHEVALV.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_NONRHEVALV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_PAD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_PAD",
    "phenotype": "Peripheral artery disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peripheral artery disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_PAD.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_PAD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_PERICARD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_PERICARD",
    "phenotype": "Pericarditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pericarditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_PERICARD.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_PERICARD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_PHLETHROMBDVTLOW",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_PHLETHROMBDVTLOW",
    "phenotype": "DVT of lower extremities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "DVT lower extremity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_PHLETHROMBDVTLOW.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_PHLETHROMBDVTLOW.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_RHEUFEV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_RHEUFEV",
    "phenotype": "Rheumatic fever incl heart disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic heart disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_RHEUFEV.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_RHEUFEV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_RHEUVALV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_RHEUVALV",
    "phenotype": "Rheumatic valve diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatic valve disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_RHEUVALV.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_RHEUVALV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_STR_EXH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_STR_EXH",
    "phenotype": "Ischaemic Stroke, excluding all haemorrhages",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ischemic stroke",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_STR_EXH.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_STR_EXH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_STR_SAH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_STR_SAH",
    "phenotype": "Stroke, including SAH",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke (incl SAH)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_STR_SAH.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_STR_SAH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_STR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_STR",
    "phenotype": "Stroke, excluding SAH",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Stroke (excl SAH)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_STR.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_STR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_UAP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_UAP",
    "phenotype": "Unstable angina pectoris",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Unstable angina",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_UAP.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_UAP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_VASCINT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_VASCINT",
    "phenotype": "Vascular diseases of the intestine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal vascular disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_VASCINT.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_VASCINT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "I9_VTE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "I9_VTE",
    "phenotype": "Venous thromboembolism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "VTE",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/I9_VTE.gwas.imputed_v3.both_sexes.tsv.bgz -O I9_VTE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IBD_BACT_INTEST_INFECTIONS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IBD_BACT_INTEST_INFECTIONS",
    "phenotype": "Bacterial intestinal infections, IBD co-morbidities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial intestinal infection",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IBD_BACT_INTEST_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz -O IBD_BACT_INTEST_INFECTIONS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IBD_ENDOMETRIOSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IBD_ENDOMETRIOSIS",
    "phenotype": "Endometriosis, IBD co-morbidity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endometriosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IBD_ENDOMETRIOSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O IBD_ENDOMETRIOSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IBD_PULM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IBD_PULM",
    "phenotype": "Respiratory diseases principally affecting the interstitium, IBD co-morbidites",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Interstitial lung disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IBD_PULM.gwas.imputed_v3.both_sexes.tsv.bgz -O IBD_PULM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IBD_VIRAL_HEPATITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IBD_VIRAL_HEPATITIS",
    "phenotype": "Viral hepatitis, IBD co-morbidity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Viral hepatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IBD_VIRAL_HEPATITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O IBD_VIRAL_HEPATITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ICDMAIN_ANY_ENTRY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ICDMAIN_ANY_ENTRY",
    "phenotype": "Any ICDMAIN event in hilmo or causes of death",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Any ICD main event",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ICDMAIN_ANY_ENTRY.gwas.imputed_v3.both_sexes.tsv.bgz -O ICDMAIN_ANY_ENTRY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "II_NEOPLASM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "II_NEOPLASM",
    "phenotype": "Neoplasms",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neoplasm",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/II_NEOPLASM.gwas.imputed_v3.both_sexes.tsv.bgz -O II_NEOPLASM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "III_BLOOD_IMMUN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "III_BLOOD_IMMUN",
    "phenotype": "Diseases of the blood and blood-forming organs and certain disorders involving the immune mechanism",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Blood/immune disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/III_BLOOD_IMMUN.gwas.imputed_v3.both_sexes.tsv.bgz -O III_BLOOD_IMMUN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ILD_DIFF_DG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ILD_DIFF_DG",
    "phenotype": "ILD differential diagnosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "ILD differential",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ILD_DIFF_DG.gwas.imputed_v3.both_sexes.tsv.bgz -O ILD_DIFF_DG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "INFLUENZA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "INFLUENZA",
    "phenotype": "All influenza (not pneumonia)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Influenza",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/INFLUENZA.gwas.imputed_v3.both_sexes.tsv.bgz -O INFLUENZA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IPF",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IPF",
    "phenotype": "Idiopathic pulmonary fibrosis (attempt to specificity)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Idiopathic pulmonary fibrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IPF.gwas.imputed_v3.both_sexes.tsv.bgz -O IPF.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IV_ENDOCRIN_NUTRIT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IV_ENDOCRIN_NUTRIT",
    "phenotype": "Endocrine, nutritional and metabolic diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Endocrine/metabolic disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IV_ENDOCRIN_NUTRIT.gwas.imputed_v3.both_sexes.tsv.bgz -O IV_ENDOCRIN_NUTRIT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "IX_CIRCULATORY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "IX_CIRCULATORY",
    "phenotype": "Diseases of the circulatory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Circulatory disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/IX_CIRCULATORY.gwas.imputed_v3.both_sexes.tsv.bgz -O IX_CIRCULATORY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "J10_ASTHMA_MAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "J10_ASTHMA_MAIN",
    "phenotype": "Asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/J10_ASTHMA_MAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O J10_ASTHMA_MAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "J10_ASTHMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "J10_ASTHMA",
    "phenotype": "Asthma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Asthma (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/J10_ASTHMA.gwas.imputed_v3.both_sexes.tsv.bgz -O J10_ASTHMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "J10_EXTERLUNG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "J10_EXTERLUNG",
    "phenotype": "Lung diseases due to external agents",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "External agent lung disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/J10_EXTERLUNG.gwas.imputed_v3.both_sexes.tsv.bgz -O J10_EXTERLUNG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_ACHAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_ACHAL",
    "phenotype": "Achalasia of cardia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Achalasia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_ACHAL.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_ACHAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_ACUTGASTR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_ACUTGASTR",
    "phenotype": "Acute gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Acute gastritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_ACUTGASTR.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_ACUTGASTR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_ADHE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_ADHE",
    "phenotype": "Intestinal adhesions without obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal adhesions",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_ADHE.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_ADHE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_APPENDIX",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_APPENDIX",
    "phenotype": "Diseases of appendix",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Appendix disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_APPENDIX.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_APPENDIX.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_BARRET",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_BARRET",
    "phenotype": "Barret oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Barrett esophagus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_BARRET.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_BARRET.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_CHOLANGI",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_CHOLANGI",
    "phenotype": "Cholangitis (sclerosing)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sclerosing cholangitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_CHOLANGI.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_CHOLANGI.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_CHRONGASTR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_CHRONGASTR",
    "phenotype": "Chronic gastritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic gastritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_CHRONGASTR.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_CHRONGASTR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_CHRONPANC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_CHRONPANC",
    "phenotype": "Chronic pancreatitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chronic pancreatitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_CHRONPANC.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_CHRONPANC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_COELIAC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_COELIAC",
    "phenotype": "Coeliac disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Celiac disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_COELIAC.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_COELIAC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_GALLBILPANC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_GALLBILPANC",
    "phenotype": "Disorders of gallbladder, biliary tract and pancreas",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gallbladder/biliary/pancreas disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_GALLBILPANC.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_GALLBILPANC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_GASTRODUOULC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_GASTRODUOULC",
    "phenotype": "Gastroduodenal ulcer",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Gastroduodenal ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_GASTRODUOULC.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_GASTRODUOULC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_GIBLEEDING",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_GIBLEEDING",
    "phenotype": "GI-bleeding",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "GI bleeding",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_GIBLEEDING.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_GIBLEEDING.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_HERNIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_HERNIA",
    "phenotype": "Hernia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hernia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_HERNIA.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_HERNIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_ILEUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_ILEUS",
    "phenotype": "Paralytic ileus and intestinal obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Paralytic ileus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_ILEUS.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_ILEUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_IMPACT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_IMPACT",
    "phenotype": "Impaction of intestines",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Intestinal impaction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_IMPACT.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_IMPACT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_LIVER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_LIVER",
    "phenotype": "Diseases of liver",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Liver disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_LIVER.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_LIVER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_OESOBST",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_OESOBST",
    "phenotype": "Oesophageal obstruction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal obstruction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_OESOBST.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_OESOBST.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_OESULC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_OESULC",
    "phenotype": "Ulcer of oesophagus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Esophageal ulcer",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_OESULC.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_OESULC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_PERITON",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_PERITON",
    "phenotype": "Diseases of peritoneum",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Peritoneal disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_PERITON.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_PERITON.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "K11_VOLVU",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "K11_VOLVU",
    "phenotype": "Volvulus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Volvulus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/K11_VOLVU.gwas.imputed_v3.both_sexes.tsv.bgz -O K11_VOLVU.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KNEE_ARTHROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KNEE_ARTHROSIS",
    "phenotype": "Gonarthrosis [arthrosis of knee](FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Knee osteoarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KNEE_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O KNEE_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_ALCOH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_ALCOH",
    "phenotype": "Alcohol abuse, main dg",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Alcohol abuse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_ALCOH.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_ALCOH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_ANXIETY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_ANXIETY",
    "phenotype": "Anxiety disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_ANXIETY.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_ANXIETY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_ANYMENTAL_SUICID",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_ANYMENTAL_SUICID",
    "phenotype": "Any mental disorder, or suicide (or attempt)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mental disorder or suicide",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_ANYMENTAL_SUICID.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_ANYMENTAL_SUICID.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_ANYMENTAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_ANYMENTAL",
    "phenotype": "Any mental disorder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mental disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_ANYMENTAL.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_ANYMENTAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_DEMENTIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_DEMENTIA",
    "phenotype": "Any dementia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dementia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_DEMENTIA.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_DEMENTIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_MOOD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_MOOD",
    "phenotype": "Mood disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mood disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_MOOD.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_MOOD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_PERSON",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_PERSON",
    "phenotype": "Personality disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Personality disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_PERSON.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_PERSON.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_SCHIZODEL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_SCHIZODEL",
    "phenotype": "Schizophrenia or delusion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Schizophrenia/delusion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_SCHIZODEL.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_SCHIZODEL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "KRA_PSY_SUBSTANCE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "KRA_PSY_SUBSTANCE",
    "phenotype": "Substance abuse",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Substance abuse",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/KRA_PSY_SUBSTANCE.gwas.imputed_v3.both_sexes.tsv.bgz -O KRA_PSY_SUBSTANCE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_ACTINKERA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_ACTINKERA",
    "phenotype": "Actinic keratosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Actinic keratosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_ACTINKERA.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_ACTINKERA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_ATROPHICSKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_ATROPHICSKIN",
    "phenotype": "Atrophic disorders of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Atrophic skin disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_ATROPHICSKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_ATROPHICSKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_FOREIGNBODYGRANULOMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_FOREIGNBODYGRANULOMA",
    "phenotype": "Foreign body granuloma of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin granuloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_FOREIGNBODYGRANULOMA.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_FOREIGNBODYGRANULOMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_GRANULOMATOUSSKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_GRANULOMATOUSSKIN",
    "phenotype": "Granulomatous disorders of skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin granulomatous disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_GRANULOMATOUSSKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_GRANULOMATOUSSKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_HIDRADENITISSUP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_HIDRADENITISSUP",
    "phenotype": "Hidradenitis suppurativa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hidradenitis suppurativa",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_HIDRADENITISSUP.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_HIDRADENITISSUP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_HYPERTROPHICSKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_HYPERTROPHICSKIN",
    "phenotype": "Hypertrophic disorders of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic skin disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_HYPERTROPHICSKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_HYPERTROPHICSKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_HYPETROPHICSCAR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_HYPETROPHICSCAR",
    "phenotype": "Hypertrophic scar",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hypertrophic scar",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_HYPETROPHICSCAR.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_HYPETROPHICSCAR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_LICHENSCLERATROPH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_LICHENSCLERATROPH",
    "phenotype": "Lichen sclerosus et atrophicus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen sclerosus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_LICHENSCLERATROPH.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_LICHENSCLERATROPH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_LICHSIMPANDPRURIGO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_LICHSIMPANDPRURIGO",
    "phenotype": "Lichen simplex chronicus and prurigo",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lichen simplex chronicus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_LICHSIMPANDPRURIGO.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_LICHSIMPANDPRURIGO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_NAIL_INGROW",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_NAIL_INGROW",
    "phenotype": "Ingrowing nail",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ingrown nail",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_NAIL_INGROW.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_NAIL_INGROW.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_NAILDIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_NAILDIS",
    "phenotype": "Nail disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nail disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_NAILDIS.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_NAILDIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_NONIONRADISKIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_NONIONRADISKIN",
    "phenotype": "Skin changes due to chronic exposure to nonionizing radiation",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Radiation skin change",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_NONIONRADISKIN.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_NONIONRADISKIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_PSORI_ARTHRO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_PSORI_ARTHRO",
    "phenotype": "Arthropathic psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriatic arthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_PSORI_ARTHRO.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_PSORI_ARTHRO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_PSORIASIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_PSORIASIS",
    "phenotype": "Psoriasis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Psoriasis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_PSORIASIS.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_PSORIASIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_PYOGENGRANUL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_PYOGENGRANUL",
    "phenotype": "Pyogenic granuloma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic granuloma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_PYOGENGRANUL.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_PYOGENGRANUL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_ROSACEA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_ROSACEA",
    "phenotype": "Rosacea",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rosacea",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_ROSACEA.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_ROSACEA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_SCARCONDITIONS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_SCARCONDITIONS",
    "phenotype": "Scar conditions and fibrosis of skin",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin scar/fibrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_SCARCONDITIONS.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_SCARCONDITIONS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "L12_URTICARIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "L12_URTICARIA",
    "phenotype": "Urticaria",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Urticaria",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/L12_URTICARIA.gwas.imputed_v3.both_sexes.tsv.bgz -O L12_URTICARIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "LUNG_CANCER_MESOT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "LUNG_CANCER_MESOT",
    "phenotype": "Lung cancer and mesothelioma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer/mesothelioma",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/LUNG_CANCER_MESOT.gwas.imputed_v3.both_sexes.tsv.bgz -O LUNG_CANCER_MESOT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "LUNG_CANCER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "LUNG_CANCER",
    "phenotype": "Lung cancer and mesothelioma",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lung cancer/mesothelioma (repeat)",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/LUNG_CANCER.gwas.imputed_v3.both_sexes.tsv.bgz -O LUNG_CANCER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ACHILLESTEND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ACHILLESTEND",
    "phenotype": "Achilles tendinitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Achilles tendinitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ACHILLESTEND.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ACHILLESTEND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ADHCAPSULITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ADHCAPSULITIS",
    "phenotype": "Adhesive capsulitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adhesive capsulitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ADHCAPSULITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ADHCAPSULITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ALGONEURO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ALGONEURO",
    "phenotype": "Alogoneurodystrophy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Algoneurodystrophy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ALGONEURO.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ALGONEURO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ARTHRITISNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ARTHRITISNAS",
    "phenotype": "Ohter specific/unspecified arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthritis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ARTHRITISNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ARTHRITISNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ARTHROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ARTHROSIS",
    "phenotype": "#Arthrosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Arthrosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_BAKERCYST",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_BAKERCYST",
    "phenotype": "Synovial cyst of popliteal space [Baker]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Baker cyst",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_BAKERCYST.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_BAKERCYST.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_CALCIFICTEND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_CALCIFICTEND",
    "phenotype": "Calcific tendinitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Calcific tendinitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_CALCIFICTEND.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_CALCIFICTEND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_CERVICALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_CERVICALGIA",
    "phenotype": "Cervicalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Cervicalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_CERVICALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_CERVICALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_CHRONDROPATHIES",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_CHRONDROPATHIES",
    "phenotype": "Chrondropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Chondropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_CHRONDROPATHIES.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_CHRONDROPATHIES.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_CONTRACTUREJOINT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_CONTRACTUREJOINT",
    "phenotype": "Contracture of joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint contracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_CONTRACTUREJOINT.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_CONTRACTUREJOINT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_DEFORMDORSO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_DEFORMDORSO",
    "phenotype": "#Deforming dorsopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Deforming dorsopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_DEFORMDORSO.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_DEFORMDORSO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_DEQUERVAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_DEQUERVAIN",
    "phenotype": "Radial styloid tenosynovitis [de Quervain]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "De Quervain tenosynovitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_DEQUERVAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_DEQUERVAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_DORSALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_DORSALGIA",
    "phenotype": "Dorsalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dorsalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_DORSALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_DORSALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_DUPUTRYEN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_DUPUTRYEN",
    "phenotype": "Palmar fascial fibromatosis [Dupuytren]",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Dupuytren contracture",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_DUPUTRYEN.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_DUPUTRYEN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ENTESOPATHYFOOT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ENTESOPATHYFOOT",
    "phenotype": "Oher enthesopathy of foot (+metatarsalgia)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Foot enthesopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ENTESOPATHYFOOT.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ENTESOPATHYFOOT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ENTESOPATHYLOW",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ENTESOPATHYLOW",
    "phenotype": "Enthesopathies of lower limb, excluding foot",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lower limb enthesopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ENTESOPATHYLOW.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ENTESOPATHYLOW.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_FIBROBLASTIC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_FIBROBLASTIC",
    "phenotype": "Fibroblastic disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Fibroblastic disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_FIBROBLASTIC.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_FIBROBLASTIC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_FINGERDEFORM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_FINGERDEFORM",
    "phenotype": "Deformity of finger(s)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Finger deformity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_FINGERDEFORM.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_FINGERDEFORM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_FLEXION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_FLEXION",
    "phenotype": "Flexion deformity",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Flexion deformity",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_FLEXION.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_FLEXION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_FOREIGNBODY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_FOREIGNBODY",
    "phenotype": "Residual foreign body in soft tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Residual foreign body",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_FOREIGNBODY.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_FOREIGNBODY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_GANGLION",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_GANGLION",
    "phenotype": "Ganglion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ganglion cyst",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_GANGLION.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_GANGLION.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_GIANTCELL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_GIANTCELL",
    "phenotype": "Giant cell arteritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Giant cell arteritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_GIANTCELL.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_GIANTCELL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_HALLUXRIGIDUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_HALLUXRIGIDUS",
    "phenotype": "Hallux rigidus",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux rigidus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_HALLUXRIGIDUS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_HALLUXRIGIDUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_HALLUXVALGUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_HALLUXVALGUS",
    "phenotype": "Hallux valgus (acquired)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Hallux valgus",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_HALLUXVALGUS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_HALLUXVALGUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_IMPINGEMENT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_IMPINGEMENT",
    "phenotype": "Impingement syndrome of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder impingement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_IMPINGEMENT.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_IMPINGEMENT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_LATERALEPICOND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_LATERALEPICOND",
    "phenotype": "Lateral epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Lateral epicondylitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_LATERALEPICOND.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_LATERALEPICOND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_LIMBPAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_LIMBPAIN",
    "phenotype": "Pain in limb",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Limb pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_LIMBPAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_LIMBPAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_LOOSEJOINT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_LOOSEJOINT",
    "phenotype": "Loose body in joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Loose body in joint",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_LOOSEJOINT.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_LOOSEJOINT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_LOWBACKPAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_LOWBACKPAIN",
    "phenotype": "Low back pain",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Low back pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_LOWBACKPAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_LOWBACKPAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_MEDIALEPICOND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_MEDIALEPICOND",
    "phenotype": "Medial epicondylitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Medial epicondylitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_MEDIALEPICOND.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_MEDIALEPICOND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_MENISCUSDERANGEMENTS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_MENISCUSDERANGEMENTS",
    "phenotype": "Meniscus derangement",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meniscus derangement",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_MENISCUSDERANGEMENTS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_MENISCUSDERANGEMENTS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_METATARSALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_METATARSALGIA",
    "phenotype": "Metatarsalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Metatarsalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_METATARSALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_METATARSALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_MUSCLE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_MUSCLE",
    "phenotype": "Disorders of muscles",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Muscle disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_MUSCLE.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_MUSCLE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_MYALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_MYALGIA",
    "phenotype": "Myalgia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Myalgia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_MYALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_MYALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_NEURALGIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_NEURALGIA",
    "phenotype": "Neuralgia and neuritis, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Neuralgia/neuritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_NEURALGIA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_NEURALGIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_OLECRANONBURSITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_OLECRANONBURSITIS",
    "phenotype": "Olecranon bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Olecranon bursitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_OLECRANONBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_OLECRANONBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_OSTEOPOROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_OSTEOPOROSIS",
    "phenotype": "Osteoporosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Osteoporosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_OSTEOPOROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_OSTEOPOROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_PATHODISLOCATIO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_PATHODISLOCATIO",
    "phenotype": "Pathological/recurrent dislocation and subluxation of joint, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Joint dislocation/subluxation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_PATHODISLOCATIO.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_PATHODISLOCATIO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_PLANTARFASC",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_PLANTARFASC",
    "phenotype": "Plantar fascial fibromatosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Plantar fibromatosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_PLANTARFASC.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_PLANTARFASC.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_POLYARTHROPATHIES",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_POLYARTHROPATHIES",
    "phenotype": "#Polyarthropathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Polyarthropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_POLYARTHROPATHIES.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_POLYARTHROPATHIES.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_PREPATELLARBURSITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_PREPATELLARBURSITIS",
    "phenotype": "Prepatellar bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Prepatellar bursitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_PREPATELLARBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_PREPATELLARBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_PYOGARTH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_PYOGARTH",
    "phenotype": "Pyogenic arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pyogenic arthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_PYOGARTH.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_PYOGARTH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_RADICULOPATHY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_RADICULOPATHY",
    "phenotype": "Radiculopathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Radiculopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_RADICULOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_RADICULOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_RECUDISLOCATIO",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_RECUDISLOCATIO",
    "phenotype": "Recurrent dislocation and subluxation of joint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Recurrent joint dislocation",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_RECUDISLOCATIO.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_RECUDISLOCATIO.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_RHEUMA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_RHEUMA",
    "phenotype": "Rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatoid arthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_RHEUMA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_RHEUMA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_RHEUMATISM",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_RHEUMATISM",
    "phenotype": "Rheumatism, unspecified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rheumatism",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_RHEUMATISM.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_RHEUMATISM.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_ROTATORCUFF",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_ROTATORCUFF",
    "phenotype": "Rotator cuff syndrome",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Rotator cuff syndrome",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_ROTATORCUFF.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_ROTATORCUFF.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SACROCOGG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SACROCOGG",
    "phenotype": "Sacrococcygeal disorders, not elsewhere classified",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sacrococcygeal disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SACROCOGG.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SACROCOGG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SCIATICA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SCIATICA",
    "phenotype": "Siatica+with lumbago",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sciatica with lumbago",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SCIATICA.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SCIATICA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SHOULDER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SHOULDER",
    "phenotype": "Shoulder lesions",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder lesion",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SHOULDER.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SHOULDER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SHOULDERBURSITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SHOULDERBURSITIS",
    "phenotype": "Bursitis of shoulder",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Shoulder bursitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SHOULDERBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SHOULDERBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SOFTOVERUSE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SOFTOVERUSE",
    "phenotype": "Soft tissue disorders related to use, overuse and pressure",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Overuse soft tissue disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SOFTOVERUSE.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SOFTOVERUSE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SPINSTENOSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SPINSTENOSIS",
    "phenotype": "Spinal stenosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spinal stenosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SPINSTENOSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SPINSTENOSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SPONDYLOLISTHESIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SPONDYLOLISTHESIS",
    "phenotype": "Spondylolisthesis/Spondylolysis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylolisthesis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SPONDYLOLISTHESIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SPONDYLOLISTHESIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SPONDYLOPATHY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SPONDYLOPATHY",
    "phenotype": "#Spondylopathies",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SPONDYLOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SPONDYLOPATHY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_SYNOTEND",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_SYNOTEND",
    "phenotype": "Disorders of synovium and tendon",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Synovium/tendon disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_SYNOTEND.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_SYNOTEND.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_THORACISPINEPAIN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_THORACISPINEPAIN",
    "phenotype": "Pain in thoracic spine",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thoracic spine pain",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_THORACISPINEPAIN.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_THORACISPINEPAIN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_TRIGGERFINGER",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_TRIGGERFINGER",
    "phenotype": "Trigger finger",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trigger finger",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_TRIGGERFINGER.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_TRIGGERFINGER.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "M13_TROCHANTERICBURSITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "M13_TROCHANTERICBURSITIS",
    "phenotype": "Trochanteric bursitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Trochanteric bursitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/M13_TROCHANTERICBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O M13_TROCHANTERICBURSITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "MEMLOSS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "MEMLOSS",
    "phenotype": "Memory loss",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Memory loss",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/MEMLOSS.gwas.imputed_v3.both_sexes.tsv.bgz -O MEMLOSS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "MENINGITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "MENINGITIS",
    "phenotype": "Meningitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Meningitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/MENINGITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O MENINGITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "N14_GLOMERULAR",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "N14_GLOMERULAR",
    "phenotype": "Glomerular diseases",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Glomerular disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/N14_GLOMERULAR.gwas.imputed_v3.both_sexes.tsv.bgz -O N14_GLOMERULAR.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "NAFLD",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "NAFLD",
    "phenotype": "Nonalcoholic fatty liver disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "NAFLD",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/NAFLD.gwas.imputed_v3.both_sexes.tsv.bgz -O NAFLD.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PNEUMOBACTKNOWN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PNEUMOBACTKNOWN",
    "phenotype": "Bacterial pneumonia (organism specified)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bacterial pneumonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PNEUMOBACTKNOWN.gwas.imputed_v3.both_sexes.tsv.bgz -O PNEUMOBACTKNOWN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PNEUMONIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PNEUMONIA",
    "phenotype": "Pneumonias (Asthma/COPD co-morbidities)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pneumonia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PNEUMONIA.gwas.imputed_v3.both_sexes.tsv.bgz -O PNEUMONIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PRE_OR_ECLAMPSIA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PRE_OR_ECLAMPSIA",
    "phenotype": "Pre-eclampsia or eclampsia",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Preeclampsia/eclampsia",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PRE_OR_ECLAMPSIA.gwas.imputed_v3.both_sexes.tsv.bgz -O PRE_OR_ECLAMPSIA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PRIM_COXARTHROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PRIM_COXARTHROSIS",
    "phenotype": "Primary coxarthrosis, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral hip osteoarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PRIM_COXARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O PRIM_COXARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PRIM_KNEEARTHROSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PRIM_KNEEARTHROSIS",
    "phenotype": "Primary gonarthrosis, bilateral",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Bilateral knee osteoarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PRIM_KNEEARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O PRIM_KNEEARTHROSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PULM_ANXIETY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PULM_ANXIETY",
    "phenotype": "Anxiety (asthma-related co-morbidities)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Anxiety",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PULM_ANXIETY.gwas.imputed_v3.both_sexes.tsv.bgz -O PULM_ANXIETY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "PULM_MEDICATIO_COMORB",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "PULM_MEDICATIO_COMORB",
    "phenotype": "Medication related adverse effects (Asthma/COPD)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adverse drug effect",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/PULM_MEDICATIO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz -O PULM_MEDICATIO_COMORB.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "RHEUMA_CHRYSTAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "RHEUMA_CHRYSTAL",
    "phenotype": "Chrystal arthropathies, rheuma endpoint",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Crystal arthropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/RHEUMA_CHRYSTAL.gwas.imputed_v3.both_sexes.tsv.bgz -O RHEUMA_CHRYSTAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "RHEUMA_SEROPOS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "RHEUMA_SEROPOS",
    "phenotype": "Seropositive rheumatoid arthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Seropositive RA",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/RHEUMA_SEROPOS.gwas.imputed_v3.both_sexes.tsv.bgz -O RHEUMA_SEROPOS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "SFN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "SFN",
    "phenotype": "Small fibre neuropathy",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Small fiber neuropathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/SFN.gwas.imputed_v3.both_sexes.tsv.bgz -O SFN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "SLEEP",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "SLEEP",
    "phenotype": "Sleep disorders (combined)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Sleep disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/SLEEP.gwas.imputed_v3.both_sexes.tsv.bgz -O SLEEP.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "SNORING",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "SNORING",
    "phenotype": "Snoring",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Snoring",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/SNORING.gwas.imputed_v3.both_sexes.tsv.bgz -O SNORING.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "SPONDYLOARTHRITIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "SPONDYLOARTHRITIS",
    "phenotype": "Spondyloarthritis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondyloarthritis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/SPONDYLOARTHRITIS.gwas.imputed_v3.both_sexes.tsv.bgz -O SPONDYLOARTHRITIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "SPONDYLOPATHY_FG",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "SPONDYLOPATHY_FG",
    "phenotype": "Spondylopathies (FG)",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Spondylopathy",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/SPONDYLOPATHY_FG.gwas.imputed_v3.both_sexes.tsv.bgz -O SPONDYLOPATHY_FG.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "STILL_ADULT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "STILL_ADULT",
    "phenotype": "Adult-onset Still disease",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Adult-onset Still disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/STILL_ADULT.gwas.imputed_v3.both_sexes.tsv.bgz -O STILL_ADULT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "THYROTOXICOSIS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "THYROTOXICOSIS",
    "phenotype": "Thyrotoxicosis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Thyrotoxicosis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/THYROTOXICOSIS.gwas.imputed_v3.both_sexes.tsv.bgz -O THYROTOXICOSIS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "TRAUMBRAIN_NONCONCUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "TRAUMBRAIN_NONCONCUS",
    "phenotype": "severe traumatic brain injury, does not include concussion",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Severe TBI",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/TRAUMBRAIN_NONCONCUS.gwas.imputed_v3.both_sexes.tsv.bgz -O TRAUMBRAIN_NONCONCUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ULCERNAS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ULCERNAS",
    "phenotype": "Ulcerative colitis, NAS",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative colitis NOS",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ULCERNAS.gwas.imputed_v3.both_sexes.tsv.bgz -O ULCERNAS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ULCERPROCT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ULCERPROCT",
    "phenotype": "Ulcerative proctitis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative proctitis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ULCERPROCT.gwas.imputed_v3.both_sexes.tsv.bgz -O ULCERPROCT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "ULCERRECT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "ULCERRECT",
    "phenotype": "Ulcerative rectosigmoiditis",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ulcerative rectosigmoiditis",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/ULCERRECT.gwas.imputed_v3.both_sexes.tsv.bgz -O ULCERRECT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "V_MENTAL_BEHAV",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "V_MENTAL_BEHAV",
    "phenotype": "Mental and behavioural disorders",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Mental/behavioral disorder",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/V_MENTAL_BEHAV.gwas.imputed_v3.both_sexes.tsv.bgz -O V_MENTAL_BEHAV.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "VI_NERVOUS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "VI_NERVOUS",
    "phenotype": "Diseases of the nervous system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Nervous system disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/VI_NERVOUS.gwas.imputed_v3.both_sexes.tsv.bgz -O VI_NERVOUS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "VII_EYE_ADNEXA",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "VII_EYE_ADNEXA",
    "phenotype": "Diseases of the eye and adnexa",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Eye/adnexa disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/VII_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz -O VII_EYE_ADNEXA.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "VIII_EAR_MASTOID",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "VIII_EAR_MASTOID",
    "phenotype": "Diseases of the ear and mastoid process",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Ear/mastoid disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/VIII_EAR_MASTOID.gwas.imputed_v3.both_sexes.tsv.bgz -O VIII_EAR_MASTOID.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "VIT_DEF",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "VIT_DEF",
    "phenotype": "Vitamin deficiency",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vitamin deficiency",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/VIT_DEF.gwas.imputed_v3.both_sexes.tsv.bgz -O VIT_DEF.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "VOCALCORDDYS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "VOCALCORDDYS",
    "phenotype": "Vocal cord dysfunction",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Vocal cord dysfunction",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/VOCALCORDDYS.gwas.imputed_v3.both_sexes.tsv.bgz -O VOCALCORDDYS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "X_RESPIRATORY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "X_RESPIRATORY",
    "phenotype": "Diseases of the respiratory system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Respiratory disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/X_RESPIRATORY.gwas.imputed_v3.both_sexes.tsv.bgz -O X_RESPIRATORY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XI_DIGESTIVE",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XI_DIGESTIVE",
    "phenotype": "Diseases of the digestive system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Digestive disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XI_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz -O XI_DIGESTIVE.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XII_SKIN_SUBCUTAN",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XII_SKIN_SUBCUTAN",
    "phenotype": "Diseases of the skin and subcutaneous tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Skin disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XII_SKIN_SUBCUTAN.gwas.imputed_v3.both_sexes.tsv.bgz -O XII_SKIN_SUBCUTAN.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XIII_MUSCULOSKELET",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XIII_MUSCULOSKELET",
    "phenotype": "Diseases of the musculoskeletal system and connective tissue",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Musculoskeletal/connective tissue disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XIII_MUSCULOSKELET.gwas.imputed_v3.both_sexes.tsv.bgz -O XIII_MUSCULOSKELET.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XIV_GENITOURINARY",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XIV_GENITOURINARY",
    "phenotype": "Diseases of the genitourinary system",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Genitourinary disease",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XIV_GENITOURINARY.gwas.imputed_v3.both_sexes.tsv.bgz -O XIV_GENITOURINARY.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XV_PREGNANCY_BIRTH",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XV_PREGNANCY_BIRTH",
    "phenotype": "Pregnancy, childbirth and the puerperium",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Pregnancy/childbirth condition",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XV_PREGNANCY_BIRTH.gwas.imputed_v3.both_sexes.tsv.bgz -O XV_PREGNANCY_BIRTH.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XVII_MALFORMAT_ABNORMAL",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XVII_MALFORMAT_ABNORMAL",
    "phenotype": "Congenital malformations, deformations and chromosomal abnormalities",
    "phenotypicCategory": "Disease",
    "phenotypicSubcategory": "Congenital anomaly",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XVII_MALFORMAT_ABNORMAL.gwas.imputed_v3.both_sexes.tsv.bgz -O XVII_MALFORMAT_ABNORMAL.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XVIII_MISCFINDINGS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XVIII_MISCFINDINGS",
    "phenotype": "Symptoms, signs and abnormal clinical and laboratory findings, not elsewhere classified",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Symptoms/signs NEC",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XVIII_MISCFINDINGS.gwas.imputed_v3.both_sexes.tsv.bgz -O XVIII_MISCFINDINGS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XX_EXTERNAL_MORB_MORT",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XX_EXTERNAL_MORB_MORT",
    "phenotype": "External causes of morbidity and mortality",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "External cause",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XX_EXTERNAL_MORB_MORT.gwas.imputed_v3.both_sexes.tsv.bgz -O XX_EXTERNAL_MORB_MORT.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "XXI_HEALTHFACTORS",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "XXI_HEALTHFACTORS",
    "phenotype": "Factors influencing health status and contact with health services",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Health service contact",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/XXI_HEALTHFACTORS.gwas.imputed_v3.both_sexes.tsv.bgz -O XXI_HEALTHFACTORS.gwas.imputed_v3.both_sexes.tsv.bgz"
  },
  {
    "accessionId": "30600_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30600",
    "phenotype": "Albumin (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Albumin quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30600_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30600_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30700_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30700",
    "phenotype": "Creatinine (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Creatinine quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30700_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30700_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30610_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30610",
    "phenotype": "Alkaline phosphatase (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ALP quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30610_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30610_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30620_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30620",
    "phenotype": "Alanine aminotransferase (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ALT quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30620_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30620_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30630_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30630",
    "phenotype": "Apoliprotein A (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ApoA quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30630_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30630_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30640_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30640",
    "phenotype": "Apoliprotein B (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "ApoB quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30640_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30640_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30650_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30650",
    "phenotype": "Aspartate aminotransferase (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "AST quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30650_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30650_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30660_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30660",
    "phenotype": "Direct bilirubin (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Direct bilirubin quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30660_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30660_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30670_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30670",
    "phenotype": "Urea (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urea quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30670_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30670_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30680_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30680",
    "phenotype": "Calcium (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Calcium quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30680_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30680_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30690_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30690",
    "phenotype": "Cholesterol (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cholesterol quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30690_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30690_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30710_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30710",
    "phenotype": "C-reactive protein (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "CRP quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30710_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30710_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30720_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30720",
    "phenotype": "Cystatin C (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Cystatin C quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30720_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30720_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30730_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30730",
    "phenotype": "Gamma glutamyltransferase (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "GGT quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30730_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30730_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30740_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30740",
    "phenotype": "Glucose (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Glucose quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30740_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30740_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30750_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30750",
    "phenotype": "Glycated haemoglobin (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "HbA1c quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30750_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30750_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30760_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30760",
    "phenotype": "HDL cholesterol (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "HDL quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30760_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30760_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30770_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30770",
    "phenotype": "IGF-1 (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "IGF-1 quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30770_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30770_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30780_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30780",
    "phenotype": "LDL direct (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "LDL quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30780_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30780_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30790_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30790",
    "phenotype": "Lipoprotein A (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Lipoprotein(a) quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30790_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30790_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30800_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30800",
    "phenotype": "Oestradiol (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Estradiol quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30800_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30800_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30810_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30810",
    "phenotype": "Phosphate (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Phosphate quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30810_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30810_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30820_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30820",
    "phenotype": "Rheumatoid factor (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "RF quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30820_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30820_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30830_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30830",
    "phenotype": "SHBG (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "SHBG quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30830_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30830_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30840_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30840",
    "phenotype": "Total bilirubin (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Total bilirubin quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30840_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30840_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30850_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30850",
    "phenotype": "Testosterone (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Testosterone quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30850_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30850_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30860_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30860",
    "phenotype": "Total protein (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Total protein quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30860_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30860_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30870_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30870",
    "phenotype": "Triglycerides (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Triglycerides quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30870_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30870_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30880_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30880",
    "phenotype": "Urate (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Urate quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30880_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30880_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30890_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30890",
    "phenotype": "Vitamin D (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Vitamin D quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30890_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30890_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  },
  {
    "accessionId": "30897_irnt",
    "sources": "ukbbank_nealelab_v2",
    "phenocode": "30897",
    "phenotype": "Estimated sample dilution factor (quantile)",
    "phenotypicCategory": "Measurement",
    "phenotypicSubcategory": "Sample dilution factor quantile",
    "pmid": "",
    "download": "https://broad-ukb-sumstats-us-east-1.s3.amazonaws.com/round2/additive-tsvs/30897_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz -O 30897_irnt.gwas.imputed_v3.both_sexes.varorder.tsv.bgz"
  }
]